import { Coordinates } from './coordinates';
import { Currency } from './currency';
import { Language } from 'hic-components/src/multi-languages-input/multi-languages-types';
import { LocalizedString } from 'hic-components/src/multi-languages-input/multi-languages-types';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CapitalizedString: any;
  Coordinates: Coordinates;
  Currency: Currency;
  Date: Date;
  DateTime: Date;
  EmailAddress: string;
  EncryptedString: string;
  JSON: any;
  Language: Language;
  LocalizedString: LocalizedString;
  PhoneNumber: string;
  Time: Date;
  URL: string;
  UppercaseString: any;
  UtcOffset: string;
  Void: any;
};

/** Entità che serve per identificare le cod */
export type AccountantCategory = {
  auditable: Auditable;
  default: AccountantDefault;
  defaultVat: Vat;
  /** Il default Vat indica l'aliquota iva di default della voce contabile */
  defaultVatId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type AccountantCategoryQueryFilter = {
  advance?: InputMaybe<Scalars['Boolean']>;
  deposit?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo che ci permette di sapere quale voce utilizzare in modo automatico per le varie operazioni */
export type AccountantDefault = {
  advance: Scalars['Boolean'];
  deposit: Scalars['Boolean'];
};

/**
 * Questo tipo ci permette di slavare all'interno della reservation e ReservedResource tutte le azioni che ci possono essere.
 * Ad esempio link WCI Inviata, WCI Effettuato, Carta Richiesta etc etc.
 */
export type ActionLog = {
  createdOn: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ActivatePointOfSaleItem = {
  /** Flag che indica se il Punto Vendita deve essere attivato o disattivato. */
  activate: Scalars['Boolean'];
  description: Scalars['String'];
  /** Codice identificativo usato dal sistema esterno (per CassaInCloud è il SalesPointId). */
  externalId: Scalars['String'];
  /** L'id del Punto Vendita, se esiste. */
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ActivatePointOfSalesInput = {
  /** L'ApiKey a cui associare i PuntiVendita che vengono creati. */
  apiKey: Scalars['String'];
  /** L'id del charge-category da usare quando deve essere creato il PuntoVendita di default. */
  defaultChargeCategoryId: Scalars['ID'];
  /** L'elenco dei PuntiVendita da attivare o disattivare. */
  pointOfSales: Array<ActivatePointOfSaleItem>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type AdditionaServiceImage = {
  additionalServiceId: Scalars['ID'];
  images?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Il servizio è un entità che permette di generare addebiti all'interno di un conto
 * Ha delle regole che permettono al sistema di generare la corretta produzione
 */
export type AdditionalService = {
  auditable: Auditable;
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti gli adulti.
   * Default False. Visibile se *PERSON*.
   */
  automaticForAdults: Scalars['Boolean'];
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti i children che occupano un posto letto.
   * Default false. Visibile se *PERSON*.
   */
  automaticForChildren: Scalars['Boolean'];
  /**
   * La gestione della disponibilità di un servizio di default è infinita
   * Se si specifica availabilityConfig, lo si lega ad un resourceType e si gestisce la disponibilità in maniera finita
   */
  availabilityConfig?: Maybe<ServiceAvailability>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  /** Prezzi per Fascia di età, attivabile solo se il tipo è *Person*. */
  childServicePrices?: Maybe<Array<ChildServicePrice>>;
  currency: Scalars['Currency'];
  description: Scalars['LocalizedString'];
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  id: Scalars['ID'];
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  /** Giorni minimi per poter attivare il servizio */
  minStay?: Maybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  price: Scalars['Int'];
  pricingType: PricingType;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  /** La validità non è obbligatoria, ma può essere utile in situazioni tipo lo skipass */
  validity?: Maybe<Range>;
};

export type AdditionalServiceInput = {
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti gli adulti
   * Default False visibile se *PERSON*
   */
  automaticForAdults: Scalars['Boolean'];
  /**
   * Se attivo indica che il servizio verrà aggiunto in automatico per tutti i children che occupano un posto letto
   * Default false visibile se *PERSON*
   */
  automaticForChildren: Scalars['Boolean'];
  /**
   * La gestione della disponibilità di un servizio di default è infinita
   * Se si specifica availabilityConfig, lo si lega ad un resourceType e si gestisce la disponibilità in maniera finita
   */
  availabilityConfig?: InputMaybe<ServiceAvailabilityInput>;
  chargeCategoryId: Scalars['ID'];
  /** Prezzi per Fascia di età, attivabile solo se il tipo è *Person* */
  childServicePrices?: InputMaybe<Array<ChildServicePriceInput>>;
  currency: Scalars['Currency'];
  description: Scalars['LocalizedString'];
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  minStay?: InputMaybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  price: Scalars['Int'];
  pricingType: PricingType;
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  validity?: InputMaybe<RangeInput>;
};

export type AdditionalServiceLimitedAvailability = {
  day: Scalars['Date'];
  resourceId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  time: TimeRange;
};

export type AdditionalServiceLimitedAvailabilityInput = {
  day: Scalars['Date'];
  resourceId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  time: TimeRangeInput;
};

export type AdditionalServiceQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  stay?: InputMaybe<ClosedRangeInput>;
  tenantId: IDFilter;
};

/** Address , embedded document */
export type Address = {
  address?: Maybe<Scalars['CapitalizedString']>;
  /** city è la località di nascita solo per gli esteri. Per gli italiani c'è municipalityId */
  city?: Maybe<Scalars['CapitalizedString']>;
  coordinates?: Maybe<Scalars['Coordinates']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['ID']>;
  municipality?: Maybe<Municipality>;
  municipalityId?: Maybe<Scalars['ID']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  countryId?: InputMaybe<Scalars['ID']>;
  municipalityId?: InputMaybe<Scalars['ID']>;
  postalCode?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
};

export const AgodaOccupancyModel = {
  FullRate: 'FullRate'
} as const;

export type AgodaOccupancyModel = typeof AgodaOccupancyModel[keyof typeof AgodaOccupancyModel];
/** Entità che contiene i dati di configurazione del portale Agoda. */
export type AgodaParameters = {
  occupancyModel: AgodaOccupancyModel;
};

export type AirbnbHostAuthentication = {
  /** I dati di autenticazione correntemente attivi. */
  authentication?: Maybe<AirbnbParametersAuthentication>;
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  hostAuthorizationCode?: Maybe<Scalars['String']>;
  /** Data e ora in cui l'albergatore ha autorizzato la nostra applicazione. */
  hostAuthorizationTimestamp?: Maybe<Scalars['DateTime']>;
  /** Identificativo dell'albergatore nella piattaforma Airbnb. */
  hostUserId?: Maybe<Scalars['String']>;
};

export type AirbnbHostAuthorizationInput = {
  channelId: Scalars['ID'];
  /** Code retrieved from the Host authorization Redirect URL */
  hostAuthorizationCode: Scalars['String'];
};

/** Entità che contiene i dati di configurazione del portale Airbnb. */
export type AirbnbParameters = {
  /** I dati di autenticazione correntemente attivi. */
  authentication?: Maybe<AirbnbParametersAuthentication>;
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  hostAuthorizationCode?: Maybe<Scalars['String']>;
  /** Data e ora in cui l'albergatore ha autorizzato la nostra applicazione. */
  hostAuthorizationTimestamp?: Maybe<Scalars['DateTime']>;
  /** Identificativo dell'albergatore nella piattaforma Airbnb. */
  hostUserId?: Maybe<Scalars['String']>;
};

export type AirbnbParametersAuthentication = {
  accessToken: Scalars['EncryptedString'];
  /** Unix time */
  expiresAt: Scalars['Int'];
  refreshToken: Scalars['EncryptedString'];
};

export const AlgebraicSign = {
  NEGATIVE: 'NEGATIVE',
  POSITIVE: 'POSITIVE'
} as const;

export type AlgebraicSign = typeof AlgebraicSign[keyof typeof AlgebraicSign];
/** Dotazioni e servizi che possono essere associate ad una tipologia di risorsa */
export type Amenity = {
  auditable: Auditable;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
};

export type AmenityInput = {
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
};

export type AmenityQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
};

export type AttachmentForDocumentInput = {
  body?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  messageTemplateId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

/** Entità di Audit, contiene le modifiche ad ogni record Auditable */
export type Audit = {
  changes?: Maybe<Scalars['JSON']>;
  correlationId: Scalars['String'];
  entityId: Scalars['ID'];
  entityName: Scalars['String'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  operationName: Scalars['String'];
  tenantId?: Maybe<Scalars['ID']>;
  timestamp: Scalars['DateTime'];
};

export type AuditQueryFilter = {
  correlationId?: InputMaybe<StringFilter>;
  date?: InputMaybe<ClosedRangeInput>;
  entityId?: InputMaybe<IDFilter>;
  entityName?: InputMaybe<StringFilter>;
  modifiedBy?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<StringFilter>;
  operationName?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type AuditSortInput = {
  timestamp?: InputMaybe<Sort>;
};

/** Dati Auditable, embedded document da utilizzare in tutte le entità */
export type Auditable = {
  audits: Array<Audit>;
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  state: State;
  versions: Array<Maybe<Scalars['JSON']>>;
};

export type AvailabilityRequest = {
  auditable: Auditable;
  customer: CustomerAvailabilityRequest;
  end: Scalars['Date'];
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  resources: Array<ResourceAvailabilityRequest>;
  start: Scalars['Date'];
  state: AvailabilityRequestState;
  tenantId: Scalars['ID'];
};

export type AvailabilityRequestInput = {
  customer: CustomerAvailabilityRequestInput;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resources: Array<ResourceRQInput>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type AvailabilityRequestQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  propertyId?: InputMaybe<IDFilter>;
  state?: InputMaybe<AvailabilityRequestStateFilter>;
  tenantId: IDFilter;
};

export const AvailabilityRequestState = {
  NEW: 'NEW',
  NOTIFIED: 'NOTIFIED',
  RESERVED: 'RESERVED',
  VISITED: 'VISITED'
} as const;

export type AvailabilityRequestState = typeof AvailabilityRequestState[keyof typeof AvailabilityRequestState];
export type AvailabilityRequestStateFilter = {
  in: Array<AvailabilityRequestState>;
};

export type AvailableResourcesInput = {
  endDate: Scalars['Date'];
  excludeReservedResourceId?: InputMaybe<Scalars['ID']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  rateId?: InputMaybe<Scalars['ID']>;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export const BeforeOrAfter = {
  AFTER: 'AFTER',
  BEFORE: 'BEFORE'
} as const;

export type BeforeOrAfter = typeof BeforeOrAfter[keyof typeof BeforeOrAfter];
/**
 * Il conto contiene è un raggruppamento di addebiti di produzione
 * Il conto può essere legato ad una o più prenotazioni e a una o più risorse
 * Il conto può essere legato soltanto ad un customer e rappresenta un conto passante
 * Il conto quando viene creato è di default di tipo MAIN
 */
export type Bill = {
  auditable: Auditable;
  category: BillCategoryType;
  description: Scalars['String'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  open: Scalars['Boolean'];
  owner: Customer;
  ownerId: Scalars['ID'];
  productions?: Maybe<Array<ProductionAssigned>>;
  propertyId: Scalars['ID'];
  reservation?: Maybe<Array<Reservation>>;
  reservationId?: Maybe<Array<Scalars['ID']>>;
  reservedResource?: Maybe<Array<ReservedResource>>;
  reservedResourceId?: Maybe<Array<Scalars['ID']>>;
  searchInfo: BillSearchInfo;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type BillAllocationInput = {
  billId: Scalars['ID'];
  quota: Scalars['Float'];
};

export const BillCategoryType = {
  EXTRA: 'EXTRA',
  MAIN: 'MAIN',
  REVERSE: 'REVERSE',
  WALKIN: 'WALKIN'
} as const;

export type BillCategoryType = typeof BillCategoryType[keyof typeof BillCategoryType];
export type BillCheckoutInput = {
  billId: Scalars['ID'];
  productions: Array<ProductionCheckoutInput>;
};

export type BillInput = {
  category: BillCategoryType;
  description: Scalars['String'];
  ownerId: Scalars['ID'];
  productions?: InputMaybe<Array<ProductionAssignedInput>>;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Array<Scalars['ID']>>;
  reservedResourceId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
};

export type BillQueryFilter = {
  category?: InputMaybe<BillCategoryType>;
  createdOn?: InputMaybe<RangeInput>;
  description?: InputMaybe<StringFilter>;
  end?: InputMaybe<DateFilter>;
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  reservationId?: InputMaybe<IDFilter>;
  reservedResourceId?: InputMaybe<IDFilter>;
  start?: InputMaybe<DateFilter>;
  tenantId: IDFilter;
};

export type BillSearchInfo = {
  end?: Maybe<Scalars['Date']>;
  guestNames?: Maybe<Array<Scalars['String']>>;
  ownerName: Scalars['String'];
  resources?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<Scalars['Date']>;
};

export const BookingAction = {
  BOOK: 'BOOK',
  CANCEL: 'CANCEL',
  MODIFY: 'MODIFY'
} as const;

export type BookingAction = typeof BookingAction[keyof typeof BookingAction];
/** BookingEngineConfiguration */
export type BookingEngineConfiguration = {
  fiscalAdvances: Scalars['Boolean'];
  /** Codice Google Analytics 4 */
  googleGA4?: Maybe<Scalars['String']>;
};

export type BookingEngineConfigurationInput = {
  fiscalAdvances: Scalars['Boolean'];
  /** Codice Google Analytics 4 */
  googleGA4?: InputMaybe<Scalars['String']>;
};

export type BookingEngineUrl = {
  auditable: Auditable;
  id: Scalars['ID'];
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

export type BookingEngineUrlInput = {
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

/** La politica di booking contine le logiche per garantire la prenotazione, pagamenti, cancellazione e la gestione di eventuali penali. */
export type BookingPolicy = {
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  auditable: Auditable;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicy;
  id: Scalars['ID'];
  /** Nome solo ad uso interno */
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRule;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRule;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type BookingPolicyDigitalPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  noShow: Scalars['Int'];
};

export type BookingPolicyDigitalPaymentInput = {
  currency: Scalars['Currency'];
  firstNightAmount: Scalars['Int'];
  language: Scalars['Language'];
  policies: Array<ReservationBookingPolicyInput>;
  start: Scalars['Date'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  totalAmount: Scalars['Int'];
};

export type BookingPolicyInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  cancellationPolicy: CancellationPolicyInput;
  name: Scalars['String'];
  noShowRule: NoShowRuleInput;
  paymentRule: PaymentRuleInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type BookingPolicyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** EXCEL */
export type BulkReservation = {
  correlationId: Scalars['String'];
  deleteError?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importedId?: Maybe<Scalars['ID']>;
  processed: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  row: BulkReservationRow;
  tenantId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
};

export type BulkReservationInput = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Int'];
  companyName?: InputMaybe<Scalars['String']>;
  createdOn?: InputMaybe<Scalars['DateTime']>;
  credit?: InputMaybe<CreditType>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerLanguage?: InputMaybe<Scalars['Language']>;
  customerName: Scalars['String'];
  customerPhone?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  groupName?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  reservationCode?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
  voucher?: InputMaybe<Scalars['String']>;
};

export type BulkReservationRow = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  credit?: Maybe<CreditType>;
  customerEmail?: Maybe<Scalars['String']>;
  customerLanguage?: Maybe<Scalars['Language']>;
  customerName: Scalars['String'];
  customerPhone?: Maybe<Scalars['String']>;
  end: Scalars['Date'];
  groupName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  reservationCode?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  totalAmount: Scalars['Int'];
  voucher?: Maybe<Scalars['String']>;
};

export type CacheCollection = {
  expirationDate?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  value: Scalars['JSON'];
};

/** Questo tipo contiene le informazioni che servono al sistema per calcolare l'importo , il vaore è semrpe intero anche per le percentuali */
export type CalculationPrice = {
  type: ValueType;
  value: Scalars['Int'];
};

export type CalculationPriceInput = {
  type: ValueType;
  value: Scalars['Int'];
};

export const CancelReservationResult = {
  DONE: 'DONE',
  NOSHOW: 'NOSHOW',
  NOTREF: 'NOTREF',
  PENALTY: 'PENALTY',
  REFUND_ERROR: 'REFUND_ERROR'
} as const;

export type CancelReservationResult = typeof CancelReservationResult[keyof typeof CancelReservationResult];
/** Tipo di penale per le cancellazioni tardive */
export const CancellationPenaltyType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type CancellationPenaltyType = typeof CancellationPenaltyType[keyof typeof CancellationPenaltyType];
/** Policy di cancellazione legata alla booking policy */
export type CancellationPolicy = {
  /**
   * Se il valore è zero indica che si può cancellare senza penali fino al giorno dell'arrivo, default 7
   * Se non impostato è perchè non è rimborsabile
   */
  daysWithoutPenalties?: Maybe<Scalars['Int']>;
  /**
   * Default è mezzanotte 00:00 che indica l'inzio del giorno, altrimenti è possibile gestire l'orario che in combinazione con i giorni.
   * Se non impostato è perchè non è rimborsabile
   * Default 7 giorni e 00:00 indica che la prenotazione può essere cancellata fino alle 23.59 dell'ottavo giorno prima dell'arrivo
   */
  hourWithoutPenalties?: Maybe<Scalars['Time']>;
  /** Dati per calcolare le penali su tardiva cancellazione */
  penaltyType?: Maybe<CancellationPenaltyType>;
  percentage?: Maybe<Scalars['Float']>;
  type: CancellationPolicyType;
};

export type CancellationPolicyInput = {
  daysWithoutPenalties?: InputMaybe<Scalars['Int']>;
  hourWithoutPenalties?: InputMaybe<Scalars['Time']>;
  penaltyType?: InputMaybe<CancellationPenaltyType>;
  percentage?: InputMaybe<Scalars['Float']>;
  type: CancellationPolicyType;
};

/** Tipo di cancellazione */
export const CancellationPolicyType = {
  ALWAYSFREE: 'ALWAYSFREE',
  BYDATE: 'BYDATE',
  NOTREF: 'NOTREF'
} as const;

export type CancellationPolicyType = typeof CancellationPolicyType[keyof typeof CancellationPolicyType];
export type CancelledDocument = {
  auditable: Auditable;
  document: Document;
  documentDate: Scalars['Date'];
  documentId: Scalars['ID'];
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Card = {
  cardType: Scalars['String'];
  plans?: Maybe<Array<Plan>>;
  title: Scalars['String'];
};

/** Entità Cassa */
export type CashDesk = {
  auditable: Auditable;
  cashDeskType: CashDeskType;
  cashDeskTypeId: Scalars['ID'];
  hotelDate: Scalars['Date'];
  id: Scalars['ID'];
  open: Scalars['Boolean'];
  owner?: Maybe<User>;
  /**
   * La cassa potrebbe avere un owner in modo che solo chi è il proprietario la può usare.
   * Non è obligatorio perchè non è gestito in tutte le strutture, di default sarà sempre aperta e chiusa in fase di chiusura
   */
  ownerID?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CashDeskInput = {
  cashDeskTypeId: Scalars['ID'];
  hotelDate: Scalars['Date'];
  ownerID?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CashDeskQueryFilter = {
  cashDeskTypeId?: InputMaybe<IDFilter>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<IDFilter>;
  open?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/**
 * Tipo cassa, il tipo cassa è associato alla property o alla sub property e permette di avere le configurazioni necessarie per gestire la cassa.
 * La creazione di una nuova property genera una cassa collegata che permette di emettere tutti i tipi di documenti.
 * Per ogni cassa è possibile avere solo un tipo documento
 * Su ogni tipo cassa è possibile associare uno o più workstation di fiscal gateway
 */
export type CashDeskType = {
  auditable: Auditable;
  code: CashDeskTypeCode;
  documentsActive: Array<DocumentActive>;
  documentsActiveId: Array<Scalars['ID']>;
  fiscalGatewayWorkstations: Array<FiscalGatewayWorkstation>;
  id: Scalars['ID'];
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const CashDeskTypeCode = {
  FRONT: 'FRONT'
} as const;

export type CashDeskTypeCode = typeof CashDeskTypeCode[keyof typeof CashDeskTypeCode];
export type CashDeskTypeInput = {
  code: CashDeskTypeCode;
  documentsActiveId: Array<Scalars['ID']>;
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudApiKey = {
  apiKey: Scalars['String'];
  description: Scalars['String'];
};

export type CassaInCloudApiKeyInput = {
  apiKey: Scalars['String'];
  description: Scalars['String'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudConfiguration = {
  /** Elenco delle ApiKey gestite. */
  apiKeys?: Maybe<Array<CassaInCloudConfigurationApiKeyEntry>>;
  /** Il secret da comunicare a CassaInCloud. Tale secret deve essere passato in ogni chiamata ai nostri servizi. */
  tenantSecret: Scalars['String'];
};

export type CassaInCloudConfigurationApiKeyEntry = {
  apiKey: Scalars['EncryptedString'];
  description: Scalars['String'];
  /** Elenco dei Punti Vendita collegati a questa ApiKey. */
  pointOfSaleIds?: Maybe<Array<Scalars['ID']>>;
  pointOfSales?: Maybe<Array<PointOfSale>>;
};

export type CassaInCloudDepartment = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type CassaInCloudDepartmentsQueryFilter = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudSalesMode = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type CassaInCloudSalesModesQueryFilter = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CassaInCloudSalesPoint = {
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CervedActivityStatus = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedAdvancedAddress = {
  city?: Maybe<CervedCity>;
  country?: Maybe<CervedCountry>;
  postal_code?: Maybe<Scalars['String']>;
  province?: Maybe<CervedProvince>;
  street?: Maybe<CervedStreet>;
};

export type CervedAdvancedNoReaData = {
  form_code?: Maybe<Scalars['String']>;
  form_description?: Maybe<Scalars['String']>;
};

/** Input per la ricerca avanzata in Cerved */
export type CervedAdvancedSearchInput = {
  /** Nominativo o ragione sociale */
  name?: InputMaybe<Scalars['String']>;
  /** Ricerca generica */
  searchText?: InputMaybe<Scalars['String']>;
  /** Codice fiscale */
  taxCode?: InputMaybe<Scalars['String']>;
  /** Partita IVA */
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** Risposta della ricerca avanzata in Cerved */
export type CervedAdvancedSearchResponse = {
  subjects?: Maybe<Array<Maybe<CervedSubject>>>;
  subjects_total_number?: Maybe<Scalars['Int']>;
};

export type CervedAteco = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedCity = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  istat_code?: Maybe<Scalars['String']>;
};

export type CervedCompanyInfo = {
  activity_status?: Maybe<CervedActivityStatus>;
  business_name?: Maybe<Scalars['String']>;
  economic_activity?: Maybe<CervedEconomicActivity>;
  head_office?: Maybe<Scalars['Boolean']>;
  legal_form?: Maybe<CervedLegalForm>;
  lei_code?: Maybe<Scalars['String']>;
  no_rea_data?: Maybe<CervedAdvancedNoReaData>;
  operational_flag?: Maybe<Scalars['Boolean']>;
  public_administration?: Maybe<CervedPublicAdministration>;
  rea_code?: Maybe<CervedRea>;
  vat_number?: Maybe<Scalars['String']>;
};

/** Input per recuperare la lista dei contatti di un Soggetto (persona giuridica) */
export type CervedContactsInput = {
  /** Identificativo univoco Cerved del Soggetto (persona giuridica) restituito dal servizio di ricerca. */
  subjectId: Scalars['String'];
};

/** Risposta della richiesta dei contatti di un Soggetto */
export type CervedContactsResponse = {
  /** Lista di indirizzi (non PEC) associati al soggetto */
  indirizzi_email?: Maybe<Array<Maybe<CervedEmail>>>;
  /** Lista di indirizzi PEC associati al soggetto */
  indirizzi_email_certificate?: Maybe<Array<Maybe<CervedEmail>>>;
  /** Lista delle url dei siti associati al soggetto */
  siti_web?: Maybe<Array<Maybe<CervedSitoWeb>>>;
  /** Lista di numeri di telefono associati al soggetto */
  telefoni?: Maybe<Array<Maybe<CervedTelefono>>>;
};

export type CervedCountry = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isoCode?: Maybe<Scalars['String']>;
};

export type CervedEconomicActivity = {
  ateco?: Maybe<CervedAteco>;
};

export type CervedEmail = {
  /** Categoria associata a ciascun indirizzo email */
  categoria?: Maybe<Scalars['String']>;
  /** Indirizzo email */
  email?: Maybe<Scalars['String']>;
};

export type CervedLegalForm = {
  class_code?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedPersonInfo = {
  birth_date?: Maybe<Scalars['String']>;
  birth_place?: Maybe<CervedAdvancedAddress>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CervedProvince = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CervedPublicAdministration = {
  pa_owned?: Maybe<Scalars['Boolean']>;
  pa_subject?: Maybe<Scalars['Boolean']>;
  pa_supplier?: Maybe<Scalars['Boolean']>;
};

export type CervedRea = {
  cciaa?: Maybe<Scalars['String']>;
  rea_number?: Maybe<Scalars['Int']>;
  registration_date?: Maybe<Scalars['String']>;
};

export type CervedSitoWeb = {
  /** Tipologia sito web (principale o secondario) */
  tipo?: Maybe<Scalars['String']>;
  /** Sito web */
  url?: Maybe<Scalars['String']>;
};

export type CervedStreet = {
  description?: Maybe<Scalars['String']>;
};

export type CervedSubject = {
  address?: Maybe<CervedAdvancedAddress>;
  company_info?: Maybe<CervedCompanyInfo>;
  person_info?: Maybe<CervedPersonInfo>;
  subject_id?: Maybe<Scalars['String']>;
  subject_type?: Maybe<Scalars['String']>;
  tax_code?: Maybe<Scalars['String']>;
};

export type CervedTelefono = {
  /** Fonte di ciascun numero di telefono */
  fonte?: Maybe<Scalars['String']>;
  /** Numero di telefono */
  numero?: Maybe<Scalars['String']>;
  /** Sede a cui è associato il numero */
  sede?: Maybe<Scalars['String']>;
  /** Uso di ciascun numero di telefono */
  uso?: Maybe<Scalars['String']>;
};

/**
 * Entità che mantiene le configurazioni dei portali collegati alla property, in questo caso potrebbero essere anche subproperty
 * Lo stato in qesto caso è importante perchè è possibile inibire l'invio dei dati lasciando il portale inattivo, fino a quando non sarà l'operatore a decidere di attivare.
 * In quel caso è necessario chiedere all'operatore se deve essere aggiornato i dati del portale con i dati presenti o meno.
 */
export type Channel = {
  /** I dati di configurazione della struttura nel portale Agoda. */
  agodaParameters?: Maybe<AgodaParameters>;
  /** I dati di configurazione della struttura nel portale Airbnb. */
  airbnbParameters?: Maybe<AirbnbParameters>;
  auditable: Auditable;
  channelChargeMappings?: Maybe<Array<ChannelChargeMapping>>;
  channelRateMappings?: Maybe<Array<ChannelRateMapping>>;
  channelResourceTypeMappings?: Maybe<Array<ChannelResourceTypeMapping>>;
  /** Eventuali credenziali assegnate alla struttura dal portale per accedere ai propri servizi web. */
  credentials?: Maybe<ChannelCredentials>;
  /** I dati di configurazione della struttura nel portale Expedia. */
  expediaParameters?: Maybe<ExpediaParameters>;
  id: Scalars['ID'];
  /** Dati informativi che possono essere visulizzati sul client */
  info?: Maybe<Scalars['String']>;
  /**
   * Se impostata indica quando è stato eseguito l'import iniziale delle prenotazioni.
   * Se la data è presente non deve essere possibile rieseguire l'import.
   */
  initialImportDate?: Maybe<Scalars['DateTime']>;
  /** Indica quando è stato fatto l'ultima operazione di download di una prenotazione */
  lastDownload?: Maybe<Scalars['DateTime']>;
  /** Indica quando è stato eseguito l'ultimo aggiornamento massivo del canale */
  lastUpdateChannel?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  /**
   * Per ogni account dei portali  è possibile specificare una variazione in percentuale della tariffa
   * Ad esempio 3% in più su Booking.com e 4% in più su Air Bnb.
   * Default 0
   */
  percentage: Scalars['Float'];
  portal: Portal;
  portalId: Scalars['ID'];
  property: Property;
  propertyId: Scalars['ID'];
  /** Codice che identifica la property sul portale se gestito. */
  propertyPortalCode?: Maybe<Scalars['String']>;
  subProperty?: Maybe<Property>;
  subPropertyId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  /** Se viene utilizzato tramite Figaro è necessario avere l'id del portale per le connessioni */
  throughFigaro?: Maybe<Scalars['Int']>;
};

export type ChannelAvailabilityEventPayload = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChannelChargeMapping = {
  chargeCategory: ChargeCategory;
  chargeCategoryCodePortal: Scalars['String'];
  chargeCategoryId: Scalars['ID'];
};

export type ChannelChargeMappingInput = {
  chargeCategoryCodePortal: Scalars['String'];
  chargeCategoryId: Scalars['ID'];
};

export type ChannelCommunicationFilter = {
  channelId: IDFilter;
  error: Scalars['Boolean'];
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const ChannelCommunicationOperation = {
  AVAILABILITY: 'AVAILABILITY',
  PRICE: 'PRICE',
  RESERVATION: 'RESERVATION',
  RESTRICTION: 'RESTRICTION'
} as const;

export type ChannelCommunicationOperation = typeof ChannelCommunicationOperation[keyof typeof ChannelCommunicationOperation];
/**
 * Collection che ci permette di salvare per ogni canale le informazioni da mostrare all'utente, queste informazioni rimangono live solo per n giorni. N da specificare sul TTL
 * Le stesse informazioni sono presenti in helk con una retention maggiore.
 */
export type ChannelCommunicationResult = {
  channel?: Maybe<Channel>;
  channelId: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  dataSendJson: Scalars['JSON'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  operations?: Maybe<Array<ChannelCommunicationOperation>>;
  portalName: PortalName;
  property?: Maybe<Property>;
  propertyId: Scalars['ID'];
  state: ChannelCommunicationState;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
};

export const ChannelCommunicationState = {
  ERROR: 'ERROR',
  OK: 'OK',
  WARNING: 'WARNING'
} as const;

export type ChannelCommunicationState = typeof ChannelCommunicationState[keyof typeof ChannelCommunicationState];
export type ChannelCredentials = {
  /** Password dell'utenza. */
  password: Scalars['EncryptedString'];
  /** Identificativo dell'utenza. */
  userId: Scalars['EncryptedString'];
};

export type ChannelCredentialsInput = {
  /** Password dell'utenza. */
  password: Scalars['EncryptedString'];
  /** Identificativo dell'utenza. */
  userId: Scalars['EncryptedString'];
};

export type ChannelInput = {
  /** Codice ottenuto al termine della procedura con cui l'albergatore autorizza la nostra applicazione a gestire i dati presenti su Airbnb. */
  airbnbHostAuthorizationCode?: InputMaybe<Scalars['String']>;
  channelChargeMappings?: InputMaybe<Array<ChannelChargeMappingInput>>;
  channelId?: InputMaybe<Scalars['ID']>;
  channelRateMappings?: InputMaybe<Array<ChannelRateMappingInput>>;
  channelResourceTypeMappings?: InputMaybe<Array<ChannelResourceTypeMappingInput>>;
  /** Eventuali credenziali assegnate alla struttura per accedere ai servizi web del portale. */
  credentials?: InputMaybe<ChannelCredentialsInput>;
  name: Scalars['String'];
  percentage: Scalars['Float'];
  portalId: Scalars['ID'];
  propertyId: Scalars['ID'];
  propertyPortalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<State>;
  subPropertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ChannelManagerEvent = {
  message?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  processed: Scalars['Boolean'];
  propertyId?: Maybe<Scalars['ID']>;
  reservationCode?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type ChannelManagerEventFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entita che ci permette di aggiungere informazioni provenienti dai portali alla pagina di configurazione. */
export type ChannelOutput = {
  channel?: Maybe<Channel>;
  id: Scalars['ID'];
  /** Eventuali messaggi che vogliamo veicolare sul client */
  message?: Maybe<Scalars['String']>;
  /** onboardingUrl attivo solo se stato è draft, è utilizzabile solo AirBnb e Booking.com */
  onboardingUrl?: Maybe<Scalars['String']>;
  /** Indica lo stato dei dati di configurazione presenti nel portale.     Se true: tutti i dati sono stati letti con successo.     Se false: non è stato possibile leggere i dati del portale. */
  portalDataRetrieved: Scalars['Boolean'];
  portalOpportunities?: Maybe<Array<PortalOpportunity>>;
  /** Mapping Rate non più attivi */
  portalRatesNoLongerExist?: Maybe<Array<ChannelRateMapping>>;
  /** Tipologie */
  portalRatesNotMapped?: Maybe<Array<PortalRate>>;
  /** Id di rate mappate ma tariffe non più presenti sul portale */
  portalRatesWarn?: Maybe<Array<Scalars['ID']>>;
  /** Mapping Tipologie non più attivi */
  portalResourcesTypeNoLongerExist?: Maybe<Array<ChannelResourceTypeMapping>>;
  portalResourcesTypeNotMapped?: Maybe<Array<PortalResourceType>>;
  /** Id di tipologie mappate ma camere non più presenti sul portale */
  portalResourcesTypeWarn?: Maybe<Array<Scalars['ID']>>;
};

export type ChannelQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const ChannelQueueType = {
  HIGH: 'HIGH',
  NORMAL: 'NORMAL',
  RATE_LIMITED: 'RATE_LIMITED'
} as const;

export type ChannelQueueType = typeof ChannelQueueType[keyof typeof ChannelQueueType];
export type ChannelRateEventPayload = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellRateEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di associare per ogni tariffa del pms la tariffa del portale, su ogni tariffa sono presenti le tipologie gestite. */
export type ChannelRateMapping = {
  /** Arrangiamento, possiamo decidere di non usare l'arrangiamento di default */
  chargeCategoryId?: Maybe<Scalars['ID']>;
  portalrate: PortalRate;
  rate?: Maybe<Rate>;
  rateId: Scalars['ID'];
};

export type ChannelRateMappingInput = {
  /** Arrangiamento, possiamo decidere di non usare l'arrangiamento di default */
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
  portalrate: PortalRateInput;
  rateId: Scalars['ID'];
};

/** Tipo che contiene le prenotazioni scaricate dai channels */
export type ChannelReservation = {
  action: BookingAction;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['ID']>;
  expireAt: Scalars['DateTime'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  /**
   * Token per recuperare dal card-vault i dati della carta di pagamento, se presente:
   * se nella prenotazione sono presenti i dati di una carta, questa viene tokenizzata e i dati originali nella prenotazione vengono offuscati.
   */
  paymentCardToken?: Maybe<Scalars['String']>;
  portalName: PortalName;
  processed: Scalars['Boolean'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  receivedOn: Scalars['DateTime'];
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  sourceJson: Scalars['JSON'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type ChannelReservationEventPayload = {
  action: BookingAction;
  channelReservationId: Scalars['String'];
};

/** Tipo che ci permette di associare le tipologie tra il portale e il gestionale */
export type ChannelResourceTypeMapping = {
  portalResourceType: PortalResourceType;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId: Scalars['ID'];
};

export type ChannelResourceTypeMappingInput = {
  portalResourceType: PortalResourceTypeInput;
  resourceTypeId: Scalars['ID'];
};

export type ChannelSpecificAvailabilityEventPayload = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  priority?: Maybe<ChannelQueueType>;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  stopSellEvent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChannelSpecificPriceEventPayload = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  priority?: Maybe<ChannelQueueType>;
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

/**
 * Entita base per gli addebiti, si porta dietro le informazioni base come l'iva di default se è un arrangiamento
 * Potrebbero essere tipi addebiti comuni al tenant
 */
export type ChargeCategory = {
  auditable: Auditable;
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  /** Codice richiesto nel caso di addebiti di arrangiamento */
  code?: Maybe<ChargeCategoryBoard>;
  defaultVat: Vat;
  /** Il default Vat indica l'aliquota iva di default dell'addebito */
  defaultVatId: Scalars['ID'];
  dinnerIncluded: Scalars['Boolean'];
  id: Scalars['ID'];
  lunchIncluded: Scalars['Boolean'];
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId?: Maybe<Scalars['ID']>;
  /** Indica se la categoria è un arrangiamento */
  stayIncluded: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

/** Enumerativo dei codici di arrangiamento */
export const ChargeCategoryBoard = {
  BB: 'BB',
  FB: 'FB',
  HB: 'HB',
  RO: 'RO'
} as const;

export type ChargeCategoryBoard = typeof ChargeCategoryBoard[keyof typeof ChargeCategoryBoard];
export type ChargeCategoryInput = {
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  code?: InputMaybe<ChargeCategoryBoard>;
  defaultVatId: Scalars['ID'];
  dinnerIncluded: Scalars['Boolean'];
  lunchIncluded: Scalars['Boolean'];
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  stayIncluded: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type ChargeCategoryPrice = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  price: Scalars['Int'];
  range?: Maybe<Array<Range>>;
};

export type ChargeCategoryPriceInput = {
  chargeCategoryId: Scalars['ID'];
  price: Scalars['Int'];
  range?: InputMaybe<Array<RangeInput>>;
};

export type ChargeCategoryQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  stayIncluded?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type ChargeCategoryTranscodeSource = {
  /** L'identificativo esterno del reparto. */
  externalDepartmentId: Scalars['String'];
  /** L'identificativo esterno della modalità di vendita. */
  externalSalesModeId?: Maybe<Scalars['String']>;
  /** L'identificativo del turno. Se non è presente, allora il turno è unico. */
  mealShiftId?: Maybe<Scalars['String']>;
};

export type ChargeConversion = {
  destinationChargeCategoryId: Scalars['ID'];
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId?: Maybe<Scalars['ID']>;
  sourceChargeCategoryId: Scalars['ID'];
};

export type ChargeConversionInput = {
  destinationChargeCategoryId: Scalars['ID'];
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
  sourceChargeCategoryId: Scalars['ID'];
};

export type ChargeForReservationInput = {
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ChargePartition = {
  chargeMappings: Array<ChargePartitionMapping>;
  rateId?: Maybe<Scalars['ID']>;
  residualChargeCategoryId: Scalars['ID'];
  sourceChargeCategoryId: Scalars['ID'];
  validity?: Maybe<ClosedRange>;
};

export type ChargePartitionInput = {
  chargeMappings: Array<ChargePartitionMappingInput>;
  rateId?: InputMaybe<Scalars['ID']>;
  residualChargeCategoryId: Scalars['ID'];
  sourceChargeCategoryId: Scalars['ID'];
  validity?: InputMaybe<ClosedRangeInput>;
};

export type ChargePartitionMapping = {
  adults: Scalars['Boolean'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Int'];
};

export type ChargePartitionMappingInput = {
  adults: Scalars['Boolean'];
  chargeCategoryId: Scalars['ID'];
  children: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Int'];
};

/**
 * Questa entità fornisce la varizioni di prezzo dall'arrangiamento base
 * L'importo si riferisce sempre a persona e a notte se specificato a persona, se il modello è derivato altrimenti
 * se statico non viene gestito il tipo di operazione ma viene usato il price come importo e gli importi per le altre occupazioni
 * Se derivato la variazione può essere positiva o negativa in base al servizio selezionato come base.
 * In caso in cui si imposta l'importo direttamente (Static Rate) si gestisce tutto in priceForDifferentOccupation, in questo caso
 * deve essere specificato anche la tipologia di camera
 */
export type ChargeRate = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  operation: MathOperation;
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i prezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  priceModel: PriceModel;
  resourceType?: Maybe<ResourceType>;
  resourceTypeId?: Maybe<Scalars['ID']>;
};

export type ChargeRateBaseInput = {
  chargeCategoryBoard: ChargeCategoryBoard;
  operation: MathOperation;
  price: Scalars['Int'];
};

export type ChargeRateInput = {
  chargeCategoryId: Scalars['ID'];
  operation: MathOperation;
  price: Scalars['Int'];
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  priceModel: PriceModel;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
};

/** Entita per gestire gli scorpori e la riclassificazione degli addebiti */
export type ChargeTransformation = {
  auditable: Auditable;
  conversions: Array<ChargeConversion>;
  id: Scalars['ID'];
  partitions: Array<ChargePartition>;
  property: Property;
  propertyId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ChargeTransformationInput = {
  conversions: Array<ChargeConversionInput>;
  partitions: Array<ChargePartitionInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type CheckinCheckoutReservedResourceInput = {
  guestIds: Array<Scalars['ID']>;
  reservedResourceId: Scalars['ID'];
};

export type CheckinCheckoutReservedResourcesInput = {
  /** Nota: campo obbligatorio quando la chiamata avviene nel dominio di sicurezza 'GUEST_PORTAL'. */
  reservationId?: InputMaybe<Scalars['ID']>;
  reservedResources: Array<CheckinCheckoutReservedResourceInput>;
  tenantId: Scalars['ID'];
};

export const CheckoutDocumentGroupType = {
  ANALITIC: 'ANALITIC',
  DATE: 'DATE',
  DATE_BILL: 'DATE_BILL',
  TOTAL: 'TOTAL',
  TOTAL_BILL: 'TOTAL_BILL'
} as const;

export type CheckoutDocumentGroupType = typeof CheckoutDocumentGroupType[keyof typeof CheckoutDocumentGroupType];
/** CHECKOUT */
export type CheckoutDocumentInput = {
  billCheckout: Array<BillCheckoutInput>;
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  deposits: Array<DepositCheckoutInput>;
  draft: Scalars['Boolean'];
  fiscalType: FiscalType;
  groupBy?: InputMaybe<CheckoutDocumentGroupType>;
  note?: InputMaybe<Scalars['String']>;
  payments: Array<DocumentPaymentDetailInput>;
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/**
 * Per ogni property è possibile definire le tipologie dei ragazzi
 * Ad esempio Infant min = 0 e MAx 2, Child min 3 max 12 il resto si considera adulto.
 * In fase di onboarding vengono create di default 2 fasce di cui la infant non occupa posto
 */
export type Child = {
  auditable: Auditable;
  id: Scalars['ID'];
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  /** Proprietà che indica se il bambino è da considerarsi come occupante, se è true non occupa un posto letto. */
  noOccupancy: Scalars['Boolean'];
  /** Indica lo sconto base della fascia di età, varia da 0 a 1 */
  percentageDiscount: Scalars['Float'];
  propertyId?: Maybe<Scalars['ID']>;
  taxonomy: Taxonomy;
  taxonomyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di sapere lo sconto applicare per ogni fascia */
export type ChildDiscountPercentage = {
  child: Child;
  childId: Scalars['ID'];
  percentage: Scalars['Float'];
};

/** Tipo che ci permette di sapere lo sconto applicare per ogni fascia (childID deve essere stringa vuota per creare un nuovo Child) */
export type ChildDiscountPercentageInput = {
  child?: InputMaybe<ChildRateInput>;
  childId: Scalars['ID'];
  percentage: Scalars['Float'];
};

export type ChildOccupancy = {
  child: Child;
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyAvailabilityRequest = {
  child: Child;
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyInput = {
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildOccupancyRQInput = {
  childId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ChildQueryFilter = {
  id?: InputMaybe<IDFilter>;
  maxAge?: InputMaybe<IntFilter>;
  minAge?: InputMaybe<IntFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo che permette di inserire/modificare un Child quando si gestisce una Rate BASE */
export type ChildRateInput = {
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  noOccupancy: Scalars['Boolean'];
  taxonomyId: Scalars['ID'];
};

export type ChildRule = {
  /** Eventuali sconti per fascia di età che vanno in ovveride agli sconti standard */
  childDiscount?: Maybe<Array<ChildDiscountPercentage>>;
  rule: ChildRuleType;
};

export type ChildRuleInput = {
  /** Eventuali sconti per fascia di età che vanno in ovveride agli sconti standard */
  childDiscount?: InputMaybe<Array<ChildDiscountPercentageInput>>;
  rule: ChildRuleType;
};

export const ChildRuleType = {
  INHERITANCE: 'INHERITANCE',
  NOTAPPLY: 'NOTAPPLY',
  OVERRIDE: 'OVERRIDE'
} as const;

export type ChildRuleType = typeof ChildRuleType[keyof typeof ChildRuleType];
/** Embedded Type per AdditionalService */
export type ChildServicePrice = {
  child: Child;
  childId: Scalars['ID'];
  price: Scalars['Int'];
};

export type ChildServicePriceInput = {
  childId: Scalars['ID'];
  price: Scalars['Int'];
};

export type CityTaxAmountByPeriod = {
  amount: Scalars['Int'];
  period: Range;
};

export type CityTaxAmountByPeriodInput = {
  amount: Scalars['Int'];
  period: RangeInput;
};

/** CityTaxConfiguration embedded document */
export type CityTaxConfiguration = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  configurations: Array<CityTaxRuleConfiguration>;
};

export type CityTaxConfigurationInput = {
  amount: Scalars['Int'];
  amountByPeriod?: InputMaybe<Array<CityTaxAmountByPeriodInput>>;
  currency: Scalars['Currency'];
  fileGenerator?: InputMaybe<CityTaxFileGenerator>;
  genericConfiguration?: InputMaybe<CityTaxGenericConfigurationInput>;
  name: Scalars['String'];
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  rule: CityTaxRule;
};

export type CityTaxDocumentRange = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

/** Causali di esenzione CityTax */
export type CityTaxExoneration = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
  discount?: Maybe<Scalars['Float']>;
  extCode?: Maybe<Scalars['String']>;
};

export const CityTaxExonerationCode = {
  ACINV74: 'ACINV74',
  ACPZRI: 'ACPZRI',
  AGECOMM: 'AGECOMM',
  AIRBNB: 'AIRBNB',
  AIRE: 'AIRE',
  ANZIANI: 'ANZIANI',
  ARTIACC: 'ARTIACC',
  ASSDEGENTI: 'ASSDEGENTI',
  ATLETI: 'ATLETI',
  AUTELE: 'AUTELE',
  AUTISTA: 'AUTISTA',
  AZPROD: 'AZPROD',
  CALAMITA: 'CALAMITA',
  CARDTURI: 'CARDTURI',
  CASERIPOSO: 'CASERIPOSO',
  COMROS: 'COMROS',
  CONTR_TO: 'CONTR_TO',
  CONVRFI: 'CONVRFI',
  CORDIPLEST: 'CORDIPLEST',
  COSSNA: 'COSSNA',
  COVID19: 'COVID19',
  DAYUSE: 'DAYUSE',
  DETNT: 'DETNT',
  DIPPUBMIS: 'DIPPUBMIS',
  DIPSTRUT: 'DIPSTRUT',
  DISABILI: 'DISABILI',
  DOCENTE: 'DOCENTE',
  EDUCATOUR: 'EDUCATOUR',
  ES12NOTTI: 'ES12NOTTI',
  ESENTEG7: 'ESENTEG7',
  ESGESTR: 'ESGESTR',
  ESMINSTRA: 'ESMINSTRA',
  ESPROINT: 'ESPROINT',
  ESVITRATTA: 'ESVITRATTA',
  ESVIVIODOM: 'ESVIVIODOM',
  ETAMAX: 'ETAMAX',
  ETAMIN: 'ETAMIN',
  FAPZR: 'FAPZR',
  FGLTRZ: 'FGLTRZ',
  FORZEORD: 'FORZEORD',
  GEMELTAO: 'GEMELTAO',
  GIORNALIST: 'GIORNALIST',
  GIORTAO: 'GIORTAO',
  GRPSCL: 'GRPSCL',
  GRPSPORT: 'GRPSPORT',
  GRUPPI: 'GRUPPI',
  GUIDA: 'GUIDA',
  INDACC: 'INDACC',
  INVAL74: 'INVAL74',
  LAV5NOTMAX: 'LAV5NOTMAX',
  LAVORATORE: 'LAVORATORE',
  LAVPUB: 'LAVPUB',
  MINA18: 'MINA18',
  MINGSP: 'MINGSP',
  MINORI: 'MINORI',
  MINOSP: 'MINOSP',
  MULTI: 'MULTI',
  NOCITYTAX: 'NOCITYTAX',
  NOTTIMAX: 'NOTTIMAX',
  NOTTIMAXCN: 'NOTTIMAXCN',
  NOTTIMAXCV: 'NOTTIMAXCV',
  NOTTIMAXUA: 'NOTTIMAXUA',
  OSPCASA: 'OSPCASA',
  OSPCOMUNE: 'OSPCOMUNE',
  OSPUAB: 'OSPUAB',
  P6090120: 'P6090120',
  PGKO: 'PGKO',
  PROIMM: 'PROIMM',
  PROIMU: 'PROIMU',
  R50GSCT: 'R50GSCT',
  RESIDENTE: 'RESIDENTE',
  RIABILITAZ: 'RIABILITAZ',
  RICERCA: 'RICERCA',
  RID30GR: 'RID30GR',
  RIFPOL: 'RIFPOL',
  RITARDI: 'RITARDI',
  SALUTE: 'SALUTE',
  SALUTE104: 'SALUTE104',
  SALUTEGEN: 'SALUTEGEN',
  SCOLARESC: 'SCOLARESC',
  SCONTOMIN: 'SCONTOMIN',
  SPOSI: 'SPOSI',
  STAGE: 'STAGE',
  STUDACC: 'STUDACC',
  STUDENTE: 'STUDENTE',
  TARFORFET: 'TARFORFET',
  TERAPIA: 'TERAPIA',
  TERMALI: 'TERMALI',
  TRADUTTORE: 'TRADUTTORE',
  VOLONTARI: 'VOLONTARI'
} as const;

export type CityTaxExonerationCode = typeof CityTaxExonerationCode[keyof typeof CityTaxExonerationCode];
export type CityTaxExonerationInput = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
  discount?: InputMaybe<Scalars['Float']>;
  extCode?: InputMaybe<Scalars['String']>;
};

export type CityTaxExonerations = {
  code: CityTaxExonerationCode;
  guests: Array<Scalars['String']>;
  nights: Scalars['Int'];
};

export const CityTaxFileGenerator = {
  PROXIMA: 'PROXIMA',
  TBPRES01: 'TBPRES01'
} as const;

export type CityTaxFileGenerator = typeof CityTaxFileGenerator[keyof typeof CityTaxFileGenerator];
export type CityTaxGenericConfiguration = {
  amountType: ValueType;
  exonerations: Array<CityTaxExoneration>;
  maxNights: Scalars['Int'];
  minAge: Scalars['Int'];
  validity?: Maybe<CityTaxValidity>;
};

export type CityTaxGenericConfigurationInput = {
  amountType: ValueType;
  exonerations: Array<CityTaxExonerationInput>;
  maxNights: Scalars['Int'];
  minAge: Scalars['Int'];
  validity?: InputMaybe<CityTaxValidityInput>;
};

export type CityTaxRegulationRicestat = {
  municipalityCode: Scalars['String'];
  rules: Array<CityTaxRegulationRicestatRule>;
};

export type CityTaxRegulationRicestatRule = {
  cityTaxCode: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CityTaxReport = {
  creditNote?: Maybe<CityTaxReportDetail>;
  invoice?: Maybe<CityTaxReportDetail>;
  receipt?: Maybe<CityTaxReportDetail>;
};

export type CityTaxReportDetail = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  documents: CityTaxDocumentRange;
  exonerations: Array<CityTaxReportExoneration>;
  payingGuests: Scalars['Int'];
  payingNights: Scalars['Int'];
};

export type CityTaxReportExoneration = {
  guests: Scalars['Int'];
  nights: Scalars['Int'];
  type: CityTaxReportExonerationType;
};

export type CityTaxReportExonerationType = {
  code: CityTaxExonerationCode;
  description: Scalars['LocalizedString'];
};

export type CityTaxReportInput = {
  from: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  to: Scalars['Date'];
};

export const CityTaxRule = {
  BERGAMO: 'BERGAMO',
  CALENZANO: 'CALENZANO',
  FIUGGI: 'FIUGGI',
  GENERIC: 'GENERIC',
  ROMA: 'ROMA',
  ROMA_CAMPING: 'ROMA_CAMPING',
  SERRALUNGA_ALBA: 'SERRALUNGA_ALBA',
  VENEZIA: 'VENEZIA'
} as const;

export type CityTaxRule = typeof CityTaxRule[keyof typeof CityTaxRule];
export type CityTaxRuleConfiguration = {
  amount: Scalars['Int'];
  amountByPeriod?: Maybe<Array<CityTaxAmountByPeriod>>;
  currency: Scalars['Currency'];
  fileGenerator?: Maybe<CityTaxFileGenerator>;
  genericConfiguration?: Maybe<CityTaxGenericConfiguration>;
  name: Scalars['String'];
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  rule: CityTaxRule;
};

export type CityTaxRulesOutput = {
  match: Scalars['Boolean'];
  rules: Array<CityTaxRule>;
};

export type CityTaxStatistics = {
  amount: Scalars['Int'];
  exonerations: Array<CityTaxExonerations>;
  payingGuests: Array<Scalars['String']>;
  payingNights: Scalars['Int'];
};

export type CityTaxValidity = {
  /**  mmDD format  */
  end: Scalars['String'];
  /**  mmDD format  */
  start: Scalars['String'];
};

export type CityTaxValidityInput = {
  /**  mmDD format  */
  end: Scalars['String'];
  /**  mmDD format  */
  start: Scalars['String'];
};

export const CleaningState = {
  CLEAN: 'CLEAN',
  DIRTY: 'DIRTY'
} as const;

export type CleaningState = typeof CleaningState[keyof typeof CleaningState];
export type ClosedRange = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

export type ClosedRangeInput = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

/** Tipo company serve per gestire le specificità delle aziende */
export type Company = {
  defaultCredit?: Maybe<CreditType>;
  felOptions?: Maybe<CompanyFelOptions>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: Maybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type CompanyFelOptions = {
  /** se true riporta il voucher della prenotazione sul campo 2.2.1.15 (RiferimentoAmministrazione) */
  riferimentoAmministrazione?: Maybe<Scalars['Boolean']>;
};

export type CompanyFelOptionsInput = {
  /** se true riporta il voucher della prenotazione sul campo 2.2.1.15 (RiferimentoAmministrazione) */
  riferimentoAmministrazione?: InputMaybe<Scalars['Boolean']>;
};

export type CompanyInfoForPrivacyOutput = {
  address?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  defaultCredit?: InputMaybe<CreditType>;
  felOptions?: InputMaybe<CompanyFelOptionsInput>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: InputMaybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type ConfigMappingQueryFilter = {
  portalId: IDFilter;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export type ConfirmQuotationInput = {
  additionalNote?: InputMaybe<NoteInput>;
  company?: InputMaybe<CustomerInput>;
  customer?: InputMaybe<CustomerInput>;
  overbooking: OvbResolveType;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userAddedServices?: InputMaybe<Array<UserAddedService>>;
};

/**
 * Tipo che contiene le informazioni che non devono mutare all'interno del documento e che permettono una nuova stampa o gestione che non varia nel tempo
 * Il layout è da consolidare come tipo
 */
export type ConsolidatedData = {
  cityTaxStatistics?: Maybe<CityTaxStatistics>;
  customer: Customer;
  /** TBD da definire coem gestirlo */
  layout: Scalars['String'];
};

/** Entità per la gestione dei contatori (prenotazioni, documenti, ...) */
export type Counter = {
  auditable: Auditable;
  documentActiveId?: Maybe<Scalars['ID']>;
  /** Codifica del numeratore con placeholders: {{value}}, {{value:x}}, {{year}}, {{year_2}} */
  format: Scalars['String'];
  id: Scalars['ID'];
  propertyId?: Maybe<Scalars['ID']>;
  /** Impostare a true Se il numeratore deve essere resettato al cambio anno. */
  reset: Scalars['Boolean'];
  /**  subType e documentActiveId sono valorizzati solo se il type è DOCUMENT  */
  subType?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type CounterResult = {
  code: Scalars['String'];
  value: Scalars['Int'];
};

/** Tipologie di contatori per i progressivi */
export const CounterType = {
  CUSTOMER: 'CUSTOMER',
  DOCUMENT: 'DOCUMENT',
  ELECTRONIC_INVOICE: 'ELECTRONIC_INVOICE',
  GDPRLOG: 'GDPRLOG',
  QUOTATION: 'QUOTATION',
  RESERVATION: 'RESERVATION'
} as const;

export type CounterType = typeof CounterType[keyof typeof CounterType];
/** Nazioni con codici ISO necessari per le integrazioni */
export type Country = {
  auditable: Auditable;
  codeItalianPs: Scalars['String'];
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  isoCode3: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['LocalizedString'];
};

export type CountryInput = {
  codeItalianPs: Scalars['String'];
  isoCode: Scalars['String'];
  isoCode3: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['LocalizedString'];
};

export type CountryQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isoCode?: InputMaybe<StringFilter>;
  isoCode3?: InputMaybe<StringFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
};

export type CreateCounterInput = {
  documentActiveId?: InputMaybe<Scalars['String']>;
  format: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  reset: Scalars['Boolean'];
  subType?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type CreateCountersForPropertyInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  year: Scalars['Int'];
};

export type CreateResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailability: ResourceUnavailabilityInput;
};

/** CREDIT NOTE */
export type CreditNoteDocumentInput = {
  /** Used to partial revert document */
  documentDetailsToRevert?: InputMaybe<Array<DocumentDetailToRevertInput>>;
  /** id of the document to revert */
  documentId: Scalars['ID'];
  paymentActiveId?: InputMaybe<Scalars['ID']>;
  reverseProduction: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type CreditNoteForAdvanceInput = {
  /** id of the document to revert */
  documentId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const CreditType = {
  FC: 'FC',
  FCT: 'FCT',
  HC: 'HC',
  HCT: 'HCT',
  NC: 'NC'
} as const;

export type CreditType = typeof CreditType[keyof typeof CreditType];
/**
 * Tipo di logica daapplicare al motore di tariffe, se l'offerta non copre tutto il periodo richiesto il sistema deve decidere in base a questo valore
 * Nocross indica al sistema che l'offerta non ha termini di applicabilità diversi da quelli impostati, estendi indica che l'importo viene esteso anche agli altri giorni,
 * ma non viene applicato lo sconto
 */
export const CrossSell = {
  EXTEND: 'EXTEND',
  NOCROSS: 'NOCROSS'
} as const;

export type CrossSell = typeof CrossSell[keyof typeof CrossSell];
/** Enum usato negli eventi */
export const CrudOperation = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE'
} as const;

export type CrudOperation = typeof CrudOperation[keyof typeof CrudOperation];
/**
 * Il Customer può essere una persona o un'azienda, l'azienda puà essere una società
 * In caso di persona il nome completo deve essere inserito in name mettendo prima il cognome e poi il nome.
 */
export type Customer = {
  address?: Maybe<Address>;
  auditable: Auditable;
  cityTax?: Maybe<CustomerCityTax>;
  /** In caso di tipo company ci sono i dati specifici. */
  company?: Maybe<Company>;
  /** Indica il Cliente fittizio, è presente un solo customer dummy per tenant */
  dummyCustomer?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['CapitalizedString']>;
  fiscalCode?: Maybe<Scalars['UppercaseString']>;
  id: Scalars['ID'];
  language: Scalars['Language'];
  lastName?: Maybe<Scalars['CapitalizedString']>;
  mailContacts?: Maybe<Array<MailContact>>;
  /** Codice da utilizzare per le configurazioni di export */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['CapitalizedString'];
  /** In caso di tipo Persona ci sono i dati specifici. */
  person?: Maybe<Person>;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  privacy?: Maybe<Privacy>;
  relatedCompany?: Maybe<Customer>;
  /**  Azienda collegata ad un cliente  */
  relatedCompanyId?: Maybe<Scalars['ID']>;
  /**  vatId to use for stay production  */
  stayVatId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Tag>>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  type: CustomerType;
  vatNumber?: Maybe<Scalars['UppercaseString']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type CustomerAvailabilityRequest = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['Language'];
  lastName: Scalars['String'];
  privacy: Privacy;
};

export type CustomerAvailabilityRequestInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Scalars['Language'];
  lastName: Scalars['String'];
  privacy: PrivacyInput;
};

export type CustomerCityTax = {
  contracts?: Maybe<Array<Range>>;
  exoneration?: Maybe<CityTaxExonerationCode>;
};

export type CustomerCityTaxInput = {
  contracts?: InputMaybe<Array<RangeInput>>;
  exoneration?: InputMaybe<CityTaxExonerationCode>;
};

/**
 * Entità che contiene una immagine collegata a un ospite (esempio: documento di identità, firma, ecc.).
 * Le immagini vengono cancellate da un indice TTL dopo 10gg da checkoutDate.
 * NB: a parità di customer, possono esistere altre immagini per eventuali altre facciate dello stesso documento.
 */
export type CustomerDocumentImage = {
  /** Data di checkout dell'ospite (serve per la successiva cancellazione dell'immagine, dopo 10 giorni). */
  checkoutDate: Scalars['Date'];
  /** Id del Customer a cui appartiene il documento. */
  customerId: Scalars['ID'];
  /** Descrizione dell'immagine (esempio: Carta d'identità - fronte, Carta d'identità - retro, firma, ecc.). */
  description: Scalars['String'];
  file: File;
  /** Id dell'entità File contenente i dettagli dell'immagine. */
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  reservedResource: ReservedResource;
  /** Id della ReservedResource a cui è associato il documento. */
  reservedResourceId: Scalars['ID'];
  /** La tipologia di immagine. */
  type: CustomerDocumentImageType;
};

export type CustomerDocumentImageQueryFilter = {
  customerId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** La tipologia di immagine collegata a un ospite. */
export const CustomerDocumentImageType = {
  IDENTIFICATION_DOCUMENT: 'IDENTIFICATION_DOCUMENT',
  SELFIE: 'SELFIE',
  SIGNATURE: 'SIGNATURE'
} as const;

export type CustomerDocumentImageType = typeof CustomerDocumentImageType[keyof typeof CustomerDocumentImageType];
export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  cityTax?: InputMaybe<CustomerCityTaxInput>;
  company?: InputMaybe<CompanyInput>;
  firstName?: InputMaybe<Scalars['String']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  language: Scalars['Language'];
  lastName?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  person?: InputMaybe<PersonInput>;
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  privacy?: InputMaybe<PrivacyInput>;
  relatedCompanyId?: InputMaybe<Scalars['ID']>;
  stayVatId?: InputMaybe<Scalars['ID']>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  type: CustomerType;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type CustomerQueryFilter = {
  dummy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  search?: InputMaybe<StringFilter>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: IDFilter;
  type?: InputMaybe<CustomerType>;
};

/** Use just one key per array element */
export type CustomerSortInput = {
  fiscalCode?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  person?: InputMaybe<PersonSortInput>;
  type?: InputMaybe<Sort>;
  vatNumber?: InputMaybe<Sort>;
};

export const CustomerType = {
  COMPANY: 'COMPANY',
  PERSON: 'PERSON'
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];
/** Definizione giornaliera della disponibilità, l'availability è la disponibilità reale della tipololgia, onlineLimit è quella on line. */
export type DailyAvailability = {
  auditable: Auditable;
  availability: Scalars['Int'];
  day: Scalars['Date'];
  id: Scalars['ID'];
  inventory: Scalars['Int'];
  onlineLimit?: Maybe<Scalars['Int']>;
  portalVariations?: Maybe<Array<PortalVariation>>;
  property: Property;
  propertyId: Scalars['ID'];
  reservedResources: Array<ReservedResource>;
  reservedResourcesId: Array<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resources: Array<ResourceCommitment>;
  shadowCommitments?: Maybe<Array<ShadowCommitment>>;
  stopSellOTA: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DailyAvailabilityQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  propertyId?: InputMaybe<IDFilter>;
  resourceTypeId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Rate Query Embedded Type */
export type DailyAvailabilityRq = {
  availability: Scalars['Int'];
  day: Scalars['Date'];
};

/** Configurazione delle procedure di chiusura notturna per Property */
export type DailyClosure = {
  auditable: Auditable;
  id: Scalars['ID'];
  /** procedures with order less than 100 are executed under transaction */
  order: Scalars['Int'];
  procedureName: DailyClosureProcedure;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Log delle procedure di chiusura notturna */
export type DailyClosureAudit = {
  /** Nome della eventuale configurazione della procedura. */
  configurationName?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  executedBy: Scalars['String'];
  executionDate: Scalars['DateTime'];
  /** Gli identificativi di eventuali file scaricati e/o generati dalla procedura. */
  fileIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  manualExecution: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  procedureName: DailyClosureProcedure;
  propertyId: Scalars['ID'];
  referenceDate: Scalars['DateTime'];
  result: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DailyClosureAuditQueryFilter = {
  executionDate?: InputMaybe<DateFilter>;
  procedureName?: InputMaybe<DailyClosureProcedure>;
  propertyId: IDFilter;
  referenceDate?: InputMaybe<DateFilter>;
  result?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type DailyClosureAuditSortInput = {
  executionDate?: InputMaybe<Sort>;
  result?: InputMaybe<Sort>;
};

export type DailyClosureCommandPayload = {
  messageGroupId: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: DailyClosureCommandType;
};

export const DailyClosureCommandType = {
  DAILY_CLOSURE: 'DAILY_CLOSURE',
  SEND_PS: 'SEND_PS'
} as const;

export type DailyClosureCommandType = typeof DailyClosureCommandType[keyof typeof DailyClosureCommandType];
export type DailyClosureConfiguration = {
  automatic: Scalars['Boolean'];
  time: Scalars['Time'];
};

export type DailyClosureConfigurationInput = {
  automatic: Scalars['Boolean'];
  time: Scalars['Time'];
};

export type DailyClosureEvent = {
  errors?: Maybe<Array<Scalars['String']>>;
  procedureNames?: Maybe<Array<DailyClosureProcedure>>;
  propertyId: Scalars['ID'];
  result: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DailyClosureEventFilter = {
  procedureName?: InputMaybe<DailyClosureProcedure>;
  propertyId: Scalars['ID'];
  result?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Procedure che possono essere lanciate durante la chiusura giornaliera */
export const DailyClosureProcedure = {
  AssignIncomingResource: 'AssignIncomingResource',
  ChangeDate: 'ChangeDate',
  CreateDailyAvailabilitySnapshot: 'CreateDailyAvailabilitySnapshot',
  ExpiredQuotations: 'ExpiredQuotations',
  ExtendDailyAvailability: 'ExtendDailyAvailability',
  GetReceiptPS: 'GetReceiptPS',
  PSLongStay: 'PSLongStay',
  ResourceCleaningState: 'ResourceCleaningState',
  SendIstat: 'SendIstat',
  SendPS: 'SendPS',
  VerifyAndReOpenCashDesks: 'VerifyAndReOpenCashDesks'
} as const;

export type DailyClosureProcedure = typeof DailyClosureProcedure[keyof typeof DailyClosureProcedure];
/** Istantanea della disponibilità per il pickup */
export type DailyForecastSnapshot = {
  currency: Scalars['Currency'];
  days: Array<DayForecastSnapshot>;
  hotelDate: Scalars['Date'];
  hotelDateHistory?: Maybe<DayForecastSnapshot>;
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  year: Scalars['Int'];
};

export type DailyForecastSnapshotQueryFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DailyForecastSnapshotSortInput = {
  hotelDate?: InputMaybe<Sort>;
};

export type DailyPrice = {
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
  price: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

/** Rate Query Embedded Type */
export type DailyPriceRq = {
  day: Scalars['Date'];
  price: Scalars['Int'];
  restriction?: Maybe<RateRestriction>;
};

/**
 * Entità che mantiene giornalmente i dati delle tariffe:
 * per ogni giorno e tariffa contiene la lista dei prezzi modificati
 */
export type DailyRate = {
  auditable: Auditable;
  bookingPolicy?: Maybe<BookingPolicy>;
  /** E' possibile avere una gestione giornaliera della policy */
  bookingPolicyId?: Maybe<Scalars['ID']>;
  chargesRate?: Maybe<Array<ResourceChargeRate>>;
  closeChargesCategories?: Maybe<Array<ChargeCategory>>;
  /** Arrangiamenti chiusi rispetto alla tariffa, ad esempio in inverno non c'è il ristorante o è chiuso per problemi */
  closeChargesCategoryId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  day: Scalars['Date'];
  id: Scalars['ID'];
  property: Property;
  propertyId: Scalars['ID'];
  rate: Rate;
  /** Tariffa a cui si applicano le modifiche */
  rateId: Scalars['ID'];
  stopSellResourcesType?: Maybe<Array<ResourceType>>;
  /** Risorse bloccate alla vendita sul giorno, vanno in ovveride alla tariffa */
  stopSellResourcesTypeId?: Maybe<Array<Scalars['ID']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DashBoardRefreshEvent = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DashboardEventRow = {
  /** The data related to the event. */
  data?: Maybe<Array<Scalars['String']>>;
  /** The date and time when the event occurred. */
  occurred: Scalars['DateTime'];
};

export type DashboardKpiRow = {
  /** The current number counted up to now. */
  current: Scalars['Int'];
  /** Additional data. */
  moreData?: Maybe<Array<Scalars['Int']>>;
  /** The expected total number for today. */
  total?: Maybe<Scalars['Int']>;
};

export type DashboardMealsQueryOutput = {
  /** The breakfasts. */
  breakfasts: DashboardKpiRow;
  /** The dinners. */
  dinners: DashboardKpiRow;
  /** The lunches. */
  lunches: DashboardKpiRow;
};

export type DashboardQueryFilter = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DashboardReceptionQueryOutput = {
  /** The resources with guests who are arriving, where: moreData[0] is 'current persons arrived up to now'; moreData[1] is 'expected persons to arrive today'; moreData[2] is 'resources with not shown persons (when the requested day is HotelDate)'; moreData[3] is 'not shown persons (when the requested day is HotelDate)'. */
  arrivals: DashboardKpiRow;
  /** The resources availability. */
  availability: DashboardKpiRow;
  /** The resources with guests who are leaving, where: moreData[0] is 'current persons left up to now'; moreData[1] is 'expected persons to leave today'. */
  departures: DashboardKpiRow;
  /** The resources occupancy, where: moreData[0] is 'resources unavailability'. */
  occupancy: DashboardKpiRow;
};

export type DashboardRevenueQueryOutput = {
  /** The Average Daily Rate (ADR). */
  adr: DashboardKpiRow;
  /** The Revenue Per Available Room (RevPAR). */
  revpar: DashboardKpiRow;
  /** The room production. */
  roomProduction: DashboardKpiRow;
  /** The total production. */
  totalProduction: DashboardKpiRow;
};

export type DashboardSellsQueryOutput = {
  /** The number of cancellations, where: total is 'total production generated by the reservations'. */
  cancellations: DashboardKpiRow;
  /** The last cancellation, where: data[0] is 'reservation number'; data[1] is 'arrival date'; data[2] is 'reservation amount'; data[3] is 'name of the person who had booked'. */
  lastCancellation?: Maybe<DashboardEventRow>;
  /** The last reservation, where: data[0] is 'reservation number'; data[1] is 'arrival date'; data[2] is 'reservation amount'; data[3] is 'name of the person who has booked'. */
  lastReservation?: Maybe<DashboardEventRow>;
  /** The number of reservations, where: total is 'the total production generated by the reservations'. */
  reservations: DashboardKpiRow;
};

export type DatabaseAttachState = {
  info?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
};

export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
};

export type DatiDocumentiCorrelati = {
  codiceCIG?: Maybe<Scalars['String']>;
  codiceCUP?: Maybe<Scalars['String']>;
  commessa?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['Date']>;
  idDocumento?: Maybe<Scalars['String']>;
};

export type DatiDocumentiCorrelatiInput = {
  codiceCIG?: InputMaybe<Scalars['String']>;
  codiceCUP?: InputMaybe<Scalars['String']>;
  commessa?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Date']>;
  idDocumento?: InputMaybe<Scalars['String']>;
};

export type DayForecastSnapshot = {
  day: Scalars['Date'];
  distributions: Array<ForecastDistribution>;
  /** Sum of inventory of all resource types. */
  inventory: Scalars['Int'];
  /** Sum of availability of all resource types. */
  occupancy: Scalars['Int'];
  resourceTypeHistory: Array<ForecastResourceType>;
  roomProduction: ProductionAmount;
  totalProduction: ProductionAmount;
  /** Sum of all unavailability */
  unavailability: Scalars['Int'];
};

export type DeleteResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailabilityId: Scalars['ID'];
};

/**
 * Entità che ci permette di associare i documenti di deposito con i conti
 * Il conto non è obbligatorio. Amount è sempre positivo.
 * Se non esiste documentId la quota di deposito è disponibile
 * Se esiste documentId la quota di deposito è stata utilizzata
 * La quota disponibile di un depositDocument è la somma di amount dei record con depositDocumentId richiesto e documentId a null
 * La quota utilizzata di un depositDocument è la somma di amount dei record con depositDocumentId richiesto e documentId valorizzato
 */
export type DepositAssigned = {
  amount: Scalars['Int'];
  auditable: Auditable;
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  depositDocument: Document;
  depositDocumentId: Scalars['ID'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type DepositAssignment = {
  amount: Scalars['Int'];
  billId?: Maybe<Scalars['ID']>;
  reservationId?: Maybe<Scalars['ID']>;
  reservedResourceId?: Maybe<Scalars['ID']>;
};

export type DepositAssignmentInput = {
  amount: Scalars['Int'];
  billId?: InputMaybe<Scalars['ID']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  reservedResourceId?: InputMaybe<Scalars['ID']>;
};

export type DepositCheckoutInput = {
  amount: Scalars['Int'];
  depositAssignedId: Scalars['ID'];
};

/** DEPOSIT */
export type DepositDocumentInput = {
  amount: Scalars['Int'];
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  depositAssignments: Array<DepositAssignmentInput>;
  draft: Scalars['Boolean'];
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  payments: Array<DocumentPaymentDetailInput>;
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  vatId?: InputMaybe<Scalars['ID']>;
};

export type DepositDocumentQueryFilter = {
  billId?: InputMaybe<Scalars['ID']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: IDFilter;
};

/** Le regole di derivazione si applicano ad importo passato e vengono elaborate seguendo l'order */
export type DerivationPriceRules = {
  operation: MathOperation;
  order: Scalars['Int'];
  round: Scalars['Boolean'];
  type: ValueType;
  value: Scalars['Float'];
};

/** Tipo che definisce la variazione di prezzo in percentuale rispetto alla base, può sommare o diminuire. */
export type DerivationRules = {
  operation: MathOperation;
  value: Scalars['Float'];
};

/** Tipo che definisce la variazione di prezzo in percentuale rispetto alla base, può sommare o diminuire. */
export type DerivationRulesInput = {
  operation: MathOperation;
  value: Scalars['Float'];
};

/** Questo tipo serve all'interno delle rate per collegare gli addebiti che ereditano dal base i dati e hanno soltanto delle logiche di derivaioni prezzi */
export type DerivedCharge = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  priceRules?: Maybe<Array<DerivationPriceRules>>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type DescriptionRow = {
  description?: Maybe<Scalars['String']>;
  imageFirst?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Tipo che contiene le possibili entità che sono collegate al dettaglio */
export type DetailNature = {
  accountantCategory?: Maybe<AccountantCategory>;
  accountantCategoryId?: Maybe<Scalars['ID']>;
  chargeCategory?: Maybe<ChargeCategory>;
  chargeCategoryId?: Maybe<Scalars['ID']>;
};

export type DetailNatureInput = {
  accountantCategoryId?: InputMaybe<Scalars['ID']>;
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
};

/** Il tipo dictionary è una */
export type Dictionary = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Il tipo dictionarySecrect è un dictionary che la particolarità di avere il valore criptato */
export type DictionarySecrect = {
  key: Scalars['String'];
  value: Scalars['EncryptedString'];
};

/** L'entità documento rappresenta tutti i possibili tipi di documenti che possono essere gestiti in HIC */
export type Document = {
  auditable: Auditable;
  bills?: Maybe<Array<Bill>>;
  cashDesk: CashDesk;
  cashDeskId: Scalars['ID'];
  cashDeskType: CashDeskType;
  cashDeskTypeId: Scalars['ID'];
  consolidatedData?: Maybe<ConsolidatedData>;
  creditNote?: Maybe<Document>;
  creditNoteId?: Maybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  customer: Customer;
  customerId: Scalars['ID'];
  depositAssigneds?: Maybe<Array<DepositAssigned>>;
  depositAssignments?: Maybe<Array<DepositAssignment>>;
  documentDate: Scalars['Date'];
  documentDetails: Array<DocumentDetail>;
  documentPaymentDetails: Array<DocumentPaymentDetail>;
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: DocumentType;
  documentVatDetails: Array<DocumentVatDetail>;
  exportInfo?: Maybe<ExportInfo>;
  felAdditionalInfo?: Maybe<FelAdditionalInfo>;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  /** Eventuali dati extra aggiunti dalla procedura di importazione quando il documento proviene da un altro PMS. */
  importInfo?: Maybe<DocumentImportInfo>;
  netAmount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  referenceDocument?: Maybe<Document>;
  /** Campo calcolato in caso di documentType ADVANCE */
  residualAmount?: Maybe<Scalars['Int']>;
  scelAdditionalInfo?: Maybe<ScelAdditionalInfo>;
  splitPayment: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  totalAmount: Scalars['Int'];
  unpaidAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

/**
 * Tipi documenti attivi per la property o per le subproperty.
 * Per ogni tipologia di documento è possibile definire una serie.
 * Non è possibile avere lo stesso tipo documento attivo senza una serie.
 */
export type DocumentActive = {
  auditable: Auditable;
  counters?: Maybe<Array<Counter>>;
  documentSetCode?: Maybe<Scalars['String']>;
  fiscalType: FiscalType;
  id: Scalars['ID'];
  managementCode?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DocumentActiveInput = {
  documentNumberFormat?: InputMaybe<Scalars['String']>;
  documentSetCode?: InputMaybe<Scalars['String']>;
  fiscalType: FiscalType;
  managementCode?: InputMaybe<Scalars['String']>;
  nextDocumentNumber?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type DocumentCounterInput = {
  documentActiveId?: InputMaybe<Scalars['String']>;
  documentSetCode?: InputMaybe<Scalars['String']>;
  fiscalType?: InputMaybe<FiscalType>;
  format?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  tenantId: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
  year: Scalars['Int'];
};

/** EVENTS */
export type DocumentCreatedEvent = {
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendReceiptByMail?: Maybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Tipo che identifica le righe */
export type DocumentDetail = {
  amount: Scalars['Int'];
  bill?: Maybe<Bill>;
  /** Valorizzato solo nel caso di addebiti raggruppati per conto */
  billId?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  /** Valorizzato solo nel caso di addebiti raggruppati per periodo */
  dateTo?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNature;
  referenceDocument?: Maybe<Document>;
  /** Indica il documento di riferimento, può essere una caparra/anticipo/sospeso */
  referenceDocumentId?: Maybe<Scalars['ID']>;
  totalAmount: Scalars['Int'];
  vat?: Maybe<Vat>;
  vatId?: Maybe<Scalars['ID']>;
};

export type DocumentDetailInput = {
  amount: Scalars['Int'];
  billId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNatureInput;
  referenceDocumentId?: InputMaybe<Scalars['ID']>;
  vatId?: InputMaybe<Scalars['ID']>;
};

export type DocumentDetailToRevertInput = {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNatureInput;
  referenceDocumentId?: InputMaybe<Scalars['ID']>;
  totalAmount: Scalars['Int'];
  vatId: Scalars['ID'];
};

export type DocumentExportedEvent = {
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberExtended: Scalars['String'];
  propertyId: Scalars['ID'];
  success: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type DocumentExportedEventFilter = {
  propertyId: Scalars['ID'];
  success?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

/** Dati aggiuntivi quando il documento proviene da una importazione. */
export type DocumentImportInfo = {
  /** Elenco dei pagamenti che compensano il sospeso, da usare quando le corrispondenti quietanze non sono disponibili. */
  paidInFullPayments?: Maybe<Array<DocumentImportInfoPaidInFullPayment>>;
};

export type DocumentImportInfoPaidInFullPayment = {
  /** Importo del pagamento. */
  amount: Scalars['Int'];
  /** Data del pagamento. */
  date: Scalars['Date'];
  /** Eventuale descrizione del pagamento o il nome del tipo pagamento. */
  description?: Maybe<Scalars['String']>;
  /** Eventuale riferimento del pagamento. */
  reference?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  documentDetails?: InputMaybe<Array<DocumentDetailInput>>;
  documentPaymentDetails?: InputMaybe<Array<DocumentPaymentDetailInput>>;
  documentType: DocumentType;
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

/** Tipo che ci permette di legare l'incasso al documento */
export type DocumentPaymentDetail = {
  amount: Scalars['Int'];
  expireDate?: Maybe<Scalars['Date']>;
  paymentActive: PaymentActive;
  paymentActiveId: Scalars['ID'];
  referenceDocument?: Maybe<Document>;
  /** Indica il documento di riferimento, può essere una caparra/anticipo o il documento di origine di una nota di credito */
  referenceDocumentId?: Maybe<Scalars['ID']>;
};

export type DocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  expireDate?: InputMaybe<Scalars['Date']>;
  paymentActiveId: Scalars['ID'];
  referenceDocumentId?: InputMaybe<Scalars['ID']>;
};

export type DocumentQueryFilter = {
  cashDeskTypeId?: InputMaybe<IDFilter>;
  customerId?: InputMaybe<IDFilter>;
  documentDate?: InputMaybe<DateFilter>;
  documentType?: InputMaybe<DocumentType>;
  draft?: InputMaybe<Scalars['Boolean']>;
  fiscalType?: InputMaybe<FiscalTypeFilter>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  referenceDocumentId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  unpaid?: InputMaybe<Scalars['Boolean']>;
  userTsId?: InputMaybe<Scalars['String']>;
};

export type DocumentTotal = {
  currency: Scalars['Currency'];
  totals: DocumentTotalByCurrency;
};

export type DocumentTotalByCurrency = {
  advance: Scalars['Int'];
  citytax: Scalars['Int'];
  deposit: Scalars['Int'];
  other: Scalars['Int'];
  payments: Array<DocumentTotalPayment>;
  stay: Scalars['Int'];
  totalAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

export type DocumentTotalPayment = {
  paymentActiveId: Scalars['ID'];
  paymentActiveName: Scalars['LocalizedString'];
  total: Scalars['Int'];
};

export const DocumentType = {
  ADVANCE: 'ADVANCE',
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  PAID_IN_FULL: 'PAID_IN_FULL'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
/** Indica l'importo dell'iva raggruppato per tipo. Il calcolo deve avvenire sempre sommando prima tutti gli importi delle righe e poi scorporare */
export type DocumentVatDetail = {
  netAmount: Scalars['Int'];
  vat: Vat;
  vatAmount: Scalars['Int'];
  vatId: Scalars['ID'];
};

/** Entità Email, contiene le informazioni sulle email inviate dal sistema */
export type Email = {
  availabilityRequestId?: Maybe<Scalars['ID']>;
  bcc?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  customerId?: Maybe<Scalars['ID']>;
  documents?: Maybe<Array<Document>>;
  documentsId?: Maybe<Array<Scalars['ID']>>;
  emailState: EmailState;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messageAutomationId?: Maybe<Scalars['ID']>;
  messageId?: Maybe<Scalars['String']>;
  messageTemplateId: Scalars['ID'];
  quotationId?: Maybe<Scalars['ID']>;
  replyTo?: Maybe<Scalars['String']>;
  reservationId?: Maybe<Scalars['ID']>;
  stateTransaction: Array<EmailStateTransaction>;
  subject: Scalars['String'];
  tenantId: Scalars['ID'];
  to: Scalars['String'];
};

/** Stati delle entità di HIC */
export const EmailState = {
  BOUNCE: 'BOUNCE',
  CLICK: 'CLICK',
  DELIVERY: 'DELIVERY',
  ERROR: 'ERROR',
  OPEN: 'OPEN',
  SEND: 'SEND'
} as const;

export type EmailState = typeof EmailState[keyof typeof EmailState];
export type EmailStateTransaction = {
  result?: Maybe<Scalars['String']>;
  state: EmailState;
  timestamp: Scalars['DateTime'];
};

/** Contiene la configurazione del servizio aggiuntivo e la quantità richiesta. */
export type EmbeddedAdditionalService = {
  /** Il servizio aggiuntivo. */
  additionalService: AdditionalService;
  /** Obbligatorio nel caso di servizio a disponibilità limitata */
  limitedAvailability?: Maybe<AdditionalServiceLimitedAvailability>;
  /** Indica se il servizio è obbligatorio per la tariffa (quindi aggiunto automaticamente). */
  mandatory: Scalars['Boolean'];
  /** Indica se il prezzo del servizio è incluso nella tariffa (quindi il prezzo è zero). */
  priceZero: Scalars['Boolean'];
  /**
   * Quantità del servizio. In caso di servizio configurato 'per ospite', la quantità NON deve essere specificata
   * (la produzione viene poi calcolata in funzione del numero di ospiti)."
   */
  quantity?: Maybe<Scalars['Int']>;
};

export type EmbeddedAdditionalServiceInput = {
  /** Id del servizio aggiuntivo */
  additionalServiceId: Scalars['ID'];
  /** Obbligatorio nel caso di servizio a disponibilità limitata */
  limitedAvailability?: InputMaybe<AdditionalServiceLimitedAvailabilityInput>;
  /** Quantità del servizio. In caso di servizio configurato 'per ospite', la quantità non deve essere specificata perchè sarà ricavata automaticamente dal numero di ospiti. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type EmbeddedProductionInput = {
  amount: Scalars['Float'];
  billId?: InputMaybe<Scalars['ID']>;
  chargeCategoryId: Scalars['ID'];
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type EntityImageInput = {
  additionalServiceImages?: InputMaybe<Array<AdditionaServiceImage>>;
  propertyId: Scalars['ID'];
  propertyImages?: InputMaybe<PropertyImageInput>;
  resourceTypeImages?: InputMaybe<Array<ResourceTypeImageInput>>;
  tenantId: Scalars['ID'];
};

/** L'ambito in cui sono utilizzate o richieste le esenzioni: determina l'eventuale filtro applicato al set di esenzioni disponibili. */
export const ExonerationUsage = {
  /** Le esenzioni applicabili in caso di configurazione della regola generica. */
  CONFIGURATION_GENERIC: 'CONFIGURATION_GENERIC',
  /** Le esenzioni applicabili in caso di modifica di una scheda cliente. */
  CUSTOMER: 'CUSTOMER',
  /** Le esenzioni applicabili in caso di modifica di un ospite (cioè in una prenotazione). */
  GUEST: 'GUEST',
  /** Le esenzioni applicabili in caso di modifica di un addebito di produzione. */
  PRODUCTION: 'PRODUCTION',
  /** Tutte le esenzioni della struttura. */
  PROPERTY: 'PROPERTY'
} as const;

export type ExonerationUsage = typeof ExonerationUsage[keyof typeof ExonerationUsage];
/** Entità che contiene i dati di configurazione del portale Expedia. */
export type ExpediaParameters = {
  allowedAgeCategories?: Maybe<Array<Scalars['String']>>;
  distributionModels?: Maybe<Array<Scalars['String']>>;
  pricingModel: ExpediaPricingModel;
  rateAcquisitionType?: Maybe<Scalars['String']>;
};

export const ExpediaPricingModel = {
  OccupancyBasedPricing: 'OccupancyBasedPricing',
  PerDayPricing: 'PerDayPricing'
} as const;

export type ExpediaPricingModel = typeof ExpediaPricingModel[keyof typeof ExpediaPricingModel];
/** Richieste di export */
export type ExportData = {
  auditable: Auditable;
  exportProcedure: ExportProcedure;
  exportProcedureId: Scalars['ID'];
  fileIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  requestInfo: ExportRequest;
  status: ExportRequestStatus;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ExportDataQueryFilter = {
  exportProcedureId: Scalars['String'];
  tenantId: IDFilter;
};

export type ExportDatabaseInput = {
  database: Scalars['String'];
  extPropertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type ExportDatabaseOutput = {
  taskId: Scalars['ID'];
};

export type ExportInfo = {
  data: Scalars['DateTime'];
  forceExport: Scalars['Boolean'];
  user: Scalars['String'];
};

export type ExportInput = {
  end: Scalars['Date'];
  exportProcedureId: Scalars['ID'];
  forceExport?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  user?: InputMaybe<Scalars['String']>;
};

/** Configurazione Base per Export COntabile */
export type ExportManagement = {
  batchPayments: Scalars['String'];
  batchSales: Scalars['String'];
  /** Conto debiti Enti comunali, obbligayporio se attiva city tax */
  cityTaxDebts?: Maybe<Scalars['String']>;
  /** Mastro clienti */
  customersAccount: Scalars['String'];
  /** Conto caparre */
  customersDeposit: Scalars['String'];
  /** Conti Acconti */
  customersFiscalDeposit: Scalars['String'];
  /** Conto corrispettivi */
  customersVATPayments: Scalars['String'];
  /** Debiti per iva */
  debtsforVAT: Scalars['String'];
  defaultCompanyCode: Scalars['String'];
  exportSuspendedPayments: Scalars['Boolean'];
  /** Raggruppa incassi corrispettivi */
  groupPayments: Scalars['Boolean'];
  /** Raggruppa ricavi corrispettivi */
  groupRevenues: Scalars['Boolean'];
  /** Conto ricavi */
  revenueAccount: Scalars['String'];
  /** Iva vendite */
  vatSales: Scalars['String'];
  /** IVA_RF_Sospeso */
  vatrfSuspended: Scalars['String'];
};

export type ExportManagementInput = {
  batchPayments: Scalars['String'];
  batchSales: Scalars['String'];
  cityTaxDebts?: InputMaybe<Scalars['String']>;
  customersAccount: Scalars['String'];
  customersDeposit: Scalars['String'];
  customersFiscalDeposit: Scalars['String'];
  customersVATPayments: Scalars['String'];
  debtsforVAT: Scalars['String'];
  defaultCompanyCode: Scalars['String'];
  exportSuspendedPayments: Scalars['Boolean'];
  groupPayments: Scalars['Boolean'];
  groupRevenues: Scalars['Boolean'];
  revenueAccount: Scalars['String'];
  vatSales: Scalars['String'];
  vatrfSuspended: Scalars['String'];
};

/** Tipologie di export */
export const ExportManagementProcedure = {
  TS: 'TS'
} as const;

export type ExportManagementProcedure = typeof ExportManagementProcedure[keyof typeof ExportManagementProcedure];
/** Collection che contiene le procedure configurate per il tenant o per la property. */
export type ExportProcedure = {
  auditable: Auditable;
  id: Scalars['ID'];
  managementConfiguration: ExportManagement;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  type: ExportManagementProcedure;
};

export type ExportProcedureInput = {
  managementConfiguration: ExportManagementInput;
  propertyId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<State>;
  tenantId: Scalars['ID'];
  type: ExportManagementProcedure;
};

export type ExportProcedureQueryFilter = {
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<ExportManagementProcedure>;
};

export type ExportRequest = {
  end: Scalars['Date'];
  forceExport?: Maybe<Scalars['Boolean']>;
  start: Scalars['Date'];
  user?: Maybe<Scalars['String']>;
};

export const ExportRequestStatus = {
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS'
} as const;

export type ExportRequestStatus = typeof ExportRequestStatus[keyof typeof ExportRequestStatus];
export type ExportableDatabase = {
  name: Scalars['String'];
  ready: Scalars['Boolean'];
};

export type FakeInput = {
  ia: Scalars['String'];
  ib: Scalars['Int'];
};

export type FakeOutput = {
  oa: Scalars['String'];
  ob: Scalars['Int'];
};

/** Funzionalità dell'applicativo */
export const Feature = {
  AUTOMATION: 'AUTOMATION',
  AUTOMATION_API: 'AUTOMATION_API',
  ENTERPRISE: 'ENTERPRISE',
  GUEST_PORTAL: 'GUEST_PORTAL',
  HOUSEKEEPER: 'HOUSEKEEPER',
  HUB: 'HUB',
  HUB_EXT: 'HUB_EXT',
  MULTI_PROPERTY: 'MULTI_PROPERTY'
} as const;

export type Feature = typeof Feature[keyof typeof Feature];
export type FelAdditionalInfo = {
  /** state is one of TS DIGITAL final states */
  closed: Scalars['Boolean'];
  customFields?: Maybe<FelCustomFields>;
  flowType?: Maybe<SdiFlowType>;
  /** TS Digital HubId */
  hubId?: Maybe<Scalars['String']>;
  /** last error received from TS DIGITAL */
  lastError?: Maybe<Scalars['String']>;
  /** Sent to TS Digital */
  sent: Scalars['Boolean'];
  /** TD Digital State */
  state?: Maybe<FelState>;
  /** Timestamp of last update */
  timeStamp: Scalars['DateTime'];
};

/** Electronic Invoice Configuration */
export type FelConfiguration = {
  authorizedCapital?: Maybe<Scalars['Int']>;
  /** Se non specificato è SDI */
  flowType?: Maybe<FlowType>;
  inLiquidation: Scalars['Boolean'];
  reaCode?: Maybe<Scalars['String']>;
  reaOffice?: Maybe<Scalars['String']>;
  soleShareholder: Scalars['Boolean'];
  taxSystem: RegimeFiscale;
};

export type FelConfigurationInput = {
  authorizedCapital?: InputMaybe<Scalars['Int']>;
  /** Se non specificato è SDI */
  flowType?: InputMaybe<FlowType>;
  inLiquidation: Scalars['Boolean'];
  reaCode?: InputMaybe<Scalars['String']>;
  reaOffice?: InputMaybe<Scalars['String']>;
  soleShareholder: Scalars['Boolean'];
  taxSystem: RegimeFiscale;
};

export type FelCustomFields = {
  bolloVirtuale?: Maybe<Scalars['Boolean']>;
  datiContratto?: Maybe<DatiDocumentiCorrelati>;
  datiConvenzione?: Maybe<DatiDocumentiCorrelati>;
  datiFattureCollegate?: Maybe<DatiDocumentiCorrelati>;
  datiOrdineAcquisto?: Maybe<DatiDocumentiCorrelati>;
  datiRicezione?: Maybe<DatiDocumentiCorrelati>;
  riferimentoAmministrazione?: Maybe<Scalars['String']>;
};

export type FelCustomFieldsInput = {
  bolloVirtuale?: InputMaybe<Scalars['Boolean']>;
  datiContratto?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiConvenzione?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiFattureCollegate?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiOrdineAcquisto?: InputMaybe<DatiDocumentiCorrelatiInput>;
  datiRicezione?: InputMaybe<DatiDocumentiCorrelatiInput>;
};

export const FelState = {
  ACCETTATO: 'ACCETTATO',
  CARICATO: 'CARICATO',
  CONTROLLATO: 'CONTROLLATO',
  DEPOSITATO: 'DEPOSITATO',
  FIRMATO: 'FIRMATO',
  INVIATO: 'INVIATO',
  IN_GESTIONE: 'IN_GESTIONE',
  NESSUNA_RISPOSTA: 'NESSUNA_RISPOSTA',
  NON_RECAPITATO: 'NON_RECAPITATO',
  REGISTRATO: 'REGISTRATO',
  RIFIUTATO: 'RIFIUTATO',
  SCARICATO: 'SCARICATO',
  SCARTATO: 'SCARTATO',
  VALIDATO: 'VALIDATO'
} as const;

export type FelState = typeof FelState[keyof typeof FelState];
/**
 * Entità che rappresenta un file caricato sulla piattaforma, collegabile ad una o più
 * altre entità.
 */
export type File = {
  URL: Scalars['String'];
  auditable: Auditable;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['ID']>;
  public: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type FileInput = {
  filename: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  public: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type FileUploadResponse = {
  file: File;
  preSignedURL: Scalars['String'];
};

export type FilesQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type FiscalConfiguration = {
  address?: Maybe<Address>;
  cashDeskTypeIds: Array<Scalars['ID']>;
  default: Scalars['Boolean'];
  felConfiguration?: Maybe<FelConfiguration>;
  fiscalCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyName?: Maybe<Scalars['String']>;
  registryItemId: Scalars['String'];
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  tspay?: Maybe<TsPayData>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type FiscalConfigurationInput = {
  address?: InputMaybe<AddressInput>;
  cashDeskTypeIds: Array<Scalars['ID']>;
  default: Scalars['Boolean'];
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyName?: InputMaybe<Scalars['String']>;
  registryItemId: Scalars['String'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

/** Dati relativi al fiscal gateway vengono creati in fase di */
export type FiscalGatewayData = {
  accountID: Scalars['String'];
  createdOn: Scalars['DateTime'];
  secret: Scalars['EncryptedString'];
  webhook: Scalars['Boolean'];
};

/**
 * Il fiscal Gateway rappresenta una stampante fiscale collegata al gestionale.
 * I dati comuni sono all'interno del tenant e servono per identificarsi sul gateway oltre che al workstationid
 * L'apikey che è criptata serve come dato da far visualizzare all'utente per associare la cassa
 */
export type FiscalGatewayWorkstation = {
  apikey: Scalars['EncryptedString'];
  auditable: Auditable;
  cashDeskType?: Maybe<CashDeskType>;
  cashDeskTypeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastCommandSend?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  workstationID: Scalars['String'];
};

export type FiscalGatewayWorkstationQueryFilter = {
  name?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export const FiscalType = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  INVOICE: 'INVOICE',
  NON_FISCAL: 'NON_FISCAL',
  PAID_IN_FULL: 'PAID_IN_FULL',
  RECEIPT: 'RECEIPT',
  RETURN_DEPOSIT: 'RETURN_DEPOSIT'
} as const;

export type FiscalType = typeof FiscalType[keyof typeof FiscalType];
export type FiscalTypeFilter = {
  eq?: InputMaybe<FiscalType>;
  in?: InputMaybe<Array<FiscalType>>;
  ne?: InputMaybe<FiscalType>;
  nin?: InputMaybe<Array<FiscalType>>;
};

export const FiscalTypeForAdvances = {
  INVOICE: 'INVOICE',
  NON_FISCAL: 'NON_FISCAL',
  RECEIPT: 'RECEIPT'
} as const;

export type FiscalTypeForAdvances = typeof FiscalTypeForAdvances[keyof typeof FiscalTypeForAdvances];
export const FlowType = {
  SDI: 'SDI',
  STORE: 'STORE'
} as const;

export type FlowType = typeof FlowType[keyof typeof FlowType];
export type FooterFeature = {
  text: Scalars['String'];
};

export type ForecastDistribution = {
  chargeCategoryLabel: Scalars['String'];
  occupancy: Scalars['Int'];
  originLabel: Scalars['String'];
  roomProduction: ProductionAmount;
  totalProduction: ProductionAmount;
};

export type ForecastResourceType = {
  distributions: Array<ForecastDistribution>;
  inventory: Scalars['Int'];
  occupancy: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
  roomProduction: ProductionAmount;
  totalProduction: ProductionAmount;
  unavailability: Scalars['Int'];
};

export type GdprLog = {
  action: GdprLogAction;
  checksum: Scalars['String'];
  function: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  mode: GdprLogMode;
  operation: GdprLogOperation;
  progress: Scalars['Int'];
  request?: Maybe<RequestData>;
  sent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  userId?: Maybe<Scalars['String']>;
};

export const GdprLogAction = {
  ChangeMode: 'ChangeMode',
  Exec: 'Exec',
  Login: 'Login',
  LoginFailed: 'LoginFailed',
  Logout: 'Logout',
  Message: 'Message'
} as const;

export type GdprLogAction = typeof GdprLogAction[keyof typeof GdprLogAction];
export const GdprLogMode = {
  Background: 'Background',
  Foreground: 'Foreground'
} as const;

export type GdprLogMode = typeof GdprLogMode[keyof typeof GdprLogMode];
export const GdprLogOperation = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
  READ: 'READ',
  UPDATE: 'UPDATE'
} as const;

export type GdprLogOperation = typeof GdprLogOperation[keyof typeof GdprLogOperation];
export type GdprLogQueryFilter = {
  sent?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  timestamp?: InputMaybe<DateFilter>;
  userId?: InputMaybe<Scalars['String']>;
};

export const GenderType = {
  FEMALE: 'FEMALE',
  MALE: 'MALE'
} as const;

export type GenderType = typeof GenderType[keyof typeof GenderType];
export type GenerateCityTaxFileError = {
  /** Il giorno a cui si riferisce l'errore, se disponibile. */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<Scalars['String']>;
  /** Messaggio di errore. */
  message: Scalars['String'];
  /** Nome della configurazione della regola di CityTax. */
  ruleConfigurationName: Scalars['String'];
};

export type GenerateCityTaxFileInput = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  ruleConfigurationName?: InputMaybe<Scalars['String']>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type GenerateCityTaxFileResult = {
  errors?: Maybe<Array<GenerateCityTaxFileError>>;
  fileUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GenerateIstatFileError = {
  /** Nome della configurazione Istat. */
  configurationName: Scalars['String'];
  /** Il giorno a cui si riferisce l'errore, se disponibile. */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<IstatGuest>;
  /** Messaggio di errore. */
  message: Scalars['String'];
};

export type GenerateIstatFileInput = {
  configurationName: Scalars['String'];
  end: Scalars['Date'];
  /**
   * Indica se è la prima generazione del file di dati: nel primo invio, alcuni sistemi Istat (es. SPOT-Puglia)
   * richiedono dati aggiuntivi per inizializzare il loro archivio, ad es. i presenti del giorno precedente il primo invio.
   */
  isFirstFile?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type GenerateIstatFileResult = {
  errors?: Maybe<Array<GenerateIstatFileError>>;
  fileUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GetCityTaxRegulationRicestatInput = {
  municipalityCodeItalianPS: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetCityTaxRulesInput = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetCounterInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type: CounterType;
  year: Scalars['Int'];
};

export type GetIstatDataInput = {
  /** Nome della configurazione Istat. */
  configurationName?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type GetIstatPropertiesTrentinoInput = {
  password: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  username: Scalars['String'];
};

export type GetRegistryItemsInput = {
  countryIsoCode: Scalars['String'];
  fiscalCode?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type GoogleCoordinates = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GoogleLocation = {
  location: GoogleCoordinates;
};

/** Oggetto che ritorna dal serviizo di di Google */
export type GooglePlace = {
  formatted_address: Scalars['String'];
  geometry: GoogleLocation;
  name: Scalars['String'];
  place_id: Scalars['String'];
  rating: Scalars['Float'];
};

/** Dati di dettaglio per aumentare i tipi è necessario vedere il servizio */
export type GooglePlaceDetail = {
  formatted_address: Scalars['String'];
  formatted_phone_number?: Maybe<Scalars['String']>;
  international_phone_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price_level?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  reviews?: Maybe<Array<GooglePlaceReview>>;
  url?: Maybe<Scalars['String']>;
  user_ratings_total?: Maybe<Scalars['Int']>;
  vicinity?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Dati di dettaglio ricavati da Google tramite il Place ID */
export type GooglePlaceDetailResponse = {
  error_message?: Maybe<Scalars['String']>;
  info_messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  result?: Maybe<GooglePlaceDetail>;
  status?: Maybe<Scalars['String']>;
};

/**
 * Input per recuperare le info che ha salvato google per il place id passato.
 * I risultati sono inerenti alla lingua passata.
 */
export type GooglePlaceInput = {
  language: Scalars['String'];
  place_id: Scalars['String'];
};

/**
 * Elenco di candidati che sono stati recuperati dal servizio api di Google Place
 * Se status non è OK è presente il messaggio di errore
 */
export type GooglePlaceResponse = {
  candidates?: Maybe<Array<GooglePlace>>;
  error_message?: Maybe<Scalars['String']>;
  info_messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['String']>;
};

/** Oggetto che ritorna dal servizio di di Google e rappresenta una review */
export type GooglePlaceReview = {
  author_name: Scalars['String'];
  rating: Scalars['Float'];
  relative_time_description: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  time: Scalars['Float'];
};

/** Input per ricercare i dati tramite l'api di google */
export type GooglePlacesFindInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  name: Scalars['String'];
};

/**
 * Tipo di Garanzia richiesta
 * Le tipologie pilotano anche l'intefaccia, vedi specifiche
 */
export const GuaranteeType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  NOTREQUIRED: 'NOTREQUIRED',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type GuaranteeType = typeof GuaranteeType[keyof typeof GuaranteeType];
/**
 * Tipo che ci permette di salvare all'interno della prenotazione gli ospiti.
 * Come per la ReservedResource ci sono le fasi anche per gli ospiti.
 */
export type GuestOccupancy = {
  checkin?: Maybe<Scalars['DateTime']>;
  checkout?: Maybe<Scalars['DateTime']>;
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guest: Customer;
  guestId: Scalars['ID'];
  phase: ReservedResourcePhase;
  /** Informazioni sull'invio ad alloggiati web */
  psSent?: Maybe<PsSent>;
  start: Scalars['Date'];
  type: GuestType;
  /** Lo stato del Web Check-in. */
  wciState?: Maybe<WciState>;
};

export type GuestOccupancyInput = {
  cityTaxExoneration?: InputMaybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guestId: Scalars['ID'];
  start: Scalars['Date'];
  type: GuestType;
};

export type GuestPortalAddServicesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalAddServicesReservedResource>;
};

export type GuestPortalAddServicesReservedResource = {
  additionalServices: Array<GuestPortalAddServicesReservedResourceService>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalAddServicesReservedResourceService = {
  additionalServiceId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type GuestPortalCheckinReservedResource = {
  guests: Array<GuestPortalCheckinReservedResourceGuest>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalCheckinReservedResourceGuest = {
  guestId: Scalars['ID'];
  selfieImage?: InputMaybe<GuestPortalWebCheckinImage>;
};

export type GuestPortalCheckinReservedResourcesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalCheckinReservedResource>;
};

export type GuestPortalCheckoutDocumentInput = {
  billIds: Array<Scalars['String']>;
  callbackUrl: Scalars['String'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  fiscalType: FiscalType;
  reservationId: Scalars['ID'];
};

export type GuestPortalCheckoutDocumentResult = {
  documentId: Scalars['String'];
  tsPayUrl?: Maybe<Scalars['String']>;
};

export type GuestPortalCheckoutReservedResource = {
  guestIds: Array<Scalars['ID']>;
  reservedResourceId: Scalars['ID'];
};

export type GuestPortalCheckoutReservedResourcesInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalCheckoutReservedResource>;
};

export type GuestPortalReservationBillsOutput = {
  bills: Array<Bill>;
  billsId: Array<Scalars['ID']>;
  currency: Scalars['Currency'];
  depositsAmount: Scalars['Int'];
  id: Scalars['ID'];
};

export type GuestPortalWebCheckinGuest = {
  /** Non valorizzare se ospite italiano */
  birthCity?: InputMaybe<Scalars['String']>;
  birthCountryId: Scalars['ID'];
  birthDate: Scalars['Date'];
  /** Non valorizzare se ospite straniero */
  birthMunicipalityId?: InputMaybe<Scalars['ID']>;
  /** Non valorizzare se ospite italiano */
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  gender: GenderType;
  identificationDocument?: InputMaybe<GuestPortalWebCheckinIdentificationDocument>;
  language: Scalars['Language'];
  lastName?: InputMaybe<Scalars['String']>;
  /** Non valorizzare se ospite straniero */
  municipalityId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Cittadinanza */
  nationalityId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<GuestPortalWebCheckinPrivacyInfo>;
  selfieImage?: InputMaybe<GuestPortalWebCheckinImage>;
  type: GuestType;
};

export type GuestPortalWebCheckinIdentificationDocument = {
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  documentTypeId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  images?: InputMaybe<Array<GuestPortalWebCheckinImage>>;
  number: Scalars['String'];
  releasedBy?: InputMaybe<Scalars['String']>;
};

export type GuestPortalWebCheckinImage = {
  /** Descrizione dell'immagine. */
  description: Scalars['String'];
  /** Id dell'entità File contenente i dettagli dell'immagine. */
  fileId: Scalars['ID'];
};

export type GuestPortalWebCheckinInput = {
  reservationId: Scalars['ID'];
  reservedResources: Array<GuestPortalWebCheckinReservedResource>;
};

export type GuestPortalWebCheckinPrivacyInfo = {
  dataThirdPartyConsent?: InputMaybe<Scalars['Boolean']>;
  managementConsent: Scalars['Boolean'];
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  profiledMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  signature: GuestPortalWebCheckinImage;
};

export type GuestPortalWebCheckinReservedResource = {
  guests: Array<GuestPortalWebCheckinGuest>;
  reservedResourceId: Scalars['ID'];
};

/** Tipologia Ospite PS Italiana */
export const GuestType = {
  FAMILY: 'FAMILY',
  GROUP_HEAD: 'GROUP_HEAD',
  GROUP_MEMBER: 'GROUP_MEMBER',
  HEAD_OF_FAMILY: 'HEAD_OF_FAMILY',
  SINGLE_GUEST: 'SINGLE_GUEST'
} as const;

export type GuestType = typeof GuestType[keyof typeof GuestType];
export type HoauConfiguration = {
  baseUrl: Scalars['String'];
  token?: Maybe<Scalars['EncryptedString']>;
  userId: Scalars['String'];
};

export type HoauConfigurationInput = {
  baseUrl: Scalars['String'];
  token?: InputMaybe<Scalars['EncryptedString']>;
  userId: Scalars['String'];
};

export type HorecaHubFlows = {
  id: Scalars['ID'];
  integration1Id: Scalars['ID'];
  integration2Id: Scalars['ID'];
  state: Scalars['String'];
};

/** Horeca Hub: entità di integrazione */
export type HorecaHubIntegration = {
  auditable: Auditable;
  handledEntities?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  secret: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
  token?: Maybe<Scalars['String']>;
};

export type HotelDateInput = {
  hotelDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type HousekeepingConfiguration = {
  /** Numero di giorni dopo il quale la risorsa in checkin viene impostata a DIRTY. */
  daysForResourceDirty?: Maybe<Scalars['Int']>;
  /** Eventuali colonne aggiuntive da visualizzare nel report governante. */
  reportAdditionalColumns?: Maybe<Array<Scalars['String']>>;
};

export type HousekeepingConfigurationInput = {
  /** Numero di giorni dopo il quale la risorsa in checkin viene impostata a DIRTY. */
  daysForResourceDirty?: InputMaybe<Scalars['Int']>;
  /** Eventuali colonne aggiuntive da visualizzare nel report governante. */
  reportAdditionalColumns?: InputMaybe<Array<Scalars['String']>>;
};

export type HubSpotDataInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type IDFilter = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  ne?: InputMaybe<Scalars['ID']>;
  nin?: InputMaybe<Array<Scalars['ID']>>;
};

export type IbeCodeFilter = {
  ibeCode: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entità dei tipi documento, le tipologie sono standard */
export type IdentificationDocument = {
  auditable: Auditable;
  codeItalianPs: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type IdentificationDocumentInput = {
  codeItalianPs: Scalars['String'];
  duration: Scalars['Int'];
  name: Scalars['LocalizedString'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type IdentificationDocumentQueryFilter = {
  codeIstat?: InputMaybe<StringFilter>;
  codeItalianPs?: InputMaybe<StringFilter>;
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<LocalizedStringFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export type ImportPropertyConfigurationInput = {
  msLimit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  step?: InputMaybe<ImportPropertyConfigurationStep>;
  taskId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const ImportPropertyConfigurationStep = {
  BILLS: 'BILLS',
  CONFIGURATION: 'CONFIGURATION',
  CUSTOMERS: 'CUSTOMERS',
  DATA: 'DATA',
  DOCUMENTS: 'DOCUMENTS',
  REBUILD_AVAILABILITY: 'REBUILD_AVAILABILITY',
  REBUILD_HISTORY: 'REBUILD_HISTORY',
  RESERVATIONS: 'RESERVATIONS'
} as const;

export type ImportPropertyConfigurationStep = typeof ImportPropertyConfigurationStep[keyof typeof ImportPropertyConfigurationStep];
export type ImportPropertyInput = {
  bookingPolicy: ReservationBookingPolicyInput;
  categoryId?: InputMaybe<Scalars['ID']>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  externalPropertyId: Scalars['String'];
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  plantId?: InputMaybe<Scalars['String']>;
  registryItemId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type ImportPropertyOutput = {
  propertyId: Scalars['ID'];
  taskId: Scalars['ID'];
};

export const ImportTaskType = {
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT'
} as const;

export type ImportTaskType = typeof ImportTaskType[keyof typeof ImportTaskType];
export type ImportedAdditionalService = {
  data: ImportedAdditionalServiceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedAdditionalServiceData = {
  automaticForAdults: Scalars['Boolean'];
  automaticForChildren: Scalars['Boolean'];
  description: ImportedLocalizedString;
  excludeCheckin: Scalars['Boolean'];
  excludeCheckout: Scalars['Boolean'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  minStay?: Maybe<Scalars['Int']>;
  name: ImportedLocalizedString;
  price: Scalars['Int'];
  /** PER_STAY, PER_PERSON, PER_NIGHT, PER_PERSON_PER_NIGHT */
  pricingType: PricingType;
  validity?: Maybe<Range>;
};

export type ImportedAddress = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  municipalityIstatCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
};

export type ImportedBill = {
  data: ImportedBillData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedBillData = {
  /** MAIN, EXTRA, WALKIN, REVERSE */
  category: BillCategoryType;
  createdOn?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  extDocumentId?: Maybe<Scalars['String']>;
  extOwnerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservationId?: Maybe<Scalars['String']>;
  extReservedResourceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  open: Scalars['Boolean'];
};

export type ImportedBookingPolicy = {
  data: ImportedBookingPolicyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedBookingPolicyData = {
  cancellationPolicy?: Maybe<ImportedCancellationPolicy>;
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  noShowRule?: Maybe<ImportedNoShowRule>;
  paymentRule?: Maybe<ImportedPaymentRule>;
};

export type ImportedCancellationPolicy = {
  daysWithoutPenalties?: Maybe<Scalars['Int']>;
  hourWithoutPenalties?: Maybe<Scalars['String']>;
  penaltyType?: Maybe<CancellationPenaltyType>;
  percentage?: Maybe<Scalars['Int']>;
  type: CancellationPolicyType;
};

export type ImportedChargeCategory = {
  data: ImportedChargeCategoryData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedChargeCategoryData = {
  breakfastIncluded: Scalars['Boolean'];
  cityTax: Scalars['Boolean'];
  /** RO BB HB FB */
  code?: Maybe<ChargeCategoryBoard>;
  dinnerIncluded: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  lunchIncluded: Scalars['Boolean'];
  name: Scalars['String'];
  stayIncluded: Scalars['Boolean'];
  vat: ImportedVat;
};

export type ImportedCompany = {
  /** NC, HC, HCT, FC, FCT */
  defaultCredit?: Maybe<CreditType>;
  physicalPerson: Scalars['Boolean'];
  sdiCode?: Maybe<Scalars['String']>;
  splitPayment: Scalars['Boolean'];
};

export type ImportedCounter = {
  data: ImportedCounterData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedCounterData = {
  documentInfo?: Maybe<ImportedCounterDocumentData>;
  extPropertyId: Scalars['String'];
  format: Scalars['String'];
  id: Scalars['String'];
  reset: Scalars['Boolean'];
  /** RESERVATION, DOCUMENT, ELECTRONIC_INVOICE, QUOTATION */
  type: CounterType;
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type ImportedCounterDocumentData = {
  fiscalType: Scalars['String'];
  set?: Maybe<Scalars['String']>;
};

export type ImportedCustomer = {
  data: ImportedCustomerData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedCustomerData = {
  address?: Maybe<ImportedAddress>;
  company?: Maybe<ImportedCompany>;
  firstName?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany: Scalars['Boolean'];
  languageIsoCode: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  mailContact?: Maybe<ImportedMailContact>;
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  person?: Maybe<ImportedPerson>;
  phoneContact?: Maybe<ImportedPhoneContact>;
  privacy?: Maybe<ImportedPrivacy>;
  vatNumber?: Maybe<Scalars['String']>;
  webContact?: Maybe<ImportedWebContact>;
};

export type ImportedDocument = {
  creditNoteMapped?: Maybe<Scalars['Boolean']>;
  data: ImportedDocumentData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentAdditionalInfo = {
  fel_flow_type?: Maybe<ImportedFelFlowType>;
  fel_hubId?: Maybe<Scalars['String']>;
  fel_state?: Maybe<FelState>;
  sent: Scalars['Boolean'];
  timeStamp: Scalars['DateTime'];
};

export type ImportedDocumentData = {
  additionalInfo?: Maybe<ImportedDocumentAdditionalInfo>;
  consolidatedCustomer: ImportedCustomerData;
  documentDate: Scalars['Date'];
  documentSetCode?: Maybe<Scalars['String']>;
  documentType: ImportedDocumentType;
  extCustomerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  isAdvance: Scalars['Boolean'];
  netAmount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  numberExtended: Scalars['String'];
  splitPayment: Scalars['Boolean'];
  totalAmount: Scalars['Int'];
  unpaidAmount: Scalars['Int'];
  vatAmount: Scalars['Int'];
};

export type ImportedDocumentDepositAssignment = {
  data: ImportedDocumentDepositAssignmentData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentDepositAssignmentData = {
  amount: Scalars['Int'];
  depositExtDocumentId: Scalars['String'];
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservationId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedDocumentDetail = {
  data: ImportedDocumentDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentDetailData = {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  description: Scalars['String'];
  extChargeCategoryId?: Maybe<Scalars['String']>;
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Int'];
  referenceExtDocumentId?: Maybe<Scalars['String']>;
  totalAmount: Scalars['Int'];
  vat?: Maybe<ImportedVat>;
};

export type ImportedDocumentPaymentDetail = {
  data: ImportedDocumentPaymentDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentPaymentDetailData = {
  amount: Scalars['Int'];
  expireDate?: Maybe<Scalars['Date']>;
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  /** CASH, CHANGE, BANKTRANSFER, BANKCHECK, CREDITCARD, UNPAID, BALANCE_UNPAID, DEPOSIT, RETURN_DEPOSIT, SPLITPAYMENT, RETURN_SPLITPAYMENT */
  paymentTypeCode: PaymentTypeCode;
  referenceExtDocumentId?: Maybe<Scalars['String']>;
};

export const ImportedDocumentType = {
  CREDIT_NOTE: 'CREDIT_NOTE',
  INVOICE: 'INVOICE',
  NON_FISCAL_ADVANCE: 'NON_FISCAL_ADVANCE',
  NON_FISCAL_RETURN_ADVANCE: 'NON_FISCAL_RETURN_ADVANCE',
  PAID_IN_FULL: 'PAID_IN_FULL',
  RECEIPT: 'RECEIPT'
} as const;

export type ImportedDocumentType = typeof ImportedDocumentType[keyof typeof ImportedDocumentType];
export type ImportedDocumentVatDetail = {
  data: ImportedDocumentVatDetailData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedDocumentVatDetailData = {
  extDocumentId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  netAmount: Scalars['Int'];
  vat: ImportedVat;
  vatAmount: Scalars['Int'];
};

export type ImportedError = {
  entity: Scalars['String'];
  error: Scalars['String'];
  extEntityId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  timeStamp: Scalars['DateTime'];
};

export type ImportedErrorQueryFilter = {
  extPropertyId?: InputMaybe<StringFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export const ImportedFelFlowType = {
  SDIPA: 'SDIPA',
  SDIPR: 'SDIPR'
} as const;

export type ImportedFelFlowType = typeof ImportedFelFlowType[keyof typeof ImportedFelFlowType];
export type ImportedGuestOccupancy = {
  data: ImportedGuestOccupancyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedGuestOccupancyData = {
  checkin?: Maybe<Scalars['DateTime']>;
  checkout?: Maybe<Scalars['DateTime']>;
  end: Scalars['Date'];
  extCustomerId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  /** RESERVATION, CHECKIN, CHECKOUT */
  phase: ReservedResourcePhase;
  start: Scalars['Date'];
  /** SINGLE_GUEST, HEAD_OF_FAMILY, GROUP_HEAD, FAMILY, GROUP_MEMBER */
  type: GuestType;
};

export type ImportedLocalizedString = {
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  it?: Maybe<Scalars['String']>;
};

export type ImportedMailContact = {
  mail?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
};

export type ImportedNoShowRule = {
  percentage?: Maybe<Scalars['Int']>;
  type: NoShowType;
};

export type ImportedPaymentRule = {
  guaranteedCreditCard: Scalars['Boolean'];
  percentage?: Maybe<Scalars['Int']>;
  type: GuaranteeType;
};

export type ImportedPerson = {
  birthAddress?: Maybe<ImportedAddress>;
  birthDate?: Maybe<Scalars['Date']>;
  identificationDocument?: Maybe<ImportedPersonIdentificationDocument>;
  isMale?: Maybe<Scalars['Boolean']>;
  nationalityIsoCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ImportedPersonIdentificationDocument = {
  city?: Maybe<Scalars['String']>;
  codeItalianPs: Scalars['String'];
  countryIsoCode: Scalars['String'];
  expirationDate: Scalars['Date'];
  number: Scalars['UppercaseString'];
  releaseBy?: Maybe<Scalars['String']>;
};

export type ImportedPhoneContact = {
  fax?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type ImportedPortalInfo = {
  externalId: Scalars['String'];
  /** BOOKING, EXPEDIA, AIRBNB */
  portalName: PortalName;
};

export type ImportedPrivacy = {
  dataThirdPartyConsent?: Maybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: Maybe<Scalars['Date']>;
  managementConsent?: Maybe<Scalars['Boolean']>;
  managementConsentDate?: Maybe<Scalars['Date']>;
  marketingConsent?: Maybe<Scalars['Boolean']>;
  marketingConsentDate?: Maybe<Scalars['Date']>;
};

export type ImportedProduct = {
  data: ImportedProductData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductData = {
  amount: Scalars['Int'];
  description: Scalars['String'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedProduction = {
  data: ImportedProductionData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductionAssigned = {
  data: ImportedProductionAssignedData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedProductionAssignedData = {
  extBillId: Scalars['String'];
  extProductionId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  quota: Scalars['Float'];
};

export type ImportedProductionData = {
  amount: Scalars['Int'];
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  extAdditionalServiceId?: Maybe<Scalars['String']>;
  extChargeCategoryId: Scalars['String'];
  extGuestId?: Maybe<Scalars['String']>;
  extPropertyId: Scalars['String'];
  extReservedResourceId?: Maybe<Scalars['String']>;
  hotelDate: Scalars['Date'];
  id: Scalars['String'];
  manual: Scalars['Boolean'];
  quantity: Scalars['Int'];
  total: Scalars['Int'];
  vat: ImportedVat;
};

/** Collections */
export type ImportedProperty = {
  data: ImportedPropertyData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

/** Entità di configurazione */
export type ImportedPropertyData = {
  address?: Maybe<ImportedAddress>;
  description: ImportedLocalizedString;
  fiscalCode?: Maybe<Scalars['String']>;
  hotelDate?: Maybe<Scalars['Date']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mailContact?: Maybe<ImportedMailContact>;
  name: Scalars['String'];
  phoneContact?: Maybe<ImportedPhoneContact>;
  vatNumber?: Maybe<Scalars['String']>;
  webContact?: Maybe<ImportedWebContact>;
};

export type ImportedRate = {
  data: ImportedRateData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedRateData = {
  description: ImportedLocalizedString;
  extBookingPolicyId: Scalars['String'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  name: ImportedLocalizedString;
  order: Scalars['Int'];
};

/** Tipi comuni */
export type ImportedReference = {
  /**
   * Rappresenta l'id interno di TSH
   * Viene valorizzato nel momento in cui il documento viene processato.
   * Per le tabelle molti a molti rimane vuoto perché vengono processate come embedded document
   */
  importedId?: Maybe<Scalars['ID']>;
  timeStamp: Scalars['DateTime'];
};

export type ImportedReservation = {
  data: ImportedReservationData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservationData = {
  canceledOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  /** NC, HC, HCT, FC, FCT */
  credit: CreditType;
  extPropertyId: Scalars['String'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCanceled: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isNoShow: Scalars['Boolean'];
  isOptioned: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  optionExpiration?: Maybe<Scalars['Date']>;
  /** OTA, PMS, IBE */
  origin: OriginName;
  portalInfo?: Maybe<ImportedPortalInfo>;
  reference: ImportedReservationReference;
  reservationCode: Scalars['String'];
  voucher?: Maybe<Scalars['String']>;
};

export type ImportedReservationReference = {
  /** Agenzia */
  agencyId?: Maybe<Scalars['String']>;
  /** Prenotante Azienda */
  customerCompanyId?: Maybe<Scalars['String']>;
  customerPersonId?: Maybe<Scalars['String']>;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['String'];
};

export type ImportedReservedResource = {
  data: ImportedReservedResourceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceAdditionalService = {
  data: ImportedReservedResourceAdditionalServiceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceAdditionalServiceData = {
  extAdditionalServiceId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  mandatory: Scalars['Boolean'];
  priceZero: Scalars['Boolean'];
  quantity?: Maybe<Scalars['Int']>;
};

export type ImportedReservedResourceChargeCategory = {
  data: ImportedReservedResourceChargeCatogoryData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceChargeCatogoryData = {
  day: Scalars['Date'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedReservedResourceDailyPrice = {
  data: ImportedReservedResourceDailyPriceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedReservedResourceDailyPriceData = {
  day: Scalars['Date'];
  extPropertyId: Scalars['String'];
  extReservedResourceId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Int'];
};

export type ImportedReservedResourceData = {
  adults: Scalars['Int'];
  assignedExtResourceTypeId: Scalars['String'];
  children: Scalars['Int'];
  end: Scalars['Date'];
  extChargeCategoryId: Scalars['String'];
  extPropertyId: Scalars['String'];
  extRateId: Scalars['String'];
  extReservationId: Scalars['String'];
  extResourceId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  /** RESERVATION, CHECKIN, CHECKOUT */
  phase: ReservedResourcePhase;
  portalExternalId?: Maybe<Scalars['String']>;
  reservedAdults: Scalars['Int'];
  reservedChildren: Scalars['Int'];
  reservedEnd: Scalars['Date'];
  reservedExtResourceTypeId: Scalars['String'];
  reservedStart: Scalars['Date'];
  start: Scalars['Date'];
};

export type ImportedResource = {
  data: ImportedResourceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceData = {
  code: Scalars['String'];
  description: Scalars['String'];
  extPropertyId: Scalars['String'];
  extResourceTypeId: Scalars['String'];
  id: Scalars['String'];
};

export type ImportedResourceType = {
  data: ImportedResourceTypeData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceTypeData = {
  additionalPersons: Scalars['Int'];
  autoEquivalent: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  description: ImportedLocalizedString;
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  inventory: Scalars['Int'];
  logicalType: Scalars['Boolean'];
  maxAdults: Scalars['Int'];
  minRate: Scalars['Int'];
  name: ImportedLocalizedString;
  order: Scalars['Int'];
  persons: Scalars['Int'];
  rackRate: Scalars['Int'];
};

export type ImportedResourceTypeEquivalence = {
  data: ImportedResourceTypeEquivalenceData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceTypeEquivalenceData = {
  extPropertyId: Scalars['String'];
  id: Scalars['String'];
  masterId: Scalars['String'];
  order: Scalars['Int'];
  slaveId: Scalars['String'];
};

export type ImportedResourceUnavailability = {
  data: ImportedResourceUnavailabilityData;
  id: Scalars['ID'];
  importedReference?: Maybe<ImportedReference>;
  tenantId: Scalars['ID'];
};

export type ImportedResourceUnavailabilityData = {
  end: Scalars['Date'];
  extPropertyId: Scalars['String'];
  extResourceId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type ImportedTask = {
  database?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  extPropertyId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastError?: Maybe<Scalars['String']>;
  lastMessage?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  tenantId: Scalars['ID'];
  timestamp: Scalars['DateTime'];
  type: ImportTaskType;
};

export type ImportedTaskQueryFilter = {
  extPropertyId?: InputMaybe<StringFilter>;
  taskId?: InputMaybe<IDFilter>;
  tenantId?: InputMaybe<IDFilter>;
};

export const ImportedVat = {
  E10: 'E10',
  E15: 'E15',
  E72: 'E72',
  E74: 'E74',
  E124: 'E124',
  FCI: 'FCI',
  V4: 'V4',
  V5: 'V5',
  V10: 'V10',
  V22: 'V22'
} as const;

export type ImportedVat = typeof ImportedVat[keyof typeof ImportedVat];
export type ImportedWebContact = {
  instagram?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  webprivacy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

/** Codici degli insight, nella BL ci sono le informazioni che devono essere gestite per ogni codice ->commoninsightinsight.bl.ts */
export const Insight = {
  CHANNEL: 'CHANNEL',
  CHILD: 'CHILD',
  CITYTAX: 'CITYTAX',
  CITYTAX_NODEF: 'CITYTAX_NODEF',
  FISCAL_GATEWAY: 'FISCAL_GATEWAY',
  IBE: 'IBE',
  ISTAT: 'ISTAT',
  ISTAT_NODEF: 'ISTAT_NODEF',
  PS: 'PS',
  RELEASE: 'RELEASE',
  SINAPSI: 'SINAPSI',
  TSPAY: 'TSPAY'
} as const;

export type Insight = typeof Insight[keyof typeof Insight];
export type InsightInput = {
  endPause: Scalars['Date'];
  insightId: Scalars['ID'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type InsightItem = {
  actionUrl?: Maybe<Scalars['String']>;
  code: Insight;
  description: Scalars['LocalizedString'];
  priority: InsightPriority;
  title: Scalars['LocalizedString'];
  type: InsightType;
};

export const InsightPriority = {
  HIGH: 'HIGH',
  HIGHEST: 'HIGHEST',
  LOW: 'LOW',
  NORMAL: 'NORMAL'
} as const;

export type InsightPriority = typeof InsightPriority[keyof typeof InsightPriority];
export type InsightQueryFilter = {
  id?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 * Entità che gestisce per ogni property lo stato dei messaggi insight
 * La prima volta che viene richiamata la gestione insight si occupa di verificare se ci sono nuovi insight e li aggiunge alla entità
 * Se sono gestite sulla property mette active, altrimenti mette draft.
 * Quando sono completi viene messo inactive
 * Se sono in pausa rimangono active ma hanno un tempo di fine pausa
 */
export type InsightStatus = {
  auditable: Auditable;
  /** Quando l'entità viene messa in pausa, l'interfaccia deve proporre un tempo Un giorno, una settimana, un mese e mai ?? */
  endPause?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  insightCode: Insight;
  insightInfo?: Maybe<InsightItem>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const InsightType = {
  ALERT: 'ALERT',
  INFO: 'INFO',
  NEW: 'NEW',
  POPUP: 'POPUP',
  URGENT: 'URGENT',
  WARNING: 'WARNING'
} as const;

export type InsightType = typeof InsightType[keyof typeof InsightType];
/**
 * Definizione di rata, la prima rata può richiedere un pagamento immediato, solo nella prima rata non è obbligatorio il campo DayfromCheckin,
 * perchè viene richiesto subito un pagamento.
 */
export type Installment = {
  dayFromCheckin?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  value: Scalars['Int'];
};

/**
 * Definizione di rata, la prima rata può richiedere un pagamento immediato, solo nella prima rata non è obbligatorio il campo DayfromCheckin,
 * perchè viene richiesto subito un pagamento.
 */
export type InstallmentInput = {
  dayFromCheckin?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
  value: Scalars['Int'];
};

export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
};

/** Represents the capabilities of an Istat system. */
export type IstatCapabilities = {
  /** Indicates whether the implementation handles the cancellation. */
  handlesCancellation?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the system supports automatic sending of Istat data. */
  supportsAutomaticSend?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the system supports the generation of Istat data files (to be uploaded separately). */
  supportsFileGeneration?: Maybe<Scalars['Boolean']>;
};

/** Istat Configuration */
export type IstatConfiguration = {
  name: Scalars['String'];
  overrideBedsNumber?: Maybe<Scalars['Int']>;
  overrideResourcesNumber?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['EncryptedString']>;
  procedureCode: IstatProcedureCode;
  propertyCode?: Maybe<Scalars['String']>;
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  sendCityTax?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['EncryptedString']>;
};

export type IstatConfigurationInput = {
  name: Scalars['String'];
  overrideBedsNumber?: InputMaybe<Scalars['Int']>;
  overrideResourcesNumber?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['EncryptedString']>;
  procedureCode: IstatProcedureCode;
  propertyCode?: InputMaybe<Scalars['String']>;
  /** DEPRECATO - Questo campo in futuro verrà rimosso. Utilizzare 'resources' invece. */
  resourceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  resources?: InputMaybe<Array<IstatResourceConfiguration>>;
  username?: InputMaybe<Scalars['EncryptedString']>;
};

export type IstatDailyData = {
  date: Scalars['Date'];
  guests: Array<IstatGuest>;
  property: IstatPropertyInfo;
};

export type IstatError = {
  /** Nome della configurazione Istat. */
  configurationName: Scalars['String'];
  /** Il giorno a cui si riferisce l'errore, se disponibile.  */
  date?: Maybe<Scalars['Date']>;
  /** L'ospite a cui si riferisce l'errore, se disponibile. */
  guest?: Maybe<IstatGuest>;
  /** Messaggio di errore. */
  message: Scalars['String'];
  /** Messaggio restituito dal sistema Istat. */
  messageFromSystem?: Maybe<Scalars['String']>;
};

export type IstatGuest = {
  birthCountry: IstatOrigin;
  birthDate: Scalars['Date'];
  birthPlace: IstatOrigin;
  country: IstatOrigin;
  end: Scalars['Date'];
  gender: GenderType;
  guarantorId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  municipality?: Maybe<IstatOrigin>;
  municipalityProvince?: Maybe<IstatOrigin>;
  /** Le fasi in cui si trova l'ospite (checkin, checkout, checkin + checkout, stay). */
  phases: IstatGuestPhase;
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  reservedResourceStart: Scalars['Date'];
  /** Codice Istat della risorsa. Presente quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  resourceCodeIstat?: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  resources: Array<IstatResource>;
  start: Scalars['Date'];
  type: GuestType;
};

export type IstatGuestPhase = {
  /** Nota: l'ospite può essere contemporaneamente anche in fase CheckOut. */
  checkin: Scalars['Boolean'];
  /** Nota: l'ospite può essere contemporaneamente anche in fase CheckIn. */
  checkout: Scalars['Boolean'];
  stay: Scalars['Boolean'];
};

export type IstatOrigin = {
  /** Codice Istat. */
  code: Scalars['String'];
  /** Codice Polizia di Stato. */
  codeItalianPs: Scalars['String'];
  /** Codice di 2 caratteri che contiene: il codice ISO, se questo oggetto è una nazione; oppure la sigla della provincia, se questo oggetto è un comune. */
  isoCode: Scalars['String'];
  /** Nome della nazione o del comune. */
  name: Scalars['String'];
};

export const IstatProcedure = {
  /** Campania */
  ISTAT_CAMPANIA: 'ISTAT_CAMPANIA',
  /** Trentino */
  ISTAT_TRENTINO: 'ISTAT_TRENTINO',
  /** Lazio */
  RADAR: 'RADAR',
  /** Toscana (città di Arezzo, Grosseto, Livorno, Lucca, Massa Carrara, Pisa, Siena) */
  RICESTAT: 'RICESTAT',
  /** Liguria */
  RIMOVCLI: 'RIMOVCLI',
  /** Abruzzo, Basilicata, Calabria, Emilia Romagna, Lombardia, Marche, Piemonte, Veneto, Toscana (città di Firenze, Pistoia e Prato), Sardegna */
  ROSS1000: 'ROSS1000',
  /** Sicilia */
  SIOT: 'SIOT',
  /** Puglia */
  SPOT: 'SPOT',
  /** Umbria */
  TURISMATICA: 'TURISMATICA',
  /** Friuli (appartamenti) */
  WEBTUR_FLATS: 'WEBTUR_FLATS',
  /** Friuli (camere) */
  WEBTUR_ROOMS: 'WEBTUR_ROOMS'
} as const;

export type IstatProcedure = typeof IstatProcedure[keyof typeof IstatProcedure];
export const IstatProcedureCode = {
  ISTAT_CAMPANIA: 'ISTAT_CAMPANIA',
  ISTAT_TRENTINO: 'ISTAT_TRENTINO',
  RADAR_LAZIO: 'RADAR_LAZIO',
  RICESTAT_AREZZO: 'RICESTAT_AREZZO',
  RICESTAT_GROSSETO: 'RICESTAT_GROSSETO',
  RICESTAT_LIVORNO: 'RICESTAT_LIVORNO',
  RICESTAT_LUCCA: 'RICESTAT_LUCCA',
  RICESTAT_MASSACARRARA: 'RICESTAT_MASSACARRARA',
  RICESTAT_PISA: 'RICESTAT_PISA',
  RICESTAT_SIENA: 'RICESTAT_SIENA',
  RIMOVCLI_LIGURIA: 'RIMOVCLI_LIGURIA',
  ROSS1000_ABRUZZO: 'ROSS1000_ABRUZZO',
  ROSS1000_BASILICATA: 'ROSS1000_BASILICATA',
  ROSS1000_CALABRIA: 'ROSS1000_CALABRIA',
  ROSS1000_EMILIAROMAGNA: 'ROSS1000_EMILIAROMAGNA',
  ROSS1000_FIRENZE: 'ROSS1000_FIRENZE',
  ROSS1000_LOMBARDIA: 'ROSS1000_LOMBARDIA',
  ROSS1000_MARCHE: 'ROSS1000_MARCHE',
  ROSS1000_PIEMONTE: 'ROSS1000_PIEMONTE',
  ROSS1000_PISTOIA: 'ROSS1000_PISTOIA',
  ROSS1000_PRATO: 'ROSS1000_PRATO',
  ROSS1000_SARDEGNA: 'ROSS1000_SARDEGNA',
  ROSS1000_VENETO: 'ROSS1000_VENETO',
  SIOT_SICILIA: 'SIOT_SICILIA',
  SPOT_PUGLIA: 'SPOT_PUGLIA',
  TURISMATICA_UMBRIA: 'TURISMATICA_UMBRIA',
  WEBTUR_FLATS_FRIULI: 'WEBTUR_FLATS_FRIULI',
  WEBTUR_ROOMS_FRIULI: 'WEBTUR_ROOMS_FRIULI'
} as const;

export type IstatProcedureCode = typeof IstatProcedureCode[keyof typeof IstatProcedureCode];
export type IstatPropertyInfo = {
  availableBeds: Scalars['Int'];
  availableRooms: Scalars['Int'];
  inventoryBeds: Scalars['Int'];
  inventoryRooms: Scalars['Int'];
  /** Indica se la struttura è chiusa. */
  isClosed?: Maybe<Scalars['Boolean']>;
  occupiedRooms: Scalars['Int'];
};

export type IstatPropertyTrentino = {
  /** Identificativo della struttura. */
  code: Scalars['String'];
  /** Nome della struttura associata all'utenza. */
  name: Scalars['String'];
};

export type IstatResource = {
  end: Scalars['Date'];
  /** Il codice assegnato alla risorsa (cioè il nome o numero). */
  resourceCode: Scalars['String'];
  /** Codice Istat della risorsa. Presente quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  resourceCodeIstat?: Maybe<Scalars['String']>;
  resourceId: Scalars['ID'];
  start: Scalars['Date'];
};

export type IstatResourceConfiguration = {
  /** Codice Istat della risorsa. Necessario quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  codeIstat?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type KeyValue = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type LastThreadMessage = {
  createdOn: Scalars['DateTime'];
  externalUserId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type Link2PayCheckoutDocumentInput = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  documentId: Scalars['ID'];
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type Link2PayInput = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  description: Scalars['String'];
  merchantRef: Scalars['String'];
  paymentRef: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  title: Scalars['String'];
};

export type Link2PayOutput = {
  orderKey: Scalars['String'];
  type: TsPayLinkType;
  url: Scalars['String'];
};

export type Link2PayQuotationInput = {
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Link2PayReservationInput = {
  payment?: InputMaybe<PaymentInput>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type Link2PayUnpaidDocumentInput = {
  /**  paid in full document identifier  */
  customerId: Scalars['ID'];
  documentId: Scalars['ID'];
  payment: PaymentInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type LocalizedMailMessageTemplate = {
  language: Scalars['Language'];
  value: MailMessageTemplate;
};

export type LocalizedMailMessageTemplateInput = {
  language: Scalars['Language'];
  value: MailMessageTemplateInput;
};

export type LocalizedStringFilter = {
  language?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type MailContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: MailContactType;
  value: Scalars['EmailAddress'];
};

export type MailContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: MailContactType;
  value: Scalars['EmailAddress'];
};

/** Tipologie di contatti Mail */
export const MailContactType = {
  GUEST: 'GUEST',
  MAIN: 'MAIN',
  OTHER: 'OTHER',
  PEC: 'PEC',
  PRIVATE: 'PRIVATE',
  SUPPORT: 'SUPPORT'
} as const;

export type MailContactType = typeof MailContactType[keyof typeof MailContactType];
export type MailInput = {
  availabilityRequestId?: InputMaybe<Scalars['ID']>;
  bcc?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  customerId?: InputMaybe<Scalars['ID']>;
  documentsId?: InputMaybe<Array<Scalars['ID']>>;
  from: Scalars['String'];
  messageAutomationId?: InputMaybe<Scalars['ID']>;
  messageTemplateId: Scalars['ID'];
  quotationId?: InputMaybe<Scalars['ID']>;
  replyTo?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
  tenantId: Scalars['ID'];
  to: Scalars['String'];
};

export type MailMessageTemplate = {
  /** Contiene il json che utilizza il componente per visualizzare le mail */
  design?: Maybe<Scalars['String']>;
  /** Body html da utilizzare per inviare le mail */
  html?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MailMessageTemplateInput = {
  /** Contiene il json che utilizza il componente per visualizzare le mail */
  design?: InputMaybe<Scalars['String']>;
  /** Body html da utilizzare per inviare le mail */
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type ManualDailyPrice = {
  day: Scalars['Date'];
  price: Scalars['Int'];
};

export type ManualDailyPriceInput = {
  day: Scalars['Date'];
  price: Scalars['Int'];
};

export type ManualDocumentDetailInput = {
  amount: Scalars['Int'];
  date: Scalars['Date'];
  description: Scalars['String'];
  quantity: Scalars['Int'];
  reference: DetailNatureInput;
  vatId?: InputMaybe<Scalars['ID']>;
};

/** DOCUMENT */
export type ManualDocumentInput = {
  cashDeskId: Scalars['ID'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  documentDetails?: InputMaybe<Array<ManualDocumentDetailInput>>;
  documentPaymentDetails?: InputMaybe<Array<ManualDocumentPaymentDetailInput>>;
  /** default: true */
  draft?: InputMaybe<Scalars['Boolean']>;
  fiscalType: FiscalType;
  note?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  /** Note da inviare alla stampante fiscale */
  scelNote?: InputMaybe<Scalars['String']>;
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

export type ManualDocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  expireDate?: InputMaybe<Scalars['Date']>;
  paymentActiveId: Scalars['ID'];
};

export const MathOperation = {
  DECREASE: 'DECREASE',
  SUM: 'SUM'
} as const;

export type MathOperation = typeof MathOperation[keyof typeof MathOperation];
export type MessageAutomation = {
  auditable: Auditable;
  cancellationMessageTemplate?: Maybe<MessageTemplate>;
  /**  Required if scheduledType is CREATION  */
  cancellationMessageTemplateId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastExecution?: Maybe<Scalars['DateTime']>;
  linkToPayMessageTemplate?: Maybe<MessageTemplate>;
  /**  Required if scheduledType is CREATION  */
  linkToPayMessageTemplateId?: Maybe<Scalars['ID']>;
  messageTemplate: MessageTemplate;
  messageTemplateCode: MessageTemplateCode;
  messageTemplateId: Scalars['ID'];
  name: Scalars['String'];
  originIds: Array<Scalars['ID']>;
  phase: Array<ReservedResourcePhase>;
  property: Property;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  scheduledConfiguration?: Maybe<MessageAutomationSchedule>;
  scheduledType: MessageAutomationScheduleType;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  wciState: MessageAutomationPresence;
};

export type MessageAutomationInput = {
  cancellationMessageTemplateId?: InputMaybe<Scalars['ID']>;
  isActive: Scalars['Boolean'];
  linkToPayMessageTemplateId?: InputMaybe<Scalars['ID']>;
  messageTemplateId: Scalars['ID'];
  name: Scalars['String'];
  originIds: Array<Scalars['ID']>;
  phase: Array<ReservedResourcePhase>;
  propertyId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
  scheduledConfiguration?: InputMaybe<MessageAutomationScheduleInput>;
  scheduledType: MessageAutomationScheduleType;
  tenantId: Scalars['ID'];
  wciState: MessageAutomationPresence;
};

export const MessageAutomationOutOfBouce = {
  IGNORE: 'IGNORE',
  SEND: 'SEND'
} as const;

export type MessageAutomationOutOfBouce = typeof MessageAutomationOutOfBouce[keyof typeof MessageAutomationOutOfBouce];
export const MessageAutomationPresence = {
  ALWAYS: 'ALWAYS',
  WCI_DONE: 'WCI_DONE',
  WCI_TODO: 'WCI_TODO'
} as const;

export type MessageAutomationPresence = typeof MessageAutomationPresence[keyof typeof MessageAutomationPresence];
export type MessageAutomationQueryFilter = {
  id?: InputMaybe<IDFilter>;
  messageTemplateId?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type MessageAutomationSchedule = {
  beforeOrAfter: BeforeOrAfter;
  days: Scalars['Int'];
  outOfBounds: MessageAutomationOutOfBouce;
  scheduleAt: Scalars['DateTime'];
};

export type MessageAutomationScheduleInput = {
  beforeOrAfter: BeforeOrAfter;
  days: Scalars['Int'];
  outOfBounds: MessageAutomationOutOfBouce;
  scheduleAt: Scalars['DateTime'];
};

export const MessageAutomationScheduleType = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  CREATION: 'CREATION'
} as const;

export type MessageAutomationScheduleType = typeof MessageAutomationScheduleType[keyof typeof MessageAutomationScheduleType];
export type MessageForAutomationInput = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 * Template mail per le comunicazioni verso gli ospiti
 * I template sono gestiti da TS, quelli di sistema non hanno il tenant inserito.
 * In caso in cui il cliente le vuole personalizzare vengono duplicati e inseriti nel tenant.
 * In caso di multiproperty è possibile associare i template alle property
 * La gestione di campi unione viene gestita con handlebars che utilizza mustache come linguaggio
 * Lo stato Inactive è gestito quindi è necessario prenedere sia gli active che gli inactive se non diversamente specificato
 */
export type MessageTemplate = {
  auditable: Auditable;
  chat?: Maybe<Scalars['LocalizedString']>;
  /** Codice che identifica il template */
  code: MessageTemplateCode;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mail?: Maybe<Array<LocalizedMailMessageTemplate>>;
  name: Scalars['String'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
  type: MessageTemplateType;
};

/** Enum per i codici di MessageTemplate */
export const MessageTemplateCode = {
  AVAILABILITY_REQUEST: 'AVAILABILITY_REQUEST',
  COMMUNICATION: 'COMMUNICATION',
  LINK2PAY: 'LINK2PAY',
  POS_LINK2PAY: 'POS_LINK2PAY',
  QUOTATION: 'QUOTATION',
  RESERVATION: 'RESERVATION',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  UNPAID_DOCUMENTS: 'UNPAID_DOCUMENTS',
  WCI: 'WCI'
} as const;

export type MessageTemplateCode = typeof MessageTemplateCode[keyof typeof MessageTemplateCode];
export type MessageTemplateCodeFilter = {
  eq?: InputMaybe<MessageTemplateCode>;
  in?: InputMaybe<Array<MessageTemplateCode>>;
  ne?: InputMaybe<MessageTemplateCode>;
  nin?: InputMaybe<Array<MessageTemplateCode>>;
};

export type MessageTemplateInput = {
  chat?: InputMaybe<Scalars['LocalizedString']>;
  code: MessageTemplateCode;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  mail?: InputMaybe<Array<LocalizedMailMessageTemplateInput>>;
  name: Scalars['String'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  type: MessageTemplateType;
};

export type MessageTemplateQueryFilter = {
  code?: InputMaybe<MessageTemplateCodeFilter>;
  customOnly: Scalars['Boolean'];
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['Language']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<MessageTemplateType>;
};

export const MessageTemplateType = {
  CHAT: 'CHAT',
  MAIL: 'MAIL'
} as const;

export type MessageTemplateType = typeof MessageTemplateType[keyof typeof MessageTemplateType];
/**
 * Moduli del metering
 *   BE BOOKING ENGINE
 *   CM CHANNEL MANAGER
 *   PMS PMS CORE
 *   RM RATE MANAGER
 */
export const MeteringModule = {
  BE: 'BE',
  CM: 'CM',
  PMS: 'PMS',
  RM: 'RM'
} as const;

export type MeteringModule = typeof MeteringModule[keyof typeof MeteringModule];
/**
 * Il modulo è legato al pacchetto che arriva dal metering
 * I moduli base sono PMS, CM, RMS e BM
 * Il modulo viene creato dal metering
 * Se viene disattivato viene gestito lo stato Inactive, cosi rimane traccia dei moduli.
 * La quantità serve per le camere
 */
export type Module = {
  auditable: Auditable;
  bbsPackageId?: Maybe<Scalars['String']>;
  consumptions?: Maybe<Array<ModuleConsumption>>;
  expireDate?: Maybe<Scalars['Date']>;
  family?: Maybe<Scalars['String']>;
  featureCode: MeteringModule;
  features?: Maybe<Array<Feature>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  packageId: Scalars['String'];
  plantId: Scalars['String'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  workspaceId: Scalars['String'];
};

export type ModuleConsumption = {
  quantity: Scalars['Int'];
  slotId: Scalars['String'];
};

export type MoveProductionAssignedInput = {
  destinationBill: Scalars['ID'];
  productionAssigneds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

/** Comuni italiani con dati neessari per gestire comunicazioni ps e istat. La collections viene aggiornata esternamente. */
export type Municipality = {
  auditable: Auditable;
  cadastralCode: Scalars['String'];
  codeItalianPs: Scalars['String'];
  history?: Maybe<Array<MunicipalityHistory>>;
  id: Scalars['ID'];
  istat: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  provincialCapital: Scalars['Boolean'];
  region: Scalars['String'];
  regionCode: Scalars['String'];
};

export type MunicipalityHistory = {
  codeItalianPs: Scalars['String'];
  from: Scalars['Date'];
  istat: Scalars['String'];
  province: Scalars['String'];
  to: Scalars['Date'];
};

export type MunicipalityInput = {
  cadastralCode: Scalars['String'];
  codeItalianPs: Scalars['String'];
  istat: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  provincialCapital: Scalars['Boolean'];
  region: Scalars['String'];
  regionCode: Scalars['String'];
};

export type MunicipalityQueryFilter = {
  id?: InputMaybe<IDFilter>;
  istat?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  province?: InputMaybe<StringFilter>;
};

export type Mutation = {
  activatePointOfSales?: Maybe<Scalars['Void']>;
  addCassaInCloudApiKey?: Maybe<CassaInCloudConfigurationApiKeyEntry>;
  airbnbResetRefreshToken?: Maybe<Scalars['Void']>;
  associateFiscalGatewayWorkstation: FiscalGatewayWorkstation;
  attachDatabaseForExport: Scalars['String'];
  checkinReservedResources?: Maybe<Scalars['Void']>;
  checkoutReservedResources?: Maybe<Scalars['Void']>;
  cleanImport?: Maybe<Scalars['Void']>;
  closeCashDesk?: Maybe<Scalars['Void']>;
  confirmQuotation: PayAndConfirmQuotation;
  createAdditionalService: AdditionalService;
  createAmenity: Amenity;
  createAvailabilityRequest: AvailabilityRequest;
  createBill: Bill;
  createBookingEngineUrl: BookingEngineUrl;
  createBookingPolicy: BookingPolicy;
  createCashDesk: CashDesk;
  createCashDeskType: CashDeskType;
  createChannel: Channel;
  createChargeCategory: ChargeCategory;
  /**  Crea un pagamento per una prenotazione  */
  createChargeForReservation: TsPayCharge;
  createCheckoutDocument: Document;
  createCreditNoteDocument: Scalars['String'];
  createCreditNoteForAdvance: Scalars['String'];
  createCustomer: Customer;
  createDepositDocument: Document;
  createDocumentActive: DocumentActive;
  createExportProcedure: ExportProcedure;
  createExportScripts?: Maybe<Scalars['Void']>;
  createFiscalGatewayWorkstation: FiscalGatewayWorkstation;
  createIdentificationDocument: IdentificationDocument;
  /**  Crea un link 2 Pay per attivare il pos in presenza  */
  createLink2PayPosOnLine: Link2PayOutput;
  /**  Crea un link per attivare il pos in base alle booking policy della quotation (restituisce null se non c'è nulla da pagare in anticipo)  */
  createLinkForQuotation?: Maybe<Link2PayOutput>;
  /**  Crea un link per attivare il pos in base alle booking policy della reservation (restituisce null se non c'è nulla da pagare in anticipo)  */
  createLinkForReservation?: Maybe<Link2PayOutput>;
  /**  Crea un link 2 Pay per un documento di quietanza sospesi  */
  createLinkForUnpaidDocument: Link2PayOutput;
  createManualDocument: Document;
  createMessageAutomation: MessageAutomation;
  createMessageTemplate: MessageTemplate;
  createMunicipality: Municipality;
  createOrigin: Origin;
  createPaidInFullDocument: Scalars['String'];
  createPaymentActive: PaymentActive;
  createPaymentMethod: PaymentMethod;
  createPointOfSaleMealShift: PointOfSaleMealShift;
  createPosition: Position;
  createProduct: Product;
  createProduction: Production;
  createProperty: Property;
  createQuotation: Quotation;
  createQuotationForIbe: QuotationForIbeOutput;
  createRate: Rate;
  createReservation: Reservation;
  createReservationState: ReservationState;
  createReservedResource: ReservedResource;
  createResource: Resource;
  createResourceType: ResourceType;
  createResourceUnavailability: Resource;
  createTSPayGatewayForProperties?: Maybe<Scalars['Void']>;
  createTag: Tag;
  /**  Crea un'apikey per il merchant, da chiamare dopo il completamento dell'onboarding  */
  createTsPayApiKey: TsPayApiKey;
  createUserAndRole?: Maybe<Scalars['Void']>;
  createVat: Vat;
  deleteAdditionalService?: Maybe<Scalars['Void']>;
  deleteAmenity?: Maybe<Scalars['Void']>;
  deleteBill?: Maybe<Scalars['Void']>;
  deleteBookingEngineUrl?: Maybe<Scalars['Void']>;
  deleteBookingPolicy?: Maybe<Scalars['Void']>;
  deleteBulkReservations?: Maybe<Scalars['Void']>;
  deleteCashDeskType?: Maybe<Scalars['Void']>;
  deleteChannel?: Maybe<Scalars['Void']>;
  deleteChargeCategory?: Maybe<Scalars['Void']>;
  deleteCustomer?: Maybe<Scalars['Void']>;
  deleteCustomerDocumentImage?: Maybe<Scalars['Void']>;
  deleteDocument?: Maybe<Scalars['Void']>;
  deleteDocumentActive?: Maybe<Scalars['Void']>;
  deleteExportProcedure?: Maybe<Scalars['Void']>;
  deleteFiscalGatewayWorkstation?: Maybe<Scalars['Void']>;
  deleteIdentificationDocument?: Maybe<Scalars['Void']>;
  deleteInternalThreadMessage?: Maybe<Scalars['Void']>;
  deleteMessageAutomation?: Maybe<Scalars['Void']>;
  deleteMessageTemplate?: Maybe<Scalars['Void']>;
  deleteMunicipality?: Maybe<Scalars['Void']>;
  deleteOrigin?: Maybe<Scalars['Void']>;
  deletePaymentActive?: Maybe<Scalars['Void']>;
  deletePaymentMethod?: Maybe<Scalars['Void']>;
  deletePointOfSaleMealShift?: Maybe<Scalars['Void']>;
  deletePosition?: Maybe<Scalars['Void']>;
  deleteProduct?: Maybe<Scalars['Void']>;
  deleteProduction?: Maybe<Scalars['Void']>;
  deleteProperty?: Maybe<Scalars['Void']>;
  deleteQuotation?: Maybe<Scalars['Void']>;
  deleteRate?: Maybe<Scalars['Void']>;
  deleteReservation?: Maybe<Scalars['Void']>;
  deleteReservationState?: Maybe<Scalars['Void']>;
  deleteReservedResource?: Maybe<Scalars['Void']>;
  deleteResource?: Maybe<Scalars['Void']>;
  deleteResourceType?: Maybe<Scalars['Void']>;
  deleteResourceUnavailability: Resource;
  deleteTag?: Maybe<Scalars['Void']>;
  deleteVat?: Maybe<Scalars['Void']>;
  executeDailyClosure?: Maybe<Scalars['Void']>;
  executeMessageAutomation?: Maybe<Scalars['Void']>;
  exportDatabase: ExportDatabaseOutput;
  fileUploadPresignedURL: FileUploadResponse;
  finalizeDocument?: Maybe<Scalars['Void']>;
  generateCityTaxFile: GenerateCityTaxFileResult;
  generateIstatFile: GenerateIstatFileResult;
  generateTenantSecret: Scalars['String'];
  guestPortalAddServices?: Maybe<Scalars['Void']>;
  guestPortalCancelReservation: CancelReservationResult;
  guestPortalCheckinReservedResources?: Maybe<Scalars['Void']>;
  guestPortalCheckoutReservedResources?: Maybe<Scalars['Void']>;
  guestPortalCreateCheckoutDocument: GuestPortalCheckoutDocumentResult;
  guestPortalWebCheckin?: Maybe<Scalars['Void']>;
  horecahubRegisterIntegration: HorecaHubIntegration;
  importProperty: ImportPropertyOutput;
  importPropertyRetry: ImportPropertyOutput;
  insertBulkReservations?: Maybe<Scalars['String']>;
  /** Create a new Sinapsi competitor scraping task */
  insertSinapsiCompetitorRetrievalTask: Scalars['ID'];
  makeFakeEvent?: Maybe<Scalars['Void']>;
  moveProductionAssigned?: Maybe<Scalars['Void']>;
  notifyAvailabilityRequest?: Maybe<Scalars['Void']>;
  onboardingProperty?: Maybe<Property>;
  onboardingResourceType: ResourceType;
  openCashDesk?: Maybe<Scalars['Void']>;
  planReservedResourceCommitments?: Maybe<Scalars['Void']>;
  processReservation?: Maybe<Scalars['Void']>;
  rebuildPropertyAvailability?: Maybe<Scalars['Void']>;
  removeCassaInCloudApiKey?: Maybe<Scalars['Void']>;
  removePointOfSale?: Maybe<Scalars['Void']>;
  retrieveFutureReservations: Scalars['Date'];
  retrieveReservation?: Maybe<Scalars['Void']>;
  sendAttachmentEmailForDocument?: Maybe<Email>;
  sendAvailabilitiesAndPrices?: Maybe<Scalars['Void']>;
  sendDataHubSpot?: Maybe<Scalars['String']>;
  /**  BAD FORMAT errors are returned as string  */
  sendInvoiceToTSDigital?: Maybe<FelAdditionalInfo>;
  sendIstat?: Maybe<Array<IstatError>>;
  sendIstatCancellation?: Maybe<Array<IstatError>>;
  sendIstatPeriod?: Maybe<Scalars['Void']>;
  sendMail: Email;
  sendMessageForAutomation?: Maybe<Scalars['Void']>;
  sendPaymentLinkEmailForUnpaidDocuments?: Maybe<Email>;
  sendPosLink2PayEmail?: Maybe<Email>;
  sendPs?: Maybe<Array<Scalars['String']>>;
  sendQuotationEmail?: Maybe<Email>;
  sendReceiptToFiscalGateway?: Maybe<Scalars['Void']>;
  sendReminderEmailForUnpaidDocuments?: Maybe<Email>;
  sendReservationMessage?: Maybe<Scalars['Void']>;
  sendThreadMessage?: Maybe<Scalars['Void']>;
  setChargeTransformation?: Maybe<Scalars['Void']>;
  setEntityImages?: Maybe<Scalars['Void']>;
  setHotelDate?: Maybe<Scalars['Void']>;
  setInsightPause?: Maybe<Scalars['Void']>;
  setNcsNotificationRead?: Maybe<Scalars['Void']>;
  setNcsNotificationsRead?: Maybe<Scalars['Void']>;
  setNcsUserPreference?: Maybe<Scalars['Void']>;
  setPropertyCityTaxConfiguration?: Maybe<Scalars['Void']>;
  setPropertyConfigurations?: Maybe<Scalars['Void']>;
  setPropertyFiscalConfiguration?: Maybe<Scalars['Void']>;
  setPropertyIstatConfiguration?: Maybe<Scalars['Void']>;
  setPropertyPsConfiguration?: Maybe<Scalars['Void']>;
  setPropertySinapsiConfiguration?: Maybe<Scalars['Void']>;
  setPropertySubAddresses?: Maybe<Scalars['Void']>;
  setQuotationState?: Maybe<Scalars['Void']>;
  setResourceCleaningState?: Maybe<Scalars['Void']>;
  setScelTemplate?: Maybe<Scalars['Void']>;
  /** Run a round of Autopilot updates and/or cache refreshes; usually invoked as a Lambda, this API entry is provided for debug */
  sinapsiUpdate: SinapsiUpdateOutcome;
  splitProductionAssigned?: Maybe<Scalars['Void']>;
  /**
   * Mutation che si occupa di eseguire l'export, sono gestiti errori relativi a mancanza di configurazione e errore in casi di export già estratti
   * CONFIGURATION_KEY , INVALID_OPERATION
   */
  startExportManagement: ExportData;
  /**  Ritorna l'url da seguire per completare l'onboarding  */
  startTsPayOnboarding: Scalars['String'];
  undoCheckinReservedResources?: Maybe<Scalars['Void']>;
  undoCheckoutReservedResources?: Maybe<Scalars['Void']>;
  undoDocument?: Maybe<Scalars['Void']>;
  undoImport?: Maybe<Scalars['Void']>;
  updateAdditionalService: AdditionalService;
  updateAmenity: Amenity;
  /** Apply Sinapsi recommendtions to a given property */
  updateBasePricesBySinapsiAutopilot: SinapsiUpdateOutcome;
  updateBill: Bill;
  updateBookingEngineUrl: BookingEngineUrl;
  updateBookingPolicy: BookingPolicy;
  updateCashDeskType: CashDeskType;
  updateCassaInCloudApiKey?: Maybe<Scalars['Void']>;
  updateChannel: Channel;
  updateChargeCategory: ChargeCategory;
  updateCityTaxProduction?: Maybe<Scalars['Void']>;
  updateCustomer: Customer;
  updateDepositAssigneds?: Maybe<Scalars['Void']>;
  updateDocument: Document;
  updateDocumentActive: DocumentActive;
  updateDocumentNumber?: Maybe<Scalars['Void']>;
  updateDocumentPaymentDetails?: Maybe<Scalars['Void']>;
  updateExportProcedure: ExportProcedure;
  updateFinalizedDocument: Document;
  updateIdentificationDocument: IdentificationDocument;
  updateInvoiceCustomFields?: Maybe<Scalars['Void']>;
  updateInvoiceState?: Maybe<FelAdditionalInfo>;
  updateMessageAutomation: MessageAutomation;
  updateMessageTemplate: MessageTemplate;
  updateMunicipality: Municipality;
  updateOrigin: Origin;
  updatePaymentActive: PaymentActive;
  updatePaymentMethod: PaymentMethod;
  updatePointOfSale?: Maybe<Scalars['Void']>;
  updatePointOfSaleMealShift?: Maybe<Scalars['Void']>;
  updatePosition: Position;
  updatePriceCalendar?: Maybe<Scalars['Void']>;
  updatePriceCalendarRange?: Maybe<Scalars['Void']>;
  updatePrivacySettings?: Maybe<Scalars['Void']>;
  updateProduct: Product;
  updateProduction: Production;
  updateProperty: Property;
  updateQuotation: Quotation;
  updateRate: Rate;
  updateReservation: Reservation;
  updateReservationState: ReservationState;
  updateReservedResource: ReservedResource;
  updateReservedResources: Array<ReservedResource>;
  updateResource: Resource;
  updateResourceType: ResourceType;
  updateResourceUnavailability: Resource;
  updateResourcesRoomTetrisOrder?: Maybe<Scalars['Void']>;
  updateSellerName?: Maybe<Scalars['Void']>;
  /** Update an existing competitor scraping task */
  updateSinapsiCompetitorRetrievalTask: Scalars['ID'];
  /** Store the results of a Sinapsi competitor scraping task and unlock it for the next execution */
  updateSinapsiCompetitorRetrievalTaskResults: Scalars['String'];
  updateSupportUserRole: Scalars['Boolean'];
  updateTSPaySourcesForProperties?: Maybe<Scalars['Void']>;
  updateTag: Tag;
  updateThread?: Maybe<Scalars['Void']>;
  updateUserRole?: Maybe<Scalars['Void']>;
  updateVat: Vat;
  upsertNcsGroups?: Maybe<Scalars['Void']>;
};


export type MutationactivatePointOfSalesArgs = {
  input: ActivatePointOfSalesInput;
};


export type MutationaddCassaInCloudApiKeyArgs = {
  value: CassaInCloudApiKeyInput;
};


export type MutationairbnbResetRefreshTokenArgs = {
  channelId: Scalars['ID'];
};


export type MutationassociateFiscalGatewayWorkstationArgs = {
  cashDeskTypeId: Scalars['ID'];
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationattachDatabaseForExportArgs = {
  backupName: Scalars['String'];
  dbName: Scalars['String'];
};


export type MutationcheckinReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationcheckoutReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationcleanImportArgs = {
  tenantId: Scalars['ID'];
};


export type MutationcloseCashDeskArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationconfirmQuotationArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  input: ConfirmQuotationInput;
};


export type MutationcreateAdditionalServiceArgs = {
  value: AdditionalServiceInput;
};


export type MutationcreateAmenityArgs = {
  value: AmenityInput;
};


export type MutationcreateAvailabilityRequestArgs = {
  input: AvailabilityRequestInput;
};


export type MutationcreateBillArgs = {
  value: BillInput;
};


export type MutationcreateBookingEngineUrlArgs = {
  value: BookingEngineUrlInput;
};


export type MutationcreateBookingPolicyArgs = {
  value: BookingPolicyInput;
};


export type MutationcreateCashDeskArgs = {
  value: CashDeskInput;
};


export type MutationcreateCashDeskTypeArgs = {
  value: CashDeskTypeInput;
};


export type MutationcreateChannelArgs = {
  value: ChannelInput;
};


export type MutationcreateChargeCategoryArgs = {
  value: ChargeCategoryInput;
};


export type MutationcreateChargeForReservationArgs = {
  input: ChargeForReservationInput;
};


export type MutationcreateCheckoutDocumentArgs = {
  value: CheckoutDocumentInput;
};


export type MutationcreateCreditNoteDocumentArgs = {
  input: CreditNoteDocumentInput;
};


export type MutationcreateCreditNoteForAdvanceArgs = {
  input: CreditNoteForAdvanceInput;
};


export type MutationcreateCustomerArgs = {
  returnExisting?: InputMaybe<Scalars['Boolean']>;
  value: CustomerInput;
};


export type MutationcreateDepositDocumentArgs = {
  value: DepositDocumentInput;
};


export type MutationcreateDocumentActiveArgs = {
  value: DocumentActiveInput;
};


export type MutationcreateExportProcedureArgs = {
  value: ExportProcedureInput;
};


export type MutationcreateExportScriptsArgs = {
  backupName: Scalars['String'];
  type: PmsType;
};


export type MutationcreateFiscalGatewayWorkstationArgs = {
  cashDeskTypeId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationcreateIdentificationDocumentArgs = {
  value: IdentificationDocumentInput;
};


export type MutationcreateLink2PayPosOnLineArgs = {
  input: Link2PayInput;
};


export type MutationcreateLinkForQuotationArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  input: Link2PayQuotationInput;
};


export type MutationcreateLinkForReservationArgs = {
  input: Link2PayReservationInput;
};


export type MutationcreateLinkForUnpaidDocumentArgs = {
  input: Link2PayUnpaidDocumentInput;
};


export type MutationcreateManualDocumentArgs = {
  value: ManualDocumentInput;
};


export type MutationcreateMessageAutomationArgs = {
  value: MessageAutomationInput;
};


export type MutationcreateMessageTemplateArgs = {
  value: MessageTemplateInput;
};


export type MutationcreateMunicipalityArgs = {
  value: MunicipalityInput;
};


export type MutationcreateOriginArgs = {
  value: OriginInput;
};


export type MutationcreatePaidInFullDocumentArgs = {
  input: PaidInFullDocumentInput;
};


export type MutationcreatePaymentActiveArgs = {
  value: PaymentActiveInput;
};


export type MutationcreatePaymentMethodArgs = {
  value: PaymentMethodInput;
};


export type MutationcreatePointOfSaleMealShiftArgs = {
  value: PointOfSaleMealShiftInput;
};


export type MutationcreatePositionArgs = {
  value: PositionInput;
};


export type MutationcreateProductArgs = {
  value: ProductInput;
};


export type MutationcreateProductionArgs = {
  billAllocation: Array<BillAllocationInput>;
  value: ProductionInput;
};


export type MutationcreatePropertyArgs = {
  plantId?: InputMaybe<Scalars['String']>;
  value: PropertyInput;
};


export type MutationcreateQuotationArgs = {
  value: QuotationInput;
};


export type MutationcreateQuotationForIbeArgs = {
  callbackUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  value: QuotationInput;
};


export type MutationcreateRateArgs = {
  value: RateInput;
};


export type MutationcreateReservationArgs = {
  options?: InputMaybe<ReservationOptions>;
  value: ReservationInput;
};


export type MutationcreateReservationStateArgs = {
  value: ReservationStateInput;
};


export type MutationcreateReservedResourceArgs = {
  options: ReservationOptions;
  value: ReservedResourceInput;
};


export type MutationcreateResourceArgs = {
  value: ResourceInput;
};


export type MutationcreateResourceTypeArgs = {
  value: ResourceTypeInput;
};


export type MutationcreateResourceUnavailabilityArgs = {
  allowOverbooking: Scalars['Boolean'];
  value: CreateResourceUnavailabilityInput;
};


export type MutationcreateTSPayGatewayForPropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type MutationcreateTagArgs = {
  value: TagInput;
};


export type MutationcreateTsPayApiKeyArgs = {
  merchantRef: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationcreateUserAndRoleArgs = {
  input: UserInput;
};


export type MutationcreateVatArgs = {
  value: VatInput;
};


export type MutationdeleteAdditionalServiceArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteAmenityArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBillArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBookingEngineUrlArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBookingPolicyArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteBulkReservationsArgs = {
  correlationId: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCashDeskTypeArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteChannelArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteChargeCategoryArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCustomerArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteCustomerDocumentImageArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteDocumentActiveArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteExportProcedureArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteFiscalGatewayWorkstationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteIdentificationDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteInternalThreadMessageArgs = {
  tenantId: Scalars['ID'];
  threadMessageId: Scalars['ID'];
};


export type MutationdeleteMessageAutomationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteMessageTemplateArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteMunicipalityArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteOriginArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePaymentActiveArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePaymentMethodArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePointOfSaleMealShiftArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePositionArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteProductArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteProductionArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeletePropertyArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteQuotationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteRateArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservationStateArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteReservedResourceArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceTypeArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteResourceUnavailabilityArgs = {
  value: DeleteResourceUnavailabilityInput;
};


export type MutationdeleteTagArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationdeleteVatArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationexecuteDailyClosureArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationexecuteMessageAutomationArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationexportDatabaseArgs = {
  input: ExportDatabaseInput;
};


export type MutationfileUploadPresignedURLArgs = {
  file: FileInput;
};


export type MutationfinalizeDocumentArgs = {
  id: Scalars['String'];
  sendReceiptByMail?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type MutationgenerateCityTaxFileArgs = {
  input: GenerateCityTaxFileInput;
};


export type MutationgenerateIstatFileArgs = {
  input: GenerateIstatFileInput;
};


export type MutationgenerateTenantSecretArgs = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type MutationguestPortalAddServicesArgs = {
  value: GuestPortalAddServicesInput;
};


export type MutationguestPortalCancelReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationguestPortalCheckinReservedResourcesArgs = {
  input: GuestPortalCheckinReservedResourcesInput;
};


export type MutationguestPortalCheckoutReservedResourcesArgs = {
  input: GuestPortalCheckoutReservedResourcesInput;
};


export type MutationguestPortalCreateCheckoutDocumentArgs = {
  value: GuestPortalCheckoutDocumentInput;
};


export type MutationguestPortalWebCheckinArgs = {
  value: GuestPortalWebCheckinInput;
};


export type MutationhorecahubRegisterIntegrationArgs = {
  tenantId: Scalars['ID'];
};


export type MutationimportPropertyArgs = {
  value: ImportPropertyInput;
};


export type MutationimportPropertyRetryArgs = {
  input: RetryImportPropertyInput;
};


export type MutationinsertBulkReservationsArgs = {
  propertyId: Scalars['ID'];
  rows: Array<BulkReservationInput>;
  tenantId: Scalars['ID'];
};


export type MutationinsertSinapsiCompetitorRetrievalTaskArgs = {
  task_info: SinapsiCompetitorRetrievalTaskInput;
};


export type MutationmoveProductionAssignedArgs = {
  input: MoveProductionAssignedInput;
};


export type MutationnotifyAvailabilityRequestArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationonboardingPropertyArgs = {
  value: OnBoardingInput;
};


export type MutationonboardingResourceTypeArgs = {
  value: OnBoardingResourceTypeInput;
};


export type MutationopenCashDeskArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationplanReservedResourceCommitmentsArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationprocessReservationArgs = {
  channelReservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationrebuildPropertyAvailabilityArgs = {
  fireAndForget: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationremoveCassaInCloudApiKeyArgs = {
  apiKey: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationremovePointOfSaleArgs = {
  input: RemovePointOfSaleInput;
};


export type MutationretrieveFutureReservationsArgs = {
  channelId: Scalars['ID'];
  portalName: PortalName;
  tenantId: Scalars['ID'];
};


export type MutationretrieveReservationArgs = {
  channelId: Scalars['ID'];
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  portalName: PortalName;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};


export type MutationsendAttachmentEmailForDocumentArgs = {
  input: AttachmentForDocumentInput;
};


export type MutationsendAvailabilitiesAndPricesArgs = {
  input: SendAvailabilitiesAndPricesInput;
};


export type MutationsendDataHubSpotArgs = {
  data: Array<HubSpotDataInput>;
};


export type MutationsendInvoiceToTSDigitalArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsendIstatArgs = {
  input: SendIstatInput;
};


export type MutationsendIstatCancellationArgs = {
  input: SendIstatCancellationInput;
};


export type MutationsendIstatPeriodArgs = {
  input: SendIstatPeriodInput;
};


export type MutationsendMailArgs = {
  input: MailInput;
};


export type MutationsendMessageForAutomationArgs = {
  input: MessageForAutomationInput;
};


export type MutationsendPaymentLinkEmailForUnpaidDocumentsArgs = {
  input: PaymentLinkForUnpaidDocumentsInput;
};


export type MutationsendPosLink2PayEmailArgs = {
  input: SendPosLink2PayEmailInput;
};


export type MutationsendPsArgs = {
  input: SendPSInput;
};


export type MutationsendQuotationEmailArgs = {
  input: SendQuotationEmailInput;
};


export type MutationsendReceiptToFiscalGatewayArgs = {
  id: Scalars['ID'];
  resend?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type MutationsendReminderEmailForUnpaidDocumentsArgs = {
  input: ReminderForUnpaidDocumentsInput;
};


export type MutationsendReservationMessageArgs = {
  input: SendReservationMessageInput;
};


export type MutationsendThreadMessageArgs = {
  input: SendMessageInput;
};


export type MutationsetChargeTransformationArgs = {
  value: ChargeTransformationInput;
};


export type MutationsetEntityImagesArgs = {
  input: EntityImageInput;
};


export type MutationsetHotelDateArgs = {
  input: HotelDateInput;
};


export type MutationsetInsightPauseArgs = {
  input: InsightInput;
};


export type MutationsetNcsNotificationReadArgs = {
  id: Scalars['String'];
  read: Scalars['Boolean'];
};


export type MutationsetNcsNotificationsReadArgs = {
  propertyId: Scalars['ID'];
  read: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationsetNcsUserPreferenceArgs = {
  preferences: Array<NcsTemplatePreferenceInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationsetPropertyCityTaxConfigurationArgs = {
  config: Array<CityTaxConfigurationInput>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyConfigurationsArgs = {
  value: SetPropertyConfigurationsInput;
};


export type MutationsetPropertyFiscalConfigurationArgs = {
  config: Array<FiscalConfigurationInput>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyIstatConfigurationArgs = {
  config?: InputMaybe<Array<IstatConfigurationInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertyPsConfigurationArgs = {
  config?: InputMaybe<Array<PsConfigurationInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertySinapsiConfigurationArgs = {
  config: SinapsiConfigurationInput;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetPropertySubAddressesArgs = {
  config?: InputMaybe<Array<PropertySubAddressInput>>;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationsetQuotationStateArgs = {
  id: Scalars['ID'];
  state: SetQuotationState;
  tenantId: Scalars['ID'];
};


export type MutationsetResourceCleaningStateArgs = {
  input: ResourceCleaningStateInput;
};


export type MutationsetScelTemplateArgs = {
  scelTemplate: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationsinapsiUpdateArgs = {
  options: SinapsiUpdateOptions;
};


export type MutationsplitProductionAssignedArgs = {
  input: SplitProductionAssignedInput;
};


export type MutationstartExportManagementArgs = {
  input: ExportInput;
};


export type MutationstartTsPayOnboardingArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  vatNumber: Scalars['String'];
};


export type MutationundoCheckinReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationundoCheckoutReservedResourcesArgs = {
  input: CheckinCheckoutReservedResourcesInput;
};


export type MutationundoDocumentArgs = {
  id: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationundoImportArgs = {
  deleteImported: Scalars['Boolean'];
  deleteProperty: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  stepFrom: UndoImportStep;
  tenantId: Scalars['ID'];
};


export type MutationupdateAdditionalServiceArgs = {
  id: Scalars['String'];
  value: AdditionalServiceInput;
};


export type MutationupdateAmenityArgs = {
  id: Scalars['String'];
  value: AmenityInput;
};


export type MutationupdateBasePricesBySinapsiAutopilotArgs = {
  filter: SinapsiFilter;
  options: SinapsiAutopilotOptions;
};


export type MutationupdateBillArgs = {
  id: Scalars['ID'];
  value: BillInput;
};


export type MutationupdateBookingEngineUrlArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};


export type MutationupdateBookingPolicyArgs = {
  id: Scalars['String'];
  value: BookingPolicyInput;
};


export type MutationupdateCashDeskTypeArgs = {
  id: Scalars['String'];
  input: CashDeskTypeInput;
};


export type MutationupdateCassaInCloudApiKeyArgs = {
  value: CassaInCloudApiKeyInput;
};


export type MutationupdateChannelArgs = {
  id: Scalars['String'];
  value: ChannelInput;
};


export type MutationupdateChargeCategoryArgs = {
  id: Scalars['String'];
  value: ChargeCategoryInput;
};


export type MutationupdateCityTaxProductionArgs = {
  fullStay?: InputMaybe<Scalars['Boolean']>;
  guestId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateCustomerArgs = {
  guestOfReservedResourceId?: InputMaybe<Scalars['ID']>;
  id: Scalars['String'];
  value: CustomerInput;
};


export type MutationupdateDepositAssignedsArgs = {
  depositAssigneds: Array<UpdateDepositAssigneds>;
  depositDocumentId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateDocumentArgs = {
  id: Scalars['String'];
  value: DocumentInput;
};


export type MutationupdateDocumentActiveArgs = {
  id: Scalars['String'];
  input: DocumentActiveInput;
};


export type MutationupdateDocumentNumberArgs = {
  input: UpdateDocumentNumberInput;
};


export type MutationupdateDocumentPaymentDetailsArgs = {
  id: Scalars['ID'];
  paymentActiveIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type MutationupdateExportProcedureArgs = {
  id: Scalars['String'];
  value: ExportProcedureInput;
};


export type MutationupdateFinalizedDocumentArgs = {
  id: Scalars['String'];
  value: DocumentInput;
};


export type MutationupdateIdentificationDocumentArgs = {
  id: Scalars['String'];
  value: IdentificationDocumentInput;
};


export type MutationupdateInvoiceCustomFieldsArgs = {
  customFields: FelCustomFieldsInput;
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateInvoiceStateArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type MutationupdateMessageAutomationArgs = {
  id: Scalars['ID'];
  value: MessageAutomationInput;
};


export type MutationupdateMessageTemplateArgs = {
  id: Scalars['String'];
  value: MessageTemplateInput;
};


export type MutationupdateMunicipalityArgs = {
  id: Scalars['String'];
  value: MunicipalityInput;
};


export type MutationupdateOriginArgs = {
  id: Scalars['ID'];
  value: OriginInput;
};


export type MutationupdatePaymentActiveArgs = {
  id: Scalars['String'];
  input: PaymentActiveInput;
};


export type MutationupdatePaymentMethodArgs = {
  id: Scalars['String'];
  value: PaymentMethodInput;
};


export type MutationupdatePointOfSaleArgs = {
  id: Scalars['String'];
  value: PointOfSaleInput;
};


export type MutationupdatePointOfSaleMealShiftArgs = {
  id: Scalars['String'];
  value: PointOfSaleMealShiftInput;
};


export type MutationupdatePositionArgs = {
  id: Scalars['String'];
  value: PositionInput;
};


export type MutationupdatePriceCalendarArgs = {
  value: PriceCalendarInput;
};


export type MutationupdatePriceCalendarRangeArgs = {
  value: PriceCalendarRangeInput;
};


export type MutationupdatePrivacySettingsArgs = {
  tenantId: Scalars['ID'];
  value: PrivacySettingsInput;
};


export type MutationupdateProductArgs = {
  id: Scalars['ID'];
  value: ProductInput;
};


export type MutationupdateProductionArgs = {
  id: Scalars['ID'];
  value: ProductionInput;
};


export type MutationupdatePropertyArgs = {
  id: Scalars['ID'];
  value: PropertyInput;
};


export type MutationupdateQuotationArgs = {
  id: Scalars['ID'];
  value: QuotationInput;
};


export type MutationupdateRateArgs = {
  id: Scalars['String'];
  value: RateInput;
};


export type MutationupdateReservationArgs = {
  id: Scalars['ID'];
  options?: InputMaybe<ReservationOptions>;
  value: ReservationUpdateInput;
};


export type MutationupdateReservationStateArgs = {
  id: Scalars['ID'];
  value: ReservationStateInput;
};


export type MutationupdateReservedResourceArgs = {
  id: Scalars['ID'];
  options: ReservedResourceOptions;
  value: ReservedResourceInput;
};


export type MutationupdateReservedResourcesArgs = {
  options: ReservationOptions;
  value: Array<ReservedResourceMultiInput>;
};


export type MutationupdateResourceArgs = {
  id: Scalars['String'];
  value: ResourceInput;
};


export type MutationupdateResourceTypeArgs = {
  id: Scalars['String'];
  value: ResourceTypeInput;
};


export type MutationupdateResourceUnavailabilityArgs = {
  allowOverbooking: Scalars['Boolean'];
  value: UpdateResourceUnavailabilityInput;
};


export type MutationupdateResourcesRoomTetrisOrderArgs = {
  input: Array<UpdateResourceRoomTetrisOrderInput>;
  tenantId: Scalars['ID'];
};


export type MutationupdateSellerNameArgs = {
  tenantId: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationupdateSinapsiCompetitorRetrievalTaskArgs = {
  updated_task_info: SinapsiCompetitorRetrievalTaskUpdateInput;
};


export type MutationupdateSinapsiCompetitorRetrievalTaskResultsArgs = {
  data: SinapsiCompetitorRetrievalTaskResultsInput;
};


export type MutationupdateSupportUserRoleArgs = {
  itemId: Scalars['String'];
};


export type MutationupdateTSPaySourcesForPropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type MutationupdateTagArgs = {
  id: Scalars['String'];
  value: TagInput;
};


export type MutationupdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationupdateUserRoleArgs = {
  id: Scalars['ID'];
  value: Array<UserRoleInput>;
};


export type MutationupdateVatArgs = {
  id: Scalars['String'];
  value: VatInput;
};


export type MutationupsertNcsGroupsArgs = {
  propertyId?: InputMaybe<Scalars['ID']>;
  skipUserPreferences?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export const NcsChannel = {
  EMAIL: 'EMAIL',
  PEC: 'PEC',
  PUSH: 'PUSH',
  SMS: 'SMS',
  WEB: 'WEB',
  WEBHOOK: 'WEBHOOK'
} as const;

export type NcsChannel = typeof NcsChannel[keyof typeof NcsChannel];
export type NcsNotification = {
  appCode?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  delivered?: Maybe<Scalars['Boolean']>;
  deliveredDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ncsId?: Maybe<Scalars['String']>;
  notification?: Maybe<NcsNotificationDetail>;
  priority?: Maybe<NcsPriorityEnum>;
  read?: Maybe<Scalars['Boolean']>;
  readDate?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type NcsNotificationDetail = {
  message?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NcsNotificationSummary = {
  appCode?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  unread?: Maybe<Scalars['Int']>;
};

export const NcsPriorityEnum = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM'
} as const;

export type NcsPriorityEnum = typeof NcsPriorityEnum[keyof typeof NcsPriorityEnum];
/**
 * Tipo che identifica il template utilizzato per inviare un tipo messaggio tramite il servizio NCS.
 * Il template contiene le specifiche per i diversi canali (EMAIL, WEB, SMS...)
 */
export type NcsTemplate = {
  id: Scalars['ID'];
  ncsTemplatesRequest: Scalars['JSON'];
  processed: Scalars['Boolean'];
};

export type NcsTemplatePreference = {
  channels?: Maybe<Array<NcsChannel>>;
  template?: Maybe<Scalars['String']>;
};

export type NcsTemplatePreferenceInput = {
  channels: Array<NcsChannel>;
  template: Scalars['String'];
};

export type NcsUserPreference = {
  ncsId: Scalars['String'];
  templates: Array<NcsTemplatePreference>;
};

export type NcsUserPreferenceInput = {
  ncsIdGroup: Scalars['String'];
  ncsIdUser: Scalars['String'];
  preferences: Array<NcsTemplatePreferenceInput>;
};

export type NewThreadMessageEvent = {
  incoming: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type NewThreadMessageEventFilter = {
  incoming?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId?: InputMaybe<Scalars['ID']>;
};

/** Regola di gestione del no show */
export type NoShowRule = {
  percentage?: Maybe<Scalars['Float']>;
  type: NoShowType;
};

export type NoShowRuleInput = {
  percentage?: InputMaybe<Scalars['Float']>;
  type: NoShowType;
};

export const NoShowType = {
  FIRSTNIGHT: 'FIRSTNIGHT',
  NOTAPPLY: 'NOTAPPLY',
  PERCENTAGE_TOTAL: 'PERCENTAGE_TOTAL',
  TOTAL: 'TOTAL'
} as const;

export type NoShowType = typeof NoShowType[keyof typeof NoShowType];
/** Le note divise per reparto sono un embedded documents della prenotazione */
export type Note = {
  description: Scalars['String'];
  type: NoteType;
};

export type NoteInput = {
  description: Scalars['String'];
  type: NoteType;
};

export const NoteType = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  HOUSEKEEPING: 'HOUSEKEEPING',
  PORTAL: 'PORTAL',
  RESERVATION: 'RESERVATION',
  RESTAURANT: 'RESTAURANT'
} as const;

export type NoteType = typeof NoteType[keyof typeof NoteType];
export type OnBoardingInput = {
  baseRate: RateBaseInput;
  bookingPolicy: ReservationBookingPolicyInput;
  mainChargeCategory: ChargeCategoryBoard;
  plantId?: InputMaybe<Scalars['String']>;
  property: PropertyBaseInput;
};

export type OnBoardingResourceTypeInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  propertyId: Scalars['ID'];
  resourceType: ResourceTypeBaseInput;
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
  tenantId: Scalars['ID'];
};

/** Ruoli nel dominio di One Platform. */
export const OnePlatformRole = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  SUPPORT: 'SUPPORT',
  USER: 'USER'
} as const;

export type OnePlatformRole = typeof OnePlatformRole[keyof typeof OnePlatformRole];
export const OpenBillsFilterType = {
  CHECKOUT: 'CHECKOUT',
  CREATED_ON: 'CREATED_ON',
  PRODUTION_DATE: 'PRODUTION_DATE'
} as const;

export type OpenBillsFilterType = typeof OpenBillsFilterType[keyof typeof OpenBillsFilterType];
export type OpenBillsQueryFilter = {
  date: ClosedRangeInput;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: OpenBillsFilterType;
};

export const OptionType = {
  COMPOSITION: 'COMPOSITION',
  EQUIVALENCE: 'EQUIVALENCE'
} as const;

export type OptionType = typeof OptionType[keyof typeof OptionType];
export type Origin = {
  auditable: Auditable;
  custom: Scalars['Boolean'];
  id: Scalars['ID'];
  name: OriginName;
  ota: Scalars['Boolean'];
  pms: Scalars['Boolean'];
  tenantId?: Maybe<Scalars['ID']>;
};

export type OriginInput = {
  name: OriginName;
  ota: Scalars['Boolean'];
  pms: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

/** L'origine della prenotazione contiene dei dati di default e potrà poi essere customizzata per tenant e property */
export const OriginName = {
  IBE: 'IBE',
  OTA: 'OTA',
  PMS: 'PMS',
  QUOTATION: 'QUOTATION'
} as const;

export type OriginName = typeof OriginName[keyof typeof OriginName];
export type OriginQueryFilter = {
  id?: InputMaybe<IDFilter>;
  name?: InputMaybe<OriginName>;
  ota?: InputMaybe<Scalars['Boolean']>;
  pms?: InputMaybe<Scalars['Boolean']>;
  tenantId: IDFilter;
};

export type OriginStatisticOutput = {
  amount: Scalars['Float'];
  label: Scalars['String'];
};

export type OutboxEvent = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  metadata?: Maybe<OutboxEventMetadata>;
  payload: Scalars['JSON'];
  queue: Scalars['String'];
};

export type OutboxEventMetadata = {
  correlationId?: Maybe<Scalars['String']>;
  operationName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export const OvbResolveType = {
  ALLOW: 'ALLOW',
  EQUIVALENCE: 'EQUIVALENCE',
  ERROR: 'ERROR'
} as const;

export type OvbResolveType = typeof OvbResolveType[keyof typeof OvbResolveType];
export type OverbookingResult = {
  date?: Maybe<Scalars['Date']>;
  resourceTypeId?: Maybe<Scalars['String']>;
};

/** PAID IN FULL */
export type PaidInFullDocumentInput = {
  cashDeskId?: InputMaybe<Scalars['ID']>;
  customerId: Scalars['ID'];
  draft: Scalars['Boolean'];
  paymentActiveId: Scalars['ID'];
  payments: Array<PaidInFullDocumentPaymentDetailInput>;
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type PaidInFullDocumentPaymentDetailInput = {
  amount: Scalars['Int'];
  referenceDocumentId: Scalars['ID'];
};

export type PassersByBill = {
  _id: Scalars['ID'];
  creationDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<PassersByBillDocument>;
  open?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<PassersByBillOwner>;
  productionLength?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PassersByBillDocument = {
  _id?: Maybe<Scalars['ID']>;
  fiscalType?: Maybe<FiscalType>;
  numberExtended?: Maybe<Scalars['String']>;
};

export type PassersByBillOwner = {
  _id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PayAndConfirmQuotation = {
  id: Scalars['ID'];
  link2Pay?: Maybe<Link2PayOutput>;
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

/** PaymentActive sono gli incassi e sono persoanlizzati per Tenant ed eventualmente per property */
export type PaymentActive = {
  auditable: Auditable;
  id: Scalars['ID'];
  /** Codice per exportazione Contabile */
  managementCode?: Maybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentType: PaymentType;
  paymentTypeId: Scalars['ID'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type PaymentActiveInput = {
  isActive: Scalars['Boolean'];
  managementCode?: InputMaybe<Scalars['String']>;
  name: Scalars['LocalizedString'];
  paymentTypeId: Scalars['ID'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type PaymentActiveQueryFilter = {
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/**
 * Entità che mantiene i gateway gestiti dalla struttura
 * Per ogni gateway è possibile specificare quali metodi supporta
 * All'interno di configuration sono presenti i dati
 * necessari per attivare il sistema, apikey, secret etc.
 */
export type PaymentGateway = {
  auditable: Auditable;
  configuration?: Maybe<Scalars['EncryptedString']>;
  id: Scalars['ID'];
  managedMethodTypes?: Maybe<Array<PaymentMethodType>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentGatewayType;
};

export type PaymentGatewayInput = {
  configuration?: InputMaybe<Scalars['EncryptedString']>;
  managedMethodTypes?: InputMaybe<Array<PaymentMethodType>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentGatewayType;
};

export type PaymentGatewayQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const PaymentGatewayType = {
  PAYPAL: 'PAYPAL',
  TSPAY: 'TSPAY'
} as const;

export type PaymentGatewayType = typeof PaymentGatewayType[keyof typeof PaymentGatewayType];
export type PaymentInput = {
  amount: Scalars['Int'];
  currency: Scalars['Currency'];
  description: Scalars['String'];
};

export type PaymentLinkForUnpaidDocumentsInput = {
  paidInFullDocumentId: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

/**
 * I metodi di pagamento sono definiti per struttura e possono essere collegati ad un Gateway
 * Nel caso in cui il tipo sia diverso da OFFLINE il Gateway è obbligatorio
 */
export type PaymentMethod = {
  /** Potrebbe essere necessario aggiungere i dati dell'iban o altro */
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  auditable: Auditable;
  gateway?: Maybe<PaymentGateway>;
  /** Gateway di pagamento obbligatorio se methodType in options non OFFLINE */
  gatewayId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  paymentActive?: Maybe<PaymentActive>;
  /**
   * Per i processi automatici generati dalle transazionei delle carte di credito è necessario specificare la modalità di pagamento
   * associata; questo ci peremtte di generare i documenti con la modalità corretta.
   */
  paymentActiveId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentMethodType;
};

export type PaymentMethodInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  gatewayId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: PaymentMethodType;
};

export type PaymentMethodQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantId: IDFilter;
};

export const PaymentMethodType = {
  BANKTRANSFER: 'BANKTRANSFER',
  CREDITCARD: 'CREDITCARD',
  OFFLINE: 'OFFLINE'
} as const;

export type PaymentMethodType = typeof PaymentMethodType[keyof typeof PaymentMethodType];
export type PaymentRule = {
  guaranteedCreditCard: Scalars['Boolean'];
  /**
   * E' possibile richiedere anche il pagmento in forma dilazionata, per ogni rata si può specificare i giorni dall'arrivo e la percentuale richiesta
   * Il totale sui calcolare le percentuali deriva dalla scelta fatta in guaranteedPrice, se totale prenotazione il pagamento avviene
   */
  installments?: Maybe<Array<Installment>>;
  paymentsAcceptedId?: Maybe<Array<Scalars['ID']>>;
  percentage?: Maybe<Scalars['Float']>;
  type: GuaranteeType;
};

export type PaymentRuleBaseInput = {
  guaranteedCreditCard: Scalars['Boolean'];
  percentage?: InputMaybe<Scalars['Float']>;
  type: GuaranteeType;
};

export type PaymentRuleInput = {
  guaranteedCreditCard: Scalars['Boolean'];
  installments?: InputMaybe<Array<InstallmentInput>>;
  paymentsAcceptedId?: InputMaybe<Array<Scalars['ID']>>;
  percentage?: InputMaybe<Scalars['Float']>;
  type: GuaranteeType;
};

/**
 * PaymentType sono i tipi di incasso che identificano i PaymentActive
 * Questa entità predefinita ed inserita tramite Migration, ci permette di avere le impostazioni già pronte per gestire FEL e SCEL
 * I tipi negativi ci permettono di gestire movimenti di uscita di cassa
 */
export type PaymentType = {
  auditable: Auditable;
  code: PaymentTypeCode;
  codePa?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  paymentTypeElectronicReceipt: PaymentTypeElectronicReceipt;
  sign: AlgebraicSign;
};

export const PaymentTypeCode = {
  BALANCE_UNPAID: 'BALANCE_UNPAID',
  BANKCHECK: 'BANKCHECK',
  BANKTRANSFER: 'BANKTRANSFER',
  CASH: 'CASH',
  CHANGE: 'CHANGE',
  CREDITCARD: 'CREDITCARD',
  DEPOSIT: 'DEPOSIT',
  RETURN_DEPOSIT: 'RETURN_DEPOSIT',
  RETURN_SPLITPAYMENT: 'RETURN_SPLITPAYMENT',
  SPLITPAYMENT: 'SPLITPAYMENT',
  UNPAID: 'UNPAID'
} as const;

export type PaymentTypeCode = typeof PaymentTypeCode[keyof typeof PaymentTypeCode];
export type PaymentTypeCodeFilter = {
  eq?: InputMaybe<PaymentTypeCode>;
  in?: InputMaybe<Array<PaymentTypeCode>>;
  ne?: InputMaybe<PaymentTypeCode>;
  nin?: InputMaybe<Array<PaymentTypeCode>>;
};

export const PaymentTypeElectronicReceipt = {
  BANKCHECK: 'BANKCHECK',
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH: 'CASH',
  CREDITCARD: 'CREDITCARD',
  UNPAID: 'UNPAID'
} as const;

export type PaymentTypeElectronicReceipt = typeof PaymentTypeElectronicReceipt[keyof typeof PaymentTypeElectronicReceipt];
export type PaymentTypeQueryFilter = {
  code?: InputMaybe<PaymentTypeCodeFilter>;
  sign?: InputMaybe<AlgebraicSign>;
};

/** Permessi applicazione */
export const Permissions = {
  BASE: 'BASE',
  BOOKING: 'BOOKING',
  CONFIG: 'CONFIG',
  HOUSEKEEPER: 'HOUSEKEEPER',
  POS: 'POS',
  STATISTICS: 'STATISTICS'
} as const;

export type Permissions = typeof Permissions[keyof typeof Permissions];
/** Tipo che indentifica i dati delle persone (la cittadinanza è birthAddress.country) */
export type Person = {
  birthAddress?: Maybe<Address>;
  birthDate?: Maybe<Scalars['Date']>;
  gender?: Maybe<GenderType>;
  identificationDocument?: Maybe<PersonIdentificationDocument>;
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

/** Tipo che raccoglie le proprietà dei documenti di identità registarti sul customer */
export type PersonIdentificationDocument = {
  city?: Maybe<Scalars['CapitalizedString']>;
  country: Country;
  countryId: Scalars['ID'];
  document: IdentificationDocument;
  documentId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  number: Scalars['UppercaseString'];
  releaseBy?: Maybe<Scalars['String']>;
};

export type PersonIdentificationDocumentInput = {
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['ID'];
  documentId: Scalars['ID'];
  expirationDate: Scalars['Date'];
  number: Scalars['String'];
  releaseBy?: InputMaybe<Scalars['String']>;
};

export type PersonInput = {
  birthAddress?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<GenderType>;
  identificationDocument?: InputMaybe<PersonIdentificationDocumentInput>;
  nationalityId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PersonSortInput = {
  birthDate?: InputMaybe<Sort>;
};

/** Contatti telefonici */
export type PhoneContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: PhoneContactType;
  value: Scalars['String'];
};

export type PhoneContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: PhoneContactType;
  value: Scalars['String'];
};

/** Tipi di Telefono */
export const PhoneContactType = {
  FAX: 'FAX',
  MAIN: 'MAIN',
  MOBILE: 'MOBILE',
  OFFICE: 'OFFICE',
  OTHER: 'OTHER',
  PRIVATE: 'PRIVATE'
} as const;

export type PhoneContactType = typeof PhoneContactType[keyof typeof PhoneContactType];
/**  PICKUP  */
export type PickupFilter = {
  daysBefore: Scalars['Int'];
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type PickupOutputByResourceType = {
  daysBefore: Array<Scalars['Float']>;
  id: Scalars['ID'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type Plan = {
  billingFrequency?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discountPercentage?: Maybe<Scalars['Float']>;
  footerFeatures?: Maybe<Array<FooterFeature>>;
  footerFooterFeatures?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  infoLabel?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type Plant = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export const PmsType = {
  NUCONGA: 'NUCONGA',
  WEBHOTEL: 'WEBHOTEL'
} as const;

export type PmsType = typeof PmsType[keyof typeof PmsType];
/** Rappresenta un Punto Vendita. */
export type PointOfSale = {
  auditable: Auditable;
  /** La configurazione del Punto Vendita */
  configuration: PointOfSaleConfiguration;
  description: Scalars['String'];
  /** Codice identificativo usato dal sistema esterno (per CassaInCloud è il SalesPointId). */
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Indica se è il Punto Vendita di default della struttura.     Il PV di default non è collegato a nessun PV esterno e viene utilizzato esclusivamente
   * per contenere le configurazioni di default che valgono per tutti i PV della struttura.
   */
  isDefault: Scalars['Boolean'];
  /** La mappatura dei codici esterni del Punto Vendita. */
  mappings: PointOfSaleMappings;
  name: Scalars['String'];
  property: Property;
  propertyId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

/** Rappresenta una Comanda ricevuta da un Punto Vendita esterno. */
export type PointOfSaleBill = {
  auditable: Auditable;
  /** Identificativo unico della comanda. */
  billId: Scalars['String'];
  /**
   * Chiave univoca opzionale basata sull'identificativo dell'ordine, se l'ordine è presente.     La chiave è costruita secondo il seguente pattern:
   * - "R<roomId>-<orderId>", qualdo la comanda è addebitata in camera
   * - "P<passerbyId>-<orderId>", when la comanda è addebitata in un conto passanti
   */
  billOrderKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Flag che indica se la Comanda è stata annullata. */
  isCanceled: Scalars['Boolean'];
  /** Il payload completo della Comanda. */
  payload: Scalars['String'];
  /** Insieme delle righe di produzione generate da questa Comanda. */
  productions: Array<PointOfSaleBillProduction>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Associa una riga di produzione con i dati di origine della Comanda che l'hanno generata. */
export type PointOfSaleBillProduction = {
  production: Production;
  /** Id della riga di produzione. */
  productionId: Scalars['ID'];
  /** I dati di origine della riga di produzione. */
  source: PointOfSaleBillProductionSource;
};

/** Contiene i dati di origine della riga di produzione. */
export type PointOfSaleBillProductionSource = {
  /** L'origine della transcodifica del ChargeCategory. */
  chargeCategoryTranscodeSource?: Maybe<ChargeCategoryTranscodeSource>;
  /** L'elenco degli articoli. */
  products: Array<PointOfSaleBillProductionSourceProduct>;
};

export type PointOfSaleBillProductionSourceProduct = {
  amount: Scalars['Int'];
  description: Scalars['String'];
  /** L'identificativo esterno dell'articolo. */
  externalProductId: Scalars['String'];
  quantity: Scalars['Int'];
};

/** La configurazione del Punto Vendita */
export type PointOfSaleConfiguration = {
  /** Indica se è possibile aggiungere addebiti a camere già in checkout. */
  roomsOutChargeable?: Maybe<Scalars['Boolean']>;
};

export type PointOfSaleConfigurationInput = {
  /** Indica se è possibile aggiungere addebiti a camere già in checkout. */
  roomsOutChargeable?: InputMaybe<Scalars['Boolean']>;
};

export type PointOfSaleInput = {
  /** La configurazione del Punto Vendita */
  configuration: PointOfSaleConfigurationInput;
  description: Scalars['String'];
  /** La mappatura dei codici esterni del Punto Vendita. */
  mappings: PointOfSaleMappingsInput;
  name: Scalars['String'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Contiene le mappature dei codici esterni del Punto Vendita, distinte per tipo entità.   Se la mappatura per un dato codice non esiste (cioè il codice non viene trovato), la transcodifica viene eseguita nuovamente utilizzando la mappatura del Punto Vendita di default della struttura. */
export type PointOfSaleMappings = {
  /** L'insieme delle voci di mappatura degli addebiti. */
  chargeCategories: Array<PointOfSaleMappingsChargeCategoryEntry>;
};

/** Rappresenta la voce di mappatura di un addebito. */
export type PointOfSaleMappingsChargeCategoryEntry = {
  /** Codice dell'addebito. */
  chargeCategoryId: Scalars['String'];
  /**
   * Codice esterno dell'addebito. Rappresenta la chiave di ricerca.     Per un Punto Vendita CiC è formato dalla concatenazione di:
   * - Id Reparto CiC
   * - Turno pasto
   * - Id Modalità di Vendita CiC
   */
  externalCode: Scalars['String'];
};

export type PointOfSaleMappingsChargeCategoryEntryInput = {
  /** Codice dell'addebito. */
  chargeCategoryId: Scalars['String'];
  /**
   * Codice esterno dell'addebito. Rappresenta la chiave di ricerca.     Per un Punto Vendita CiC è formato dalla concatenazione di:
   * - Id Reparto CiC
   * - Id Turno pasto
   * - Id Modalità di Vendita CiC
   */
  externalCode: Scalars['String'];
};

export type PointOfSaleMappingsInput = {
  /** L'insieme delle voci di mappatura degli addebiti. */
  chargeCategories: Array<PointOfSaleMappingsChargeCategoryEntryInput>;
};

/** Rappresenta un turno per i pasti. */
export type PointOfSaleMealShift = {
  auditable: Auditable;
  /** Descrizione del turno (pranzo, cena, ...) */
  description: Scalars['String'];
  /** Ora di inizio turno, nel formato HH:MM */
  fromTime: Scalars['String'];
  id: Scalars['ID'];
  /** Eventuale struttura a cui si riferisce il turno. Se mancante, il turno è valido per tutti le strutture del tenant. */
  propertyId?: Maybe<Scalars['ID']>;
  /** Eventuale tenant a cui si riferisce il turno. Se mancante, il turno è valido per tutti i tenant. */
  tenantId?: Maybe<Scalars['ID']>;
  /** Ora di fine turno, nel formato HH:MM */
  toTime: Scalars['String'];
};

export type PointOfSaleMealShiftInput = {
  /** Descrizione del turno (pranzo, cena, ...) */
  description: Scalars['String'];
  /** Ora di inizio turno, nel formato HH:MM */
  fromTime: Scalars['String'];
  /** Eventuale struttura a cui si riferisce il turno. Se mancante, il turno è valido per tutti le strutture del tenant. */
  propertyId?: InputMaybe<Scalars['ID']>;
  /** Il tenant a cui si riferisce il turno. */
  tenantId: Scalars['ID'];
  /** Ora di fine turno, nel formato HH:MM */
  toTime: Scalars['String'];
};

export type PointOfSaleMealShiftQueryFilter = {
  /** Esclude i turni di default (cioè non legati ad alcun tenant). */
  excludeDefaults?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantID: IDFilter;
};

export type PointOfSaleQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  tenantID: IDFilter;
};

/** Entità che rappresenta il portale, al'interno sono contenute le informazioni necessarie per poterlo utilizzare */
export type Portal = {
  auditable: Auditable;
  commercialName: Scalars['String'];
  id: Scalars['ID'];
  /** Indica l'istante in cui è stata eseguita l'ultima operazione di download delle prenotazioni. */
  lastDownload?: Maybe<Scalars['DateTime']>;
  mailContacts?: Maybe<Array<MailContact>>;
  name: PortalName;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  /** Se attivo indica che il portale è collegato tramite Figaro */
  throughFigaro?: Maybe<Array<Scalars['Int']>>;
  urlBackEnd?: Maybe<Scalars['String']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PortalInfo = {
  /** La commissione destinata al portale. Valore percentuale tra 0.0 e 1.0. */
  commission?: Maybe<Scalars['Float']>;
  /** L'importo della commissione destinata al portale. */
  commissionAmount?: Maybe<Scalars['Int']>;
  createdOn: Scalars['DateTime'];
  externalId: Scalars['String'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  payment?: Maybe<PortalPayment>;
  portal: Portal;
  /** Codice di esonero da utilizzare se il portale ha fatto versato l'imposta al comune per conto della struttura */
  portalCityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  portalId: Scalars['ID'];
  /** L'origine della prenotazione nel network del portale. Ad esempio, per Expedia può essere: Expedia, Hotels.com, Travelocity, etc. */
  source?: Maybe<Scalars['String']>;
};

export const PortalName = {
  AGODA: 'AGODA',
  AIRBNB: 'AIRBNB',
  BEDBRKIT: 'BEDBRKIT',
  BOOKING: 'BOOKING',
  BOOKINGCLICK: 'BOOKINGCLICK',
  CITYBREAK: 'CITYBREAK',
  CRS: 'CRS',
  CTRIP: 'CTRIP',
  EBOOKERS: 'EBOOKERS',
  ERMES: 'ERMES',
  EXPEDIA: 'EXPEDIA',
  FERATEL: 'FERATEL',
  FIGARO: 'FIGARO',
  GOOGLEHOTELS: 'GOOGLEHOTELS',
  HOTELBEDS: 'HOTELBEDS',
  HOTELEASY: 'HOTELEASY',
  HOTUSA: 'HOTUSA',
  HRS: 'HRS',
  ITALCAMEL: 'ITALCAMEL',
  JUMBO: 'JUMBO',
  MRPRENO: 'MRPRENO',
  ODIGEO: 'ODIGEO',
  OPENTOUR: 'OPENTOUR',
  SIMPLEBOOKING: 'SIMPLEBOOKING',
  SUNHOTELS: 'SUNHOTELS',
  TABLET: 'TABLET',
  TRAVCO: 'TRAVCO',
  VERTICAL: 'VERTICAL',
  VISIONI: 'VISIONI',
  WEBHOTELIER: 'WEBHOTELIER'
} as const;

export type PortalName = typeof PortalName[keyof typeof PortalName];
/** Definizione delle opportunity */
export type PortalOpportunity = {
  code?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Contiene informazioni relative al pagamento (importo, metodo, eventuale carta, ...). */
export type PortalPayment = {
  /** Importo da addebitare sulla carta di pagamento o da richiedere al portale. */
  amount?: Maybe<Scalars['Int']>;
  /** Il modello di gestione delle commissioni, cioè se sono incluse o meno nell'importo del pagamento. */
  commissionModel?: Maybe<PortalPaymentCommissionModel>;
  /** la valuta del pagamento. */
  currency?: Maybe<Scalars['Currency']>;
  /** I dettagli della eventuale carta di pagamento. */
  paymentCard?: Maybe<PortalPaymentCard>;
  /** Il metodo di pagamento. */
  paymentMethod?: Maybe<PortalPaymentMethod>;
};

/** Contiene i dettagli della carta di pagamento. */
export type PortalPaymentCard = {
  /** When the PaymentMethod is VirtualCard, it is the date and time after which the virtual card can be charged. */
  cardActivationDate?: Maybe<Scalars['DateTime']>;
  /** The token associated to the card data stored in the card vault. */
  cardToken: Scalars['String'];
  /** Indicates the card type. For example: 'Credit Card' */
  cardType?: Maybe<Scalars['String']>;
};

/** Indica il modello di gestione delle commissioni, cioè se sono incluse o meno nell'importo del pagamento. */
export const PortalPaymentCommissionModel = {
  /** Le commissioni sono incluse. */
  GROSS: 'GROSS',
  /** Le commissioni non sono incluse. */
  NET: 'NET'
} as const;

export type PortalPaymentCommissionModel = typeof PortalPaymentCommissionModel[keyof typeof PortalPaymentCommissionModel];
/** Indica il metodo di pagamento. */
export const PortalPaymentMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH: 'CASH',
  CUSTOMER_CREDIT_CARD: 'CUSTOMER_CREDIT_CARD',
  NONE: 'NONE',
  VIRTUAL_CARD: 'VIRTUAL_CARD'
} as const;

export type PortalPaymentMethod = typeof PortalPaymentMethod[keyof typeof PortalPaymentMethod];
export type PortalQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

/** Rate del channel */
export type PortalRate = {
  derived: Scalars['Boolean'];
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: Maybe<Scalars['String']>;
  /** Numero persone da prendere di riferimento, anche questo attivo solo canali particolari */
  person?: Maybe<Scalars['Int']>;
  /** Codice che viene restituito dal canale (nel caso booking.com può essere Standard, OBP, RLO, LOS) */
  portalPricingType?: Maybe<Scalars['String']>;
  rateCodePortal: Scalars['String'];
  rateNamePortal?: Maybe<Scalars['String']>;
  /** Codici delle tipologie di room legate alla tariffa */
  resourceTypeCodes?: Maybe<Array<Scalars['String']>>;
};

export type PortalRateInput = {
  derived: Scalars['Boolean'];
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: InputMaybe<Scalars['String']>;
  /** Numero persone da prendere di riferimento, anche questo attivo solo canali particolari */
  person?: InputMaybe<Scalars['Int']>;
  /** Codice che viene restituito dal canale (nel caso booking.com può essere Standard, OBP, RLO, LOS) */
  portalPricingType?: InputMaybe<Scalars['String']>;
  rateCodePortal: Scalars['String'];
  rateNamePortal?: InputMaybe<Scalars['String']>;
  /** Codici delle tipologie di room legate alla tariffa */
  resourceTypeCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type PortalResourceType = {
  /** Il numero di adulti permette di sapere su quale occupazione il sistema scrive e quale tariffa del PMS viene presa */
  adults: Scalars['Int'];
  child?: Maybe<Scalars['Int']>;
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: Maybe<Scalars['String']>;
  resourceTypeCodePortal: Scalars['String'];
  resourceTypeNamePortal?: Maybe<Scalars['String']>;
};

export type PortalResourceTypeInput = {
  /** Il numero di adulti permette di sapere su quale occupazione il sistema scrive e quale tariffa del PMS viene presa */
  adults: Scalars['Int'];
  child?: InputMaybe<Scalars['Int']>;
  /** Nel campo info possiamo salvare eventuali dati aggiuntivi */
  info?: InputMaybe<Scalars['String']>;
  resourceTypeCodePortal: Scalars['String'];
  resourceTypeNamePortal?: InputMaybe<Scalars['String']>;
};

/**  CHANNEL / PORTAL  */
export type PortalStatisticFilter = {
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type PortalStatisticOutputByResourceType = {
  date: Scalars['Date'];
  id: Scalars['ID'];
  portal?: Maybe<Portal>;
  portalId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

/**
 * Tipo che ci permette di definire variazioni sui singoli portali
 * E' possibile chiudere la vendita per singolo portale e variare la disponibilità per singola risorsa, sempre come variazione positiva o negativa
 * se availabilityChanges = -2 indica al sistema che dovrà mandare al portale due risorse in meno rispetto all'availability generale.
 */
export type PortalVariation = {
  availabilityChanges: Scalars['Int'];
  portal: Portal;
  portalId: Scalars['ID'];
  stopSell?: Maybe<Scalars['Boolean']>;
};

/** La posizione serve per dividere le risorse, in particolare sulle stampe o in visualizzazioni tipo Tableau. */
export type Position = {
  auditable: Auditable;
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PositionInput = {
  name: Scalars['String'];
  order: Scalars['Int'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PositionQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Entità embedded che contiene le modifiche a un arrangiamento. */
export type PriceCalendarChargeCategoryChange = {
  /** Id dell'arrangiamento */
  chargeCategoryId: Scalars['ID'];
  /** Arrangiamento aperto o chiuso */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Modifiche ai prezzi per numero di persone */
  pricePerOccupationChanges?: InputMaybe<Array<PriceCalendarPricePerOccupationChange>>;
};

/**
 * Contiene i prezzi di un singolo giorno del calendario prezzi per i vari tipi risorsa.
 * I dati provengono da DailyAvailability insieme all'eventuale DailyRate definito per il giorno.
 */
export type PriceCalendarDay = {
  availabilities: Array<PriceCalendarDayAvailability>;
  day: Scalars['Date'];
  id: Scalars['ID'];
  rates: Array<PriceCalendarDayRate>;
};

/** Embedded entity che contiene i dati provenienti da DailyAvailability */
export type PriceCalendarDayAvailability = {
  availability: Scalars['Int'];
  dailyAvailabilityId: Scalars['ID'];
  inventory: Scalars['Int'];
  onlineLimit?: Maybe<Scalars['Int']>;
  portalVariations?: Maybe<Array<PortalVariation>>;
  reservedResources: Array<ReservedResource>;
  reservedResourcesId: Array<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resourcesId: Array<Scalars['ID']>;
  stopSellOTA: Scalars['Boolean'];
};

/** Entità embedded che contiene le modifiche al calendario prezzi per un singolo giorno. */
export type PriceCalendarDayChange = {
  /** Il giorno a cui si riferiscono le modifiche. */
  day: Scalars['Date'];
  /** Le modifiche relative ai tipi risorsa */
  resourceTypeChanges: Array<PriceCalendarResourceTypeChange>;
};

/** Embedded entity che contiene i dati provenienti da DailyRate */
export type PriceCalendarDayRate = {
  bookingPolicy?: Maybe<BookingPolicy>;
  bookingPolicyId?: Maybe<Scalars['ID']>;
  chargesRate?: Maybe<Array<ResourceChargeRate>>;
  closeChargesCategories?: Maybe<Array<ChargeCategory>>;
  /** Arrangiamenti chiusi rispetto alla tariffa, ad esempio in inverno non c'è il ristorante o è chiuso per problemi */
  closeChargesCategoryId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  dailyRateId: Scalars['ID'];
  rate: Rate;
  rateId: Scalars['ID'];
  stopSellResourcesType?: Maybe<Array<ResourceType>>;
  /** Risorse bloccate alla vendita sul giorno, vanno in ovveride alla tariffa */
  stopSellResourcesTypeId?: Maybe<Array<Scalars['ID']>>;
};

/** Filtro per recuperare i dati del calendario prezzi. */
export type PriceCalendarFilter = {
  endDate: Scalars['Date'];
  propertyId: IDFilter;
  startDate: Scalars['Date'];
  tenantId: IDFilter;
};

/** Input per aggiornare il calendario prezzi. Le proprietà non valorizzate non saranno modificate. */
export type PriceCalendarInput = {
  /** L'elenco delle modifiche per giorno */
  changes: Array<PriceCalendarDayChange>;
  /** La valuta dei prezzi */
  currency: Scalars['Currency'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/** Entità embedded che contiene il prezzo di un arrangiamento per occupazione. */
export type PriceCalendarPricePerOccupationChange = {
  /** Il numero di persone */
  occupation: Scalars['Int'];
  /** Prezzo relativo al numero di persone */
  price: Scalars['Int'];
};

/** Input per aggiornare un range di giorni del calendario prezzi. Le proprietà non valorizzate non saranno modificate. */
export type PriceCalendarRangeInput = {
  /** La valuta dei prezzi */
  currency: Scalars['Currency'];
  /** L'ultimo giorno del range da modificare. */
  endDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  /** Le modifiche relative ai tipi risorsa */
  resourceTypeChanges: Array<PriceCalendarResourceTypeChange>;
  /** Il primo giorno del range da modificare. */
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  /**
   * Valore contenente i giorni della settimana da modificare.
   * Stringa di 7 bit dove il primo bit rappresenta la domenica. Se un bit vale 1, il giorno corrispondente è selezionato.
   * Esempio: '1111111' -> tutti i giorni;  '0001000' -> solo Mercoledì;  '1000001' -> solo weekend;
   */
  weekdayFlags: Scalars['String'];
};

/** Entità embedded che contiene le modifiche alla tariffa. */
export type PriceCalendarRateChange = {
  /** Id della politica di booking */
  bookingPolicyId?: InputMaybe<Scalars['ID']>;
  /** Modifiche agli arrangiamenti */
  chargeCategoryChanges?: InputMaybe<Array<PriceCalendarChargeCategoryChange>>;
  /** Giorno Chiuso in arrivo */
  closedToArrival?: InputMaybe<Scalars['Boolean']>;
  /** Giorno Chiuso in partenza */
  closedToDeparture?: InputMaybe<Scalars['Boolean']>;
  /** Giorni minimi di soggiorno */
  minStay?: InputMaybe<Scalars['Int']>;
  /** Il tipo di prezzo. Obbligatorio se standardPrice o minStay o chargeCategoryChanges[].pricePerOccupation[] è specificato. */
  priceType?: InputMaybe<PriceType>;
  /** Id della tariffa */
  rateId: Scalars['ID'];
  /** Id dell'addebito standard. Obbligatorio se standardPrice o minStay è specificato. */
  standardChargeCategoryId?: InputMaybe<Scalars['ID']>;
  /** Prezzo standard */
  standardPrice?: InputMaybe<Scalars['Int']>;
  /** Indica se la tipologia risorsa deve essere messa in stop-sell */
  stopSell?: InputMaybe<Scalars['Boolean']>;
};

/** Entità embedded che contiene le modifiche al calendario prezzi relative a un tipo risorsa. */
export type PriceCalendarResourceTypeChange = {
  /** Indica il limite di alloggi da mettere in vendita sulle OTA, se -1 lo elimina */
  onlineLimit?: InputMaybe<Scalars['Int']>;
  /** Le modifiche alla tariffa */
  rate?: InputMaybe<PriceCalendarRateChange>;
  /** Id della tipologia risorsa a cui si applicano le modifiche */
  resourceTypeId: Scalars['ID'];
  /** Indica se la tipologia risorsa deve essere messa in stop-sell per i portali online */
  stopSellOTA?: InputMaybe<Scalars['Boolean']>;
};

export const PriceModel = {
  DERIVED: 'DERIVED',
  STATIC: 'STATIC'
} as const;

export type PriceModel = typeof PriceModel[keyof typeof PriceModel];
/** Tipo che permette di associare un prezzo ad un occupazione */
export type PriceOccupation = {
  occupation: Scalars['Int'];
  price: Scalars['Int'];
};

/** Tipo che permette di associare un prezzo ad un occupazione */
export type PriceOccupationInput = {
  occupation: Scalars['Int'];
  price: Scalars['Int'];
};

export type PriceRange = {
  name: Scalars['String'];
  resourceType: Array<ResourceTypePriceRange>;
};

export type PriceRangeInput = {
  name: Scalars['String'];
  resourceType: Array<ResourceTypePriceRangeInput>;
};

/** Rate Query Embedded Type */
export type PriceRq = {
  bookable: Scalars['Boolean'];
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  dailyPrice: Array<DailyPriceRq>;
  rateRestriction?: Maybe<RateRestriction>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  restrictionsNotMet?: Maybe<Array<RateRestriction>>;
};

export const PriceType = {
  PERSON: 'PERSON',
  ROOM: 'ROOM'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];
export type PricesPage = {
  cards?: Maybe<Array<Card>>;
  description: Scalars['String'];
  descriptionRows?: Maybe<Array<DescriptionRow>>;
  url: Scalars['String'];
};

export const PricingType = {
  PER_NIGHT: 'PER_NIGHT',
  PER_PERSON: 'PER_PERSON',
  PER_PERSON_PER_NIGHT: 'PER_PERSON_PER_NIGHT',
  PER_STAY: 'PER_STAY'
} as const;

export type PricingType = typeof PricingType[keyof typeof PricingType];
export type Privacy = {
  dataThirdPartyConsent?: Maybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: Maybe<Scalars['Date']>;
  healthDataConsent?: Maybe<Scalars['Boolean']>;
  healthDataConsentDate?: Maybe<Scalars['Date']>;
  log?: Maybe<RequestData>;
  managementConsent?: Maybe<Scalars['Boolean']>;
  managementConsentDate?: Maybe<Scalars['Date']>;
  marketingConsent?: Maybe<Scalars['Boolean']>;
  marketingConsentDate?: Maybe<Scalars['Date']>;
  profiledMarketingConsent?: Maybe<Scalars['Boolean']>;
  profiledMarketingConsentDate?: Maybe<Scalars['Date']>;
};

export type PrivacyInput = {
  dataThirdPartyConsent?: InputMaybe<Scalars['Boolean']>;
  dataThirdPartyConsentDate?: InputMaybe<Scalars['Date']>;
  healthDataConsent?: InputMaybe<Scalars['Boolean']>;
  healthDataConsentDate?: InputMaybe<Scalars['Date']>;
  managementConsent?: InputMaybe<Scalars['Boolean']>;
  managementConsentDate?: InputMaybe<Scalars['Date']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  marketingConsentDate?: InputMaybe<Scalars['Date']>;
  profiledMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  profiledMarketingConsentDate?: InputMaybe<Scalars['Date']>;
};

/** Configurazione del testo della Informativa sul trattamento dei dati personali. */
export type PrivacySettings = {
  companyAddress?: Maybe<Scalars['String']>;
  /** Email di contatto per le richieste privacy */
  companyEmail?: Maybe<Scalars['String']>;
  companyFiscalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyVat?: Maybe<Scalars['String']>;
  /** Durata del periodo di conservazione dei dati, in mesi. */
  dataRetentionMonths: Scalars['Int'];
  /** Se vale true, il testo è gestito manualmente dall'operatore; altrimenti viene generato dalla composizione delle sezioni abilitate. */
  isCustomText: Scalars['Boolean'];
  /** Il testo dell'Informativa. */
  text: Scalars['LocalizedString'];
  useDirectMarketing: Scalars['Boolean'];
  useHealthData: Scalars['Boolean'];
  useProfiledMarketing: Scalars['Boolean'];
  useThirdPartyMarketing: Scalars['Boolean'];
};

export type PrivacySettingsInput = {
  companyAddress?: InputMaybe<Scalars['String']>;
  /** Email di contatto per le richieste privacy */
  companyEmail?: InputMaybe<Scalars['String']>;
  companyFiscalCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyVat?: InputMaybe<Scalars['String']>;
  /** Durata del periodo di conservazione dei dati, in mesi. */
  dataRetentionMonths: Scalars['Int'];
  /** Se vale true, il testo è gestito manualmente dall'operatore; altrimenti viene generato dalla composizione delle sezioni abilitate. */
  isCustomText: Scalars['Boolean'];
  /** Il testo dell'Informativa. */
  text: Scalars['LocalizedString'];
  useDirectMarketing: Scalars['Boolean'];
  useHealthData: Scalars['Boolean'];
  useProfiledMarketing: Scalars['Boolean'];
  useThirdPartyMarketing: Scalars['Boolean'];
};

export type Product = {
  amount: Scalars['Int'];
  auditable: Auditable;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type ProductInput = {
  amount: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ProductQueryFilter = {
  chargeCategoryId?: InputMaybe<IDFilter>;
  id?: InputMaybe<IDFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** L'entità produzione contiene tutti gli addebiti generati */
export type Production = {
  additionalService?: Maybe<AdditionalService>;
  additionalServiceId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  auditable: Auditable;
  bills?: Maybe<Array<ProductionAssigned>>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  cityTax?: Maybe<ProductionCityTax>;
  currency: Scalars['Currency'];
  /** Data di riferimento per la produzione */
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  /** Data hotel di inserimento (è valorizzata automaticamente) */
  hotelDate: Scalars['Date'];
  id: Scalars['ID'];
  manual: Scalars['Boolean'];
  propertyId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  total: Scalars['Int'];
  vat: Vat;
  vatId: Scalars['ID'];
};

export type ProductionAmount = {
  amountAfterTax: Scalars['Int'];
  amountBeforeTax: Scalars['Int'];
};

/** L'entità ProductionAssigned ci permette di avere sul conto l'associazione con la produzione e la quota parte. */
export type ProductionAssigned = {
  bill: Bill;
  billId: Scalars['ID'];
  id: Scalars['ID'];
  production: Production;
  productionId: Scalars['ID'];
  quota: Scalars['Float'];
};

export type ProductionAssignedInput = {
  production: ProductionBillInput;
  productionId: Scalars['ID'];
};

export type ProductionBillInput = {
  amount: Scalars['Float'];
  chargeCategoryId: Scalars['ID'];
  cityTax?: InputMaybe<ProductionCityTaxInput>;
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  manual: Scalars['Boolean'];
  quantity: Scalars['Int'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type ProductionCheckoutInput = {
  amount: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  productionAssignedId: Scalars['ID'];
};

export type ProductionCityTax = {
  exoneration?: Maybe<CityTaxExonerationCode>;
  guestId?: Maybe<Scalars['ID']>;
};

export type ProductionCityTaxInput = {
  exoneration?: InputMaybe<CityTaxExonerationCode>;
  guestId?: InputMaybe<Scalars['ID']>;
};

export type ProductionInput = {
  additionalServiceId?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
  chargeCategoryId: Scalars['ID'];
  cityTax?: InputMaybe<ProductionCityTaxInput>;
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  total: Scalars['Float'];
  vatId: Scalars['ID'];
};

export type ProductionQueryFilter = {
  propertyId: IDFilter;
  reservedResourceId: IDFilter;
  tenantId: IDFilter;
};

/**
 * Property rappresenta la struttura, deve essere presente almeno una struttura sul tenant.
 * Il Tipo Sub Property serve al nostro cliente per poter dividere le proprie risorse in modo da poter gestire in modo semplice la possibilità
 * di avere delle gestioni separate per PS, Istat, City Tax ed eventualemnte per la parte fiscale
 * Non è un multiproperty, la Property deve essere semrpe creata ed eredità dalla struttura base le impostazioni base.
 */
export type Property = {
  address?: Maybe<Address>;
  auditable: Auditable;
  bookingEngineConfiguration?: Maybe<BookingEngineConfiguration>;
  category?: Maybe<Taxonomy>;
  /** La categoria è relativa al tipo, 3 stelle, 4 stelle, etc etc. PROPERTY_CATEGORY */
  categoryId?: Maybe<Scalars['ID']>;
  checkin?: Maybe<TimeRange>;
  checkout?: Maybe<TimeRange>;
  cityTaxConfiguration?: Maybe<CityTaxConfiguration>;
  classType?: Maybe<Taxonomy>;
  /** La classe di tipologia indica Hotel, Appartamenti, B&B etc PROPERTY_CLASSTYPE */
  classTypeId?: Maybe<Scalars['ID']>;
  dailyClosureConfiguration: DailyClosureConfiguration;
  description?: Maybe<Scalars['LocalizedString']>;
  fiscalCode?: Maybe<Scalars['String']>;
  fiscalConfigurations?: Maybe<Array<FiscalConfiguration>>;
  groups?: Maybe<Array<PropertyGroup>>;
  groupsId?: Maybe<Array<Scalars['ID']>>;
  hoauConfiguration?: Maybe<HoauConfiguration>;
  hotelDate: Scalars['Date'];
  housekeepingConfiguration?: Maybe<HousekeepingConfiguration>;
  ibeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<PropertyImage>>;
  istatConfigurations?: Maybe<Array<IstatConfiguration>>;
  mailContacts?: Maybe<Array<MailContact>>;
  /** Moduli collegati al property e al modulo acquistato */
  modules?: Maybe<Array<Module>>;
  name: Scalars['String'];
  ncsId?: Maybe<Scalars['String']>;
  parentProperty?: Maybe<Property>;
  parentPropertyId?: Maybe<Scalars['ID']>;
  phoneContacts?: Maybe<Array<PhoneContact>>;
  placeId?: Maybe<Scalars['String']>;
  psConfigurations?: Maybe<Array<PsConfiguration>>;
  reportConfigurations?: Maybe<Array<ReportConfiguration>>;
  /** Se true indica alla procedura di autoassegnazione che viene attivata in chiusura di assegnare le camere in arrivo */
  resourceAutoAssign?: Maybe<Scalars['Boolean']>;
  /** TSDIGITAL office identifier */
  resourceId?: Maybe<Scalars['String']>;
  sinapsiConfiguration?: Maybe<SinapsiConfiguration>;
  /**  Indirizzi alternativi per resourceType (piccola struttura diffusa)  */
  subAddresses?: Maybe<Array<PropertySubAddress>>;
  subProperties?: Maybe<Array<Property>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  /** Timezone serve per avere l'orario corretto della struttura rispetto a UCT */
  timeZone?: Maybe<Scalars['UtcOffset']>;
  /** Il tipo indica se siamo in presenza di una subproperty o di una property */
  type: PropertyType;
  vatNumber?: Maybe<Scalars['String']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PropertyBaseInput = {
  address?: InputMaybe<AddressInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  felConfiguration?: InputMaybe<FelConfigurationInput>;
  fiscalAdvances?: InputMaybe<Scalars['Boolean']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  housekeepingConfiguration?: InputMaybe<HousekeepingConfigurationInput>;
  iban?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  registryItemId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type PropertyFilterClient = {
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Il property Group è un insieme di strutture, ha vari scopi in ambito Multistruttura.
 * Sarà attivabile sicuramente con una licenza specifica e permette una visione complessiva delle strutture.
 */
export type PropertyGroup = {
  auditable: Auditable;
  id: Scalars['ID'];
  name: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type PropertyGroupInput = {
  name: Scalars['String'];
  tenantId: Scalars['ID'];
};

export type PropertyImage = {
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  type: PropertyImageType;
};

export type PropertyImageInput = {
  images?: InputMaybe<Array<Scalars['ID']>>;
  logo?: InputMaybe<Scalars['ID']>;
  squareLogo?: InputMaybe<Scalars['ID']>;
};

export const PropertyImageType = {
  IMAGE: 'IMAGE',
  LOGO: 'LOGO',
  SQUARE_LOGO: 'SQUARE_LOGO'
} as const;

export type PropertyImageType = typeof PropertyImageType[keyof typeof PropertyImageType];
export type PropertyInput = {
  address?: InputMaybe<AddressInput>;
  bookingEngineConfiguration?: InputMaybe<BookingEngineConfigurationInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  checkin?: InputMaybe<TimeRangeInput>;
  checkout?: InputMaybe<TimeRangeInput>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  dailyClosureConfiguration?: InputMaybe<DailyClosureConfigurationInput>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  featuresId?: InputMaybe<Array<Scalars['ID']>>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  groupsId?: InputMaybe<Array<Scalars['ID']>>;
  hoauConfiguration?: InputMaybe<HoauConfigurationInput>;
  hotelDate?: InputMaybe<Scalars['Date']>;
  housekeepingConfiguration?: InputMaybe<HousekeepingConfigurationInput>;
  ibeCode?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  parentPropertyId?: InputMaybe<Scalars['ID']>;
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  resourceAutoAssign?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['UtcOffset']>;
  type: PropertyType;
  vatNumber?: InputMaybe<Scalars['String']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export type PropertyPsConfigurationInput = {
  name: Scalars['String'];
  resourceTypeIds: Array<Scalars['ID']>;
  resources: Array<PsResourceConfiguration>;
};

export type PropertyPsConfigurationQueryInput = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type PropertyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type PropertyResourceMultiConfigurationInput = {
  name: Scalars['String'];
  resourceIds: Array<Scalars['ID']>;
  resourceTypeIds: Array<Scalars['ID']>;
};

export type PropertyResourceTypeMultiConfigurationInput = {
  name: Scalars['String'];
  resourceTypeIds: Array<Scalars['ID']>;
};

export type PropertySubAddress = {
  address?: Maybe<Address>;
  category?: Maybe<Taxonomy>;
  /**  La categoria è relativa al tipo, 3 stelle, 4 stelle, etc etc. PROPERTY_CATEGORY  */
  categoryId?: Maybe<Scalars['ID']>;
  checkin?: Maybe<TimeRange>;
  checkout?: Maybe<TimeRange>;
  classType?: Maybe<Taxonomy>;
  /**  La classe di tipologia indica Hotel, Appartamenti, B&B etc PROPERTY_CLASSTYPE  */
  classTypeId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['LocalizedString']>;
  ibeCode?: Maybe<Scalars['String']>;
  mailContacts?: Maybe<Array<MailContact>>;
  name: Scalars['String'];
  phoneContacts?: Maybe<Array<PhoneContact>>;
  placeId?: Maybe<Scalars['String']>;
  resourceTypeIds: Array<Scalars['ID']>;
  webContacts?: Maybe<Array<WebContact>>;
};

export type PropertySubAddressInput = {
  address?: InputMaybe<AddressInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  checkin?: InputMaybe<TimeRangeInput>;
  checkout?: InputMaybe<TimeRangeInput>;
  classTypeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['LocalizedString']>;
  ibeCode?: InputMaybe<Scalars['String']>;
  mailContacts?: InputMaybe<Array<MailContactInput>>;
  name: Scalars['String'];
  phoneContacts?: InputMaybe<Array<PhoneContactInput>>;
  placeId?: InputMaybe<Scalars['String']>;
  resourceTypeIds: Array<Scalars['ID']>;
  webContacts?: InputMaybe<Array<WebContactInput>>;
};

export const PropertyType = {
  PROPERTY: 'PROPERTY',
  SUBPROPERTY: 'SUBPROPERTY'
} as const;

export type PropertyType = typeof PropertyType[keyof typeof PropertyType];
/** Alloggiati Web Configuration */
export type PsConfiguration = {
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['EncryptedString'];
  resourceIds?: Maybe<Array<Scalars['ID']>>;
  resourceTypeIds?: Maybe<Array<Scalars['ID']>>;
  username: Scalars['EncryptedString'];
  wskey: Scalars['EncryptedString'];
};

export type PsConfigurationInput = {
  auto: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['EncryptedString'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  resources?: InputMaybe<Array<PsResourceConfiguration>>;
  username: Scalars['EncryptedString'];
  wskey: Scalars['EncryptedString'];
};

export type PsError = {
  code: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type PsResourceConfiguration = {
  codeItalianPs?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type PsSent = {
  lastError?: Maybe<PsError>;
  success: Scalars['Boolean'];
  timestamp: Scalars['DateTime'];
};

export type Query = {
  accountantCategories?: Maybe<Array<AccountantCategory>>;
  additionalServices?: Maybe<Array<AdditionalService>>;
  amenities?: Maybe<Array<Amenity>>;
  apiVersion: Scalars['String'];
  audits?: Maybe<Array<Audit>>;
  availabilityRequests?: Maybe<Array<AvailabilityRequest>>;
  bills?: Maybe<Array<Bill>>;
  bookingEngineUrls: Array<BookingEngineUrl>;
  bookingPolicies?: Maybe<Array<BookingPolicy>>;
  bulkReservations: Array<BulkReservation>;
  cashDeskTypes?: Maybe<Array<CashDeskType>>;
  cashDesks?: Maybe<Array<CashDesk>>;
  cervedAdvancedSearch: CervedAdvancedSearchResponse;
  cervedContacts: CervedContactsResponse;
  /** Query che recupera i dati dei risultati */
  channelCommunicationResults?: Maybe<Array<ChannelCommunicationResult>>;
  /** Query che recupera i dati presenti nel database e recuper la informazioni dal portale se possibile */
  channelDetails: ChannelOutput;
  channels?: Maybe<Array<Channel>>;
  chargeCategories?: Maybe<Array<ChargeCategory>>;
  /** Verifica se l'ApiKey specificato è valido. */
  checkCassaInCloudApiKey: Scalars['Boolean'];
  checkNcsNotifications?: Maybe<Scalars['Void']>;
  checkQuotationAvailability?: Maybe<ReservationAvailability>;
  checkReservationAvailability?: Maybe<ReservationAvailability>;
  children?: Maybe<Array<Child>>;
  cityTaxExonerations?: Maybe<Array<CityTaxExoneration>>;
  countries?: Maybe<Array<Country>>;
  customerDocumentImages?: Maybe<Array<CustomerDocumentImage>>;
  customers?: Maybe<Array<Customer>>;
  dailyAvailabilities?: Maybe<Array<DailyAvailability>>;
  dailyClosureAudits?: Maybe<Array<DailyClosureAudit>>;
  dailyForecastSnapshots?: Maybe<Array<DailyForecastSnapshot>>;
  dashboardMeals?: Maybe<DashboardMealsQueryOutput>;
  dashboardRRs?: Maybe<Array<ReservedResource>>;
  dashboardReception?: Maybe<DashboardReceptionQueryOutput>;
  dashboardRevenue?: Maybe<DashboardRevenueQueryOutput>;
  dashboardSells?: Maybe<DashboardSellsQueryOutput>;
  defaultMessageTemplates?: Maybe<Array<MessageTemplate>>;
  depositDocuments?: Maybe<Array<Document>>;
  documentActives?: Maybe<Array<DocumentActive>>;
  documentTotals: Array<DocumentTotal>;
  documents?: Maybe<Array<Document>>;
  exportData?: Maybe<Array<ExportData>>;
  exportProcedures?: Maybe<Array<ExportProcedure>>;
  exportableDatabases?: Maybe<Array<ExportableDatabase>>;
  files?: Maybe<Array<File>>;
  fiscalGatewayWorkstations: Array<FiscalGatewayWorkstation>;
  gdprLogs?: Maybe<Array<GdprLog>>;
  getAllAvailableResources?: Maybe<Array<Resource>>;
  getBookingPolicyDigitalPaymentInfo: BookingPolicyDigitalPaymentInfo;
  getCassaInCloudDepartments: Array<CassaInCloudDepartment>;
  getCassaInCloudSalesModes: Array<CassaInCloudSalesMode>;
  getCassaInCloudSalesPoints: Array<CassaInCloudSalesPoint>;
  getCatalogFromStore: StoreResponse;
  getChargeTransformation?: Maybe<ChargeTransformation>;
  getCityTaxRegulationRicestat: CityTaxRegulationRicestat;
  getCityTaxReport: CityTaxReport;
  getCityTaxRules: CityTaxRulesOutput;
  getCompanyInfoForPrivacy: CompanyInfoForPrivacyOutput;
  getDatabaseAttachState: DatabaseAttachState;
  getDocumentEmails?: Maybe<Array<Email>>;
  getIstatData?: Maybe<Array<IstatDailyData>>;
  getIstatProcedureByProperty: IstatProcedureCode;
  getIstatPropertiesTrentino: Array<IstatPropertyTrentino>;
  getIstatSystemCapabilities: IstatCapabilities;
  getNcsNotifications?: Maybe<Array<NcsNotification>>;
  getNcsNotificationsSummary?: Maybe<Array<NcsNotificationSummary>>;
  getPickupByResourceType: Array<PickupOutputByResourceType>;
  getPriceCalendar: Array<PriceCalendarDay>;
  getQuotationDigitalPaymentInfo: QuotationPaymentInfo;
  getQuotationLink: Scalars['String'];
  getRegistryItems: Array<RegistryItem>;
  getReservationDigitalPaymentInfo: ReservationPaymentInfo;
  getReservationEmails?: Maybe<Array<Email>>;
  getReservationLink: Scalars['String'];
  /** Ritorna i dati della carta di pagamento associata alla prenotazione specificata. Oppure null se non esiste alcuna carta. */
  getReservationPortalPaymentCard?: Maybe<ReservationPortalPaymentCard>;
  getResourceAvailability: Scalars['Boolean'];
  getResourceTypeAvailability: Scalars['Int'];
  /** Get the list of existing competitor locations */
  getSinapsiCompetitorLocations: Array<SinapsiCompetitorLocationItem>;
  /** Retrieve (and lock) the next Sinapsi competitor scraping task based on filter and last execution */
  getSinapsiCompetitorNextRetrievalTask?: Maybe<SinapsiCompetitorRetrievalTaskItem>;
  /** Get the list of updated competitor prices for the specified hotels (use the IDs returned by getSinapsiCompetitorProperties) */
  getSinapsiCompetitorPrices: Array<SinapsiCompetitorPropertyPricingInfo>;
  /** Get the list of previously scraped properties for the given location */
  getSinapsiCompetitorProperties: Array<SinapsiCompetitorPropertyBasicInfo>;
  /** Retrieve the list of Sinapsi competitor scraping tasks */
  getSinapsiCompetitorRetrievalTasks: Array<SinapsiCompetitorRetrievalTaskItem>;
  /** Get the list of base rate changes */
  getSinapsiDailyPriceAudit: Array<SinapsiDailyPriceAuditOutput>;
  /** Compute new proposed prices and budget forecasts */
  getSinapsiPrices: SinapsiOutput;
  getStatistics?: Maybe<Array<StatisticOutput>>;
  getStatisticsByResourceType?: Maybe<Array<StatisticOutputByResourceType>>;
  getSubscriptionInfo: Array<SubscriptionDigital>;
  getSubscriptionStore: Scalars['String'];
  getUrlFromStore: StoreUpgradeResponse;
  getUserPermissions: UserPermissionOutput;
  getWorstBookingPolicy: ReservationBookingPolicy;
  googlePlaceDetail: GooglePlaceDetailResponse;
  googlePlacesFind: GooglePlaceResponse;
  guestPortalReservation?: Maybe<Reservation>;
  guestPortalReservationBills: GuestPortalReservationBillsOutput;
  guestPortalVerifyCheckoutDocument: Scalars['Boolean'];
  heartbeat?: Maybe<Scalars['Void']>;
  horecahubFlows: Array<HorecaHubFlows>;
  horecahubIntegrations: Array<HorecaHubIntegration>;
  identificationDocuments?: Maybe<Array<IdentificationDocument>>;
  importableProperties?: Maybe<Array<ImportedProperty>>;
  importedErrors?: Maybe<Array<ImportedError>>;
  importedTasks?: Maybe<Array<ImportedTask>>;
  insights?: Maybe<Array<InsightStatus>>;
  messageAutomations?: Maybe<Array<MessageAutomation>>;
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  municipalities?: Maybe<Array<Municipality>>;
  ncsUserPreferences: NcsUserPreference;
  openBills?: Maybe<Array<Bill>>;
  origins?: Maybe<Array<Origin>>;
  passersByBills?: Maybe<Array<PassersByBill>>;
  paymentActives: Array<PaymentActive>;
  paymentGateways?: Maybe<Array<PaymentGateway>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentTypes: Array<PaymentType>;
  pointOfSaleMealShifts: Array<PointOfSaleMealShift>;
  pointOfSales: Array<PointOfSale>;
  portals?: Maybe<Array<Portal>>;
  positions?: Maybe<Array<Position>>;
  productions?: Maybe<Array<Production>>;
  products?: Maybe<Array<Product>>;
  properties?: Maybe<Array<Property>>;
  provinces: Array<Scalars['String']>;
  quotation: Quotation;
  quotations: Array<Quotation>;
  rateQuery: RqOutput;
  rateQueryForResource: RqForResourceOutput;
  rates?: Maybe<Array<Rate>>;
  reservationSearch?: Maybe<Array<ReservationQueryOutput>>;
  reservationStates?: Maybe<Array<ReservationState>>;
  reservations?: Maybe<Array<Reservation>>;
  reservedResources?: Maybe<Array<ReservedResource>>;
  resolveBookingEngineUrl?: Maybe<BookingEngineUrl>;
  resourceLayouts?: Maybe<Array<ResourceLayout>>;
  resourceTypes?: Maybe<Array<ResourceType>>;
  resources?: Maybe<Array<Resource>>;
  resourcesHousekeeping?: Maybe<Array<ResourceHousekeeping>>;
  roles?: Maybe<Array<Role>>;
  tags?: Maybe<Array<Tag>>;
  taxonomies?: Maybe<Array<Taxonomy>>;
  tenants?: Maybe<Array<Tenant>>;
  testPropertyPsConfiguration?: Maybe<Scalars['Boolean']>;
  threadMessages?: Maybe<Array<ThreadMessage>>;
  threads?: Maybe<Array<Thread>>;
  tsPayLinks?: Maybe<TsPayLink>;
  unusedPlants: Array<Plant>;
  users?: Maybe<Array<User>>;
  validateIbeCode: Scalars['Boolean'];
  validateItalianFiscalCode: Scalars['Boolean'];
  validateItalianVatCode: Scalars['Boolean'];
  vats?: Maybe<Array<Vat>>;
};


export type QueryaccountantCategoriesArgs = {
  filter: AccountantCategoryQueryFilter;
};


export type QueryadditionalServicesArgs = {
  filter: AdditionalServiceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryamenitiesArgs = {
  filter: AmenityQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryauditsArgs = {
  filter: AuditQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<AuditSortInput>>;
};


export type QueryavailabilityRequestsArgs = {
  filter: AvailabilityRequestQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybillsArgs = {
  filter: BillQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybookingEngineUrlsArgs = {
  propertyId: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};


export type QuerybookingPoliciesArgs = {
  filter: BookingPolicyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerybulkReservationsArgs = {
  correlationId: Scalars['String'];
  error?: InputMaybe<Scalars['Boolean']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerycashDeskTypesArgs = {
  filter: TenantPropertyIdFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycashDesksArgs = {
  filter: CashDeskQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycervedAdvancedSearchArgs = {
  input: CervedAdvancedSearchInput;
};


export type QuerycervedContactsArgs = {
  input: CervedContactsInput;
};


export type QuerychannelCommunicationResultsArgs = {
  filter: ChannelCommunicationFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerychannelDetailsArgs = {
  id: IDFilter;
  tenantId: Scalars['ID'];
};


export type QuerychannelsArgs = {
  filter: ChannelQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerychargeCategoriesArgs = {
  filter: ChargeCategoryQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycheckCassaInCloudApiKeyArgs = {
  apiKey: Scalars['String'];
};


export type QuerycheckNcsNotificationsArgs = {
  delivered?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerycheckQuotationAvailabilityArgs = {
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerycheckReservationAvailabilityArgs = {
  reservedResourceIdToIgnore?: InputMaybe<Array<Scalars['ID']>>;
  resources: Array<ResourceOccupancyInput>;
  tenantId: Scalars['ID'];
};


export type QuerychildrenArgs = {
  filter: ChildQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycityTaxExonerationsArgs = {
  propertyId: Scalars['ID'];
  reservedResourceId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  usage: ExonerationUsage;
};


export type QuerycountriesArgs = {
  filter?: InputMaybe<CountryQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomerDocumentImagesArgs = {
  filter: CustomerDocumentImageQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerycustomersArgs = {
  filter: CustomerQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<CustomerSortInput>>;
};


export type QuerydailyAvailabilitiesArgs = {
  filter: DailyAvailabilityQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydailyClosureAuditsArgs = {
  filter: DailyClosureAuditQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<DailyClosureAuditSortInput>>;
};


export type QuerydailyForecastSnapshotsArgs = {
  filter: DailyForecastSnapshotQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<DailyForecastSnapshotSortInput>>;
};


export type QuerydashboardMealsArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardRRsArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardReceptionArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardRevenueArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydashboardSellsArgs = {
  filter: DashboardQueryFilter;
};


export type QuerydefaultMessageTemplatesArgs = {
  type?: InputMaybe<MessageTemplateType>;
};


export type QuerydepositDocumentsArgs = {
  filter: DepositDocumentQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentActivesArgs = {
  filter: TenantPropertyIdFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerydocumentTotalsArgs = {
  filter: DocumentQueryFilter;
};


export type QuerydocumentsArgs = {
  filter: DocumentQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryexportDataArgs = {
  filter: ExportDataQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryexportProceduresArgs = {
  filter: ExportProcedureQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryfilesArgs = {
  filter: FilesQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryfiscalGatewayWorkstationsArgs = {
  filter: FiscalGatewayWorkstationQueryFilter;
};


export type QuerygdprLogsArgs = {
  filter: GdprLogQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerygetAllAvailableResourcesArgs = {
  filter: AvailableResourcesInput;
};


export type QuerygetBookingPolicyDigitalPaymentInfoArgs = {
  input: BookingPolicyDigitalPaymentInput;
};


export type QuerygetCassaInCloudDepartmentsArgs = {
  filter: CassaInCloudDepartmentsQueryFilter;
};


export type QuerygetCassaInCloudSalesModesArgs = {
  filter: CassaInCloudSalesModesQueryFilter;
};


export type QuerygetCassaInCloudSalesPointsArgs = {
  apiKey: Scalars['String'];
};


export type QuerygetCatalogFromStoreArgs = {
  tenantId: Scalars['ID'];
};


export type QuerygetChargeTransformationArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetCityTaxRegulationRicestatArgs = {
  input: GetCityTaxRegulationRicestatInput;
};


export type QuerygetCityTaxReportArgs = {
  filter: CityTaxReportInput;
};


export type QuerygetCityTaxRulesArgs = {
  input: GetCityTaxRulesInput;
};


export type QuerygetCompanyInfoForPrivacyArgs = {
  tenantId: Scalars['ID'];
};


export type QuerygetDatabaseAttachStateArgs = {
  dbName: Scalars['String'];
  taskId: Scalars['Int'];
};


export type QuerygetDocumentEmailsArgs = {
  customerId: Scalars['ID'];
  documentId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerygetIstatDataArgs = {
  input: GetIstatDataInput;
};


export type QuerygetIstatProcedureByPropertyArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetIstatPropertiesTrentinoArgs = {
  input: GetIstatPropertiesTrentinoInput;
};


export type QuerygetIstatSystemCapabilitiesArgs = {
  procedureCode: IstatProcedureCode;
};


export type QuerygetNcsNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<NcsPriorityEnum>;
  propertyId: Scalars['ID'];
  startingAfter?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerygetNcsNotificationsSummaryArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QuerygetPickupByResourceTypeArgs = {
  filter: PickupFilter;
};


export type QuerygetPriceCalendarArgs = {
  filter: PriceCalendarFilter;
};


export type QuerygetQuotationDigitalPaymentInfoArgs = {
  propertyId: Scalars['ID'];
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetQuotationLinkArgs = {
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetRegistryItemsArgs = {
  input: GetRegistryItemsInput;
};


export type QuerygetReservationDigitalPaymentInfoArgs = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetReservationEmailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  reservationId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerygetReservationLinkArgs = {
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetReservationPortalPaymentCardArgs = {
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerygetResourceAvailabilityArgs = {
  filter: ResourceAvailabilityInput;
};


export type QuerygetResourceTypeAvailabilityArgs = {
  filter: ResourceTypeAvailabilityInput;
};


export type QuerygetSinapsiCompetitorLocationsArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiCompetitorNextRetrievalTaskArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiCompetitorPricesArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerygetSinapsiCompetitorPropertiesArgs = {
  filter: SinapsiCompetitorRetrievalTaskFilterInput;
};


export type QuerygetSinapsiCompetitorRetrievalTasksArgs = {
  filter?: InputMaybe<SinapsiCompetitorRetrievalTaskFilterInput>;
};


export type QuerygetSinapsiDailyPriceAuditArgs = {
  filter: SinapsiDailyPriceAuditFilterInput;
};


export type QuerygetSinapsiPricesArgs = {
  filter: SinapsiFilter;
  options: SinapsiQueryOptions;
};


export type QuerygetStatisticsArgs = {
  filter: StatisticFilter;
};


export type QuerygetStatisticsByResourceTypeArgs = {
  filter: StatisticFilter;
};


export type QuerygetSubscriptionInfoArgs = {
  registryCompanyId: Scalars['String'];
};


export type QuerygetSubscriptionStoreArgs = {
  input: SubscriptionInfoInput;
};


export type QuerygetUrlFromStoreArgs = {
  request: StoreUpgradeInput;
};


export type QuerygetUserPermissionsArgs = {
  input: UserPermissionQueryInput;
};


export type QuerygetWorstBookingPolicyArgs = {
  input: WorstBookingPolicyInput;
};


export type QuerygooglePlaceDetailArgs = {
  input: GooglePlaceInput;
};


export type QuerygooglePlacesFindArgs = {
  input: GooglePlacesFindInput;
};


export type QueryguestPortalReservationArgs = {
  reservationId: Scalars['ID'];
};


export type QueryguestPortalReservationBillsArgs = {
  reservationId: Scalars['ID'];
};


export type QueryguestPortalVerifyCheckoutDocumentArgs = {
  documentId: Scalars['String'];
  reservationId: Scalars['ID'];
};


export type QueryhorecahubFlowsArgs = {
  productCode: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type QueryhorecahubIntegrationsArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type QueryidentificationDocumentsArgs = {
  filter?: InputMaybe<IdentificationDocumentQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryimportablePropertiesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryimportedErrorsArgs = {
  filters: ImportedErrorQueryFilter;
};


export type QueryimportedTasksArgs = {
  filters: ImportedTaskQueryFilter;
};


export type QueryinsightsArgs = {
  filter: InsightQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymessageAutomationsArgs = {
  filter: MessageAutomationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymessageTemplatesArgs = {
  filter: MessageTemplateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerymunicipalitiesArgs = {
  filter?: InputMaybe<MunicipalityQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryncsUserPreferencesArgs = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryopenBillsArgs = {
  filter: OpenBillsQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryoriginsArgs = {
  filter: OriginQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypassersByBillsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  open?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type QuerypaymentActivesArgs = {
  filter: PaymentActiveQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentGatewaysArgs = {
  filter: PaymentGatewayQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentMethodsArgs = {
  filter: PaymentMethodQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypaymentTypesArgs = {
  filter: PaymentTypeQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypointOfSaleMealShiftsArgs = {
  filter: PointOfSaleMealShiftQueryFilter;
};


export type QuerypointOfSalesArgs = {
  filter: PointOfSaleQueryFilter;
};


export type QueryportalsArgs = {
  filter?: InputMaybe<PortalQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypositionsArgs = {
  filter: PositionQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryproductionsArgs = {
  filter: ProductionQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryproductsArgs = {
  filter: ProductQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerypropertiesArgs = {
  filter: PropertyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryquotationArgs = {
  id: Scalars['ID'];
  setReadState?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};


export type QueryquotationsArgs = {
  filter: QuotationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryrateQueryArgs = {
  filter: RqQueryFilter;
};


export type QueryrateQueryForResourceArgs = {
  filter: RqQueryForResourceFilter;
};


export type QueryratesArgs = {
  filter: RateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservationSearchArgs = {
  filter: ReservationFullTextQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ReservationFullTextQuerySortInput>;
};


export type QueryreservationStatesArgs = {
  filter: ReservationStateQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservationsArgs = {
  filter: ReservationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryreservedResourcesArgs = {
  filter: ReservedResourceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresolveBookingEngineUrlArgs = {
  url: Scalars['String'];
};


export type QueryresourceLayoutsArgs = {
  filter: ResourceLayoutQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourceTypesArgs = {
  filter: ResourceTypeQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourcesArgs = {
  filter: ResourceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryresourcesHousekeepingArgs = {
  filter: ResourceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryrolesArgs = {
  filter?: InputMaybe<RoleQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytagsArgs = {
  filter: TagQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytaxonomiesArgs = {
  filter: TaxonomyQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytenantsArgs = {
  filter?: InputMaybe<TenantQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytestPropertyPsConfigurationArgs = {
  name?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QuerythreadMessagesArgs = {
  filter: ThreadMessageQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerythreadsArgs = {
  filter: ThreadQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerytsPayLinksArgs = {
  orderKey: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type QueryunusedPlantsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryusersArgs = {
  filter: UserQueryInput;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryvalidateIbeCodeArgs = {
  filter?: InputMaybe<IbeCodeFilter>;
};


export type QueryvalidateItalianFiscalCodeArgs = {
  fiscalCode: Scalars['String'];
};


export type QueryvalidateItalianVatCodeArgs = {
  vatCode: Scalars['String'];
};


export type QueryvatsArgs = {
  filter: VatQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type Quotation = {
  auditable: Auditable;
  expiration?: Maybe<Scalars['Date']>;
  fiscalTypeForAdvances?: Maybe<FiscalTypeForAdvances>;
  fromIbe: Scalars['Boolean'];
  id: Scalars['ID'];
  notes?: Maybe<Array<Note>>;
  property: Property;
  propertyId: Scalars['ID'];
  /** Il codice è la chiave di ricerca del preventivo (gestito come contatore) */
  quotationCode: Scalars['String'];
  quotationDetails: Array<QuotationDetail>;
  quotationState: QuotationState;
  quotationStateHistory: Array<QuotationStateHistory>;
  /** Riferimenti a customer */
  reference: ReservationReference;
  tenant: Tenant;
  tenantId: Scalars['ID'];
};

export type QuotationDetail = {
  quotedResources: Array<QuotedResource>;
  /** refFrom quotationId for security domain */
  reservation?: Maybe<Reservation>;
  reservationId?: Maybe<Scalars['ID']>;
};

export type QuotationDetailInput = {
  quotedResources: Array<QuotedResourceInput>;
  reservationId?: InputMaybe<Scalars['ID']>;
};

export type QuotationForIbe = {
  propertyId: Scalars['ID'];
  quotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  token: Scalars['String'];
};

export type QuotationForIbeOutput = {
  /**  if link2Pay is empty, the quotation can be confirmed immediately  */
  link2Pay?: Maybe<Link2PayOutput>;
  quotation?: Maybe<QuotationForIbe>;
};

export type QuotationGuestOccupancy = {
  cityTaxExoneration?: Maybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guest: Customer;
  guestId: Scalars['ID'];
  start: Scalars['Date'];
  type: GuestType;
};

export type QuotationGuestOccupancyInput = {
  cityTaxExoneration?: InputMaybe<CityTaxExonerationCode>;
  end: Scalars['Date'];
  guestId: Scalars['ID'];
  start: Scalars['Date'];
  type: GuestType;
};

export type QuotationInput = {
  expiration?: InputMaybe<Scalars['Date']>;
  fiscalTypeForAdvances?: InputMaybe<FiscalTypeForAdvances>;
  notes?: InputMaybe<Array<NoteInput>>;
  propertyId: Scalars['ID'];
  quotationDetails: Array<QuotationDetailInput>;
  /** Riferimenti a customer */
  reference: ReservationReferenceInput;
  tenantId: Scalars['ID'];
};

export type QuotationPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  end: Scalars['Date'];
  mainGuest: QuotationPaymentInfoMainGuest;
  merchantRef?: Maybe<Scalars['String']>;
  noShow: Scalars['Int'];
  propertyName: Scalars['String'];
  start: Scalars['Date'];
};

export type QuotationPaymentInfoMainGuest = {
  id: Scalars['ID'];
  language?: Maybe<Scalars['Language']>;
  name?: Maybe<Scalars['String']>;
};

export type QuotationQueryFilter = {
  createdBy?: InputMaybe<Scalars['String']>;
  createdOn?: InputMaybe<DateFilter>;
  id?: InputMaybe<Scalars['ID']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  quotationState?: InputMaybe<QuotationStateFilter>;
  search?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<DateFilter>;
  tenantId: Scalars['ID'];
};

export type QuotationResourceOccupancy = {
  end: Scalars['Date'];
  reservedResourceLayout?: Maybe<ResourceLayout>;
  reservedResourceLayoutId?: Maybe<Scalars['ID']>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export type QuotationResourceOccupancyInput = {
  end: Scalars['Date'];
  reservedResourceLayoutId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export const QuotationState = {
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  DRAFT: 'DRAFT',
  EXPIRED: 'EXPIRED',
  READ: 'READ',
  SENT: 'SENT'
} as const;

export type QuotationState = typeof QuotationState[keyof typeof QuotationState];
export type QuotationStateFilter = {
  in: Array<QuotationState>;
};

export type QuotationStateHistory = {
  state: QuotationState;
  timestamp: Scalars['DateTime'];
};

export type QuotationStateHistoryInput = {
  state: QuotationState;
  timestap: Scalars['DateTime'];
};

export type QuotedResource = {
  /** Lista degli eventuali servizi aggiuntivi (sia quelli richiesti dall'utente che già previsti dalla tariffa). */
  additionalServices?: Maybe<Array<EmbeddedAdditionalService>>;
  adults: Scalars['Int'];
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  guestOccupancies?: Maybe<Array<QuotationGuestOccupancy>>;
  /** Identificativo per distinguere le varie entità QuotedResource.     Viene automaticamente generato dal backend quando si crea una nuova entità. */
  identifier: Scalars['ID'];
  /** Prezzi giornalieri */
  manualDailyPrices?: Maybe<Array<ManualDailyPrice>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  policy?: Maybe<ReservationBookingPolicy>;
  rate: Rate;
  rateId: Scalars['ID'];
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<QuotationResourceOccupancy>;
  start: Scalars['Date'];
};

export type QuotedResourceInput = {
  /** Lista degli eventuali servizi aggiuntivi (che si aggiungono a quelli già previsti dalla tariffa) */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  end: Scalars['Date'];
  guestOccupancies?: InputMaybe<Array<QuotationGuestOccupancyInput>>;
  /**
   * Identificativo per distinguere le varie entità QuotedResource.     La prima volta che si salva la risorsa non deve essere valorizzato: verrà automaticamente generato dal backend e
   * dovrà essere passato indietro al backend senza alterazioni.
   */
  identifier?: InputMaybe<Scalars['ID']>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  rateId: Scalars['ID'];
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<QuotationResourceOccupancyInput>;
  start: Scalars['Date'];
};

/** Il tipo range indica un periodo */
export type Range = {
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export type RangeInput = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

/** La tariffa rappresenta il listino prezzi, la tariffa ha una arrangiamneto di default, in modo da semplificare le gestione online. */
export type Rate = {
  affiliatedCompanies?: Maybe<Array<Customer>>;
  /** Aziende convenzionate */
  affiliatedCompaniesId?: Maybe<Array<Scalars['ID']>>;
  /** Indica se la tariffa è una tariffa convenzionata */
  agreementRate: Scalars['Boolean'];
  auditable: Auditable;
  /** La prenotabilità indica il periodo in cui l'ospite può utilizzare la tariffa, in caso di booking engine è il peirodo in cui è visibile. */
  bookability?: Maybe<Array<Range>>;
  bookingPolicy: BookingPolicy;
  /** Le politica di booking contiene le regole di per i pagamenti e per le cancellazioni è il default che viene utilizzato, ma può essere sovrascritta nel dettaglio giornaliero. */
  bookingPolicyId: Scalars['ID'];
  chargeCategory: ChargeCategory;
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryId: Scalars['ID'];
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: Maybe<Array<ChargeRate>>;
  /** Regole di gestione dei bambini */
  childRule: ChildRule;
  /** Indica i giorni in cui non è previsto l'arrivo, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToArrival?: Maybe<Scalars['String']>;
  /** Indica i giorni in cui non è prevista la partenza, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToDeparture?: Maybe<Scalars['String']>;
  /**
   * In caso in cui l'offerta non sia valida in tutto il periodo richiesto l'operatore può decidere come il sistema deve ragionare.
   * Default NOCROSS
   */
  crossSell: CrossSell;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: Maybe<Array<DerivationRules>>;
  description: Scalars['LocalizedString'];
  /** Se presente indica al sistema che non è una tariifa pubblica */
  ibeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: Maybe<Scalars['Boolean']>;
  /** Servizi aggiuntivi Obbligatori */
  mandatoryAdditionalServices?: Maybe<Array<RateMandatoryAdditionalService>>;
  /** Giorni massimi che possono intercorrere tra la data di arrivo e la data di prenotazione (Last Minute) */
  maxAdvance?: Maybe<Scalars['Int']>;
  /** Giorni massimi del soggiorno valido se >=1 */
  maxStay?: Maybe<Scalars['Int']>;
  /** Giorni minimi che devono intercorrere tra la data di arrivo e la data di prenotazione (Prenota Prima) */
  minAdvance?: Maybe<Scalars['Int']>;
  /** Giorni minimi di soggiorno valido se >1 */
  minStay?: Maybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order: Scalars['Int'];
  parentRate?: Maybe<Rate>;
  /** Se siamo in presenza di una tariffa derivata sono presenti le regole di derivazione */
  parentRateId?: Maybe<Scalars['ID']>;
  /** Fasce di Prezzo */
  priceRanges?: Maybe<Array<PriceRange>>;
  /** I prezzi per gli addebiti non di arrangiamento */
  prices?: Maybe<Array<ChargeCategoryPrice>>;
  property: Property;
  propertyId: Scalars['ID'];
  /** Tariffa base */
  resourcesRate?: Maybe<Array<ResourceRate>>;
  resourcesTypeEnabled?: Maybe<Array<ResourceType>>;
  /** Nel caso di tariffe derivate è possibile specificare se la tariffa è attiva solo su alcune tipologie. */
  resourcesTypeEnabledId?: Maybe<Array<Scalars['ID']>>;
  /** Indica se le restrizioni sono ereditate dalla tariffa base */
  restrictionFromParent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  type: RateType;
  /**
   * La validità non è un dato obbligatorio, sulle tariffe base possiamo indicare al sistema che saranno sempre attive
   * in base al calendario predefinito della struttura
   */
  validity?: Maybe<Array<Range>>;
  /** Indica se la tariffa è visibile sul booking engine */
  visibilityOnIbe: Scalars['Boolean'];
};

export type RateBaseInput = {
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryBoard: ChargeCategoryBoard;
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: InputMaybe<Array<ChargeRateBaseInput>>;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: InputMaybe<Array<DerivationRulesInput>>;
  description: Scalars['LocalizedString'];
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['LocalizedString'];
  /** Tariffa base */
  resourcesRate: Array<ResourceRateBaseInput>;
};

export type RateInput = {
  /** Aziende convenzionate */
  affiliatedCompaniesId?: InputMaybe<Array<Scalars['ID']>>;
  /** Indica se la tariffa è una tariffa convenzionata */
  agreementRate: Scalars['Boolean'];
  /** La prenotabilità indica il periodo in cui l'ospite può utilizzare la tariffa, in caso di booking engine è il peirodo in cui è visibile. */
  bookability?: InputMaybe<Array<RangeInput>>;
  /** Le politica di booking contiene le regole di per i pagamenti e per le cancellazioni è il default che viene utilizzato, ma può essere sovrascritta nel dettaglio giornaliero. */
  bookingPolicyId: Scalars['ID'];
  /** Arrangiamneto di default della tariffa, deve essere un charge che ha stayInclude a True. */
  chargeCategoryId: Scalars['ID'];
  /** Variazioni di prezzo dall'arrangiamento base . */
  chargesRate?: InputMaybe<Array<ChargeRateInput>>;
  /** Regole di gestione dei bambini */
  childRule: ChildRuleInput;
  /** Indica i giorni in cui non è previsto l'arrivo, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToArrival?: InputMaybe<Scalars['String']>;
  /** Indica i giorni in cui non è prevista la partenza, usiamo una stringa di 7 bit il primo bit rappresenta la domenica, se 1 è chiuso se zero è aperta */
  closeToDeparture?: InputMaybe<Scalars['String']>;
  /**
   * In caso in cui l'offerta non sia valida in tutto il periodo richiesto l'operatore può decidere come il sistema deve ragionare.
   * Default NOCROSS
   */
  crossSell: CrossSell;
  currency: Scalars['Currency'];
  /** Le regole di derivazione si applicano sugli arrangiamenti, se non sono presenti non sono gestiti sulla tariffa. */
  derivedRules?: InputMaybe<Array<DerivationRulesInput>>;
  description: Scalars['LocalizedString'];
  /** Se presente indica al sistema che non è una tariifa pubblica */
  ibeCode?: InputMaybe<Scalars['String']>;
  /** Se attivo i prezzi vengono arrotondati all'unità più vicina (da valorizzare solo sulla rate base) */
  intPrices?: InputMaybe<Scalars['Boolean']>;
  /** Servizi aggiuntivi */
  mandatoryAdditionalServices?: InputMaybe<Array<RateMandatoryAdditionalServiceInput>>;
  /** Giorni massimi che possono intercorrere tra la data di arrivo e la data di prenotazione */
  maxAdvance?: InputMaybe<Scalars['Int']>;
  /** Giorni massimi del soggiorno valido se >=1 */
  maxStay?: InputMaybe<Scalars['Int']>;
  /** Giorni minimi che devono intercorrere tra la data di arrivo e la data di prenotazione */
  minAdvance?: InputMaybe<Scalars['Int']>;
  /** Giorni minimi di soggiorno valido se >1 */
  minStay?: InputMaybe<Scalars['Int']>;
  name: Scalars['LocalizedString'];
  order: Scalars['Int'];
  /** Se siamo in presenza di una tariffa derivata sono presenti le regole di derivazione */
  parentRateId?: InputMaybe<Scalars['ID']>;
  /** Fasce di Prezzo */
  priceRanges?: InputMaybe<Array<PriceRangeInput>>;
  /** I prezzi per gli addebiti non di arrangiamento */
  prices?: InputMaybe<Array<ChargeCategoryPriceInput>>;
  propertyId: Scalars['ID'];
  /** Tariffa base */
  resourcesRate?: InputMaybe<Array<ResourceRateInput>>;
  /** Nel caso di tariffe derivate è possibile specificare se la tariffa è attiva solo su alcune tipologie. */
  resourcesTypeEnabledId?: InputMaybe<Array<Scalars['ID']>>;
  /** Indica se le restrizioni sono ereditate dalla tariffa base */
  restrictionFromParent: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  type: RateType;
  /**
   * La validità non è un dato obbligatorio, sulle tariffe base possiamo indicare al sistema che saranno sempre attive
   * in base al calendario predefinito della struttura
   */
  validity?: InputMaybe<Array<RangeInput>>;
  /** Indica se la tariffa è visibile sul booking engine */
  visibilityOnIbe: Scalars['Boolean'];
};

export type RateMandatoryAdditionalService = {
  additionalService: AdditionalService;
  additionalServiceId: Scalars['ID'];
  priceZero: Scalars['Boolean'];
};

export type RateMandatoryAdditionalServiceInput = {
  additionalServiceId: Scalars['ID'];
  priceZero: Scalars['Boolean'];
};

export type RateQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  type?: InputMaybe<RateType>;
};

export const RateRestriction = {
  ADVANCE: 'ADVANCE',
  CTA: 'CTA',
  CTD: 'CTD',
  LASTMINUTE: 'LASTMINUTE',
  MAXSTAY: 'MAXSTAY',
  MINSTAY: 'MINSTAY',
  STOPSELL: 'STOPSELL',
  STOPSELL_CHARGE: 'STOPSELL_CHARGE'
} as const;

export type RateRestriction = typeof RateRestriction[keyof typeof RateRestriction];
/** Rate Query Embedded Type */
export type RateRq = {
  bookingPolicyOverride?: Maybe<BookingPolicy>;
  bookingPolicyOverrideId?: Maybe<Scalars['ID']>;
  rate: Rate;
  rateId: Scalars['ID'];
  resourceRates?: Maybe<Array<PriceRq>>;
  restrictionsNotMet?: Maybe<Array<RateRestriction>>;
};

export const RateType = {
  BASE: 'BASE',
  DERIVED: 'DERIVED',
  STATIC: 'STATIC'
} as const;

export type RateType = typeof RateType[keyof typeof RateType];
export type RebuildPropertyAvailabilityEvent = {
  errors?: Maybe<Array<ResourceTypeAvailabilityError>>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type RebuildPropertyAvailabilityEventFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type RefPointer = {
  refFrom?: InputMaybe<Scalars['String']>;
  refTo?: InputMaybe<Scalars['String']>;
};

export const RegimeFiscale = {
  RF01: 'RF01',
  RF02: 'RF02',
  RF04: 'RF04',
  RF05: 'RF05',
  RF06: 'RF06',
  RF07: 'RF07',
  RF08: 'RF08',
  RF09: 'RF09',
  RF10: 'RF10',
  RF11: 'RF11',
  RF12: 'RF12',
  RF13: 'RF13',
  RF14: 'RF14',
  RF15: 'RF15',
  RF16: 'RF16',
  RF17: 'RF17',
  RF18: 'RF18',
  RF19: 'RF19'
} as const;

export type RegimeFiscale = typeof RegimeFiscale[keyof typeof RegimeFiscale];
export type RegistryItem = {
  base: RegistryItemBase;
};

export type RegistryItemAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegistryItemBase = {
  details: RegistryItemDetails;
  hierarchyId?: Maybe<Scalars['String']>;
  holdingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier: RegistryItemIdentifier;
  ncsId: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  status: RegistryItemStatus;
};

export type RegistryItemContact = {
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RegistryItemDetails = {
  addresses: Array<RegistryItemAddress>;
  birthDate?: Maybe<Scalars['String']>;
  classifier: Scalars['String'];
  contacts?: Maybe<Array<Maybe<RegistryItemContact>>>;
  description?: Maybe<Scalars['String']>;
  economics?: Maybe<RegistryItemEconomics>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalClass?: Maybe<Scalars['String']>;
  legalForm: RegistryItemLegalForm;
  logoUrl?: Maybe<Scalars['String']>;
  professionalRegister: RegistryItemProfessionalRegister;
};

export type RegistryItemEconomicActivities = {
  mainActivity?: Maybe<RegistryItemEconomicActivitiesMainActivity>;
};

export type RegistryItemEconomicActivitiesMainActivity = {
  code?: Maybe<Scalars['String']>;
  rootCode?: Maybe<Scalars['String']>;
};

export type RegistryItemEconomics = {
  balanceSheetDate?: Maybe<Scalars['String']>;
  capitalStock?: Maybe<Scalars['String']>;
  cciaa?: Maybe<Scalars['String']>;
  economicActivities?: Maybe<RegistryItemEconomicActivities>;
  liquidationState?: Maybe<Scalars['String']>;
  rea?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
  soleShareholder?: Maybe<Scalars['String']>;
  taxRegime?: Maybe<Scalars['String']>;
};

export type RegistryItemIdentifier = {
  govCode?: Maybe<Scalars['String']>;
  taxId: Scalars['String'];
  taxRegion: Scalars['String'];
  vatNumber?: Maybe<Scalars['String']>;
};

export type RegistryItemLegalForm = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RegistryItemProfessionalRegister = {
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  registrationDate?: Maybe<Scalars['String']>;
};

export type RegistryItemStatus = {
  activatedAt?: Maybe<Scalars['String']>;
  activatedBy?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  certificationStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  externallyValidated: Scalars['Boolean'];
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  ownership?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ReminderForUnpaidDocumentsInput = {
  customerId: Scalars['ID'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  unpaidDocumentIds: Array<Scalars['ID']>;
};

export type RemovePointOfSaleInput = {
  pointOfSaleId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ReportConfiguration = {
  /** Name of the configuration. */
  name: Scalars['String'];
  parameters?: Maybe<Array<ReportConfigurationParameters>>;
};

export type ReportConfigurationParameters = {
  /** Indicates whether the header must be hidden. */
  hideHeader?: Maybe<Scalars['Boolean']>;
  /** Offset from page bottom in centimeters. */
  marginBottom?: Maybe<Scalars['Float']>;
  /** Offset from page top in centimeters. */
  marginTop?: Maybe<Scalars['Float']>;
  /** Name of the report the parameters apply to. */
  reportName: ReportName;
};

/** The only reports that support parameters. */
export const ReportName = {
  /** Documenti/Documento: Documento di cortesia */
  DOCUMENTI_DOCUMENTO: 'DOCUMENTI_DOCUMENTO'
} as const;

export type ReportName = typeof ReportName[keyof typeof ReportName];
export type RequestData = {
  ip: Scalars['String'];
  ips?: Maybe<Array<Scalars['String']>>;
  mobile?: Maybe<Scalars['Boolean']>;
  platform: Scalars['String'];
  timestamp: Scalars['DateTime'];
  userAgent: Scalars['String'];
};

/** L'entità reservation contiene i dati comuni di una prenotazione */
export type Reservation = {
  auditable: Auditable;
  canceledOn?: Maybe<Scalars['DateTime']>;
  credit: CreditType;
  depositAssigneds?: Maybe<Array<DepositAssigned>>;
  disableAutomation?: Maybe<Scalars['Boolean']>;
  fileIds?: Maybe<Array<Scalars['ID']>>;
  files?: Maybe<Array<File>>;
  fiscalTypeForAdvances?: Maybe<FiscalTypeForAdvances>;
  /** Nome del Gruppo */
  group?: Maybe<Scalars['String']>;
  guestPortalLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGroup: Scalars['Boolean'];
  notes?: Maybe<Array<Note>>;
  /** La data di scadenza opzione per adesso sulla testata */
  optionExpiration?: Maybe<Scalars['Date']>;
  origin: Origin;
  /** Origine della prenotazione è un dato obbligatorio */
  originId: Scalars['ID'];
  paCIG?: Maybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: Maybe<Scalars['String']>;
  /** Viene salvata la peggiore tra le policy presenti nelle reservedResource */
  policy?: Maybe<ReservationBookingPolicy>;
  /** Riferimenti del portale da cui è stata scaricata la prenotazione */
  portalInfo?: Maybe<PortalInfo>;
  property: Array<Property>;
  /** La struttura non è obbligatoria, potremmo avere dettagli su più strutture */
  propertyId: Array<Scalars['ID']>;
  /**  Id del preventivo se esistente  */
  quotationId?: Maybe<Scalars['ID']>;
  /** Riferimenti a customer */
  reference: ReservationReference;
  /** Il codice è la chiave di ricerca della prenotazione (gestito come contatore) */
  reservationCode: Scalars['String'];
  reservationState: ReservationState;
  /** Lo stato della prenotazione gestisce le ReservedResource collegate */
  reservationStateId: Scalars['ID'];
  /** Lista delle attività legate alla prenotazione */
  reservedResources?: Maybe<Array<ReservedResource>>;
  searchInfo?: Maybe<ReservationSearchInfo>;
  tags?: Maybe<Array<Tag>>;
  tagsId?: Maybe<Array<Scalars['ID']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  tsPayCharges?: Maybe<Array<TsPayCharge>>;
  /** Ts Pay */
  tsPayLinks?: Maybe<Array<TsPayLink>>;
  /** Il voucher proviene da canali esterni */
  voucher?: Maybe<Scalars['String']>;
};

export type ReservationAvailability = {
  error?: Maybe<ReservationAvailabilityError>;
  success: Scalars['Boolean'];
};

export type ReservationAvailabilityError = {
  date: Scalars['Date'];
  resourceId?: Maybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ReservationBillInput = {
  category: BillCategoryType;
  description: Scalars['String'];
  id: Scalars['ID'];
  ownerId: Scalars['ID'];
  propertyId: Scalars['ID'];
};

/**
 * Entità congelata nella ReservedResource; è un sottoinsieme delle property di BookingPolicy.
 * Viene presa da Rate durante la creazione/modifica di una ReservedResource
 */
export type ReservationBookingPolicy = {
  additionalNote?: Maybe<Scalars['LocalizedString']>;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicy;
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRule;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRule;
};

export type ReservationBookingPolicyInput = {
  additionalNote?: InputMaybe<Scalars['LocalizedString']>;
  /** Gestione delle policy di cancellazione */
  cancellationPolicy: CancellationPolicyInput;
  name: Scalars['String'];
  /** Regole per gestire il no show */
  noShowRule: NoShowRuleInput;
  /** Regole per la conferma della prenotaizone */
  paymentRule: PaymentRuleInput;
};

export type ReservationCounterInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  year: Scalars['Int'];
};

export type ReservationEventPayload = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
  type: ReservationEventType;
};

export const ReservationEventType = {
  CANCEL: 'CANCEL',
  CONFIRM: 'CONFIRM',
  CREATE: 'CREATE'
} as const;

export type ReservationEventType = typeof ReservationEventType[keyof typeof ReservationEventType];
export type ReservationFilterInput = {
  id: Scalars['String'];
  propertyId: Scalars['String'];
  tenantId: Scalars['String'];
};

export const ReservationFullTextQueryDateRangeType = {
  ARRIVAL: 'ARRIVAL',
  CANCELATION: 'CANCELATION',
  CREATION: 'CREATION',
  DEPARTURE: 'DEPARTURE',
  EXPIRATION: 'EXPIRATION',
  IN_HOUSE: 'IN_HOUSE'
} as const;

export type ReservationFullTextQueryDateRangeType = typeof ReservationFullTextQueryDateRangeType[keyof typeof ReservationFullTextQueryDateRangeType];
export type ReservationFullTextQueryFilter = {
  filterFrom?: InputMaybe<Scalars['Date']>;
  filterTo?: InputMaybe<Scalars['Date']>;
  filterType?: InputMaybe<ReservationFullTextQueryDateRangeType>;
  id?: InputMaybe<Scalars['ID']>;
  originId?: InputMaybe<Array<Scalars['ID']>>;
  portalId?: InputMaybe<Array<Scalars['ID']>>;
  propertyId?: InputMaybe<Scalars['ID']>;
  reservationCode?: InputMaybe<Scalars['String']>;
  reservationStateId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
};

export type ReservationFullTextQuerySortInput = {
  company?: InputMaybe<Sort>;
  createdOn?: InputMaybe<Sort>;
  end?: InputMaybe<Sort>;
  mainGuest?: InputMaybe<Sort>;
  reservationCode?: InputMaybe<Sort>;
  reservationState?: InputMaybe<Sort>;
  resources?: InputMaybe<Sort>;
  start?: InputMaybe<Sort>;
};

export type ReservationInput = {
  bills?: InputMaybe<Array<ReservationBillInput>>;
  credit?: InputMaybe<CreditType>;
  disableAutomation?: InputMaybe<Scalars['Boolean']>;
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
  fiscalTypeForAdvances?: InputMaybe<FiscalTypeForAdvances>;
  group?: InputMaybe<Scalars['String']>;
  isGroup: Scalars['Boolean'];
  notes?: InputMaybe<Array<NoteInput>>;
  optionExpiration?: InputMaybe<Scalars['Date']>;
  originId: Scalars['ID'];
  paCIG?: InputMaybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: InputMaybe<Scalars['String']>;
  propertyId: Array<Scalars['ID']>;
  /** Riferimenti a customer */
  reference: ReservationReferenceInput;
  /** Lo stato della prenotazione gestisce le ReservedResource collegate */
  reservationStateId: Scalars['ID'];
  /** Lista delle ReservedResource alla prenotazione */
  reservedResources?: InputMaybe<Array<ReservationResourceInput>>;
  searchInfo?: InputMaybe<ReservationSearchInfoInput>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};

export const ReservationMessageTemplateCode = {
  COMMUNICATION: 'COMMUNICATION',
  LINK2PAY: 'LINK2PAY',
  RESERVATION: 'RESERVATION',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  WCI: 'WCI'
} as const;

export type ReservationMessageTemplateCode = typeof ReservationMessageTemplateCode[keyof typeof ReservationMessageTemplateCode];
export type ReservationOptions = {
  overbooking?: InputMaybe<OvbResolveType>;
  production?: InputMaybe<ReservationProductionType>;
};

export type ReservationPaymentInfo = {
  amount: Scalars['Int'];
  bookingPolicy: ReservationBookingPolicy;
  confirmationPageNote: Scalars['String'];
  currency: Scalars['Currency'];
  end: Scalars['Date'];
  mainGuest: ReservationPaymentInfoMainGuest;
  merchantRef?: Maybe<Scalars['String']>;
  noShow: Scalars['Int'];
  propertyName: Scalars['String'];
  reservationCode: Scalars['String'];
  start: Scalars['Date'];
};

export type ReservationPaymentInfoMainGuest = {
  id: Scalars['ID'];
  language?: Maybe<Scalars['Language']>;
  name?: Maybe<Scalars['String']>;
};

export type ReservationPortalPaymentCard = {
  /** Codice di sicurezza, se presente. */
  cvv?: Maybe<Scalars['String']>;
  /** Mese e anno di scadenza. */
  expiration: Scalars['String'];
  /** Nominativo dell'intestatario riportato sulla carta. */
  fullName: Scalars['String'];
  /** Network della carta. */
  network: Scalars['String'];
  /** Numero della carta. */
  number: Scalars['String'];
};

export const ReservationProductionType = {
  ASYNC: 'ASYNC',
  SYNC: 'SYNC'
} as const;

export type ReservationProductionType = typeof ReservationProductionType[keyof typeof ReservationProductionType];
export type ReservationQueryFilter = {
  customerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<Scalars['ID']>;
  reservationCode?: InputMaybe<StringFilter>;
  tenantId: IDFilter;
};

export type ReservationQueryOutput = {
  canceledOn?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['String']>;
  createdOn: Scalars['DateTime'];
  end: Scalars['Date'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGroup?: Maybe<Scalars['Boolean']>;
  mainGuest?: Maybe<Scalars['String']>;
  optionExpiration?: Maybe<Scalars['Date']>;
  originId: Scalars['ID'];
  portalId?: Maybe<Scalars['ID']>;
  reservationCode: Scalars['String'];
  reservationState: Scalars['String'];
  reservedResources?: Maybe<Array<ReservedResource>>;
  resources: Scalars['Int'];
  start: Scalars['Date'];
};

/** Tipo che raccoglie i riferimenti legati al customer */
export type ReservationReference = {
  agency?: Maybe<Customer>;
  /** Agenzia */
  agencyId?: Maybe<Scalars['ID']>;
  customerCompany?: Maybe<Customer>;
  /** Prenotante Azienda */
  customerCompanyId?: Maybe<Scalars['ID']>;
  customerPerson?: Maybe<Customer>;
  /** Prenotante indviduale */
  customerPersonId?: Maybe<Scalars['ID']>;
  mainGuest: Customer;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['ID'];
};

export type ReservationReferenceInput = {
  /** Agenzia */
  agencyId?: InputMaybe<Scalars['ID']>;
  /** Prenotante Azienda */
  customerCompanyId?: InputMaybe<Scalars['ID']>;
  /** Prenotante indviduale */
  customerPersonId?: InputMaybe<Scalars['ID']>;
  /** Ospite Principale, sempre obbligatorio potrebbe essere lo stesso di custmerPerson */
  mainGuestId: Scalars['ID'];
};

export type ReservationResourceInput = {
  /** Elenco di eventuali servizi aggiuntivi da aggiungere a quelli già previsti dalla tariffa */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategories?: InputMaybe<Array<ResourceChargeCategoryInput>>;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  guestOccupancies?: InputMaybe<Array<GuestOccupancyInput>>;
  id?: InputMaybe<Scalars['ID']>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  productions?: InputMaybe<Array<EmbeddedProductionInput>>;
  rateId: Scalars['ID'];
  resourceOccupancies: Array<ResourceOccupancyInput>;
  time?: InputMaybe<TimeRangeInput>;
};

export type ReservationSearchInfo = {
  customerCompanyName?: Maybe<Scalars['String']>;
  customerPersonName?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Date']>;
  mainGuestName: Scalars['String'];
  resources: Scalars['Int'];
  start?: Maybe<Scalars['Date']>;
};

export type ReservationSearchInfoInput = {
  customerCompanyName?: InputMaybe<Scalars['String']>;
  customerPersonName?: InputMaybe<Scalars['String']>;
  mainGuestName: Scalars['String'];
};

/** Gli stati della prenotazione, dovranno essere precaricati in automatico definire un set */
export type ReservationState = {
  auditable: Auditable;
  canceled: Scalars['Boolean'];
  color: Scalars['String'];
  confirmed: Scalars['Boolean'];
  custom: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  noshow: Scalars['Boolean'];
  optioned: Scalars['Boolean'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type ReservationStateInput = {
  canceled: Scalars['Boolean'];
  color: Scalars['String'];
  confirmed: Scalars['Boolean'];
  icon: Scalars['String'];
  name: Scalars['String'];
  noshow: Scalars['Boolean'];
  optioned: Scalars['Boolean'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type ReservationStateQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type ReservationUpdateInput = {
  bills?: InputMaybe<Array<ReservationBillInput>>;
  credit?: InputMaybe<CreditType>;
  disableAutomation?: InputMaybe<Scalars['Boolean']>;
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
  group?: InputMaybe<Scalars['String']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Array<NoteInput>>;
  optionExpiration?: InputMaybe<Scalars['Date']>;
  originId?: InputMaybe<Scalars['ID']>;
  paCIG?: InputMaybe<Scalars['String']>;
  /**  DatiOrdineAcquisto  */
  paOrder?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Array<Scalars['ID']>>;
  reference?: InputMaybe<ReservationReferenceInput>;
  reservationStateId?: InputMaybe<Scalars['ID']>;
  reservedResources?: InputMaybe<Array<ReservationResourceInput>>;
  tagsId?: InputMaybe<Array<Scalars['ID']>>;
  tenantId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
};

/**
 * La ReservedResource è l'impegno di una tipologia di risorsa, in caso di PMS la ReservedResource cambia fase.
 * Lo stato nelle ReservedResource è molto importante, lo stato Active indica che l'impegno scarica la disponibilità;
 * gli altri casi sono gestiti a livello logico dall'applicazione.
 * Per le persone abbiamo diviso per adulti e bambini, con la possibilità di avere il dettaglio dei bambini.
 * Le proprietà che iniziano per 'reserved' indicano il dato inserito con la prenotazione e si potranno discostare rispetto ai dati effettivi che saranno gestiti in fase di checkin.
 */
export type ReservedResource = {
  /** Lista degli eventuali servizi aggiuntivi (sia quelli richiesti dall'utente che già previsti dalla tariffa). */
  additionalServices?: Maybe<Array<EmbeddedAdditionalService>>;
  adults: Scalars['Int'];
  auditable: Auditable;
  /** Riferimento per sistemi di automation esterni */
  automationId?: Maybe<Scalars['String']>;
  /** Lista delle eventuali chargeCategory alternative per data */
  chargeCategories?: Maybe<Array<ResourceChargeCategory>>;
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  /** Prezzi provenienti dal RateQuery memorizzati per futuri ricalcoli */
  dailyPricesStored?: Maybe<ReservedResourceDailyPricesStored>;
  end: Scalars['Date'];
  guestOccupancies?: Maybe<Array<GuestOccupancy>>;
  id: Scalars['ID'];
  /** Prezzi giornalieri */
  manualDailyPrices?: Maybe<Array<ManualDailyPrice>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: Maybe<Scalars['Int']>;
  phase: ReservedResourcePhase;
  /** La policy viene salvata in modo da non avere problemi in caso in cui venga modificata successivamente. */
  policy: ReservationBookingPolicy;
  /** Riferimento esterno per prenotazioni scaricate dai portali */
  portalExternalId?: Maybe<Scalars['String']>;
  /** Addebiti giornalieri già calcolati e legati ai conti */
  productions?: Maybe<Array<Production>>;
  propertyId: Scalars['ID'];
  rate: Rate;
  /** La rate è sulla singola attività, se ci sono molteplici rate sono sugli addebiti */
  rateId: Scalars['ID'];
  reservation: Reservation;
  reservationId: Scalars['ID'];
  reservedAdults: Scalars['Int'];
  reservedChildOccupancies?: Maybe<Array<ChildOccupancy>>;
  reservedChildren: Scalars['Int'];
  reservedEnd: Scalars['Date'];
  /**
   * Fino a quando la la fase è reservation le date start e end sono sincronizzate,
   * poi quando siamo in checkin, in particolare la data di end può variare.
   */
  reservedStart: Scalars['Date'];
  /** Viene attivato nel cambio configurazione se non riesce a creare gli impegni shadow per questa risorsa */
  resourceCompositionError?: Maybe<Scalars['Boolean']>;
  /** Lista delle risorse occupate durante il soggiorno */
  resourceOccupancies: Array<ResourceOccupancy>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: Maybe<TimeRange>;
};

export type ReservedResourceDailyPricesStored = {
  adults: Scalars['Int'];
  childOccupancy?: Maybe<Array<ChildOccupancy>>;
  children: Scalars['Int'];
  dailyPrices: Array<DailyPrice>;
  persons: Scalars['Int'];
  rateId: Scalars['ID'];
};

export type ReservedResourceEvent = {
  cityTaxRequired?: Maybe<Scalars['Boolean']>;
  dashBoardKpiRefreshRequired?: Maybe<Scalars['Boolean']>;
  end: Scalars['Date'];
  forecastFull?: Maybe<Scalars['Boolean']>;
  forecastRequired?: Maybe<Scalars['Boolean']>;
  forecastUpdated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  operation: CrudOperation;
  overbooking?: Maybe<Array<OverbookingResult>>;
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ReservedResourceEventFilter = {
  propertyId: Scalars['ID'];
  range?: InputMaybe<ClosedRangeInput>;
  tenantId: Scalars['ID'];
};

export type ReservedResourceInput = {
  /** Elenco di eventuali servizi aggiuntivi da aggiungere a quelli già previsti dalla tariffa */
  additionalServices?: InputMaybe<Array<EmbeddedAdditionalServiceInput>>;
  adults: Scalars['Int'];
  chargeCategories?: InputMaybe<Array<ResourceChargeCategoryInput>>;
  chargeCategoryId: Scalars['ID'];
  childOccupancies?: InputMaybe<Array<ChildOccupancyInput>>;
  children: Scalars['Int'];
  guestOccupancies?: InputMaybe<Array<GuestOccupancyInput>>;
  /** Prezzi giornalieri */
  manualDailyPrices?: InputMaybe<Array<ManualDailyPriceInput>>;
  /** Prezzo manuale (per camera per notte) */
  manualPrice?: InputMaybe<Scalars['Int']>;
  policy?: InputMaybe<ReservationBookingPolicyInput>;
  productions?: InputMaybe<Array<EmbeddedProductionInput>>;
  rateId: Scalars['ID'];
  reservationId: Scalars['ID'];
  resourceOccupancies: Array<ResourceOccupancyInput>;
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type ReservedResourceMultiInput = {
  id: Scalars['ID'];
  reservedResource: ReservedResourceInput;
};

export type ReservedResourceOptions = {
  overbooking?: InputMaybe<OvbResolveType>;
  production?: InputMaybe<ReservedResourceProductionType>;
};

export const ReservedResourcePhase = {
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  RESERVATION: 'RESERVATION'
} as const;

export type ReservedResourcePhase = typeof ReservedResourcePhase[keyof typeof ReservedResourcePhase];
export type ReservedResourceProductionEvent = {
  end: Scalars['Date'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ReservedResourceProductionEventFilter = {
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export const ReservedResourceProductionType = {
  ASYNC: 'ASYNC',
  ASYNC_FULL: 'ASYNC_FULL',
  SKIP: 'SKIP',
  SYNC: 'SYNC',
  SYNC_FULL: 'SYNC_FULL'
} as const;

export type ReservedResourceProductionType = typeof ReservedResourceProductionType[keyof typeof ReservedResourceProductionType];
export type ReservedResourceQueryFilter = {
  dateRange?: InputMaybe<ClosedRangeInput>;
  excludeCanceled?: InputMaybe<Scalars['Boolean']>;
  guestId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<IDFilter>;
  phase?: InputMaybe<ReservedResourcePhase>;
  propertyId?: InputMaybe<IDFilter>;
  reservationId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** La risorsa è l'entità fisica del sistema, viene creata solo nella gestione del PMS */
export type Resource = {
  auditable: Auditable;
  cleaningState: CleaningState;
  /** Il codice può essere il numerodi camera 100,101 oppure APP SOle */
  code: Scalars['String'];
  /** Codice Istat della risorsa. Valorizzato quando il sistema Istat assegna un codice specifico alla risorsa (ad es. WebTur-Friuli, per le risorse di tipo 'appartamento'). */
  codeIstat?: Maybe<Scalars['String']>;
  codeItalianPs?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  lastCleaningDate?: Maybe<Scalars['DateTime']>;
  layout?: Maybe<ResourceLayout>;
  layoutId?: Maybe<Scalars['ID']>;
  position?: Maybe<Position>;
  positionId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  resourceType: ResourceType;
  /** Il resourcetype associato alla risora serve per alimentare l'inventory */
  resourceTypeId: Scalars['ID'];
  /** Ordinamento utilizzato solo dal room tetris per assegnare le camere */
  roomTetrisOrder: Scalars['Int'];
  tenantId: Scalars['ID'];
  unavailabilities?: Maybe<Array<ResourceUnavailability>>;
};

export type ResourceAvailabilityInput = {
  endDate: Scalars['Date'];
  resourceId: Scalars['ID'];
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type ResourceAvailabilityRequest = {
  adults: Scalars['Int'];
  childOccupancy?: Maybe<Array<ChildOccupancyAvailabilityRequest>>;
  quantity: Scalars['Int'];
};

/** Rate Query Embedded Type */
export type ResourceAvailabilityRq = {
  availability: Scalars['Int'];
  /**
   * City Tax amount for single requested Room (you must multiply each value by the corrisponding RqQueryFilter.resources.$.quantity)
   * In case of empty array or array with zero values, contact the structure for more information
   */
  cityTaxAmount?: Maybe<Scalars['Int']>;
  dailyAvailability?: Maybe<Array<DailyAvailabilityRq>>;
  inventory: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

/** Tipo che ci permette di definire una chargeCategory alternativa su alcune date */
export type ResourceChargeCategory = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
};

export type ResourceChargeCategoryInput = {
  chargeCategoryId: Scalars['ID'];
  day: Scalars['Date'];
};

/** All'interno della tariffa è comunque possibile specificare in modo puntuale il prezzo delle risorse per arrangiamento */
export type ResourceChargeRate = {
  chargeCategory: ChargeCategory;
  chargeCategoryId: Scalars['ID'];
  /** Giorno Chiuso in arrivo */
  closedToArrival?: Maybe<Scalars['Boolean']>;
  /** Giorno Chiuso in partenza */
  closedToDeparture?: Maybe<Scalars['Boolean']>;
  /** Eredita la min stay della rate principale */
  minStay?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  /**
   * In caso in cui non è possibile derivare i prezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  priceType: PriceType;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: Maybe<Array<RuleOccupation>>;
};

export type ResourceCleaningStateInput = {
  cleaningState: CleaningState;
  id: Scalars['ID'];
  layoutId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

/**
 *  Per le risorse orarie va specificato "time":
 * - se più prenotazioni impegnano una specifica risorsa in orari diversi questa viene conteggiata una sola volta
 * - le prenotazioni che impegnano la tipologia senza specificare una risorsa scalano una camera ciascuna (senza tener conto degli orari)
 */
export type ResourceCommitment = {
  relatedResourceId?: Maybe<Scalars['ID']>;
  resourceId: Scalars['ID'];
  time?: Maybe<TimeRange>;
  type: ResourceCommitmentType;
};

export const ResourceCommitmentType = {
  RESERVATION: 'RESERVATION',
  UNAVAILABILITY: 'UNAVAILABILITY'
} as const;

export type ResourceCommitmentType = typeof ResourceCommitmentType[keyof typeof ResourceCommitmentType];
export type ResourceEvent = {
  cleaningStateUpdated?: Maybe<Scalars['Boolean']>;
  codeUpdated?: Maybe<Scalars['Boolean']>;
  descriptionUpdated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  layoutUpdated?: Maybe<Scalars['Boolean']>;
  operation: CrudOperation;
  propertyId: Scalars['ID'];
  resourceTypeUpdated?: Maybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  unavailabilityUpdated?: Maybe<Scalars['Boolean']>;
};

export type ResourceEventFilter = {
  cleaningStateUpdated?: InputMaybe<Scalars['Boolean']>;
  codeUpdated?: InputMaybe<Scalars['Boolean']>;
  descriptionUpdated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  layoutUpdated?: InputMaybe<Scalars['Boolean']>;
  operation?: InputMaybe<CrudOperation>;
  propertyId: Scalars['ID'];
  resourceTypeUpdated?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
  unavailabilityUpdated?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceHousekeeping = {
  cleaningState: CleaningState;
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  layout?: Maybe<ResourceLayout>;
  layoutId?: Maybe<Scalars['ID']>;
  position?: Maybe<Position>;
  positionId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservedResource?: Maybe<ReservedResource>;
  reservedResourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailabilities?: Maybe<Array<ResourceUnavailability>>;
};

export type ResourceInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  layoutId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  roomTetrisOrder?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};

export const ResourceKind = {
  APARTMENT: 'APARTMENT',
  BED: 'BED',
  ROOM: 'ROOM'
} as const;

export type ResourceKind = typeof ResourceKind[keyof typeof ResourceKind];
/**
 * I possibili layout per comporre la camera, in base all'occupazione sono elencati, occupazione 2 un matrimoniale o 2 singoli, un divano letto un posto etc ect.
 * All'interno delle singole tipologie si può aggiungere i possibili scenari
 */
export type ResourceLayout = {
  auditable: Auditable;
  description: Scalars['LocalizedString'];
  id: Scalars['ID'];
  occupation: Scalars['Int'];
};

export type ResourceLayoutInput = {
  description: Scalars['String'];
  occupation: Scalars['Int'];
};

export type ResourceLayoutQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

/**
 * "
 * Questo tipo serve per definire all'interno dell'ReservedResource quale risorse viene impegnata. Potrebbe non esserci la risorsa vera e propria
 * L'obbiettivo è quello di poter pianficare eventuali cambi camera e cmq tenere traccia degli spostatmenti durante il soggiorno
 */
export type ResourceOccupancy = {
  assignedResourceType: ResourceType;
  /** La assignedResourceType è quella effettivamente assegnata (ad esempio in equivalenza. Se c'è resourceId deve essere la resourceType legata alla resource) */
  assignedResourceTypeId: Scalars['ID'];
  commitments?: Maybe<Array<ResourceOccupancyCommitment>>;
  end: Scalars['Date'];
  phase: ReservedResourcePhase;
  reservedResourceLayout?: Maybe<ResourceLayout>;
  reservedResourceLayoutId?: Maybe<Scalars['ID']>;
  reservedResourceType: ResourceType;
  /** La reservedResourcetype è quella venduta */
  reservedResourceTypeId: Scalars['ID'];
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  start: Scalars['Date'];
};

export type ResourceOccupancyCommitment = {
  quantity: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  resources?: Maybe<Array<Resource>>;
  resourcesId?: Maybe<Array<Scalars['ID']>>;
};

export type ResourceOccupancyCommitmentInput = {
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceOccupancyInput = {
  assignedResourceTypeId?: InputMaybe<Scalars['ID']>;
  commitments?: InputMaybe<Array<ResourceOccupancyCommitmentInput>>;
  end: Scalars['Date'];
  reservedResourceLayoutId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  /** La resourcetype è quella venduta */
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
};

export type ResourceQueryFilter = {
  cleaningState?: InputMaybe<CleaningState>;
  id?: InputMaybe<IDFilter>;
  propertyId: IDFilter;
  resourceTypeId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Tipo da utilizzare sulle richieste di rate query */
export type ResourceRQInput = {
  adults: Scalars['Int'];
  childOccupancy?: InputMaybe<Array<ChildOccupancyRQInput>>;
  quantity: Scalars['Int'];
};

/** Prezzi delle tipologie per l'arrangiamento base. */
export type ResourceRate = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: Maybe<Array<PriceOccupation>>;
  /** Per adesso gestiamo solo prezzo a Camera */
  priceType: PriceType;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: Maybe<Array<RuleOccupation>>;
};

export type ResourceRateBaseInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  resourceType: ResourceTypeBaseInput;
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
};

/** Prezzi delle tipologie per l'arrangiamento base. */
export type ResourceRateInput = {
  price: Scalars['Int'];
  /**
   * In caso in cui non è possibile derivare i rezzi per le occupazioni diverse è necessario
   * impostare il prezzo per le occupazioni possibili.
   */
  priceForDifferentOccupation?: InputMaybe<Array<PriceOccupationInput>>;
  /** Per adesso gestiamo solo prezzo a Camera */
  priceType: PriceType;
  resourceTypeId: Scalars['ID'];
  /**
   * In caso in cui si vogliano avere prezzi diversificati per le occupazioni previste è necessario specificarle
   * E' possibile avere derivazioni differenti per periodo.
   */
  rulesForDifferentOccupation?: InputMaybe<Array<RuleOccupationInput>>;
};

/** Il resourcetype è l'entità base del sistema, tutta la logica della disponibilità e prezzi gira su questa entità. */
export type ResourceType = {
  /**
   * Indica il numero aggiuntivo di persone oltre Persons che possono prenotare questa tipologia.
   * Se non viene gestito il numero è uguale a zero.
   */
  additionalPersons: Scalars['Int'];
  amenities?: Maybe<Array<Amenity>>;
  amenitiesId?: Maybe<Array<Scalars['ID']>>;
  auditable: Auditable;
  autoEquivalent: Scalars['Boolean'];
  /** Codice esplicativo XX, X */
  code?: Maybe<Scalars['String']>;
  configurationsLayout?: Maybe<Array<ResourceLayout>>;
  configurationsLayoutId?: Maybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  /** Nome personalizzato */
  customName?: Maybe<Scalars['LocalizedString']>;
  defaultLayout?: Maybe<ResourceLayout>;
  defaultLayoutId?: Maybe<Scalars['ID']>;
  description: Scalars['LocalizedString'];
  equivalences: Array<ResourceTypeOption>;
  id: Scalars['ID'];
  imageIds?: Maybe<Array<Scalars['ID']>>;
  images?: Maybe<Array<File>>;
  /** L'inventory se è attiva la licenza del PMS è alimentata dall'inserimento delle risorse, nel IBE e Channel deve essere imputato. */
  inventory: Scalars['Int'];
  logicalType: Scalars['Boolean'];
  /**
   * Se viene gestito indica il numero massimo di adulti che possono essere aggiunti, in quel caso la differenza tra maxperson e maxadults
   * indica quanti bambini possono essere aggiunti.
   */
  maxAdults?: Maybe<Scalars['Int']>;
  /**
   * Tariffa minima, sotto questa tariffa il sistema non invia o non pubblica le tariffe di questa risorsa
   * Serve per sicurezza.
   */
  minRate: Scalars['Int'];
  name: Taxonomy;
  /** Il name è doppia, tripla, monolocale etc.ect. */
  nameId: Scalars['ID'];
  order: Scalars['Int'];
  /** Numero base di persone che occupano la tipologia. */
  persons: Scalars['Int'];
  propertyId: Scalars['ID'];
  /** Tariffa massima , viene usata su sistema non ancora inizializzati */
  rackRate: Scalars['Int'];
  resourceCategory: Taxonomy;
  /** La categoria è Camera, Appartamento, Posto Letto.. */
  resourceCategoryId: Scalars['ID'];
  resources?: Maybe<Array<Resource>>;
  tenantId: Scalars['ID'];
  /** Configurazione dell'orario di attività. Se valorizzata, indica che questa è una tipologia a pianificazione oraria. */
  timeConfiguration?: Maybe<TimeConfiguration>;
  visibilityOnIbe: Scalars['Boolean'];
};

export type ResourceTypeAvailabilityError = {
  error: Scalars['String'];
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeAvailabilityInput = {
  endDate: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  startDate: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type ResourceTypeBaseInput = {
  additionalPersons: Scalars['Int'];
  amenitiesId?: InputMaybe<Array<Scalars['ID']>>;
  autoEquivalent?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  configurationsLayoutId?: InputMaybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  customName?: InputMaybe<Scalars['LocalizedString']>;
  description: Scalars['LocalizedString'];
  equivalences?: InputMaybe<Array<ResourceTypeOptionInput>>;
  inventory: Scalars['Int'];
  logicalType?: InputMaybe<Scalars['Boolean']>;
  maxAdults?: InputMaybe<Scalars['Int']>;
  minRate: Scalars['Int'];
  nameId: Scalars['ID'];
  order: Scalars['Int'];
  persons: Scalars['Int'];
  resourceCategoryId: Scalars['ID'];
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
};

export type ResourceTypeEquivalence = {
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeEquivalenceInput = {
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeImageInput = {
  images?: InputMaybe<Array<Scalars['ID']>>;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeInput = {
  additionalPersons: Scalars['Int'];
  amenitiesId?: InputMaybe<Array<Scalars['ID']>>;
  autoEquivalent?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  configurationsLayoutId?: InputMaybe<Array<Scalars['ID']>>;
  currency: Scalars['Currency'];
  customName?: InputMaybe<Scalars['LocalizedString']>;
  defaultLayoutId?: InputMaybe<Scalars['ID']>;
  description: Scalars['LocalizedString'];
  equivalences?: InputMaybe<Array<ResourceTypeOptionInput>>;
  inventory: Scalars['Int'];
  logicalType?: InputMaybe<Scalars['Boolean']>;
  maxAdults?: InputMaybe<Scalars['Int']>;
  minRate: Scalars['Int'];
  nameId: Scalars['ID'];
  order: Scalars['Int'];
  persons: Scalars['Int'];
  propertyId: Scalars['ID'];
  rackRate: Scalars['Int'];
  resourceCategoryId: Scalars['ID'];
  tenantId: Scalars['ID'];
  timeConfiguration?: InputMaybe<TimeConfigurationInput>;
  /**  visibilityOnIbe default: true  */
  visibilityOnIbe?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Tipo che permette di gestire le equivalenze per le tipologie fisiche e logiche (solo le tipologie logiche possono avere composizioni)
 * E' permessa anche la composizione con un solo elemento che però si comporta diversamente dall'equivalenza.
 * L'equivalenza, infatti, non impegna "al contrario" come fa la composizione; inoltre, in prenotazione, la camera assegnata è sempre quella equivalente.
 * Es: A -> B (equivalenza)
 *         se prenoto A, e A non è disponibile, avrò come assegnata B e ci sarà un impegno ombra su A solo se questa è logica
 *         se prenoto B non ci sarà nessun impegno ombra
 * Es: A = B + C (composizione)
 *         se prenoto A, avrò A come risorsa assegnata e ci saranno impegni ombra su B e C
 *         se prenoto B o C, verrà creato un impegno ombra su A
 *     A = D (composizione verso una sola risorsa)
 *         se prenoto A, avrò A come risorsa assegnata e ci sarà un impegno ombra su D
 *         se prenoto D, verrà creato un impegno ombra su A (comportamento differente rispetto all'equivalenza)
 */
export type ResourceTypeOption = {
  /**  Elenco che costituisce la composizione (nel caso di equivalenza può contenere un solo elemento)  */
  group: Array<ResourceTypeEquivalence>;
  logicResourceId?: Maybe<Scalars['ID']>;
  order: Scalars['Int'];
  type: OptionType;
};

export type ResourceTypeOptionInput = {
  /**  Elenco che costituisce la composizione (nel caso di equivalenza contiene un solo elemento)  */
  group: Array<ResourceTypeEquivalenceInput>;
  logicResourceId?: InputMaybe<Scalars['ID']>;
  order: Scalars['Int'];
  type: OptionType;
};

export type ResourceTypePriceRange = {
  price: Scalars['Int'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypePriceRangeInput = {
  price: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type ResourceTypeQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
  timeResources?: InputMaybe<Scalars['Boolean']>;
};

export const ResourceTypeTimeUnitOfMeasurement = {
  DAY: 'DAY',
  HALF_DAY: 'HALF_DAY',
  HALF_HOUR: 'HALF_HOUR',
  HOUR: 'HOUR',
  QUARTER: 'QUARTER'
} as const;

export type ResourceTypeTimeUnitOfMeasurement = typeof ResourceTypeTimeUnitOfMeasurement[keyof typeof ResourceTypeTimeUnitOfMeasurement];
export type ResourceUnavailability = {
  /**  end date has the same behavior as the reservation end date (the end day is not considered)  */
  end: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type ResourceUnavailabilityInput = {
  /**  end date has the same behavior as the reservation end date (the end day is not considered)  */
  end: Scalars['Date'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  start: Scalars['Date'];
};

export type RetryImportPropertyInput = {
  extPropertyId: Scalars['String'];
  tenantId: Scalars['ID'];
};

/**
 * Ruoli autorizzativi Admin, Delivery, Proprietrio, Direttore, FOM (Front Office Manager), Receptions...
 * E' possibile avere dei ruoli per tenant
 */
export type Role = {
  auditable: Auditable;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  permissions?: Maybe<Array<Permissions>>;
  /** Se true, non può essere impostato da fe */
  systemRole?: Maybe<Scalars['Boolean']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type RoleQueryFilter = {
  id?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type RollBackImportInput = {
  deleteImported: Scalars['Boolean'];
  deleteProperty: Scalars['Boolean'];
  extPropertyId: Scalars['String'];
  stepFrom: UndoImportStep;
  tenantId: Scalars['ID'];
};

/** Risultati del rate query per risorsa */
export type RqForResourceOutput = {
  id: Scalars['ID'];
  rate: RateRq;
};

/** Risultati del rate query */
export type RqOutput = {
  id: Scalars['ID'];
  rates?: Maybe<Array<RateRq>>;
  resources?: Maybe<Array<ResourceAvailabilityRq>>;
};

/**
 * Ratequery Filter
 * UserId ci permette di capire se la query viene fatta dal pms o da un sistema esterno.
 */
export type RqQueryFilter = {
  chargeCategoryId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  end: Scalars['Date'];
  ibeCode?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  rateId?: InputMaybe<Scalars['ID']>;
  resources: Array<ResourceRQInput>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type RqQueryForResourceFilter = {
  adults: Scalars['Int'];
  chargeCategoryId: Scalars['ID'];
  childOccupancy?: InputMaybe<Array<ChildOccupancyRQInput>>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  rateId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

/**
 * Tipo che identifica la regola del prezzo aggiuntivo a valore o in percentuale, occupancy è il numero di occupante aggiuntivo.
 * Può esserci collegata una validità, in modo da cambiare in base al periodo le variazioni
 */
export type RuleOccupation = {
  occupancy: Scalars['Int'];
  type: ValueType;
  validity?: Maybe<Range>;
  value: Scalars['Float'];
  variation: MathOperation;
};

/**
 * Tipo che identifica la regola del prezzo aggiuntivo a valore o in percentuale, occupancy è il numero di occupante aggiuntivo.
 * Può esserci collegata una validità, in modo da cambiare in base al periodo le variazioni
 */
export type RuleOccupationInput = {
  occupancy: Scalars['Int'];
  type: ValueType;
  validity?: InputMaybe<RangeInput>;
  value: Scalars['Float'];
  variation: MathOperation;
};

export type ScelAdditionalInfo = {
  /**  Live from FiscalGateway Hook  */
  canceled?: Maybe<Scalars['Boolean']>;
  /** last error received */
  lastError?: Maybe<Scalars['String']>;
  /** Note for FiscalGateway */
  note?: Maybe<Scalars['String']>;
  /** order_id sent to FiscalGateway */
  orderId: Scalars['String'];
  /** Sent to FiscalGateway (attempts) */
  sent: Scalars['Int'];
  /**  State from FiscalGateway Hook  */
  state?: Maybe<ScelState>;
  /** Timestamp of last update */
  timeStamp: Scalars['DateTime'];
};

export const ScelState = {
  DONE: 'DONE',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  WAITING: 'WAITING'
} as const;

export type ScelState = typeof ScelState[keyof typeof ScelState];
export const SdiFlowType = {
  SDIPA: 'SDIPA',
  SDIPR: 'SDIPR'
} as const;

export type SdiFlowType = typeof SdiFlowType[keyof typeof SdiFlowType];
export type SendAvailabilitiesAndPricesInput = {
  channelId: Scalars['ID'];
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendIstatCancellationInput = {
  /** Nome della configurazione Istat. */
  configurationName?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendIstatInput = {
  /** Nome della configurazione Istat. Se non specificato, l'invio verrà eseguito per tutte le configurazioni della struttura. */
  configurationName?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SendIstatPeriodInput = {
  /** Nome della configurazione Istat. Se non specificato, l'invio verrà eseguito per tutte le configurazioni della struttura. */
  configurationName?: InputMaybe<Scalars['String']>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
};

export type SendMessageInput = {
  internalNote: Scalars['Boolean'];
  message: Scalars['String'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type SendPSInput = {
  date: Scalars['Date'];
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  testOnly: Scalars['Boolean'];
};

export type SendPosLink2PayEmailInput = {
  orderKey: Scalars['String'];
  propertyId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type SendQuotationEmailInput = {
  propertyId: Scalars['ID'];
  quotationId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type SendReservationMessageInput = {
  body?: InputMaybe<Scalars['String']>;
  messageTemplateId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  sendTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type ServiceAvailability = {
  entireStay: Scalars['Boolean'];
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  time?: Maybe<TimeRange>;
};

export type ServiceAvailabilityInput = {
  entireStay: Scalars['Boolean'];
  resourceTypeId: Scalars['ID'];
  time?: InputMaybe<TimeRangeInput>;
};

export type SetNcsUserPreferenceInput = {
  preferences: Array<NcsTemplatePreferenceInput>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SetPropertyConfigurationsInput = {
  cityTaxConfigurations?: InputMaybe<Array<PropertyResourceMultiConfigurationInput>>;
  fiscalConfigurations?: InputMaybe<Array<PropertyResourceTypeMultiConfigurationInput>>;
  istatConfigurations?: InputMaybe<Array<PropertyResourceMultiConfigurationInput>>;
  propertyId: Scalars['ID'];
  psConfigurations?: InputMaybe<Array<PropertyPsConfigurationInput>>;
  subAddresses?: InputMaybe<Array<PropertyResourceTypeMultiConfigurationInput>>;
  tenantId: Scalars['ID'];
};

export const SetQuotationState = {
  CANCELED: 'CANCELED',
  READ: 'READ',
  SENT: 'SENT'
} as const;

export type SetQuotationState = typeof SetQuotationState[keyof typeof SetQuotationState];
/**
 * Un impegno ombra è generato dalle prenotazioni su tipologie composte e serve per impegnare gli elementi della composizione o il contenitore.
 * Ad esempio, per gli ostelli, dove abbiamo Camerate e Posti Letto:
 * - quando prenoto una camerata impegno, con impegni ombra, tutti i posti letto che la compongono
 * - quando prenoto un posto letto impegno, con un impegno ombra, anche la camerata in cui si trova
 * Gli impegni ombra in cui è fissato resourceId vengono raggruppati e si conteggiano una sola volta per risorsa,
 * quelli in cui non è presente resourceId scalano la disponibilità in egual numero.
 */
export type ShadowCommitment = {
  reservedResource: ReservedResource;
  reservedResourceId: Scalars['ID'];
  resourceId?: Maybe<Scalars['ID']>;
  time?: Maybe<TimeRange>;
};

export type SinapsiAutopilot = {
  active: Scalars['Boolean'];
  max_n_days?: Maybe<Scalars['Int']>;
};

export type SinapsiAutopilotInput = {
  active: Scalars['Boolean'];
  max_n_days?: InputMaybe<Scalars['Int']>;
};

export type SinapsiAutopilotOptions = {
  /** If false, recompute the cache from scratch; otherwise (default) incrementally update it with the latest events */
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  /** If present, override the SERIAL_QUERIES constant in parameters.ts */
  serial_queries_override?: InputMaybe<Scalars['Boolean']>;
};

export type SinapsiBudgetForecast = {
  closed?: Maybe<Scalars['Float']>;
  long_term?: Maybe<Scalars['Float']>;
  month: Scalars['String'];
  no_ave?: Maybe<Scalars['Float']>;
  otb: Scalars['Int'];
  otb_one_year_ago?: Maybe<Scalars['Int']>;
  to_come: Scalars['Int'];
  total: Scalars['Int'];
};

/** Competitor property pricing info as provided to clients */
export type SinapsiCompetitorAccommodationItem = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<Scalars['Int']>;
};

export type SinapsiCompetitorLocationItem = {
  location: Scalars['String'];
};

/** Portal-dependent info for a competitor */
export type SinapsiCompetitorPortalInfo = {
  /** Customer review stars of the property translated to a 0-10 scale */
  customer_stars?: Maybe<Scalars['Float']>;
  /** ID of the property within the portal (may not be unique across portals) */
  id: Scalars['String'];
  /** We might consider an ID to the 'portals' collection, but some portals might be outside the CM scope */
  portal_name: Scalars['String'];
  /** List of rooms inferred by the portal's results pages, if any */
  rooms?: Maybe<Array<SinapsiCompetitorRoomInfo>>;
};

export type SinapsiCompetitorPriceItem = {
  amount: Scalars['Float'];
  checkin: Scalars['Date'];
  guests: Scalars['Int'];
  nights: Scalars['Int'];
  room_id?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type SinapsiCompetitorPricingInfoByPortal = {
  customer_stars?: Maybe<Scalars['Float']>;
  portal_name?: Maybe<Scalars['String']>;
  prices: Array<SinapsiCompetitorPriceItem>;
  rooms?: Maybe<Array<SinapsiCompetitorAccommodationItem>>;
};

/**
 * Represents a property as it appears on a typical portal's results listing.
 * Maintains an array of all retrieved prices.
 */
export type SinapsiCompetitorProperty = {
  auditable: Auditable;
  /** Official star ranking */
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Location of the hotel, as inferred by the scraper */
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * Every property must be referenced by at least one portal, possibly many.
   * Properties that may vary across portals are stored here.
   */
  portal_info: Array<SinapsiCompetitorPortalInfo>;
  /** Retrieved pricing info */
  pricing_info: Array<SinapsiCompetitorRetrievalResult>;
  /** If available, type inferred from some portal's results page (e.g., 'Hotel', 'B&B...) */
  type?: Maybe<Scalars['String']>;
};

/**
 * Info about a property's accommodation type as returned by the portal's results page.
 * The ID must be unique within a (portal, property) combination.
 */
export type SinapsiCompetitorPropertyAccommodationItem = {
  id: Scalars['String'];
  name: Scalars['String'];
  occupancy?: InputMaybe<Scalars['Int']>;
};

/** Subset of competitor property info, returned by API searching for properties in a specific geographic area */
export type SinapsiCompetitorPropertyBasicInfo = {
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/**
 * Info about a property as returned by the portal's results page.
 * The scraper must provide a unique ID for each property within a portal; if the portal
 * does not provide such information, the scraper should create the ID by hashing some stable information about the property.
 */
export type SinapsiCompetitorPropertyItem = {
  /** List of accommodations, if the portal distinguishes them, referenced by the price items list. May be empty. */
  accommodations?: InputMaybe<Array<SinapsiCompetitorPropertyAccommodationItem>>;
  /** Customer review  stars as reported by the portal, translated to a 0-10 scale */
  customer_stars?: InputMaybe<Scalars['Float']>;
  /** Number of official stars, if applicable */
  hotel_stars?: InputMaybe<Scalars['Int']>;
  /** Portal's property ID */
  id: Scalars['String'];
  /** Location of the hotel, as inferred by the scraper */
  location?: InputMaybe<Scalars['String']>;
  /** Name of the property according to the portal's results page */
  name: Scalars['String'];
  /** List of retrieved pricing entries */
  pricing: Array<SinapsiCompetitorPropertyPriceItem>;
  /** Type of the property according to the portal's results page */
  type?: InputMaybe<Scalars['String']>;
};

/**
 * A single quotation returned by the scraped portal. Only variable quantities not contained in the query.
 * (e.g., number of nights is defined by the task)
 */
export type SinapsiCompetitorPropertyPriceItem = {
  /** Portal-defined ID of the corresponding accommodation. May be undefined. */
  accommodation_id?: InputMaybe<Scalars['String']>;
  /** Quotation (in cents) */
  amount: Scalars['Int'];
  /** Check-in date of the quotation */
  checkin: Scalars['Date'];
};

export type SinapsiCompetitorPropertyPricingInfo = {
  hotel_stars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pricing_info: Array<SinapsiCompetitorPricingInfoByPortal>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Represents a row in the portal's results page contains a price quote for a room given the
 * requested check-in date.
 */
export type SinapsiCompetitorRetrievalResult = {
  /** Checkin date */
  checkin: Scalars['Date'];
  /** Property/room quote, in cents */
  price: Scalars['Int'];
  /** If the room is specified, it is referenced by the portal's ID */
  roomID?: Maybe<Scalars['String']>;
  sinapsiCompetitorRetrievalTask: SinapsiCompetitorRetrievalTask;
  /** The task that generated this result, containing all query details (except check-in date, see below) */
  sinapsiCompetitorRetrievalTaskId: Scalars['ID'];
  /** when was the result retrieved */
  timestamp: Scalars['DateTime'];
};

/**
 * Represents a retrieval task performing a sequence of queries.
 * The portal's responses to these queries populate the competitorRetrievalResults collection (or update existing documents)
 * They also populate the competitorProperties collection (or, if the property already exists, update the 'hotel_stars', 'customer_stars' and 'rooms' fields)
 */
export type SinapsiCompetitorRetrievalTask = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  auditable: Auditable;
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: Maybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * Task deadline used to set the priority.
   * If present, next time the task is expected to run.
   * Updated upon task completion by adding 'period' days to the current datetime.
   * Initially missing, meaning maximum priority
   */
  next_execution?: Maybe<Scalars['DateTime']>;
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: Maybe<Scalars['Int']>;
  /**
   * If missing, null or older than 2 days, no client is running the task.
   * If present, the task has been provided to a client which hasn't returned a completion message (yet).
   * Set to null when the client sends a completion message.
   */
  running_since?: Maybe<Scalars['DateTime']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: Maybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: Maybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: Maybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

export type SinapsiCompetitorRetrievalTaskFilterInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location?: InputMaybe<Scalars['String']>;
  /** Name of the target portal */
  portal_name?: InputMaybe<Scalars['String']>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
};

export type SinapsiCompetitorRetrievalTaskInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: InputMaybe<Scalars['Int']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: InputMaybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

export type SinapsiCompetitorRetrievalTaskItem = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active: Scalars['Boolean'];
  /** Day span, starting from today, for the query's check-in date */
  day_span: Scalars['Int'];
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: Maybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location: Scalars['String'];
  /** Number of guests for which the search must be issued */
  guests: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * Task deadline used to set the priority.
   * If present, next time the task is expected to run.
   * Updated upon task completion by adding 'period' days to the current datetime.
   * Initially missing, meaning maximum priority
   */
  next_execution?: Maybe<Scalars['DateTime']>;
  /** Number of nights for which the search must be issued */
  nights: Scalars['Int'];
  /** Ideal number of days between retrievals */
  period: Scalars['Int'];
  /** Name of the target portal */
  portal_name: Scalars['String'];
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: Maybe<Scalars['Int']>;
  /**
   * If missing, null or older than 2 days, no client is running the task.
   * If present, the task has been provided to a client which hasn't returned a completion message (yet).
   * Set to null when the client sends a completion message.
   */
  running_since?: Maybe<Scalars['DateTime']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: Maybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: Maybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: Maybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: Maybe<Array<Scalars['Int']>>;
};

/** Final results of a retrieval task. */
export type SinapsiCompetitorRetrievalTaskResultsInput = {
  /** List of results. May be missing if the API is called with the sole purpose of unblocking the task for */
  results?: InputMaybe<Array<SinapsiCompetitorPropertyItem>>;
  /** ID of the completed retrieval task */
  taskId: Scalars['ID'];
};

export type SinapsiCompetitorRetrievalTaskUpdateInput = {
  /** False if task is deactivated (but still possibly referenced by retrieval results) */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Day span, starting from today, for the query's check-in date */
  day_span?: InputMaybe<Scalars['Int']>;
  /** If missing or false, only retrieve search results within the requested location - otherwise keep retrieving */
  disregard_location_boundaries?: InputMaybe<Scalars['Boolean']>;
  /** Location part of the query */
  geographic_location?: InputMaybe<Scalars['String']>;
  /** Number of guests for which the search must be issued */
  guests?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Number of nights for which the search must be issued */
  nights?: InputMaybe<Scalars['Int']>;
  /** Ideal number of days between retrievals */
  period?: InputMaybe<Scalars['Int']>;
  /** Name of the target portal */
  portal_name?: InputMaybe<Scalars['String']>;
  /** If missing or falsey, keep retrieving to the end; otherwise, stop after retrieving at least this number of different results */
  result_limit?: InputMaybe<Scalars['Int']>;
  /**
   * List of special dates that must always be queried, even if not in the correct weekday,
   * provided that they occur in the currend dayspan (e.g., Christmas, festivals, etc.)
   */
  special_days?: InputMaybe<Array<Scalars['Date']>>;
  /** Limit the query to properties with specific numbers of stars (if missing, no filter) */
  stars?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit the query to properties of a specific type (if missing, no filter) */
  type?: InputMaybe<Scalars['String']>;
  /** Which days of the week must be queried as check-in dates (0 = Sunday, all if missing) */
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

/** Portal-dependent info for a competitor's room (resource / accommodation type) */
export type SinapsiCompetitorRoomInfo = {
  /** ID of the room within the portal (may not be unique across properties) */
  id: Scalars['String'];
  /** name of the room (if provided) */
  name?: Maybe<Scalars['String']>;
  /** occupancy of the room (if provided) */
  occupancy?: Maybe<Scalars['Int']>;
};

export type SinapsiConfiguration = {
  autopilot?: Maybe<SinapsiAutopilot>;
  holidays?: Maybe<Array<SinapsiHoliday>>;
  ignore_resources?: Maybe<Array<Scalars['ID']>>;
  pricing?: Maybe<SinapsiPricing>;
  risk_profile?: Maybe<SinapsiRiskProfileParameters>;
};

export type SinapsiConfigurationInput = {
  autopilot?: InputMaybe<SinapsiAutopilotInput>;
  holidays?: InputMaybe<Array<SinapsiHolidayInput>>;
  ignore_resources?: InputMaybe<Array<Scalars['ID']>>;
  pricing?: InputMaybe<SinapsiPricingInput>;
  risk_profile?: InputMaybe<SinapsiRiskProfileParametersInput>;
};

export type SinapsiDailyPriceAuditFilterInput = {
  day: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SinapsiDailyPriceAuditOutput = {
  price: Scalars['Int'];
  timestamp: Scalars['DateTime'];
};

export type SinapsiFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SinapsiHoliday = {
  date: Scalars['Date'];
  days: Scalars['Int'];
  index?: Maybe<Scalars['Int']>;
  last_year?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type SinapsiHolidayInput = {
  date: Scalars['Date'];
  days: Scalars['Int'];
  index?: InputMaybe<Scalars['Int']>;
  last_year?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type SinapsiLastPeriodStats = {
  /** Timestamp of the last price change operation */
  last_price_change: Scalars['DateTime'];
  /**
   * Number of unique accommodation/checkin date pairs updated at least once since period_start.
   * Note that multiple updates to the same accommodation/chackin date are only counted once
   */
  n_changed_prices: Scalars['Int'];
  /** Same as above, but every change to the same accommodation/checkin date is counted separately */
  n_changes: Scalars['Int'];
  /** Date from which the following statistics are counted */
  period_start: Scalars['DateTime'];
};

export type SinapsiOutput = {
  /** List of monthly budget forecasts */
  budget_forecast?: Maybe<Array<SinapsiBudgetForecast>>;
  /** Basic stats: number of changes in the last period, see SinapsiQueryOptions.n_days_for_stats */
  last_period_stats?: Maybe<SinapsiLastPeriodStats>;
  /** List of recommended prices */
  prices?: Maybe<Array<SinapsiResourceRecommendedPrices>>;
};

export type SinapsiPriceInfos = {
  closed?: Maybe<Scalars['Boolean']>;
  pulled_by?: Maybe<Scalars['ID']>;
  pushed_by?: Maybe<Scalars['ID']>;
};

export type SinapsiPriceLimit = {
  max: Scalars['Int'];
  min: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type SinapsiPriceLimitInput = {
  max: Scalars['Int'];
  min: Scalars['Int'];
  resourceTypeId: Scalars['ID'];
};

export type SinapsiPriceOverride = {
  from: Scalars['Date'];
  limits: Array<SinapsiPriceLimit>;
  to: Scalars['Date'];
};

export type SinapsiPriceOverrideInput = {
  from: Scalars['Date'];
  limits: Array<SinapsiPriceLimitInput>;
  to: Scalars['Date'];
};

export type SinapsiPriceWarnings = {
  max?: Maybe<Scalars['Boolean']>;
  min?: Maybe<Scalars['Boolean']>;
};

export type SinapsiPricing = {
  limits?: Maybe<Array<SinapsiPriceLimit>>;
  order?: Maybe<SinapsiPricingOrder>;
  overrides?: Maybe<Array<SinapsiPriceOverride>>;
};

export type SinapsiPricingInput = {
  limits?: InputMaybe<Array<SinapsiPriceLimitInput>>;
  order?: InputMaybe<SinapsiPricingOrderInput>;
  overrides?: InputMaybe<Array<SinapsiPriceOverrideInput>>;
};

export type SinapsiPricingOrder = {
  active?: Maybe<Scalars['Boolean']>;
  exclude_from_ordering?: Maybe<Array<Scalars['ID']>>;
};

export type SinapsiPricingOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  exclude_from_ordering?: InputMaybe<Array<Scalars['ID']>>;
};

export type SinapsiQueryOptions = {
  /** Also compute budget forecast, default is true */
  do_budget?: InputMaybe<Scalars['Boolean']>;
  /** If false, recompute the cache from scratch; otherwise (default) incrementally update it with the latest events */
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  /** Number of days in the past for basic stats (if undefined, one week) */
  n_days_for_stats?: InputMaybe<Scalars['Int']>;
};

export type SinapsiResourceRecommendedPrice = {
  date: Scalars['Date'];
  debug_txt?: Maybe<Scalars['String']>;
  infos?: Maybe<SinapsiPriceInfos>;
  price: Scalars['Int'];
  warnings?: Maybe<SinapsiPriceWarnings>;
};

export type SinapsiResourceRecommendedPrices = {
  recommendations: Array<Maybe<SinapsiResourceRecommendedPrice>>;
  resourceTypeId: Scalars['ID'];
};

/** Sinapsi Configuration, embedded document */
export type SinapsiRiskProfileParameters = {
  /** low | medium | high */
  risk_appetite: Scalars['String'];
};

/**  SINAPSI PARAMETERS  */
export type SinapsiRiskProfileParametersInput = {
  /**  low | medium | high  */
  risk_appetite: Scalars['String'];
};

export type SinapsiUpdateOptions = {
  incremental_cache_update?: InputMaybe<Scalars['Boolean']>;
  perform_cache_updates: Scalars['Boolean'];
  propertyId?: InputMaybe<Scalars['ID']>;
  run_autopilot: Scalars['Boolean'];
  serial_queries_override?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type SinapsiUpdateOutcome = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
  warnings?: Maybe<Array<Scalars['String']>>;
};

export const Sort = {
  asc: 'asc',
  desc: 'desc'
} as const;

export type Sort = typeof Sort[keyof typeof Sort];
export type SplitProductionAssignedInput = {
  destinationBills?: InputMaybe<Array<Scalars['ID']>>;
  productionAssigneds: Array<Scalars['ID']>;
  splitType: SplitType;
  tenantId: Scalars['ID'];
  value: Scalars['Int'];
};

export const SplitType = {
  BY_VALUE: 'BY_VALUE',
  EQUAL_PARTS: 'EQUAL_PARTS'
} as const;

export type SplitType = typeof SplitType[keyof typeof SplitType];
/** Stati delle entità di HIC */
export const State = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  DRAFT: 'DRAFT',
  INACTIVE: 'INACTIVE'
} as const;

export type State = typeof State[keyof typeof State];
/**  STATISTIC  */
export type StatisticFilter = {
  chargeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  consolidated?: InputMaybe<Scalars['Boolean']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  end: Scalars['Date'];
  propertyId: Scalars['ID'];
  resourceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  start: Scalars['Date'];
  tenantId: Scalars['ID'];
  vatIncluded: Scalars['Boolean'];
};

export type StatisticOutput = {
  adr: Scalars['Float'];
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  inventory: Scalars['Int'];
  occupancy: Scalars['Int'];
  originDistributions: Array<OriginStatisticOutput>;
  revpar: Scalars['Float'];
  roomProduction: Scalars['Float'];
  totalProduction: Scalars['Float'];
  trevpar: Scalars['Float'];
  unavailability: Scalars['Int'];
};

export type StatisticOutputByResourceType = {
  adr: Scalars['Float'];
  currency: Scalars['Currency'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  inventory: Scalars['Int'];
  occupancy: Scalars['Int'];
  originDistributions: Array<OriginStatisticOutput>;
  resourceType: ResourceType;
  resourceTypeId: Scalars['ID'];
  revpar: Scalars['Float'];
  roomProduction: Scalars['Float'];
  totalProduction: Scalars['Float'];
  trevpar: Scalars['Float'];
  unavailability: Scalars['Int'];
};

export type StopSellInput = {
  end: Scalars['Date'];
  onlineLimit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['ID'];
  resourceTypeId: Scalars['ID'];
  start: Scalars['Date'];
  stopSellOTA?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['ID'];
};

export type StoreResponse = {
  code: Scalars['String'];
  name: Scalars['String'];
  pricesPages?: Maybe<Array<PricesPage>>;
};

export type StoreUpgradeInput = {
  action: Scalars['String'];
  email: Scalars['String'];
  planReference: Scalars['String'];
  productCode: Scalars['String'];
  subscriptionIdToUpgrade: Scalars['String'];
};

export type StoreUpgradeRequest = {
  action: Scalars['String'];
  email: Scalars['String'];
  planReference: Scalars['String'];
  productCode: Scalars['String'];
  subscriptionIdToUpgrade: Scalars['String'];
};

export type StoreUpgradeResponse = {
  url: Scalars['String'];
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  channelManagerEvent?: Maybe<ChannelManagerEvent>;
  dailyClosureEvent?: Maybe<DailyClosureEvent>;
  dashboardKpiEvent?: Maybe<DashBoardRefreshEvent>;
  documentExportedEvent?: Maybe<DocumentExportedEvent>;
  fakeEvent?: Maybe<FakeOutput>;
  newThreadMessageEvent?: Maybe<NewThreadMessageEvent>;
  rebuildPropertyAvailabilityEvent?: Maybe<RebuildPropertyAvailabilityEvent>;
  reservedResourceEvent?: Maybe<ReservedResourceEvent>;
  reservedResourceProductionEvent?: Maybe<ReservedResourceProductionEvent>;
  resourceEvent?: Maybe<ResourceEvent>;
};


export type SubscriptionchannelManagerEventArgs = {
  filter: ChannelManagerEventFilter;
};


export type SubscriptiondailyClosureEventArgs = {
  filter: DailyClosureEventFilter;
};


export type SubscriptiondashboardKpiEventArgs = {
  filter: DashboardQueryFilter;
};


export type SubscriptiondocumentExportedEventArgs = {
  filter: DocumentExportedEventFilter;
};


export type SubscriptionnewThreadMessageEventArgs = {
  filter: NewThreadMessageEventFilter;
};


export type SubscriptionrebuildPropertyAvailabilityEventArgs = {
  filter: RebuildPropertyAvailabilityEventFilter;
};


export type SubscriptionreservedResourceEventArgs = {
  filter: ReservedResourceEventFilter;
};


export type SubscriptionreservedResourceProductionEventArgs = {
  filter: ReservedResourceProductionEventFilter;
};


export type SubscriptionresourceEventArgs = {
  filter: ResourceEventFilter;
};

export type SubscriptionDigital = {
  active?: Maybe<Scalars['Boolean']>;
  appDescription?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type SubscriptionInfoInput = {
  featureCode: MeteringModule;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type SubscriptionModuleOutput = {
  features?: Maybe<Array<Feature>>;
  modules?: Maybe<Array<MeteringModule>>;
  trialModules?: Maybe<Array<TrialModule>>;
  userModules?: Maybe<Array<MeteringModule>>;
  userRole?: Maybe<UserRoleOutput>;
};

/** Le entità Tag sono per tenantId */
export type Tag = {
  auditable: Auditable;
  color: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type TagInput = {
  color: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type TagQueryFilter = {
  id?: InputMaybe<IDFilter>;
  label?: InputMaybe<StringFilter>;
  tenantId: IDFilter;
};

/** Entità che contiene i dati delle lookup gestite */
export type Taxonomy = {
  auditable: Auditable;
  description: Scalars['LocalizedString'];
  id: Scalars['ID'];
  /** Ordinamento è da utilizzare quando viene tirata su la lookup. */
  order: Scalars['Int'];
  parent?: Maybe<Taxonomy>;
  /** E' possibile creare lookup master detail specificando il parent */
  parentId?: Maybe<Scalars['ID']>;
  /** Codice usato per l'associazione con elementi parent durante la migration e per mappare con la gestione dei classifier del workspace/office */
  ref?: Maybe<Scalars['String']>;
  /** Tipologia della lookup */
  type: TaxonomyType;
};

export type TaxonomyInput = {
  description: Scalars['LocalizedString'];
  order: Scalars['Int'];
  parentId?: InputMaybe<Scalars['ID']>;
  type: TaxonomyType;
};

export type TaxonomyQueryFilter = {
  id?: InputMaybe<IDFilter>;
  parentId?: InputMaybe<IDFilter>;
  type?: InputMaybe<TaxonomyTypeFilter>;
};

export const TaxonomyType = {
  CHILDTYPE: 'CHILDTYPE',
  PAYMENT: 'PAYMENT',
  PROPERTY_CATEGORY: 'PROPERTY_CATEGORY',
  PROPERTY_CLASSTYPE: 'PROPERTY_CLASSTYPE',
  RESOURCE_CATEGORY: 'RESOURCE_CATEGORY',
  RESOURCE_NAME: 'RESOURCE_NAME'
} as const;

export type TaxonomyType = typeof TaxonomyType[keyof typeof TaxonomyType];
export type TaxonomyTypeFilter = {
  eq?: InputMaybe<TaxonomyType>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<TaxonomyType>>;
  ne?: InputMaybe<TaxonomyType>;
  nin?: InputMaybe<Array<TaxonomyType>>;
};

/** Il Tenant rappresenta il cliente che acquista Hotel in Cloud, la creazione del Tenant avviene tramite provisioning. */
export type Tenant = {
  auditable: Auditable;
  backoffice?: Maybe<Scalars['Boolean']>;
  cassaInCloudConfiguration?: Maybe<CassaInCloudConfiguration>;
  currency: Scalars['Currency'];
  description?: Maybe<Scalars['String']>;
  fiscalCode?: Maybe<Scalars['String']>;
  fiscalGatewayData?: Maybe<FiscalGatewayData>;
  id: Scalars['ID'];
  language: Scalars['Language'];
  modules?: Maybe<Array<Module>>;
  ncsId?: Maybe<Scalars['String']>;
  privacySettings?: Maybe<PrivacySettings>;
  registryItemId: Scalars['String'];
  scelTemplate?: Maybe<Scalars['String']>;
  sellerName?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type TenantPropertyIdFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

export type TenantQueryFilter = {
  id?: InputMaybe<IDFilter>;
};

export type Thread = {
  archived: Scalars['Boolean'];
  auditable: Auditable;
  externalId: Scalars['String'];
  externalUsers: Array<ThreadUser>;
  id: Scalars['ID'];
  lastMessage?: Maybe<LastThreadMessage>;
  messages: Array<ThreadMessage>;
  origin: ThreadOrigin;
  propertyId: Scalars['ID'];
  propertyPortalCode?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  reservation: Reservation;
  reservationId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ThreadMessage = {
  auditable: Auditable;
  externalId?: Maybe<Scalars['String']>;
  /**  valorizzato solo per gli utenti esterni, se non valorizzato è un messaggio della struttura inviato dall'utente auditable.createdBy   */
  externalUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNote: Scalars['Boolean'];
  message: Scalars['String'];
  messageAutomationId?: Maybe<Scalars['ID']>;
  messageTemplateId?: Maybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type ThreadMessageQueryFilter = {
  propertyId: Scalars['ID'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

export const ThreadOrigin = {
  AIRBNB: 'AIRBNB',
  BOOKING: 'BOOKING'
} as const;

export type ThreadOrigin = typeof ThreadOrigin[keyof typeof ThreadOrigin];
export type ThreadQueryFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
  reservationId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type ThreadUser = {
  externalId: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  preferred_locale?: Maybe<Scalars['String']>;
};

export type TimeConfiguration = {
  activity?: Maybe<TimeRange>;
  chargeCategoryId: Scalars['ID'];
  unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement;
};

export type TimeConfigurationInput = {
  activity?: InputMaybe<TimeRangeInput>;
  chargeCategoryId: Scalars['ID'];
  unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement;
};

export type TimeRange = {
  from: Scalars['Time'];
  to: Scalars['Time'];
};

export type TimeRangeInput = {
  from: Scalars['Time'];
  to: Scalars['Time'];
};

export type TrialModule = {
  module: MeteringModule;
  trialExpiration: Scalars['Date'];
};

export type TsPayApiKey = {
  apiKey: Scalars['String'];
  auditable: Auditable;
  authKey: Scalars['String'];
  id: Scalars['ID'];
  loginUrl: Scalars['String'];
  merchantRef: Scalars['String'];
  state: TsPayApiKeyState;
  tenantId: Scalars['ID'];
};

export const TsPayApiKeyState = {
  ACTIVE: 'ACTIVE',
  INIT: 'INIT'
} as const;

export type TsPayApiKeyState = typeof TsPayApiKeyState[keyof typeof TsPayApiKeyState];
export type TsPayCharge = {
  amount: Scalars['Int'];
  amountPreauth?: Maybe<Scalars['Int']>;
  apikey: TsPayApiKey;
  apikeyId: Scalars['ID'];
  auditable: Auditable;
  chargeKey: Scalars['String'];
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  error?: Maybe<TsPayError>;
  id: Scalars['ID'];
  link: TsPayLink;
  linkId: Scalars['ID'];
  netAmount: Scalars['Int'];
  payload?: Maybe<Scalars['String']>;
  propertyId: Scalars['ID'];
  refundId?: Maybe<Scalars['String']>;
  refundReason?: Maybe<TsPayRefundReason>;
  reservationId?: Maybe<Scalars['ID']>;
  sourceKey?: Maybe<Scalars['String']>;
  state: TsPayChargeState;
  tenantId: Scalars['ID'];
};

export const TsPayChargeState = {
  DISPUTE_CLOSED: 'DISPUTE_CLOSED',
  DISPUTE_CLOSED_FORCED: 'DISPUTE_CLOSED_FORCED',
  DISPUTE_CLOSED_LOST: 'DISPUTE_CLOSED_LOST',
  DISPUTE_CLOSED_WON: 'DISPUTE_CLOSED_WON',
  DISPUTE_CREATED: 'DISPUTE_CREATED',
  DISPUTE_REFOUNDED: 'DISPUTE_REFOUNDED',
  DISPUTE_UPDATED: 'DISPUTE_UPDATED',
  DISPUTE_WITHDRAWN: 'DISPUTE_WITHDRAWN',
  DONE: 'DONE',
  ERROR: 'ERROR',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PREAUTHED: 'PREAUTHED',
  PREAUTH_CANCELLED: 'PREAUTH_CANCELLED',
  REFOUNDED: 'REFOUNDED'
} as const;

export type TsPayChargeState = typeof TsPayChargeState[keyof typeof TsPayChargeState];
/** Dati relativi a TsPay */
export type TsPayData = {
  error?: Maybe<TsPayOnboardingError>;
  merchantRef?: Maybe<Scalars['String']>;
  sessionKey?: Maybe<Scalars['String']>;
  sessionUrl?: Maybe<Scalars['String']>;
  sourceTypesPayEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceTypesSaveEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  state: TsPayOnboardingState;
};

export type TsPayDeclineCode = {
  declineCode?: Maybe<Scalars['String']>;
};

export type TsPayError = {
  decline: TsPayDeclineCode;
  errorKey?: Maybe<Scalars['String']>;
  errorType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type TsPayErrorLog = {
  error?: Maybe<TsPayError>;
  timestamp: Scalars['DateTime'];
};

export type TsPayLink = {
  amount: Scalars['Int'];
  apikey: TsPayApiKey;
  apikeyId: Scalars['ID'];
  auditable: Auditable;
  cardInfo?: Maybe<Scalars['String']>;
  charges: Array<TsPayCharge>;
  currency: Scalars['Currency'];
  customerId: Scalars['ID'];
  /** Indica il documento di quietanza sospesi o di checkout al quale è collegato il pagamento */
  documentId?: Maybe<Scalars['ID']>;
  errors?: Maybe<Array<TsPayErrorLog>>;
  fiscalTypeForAdvance?: Maybe<FiscalType>;
  /**
   * Serve per discriminare se nella callback va o meno generato un documento.
   * Attualmente l'unico caso è per la reservation perché se il pagamento è un anticipo tramite link va generato un anticipo in automatico
   * mentre se il pagamento avviene in un secondo momento durante il checkout il documento non va creato (sarà l'operatore a farlo)
   */
  generateDocument: Scalars['Boolean'];
  id: Scalars['ID'];
  orderKey: Scalars['String'];
  propertyId: Scalars['ID'];
  quotation?: Maybe<TsPayQuotationInfo>;
  reservationId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  type: TsPayLinkType;
  url: Scalars['String'];
};

export const TsPayLinkType = {
  LINK2PAY: 'LINK2PAY',
  LINK2SAVE: 'LINK2SAVE'
} as const;

export type TsPayLinkType = typeof TsPayLinkType[keyof typeof TsPayLinkType];
export type TsPayOnboardingError = {
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export const TsPayOnboardingState = {
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
  ERROR: 'ERROR',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
} as const;

export type TsPayOnboardingState = typeof TsPayOnboardingState[keyof typeof TsPayOnboardingState];
export type TsPayQuotationInfo = {
  quotationDetailIndex: Scalars['Int'];
  quotationId: Scalars['ID'];
};

export const TsPayRefundReason = {
  DUPLICATE: 'DUPLICATE',
  EXPIRED_UNCAPTURED_CHARGE: 'EXPIRED_UNCAPTURED_CHARGE',
  FRAUDULENT: 'FRAUDULENT',
  REQUESTED_BY_CUSTOMER: 'REQUESTED_BY_CUSTOMER'
} as const;

export type TsPayRefundReason = typeof TsPayRefundReason[keyof typeof TsPayRefundReason];
export type TsPaySource = {
  expiration: Scalars['String'];
  last4: Scalars['String'];
  sourceKey: Scalars['String'];
  state: TsPaySourceState;
  type: Scalars['String'];
};

export const TsPaySourceState = {
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR'
} as const;

export type TsPaySourceState = typeof TsPaySourceState[keyof typeof TsPaySourceState];
export type TsPayWebhook = {
  auditable: Auditable;
  endpoint: Scalars['String'];
  event: Scalars['String'];
  extId: Scalars['String'];
  id: Scalars['ID'];
  secret: Scalars['String'];
  tenantId: Scalars['ID'];
};

export const UndoImportStep = {
  BILLS: 'BILLS',
  CONFIGURATION: 'CONFIGURATION',
  CUSTOMERS: 'CUSTOMERS',
  DOCUMENTS: 'DOCUMENTS',
  RESERVATIONS: 'RESERVATIONS'
} as const;

export type UndoImportStep = typeof UndoImportStep[keyof typeof UndoImportStep];
export type UpdateCounterInput = {
  documentActiveId?: InputMaybe<Scalars['ID']>;
  format: Scalars['String'];
  reset: Scalars['Boolean'];
  value?: InputMaybe<Scalars['Int']>;
};

/**  Input for mutation updateDepositAssigneds: provide only unused quotas  */
export type UpdateDepositAssigneds = {
  depositAssignedId?: InputMaybe<Scalars['ID']>;
  depositAssignment: DepositAssignmentInput;
};

export type UpdateDocumentNumberInput = {
  documentId: Scalars['ID'];
  number: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type UpdateResourceRoomTetrisOrderInput = {
  id: Scalars['ID'];
  roomTetrisOrder: Scalars['Int'];
};

export type UpdateResourceUnavailabilityInput = {
  resourceId: Scalars['ID'];
  tenantId: Scalars['ID'];
  unavailability: ResourceUnavailabilityInput;
  unavailabilityId: Scalars['ID'];
};

export type UpdateThreadInput = {
  archived: Scalars['Boolean'];
  read: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  threadId: Scalars['ID'];
};

/** User, utente che può accedere al sistema */
export type User = {
  auditable: Auditable;
  authorizations?: Maybe<Array<UserAuthorization>>;
  backofficeAuthorizations?: Maybe<Array<UserAuthorization>>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ncsId?: Maybe<Scalars['String']>;
  onePlatformAuthorizations?: Maybe<Array<UserOnePlatformAuthorization>>;
  tsId?: Maybe<Scalars['String']>;
};

export type UserAddedService = {
  additionalServices: Array<EmbeddedAdditionalServiceInput>;
  quotedResourceIndex: Scalars['Int'];
};

/**
 * Autorizzazioni dell'utente; può avere accesso solo ad alcune property.
 * Se sono presenti i moduli, ha solo accesso parziale al sistema
 */
export type UserAuthorization = {
  modules?: Maybe<Array<MeteringModule>>;
  propertyId?: Maybe<Scalars['ID']>;
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
};

export type UserFilterClient = {
  login?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tenantId?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mail: Scalars['String'];
  userRoles: Array<UserRoleInput>;
};

/**
 * Autorizzazione dell'utente nel dominio di One Platform.
 * Se ha dei livelli autorizzativi parziali, sono presenti i moduli
 */
export type UserOnePlatformAuthorization = {
  modules?: Maybe<Array<MeteringModule>>;
  registryItemId: Scalars['String'];
  role: OnePlatformRole;
};

export type UserPermissionInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  tsId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/**
 * Per gestire la security di un utente abbiamo bisogno di avere il ruolo, i moduli attivi sull'utente,
 *  e inoltre i moduli e le feature acquistate.
 *  I moduli trial sono esplicitati e hanno una data di scadenza
 */
export type UserPermissionOutput = {
  features?: Maybe<Array<Feature>>;
  modules?: Maybe<Array<MeteringModule>>;
  tenantSellerName?: Maybe<Scalars['String']>;
  trialModules?: Maybe<Array<TrialModule>>;
  userModules?: Maybe<Array<MeteringModule>>;
  userRole?: Maybe<UserRoleOutput>;
};

export type UserPermissionQueryInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type UserQueryInput = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  tsId?: InputMaybe<Scalars['String']>;
};

export type UserRoleInput = {
  propertyId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type UserRoleOutput = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['LocalizedString'];
  permissions?: Maybe<Array<Permissions>>;
};

export const ValueType = {
  PERCENTAGE: 'PERCENTAGE',
  VALUE: 'VALUE'
} as const;

export type ValueType = typeof ValueType[keyof typeof ValueType];
/** Tipologie aliquote iva, possono essere solo per tenant */
export type Vat = {
  auditable: Auditable;
  code: Scalars['String'];
  /** Il codice PA indica il codice di esenzione N1, N2... */
  codePa?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  /** Codice Export Dati */
  managementCode?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  propertyId?: Maybe<Scalars['ID']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  value: Scalars['Float'];
};

export type VatInput = {
  code: Scalars['String'];
  codePa?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  managementCode?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  propertyId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  value: Scalars['Float'];
};

export type VatQueryFilter = {
  id?: InputMaybe<IDFilter>;
  propertyId?: InputMaybe<IDFilter>;
  tenantId: IDFilter;
};

/** Lo stato del Web Check-in. */
export const WciState = {
  CREATED: 'CREATED',
  VALIDATED: 'VALIDATED'
} as const;

export type WciState = typeof WciState[keyof typeof WciState];
/** Contatti web */
export type WebContact = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: WebContactType;
  value: Scalars['URL'];
};

export type WebContactInput = {
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  type: WebContactType;
  value: Scalars['URL'];
};

/** Tipologie di contatti web, compresi Social Network */
export const WebContactType = {
  INSTAGRAM: 'INSTAGRAM',
  META: 'META',
  TWITTER: 'TWITTER',
  WEBPRIVACY: 'WEBPRIVACY',
  WEBSITE: 'WEBSITE',
  YOUTUBE: 'YOUTUBE'
} as const;

export type WebContactType = typeof WebContactType[keyof typeof WebContactType];
export type WorstBookingPolicyInput = {
  firstNightAmount: Scalars['Int'];
  policies: Array<ReservationBookingPolicyInput>;
  totalAmount: Scalars['Int'];
};

export type CityTaxReportDetailFragment = { amount: number, currency: Currency, payingGuests: number, payingNights: number, documents: { to: number, from: number }, exonerations: Array<{ guests: number, nights: number, type: { code: CityTaxExonerationCode, description: LocalizedString } }> };

export type GetCityTaxReportQueryVariables = Exact<{
  filter: CityTaxReportInput;
}>;


export type GetCityTaxReportQuery = { getCityTaxReport: { invoice?: { amount: number, currency: Currency, payingGuests: number, payingNights: number, documents: { to: number, from: number }, exonerations: Array<{ guests: number, nights: number, type: { code: CityTaxExonerationCode, description: LocalizedString } }> } | null, receipt?: { amount: number, currency: Currency, payingGuests: number, payingNights: number, documents: { to: number, from: number }, exonerations: Array<{ guests: number, nights: number, type: { code: CityTaxExonerationCode, description: LocalizedString } }> } | null } };

export type GetCityTaxConfigurationsQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type GetCityTaxConfigurationsQuery = { properties?: Array<{ cityTaxConfiguration?: { configurations: Array<{ name: string, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null }> } | null }> | null };

export type GenerateCityTaxFileMutationVariables = Exact<{
  filter: GenerateCityTaxFileInput;
}>;


export type GenerateCityTaxFileMutation = { generateCityTaxFile: { success: boolean, fileUrl?: string | null, errors?: Array<{ ruleConfigurationName: string, date?: Date | null, message: string }> | null } };

export type FelAdditionalInfoFragment = { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null };

export type ScelAdditionalInfoFragment = { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null };

export type DatiDocumentiCorrelatiFragment = { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null };

export type CustomFieldsFragment = { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null };

export type DocumentsListFragment = { id: string, fiscalType: FiscalType, currency: Currency, numberExtended: string, number: number, documentDate: Date, totalAmount: number, netAmount: number, vatAmount: number, unpaidAmount: number, consolidatedData?: { customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null } } | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null }, felAdditionalInfo?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null, customFields?: { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null } | null } | null, scelAdditionalInfo?: { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null } | null, cashDesk: { cashDeskTypeId: string }, auditable: { state: State }, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActive: { name: LocalizedString, paymentType: { sign: AlgebraicSign } } }> };

export type FiscalConfigurationDocumentsQueryVariables = Exact<{
  propertyFilter: PropertyQueryFilter;
  cashDeskTypeFilter: TenantPropertyIdFilter;
}>;


export type FiscalConfigurationDocumentsQuery = { properties?: Array<{ fiscalConfigurations?: Array<{ name: string, cashDeskTypeIds: Array<string> }> | null }> | null, cashDeskTypes?: Array<{ id: string, name: string }> | null };

export type DocumentsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentsQuery = { documents?: Array<{ id: string, fiscalType: FiscalType, currency: Currency, numberExtended: string, number: number, documentDate: Date, totalAmount: number, netAmount: number, vatAmount: number, unpaidAmount: number, consolidatedData?: { customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null } } | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null }, felAdditionalInfo?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null, customFields?: { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null } | null } | null, scelAdditionalInfo?: { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null } | null, cashDesk: { cashDeskTypeId: string }, auditable: { state: State }, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActive: { name: LocalizedString, paymentType: { sign: AlgebraicSign } } }> }> | null };

export type SendInvoideToTSDigitalMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type SendInvoideToTSDigitalMutation = { sendInvoiceToTSDigital?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null } | null };

export type PaymentActivesDocumentsQueryVariables = Exact<{
  filter: PaymentActiveQueryFilter;
}>;


export type PaymentActivesDocumentsQuery = { paymentActives: Array<{ id: string, name: LocalizedString }> };

export type UpdateInvoiceStateMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type UpdateInvoiceStateMutation = { updateInvoiceState?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null } | null };

export type SendReceiptToFiscalGatewayMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
  resend?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendReceiptToFiscalGatewayMutation = { sendReceiptToFiscalGateway?: any | null };

export type DocumentTotalsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
}>;


export type DocumentTotalsQuery = { documentTotals: Array<{ currency: Currency, totals: { totalAmount: number, vatAmount: number, stay: number, citytax: number, deposit: number, advance: number, other: number, payments: Array<{ paymentActiveId: string, paymentActiveName: LocalizedString, total: number }> } }> };

export type UnpaidDocumentReservationFragment = { id: string, voucher?: string | null, reservationCode: string, reference: { mainGuest: { name: any } } };

export type UnpaidDocumentsFragment = { id: string, numberExtended: string, documentDate: Date, totalAmount: number, unpaidAmount: number, residualAmount?: number | null, documentPaymentDetails: Array<{ expireDate?: Date | null, amount: number, paymentActiveId: string }>, bills?: Array<{ reservation?: Array<{ id: string, voucher?: string | null, reservationCode: string, reference: { mainGuest: { name: any } } }> | null }> | null };

export type UnpaidDocumentsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UnpaidDocumentsQuery = { documents?: Array<{ id: string, numberExtended: string, documentDate: Date, totalAmount: number, unpaidAmount: number, residualAmount?: number | null, documentPaymentDetails: Array<{ expireDate?: Date | null, amount: number, paymentActiveId: string }>, bills?: Array<{ reservation?: Array<{ id: string, voucher?: string | null, reservationCode: string, reference: { mainGuest: { name: any } } }> | null }> | null }> | null };

export type PaidInFullDocumentFragment = { id: string, numberExtended: string, documentDate: Date, totalAmount: number, documentPaymentDetails: Array<{ paymentActiveId: string, amount: number, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null }>, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null }, auditable: { state: State } };

export type PaidInFullDocumentsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PaidInFullDocumentsQuery = { documents?: Array<{ id: string, numberExtended: string, documentDate: Date, totalAmount: number, documentPaymentDetails: Array<{ paymentActiveId: string, amount: number, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null }>, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null }, auditable: { state: State } }> | null };

export type CreatePaidInFullDocumentMutationVariables = Exact<{
  input: PaidInFullDocumentInput;
}>;


export type CreatePaidInFullDocumentMutation = { createPaidInFullDocument: string };

export type DeleteDocumentMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type DeleteDocumentMutation = { deleteDocument?: any | null };

export type SendPaymentLinkEMailForUnpaidDocumentsMutationVariables = Exact<{
  input: PaymentLinkForUnpaidDocumentsInput;
}>;


export type SendPaymentLinkEMailForUnpaidDocumentsMutation = { sendPaymentLinkEmailForUnpaidDocuments?: { emailState: EmailState } | null };

export type CreateLinkForUnpaidDocumentMutationVariables = Exact<{
  input: Link2PayUnpaidDocumentInput;
}>;


export type CreateLinkForUnpaidDocumentMutation = { createLinkForUnpaidDocument: { url: string } };

export type SendReminderEmailForUnpaidDocumentsMutationVariables = Exact<{
  input: ReminderForUnpaidDocumentsInput;
}>;


export type SendReminderEmailForUnpaidDocumentsMutation = { sendReminderEmailForUnpaidDocuments?: { emailState: EmailState } | null };

export type DocumentEmailFragment = { id: string, messageId?: string | null, from?: string | null, to: string, subject: string, emailState: EmailState, body: string, stateTransaction: Array<{ state: EmailState, result?: string | null, timestamp: Date }>, documents?: Array<{ id: string, documentType: DocumentType }> | null };

export type GetDocumentEmailsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  customerId: Scalars['ID'];
  documentId?: InputMaybe<Scalars['ID']>;
}>;


export type GetDocumentEmailsQuery = { getDocumentEmails?: Array<{ id: string, messageId?: string | null, from?: string | null, to: string, subject: string, emailState: EmailState, body: string, stateTransaction: Array<{ state: EmailState, result?: string | null, timestamp: Date }>, documents?: Array<{ id: string, documentType: DocumentType }> | null }> | null };

export type UpdateInvoiceCustomFieldsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  customFields: FelCustomFieldsInput;
  updateInvoiceCustomFieldsId: Scalars['ID'];
}>;


export type UpdateInvoiceCustomFieldsMutation = { updateInvoiceCustomFields?: any | null };

export type UpdateDocumentPaymentDetailsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  updateDocumentPaymentDetailsId: Scalars['ID'];
  paymentActiveIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateDocumentPaymentDetailsMutation = { updateDocumentPaymentDetails?: any | null };

export type accountantCategoriesQueryVariables = Exact<{
  filter: AccountantCategoryQueryFilter;
}>;


export type accountantCategoriesQuery = { accountantCategories?: Array<{ id: string, defaultVatId: string, default: { advance: boolean, deposit: boolean } }> | null };

export type DepositDetailDocumentFragment = { id: string, numberExtended: string, fiscalType: FiscalType, documentDate: Date, totalAmount: number, residualAmount?: number | null, currency: Currency };

export type DepositDetailDocumentsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
}>;


export type DepositDetailDocumentsQuery = { documents?: Array<{ id: string, numberExtended: string, fiscalType: FiscalType, documentDate: Date, totalAmount: number, residualAmount?: number | null, currency: Currency }> | null };

export type PropertyCityTaxConfigurationFragment = { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> };

export type InnerPropertyFragment = { id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null };

export type PropertyFragment = { id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, subProperties?: Array<{ id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null }> | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null };

export type PropertyQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type PropertyQuery = { properties?: Array<{ id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, subProperties?: Array<{ id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null }> | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null }> | null };

export type PropertyNewMutationVariables = Exact<{
  input: PropertyInput;
}>;


export type PropertyNewMutation = { createProperty: { id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, subProperties?: Array<{ id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null }> | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null } };

export type PropertyUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PropertyInput;
}>;


export type PropertyUpdateMutation = { updateProperty: { id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, subProperties?: Array<{ id: string, tenantId: string, type: PropertyType, parentPropertyId?: string | null, name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, vatNumber?: string | null, fiscalCode?: string | null, placeId?: string | null, ibeCode?: string | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null }> | null, fiscalConfigurations?: Array<{ resourceTypeIds?: Array<string> | null, felConfiguration?: { taxSystem: RegimeFiscale } | null }> | null, cityTaxConfiguration?: { configurations: Array<{ genericConfiguration?: { maxNights: number, minAge: number, amountType: ValueType, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null, subAddresses?: Array<{ name: string, description?: LocalizedString | null, classTypeId?: string | null, categoryId?: string | null, placeId?: string | null, resourceTypeIds: Array<string>, ibeCode?: string | null, address?: { coordinates?: Coordinates | null, countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, checkout?: { from: Date, to: Date } | null, checkin?: { to: Date, from: Date } | null }> | null } };

export type PropertyDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
}>;


export type PropertyDeleteMutation = { deleteProperty?: any | null };

export type PropertyClassTypeFragment = { id: string, description: LocalizedString, order: number };

export type PropertyClassTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyClassTypesQuery = { taxonomies?: Array<{ id: string, description: LocalizedString, order: number }> | null };

export type PropertyCategoryFragment = { id: string, description: LocalizedString, parentId?: string | null, order: number };

export type PropertyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyCategoriesQuery = { taxonomies?: Array<{ id: string, description: LocalizedString, parentId?: string | null, order: number }> | null };

export type SetPropertySubAddressesMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  config?: InputMaybe<Array<PropertySubAddressInput> | PropertySubAddressInput>;
}>;


export type SetPropertySubAddressesMutation = { setPropertySubAddresses?: any | null };

export type AuditFragment = { id: string, operationName: string, timestamp: Date, modifiedBy?: string | null, operation: string, changes?: any | null, entityId: string, entityName: string, correlationId: string };

export type AuditsListQueryVariables = Exact<{
  filter: AuditQueryFilter;
  sorts?: InputMaybe<Array<AuditSortInput> | AuditSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AuditsListQuery = { audits?: Array<{ id: string, operationName: string, timestamp: Date, modifiedBy?: string | null, operation: string, changes?: any | null, entityId: string, entityName: string, correlationId: string }> | null };

export type ChargeCategoryAuditFragment = { id: string, name: string };

export type ChargeCategoriesAuditQueryVariables = Exact<{
  filter: ChargeCategoryQueryFilter;
}>;


export type ChargeCategoriesAuditQuery = { chargeCategories?: Array<{ id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } }> | null };

export type VatAuditFragment = { id: string, description: string, value: number };

export type VatsAuditQueryVariables = Exact<{
  filter: VatQueryFilter;
}>;


export type VatsAuditQuery = { vats?: Array<{ id: string, description: string, value: number }> | null };

export type ReservedResourceAuditFragment = { resourceOccupancies: Array<{ end: Date, start: Date, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }>, reservation: { reservationCode: string, id: string } };

export type ReservedResourceAuditQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type ReservedResourceAuditQuery = { reservedResources?: Array<{ resourceOccupancies: Array<{ end: Date, start: Date, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }>, reservation: { reservationCode: string, id: string } }> | null };

export type ResourceTypeAuditFragment = { id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, resources?: Array<{ id: string, code: string }> | null };

export type ResourceTypeAuditQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypeAuditQuery = { resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, resources?: Array<{ id: string, code: string }> | null }> | null };

export type DeleteReservedResourceIdsQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type DeleteReservedResourceIdsQuery = { reservedResources?: Array<{ id: string }> | null };

export type DeleteDocumentIdsQueryVariables = Exact<{
  filter: DocumentQueryFilter;
}>;


export type DeleteDocumentIdsQuery = { documents?: Array<{ id: string }> | null };

export type DeleteBillIdsQueryVariables = Exact<{
  filter: BillQueryFilter;
}>;


export type DeleteBillIdsQuery = { bills?: Array<{ id: string }> | null };

export type DeleteProductionIdsQueryVariables = Exact<{
  filter: ProductionQueryFilter;
}>;


export type DeleteProductionIdsQuery = { productions?: Array<{ id: string }> | null };

export type DeleteDepositDocumentIdsQueryVariables = Exact<{
  filter: DepositDocumentQueryFilter;
}>;


export type DeleteDepositDocumentIdsQuery = { depositDocuments?: Array<{ id: string }> | null };

export type BillPageFragment = { id: string, open: boolean, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, description: string, documentId?: string | null, category: BillCategoryType, ownerId: string, auditable: { createdOn?: Date | null }, reservation?: Array<{ id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ start: Date, end: Date }> | null }> | null, productions?: Array<{ id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, chargeCategoryId: string, vatId: string, description?: string | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null, reservedResource?: { id: string, start: Date, end: Date, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null }> } | null } }> | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null } };

export type ProductionAssignedBillPageFragment = { id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, chargeCategoryId: string, vatId: string, description?: string | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null, reservedResource?: { id: string, start: Date, end: Date, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null }> } | null } };

export type ProductionBillPageFragment = { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, chargeCategoryId: string, vatId: string, description?: string | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null, reservedResource?: { id: string, start: Date, end: Date, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null }> } | null };

export type ReservedResourceBillPageFragment = { id: string, start: Date, end: Date, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null }> };

export type ResourceOccupancyBillPageFragment = { start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null };

export type BillsQueryVariables = Exact<{
  filter: OpenBillsQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BillsQuery = { openBills?: Array<{ id: string, open: boolean, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, description: string, documentId?: string | null, category: BillCategoryType, ownerId: string, auditable: { createdOn?: Date | null }, reservation?: Array<{ id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ start: Date, end: Date }> | null }> | null, productions?: Array<{ id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, chargeCategoryId: string, vatId: string, description?: string | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null, reservedResource?: { id: string, start: Date, end: Date, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceTypeId: string, resourceId?: string | null }> } | null } }> | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null } }> | null };

export type DepositAssignedBillPageQueryVariables = Exact<{
  filter: ReservationQueryFilter;
}>;


export type DepositAssignedBillPageQuery = { reservations?: Array<{ depositAssigneds?: Array<{ depositDocumentId: string }> | null }> | null };

export type ChargeCategoryBillPageFragment = { id: string, name: string, cityTax: boolean, stayIncluded: boolean };

export type VatBillPageFragment = { id: string, code: string, value: number };

export type ResourceTypeBillPageFragment = { id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } };

export type ResourceBillPageFragment = { id: string, code: string };

export type AdditionalInfoBillPageQueryVariables = Exact<{
  chargeCategoryFilter: ChargeCategoryQueryFilter;
  vatFilter: VatQueryFilter;
  resourceTypeFilter: ResourceTypeQueryFilter;
  resourceFilter: ResourceQueryFilter;
}>;


export type AdditionalInfoBillPageQuery = { chargeCategories?: Array<{ id: string, name: string, cityTax: boolean, stayIncluded: boolean }> | null, vats?: Array<{ id: string, code: string, value: number }> | null, resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }> | null, resources?: Array<{ id: string, code: string }> | null };

export type BillListProductionItemFragment = { id: string, date: Date, hotelDate: Date, chargeCategoryId: string, currency: Currency, description?: string | null, quantity: number, amount: number, total: number, vatId: string, manual: boolean, reservedResourceId?: string | null, chargeCategory: { name: string }, vat: { code: string, value: number }, reservedResource?: { guestOccupancies?: Array<{ start: Date, end: Date, guest: { name: any } }> | null, resourceOccupancies: Array<{ resource?: { code: string, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } } } | null }>, reservation: { reservationCode: string } } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null };

export type BillListItemFragment = { id: string, tenantId: string, propertyId: string, ownerId: string, documentId?: string | null, open: boolean, description: string, category: BillCategoryType, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, document?: { numberExtended: string, id: string, fiscalType: FiscalType, currency: Currency, number: number, documentDate: Date, totalAmount: number, netAmount: number, vatAmount: number, unpaidAmount: number, consolidatedData?: { customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null } } | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null }, felAdditionalInfo?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null, customFields?: { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null } | null } | null, scelAdditionalInfo?: { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null } | null, cashDesk: { cashDeskTypeId: string }, auditable: { state: State }, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActive: { name: LocalizedString, paymentType: { sign: AlgebraicSign } } }> } | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { id: string, name: any, type: CustomerType }, auditable: { createdOn?: Date | null }, reservation?: Array<{ reservationCode: string, reservedResources?: Array<{ id: string }> | null }> | null, reservedResource?: Array<{ end: Date, start: Date }> | null, productions?: Array<{ id: string, quota: number, production: { id: string, date: Date, hotelDate: Date, chargeCategoryId: string, currency: Currency, description?: string | null, quantity: number, amount: number, total: number, vatId: string, manual: boolean, reservedResourceId?: string | null, chargeCategory: { name: string }, vat: { code: string, value: number }, reservedResource?: { guestOccupancies?: Array<{ start: Date, end: Date, guest: { name: any } }> | null, resourceOccupancies: Array<{ resource?: { code: string, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } } } | null }>, reservation: { reservationCode: string } } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } }> | null };

export type BillItemReservedResourceFragment = { start: Date, end: Date };

export type BillItemFragment = { id: string, tenantId: string, propertyId: string, description: string, category: BillCategoryType, ownerId: string, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { name: any }, reservation?: Array<{ reservationCode: string, reservationState: { noshow: boolean } }> | null, reservedResource?: Array<{ start: Date, end: Date }> | null, auditable: { createdOn?: Date | null } };

export type BillSearchQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  filter: BillQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BillSearchQuery = { bills?: Array<{ id: string, tenantId: string, propertyId: string, description: string, category: BillCategoryType, ownerId: string, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { name: any }, reservation?: Array<{ reservationCode: string, reservationState: { noshow: boolean } }> | null, reservedResource?: Array<{ start: Date, end: Date }> | null, auditable: { createdOn?: Date | null } }> | null };

export type BillsListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  filter: BillQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BillsListQuery = { bills?: Array<{ id: string, tenantId: string, propertyId: string, ownerId: string, documentId?: string | null, open: boolean, description: string, category: BillCategoryType, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, document?: { numberExtended: string, id: string, fiscalType: FiscalType, currency: Currency, number: number, documentDate: Date, totalAmount: number, netAmount: number, vatAmount: number, unpaidAmount: number, consolidatedData?: { customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null } } | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null }, felAdditionalInfo?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null, customFields?: { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null } | null } | null, scelAdditionalInfo?: { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null } | null, cashDesk: { cashDeskTypeId: string }, auditable: { state: State }, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActive: { name: LocalizedString, paymentType: { sign: AlgebraicSign } } }> } | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { id: string, name: any, type: CustomerType }, auditable: { createdOn?: Date | null }, reservation?: Array<{ reservationCode: string, reservedResources?: Array<{ id: string }> | null }> | null, reservedResource?: Array<{ end: Date, start: Date }> | null, productions?: Array<{ id: string, quota: number, production: { id: string, date: Date, hotelDate: Date, chargeCategoryId: string, currency: Currency, description?: string | null, quantity: number, amount: number, total: number, vatId: string, manual: boolean, reservedResourceId?: string | null, chargeCategory: { name: string }, vat: { code: string, value: number }, reservedResource?: { guestOccupancies?: Array<{ start: Date, end: Date, guest: { name: any } }> | null, resourceOccupancies: Array<{ resource?: { code: string, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } } } | null }>, reservation: { reservationCode: string } } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } }> | null }> | null };

export type CreateBillMutationVariables = Exact<{
  value: BillInput;
}>;


export type CreateBillMutation = { createBill: { id: string, tenantId: string, propertyId: string, description: string, category: BillCategoryType, ownerId: string, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { name: any }, reservation?: Array<{ reservationCode: string, reservationState: { noshow: boolean } }> | null, reservedResource?: Array<{ start: Date, end: Date }> | null, auditable: { createdOn?: Date | null } } };

export type UpdateBillMutationVariables = Exact<{
  updateBillId: Scalars['ID'];
  value: BillInput;
}>;


export type UpdateBillMutation = { updateBill: { id: string, tenantId: string, propertyId: string, ownerId: string, documentId?: string | null, open: boolean, description: string, category: BillCategoryType, reservationId?: Array<string> | null, reservedResourceId?: Array<string> | null, document?: { numberExtended: string, id: string, fiscalType: FiscalType, currency: Currency, number: number, documentDate: Date, totalAmount: number, netAmount: number, vatAmount: number, unpaidAmount: number, consolidatedData?: { customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null } } | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null }, felAdditionalInfo?: { state?: FelState | null, sent: boolean, closed: boolean, lastError?: string | null, customFields?: { bolloVirtuale?: boolean | null, datiOrdineAcquisto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiContratto?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiConvenzione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiFattureCollegate?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null, datiRicezione?: { idDocumento?: string | null, data?: Date | null, commessa?: string | null, codiceCIG?: string | null, codiceCUP?: string | null } | null } | null } | null, scelAdditionalInfo?: { sent: number, lastError?: string | null, state?: ScelState | null, canceled?: boolean | null } | null, cashDesk: { cashDeskTypeId: string }, auditable: { state: State }, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActive: { name: LocalizedString, paymentType: { sign: AlgebraicSign } } }> } | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null }, owner: { id: string, name: any, type: CustomerType }, auditable: { createdOn?: Date | null }, reservation?: Array<{ reservationCode: string, reservedResources?: Array<{ id: string }> | null }> | null, reservedResource?: Array<{ end: Date, start: Date }> | null, productions?: Array<{ id: string, quota: number, production: { id: string, date: Date, hotelDate: Date, chargeCategoryId: string, currency: Currency, description?: string | null, quantity: number, amount: number, total: number, vatId: string, manual: boolean, reservedResourceId?: string | null, chargeCategory: { name: string }, vat: { code: string, value: number }, reservedResource?: { guestOccupancies?: Array<{ start: Date, end: Date, guest: { name: any } }> | null, resourceOccupancies: Array<{ resource?: { code: string, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } } } | null }>, reservation: { reservationCode: string } } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } }> | null } };

export type DeleteBillMutationVariables = Exact<{
  deleteBillTenantId: Scalars['ID'];
  deleteBillId: Scalars['ID'];
}>;


export type DeleteBillMutation = { deleteBill?: any | null };

export type CreateProductionMutationVariables = Exact<{
  value: ProductionInput;
  billAllocation: Array<BillAllocationInput> | BillAllocationInput;
}>;


export type CreateProductionMutation = { createProduction: { id: string } };

export type ReservationBillFragment = { id: string, reservationId?: Array<string> | null, open: boolean, reservedResourceId?: Array<string> | null, description: string, category: BillCategoryType, auditable: { createdOn?: Date | null }, owner: { id: string, name: any, type: CustomerType }, reservedResource?: Array<{ id: string, end: Date, start: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }> }> | null, productions?: Array<{ id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, description?: string | null, chargeCategory: { id: string, name: string, cityTax: boolean, stayIncluded: boolean }, vat: { id: string, value: number, code: string }, reservedResource?: { id: string, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } }> | null, document?: { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null }, creditNote?: { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { name: any, type: CustomerType, fiscalCode?: any | null } } | null } | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null } };

export type GetAllAvailableResourcesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  excludeReservedResourceId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
  time?: InputMaybe<TimeRangeInput>;
  resourceTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type GetAllAvailableResourcesQuery = { getAllAvailableResources?: Array<{ id: string, code: string, resourceTypeId: string }> | null };

export type DailyAvailabilitiesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
  resourceTypeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DailyAvailabilitiesQuery = { dailyAvailabilities?: Array<{ availability: number, day: Date, resourceTypeId: string }> | null };

export type PlanningReservationFragment = { id: string, voucher?: string | null, reservationCode: string, credit: CreditType, isGroup: boolean, group?: string | null, reservationState: { confirmed: boolean, canceled: boolean, noshow: boolean, optioned: boolean }, reference: { mainGuest: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null }, portalInfo?: { portal: { name: PortalName } } | null, notes?: Array<{ description: string }> | null, origin: { id: string, name: OriginName }, tags?: Array<{ id: string, label: string, color: string }> | null };

export type PlaningGuestOccupancyFragment = { type: GuestType, phase: ReservedResourcePhase, guest: { id: string, name: any, tags?: Array<{ id: string, label: string, color: string }> | null } };

export type PlanningReservedResourceFragment = { id: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, time?: { from: Date, to: Date } | null, policy: { name: string }, chargeCategory: { name: string }, reservation: { id: string, voucher?: string | null, reservationCode: string, credit: CreditType, isGroup: boolean, group?: string | null, reservationState: { confirmed: boolean, canceled: boolean, noshow: boolean, optioned: boolean }, reference: { mainGuest: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null }, portalInfo?: { portal: { name: PortalName } } | null, notes?: Array<{ description: string }> | null, origin: { id: string, name: OriginName }, tags?: Array<{ id: string, label: string, color: string }> | null }, resourceOccupancies: Array<{ start: Date, end: Date, reservedResourceType: { id: string, code?: string | null }, assignedResourceType: { id: string, code?: string | null }, resource?: { id: string, code: string } | null, commitments?: Array<{ resourceTypeId: string, resourcesId?: Array<string> | null, quantity: number }> | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, guest: { name: any } }> | null };

export type PlanningReservedResourcesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type PlanningReservedResourcesQuery = { reservedResources?: Array<{ id: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, time?: { from: Date, to: Date } | null, policy: { name: string }, chargeCategory: { name: string }, reservation: { id: string, voucher?: string | null, reservationCode: string, credit: CreditType, isGroup: boolean, group?: string | null, reservationState: { confirmed: boolean, canceled: boolean, noshow: boolean, optioned: boolean }, reference: { mainGuest: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null }, portalInfo?: { portal: { name: PortalName } } | null, notes?: Array<{ description: string }> | null, origin: { id: string, name: OriginName }, tags?: Array<{ id: string, label: string, color: string }> | null }, resourceOccupancies: Array<{ start: Date, end: Date, reservedResourceType: { id: string, code?: string | null }, assignedResourceType: { id: string, code?: string | null }, resource?: { id: string, code: string } | null, commitments?: Array<{ resourceTypeId: string, resourcesId?: Array<string> | null, quantity: number }> | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, guest: { name: any } }> | null }> | null };

export type PlanningReservedResourceDetailsFragment = { adults: number, chargeCategoryId: string, children: number, manualPrice?: number | null, rateId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, guestOccupancies?: Array<{ wciState?: WciState | null, type: GuestType, start: Date, phase: ReservedResourcePhase, guestId: string, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null }> | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, reservedResourceTypeId: string, assignedResourceTypeId: string, start: Date, commitments?: Array<{ resourceTypeId: string, resourcesId?: Array<string> | null }> | null }>, productions?: Array<{ currency: Currency, total: number, date: Date, chargeCategory: { stayIncluded: boolean } }> | null };

export type PlanningReservedResourceDetailsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservedResourceId: Scalars['ID'];
}>;


export type PlanningReservedResourceDetailsQuery = { reservedResources?: Array<{ adults: number, chargeCategoryId: string, children: number, manualPrice?: number | null, rateId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, guestOccupancies?: Array<{ wciState?: WciState | null, type: GuestType, start: Date, phase: ReservedResourcePhase, guestId: string, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null }> | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, reservedResourceTypeId: string, assignedResourceTypeId: string, start: Date, commitments?: Array<{ resourceTypeId: string, resourcesId?: Array<string> | null }> | null }>, productions?: Array<{ currency: Currency, total: number, date: Date, chargeCategory: { stayIncluded: boolean } }> | null }> | null };

export type ReservedResourcesSubscriptionVariables = Exact<{
  filter: ReservedResourceEventFilter;
}>;


export type ReservedResourcesSubscription = { reservedResourceEvent?: { id: string, operation: CrudOperation } | null };

export type ResourceUnavailabilityFragment = { id: string, name: string, start: Date, end: Date, note?: string | null };

export type ResourceForPlanningFragment = { id: string, code: string, cleaningState: CleaningState, roomTetrisOrder: number, position?: { name: string } | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, unavailabilities?: Array<{ id: string, name: string, start: Date, end: Date, note?: string | null }> | null };

export type ResourceTimeConfigurationFragment = { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null };

export type ResourceTypeForPlanningFragment = { id: string, code?: string | null, customName?: LocalizedString | null, tenantId: string, propertyId: string, inventory: number, logicalType: boolean, name: { type: TaxonomyType, description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, resources?: Array<{ id: string, code: string, cleaningState: CleaningState, roomTetrisOrder: number, position?: { name: string } | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, unavailabilities?: Array<{ id: string, name: string, start: Date, end: Date, note?: string | null }> | null }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null };

export type PlanningResourceTypesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  timeResource?: InputMaybe<Scalars['Boolean']>;
  resourceTypeId?: InputMaybe<IDFilter>;
}>;


export type PlanningResourceTypesQuery = { resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, tenantId: string, propertyId: string, inventory: number, logicalType: boolean, name: { type: TaxonomyType, description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, resources?: Array<{ id: string, code: string, cleaningState: CleaningState, roomTetrisOrder: number, position?: { name: string } | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, unavailabilities?: Array<{ id: string, name: string, start: Date, end: Date, note?: string | null }> | null }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }> | null };

export type PlanningDailyAvailabilitiesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type PlanningDailyAvailabilitiesQuery = { dailyAvailabilities?: Array<{ day: Date, resourceTypeId: string, availability: number, resources: Array<{ type: ResourceCommitmentType, resourceId: string }> }> | null };

export type PlanningReservationInfoDataFragment = { id: string, reservedResources?: Array<{ id: string, phase: ReservedResourcePhase, guestOccupancies?: Array<{ wciState?: WciState | null }> | null, productions?: Array<{ total: number, bills?: Array<{ bill: { reservationId?: Array<string> | null, id: string, open: boolean } }> | null }> | null }> | null };

export type PlanningReservationDepositInfoDataFragment = { id: string, residualAmount?: number | null };

export type PlanningReservationInfoQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
}>;


export type PlanningReservationInfoQuery = { reservations?: Array<{ id: string, reservedResources?: Array<{ id: string, phase: ReservedResourcePhase, guestOccupancies?: Array<{ wciState?: WciState | null }> | null, productions?: Array<{ total: number, bills?: Array<{ bill: { reservationId?: Array<string> | null, id: string, open: boolean } }> | null }> | null }> | null }> | null, depositDocuments?: Array<{ id: string, residualAmount?: number | null }> | null };

export type PriceCalendarDayAvailabilityFragment = { availability: number, resourceTypeId: string, stopSellOTA: boolean, onlineLimit?: number | null };

export type PriceCalendarDayRateFragment = { rateId: string, bookingPolicyId?: string | null, stopSellResourcesTypeId?: Array<string> | null, closeChargesCategoryId?: Array<string> | null, currency: Currency, chargesRate?: Array<{ priceType: PriceType, chargeCategoryId: string, resourceTypeId: string, price?: number | null, minStay?: number | null, closedToArrival?: boolean | null, closedToDeparture?: boolean | null, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null };

export type PriceCalendarDayFragment = { id: string, day: Date, availabilities: Array<{ availability: number, resourceTypeId: string, stopSellOTA: boolean, onlineLimit?: number | null }>, rates: Array<{ rateId: string, bookingPolicyId?: string | null, stopSellResourcesTypeId?: Array<string> | null, closeChargesCategoryId?: Array<string> | null, currency: Currency, chargesRate?: Array<{ priceType: PriceType, chargeCategoryId: string, resourceTypeId: string, price?: number | null, minStay?: number | null, closedToArrival?: boolean | null, closedToDeparture?: boolean | null, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null }> };

export type GetPriceCalendarQueryVariables = Exact<{
  filter: PriceCalendarFilter;
}>;


export type GetPriceCalendarQuery = { getPriceCalendar: Array<{ id: string, day: Date, availabilities: Array<{ availability: number, resourceTypeId: string, stopSellOTA: boolean, onlineLimit?: number | null }>, rates: Array<{ rateId: string, bookingPolicyId?: string | null, stopSellResourcesTypeId?: Array<string> | null, closeChargesCategoryId?: Array<string> | null, currency: Currency, chargesRate?: Array<{ priceType: PriceType, chargeCategoryId: string, resourceTypeId: string, price?: number | null, minStay?: number | null, closedToArrival?: boolean | null, closedToDeparture?: boolean | null, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null }> }> };

export type ResourceTypeAndRateAndChargeCategoryQueryVariables = Exact<{
  filterResourceType: ResourceTypeQueryFilter;
  filterRate: RateQueryFilter;
  filterChargeCategory: ChargeCategoryQueryFilter;
}>;


export type ResourceTypeAndRateAndChargeCategoryQuery = { resourceTypes?: Array<{ id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null }> | null, rates?: Array<{ currency: Currency, type: RateType, name: LocalizedString, description: LocalizedString, visibilityOnIbe: boolean, agreementRate: boolean, parentRateId?: string | null, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, closeToArrival?: string | null, closeToDeparture?: string | null, chargeCategoryId: string, resourcesTypeEnabledId?: Array<string> | null, bookingPolicyId: string, ibeCode?: string | null, order: number, tenantId: string, propertyId: string, id: string, restrictionFromParent: boolean, crossSell: CrossSell, affiliatedCompaniesId?: Array<string> | null, intPrices?: boolean | null, derivedRules?: Array<{ operation: MathOperation, value: number }> | null, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null, parentRate?: { resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null } | null, chargesRate?: Array<{ chargeCategoryId: string, priceModel: PriceModel, operation: MathOperation, price: number, resourceTypeId?: string | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null, chargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null } }> | null, resourcesTypeEnabled?: Array<{ id: string, persons: number }> | null, childRule: { rule: ChildRuleType, childDiscount?: Array<{ childId: string, percentage: number, child: { id: string, percentageDiscount: number, noOccupancy: boolean, maxAge: number, minAge: number, taxonomyId: string, taxonomy: { description: LocalizedString } } }> | null }, chargeCategory: { name: string, code?: ChargeCategoryBoard | null }, bookingPolicy: { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, name: LocalizedString } }> | null, priceRanges?: Array<{ name: string, resourceType: Array<{ resourceTypeId: string, price: number, resourceType: { rackRate: number, customName?: LocalizedString | null, code?: string | null, persons: number, additionalPersons: number, name: { description: LocalizedString } } }> }> | null }> | null, chargeCategories?: Array<{ id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } }> | null };

export type UpdatePriceCalendarMutationVariables = Exact<{
  value: PriceCalendarInput;
}>;


export type UpdatePriceCalendarMutation = { updatePriceCalendar?: any | null };

export type UpdatePriceCalendarRangeMutationVariables = Exact<{
  value: PriceCalendarRangeInput;
}>;


export type UpdatePriceCalendarRangeMutation = { updatePriceCalendarRange?: any | null };

export type ProductionAssignedFragment = { id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, description?: string | null, chargeCategory: { id: string, name: string, cityTax: boolean, stayIncluded: boolean }, vat: { id: string, value: number, code: string }, reservedResource?: { id: string, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } };

export type MoveProductionAssignedMutationVariables = Exact<{
  input: MoveProductionAssignedInput;
}>;


export type MoveProductionAssignedMutation = { moveProductionAssigned?: any | null };

export type SplitProductionAssignedMutationVariables = Exact<{
  input: SplitProductionAssignedInput;
}>;


export type SplitProductionAssignedMutation = { splitProductionAssigned?: any | null };

export type ProductionFragment = { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, description?: string | null, chargeCategory: { id: string, name: string, cityTax: boolean, stayIncluded: boolean }, vat: { id: string, value: number, code: string }, reservedResource?: { id: string, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null };

export type deleteProductionMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type deleteProductionMutation = { deleteProduction?: any | null };

export type UpdateProductionMutationVariables = Exact<{
  id: Scalars['ID'];
  value: ProductionInput;
}>;


export type UpdateProductionMutation = { updateProduction: { id: string, amount: number, quantity: number, total: number, description?: string | null } };

export type IstatDataFragment = { date: Date, property: { availableRooms: number, availableBeds: number, occupiedRooms: number }, guests: Array<{ phases: { checkin: boolean, checkout: boolean, stay: boolean }, municipality?: { name: string, isoCode: string } | null, country: { name: string, isoCode: string } }> };

export type GetIstatDataQueryVariables = Exact<{
  input: GetIstatDataInput;
}>;


export type GetIstatDataQuery = { getIstatData?: Array<{ date: Date, property: { availableRooms: number, availableBeds: number, occupiedRooms: number }, guests: Array<{ phases: { checkin: boolean, checkout: boolean, stay: boolean }, municipality?: { name: string, isoCode: string } | null, country: { name: string, isoCode: string } }> }> | null };

export type PsErrorFragment = { message: string, details?: string | null, code: string };

export type PsRegistrationDataFragment = { id: string, reservationId: string, reservation: { reservationState: { noshow: boolean, canceled: boolean } }, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, checkout?: Date | null, checkin?: Date | null, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null }, psSent?: { success: boolean, timestamp: Date, lastError?: { message: string, details?: string | null, code: string } | null } | null }> | null, resourceOccupancies: Array<{ assignedResourceType: { customName?: LocalizedString | null, description: LocalizedString } }> };

export type PsRegistrationsDataQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type PsRegistrationsDataQuery = { reservedResources?: Array<{ id: string, reservationId: string, reservation: { reservationState: { noshow: boolean, canceled: boolean } }, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, checkout?: Date | null, checkin?: Date | null, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null }, psSent?: { success: boolean, timestamp: Date, lastError?: { message: string, details?: string | null, code: string } | null } | null }> | null, resourceOccupancies: Array<{ assignedResourceType: { customName?: LocalizedString | null, description: LocalizedString } }> }> | null };

export type GetPsConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type GetPsConfigurationQuery = { properties?: Array<{ psConfigurations?: Array<{ auto: boolean }> | null }> | null };

export type SendPsMutationVariables = Exact<{
  input: SendPSInput;
}>;


export type SendPsMutation = { sendPs?: Array<string> | null };

export type IstatErrorFragment = { configurationName: string, date?: Date | null, message: string, messageFromSystem?: string | null };

export type SendIstatMutationVariables = Exact<{
  input: SendIstatInput;
}>;


export type SendIstatMutation = { sendIstat?: Array<{ configurationName: string, date?: Date | null, message: string, messageFromSystem?: string | null }> | null };

export type SendIstatPeriodMutationVariables = Exact<{
  input: SendIstatPeriodInput;
}>;


export type SendIstatPeriodMutation = { sendIstatPeriod?: any | null };

export type RegistrationFileFragment = { key: string, URL: string, filename?: string | null, mimeType?: string | null };

export type GetRegistrationFilesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
}>;


export type GetRegistrationFilesQuery = { files?: Array<{ key: string, URL: string, filename?: string | null, mimeType?: string | null }> | null };

export type GenerateIstatFileMutationVariables = Exact<{
  input: GenerateIstatFileInput;
}>;


export type GenerateIstatFileMutation = { generateIstatFile: { success: boolean, fileUrl?: string | null, errors?: Array<{ configurationName: string, date?: Date | null, message: string }> | null } };

export type BookingPolicyReservationFragment = { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } };

export type ReservationRatesFragment = { id: string, resources?: Array<{ availability: number, inventory: number, dailyAvailability?: Array<{ availability: number, day: Date }> | null, resourceType: { id: string, description: LocalizedString, code?: string | null, persons: number, additionalPersons: number, inventory: number, rackRate: number, currency: Currency, customName?: LocalizedString | null, maxAdults?: number | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null } }> | null, rates?: Array<{ bookingPolicyOverrideId?: string | null, restrictionsNotMet?: Array<RateRestriction> | null, bookingPolicyOverride?: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } } | null, rate: { id: string, name: LocalizedString, chargeCategoryId: string, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, affiliatedCompaniesId?: Array<string> | null, closeToArrival?: string | null, closeToDeparture?: string | null, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null, bookingPolicy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, childRule: { rule: ChildRuleType, childDiscount?: Array<{ percentage: number, child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, resourceRates?: Array<{ bookable: boolean, restrictionsNotMet?: Array<RateRestriction> | null, resourceTypeId: string, chargeCategoryId: string, dailyPrice: Array<{ price: number, day: Date, restriction?: RateRestriction | null }>, resourceType: { maxAdults?: number | null, persons: number }, chargeCategory: { name: string, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string } }> | null }> | null };

export type OriginFragment = { id: string, name: OriginName, pms: boolean };

export type ReservationRatesQueryVariables = Exact<{
  filter: RqQueryFilter;
}>;


export type ReservationRatesQuery = { rateQuery: { id: string, resources?: Array<{ availability: number, inventory: number, dailyAvailability?: Array<{ availability: number, day: Date }> | null, resourceType: { id: string, description: LocalizedString, code?: string | null, persons: number, additionalPersons: number, inventory: number, rackRate: number, currency: Currency, customName?: LocalizedString | null, maxAdults?: number | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null } }> | null, rates?: Array<{ bookingPolicyOverrideId?: string | null, restrictionsNotMet?: Array<RateRestriction> | null, bookingPolicyOverride?: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } } | null, rate: { id: string, name: LocalizedString, chargeCategoryId: string, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, affiliatedCompaniesId?: Array<string> | null, closeToArrival?: string | null, closeToDeparture?: string | null, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null, bookingPolicy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, childRule: { rule: ChildRuleType, childDiscount?: Array<{ percentage: number, child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, resourceRates?: Array<{ bookable: boolean, restrictionsNotMet?: Array<RateRestriction> | null, resourceTypeId: string, chargeCategoryId: string, dailyPrice: Array<{ price: number, day: Date, restriction?: RateRestriction | null }>, resourceType: { maxAdults?: number | null, persons: number }, chargeCategory: { name: string, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string } }> | null }> | null } };

export type OriginsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  pms?: InputMaybe<Scalars['Boolean']>;
}>;


export type OriginsQuery = { origins?: Array<{ id: string, name: OriginName, pms: boolean }> | null };

export type ReservationCreateMutationVariables = Exact<{
  value: ReservationInput;
  options: ReservationOptions;
}>;


export type ReservationCreateMutation = { createReservation: { id: string, credit: CreditType, tenantId: string, propertyId: Array<string>, reservationCode: string, isGroup: boolean, group?: string | null, paOrder?: string | null, paCIG?: string | null, disableAutomation?: boolean | null, voucher?: string | null, optionExpiration?: Date | null, portalInfo?: { commission?: number | null, portalCityTaxExoneration?: CityTaxExonerationCode | null, portal: { name: PortalName }, payment?: { amount?: number | null, currency?: Currency | null, commissionModel?: PortalPaymentCommissionModel | null, paymentMethod?: PortalPaymentMethod | null, paymentCard?: { cardActivationDate?: Date | null } | null } | null } | null, reservedResources?: Array<{ id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }, origin: { id: string, name: OriginName }, auditable: { createdOn?: Date | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean }, policy?: { name: string, additionalNote?: LocalizedString | null, paymentRule: { guaranteedCreditCard: boolean, type: GuaranteeType }, noShowRule: { percentage?: number | null, type: NoShowType }, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType } } | null, tsPayLinks?: Array<{ id: string, generateDocument: boolean, documentId?: string | null, cardInfo?: string | null, type: TsPayLinkType, currency: Currency, amount: number, auditable: { createdOn?: Date | null, modifiedOn?: Date | null, state: State }, charges: Array<{ state: TsPayChargeState, amount: number, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null } }> }> | null, files?: Array<{ id: string, URL: string, filename?: string | null, mimeType?: string | null, auditable: { createdOn?: Date | null } }> | null } };

export type ReservationInputFragment = { id: string, group?: string | null, disableAutomation?: boolean | null, reference: { customerPersonId?: string | null, customerCompanyId?: string | null, mainGuestId: string }, reservedResources?: Array<{ end: Date, start: Date, rateId: string, chargeCategoryId: string }> | null, notes?: Array<{ description: string }> | null };

export type ReservedResourceCreateMutationVariables = Exact<{
  value: ReservedResourceInput;
  options: ReservationOptions;
}>;


export type ReservedResourceCreateMutation = { createReservedResource: { id: string } };

export type ReservationsCreationQueryVariables = Exact<{
  filter: ReservationQueryFilter;
}>;


export type ReservationsCreationQuery = { reservations?: Array<{ id: string, group?: string | null, disableAutomation?: boolean | null, reference: { customerPersonId?: string | null, customerCompanyId?: string | null, mainGuestId: string }, reservedResources?: Array<{ end: Date, start: Date, rateId: string, chargeCategoryId: string }> | null, notes?: Array<{ description: string }> | null }> | null };

export type DepositAssignedFragment = { id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number };

export type DepositDocumentFragment = { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, residualAmount?: number | null, documentDate: Date, documentPaymentDetails: Array<{ paymentActive: { name: LocalizedString } }>, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { name: any, type: CustomerType, fiscalCode?: any | null } };

export type CreateDepositMutationVariables = Exact<{
  input: DepositDocumentInput;
}>;


export type CreateDepositMutation = { createDepositDocument: { id: string } };

export type DeleteDepositMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  depositId: Scalars['String'];
}>;


export type DeleteDepositMutation = { deleteDocument?: any | null };

export type ReservationBillDocumentFragment = { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null }, creditNote?: { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { name: any, type: CustomerType, fiscalCode?: any | null } } | null };

export type CreateCheckoutDocumentMutationVariables = Exact<{
  input: CheckoutDocumentInput;
}>;


export type CreateCheckoutDocumentMutation = { createCheckoutDocument: { id: string } };

export type GetProductionsQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type GetProductionsQuery = { reservedResources?: Array<{ productions?: Array<{ id: string }> | null }> | null };

export type ProductionDetailItemFragment = { id: string, date: Date, description?: string | null, quantity: number, amount: number, total: number, currency: Currency, chargeCategory: { name: string }, bills?: Array<{ quota: number, bill: { id: string, description: string, reservation?: Array<{ id: string, reservationCode: string }> | null } }> | null };

export type ReservedResourceProductionDetailItemFragment = { productions?: Array<{ id: string, date: Date, description?: string | null, quantity: number, amount: number, total: number, currency: Currency, chargeCategory: { name: string }, bills?: Array<{ quota: number, bill: { id: string, description: string, reservation?: Array<{ id: string, reservationCode: string }> | null } }> | null }> | null };

export type GetProductionsDetailsQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type GetProductionsDetailsQuery = { reservedResources?: Array<{ productions?: Array<{ id: string, date: Date, description?: string | null, quantity: number, amount: number, total: number, currency: Currency, chargeCategory: { name: string }, bills?: Array<{ quota: number, bill: { id: string, description: string, reservation?: Array<{ id: string, reservationCode: string }> | null } }> | null }> | null }> | null };

export type ReservationListFragment = { id: string, reservationCode: string, reservationState: { name: string, icon: string, color: string }, reference: { mainGuest: { name: any } }, origin: { name: OriginName }, reservedResources?: Array<{ adults: number, children: number, start: Date, end: Date, chargeCategory: { name: string } }> | null, notes?: Array<{ type: NoteType, description: string }> | null };

export type ReservationListQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ReservationListQuery = { reservations?: Array<{ id: string, reservationCode: string, reservationState: { name: string, icon: string, color: string }, reference: { mainGuest: { name: any } }, origin: { name: OriginName }, reservedResources?: Array<{ adults: number, children: number, start: Date, end: Date, chargeCategory: { name: string } }> | null, notes?: Array<{ type: NoteType, description: string }> | null }> | null };

export type reservationSearchFragment = { id: string, reservationCode: string, mainGuest?: string | null, company?: string | null, start: Date, end: Date, reservationState: string, resources: number, canceledOn?: Date | null, createdOn: Date, group?: string | null, isGroup?: boolean | null, originId: string, portalId?: string | null, optionExpiration?: Date | null };

export type ReservationSearchQueryVariables = Exact<{
  filter: ReservationFullTextQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ReservationFullTextQuerySortInput>;
}>;


export type ReservationSearchQuery = { reservationSearch?: Array<{ id: string, reservationCode: string, mainGuest?: string | null, company?: string | null, start: Date, end: Date, reservationState: string, resources: number, canceledOn?: Date | null, createdOn: Date, group?: string | null, isGroup?: boolean | null, originId: string, portalId?: string | null, optionExpiration?: Date | null }> | null };

export type UsedPortalFragment = { id: string, name: PortalName, commercialName: string };

export type UsedPortalQueryVariables = Exact<{
  filter: ChannelQueryFilter;
}>;


export type UsedPortalQuery = { channels?: Array<{ portal: { id: string, name: PortalName, commercialName: string } }> | null };

export type ReservationDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ReservationDeleteMutation = { deleteReservation?: any | null };

export type ReservationStateFragment = { id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean };

export type ReservationStatesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type ReservationStatesQuery = { reservationStates?: Array<{ id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean }> | null };

export type NoteFragment = { type: NoteType, description: string };

export type ResourceTypeFragmentFragment = { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null };

export type ResourceOccupancyFragment = { start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null };

export type GuestAddressFragment = { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null };

export type GuestFragment = { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null };

export type GuestsLookupQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  search?: InputMaybe<StringFilter>;
  idFilter?: InputMaybe<IDFilter>;
  type?: InputMaybe<CustomerType>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GuestsLookupQuery = { customers?: Array<{ id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null }> | null };

export type GuestOccupancyFragment = { phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } };

export type ReservedResourceFragment = { id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null };

export type ReferenceCustomerFragment = { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null };

export type ReferenceCustomersLookupQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  search?: InputMaybe<StringFilter>;
  idFilter?: InputMaybe<IDFilter>;
  type?: InputMaybe<CustomerType>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ReferenceCustomersLookupQuery = { customers?: Array<{ id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }> | null };

export type TsPayChargeFragment = { id: string, chargeKey: string, state: TsPayChargeState, refundReason?: TsPayRefundReason | null, amount: number, amountPreauth?: number | null, netAmount: number, currency: Currency, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null, state: State }, link: { auditable: { modifiedOn?: Date | null } } };

export type TsPayLinkFragment = { id: string, generateDocument: boolean, documentId?: string | null, cardInfo?: string | null, type: TsPayLinkType, currency: Currency, amount: number, auditable: { createdOn?: Date | null, modifiedOn?: Date | null, state: State }, charges: Array<{ state: TsPayChargeState, amount: number, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null } }> };

export type PortalInfoFragment = { commission?: number | null, portalCityTaxExoneration?: CityTaxExonerationCode | null, portal: { name: PortalName }, payment?: { amount?: number | null, currency?: Currency | null, commissionModel?: PortalPaymentCommissionModel | null, paymentMethod?: PortalPaymentMethod | null, paymentCard?: { cardActivationDate?: Date | null } | null } | null };

export type ReservationBookingPolicyFragment = { name: string, additionalNote?: LocalizedString | null, paymentRule: { guaranteedCreditCard: boolean, type: GuaranteeType }, noShowRule: { percentage?: number | null, type: NoShowType }, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType } };

export type ReservationFileFragment = { id: string, URL: string, filename?: string | null, mimeType?: string | null, auditable: { createdOn?: Date | null } };

export type ReservationDetailFragment = { id: string, credit: CreditType, tenantId: string, propertyId: Array<string>, reservationCode: string, isGroup: boolean, group?: string | null, paOrder?: string | null, paCIG?: string | null, disableAutomation?: boolean | null, voucher?: string | null, optionExpiration?: Date | null, portalInfo?: { commission?: number | null, portalCityTaxExoneration?: CityTaxExonerationCode | null, portal: { name: PortalName }, payment?: { amount?: number | null, currency?: Currency | null, commissionModel?: PortalPaymentCommissionModel | null, paymentMethod?: PortalPaymentMethod | null, paymentCard?: { cardActivationDate?: Date | null } | null } | null } | null, reservedResources?: Array<{ id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }, origin: { id: string, name: OriginName }, auditable: { createdOn?: Date | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean }, policy?: { name: string, additionalNote?: LocalizedString | null, paymentRule: { guaranteedCreditCard: boolean, type: GuaranteeType }, noShowRule: { percentage?: number | null, type: NoShowType }, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType } } | null, tsPayLinks?: Array<{ id: string, generateDocument: boolean, documentId?: string | null, cardInfo?: string | null, type: TsPayLinkType, currency: Currency, amount: number, auditable: { createdOn?: Date | null, modifiedOn?: Date | null, state: State }, charges: Array<{ state: TsPayChargeState, amount: number, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null } }> }> | null, files?: Array<{ id: string, URL: string, filename?: string | null, mimeType?: string | null, auditable: { createdOn?: Date | null } }> | null };

export type ReservationDetailQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
}>;


export type ReservationDetailQuery = { getReservationLink: string, reservations?: Array<{ id: string, credit: CreditType, tenantId: string, propertyId: Array<string>, reservationCode: string, isGroup: boolean, group?: string | null, paOrder?: string | null, paCIG?: string | null, disableAutomation?: boolean | null, voucher?: string | null, optionExpiration?: Date | null, portalInfo?: { commission?: number | null, portalCityTaxExoneration?: CityTaxExonerationCode | null, portal: { name: PortalName }, payment?: { amount?: number | null, currency?: Currency | null, commissionModel?: PortalPaymentCommissionModel | null, paymentMethod?: PortalPaymentMethod | null, paymentCard?: { cardActivationDate?: Date | null } | null } | null } | null, reservedResources?: Array<{ id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }, origin: { id: string, name: OriginName }, auditable: { createdOn?: Date | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean }, policy?: { name: string, additionalNote?: LocalizedString | null, paymentRule: { guaranteedCreditCard: boolean, type: GuaranteeType }, noShowRule: { percentage?: number | null, type: NoShowType }, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType } } | null, tsPayLinks?: Array<{ id: string, generateDocument: boolean, documentId?: string | null, cardInfo?: string | null, type: TsPayLinkType, currency: Currency, amount: number, auditable: { createdOn?: Date | null, modifiedOn?: Date | null, state: State }, charges: Array<{ state: TsPayChargeState, amount: number, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null } }> }> | null, files?: Array<{ id: string, URL: string, filename?: string | null, mimeType?: string | null, auditable: { createdOn?: Date | null } }> | null }> | null, bills?: Array<{ id: string, reservationId?: Array<string> | null, open: boolean, reservedResourceId?: Array<string> | null, description: string, category: BillCategoryType, auditable: { createdOn?: Date | null }, owner: { id: string, name: any, type: CustomerType }, reservedResource?: Array<{ id: string, end: Date, start: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }> }> | null, productions?: Array<{ id: string, quota: number, billId: string, production: { id: string, currency: Currency, amount: number, quantity: number, total: number, date: Date, description?: string | null, chargeCategory: { id: string, name: string, cityTax: boolean, stayIncluded: boolean }, vat: { id: string, value: number, code: string }, reservedResource?: { id: string, reservationId: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> } | null, cityTax?: { guestId?: string | null, exoneration?: CityTaxExonerationCode | null } | null } }> | null, document?: { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { id: string, name: any, type: CustomerType, fiscalCode?: any | null }, creditNote?: { id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, documentDate: Date, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { name: any, type: CustomerType, fiscalCode?: any | null } } | null } | null, searchInfo: { ownerName: string, resources?: Array<string> | null, guestNames?: Array<string> | null } }> | null, depositDocuments?: Array<{ id: string, numberExtended: string, fiscalType: FiscalType, totalAmount: number, residualAmount?: number | null, documentDate: Date, documentPaymentDetails: Array<{ paymentActive: { name: LocalizedString } }>, depositAssigneds?: Array<{ id: string, reservationId?: string | null, reservedResourceId?: string | null, billId?: string | null, documentId?: string | null, amount: number }> | null, customer: { name: any, type: CustomerType, fiscalCode?: any | null } }> | null };

export type ReservationUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ReservationUpdateInput;
}>;


export type ReservationUpdateMutation = { updateReservation: { id: string, credit: CreditType, tenantId: string, propertyId: Array<string>, reservationCode: string, isGroup: boolean, group?: string | null, paOrder?: string | null, paCIG?: string | null, disableAutomation?: boolean | null, voucher?: string | null, optionExpiration?: Date | null, portalInfo?: { commission?: number | null, portalCityTaxExoneration?: CityTaxExonerationCode | null, portal: { name: PortalName }, payment?: { amount?: number | null, currency?: Currency | null, commissionModel?: PortalPaymentCommissionModel | null, paymentMethod?: PortalPaymentMethod | null, paymentCard?: { cardActivationDate?: Date | null } | null } | null } | null, reservedResources?: Array<{ id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }, origin: { id: string, name: OriginName }, auditable: { createdOn?: Date | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { id: string, name: string, icon: string, color: string, order: number, confirmed: boolean, optioned: boolean, canceled: boolean, noshow: boolean }, policy?: { name: string, additionalNote?: LocalizedString | null, paymentRule: { guaranteedCreditCard: boolean, type: GuaranteeType }, noShowRule: { percentage?: number | null, type: NoShowType }, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType } } | null, tsPayLinks?: Array<{ id: string, generateDocument: boolean, documentId?: string | null, cardInfo?: string | null, type: TsPayLinkType, currency: Currency, amount: number, auditable: { createdOn?: Date | null, modifiedOn?: Date | null, state: State }, charges: Array<{ state: TsPayChargeState, amount: number, error?: { message?: string | null, errorType?: string | null } | null, auditable: { modifiedOn?: Date | null } }> }> | null, files?: Array<{ id: string, URL: string, filename?: string | null, mimeType?: string | null, auditable: { createdOn?: Date | null } }> | null } };

export type ReservedResourceUpdateMutationVariables = Exact<{
  reservedResourceId: Scalars['ID'];
  input: ReservedResourceInput;
  options: ReservedResourceOptions;
}>;


export type ReservedResourceUpdateMutation = { updateReservedResource: { id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null } };

export type DeleteReservedResourceMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteReservedResourceId: Scalars['ID'];
}>;


export type DeleteReservedResourceMutation = { deleteReservedResource?: any | null };

export type AvailableResourcesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  resourceTypeId?: InputMaybe<Scalars['ID']>;
  start: Scalars['Date'];
  end: Scalars['Date'];
  time?: InputMaybe<TimeRangeInput>;
}>;


export type AvailableResourcesQuery = { getAllAvailableResources?: Array<{ id: string, description: string, positionId?: string | null, code: string, resourceTypeId: string, position?: { id: string, name: string, order: number } | null, layout?: { occupation: number, description: LocalizedString } | null, resourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } }> | null };

export type ReservedResourcesCheckInMutationVariables = Exact<{
  input: CheckinCheckoutReservedResourcesInput;
}>;


export type ReservedResourcesCheckInMutation = { checkinReservedResources?: any | null };

export type ReservedResourcesCheckOutMutationVariables = Exact<{
  input: CheckinCheckoutReservedResourcesInput;
}>;


export type ReservedResourcesCheckOutMutation = { checkoutReservedResources?: any | null };

export type CityTaxExonerationFragment = { code: CityTaxExonerationCode, description: LocalizedString, discount?: number | null };

export type CityTaxExonerationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  usage: ExonerationUsage;
}>;


export type CityTaxExonerationsQuery = { cityTaxExonerations?: Array<{ code: CityTaxExonerationCode, description: LocalizedString, discount?: number | null }> | null };

export type EditRRResourceTypesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  timeResources?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditRRResourceTypesQuery = { resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, maxAdults?: number | null, persons: number, additionalPersons: number, name: { description: LocalizedString } }> | null };

export type GetReservationPortalPaymentCardQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  reservationId: Scalars['ID'];
}>;


export type GetReservationPortalPaymentCardQuery = { getReservationPortalPaymentCard?: { network: string, number: string, fullName: string, expiration: string, cvv?: string | null } | null };

export type EmailFragment = { id: string, to: string, subject: string, emailState: EmailState, body: string, stateTransaction: Array<{ state: EmailState, timestamp: Date, result?: string | null }> };

export type GetReservationEmailsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  reservationId: Scalars['ID'];
}>;


export type GetReservationEmailsQuery = { getReservationEmails?: Array<{ id: string, to: string, subject: string, emailState: EmailState, body: string, stateTransaction: Array<{ state: EmailState, timestamp: Date, result?: string | null }> }> | null };

export type CustomerDocumentImagesQueryVariables = Exact<{
  filter: CustomerDocumentImageQueryFilter;
}>;


export type CustomerDocumentImagesQuery = { customerDocumentImages?: Array<{ type: CustomerDocumentImageType, fileId: string, file: { URL: string } }> | null };

export type UpdateReservedResourcesMutationVariables = Exact<{
  value: Array<ReservedResourceMultiInput> | ReservedResourceMultiInput;
  options: ReservationOptions;
}>;


export type UpdateReservedResourcesMutation = { updateReservedResources: Array<{ id: string, propertyId: string, reservationId: string, start: Date, end: Date, phase: ReservedResourcePhase, adults: number, children: number, manualPrice?: number | null, additionalServices?: Array<{ quantity?: number | null, additionalService: { id: string } }> | null, chargeCategory: { id: string, code?: ChargeCategoryBoard | null, name: string }, chargeCategories?: Array<{ chargeCategoryId: string, day: Date }> | null, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayoutId?: string | null, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, name: { description: LocalizedString }, configurationsLayout?: Array<{ id: string, occupation: number, description: LocalizedString }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, activity?: { from: Date, to: Date } | null } | null }, resource?: { id: string, code: string } | null }>, rate: { id: string, name: LocalizedString, chargesRate?: Array<{ chargeCategoryId: string }> | null, childRule: { childDiscount?: Array<{ child: { id: string, noOccupancy: boolean, taxonomy: { description: LocalizedString }, auditable: { state: State } } }> | null } }, productions?: Array<{ currency: Currency, amount: number, hotelDate: Date, chargeCategoryId: string, date: Date, description?: string | null, id: string, quantity: number, total: number, vatId: string, chargeCategory: { stayIncluded: boolean }, bills?: Array<{ billId: string }> | null }> | null, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, checkin?: Date | null, checkout?: Date | null, guest: { id: string, type: CustomerType, name: any, firstName?: any | null, lastName?: any | null, language: Language, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, number: any, city?: any | null, expirationDate: Date, countryId: string } | null } | null, auditable: { state: State }, phoneContacts?: Array<{ isDefault: boolean, order: number, value: string, type: PhoneContactType }> | null, mailContacts?: Array<{ isDefault: boolean, order: number, value: string, type: MailContactType }> | null, cityTax?: { exoneration?: CityTaxExonerationCode | null } | null } }> | null, childOccupancies?: Array<{ quantity: number, child: { id: string, noOccupancy: boolean, minAge: number, maxAge: number } }> | null, dailyPricesStored?: { dailyPrices: Array<{ day: Date, price: number }> } | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, policy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { type: NoShowType, percentage?: number | null }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } }, time?: { from: Date, to: Date } | null }> };

export type UndoCheckinReservedResourcesMutationVariables = Exact<{
  input: CheckinCheckoutReservedResourcesInput;
}>;


export type UndoCheckinReservedResourcesMutation = { undoCheckinReservedResources?: any | null };

export type UndoCheckoutReservedResourcesMutationVariables = Exact<{
  input: CheckinCheckoutReservedResourcesInput;
}>;


export type UndoCheckoutReservedResourcesMutation = { undoCheckoutReservedResources?: any | null };

export type CreateChargeForReservationMutationVariables = Exact<{
  input: ChargeForReservationInput;
}>;


export type CreateChargeForReservationMutation = { createChargeForReservation: { amount: number } };

export type HoauReservedResourcesQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type HoauReservedResourcesQuery = { reservedResources?: Array<{ id: string, automationId?: string | null, guestOccupancies?: Array<{ guest: { name: any } }> | null, resourceOccupancies: Array<{ start: Date, end: Date, resource?: { code: string } | null, assignedResourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, reservedResourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } } }> }> | null };

export type SendMessageForAutomationMutationVariables = Exact<{
  input: MessageForAutomationInput;
}>;


export type SendMessageForAutomationMutation = { sendMessageForAutomation?: any | null };

export type ReservationSearchWithRRFragment = { id: string, reservationCode: string, mainGuest?: string | null, company?: string | null, start: Date, end: Date, reservationState: string, resources: number, canceledOn?: Date | null, createdOn: Date, group?: string | null, isGroup?: boolean | null, originId: string, portalId?: string | null, optionExpiration?: Date | null, reservedResources?: Array<{ id: string, guestOccupancies?: Array<{ guest: { id: string, name: any } }> | null, resourceOccupancies: Array<{ assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> }> | null };

export type ReservationSearchWithDetailsQueryVariables = Exact<{
  filter: ReservationFullTextQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ReservationFullTextQuerySortInput>;
}>;


export type ReservationSearchWithDetailsQuery = { reservationSearch?: Array<{ id: string, reservationCode: string, mainGuest?: string | null, company?: string | null, start: Date, end: Date, reservationState: string, resources: number, canceledOn?: Date | null, createdOn: Date, group?: string | null, isGroup?: boolean | null, originId: string, portalId?: string | null, optionExpiration?: Date | null, reservedResources?: Array<{ id: string, guestOccupancies?: Array<{ guest: { id: string, name: any } }> | null, resourceOccupancies: Array<{ assignedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { id: string, code: string } | null }> }> | null }> | null };

export type RateQueryForResourceQueryVariables = Exact<{
  filter: RqQueryForResourceFilter;
}>;


export type RateQueryForResourceQuery = { rateQueryForResource: { rate: { bookingPolicyOverrideId?: string | null, rateId: string, resourceRates?: Array<{ chargeCategoryId: string, resourceTypeId: string, dailyPrice: Array<{ day: Date, price: number }> }> | null, rate: { affiliatedCompaniesId?: Array<string> | null } } } };

export type ResourceTypesGroupQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypesGroupQuery = { resourceTypes?: Array<{ id: string, maxAdults?: number | null, persons: number }> | null };

export type CreateResourceUnavailabilityMutationVariables = Exact<{
  value: CreateResourceUnavailabilityInput;
  allowOverbooking: Scalars['Boolean'];
}>;


export type CreateResourceUnavailabilityMutation = { createResourceUnavailability: { id: string } };

export type UpdateResourceUnavailabilityMutationVariables = Exact<{
  value: UpdateResourceUnavailabilityInput;
  allowOverbooking: Scalars['Boolean'];
}>;


export type UpdateResourceUnavailabilityMutation = { updateResourceUnavailability: { id: string } };

export type DeleteResourceUnavailabilityMutationVariables = Exact<{
  value: DeleteResourceUnavailabilityInput;
}>;


export type DeleteResourceUnavailabilityMutation = { deleteResourceUnavailability: { id: string } };

export type GetWorstBookingPolicyQueryVariables = Exact<{
  input: WorstBookingPolicyInput;
}>;


export type GetWorstBookingPolicyQuery = { getWorstBookingPolicy: { additionalNote?: LocalizedString | null, name: string, cancellationPolicy: { daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null, type: CancellationPolicyType }, noShowRule: { percentage?: number | null, type: NoShowType }, paymentRule: { guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null, percentage?: number | null, type: GuaranteeType, installments?: Array<{ dayFromCheckin?: number | null, order: number, value: number }> | null } } };

export type CustomerListFragment = { id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null } | null, person?: { birthDate?: Date | null } | null, company?: { splitPayment: boolean } | null };

export type CustomersQueryVariables = Exact<{
  filter: CustomerQueryFilter;
  sorts?: InputMaybe<Array<CustomerSortInput> | CustomerSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CustomersQuery = { customers?: Array<{ id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null } | null, person?: { birthDate?: Date | null } | null, company?: { splitPayment: boolean } | null }> | null };

export type CustomerQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  customerId?: InputMaybe<Scalars['ID']>;
  dummy?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomerQuery = { customers?: Array<{ id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, stayVatId?: string | null, firstName?: any | null, lastName?: any | null, language: Language, tenantId: string, tagsId?: Array<string> | null, relatedCompanyId?: string | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null, profiledMarketingConsent?: boolean | null, profiledMarketingConsentDate?: Date | null, log?: { ip: string, platform: string, timestamp: Date, userAgent: string } | null } | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, company?: { physicalPerson: boolean, sdiCode?: string | null, defaultCredit?: CreditType | null, splitPayment: boolean, felOptions?: { riferimentoAmministrazione?: boolean | null } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, releaseBy?: string | null, expirationDate: Date, number: any, countryId: string, city?: any | null } | null } | null, auditable: { state: State }, cityTax?: { exoneration?: CityTaxExonerationCode | null, contracts?: Array<{ start?: Date | null, end?: Date | null }> | null } | null }> | null };

export type CustomerDetailFragment = { id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, stayVatId?: string | null, firstName?: any | null, lastName?: any | null, language: Language, tenantId: string, tagsId?: Array<string> | null, relatedCompanyId?: string | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null, profiledMarketingConsent?: boolean | null, profiledMarketingConsentDate?: Date | null, log?: { ip: string, platform: string, timestamp: Date, userAgent: string } | null } | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, company?: { physicalPerson: boolean, sdiCode?: string | null, defaultCredit?: CreditType | null, splitPayment: boolean, felOptions?: { riferimentoAmministrazione?: boolean | null } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, releaseBy?: string | null, expirationDate: Date, number: any, countryId: string, city?: any | null } | null } | null, auditable: { state: State }, cityTax?: { exoneration?: CityTaxExonerationCode | null, contracts?: Array<{ start?: Date | null, end?: Date | null }> | null } | null };

export type CustomerNewMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type CustomerNewMutation = { createCustomer: { id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, stayVatId?: string | null, firstName?: any | null, lastName?: any | null, language: Language, tenantId: string, tagsId?: Array<string> | null, relatedCompanyId?: string | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null, profiledMarketingConsent?: boolean | null, profiledMarketingConsentDate?: Date | null, log?: { ip: string, platform: string, timestamp: Date, userAgent: string } | null } | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, company?: { physicalPerson: boolean, sdiCode?: string | null, defaultCredit?: CreditType | null, splitPayment: boolean, felOptions?: { riferimentoAmministrazione?: boolean | null } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, releaseBy?: string | null, expirationDate: Date, number: any, countryId: string, city?: any | null } | null } | null, auditable: { state: State }, cityTax?: { exoneration?: CityTaxExonerationCode | null, contracts?: Array<{ start?: Date | null, end?: Date | null }> | null } | null } };

export type CustomerUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  input: CustomerInput;
  guestOfReservedResourceId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomerUpdateMutation = { updateCustomer: { id: string, type: CustomerType, name: any, fiscalCode?: any | null, vatNumber?: any | null, stayVatId?: string | null, firstName?: any | null, lastName?: any | null, language: Language, tenantId: string, tagsId?: Array<string> | null, relatedCompanyId?: string | null, mailContacts?: Array<{ type: MailContactType, value: string, order: number, isDefault: boolean }> | null, phoneContacts?: Array<{ type: PhoneContactType, value: string, order: number, isDefault: boolean }> | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string, id: string, name: LocalizedString } | null, municipality?: { name: string, id: string } | null } | null, privacy?: { marketingConsent?: boolean | null, marketingConsentDate?: Date | null, managementConsent?: boolean | null, managementConsentDate?: Date | null, dataThirdPartyConsent?: boolean | null, dataThirdPartyConsentDate?: Date | null, profiledMarketingConsent?: boolean | null, profiledMarketingConsentDate?: Date | null, log?: { ip: string, platform: string, timestamp: Date, userAgent: string } | null } | null, webContacts?: Array<{ type: WebContactType, value: string, order: number, isDefault: boolean }> | null, company?: { physicalPerson: boolean, sdiCode?: string | null, defaultCredit?: CreditType | null, splitPayment: boolean, felOptions?: { riferimentoAmministrazione?: boolean | null } | null } | null, person?: { gender?: GenderType | null, birthDate?: Date | null, nationalityId?: string | null, birthAddress?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, identificationDocument?: { documentId: string, releaseBy?: string | null, expirationDate: Date, number: any, countryId: string, city?: any | null } | null } | null, auditable: { state: State }, cityTax?: { exoneration?: CityTaxExonerationCode | null, contracts?: Array<{ start?: Date | null, end?: Date | null }> | null } | null } };

export type CustomerDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type CustomerDeleteMutation = { deleteCustomer?: any | null };

export type SimpleCustomerLookupFragment = { id: string, name: any, firstName?: any | null, lastName?: any | null, type: CustomerType, language: Language, relatedCompanyId?: string | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, address?: { city?: any | null, address?: any | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null, person?: { birthDate?: Date | null, birthAddress?: { city?: any | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null } | null, company?: { defaultCredit?: CreditType | null } | null, tags?: Array<{ id: string, label: string, color: string }> | null, relatedCompany?: { name: any } | null };

export type SimpleCustomersLookupQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  search?: InputMaybe<StringFilter>;
  idFilter?: InputMaybe<IDFilter>;
  type?: InputMaybe<CustomerType>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SimpleCustomersLookupQuery = { customers?: Array<{ id: string, name: any, firstName?: any | null, lastName?: any | null, type: CustomerType, language: Language, relatedCompanyId?: string | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, address?: { city?: any | null, address?: any | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null, person?: { birthDate?: Date | null, birthAddress?: { city?: any | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null } | null, company?: { defaultCredit?: CreditType | null } | null, tags?: Array<{ id: string, label: string, color: string }> | null, relatedCompany?: { name: any } | null }> | null };

export type ValidateItalianFiscalCodeQueryVariables = Exact<{
  fiscalCode: Scalars['String'];
}>;


export type ValidateItalianFiscalCodeQuery = { validateItalianFiscalCode: boolean };

export type ValidateItalianVatCodeQueryVariables = Exact<{
  vatCode: Scalars['String'];
}>;


export type ValidateItalianVatCodeQuery = { validateItalianVatCode: boolean };

export type CityTaxForPersonFormQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type CityTaxForPersonFormQuery = { properties?: Array<{ cityTaxConfiguration?: { configurations: Array<{ rule: CityTaxRule }> } | null }> | null };

export type GuestNameQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  guestId: Scalars['ID'];
}>;


export type GuestNameQuery = { customers?: Array<{ id: string, name: any }> | null };

export type DailyClosureAuditFragment = { id: string, tenantId: string, propertyId: string, procedureName: DailyClosureProcedure, executionDate: Date, executedBy: string, duration: number, manualExecution: boolean, result: boolean, message?: string | null, fileIds?: Array<string> | null, configurationName?: string | null, referenceDate: Date };

export type DailyClosureAuditsQueryVariables = Exact<{
  filter: DailyClosureAuditQueryFilter;
  sorts?: InputMaybe<Array<DailyClosureAuditSortInput> | DailyClosureAuditSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type DailyClosureAuditsQuery = { dailyClosureAudits?: Array<{ id: string, tenantId: string, propertyId: string, procedureName: DailyClosureProcedure, executionDate: Date, executedBy: string, duration: number, manualExecution: boolean, result: boolean, message?: string | null, fileIds?: Array<string> | null, configurationName?: string | null, referenceDate: Date }> | null };

export type DashboardKpiRowFragment = { current: number, total?: number | null, moreData?: Array<number> | null };

export type DashboardEventRowFragment = { data?: Array<string> | null, occurred: Date };

export type DashboardReceptionFragment = { departures: { current: number, total?: number | null, moreData?: Array<number> | null }, arrivals: { current: number, total?: number | null, moreData?: Array<number> | null }, occupancy: { current: number, total?: number | null, moreData?: Array<number> | null }, availability: { current: number, total?: number | null, moreData?: Array<number> | null } };

export type DashboardMealsFragment = { breakfasts: { current: number, total?: number | null, moreData?: Array<number> | null }, lunches: { current: number, total?: number | null, moreData?: Array<number> | null }, dinners: { current: number, total?: number | null, moreData?: Array<number> | null } };

export type DashboardRevenueFragment = { revpar: { current: number, total?: number | null, moreData?: Array<number> | null }, adr: { current: number, total?: number | null, moreData?: Array<number> | null }, roomProduction: { current: number, total?: number | null, moreData?: Array<number> | null }, totalProduction: { current: number, total?: number | null, moreData?: Array<number> | null } };

export type DashboardSalesFragment = { reservations: { current: number, total?: number | null, moreData?: Array<number> | null }, lastReservation?: { data?: Array<string> | null, occurred: Date } | null, cancellations: { current: number, total?: number | null, moreData?: Array<number> | null }, lastCancellation?: { data?: Array<string> | null, occurred: Date } | null };

export type DashboardKpiQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type DashboardKpiQuery = { dashboardReception?: { departures: { current: number, total?: number | null, moreData?: Array<number> | null }, arrivals: { current: number, total?: number | null, moreData?: Array<number> | null }, occupancy: { current: number, total?: number | null, moreData?: Array<number> | null }, availability: { current: number, total?: number | null, moreData?: Array<number> | null } } | null, dashboardMeals?: { breakfasts: { current: number, total?: number | null, moreData?: Array<number> | null }, lunches: { current: number, total?: number | null, moreData?: Array<number> | null }, dinners: { current: number, total?: number | null, moreData?: Array<number> | null } } | null, dashboardRevenue?: { revpar: { current: number, total?: number | null, moreData?: Array<number> | null }, adr: { current: number, total?: number | null, moreData?: Array<number> | null }, roomProduction: { current: number, total?: number | null, moreData?: Array<number> | null }, totalProduction: { current: number, total?: number | null, moreData?: Array<number> | null } } | null, dashboardSells?: { reservations: { current: number, total?: number | null, moreData?: Array<number> | null }, lastReservation?: { data?: Array<string> | null, occurred: Date } | null, cancellations: { current: number, total?: number | null, moreData?: Array<number> | null }, lastCancellation?: { data?: Array<string> | null, occurred: Date } | null } | null };

export type DashboardRRFragment = { id: string, phase: ReservedResourcePhase, start: Date, end: Date, adults: number, children: number, childOccupancies?: Array<{ childId: string, quantity: number, child: { minAge: number, maxAge: number, taxonomy: { description: LocalizedString } } }> | null, productions?: Array<{ total: number, bills?: Array<{ quota: number, bill: { open: boolean } }> | null }> | null, chargeCategory: { name: string, code?: ChargeCategoryBoard | null, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean }, resourceOccupancies: Array<{ start: Date, resource?: { id: string, code: string } | null, reservedResourceType: { customName?: LocalizedString | null, name: { description: LocalizedString } } }>, reservation: { id: string, isGroup: boolean, group?: string | null, reservationStateId: string, reservedResources?: Array<{ id: string }> | null, depositAssigneds?: Array<{ amount: number, documentId?: string | null }> | null, origin: { name: OriginName, ota: boolean }, portalInfo?: { portal: { name: PortalName } } | null, reference: { mainGuest: { name: any, language: Language, type: CustomerType }, agency?: { name: any, language: Language, type: CustomerType } | null, customerPerson?: { name: any, language: Language, type: CustomerType } | null, customerCompany?: { name: any, language: Language, type: CustomerType } | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { noshow: boolean } }, guestOccupancies?: Array<{ type: GuestType, start: Date, end: Date, guest: { name: any } }> | null };

export type DashboardRRsQueryVariables = Exact<{
  filter: DashboardQueryFilter;
}>;


export type DashboardRRsQuery = { dashboardRRs?: Array<{ id: string, phase: ReservedResourcePhase, start: Date, end: Date, adults: number, children: number, childOccupancies?: Array<{ childId: string, quantity: number, child: { minAge: number, maxAge: number, taxonomy: { description: LocalizedString } } }> | null, productions?: Array<{ total: number, bills?: Array<{ quota: number, bill: { open: boolean } }> | null }> | null, chargeCategory: { name: string, code?: ChargeCategoryBoard | null, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean }, resourceOccupancies: Array<{ start: Date, resource?: { id: string, code: string } | null, reservedResourceType: { customName?: LocalizedString | null, name: { description: LocalizedString } } }>, reservation: { id: string, isGroup: boolean, group?: string | null, reservationStateId: string, reservedResources?: Array<{ id: string }> | null, depositAssigneds?: Array<{ amount: number, documentId?: string | null }> | null, origin: { name: OriginName, ota: boolean }, portalInfo?: { portal: { name: PortalName } } | null, reference: { mainGuest: { name: any, language: Language, type: CustomerType }, agency?: { name: any, language: Language, type: CustomerType } | null, customerPerson?: { name: any, language: Language, type: CustomerType } | null, customerCompany?: { name: any, language: Language, type: CustomerType } | null }, notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { noshow: boolean } }, guestOccupancies?: Array<{ type: GuestType, start: Date, end: Date, guest: { name: any } }> | null }> | null };

export type IstatDailyClosureAuditFragment = { executionDate: Date, referenceDate: Date, procedureName: DailyClosureProcedure, result: boolean, manualExecution: boolean, message?: string | null, configurationName?: string | null };

export type IstatDailyClosureAuditsQueryVariables = Exact<{
  filter: DailyClosureAuditQueryFilter;
  sorts?: InputMaybe<Array<DailyClosureAuditSortInput> | DailyClosureAuditSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type IstatDailyClosureAuditsQuery = { dailyClosureAudits?: Array<{ executionDate: Date, referenceDate: Date, procedureName: DailyClosureProcedure, result: boolean, manualExecution: boolean, message?: string | null, configurationName?: string | null }> | null };

export type DashboardCleaningFragment = { id: string, cleaningState: CleaningState, code: string, positionId?: string | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, unavailabilities?: Array<{ id: string, start: Date, end: Date, name: string, note?: string | null }> | null, reservedResource?: { id: string, start: Date, end: Date, children: number, adults: number, resourceOccupancies: Array<{ resourceId?: string | null, start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayout?: { id: string, occupation: number, description: LocalizedString } | null }>, reservation: { notes?: Array<{ description: string, type: NoteType }> | null, reservationState: { canceled: boolean } } } | null, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement } | null } };

export type DashboardCleaningQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type DashboardCleaningQuery = { resourcesHousekeeping?: Array<{ id: string, cleaningState: CleaningState, code: string, positionId?: string | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, unavailabilities?: Array<{ id: string, start: Date, end: Date, name: string, note?: string | null }> | null, reservedResource?: { id: string, start: Date, end: Date, children: number, adults: number, resourceOccupancies: Array<{ resourceId?: string | null, start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceLayout?: { id: string, occupation: number, description: LocalizedString } | null }>, reservation: { notes?: Array<{ description: string, type: NoteType }> | null, reservationState: { canceled: boolean } } } | null, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement } | null } }> | null };

export type DashboardKpiEventSubscriptionVariables = Exact<{
  filter: DashboardQueryFilter;
}>;


export type DashboardKpiEventSubscription = { dashboardKpiEvent?: { tenantId: string, propertyId: string, date: Date } | null };

export type SendReservationEmailMutationVariables = Exact<{
  input: SendReservationMessageInput;
}>;


export type SendReservationEmailMutation = { sendReservationMessage?: any | null };

export type SendPosLink2PayEmailMutationVariables = Exact<{
  input: SendPosLink2PayEmailInput;
}>;


export type SendPosLink2PayEmailMutation = { sendPosLink2PayEmail?: { emailState: EmailState, stateTransaction: Array<{ result?: string | null, state: EmailState }> } | null };

export type PropertyEmailQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyEmailQuery = { properties?: Array<{ mailContacts?: Array<{ value: string, type: MailContactType }> | null }> | null };

export type SendAttachmentEmailForDocumentMutationVariables = Exact<{
  input: AttachmentForDocumentInput;
}>;


export type SendAttachmentEmailForDocumentMutation = { sendAttachmentEmailForDocument?: { id: string } | null };

export type HistoricalCustomerResearchCustomerFragment = { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null };

export type HistoricalCustomerResearchFragment = { id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ id: string, adults: number, children: number, start: Date, end: Date, productions?: Array<{ amount: number, currency: Currency, chargeCategory: { stayIncluded: boolean } }> | null, guestOccupancies?: Array<{ start: Date, end: Date, guest: { id: string, name: any } }> | null }> | null, notes?: Array<{ type: NoteType, description: string }> | null, reference: { mainGuest: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null, agency?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null } };

export type HistoricalCustomerResearchQueryVariables = Exact<{
  filter: ReservationQueryFilter;
}>;


export type HistoricalCustomerResearchQuery = { reservations?: Array<{ id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ id: string, adults: number, children: number, start: Date, end: Date, productions?: Array<{ amount: number, currency: Currency, chargeCategory: { stayIncluded: boolean } }> | null, guestOccupancies?: Array<{ start: Date, end: Date, guest: { id: string, name: any } }> | null }> | null, notes?: Array<{ type: NoteType, description: string }> | null, reference: { mainGuest: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null, agency?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null } }> | null };

export type HistoricalCustomerReservedResourceResearchFragment = { reservation: { id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ id: string, adults: number, children: number, start: Date, end: Date, productions?: Array<{ amount: number, currency: Currency, chargeCategory: { stayIncluded: boolean } }> | null, guestOccupancies?: Array<{ start: Date, end: Date, guest: { id: string, name: any } }> | null }> | null, notes?: Array<{ type: NoteType, description: string }> | null, reference: { mainGuest: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null, agency?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null } } };

export type HistoricalCustomerReservedResourceResearchQueryVariables = Exact<{
  filter: ReservedResourceQueryFilter;
}>;


export type HistoricalCustomerReservedResourceResearchQuery = { reservedResources?: Array<{ reservation: { id: string, reservationCode: string, isGroup: boolean, group?: string | null, reservedResources?: Array<{ id: string, adults: number, children: number, start: Date, end: Date, productions?: Array<{ amount: number, currency: Currency, chargeCategory: { stayIncluded: boolean } }> | null, guestOccupancies?: Array<{ start: Date, end: Date, guest: { id: string, name: any } }> | null }> | null, notes?: Array<{ type: NoteType, description: string }> | null, reference: { mainGuest: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null }, customerCompany?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null, agency?: { id: string, name: any, tags?: Array<{ id: string, color: string, label: string }> | null } | null } } }> | null };

export type NotificationBellNscSummaryQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type NotificationBellNscSummaryQuery = { getNcsNotificationsSummary?: Array<{ unread?: number | null, appCode?: string | null }> | null };

export type NcsNotificationFragment = { id?: string | null, createdDate?: string | null, read?: boolean | null, notification?: { message?: string | null, title?: string | null } | null };

export type GetNcsNotificationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GetNcsNotificationsQuery = { getNcsNotifications?: Array<{ id?: string | null, createdDate?: string | null, read?: boolean | null, notification?: { message?: string | null, title?: string | null } | null }> | null };

export type NcsUserPreferencesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type NcsUserPreferencesQuery = { ncsUserPreferences: { templates: Array<{ channels?: Array<NcsChannel> | null, template?: string | null }> } };

export type SetNcsUserPreferenceMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  userId: Scalars['ID'];
  preferences: Array<NcsTemplatePreferenceInput> | NcsTemplatePreferenceInput;
}>;


export type SetNcsUserPreferenceMutation = { setNcsUserPreference?: any | null };

export type SetNcsNotificationReadMutationVariables = Exact<{
  notificationId: Scalars['String'];
  read: Scalars['Boolean'];
}>;


export type SetNcsNotificationReadMutation = { setNcsNotificationRead?: any | null };

export type SetNcsNotificationsReadMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  read: Scalars['Boolean'];
  userId?: InputMaybe<Scalars['ID']>;
  propertyId: Scalars['ID'];
}>;


export type SetNcsNotificationsReadMutation = { setNcsNotificationsRead?: any | null };

export type RateFragment = { currency: Currency, type: RateType, name: LocalizedString, description: LocalizedString, visibilityOnIbe: boolean, agreementRate: boolean, parentRateId?: string | null, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, closeToArrival?: string | null, closeToDeparture?: string | null, chargeCategoryId: string, resourcesTypeEnabledId?: Array<string> | null, bookingPolicyId: string, ibeCode?: string | null, order: number, tenantId: string, propertyId: string, id: string, restrictionFromParent: boolean, crossSell: CrossSell, affiliatedCompaniesId?: Array<string> | null, intPrices?: boolean | null, derivedRules?: Array<{ operation: MathOperation, value: number }> | null, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null, parentRate?: { resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null } | null, chargesRate?: Array<{ chargeCategoryId: string, priceModel: PriceModel, operation: MathOperation, price: number, resourceTypeId?: string | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null, chargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null } }> | null, resourcesTypeEnabled?: Array<{ id: string, persons: number }> | null, childRule: { rule: ChildRuleType, childDiscount?: Array<{ childId: string, percentage: number, child: { id: string, percentageDiscount: number, noOccupancy: boolean, maxAge: number, minAge: number, taxonomyId: string, taxonomy: { description: LocalizedString } } }> | null }, chargeCategory: { name: string, code?: ChargeCategoryBoard | null }, bookingPolicy: { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, name: LocalizedString } }> | null, priceRanges?: Array<{ name: string, resourceType: Array<{ resourceTypeId: string, price: number, resourceType: { rackRate: number, customName?: LocalizedString | null, code?: string | null, persons: number, additionalPersons: number, name: { description: LocalizedString } } }> }> | null };

export type CompanyFragment = { id: string, name: any };

export type AllBookingPoliciesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type AllBookingPoliciesQuery = { bookingPolicies?: Array<{ id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }> | null };

export type BaseRateConfiguredResourceTypesFragment = { resourcesRate?: Array<{ resourceTypeId: string }> | null };

export type BaseRateConfiguredResourceTypesQueryVariables = Exact<{
  filter: RateQueryFilter;
}>;


export type BaseRateConfiguredResourceTypesQuery = { rates?: Array<{ resourcesRate?: Array<{ resourceTypeId: string }> | null }> | null };

export type CompaniesQueryVariables = Exact<{
  filter: CustomerQueryFilter;
}>;


export type CompaniesQuery = { customers?: Array<{ id: string, name: any }> | null };

export type RatesQueryVariables = Exact<{
  filter: RateQueryFilter;
}>;


export type RatesQuery = { rates?: Array<{ currency: Currency, type: RateType, name: LocalizedString, description: LocalizedString, visibilityOnIbe: boolean, agreementRate: boolean, parentRateId?: string | null, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, closeToArrival?: string | null, closeToDeparture?: string | null, chargeCategoryId: string, resourcesTypeEnabledId?: Array<string> | null, bookingPolicyId: string, ibeCode?: string | null, order: number, tenantId: string, propertyId: string, id: string, restrictionFromParent: boolean, crossSell: CrossSell, affiliatedCompaniesId?: Array<string> | null, intPrices?: boolean | null, derivedRules?: Array<{ operation: MathOperation, value: number }> | null, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null, parentRate?: { resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null } | null, chargesRate?: Array<{ chargeCategoryId: string, priceModel: PriceModel, operation: MathOperation, price: number, resourceTypeId?: string | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null, chargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null } }> | null, resourcesTypeEnabled?: Array<{ id: string, persons: number }> | null, childRule: { rule: ChildRuleType, childDiscount?: Array<{ childId: string, percentage: number, child: { id: string, percentageDiscount: number, noOccupancy: boolean, maxAge: number, minAge: number, taxonomyId: string, taxonomy: { description: LocalizedString } } }> | null }, chargeCategory: { name: string, code?: ChargeCategoryBoard | null }, bookingPolicy: { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, name: LocalizedString } }> | null, priceRanges?: Array<{ name: string, resourceType: Array<{ resourceTypeId: string, price: number, resourceType: { rackRate: number, customName?: LocalizedString | null, code?: string | null, persons: number, additionalPersons: number, name: { description: LocalizedString } } }> }> | null }> | null };

export type CreateRateMutationVariables = Exact<{
  value: RateInput;
}>;


export type CreateRateMutation = { createRate: { currency: Currency, type: RateType, name: LocalizedString, description: LocalizedString, visibilityOnIbe: boolean, agreementRate: boolean, parentRateId?: string | null, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, closeToArrival?: string | null, closeToDeparture?: string | null, chargeCategoryId: string, resourcesTypeEnabledId?: Array<string> | null, bookingPolicyId: string, ibeCode?: string | null, order: number, tenantId: string, propertyId: string, id: string, restrictionFromParent: boolean, crossSell: CrossSell, affiliatedCompaniesId?: Array<string> | null, intPrices?: boolean | null, derivedRules?: Array<{ operation: MathOperation, value: number }> | null, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null, parentRate?: { resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null } | null, chargesRate?: Array<{ chargeCategoryId: string, priceModel: PriceModel, operation: MathOperation, price: number, resourceTypeId?: string | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null, chargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null } }> | null, resourcesTypeEnabled?: Array<{ id: string, persons: number }> | null, childRule: { rule: ChildRuleType, childDiscount?: Array<{ childId: string, percentage: number, child: { id: string, percentageDiscount: number, noOccupancy: boolean, maxAge: number, minAge: number, taxonomyId: string, taxonomy: { description: LocalizedString } } }> | null }, chargeCategory: { name: string, code?: ChargeCategoryBoard | null }, bookingPolicy: { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, name: LocalizedString } }> | null, priceRanges?: Array<{ name: string, resourceType: Array<{ resourceTypeId: string, price: number, resourceType: { rackRate: number, customName?: LocalizedString | null, code?: string | null, persons: number, additionalPersons: number, name: { description: LocalizedString } } }> }> | null } };

export type UpdateRateMutationVariables = Exact<{
  value: RateInput;
  updateRateId: Scalars['String'];
}>;


export type UpdateRateMutation = { updateRate: { currency: Currency, type: RateType, name: LocalizedString, description: LocalizedString, visibilityOnIbe: boolean, agreementRate: boolean, parentRateId?: string | null, minStay?: number | null, maxStay?: number | null, minAdvance?: number | null, maxAdvance?: number | null, closeToArrival?: string | null, closeToDeparture?: string | null, chargeCategoryId: string, resourcesTypeEnabledId?: Array<string> | null, bookingPolicyId: string, ibeCode?: string | null, order: number, tenantId: string, propertyId: string, id: string, restrictionFromParent: boolean, crossSell: CrossSell, affiliatedCompaniesId?: Array<string> | null, intPrices?: boolean | null, derivedRules?: Array<{ operation: MathOperation, value: number }> | null, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null, parentRate?: { resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType, price: number, rulesForDifferentOccupation?: Array<{ occupancy: number, variation: MathOperation, type: ValueType, value: number }> | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null }> | null } | null, chargesRate?: Array<{ chargeCategoryId: string, priceModel: PriceModel, operation: MathOperation, price: number, resourceTypeId?: string | null, priceForDifferentOccupation?: Array<{ occupation: number, price: number }> | null, chargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null } }> | null, resourcesTypeEnabled?: Array<{ id: string, persons: number }> | null, childRule: { rule: ChildRuleType, childDiscount?: Array<{ childId: string, percentage: number, child: { id: string, percentageDiscount: number, noOccupancy: boolean, maxAge: number, minAge: number, taxonomyId: string, taxonomy: { description: LocalizedString } } }> | null }, chargeCategory: { name: string, code?: ChargeCategoryBoard | null }, bookingPolicy: { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, name: LocalizedString } }> | null, priceRanges?: Array<{ name: string, resourceType: Array<{ resourceTypeId: string, price: number, resourceType: { rackRate: number, customName?: LocalizedString | null, code?: string | null, persons: number, additionalPersons: number, name: { description: LocalizedString } } }> }> | null } };

export type DeleteRateMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteRateId: Scalars['String'];
}>;


export type DeleteRateMutation = { deleteRate?: any | null };

export type StatisticFragment = { date: Date, inventory: number, unavailability: number, occupancy: number, adr: number, revpar: number, trevpar: number, totalProduction: number, roomProduction: number, originDistributions: Array<{ amount: number, label: string }> };

export type PickupFragment = { daysBefore: Array<number>, resourceTypeId: string };

export type StatisticsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  mainStart: Scalars['Date'];
  mainEnd: Scalars['Date'];
  comparisonStart: Scalars['Date'];
  comparisonEnd: Scalars['Date'];
  vatIncluded: Scalars['Boolean'];
}>;


export type StatisticsQuery = { main?: Array<{ date: Date, inventory: number, unavailability: number, occupancy: number, adr: number, revpar: number, trevpar: number, totalProduction: number, roomProduction: number, originDistributions: Array<{ amount: number, label: string }> }> | null, comparison?: Array<{ date: Date, inventory: number, unavailability: number, occupancy: number, adr: number, revpar: number, trevpar: number, totalProduction: number, roomProduction: number, originDistributions: Array<{ amount: number, label: string }> }> | null, pickupMain: Array<{ daysBefore: Array<number>, resourceTypeId: string }>, pickupComparison: Array<{ daysBefore: Array<number>, resourceTypeId: string }> };

export type ContextTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContextTenantsQuery = { tenants?: Array<{ id: string, description?: string | null, currency: Currency, language: Language, backoffice?: boolean | null, scelTemplate?: string | null, registryItemId: string, sellerName?: string | null, privacySettings?: { isCustomText: boolean } | null }> | null };

export type ContextIstatConfigurationFragment = { name: string, procedureCode: IstatProcedureCode };

export type ContextPsConfigurationFragment = { name: string, auto: boolean };

export type ContextFiscalConfigurationFragment = { name: string, default: boolean, vatNumber?: string | null, fiscalCode?: string | null, iban?: string | null, cashDeskTypeIds: Array<string>, tspay?: { merchantRef?: string | null } | null };

export type ContextDailyClosureConfigurationFragment = { automatic: boolean, time: Date };

export type ContextSubAddressFragment = { name: string, resourceTypeIds: Array<string> };

export type ContextPropertiesQueryVariables = Exact<{
  tenantId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ContextPropertiesQuery = { properties?: Array<{ id: string, name: string, tenantId: string, hotelDate: Date, timeZone?: string | null, countryIsoCode?: { country?: { isoCode: string } | null } | null, cityTaxConfiguration?: { chargeCategoryId: string, configurations: Array<{ name: string, amount: number, rule: CityTaxRule, fileGenerator?: CityTaxFileGenerator | null }> } | null, classType?: { description: LocalizedString } | null, istatConfigurations?: Array<{ name: string, procedureCode: IstatProcedureCode }> | null, psConfigurations?: Array<{ name: string, auto: boolean }> | null, fiscalConfigurations?: Array<{ name: string, default: boolean, vatNumber?: string | null, fiscalCode?: string | null, iban?: string | null, cashDeskTypeIds: Array<string>, tspay?: { merchantRef?: string | null } | null }> | null, dailyClosureConfiguration: { automatic: boolean, time: Date }, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string> }> | null }> | null };

export type userRoleFragment = { code: string, permissions?: Array<Permissions> | null };

export type ContextUserPermissionsQueryVariables = Exact<{
  input: UserPermissionQueryInput;
}>;


export type ContextUserPermissionsQuery = { getUserPermissions: { userModules?: Array<MeteringModule> | null, modules?: Array<MeteringModule> | null, features?: Array<Feature> | null, tenantSellerName?: string | null, userRole?: { code: string, permissions?: Array<Permissions> | null } | null, trialModules?: Array<{ module: MeteringModule, trialExpiration: Date }> | null } };

export type UnusedPlantsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type UnusedPlantsQuery = { unusedPlants: Array<{ id: string, description: string }> };

export type ContextCashDocumentActivesQueryVariables = Exact<{
  filter: TenantPropertyIdFilter;
}>;


export type ContextCashDocumentActivesQuery = { cashDeskTypes?: Array<{ id: string, documentsActive: Array<{ fiscalType: FiscalType }> }> | null };

export type HorecahubIntegrationsQueryVariables = Exact<{
  horecahubIntegrationsTenantId2?: InputMaybe<Scalars['ID']>;
}>;


export type HorecahubIntegrationsQuery = { horecahubIntegrations: Array<{ id: string }> };

export type HorecahubFlowsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  productCode: Scalars['String'];
}>;


export type HorecahubFlowsQuery = { horecahubFlows: Array<{ state: string }> };

export type HorecahubRegisterIntegrationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type HorecahubRegisterIntegrationMutation = { horecahubRegisterIntegration: { id: string } };

export type HousekeepingResourceFragment = { id: string, code: string, cleaningState: CleaningState, unavailabilities?: Array<{ id: string, start: Date, end: Date, name: string, note?: string | null }> | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement } | null }, position?: { name: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, resourceId?: string | null, reservedResourceLayout?: { id: string, occupation: number, description: LocalizedString } | null }>, guestOccupancies?: Array<{ start: Date, end: Date, phase: ReservedResourcePhase }> | null, reservation: { notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { canceled: boolean } } } | null };

export type HousekeepingResourcesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  cleaningState?: InputMaybe<CleaningState>;
  resourceIdFilter?: InputMaybe<IDFilter>;
}>;


export type HousekeepingResourcesQuery = { resourcesHousekeeping?: Array<{ id: string, code: string, cleaningState: CleaningState, unavailabilities?: Array<{ id: string, start: Date, end: Date, name: string, note?: string | null }> | null, layout?: { id: string, occupation: number, description: LocalizedString } | null, resourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString }, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement } | null }, position?: { name: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, resourceId?: string | null, reservedResourceLayout?: { id: string, occupation: number, description: LocalizedString } | null }>, guestOccupancies?: Array<{ start: Date, end: Date, phase: ReservedResourcePhase }> | null, reservation: { notes?: Array<{ type: NoteType, description: string }> | null, reservationState: { canceled: boolean } } } | null }> | null };

export type SetResourceCleaningStateMutationVariables = Exact<{
  input: ResourceCleaningStateInput;
}>;


export type SetResourceCleaningStateMutation = { setResourceCleaningState?: any | null };

export type ChargeCategoryImportReservationsFragment = { id: string, code?: ChargeCategoryBoard | null, name: string };

export type ChargeCategoriesImportReservationsQueryVariables = Exact<{
  filter: ChargeCategoryQueryFilter;
}>;


export type ChargeCategoriesImportReservationsQuery = { chargeCategories?: Array<{ id: string, code?: ChargeCategoryBoard | null, name: string }> | null };

export type ResourceTypeImportReservationsFragment = { id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } };

export type ResourceTypeImportReservationsQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypeImportReservationsQuery = { resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }> | null };

export type ResourceImportReservationsFragment = { id: string, code: string, resourceTypeId: string };

export type ResourceImportReservationsQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type ResourceImportReservationsQuery = { resources?: Array<{ id: string, code: string, resourceTypeId: string }> | null };

export type InsertBulkReservationsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  rows: Array<BulkReservationInput> | BulkReservationInput;
}>;


export type InsertBulkReservationsMutation = { insertBulkReservations?: string | null };

export type BulkReservationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  correlationId: Scalars['String'];
  processed?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkReservationsQuery = { bulkReservations: Array<{ error?: string | null }> };

export type TimestampBulkReservationQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  correlationId: Scalars['String'];
  error?: InputMaybe<Scalars['Boolean']>;
}>;


export type TimestampBulkReservationQuery = { bulkReservations: Array<{ timestamp: Date }> };

export type GridBulkReservationFragment = { id: string, error?: string | null, row: { originalId?: string | null, portalName?: string | null, customerName: string, start: Date, end: Date, resourceId?: string | null, resourceTypeId: string, totalAmount: number } };

export type GridBulkReservationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  correlationId: Scalars['String'];
  error?: InputMaybe<Scalars['Boolean']>;
}>;


export type GridBulkReservationsQuery = { bulkReservations: Array<{ id: string, error?: string | null, row: { originalId?: string | null, portalName?: string | null, customerName: string, start: Date, end: Date, resourceId?: string | null, resourceTypeId: string, totalAmount: number } }> };

export type PreviousImportBulkReservationFragment = { id: string, error?: string | null, timestamp: Date };

export type PreviousImportBulkReservationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  correlationId: Scalars['String'];
}>;


export type PreviousImportBulkReservationsQuery = { bulkReservations: Array<{ id: string, error?: string | null, timestamp: Date }> };

export type DeleteBulkReservationsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  correlationId: Scalars['String'];
}>;


export type DeleteBulkReservationsMutation = { deleteBulkReservations?: any | null };

export type ImportedTaskListFragment = { id: string, tenantId: string, type: ImportTaskType, timestamp: Date, start: Date, end?: Date | null, database?: string | null, extPropertyId?: string | null, lastMessage?: string | null, lastError?: string | null };

export type ImportedTasksQueryVariables = Exact<{
  filters: ImportedTaskQueryFilter;
}>;


export type ImportedTasksQuery = { importedTasks?: Array<{ id: string, tenantId: string, type: ImportTaskType, timestamp: Date, start: Date, end?: Date | null, database?: string | null, extPropertyId?: string | null, lastMessage?: string | null, lastError?: string | null }> | null };

export type ImportablePropertyDataFragment = { id: string, name: string, address?: { countryIsoCode?: string | null, address?: string | null, municipalityIstatCode?: string | null, postalCode?: string | null, province?: string | null, city?: string | null } | null };

export type ImportablePropertyFragment = { id: string, tenantId: string, data: { id: string, name: string, address?: { countryIsoCode?: string | null, address?: string | null, municipalityIstatCode?: string | null, postalCode?: string | null, province?: string | null, city?: string | null } | null } };

export type ImportablePropertiesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type ImportablePropertiesQuery = { importableProperties?: Array<{ id: string, tenantId: string, data: { id: string, name: string, address?: { countryIsoCode?: string | null, address?: string | null, municipalityIstatCode?: string | null, postalCode?: string | null, province?: string | null, city?: string | null } | null } }> | null };

export type ExportDatabaseMutationVariables = Exact<{
  input: ExportDatabaseInput;
}>;


export type ExportDatabaseMutation = { exportDatabase: { taskId: string } };

export type ImportPropertyMutationVariables = Exact<{
  value: ImportPropertyInput;
}>;


export type ImportPropertyMutation = { importProperty: { taskId: string, propertyId: string } };

export type ImportPropertyRetryMutationVariables = Exact<{
  input: RetryImportPropertyInput;
}>;


export type ImportPropertyRetryMutation = { importPropertyRetry: { propertyId: string, taskId: string } };

export type AttachDatabaseForExportMutationVariables = Exact<{
  backupName: Scalars['String'];
  dbName: Scalars['String'];
}>;


export type AttachDatabaseForExportMutation = { attachDatabaseForExport: string };

export type GetDatabaseAttachStateQueryVariables = Exact<{
  dbName: Scalars['String'];
  taskId: Scalars['Int'];
}>;


export type GetDatabaseAttachStateQuery = { getDatabaseAttachState: { state: string, percentage?: number | null, info?: string | null } };

export type ExportableDatabasesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportableDatabasesQuery = { exportableDatabases?: Array<{ name: string, ready: boolean }> | null };

export type CreateExportScriptsMutationVariables = Exact<{
  backupName: Scalars['String'];
  type: PmsType;
}>;


export type CreateExportScriptsMutation = { createExportScripts?: any | null };

export type UpdateSupportUserRoleMutationVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type UpdateSupportUserRoleMutation = { updateSupportUserRole: boolean };

export type UpdateSellerNameMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSellerNameMutation = { updateSellerName?: any | null };

export type RebuildPropertyAvailabilityMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  fireAndForget: Scalars['Boolean'];
}>;


export type RebuildPropertyAvailabilityMutation = { rebuildPropertyAvailability?: any | null };

export type RebuildPropertyAvailabilityEventSubscriptionVariables = Exact<{
  filter: RebuildPropertyAvailabilityEventFilter;
}>;


export type RebuildPropertyAvailabilityEventSubscription = { rebuildPropertyAvailabilityEvent?: { tenantId: string, propertyId: string, errors?: Array<{ error: string, resourceTypeId: string }> | null } | null };

export type OnboardingPropertyMutationVariables = Exact<{
  value: OnBoardingInput;
}>;


export type OnboardingPropertyMutation = { onboardingProperty?: { id: string } | null };

export type PasserByBillDocumentItemFragment = { _id?: string | null, numberExtended?: string | null, fiscalType?: FiscalType | null };

export type PasserByBillItemFragment = { _id: string, total?: number | null, productionLength?: number | null, description?: string | null, creationDate?: Date | null, owner?: { _id: string, name?: string | null } | null, document?: { _id?: string | null, numberExtended?: string | null, fiscalType?: FiscalType | null } | null };

export type PasserByBillsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  open?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PasserByBillsQuery = { passersByBills?: Array<{ _id: string, total?: number | null, productionLength?: number | null, description?: string | null, creationDate?: Date | null, owner?: { _id: string, name?: string | null } | null, document?: { _id?: string | null, numberExtended?: string | null, fiscalType?: FiscalType | null } | null }> | null };

export type PosDepositDocumentFragment = { id: string, depositAssigneds?: Array<{ id: string, amount: number }> | null };

export type PosDepositDocumentsQueryVariables = Exact<{
  filter: DepositDocumentQueryFilter;
}>;


export type PosDepositDocumentsQuery = { depositDocuments?: Array<{ id: string, depositAssigneds?: Array<{ id: string, amount: number }> | null }> | null };

export type AppDailyClosureEventSubscriptionVariables = Exact<{
  filter: DailyClosureEventFilter;
}>;


export type AppDailyClosureEventSubscription = { dailyClosureEvent?: { result: boolean, propertyId: string, procedureNames?: Array<DailyClosureProcedure> | null } | null };

export type QuoteMainGuestFragment = { name: any, mailContacts?: Array<{ isDefault: boolean, order: number, value: string }> | null };

export type QuoteDetailsFragment = { expiration?: Date | null, id: string, propertyId: string, quotationCode: string, quotationState: QuotationState, tenantId: string, quotationStateHistory: Array<{ state: QuotationState, timestamp: Date }>, reference: { customerPersonId?: string | null, customerCompanyId?: string | null, mainGuest: { name: any, mailContacts?: Array<{ isDefault: boolean, order: number, value: string }> | null }, customerCompany?: { company?: { defaultCredit?: CreditType | null } | null } | null }, auditable: { createdBy?: string | null, createdOn?: Date | null }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, chargeCategoryId: string, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, resourceOccupancies: Array<{ resourceTypeId: string, resourceType: { description: LocalizedString, customName?: LocalizedString | null, code?: string | null } }>, additionalServices?: Array<{ priceZero: boolean, quantity?: number | null, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null, childOccupancies?: Array<{ quantity: number, childId: string }> | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { name: LocalizedString, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }, chargeCategory: { id: string, name: string } }> }> };

export type PayAndConfirmQuotationFragment = { reservationId?: string | null };

export type QuotationDetailQueryVariables = Exact<{
  filter: QuotationQueryFilter;
}>;


export type QuotationDetailQuery = { quotations: Array<{ expiration?: Date | null, id: string, propertyId: string, quotationCode: string, quotationState: QuotationState, tenantId: string, quotationStateHistory: Array<{ state: QuotationState, timestamp: Date }>, reference: { customerPersonId?: string | null, customerCompanyId?: string | null, mainGuest: { name: any, mailContacts?: Array<{ isDefault: boolean, order: number, value: string }> | null }, customerCompany?: { company?: { defaultCredit?: CreditType | null } | null } | null }, auditable: { createdBy?: string | null, createdOn?: Date | null }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, chargeCategoryId: string, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, resourceOccupancies: Array<{ resourceTypeId: string, resourceType: { description: LocalizedString, customName?: LocalizedString | null, code?: string | null } }>, additionalServices?: Array<{ priceZero: boolean, quantity?: number | null, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null, childOccupancies?: Array<{ quantity: number, childId: string }> | null, manualDailyPrices?: Array<{ day: Date, price: number }> | null, rate: { name: LocalizedString, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }, chargeCategory: { id: string, name: string } }> }> }> };

export type OperatorNameQueryVariables = Exact<{
  tsId: Scalars['String'];
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type OperatorNameQuery = { users?: Array<{ fullname?: string | null }> | null };

export type ConfirmQuotationMutationVariables = Exact<{
  input: ConfirmQuotationInput;
}>;


export type ConfirmQuotationMutation = { confirmQuotation: { reservationId?: string | null } };

export type DeleteQuotationMutationVariables = Exact<{
  deleteQuotationId: Scalars['ID'];
  tenantId: Scalars['ID'];
}>;


export type DeleteQuotationMutation = { deleteQuotation?: any | null };

export type GetQuotationLinkQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  quotationId: Scalars['ID'];
}>;


export type GetQuotationLinkQuery = { getQuotationLink: string };

export type SetQuotationStateMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  setQuotationStateId: Scalars['ID'];
  state: SetQuotationState;
}>;


export type SetQuotationStateMutation = { setQuotationState?: any | null };

export type SendQuotationEmailMutationVariables = Exact<{
  input: SendQuotationEmailInput;
}>;


export type SendQuotationEmailMutation = { sendQuotationEmail?: { id: string } | null };

export type QuoteInputUniqueInfoFragment = { id: string, auditable: { modifiedOn?: Date | null, createdOn?: Date | null } };

export type QuoteItemFragment = { expiration?: Date | null, propertyId: string, quotationCode: string, quotationState: QuotationState, tenantId: string, id: string, reference: { agencyId?: string | null, customerCompanyId?: string | null, customerPersonId?: string | null, mainGuestId: string }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> }>, auditable: { modifiedOn?: Date | null, createdOn?: Date | null } };

export type CreateQuotationMutationVariables = Exact<{
  value: QuotationInput;
}>;


export type CreateQuotationMutation = { createQuotation: { expiration?: Date | null, propertyId: string, quotationCode: string, quotationState: QuotationState, tenantId: string, id: string, reference: { agencyId?: string | null, customerCompanyId?: string | null, customerPersonId?: string | null, mainGuestId: string }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> }>, auditable: { modifiedOn?: Date | null, createdOn?: Date | null } } };

export type UpdateQuotationMutationVariables = Exact<{
  updateQuotationId: Scalars['ID'];
  value: QuotationInput;
}>;


export type UpdateQuotationMutation = { updateQuotation: { expiration?: Date | null, propertyId: string, quotationCode: string, quotationState: QuotationState, tenantId: string, id: string, reference: { agencyId?: string | null, customerCompanyId?: string | null, customerPersonId?: string | null, mainGuestId: string }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> }>, auditable: { modifiedOn?: Date | null, createdOn?: Date | null } } };

export type QuotationDetailsFragment = { reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, rate: { name: LocalizedString, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }, chargeCategory: { id: string, name: string }, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date, resourceType: { description: LocalizedString, customName?: LocalizedString | null, code?: string | null } }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> };

export type QuotationFragment = { id: string, expiration?: Date | null, propertyId: string, tenantId: string, quotationCode: string, quotationState: QuotationState, auditable: { createdOn?: Date | null, createdBy?: string | null }, reference: { mainGuest: { name: any } }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, rate: { name: LocalizedString, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }, chargeCategory: { id: string, name: string }, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date, resourceType: { description: LocalizedString, customName?: LocalizedString | null, code?: string | null } }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> }> };

export type QuotationsQueryVariables = Exact<{
  filter: QuotationQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type QuotationsQuery = { quotations: Array<{ id: string, expiration?: Date | null, propertyId: string, tenantId: string, quotationCode: string, quotationState: QuotationState, auditable: { createdOn?: Date | null, createdBy?: string | null }, reference: { mainGuest: { name: any } }, quotationDetails: Array<{ reservationId?: string | null, quotedResources: Array<{ adults: number, children: number, end: Date, manualPrice?: number | null, rateId: string, start: Date, chargeCategoryId: string, rate: { name: LocalizedString, mandatoryAdditionalServices?: Array<{ priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }, chargeCategory: { id: string, name: string }, resourceOccupancies: Array<{ end: Date, resourceId?: string | null, resourceTypeId: string, start: Date, resourceType: { description: LocalizedString, customName?: LocalizedString | null, code?: string | null } }>, manualDailyPrices?: Array<{ day: Date, price: number }> | null, guestOccupancies?: Array<{ cityTaxExoneration?: CityTaxExonerationCode | null, end: Date, guestId: string, start: Date, type: GuestType }> | null, childOccupancies?: Array<{ childId: string, quantity: number }> | null, additionalServices?: Array<{ quantity?: number | null, priceZero: boolean, additionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } }> | null }> }> }> };

export type ResourceTypeAvailabilityQueryVariables = Exact<{
  filter: ResourceTypeAvailabilityInput;
}>;


export type ResourceTypeAvailabilityQuery = { getResourceTypeAvailability: number };

export type UserFragment = { fullname?: string | null, id: string, tsId?: string | null };

export type UsersQueryVariables = Exact<{
  filter: UserQueryInput;
}>;


export type UsersQuery = { users?: Array<{ fullname?: string | null, id: string, tsId?: string | null }> | null };

export type AccountingDataExportConfigurationFragment = { id: string, tenantId: string, propertyId?: string | null, type: ExportManagementProcedure, managementConfiguration: { batchPayments: string, batchSales: string, cityTaxDebts?: string | null, customersAccount: string, customersDeposit: string, customersFiscalDeposit: string, customersVATPayments: string, debtsforVAT: string, defaultCompanyCode: string, exportSuspendedPayments: boolean, groupPayments: boolean, groupRevenues: boolean, revenueAccount: string, vatSales: string, vatrfSuspended: string }, auditable: { state: State } };

export type AccountingDataExportSettingsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AccountingDataExportSettingsQuery = { exportProcedures?: Array<{ id: string, tenantId: string, propertyId?: string | null, type: ExportManagementProcedure, managementConfiguration: { batchPayments: string, batchSales: string, cityTaxDebts?: string | null, customersAccount: string, customersDeposit: string, customersFiscalDeposit: string, customersVATPayments: string, debtsforVAT: string, defaultCompanyCode: string, exportSuspendedPayments: boolean, groupPayments: boolean, groupRevenues: boolean, revenueAccount: string, vatSales: string, vatrfSuspended: string }, auditable: { state: State } }> | null };

export type AccountingDataExportFragment = { id: string, tenantId: string, propertyId?: string | null, status: ExportRequestStatus, fileIds?: Array<string> | null, message?: string | null, property?: { name: string } | null, requestInfo: { start: Date, end: Date, user?: string | null, forceExport?: boolean | null }, exportProcedure: { id: string, propertyId?: string | null }, auditable: { createdOn?: Date | null } };

export type AccountingDataExportsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  exportProcedureId: Scalars['String'];
}>;


export type AccountingDataExportsQuery = { exportData?: Array<{ id: string, tenantId: string, propertyId?: string | null, status: ExportRequestStatus, fileIds?: Array<string> | null, message?: string | null, property?: { name: string } | null, requestInfo: { start: Date, end: Date, user?: string | null, forceExport?: boolean | null }, exportProcedure: { id: string, propertyId?: string | null }, auditable: { createdOn?: Date | null } }> | null };

export type AccountingDataExportStartMutationVariables = Exact<{
  input: ExportInput;
}>;


export type AccountingDataExportStartMutation = { startExportManagement: { id: string, status: ExportRequestStatus, auditable: { createdOn?: Date | null } } };

export type AccountingDataExportVatFragment = { id: string, code: string, description: string, order: number, propertyId?: string | null, managementCode?: string | null, value: number };

export type AccountingDataExportVatsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AccountingDataExportVatsQuery = { vats?: Array<{ id: string, code: string, description: string, order: number, propertyId?: string | null, managementCode?: string | null, value: number }> | null };

export type AccountingDataExportPaymentActiveFragment = { id: string, propertyId?: string | null, tenantId: string, name: LocalizedString, paymentTypeId: string, managementCode?: string | null, paymentType: { sign: AlgebraicSign }, auditable: { state: State } };

export type AccountingDataExportPaymentActivesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AccountingDataExportPaymentActivesQuery = { paymentActives: Array<{ id: string, propertyId?: string | null, tenantId: string, name: LocalizedString, paymentTypeId: string, managementCode?: string | null, paymentType: { sign: AlgebraicSign }, auditable: { state: State } }> };

export type AccountingDataExportChargeCategoryFragment = { id: string, tenantId: string, propertyId?: string | null, name: string, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, cityTax: boolean, managementCode?: string | null, code?: ChargeCategoryBoard | null, defaultVat: { description: string } };

export type AccountingDataExportChargeCategoriesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AccountingDataExportChargeCategoriesQuery = { chargeCategories?: Array<{ id: string, tenantId: string, propertyId?: string | null, name: string, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, cityTax: boolean, managementCode?: string | null, code?: ChargeCategoryBoard | null, defaultVat: { description: string } }> | null };

export type AccountingDataExportCashDeskTypeFragment = { id: string, tenantId: string, propertyId: string, name: string, code: CashDeskTypeCode, managementCode?: string | null, documentsActiveId: Array<string> };

export type AccountingDataExportCashDeskTypesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AccountingDataExportCashDeskTypesQuery = { cashDeskTypes?: Array<{ id: string, tenantId: string, propertyId: string, name: string, code: CashDeskTypeCode, managementCode?: string | null, documentsActiveId: Array<string> }> | null };

export type AccountingDataExportCreateConfigurationMutationVariables = Exact<{
  value: ExportProcedureInput;
}>;


export type AccountingDataExportCreateConfigurationMutation = { createExportProcedure: { id: string } };

export type AccountingDataExportUpdateConfigurationMutationVariables = Exact<{
  id: Scalars['String'];
  value: ExportProcedureInput;
}>;


export type AccountingDataExportUpdateConfigurationMutation = { updateExportProcedure: { id: string } };

export type AccountingDataExportUpdatePaymentActiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: PaymentActiveInput;
}>;


export type AccountingDataExportUpdatePaymentActiveMutation = { updatePaymentActive: { id: string } };

export type AccountingDataExportUpdateCashDeskTypeMutationVariables = Exact<{
  id: Scalars['String'];
  input: CashDeskTypeInput;
}>;


export type AccountingDataExportUpdateCashDeskTypeMutation = { updateCashDeskType: { id: string } };

export type AdditionalServiceFragment = { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } };

export type SingleAdditionalServiceQueryVariables = Exact<{
  filter: AdditionalServiceQueryFilter;
}>;


export type SingleAdditionalServiceQuery = { additionalServices?: Array<{ id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } }> | null };

export type AdditionalServicesQueryVariables = Exact<{
  filter: AdditionalServiceQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AdditionalServicesQuery = { additionalServices?: Array<{ id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } }> | null };

export type CreateAdditionalServiceMutationVariables = Exact<{
  value: AdditionalServiceInput;
}>;


export type CreateAdditionalServiceMutation = { createAdditionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } };

export type DeleteAdditionalServiceMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteAdditionalServiceId: Scalars['String'];
}>;


export type DeleteAdditionalServiceMutation = { deleteAdditionalService?: any | null };

export type UpdateAdditionalServiceMutationVariables = Exact<{
  updateAdditionalServiceId: Scalars['String'];
  value: AdditionalServiceInput;
}>;


export type UpdateAdditionalServiceMutation = { updateAdditionalService: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, name: LocalizedString, description: LocalizedString, minStay?: number | null, pricingType: PricingType, currency: Currency, price: number, excludeCheckout: boolean, excludeCheckin: boolean, automaticForChildren: boolean, automaticForAdults: boolean, chargeCategory: { name: string }, validity?: { start?: Date | null, end?: Date | null } | null, childServicePrices?: Array<{ childId: string, price: number }> | null, availabilityConfig?: { resourceTypeId: string, entireStay: boolean, resourceType: { customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }, time?: { from: Date, to: Date } | null } | null, auditable: { state: State } } };

export type MessageAutomationFragment = { name: string, id: string, messageTemplateId: string, phase: Array<ReservedResourcePhase>, cancellationMessageTemplateId?: string | null, linkToPayMessageTemplateId?: string | null, originIds: Array<string>, resourceTypeIds: Array<string>, scheduledType: MessageAutomationScheduleType, wciState: MessageAutomationPresence, auditable: { state: State }, scheduledConfiguration?: { beforeOrAfter: BeforeOrAfter, days: number, outOfBounds: MessageAutomationOutOfBouce, scheduleAt: Date } | null };

export type MessageTemplateAutomationFragment = { id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null };

export type MessageTemplatesAutomationQueryVariables = Exact<{
  filter: MessageTemplateQueryFilter;
}>;


export type MessageTemplatesAutomationQuery = { messageTemplates?: Array<{ id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null }> | null };

export type MessageAutomationListQueryVariables = Exact<{
  filter: MessageAutomationQueryFilter;
}>;


export type MessageAutomationListQuery = { messageAutomations?: Array<{ name: string, id: string, messageTemplateId: string, phase: Array<ReservedResourcePhase>, cancellationMessageTemplateId?: string | null, linkToPayMessageTemplateId?: string | null, originIds: Array<string>, resourceTypeIds: Array<string>, scheduledType: MessageAutomationScheduleType, wciState: MessageAutomationPresence, auditable: { state: State }, scheduledConfiguration?: { beforeOrAfter: BeforeOrAfter, days: number, outOfBounds: MessageAutomationOutOfBouce, scheduleAt: Date } | null }> | null };

export type UpdateMessageAutomationMutationVariables = Exact<{
  id: Scalars['ID'];
  value: MessageAutomationInput;
}>;


export type UpdateMessageAutomationMutation = { updateMessageAutomation: { name: string, id: string, messageTemplateId: string, phase: Array<ReservedResourcePhase>, cancellationMessageTemplateId?: string | null, linkToPayMessageTemplateId?: string | null, originIds: Array<string>, resourceTypeIds: Array<string>, scheduledType: MessageAutomationScheduleType, wciState: MessageAutomationPresence, auditable: { state: State }, scheduledConfiguration?: { beforeOrAfter: BeforeOrAfter, days: number, outOfBounds: MessageAutomationOutOfBouce, scheduleAt: Date } | null } };

export type DeleteMessageAutomationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteMessageAutomationMutation = { deleteMessageAutomation?: any | null };

export type ResourceTypeAutomationFragment = { id: string, customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } };

export type ResourceTypesAndPropertyAutomationQueryVariables = Exact<{
  propertyFilter: PropertyQueryFilter;
  resourceTypeFilter: ResourceTypeQueryFilter;
}>;


export type ResourceTypesAndPropertyAutomationQuery = { properties?: Array<{ id: string, name: string, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string> }> | null }> | null, resourceTypes?: Array<{ id: string, customName?: LocalizedString | null, code?: string | null, name: { description: LocalizedString } }> | null };

export type CreateMessageAutomationMutationVariables = Exact<{
  value: MessageAutomationInput;
}>;


export type CreateMessageAutomationMutation = { createMessageAutomation: { name: string, id: string, messageTemplateId: string, phase: Array<ReservedResourcePhase>, cancellationMessageTemplateId?: string | null, linkToPayMessageTemplateId?: string | null, originIds: Array<string>, resourceTypeIds: Array<string>, scheduledType: MessageAutomationScheduleType, wciState: MessageAutomationPresence, auditable: { state: State }, scheduledConfiguration?: { beforeOrAfter: BeforeOrAfter, days: number, outOfBounds: MessageAutomationOutOfBouce, scheduleAt: Date } | null } };

export type CashDeskTypeBillingFragment = { code: CashDeskTypeCode, name: string, id: string, documentsActive: Array<{ id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null }> };

export type CashDeskTypeBillingQueryVariables = Exact<{
  filter: TenantPropertyIdFilter;
}>;


export type CashDeskTypeBillingQuery = { cashDeskTypes?: Array<{ code: CashDeskTypeCode, name: string, id: string, documentsActive: Array<{ id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null }> }> | null };

export type FiscalConfigurationBillingFragment = { iban?: string | null, cashDeskTypeIds: Array<string>, default: boolean, fiscalCode?: string | null, name: string, registryItemId: string, resourceTypeIds?: Array<string> | null, vatNumber?: string | null, propertyName?: string | null, felConfiguration?: { reaOffice?: string | null, reaCode?: string | null, inLiquidation: boolean, authorizedCapital?: number | null, soleShareholder: boolean, taxSystem: RegimeFiscale, flowType?: FlowType | null } | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null, tspay?: { state: TsPayOnboardingState } | null };

export type FiscalConfigurationsQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type FiscalConfigurationsQuery = { properties?: Array<{ id: string, vatNumber?: string | null, address?: { country?: { isoCode: string } | null } | null, tenant: { id: string, vatNumber?: string | null }, fiscalConfigurations?: Array<{ iban?: string | null, cashDeskTypeIds: Array<string>, default: boolean, fiscalCode?: string | null, name: string, registryItemId: string, resourceTypeIds?: Array<string> | null, vatNumber?: string | null, propertyName?: string | null, felConfiguration?: { reaOffice?: string | null, reaCode?: string | null, inLiquidation: boolean, authorizedCapital?: number | null, soleShareholder: boolean, taxSystem: RegimeFiscale, flowType?: FlowType | null } | null, address?: { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { isoCode: string } | null, municipality?: { name: string } | null } | null, tspay?: { state: TsPayOnboardingState } | null }> | null }> | null };

export type GetRegistryItemsQueryVariables = Exact<{
  input: GetRegistryItemsInput;
}>;


export type GetRegistryItemsQuery = { getRegistryItems: Array<{ base: { id: string, ncsId: string, details: { description?: string | null, addresses: Array<{ streetName?: string | null, streetNumber?: string | null, city?: string | null, province?: string | null, zipCode?: string | null, country?: string | null, fullAddress?: string | null, types?: Array<string | null> | null, id?: string | null }>, economics?: { rea?: string | null, cciaa?: string | null, capitalStock?: string | null, liquidationState?: string | null, registrationDate?: string | null, taxRegime?: string | null, soleShareholder?: string | null, balanceSheetDate?: string | null, economicActivities?: { mainActivity?: { code?: string | null, rootCode?: string | null } | null } | null } | null }, identifier: { vatNumber?: string | null, taxId: string } } }> };

export type SubscriptionDigitalFragment = { appId?: string | null, id?: string | null };

export type GetSubscriptionInfoQueryVariables = Exact<{
  registryCompanyId: Scalars['String'];
}>;


export type GetSubscriptionInfoQuery = { getSubscriptionInfo: Array<{ appId?: string | null, id?: string | null }> };

export type SetPropertyFiscalConfigurationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  setPropertyFiscalConfigurationId: Scalars['ID'];
  config: Array<FiscalConfigurationInput> | FiscalConfigurationInput;
}>;


export type SetPropertyFiscalConfigurationMutation = { setPropertyFiscalConfiguration?: any | null };

export type DeleteCashDeskTypeMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type DeleteCashDeskTypeMutation = { deleteCashDeskType?: any | null };

export type IsCashDeskTypeUsedQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  cashDeskTypeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type IsCashDeskTypeUsedQuery = { documents?: Array<{ id: string }> | null };

export type BookingEngineURLSQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BookingEngineURLSQuery = { bookingEngineUrls: Array<{ propertyId: Array<string>, url: string }> };

export type AvailabilityRequestFragment = { id: string, start: Date, end: Date, state: AvailabilityRequestState, auditable: { createdOn?: Date | null, modifiedOn?: Date | null }, customer: { firstName: string, lastName: string, email: string }, resources: Array<{ adults: number, childOccupancy?: Array<{ quantity: number }> | null }> };

export type AvailabilityRequestQueryVariables = Exact<{
  filter: AvailabilityRequestQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AvailabilityRequestQuery = { availabilityRequests?: Array<{ id: string, start: Date, end: Date, state: AvailabilityRequestState, auditable: { createdOn?: Date | null, modifiedOn?: Date | null }, customer: { firstName: string, lastName: string, email: string }, resources: Array<{ adults: number, childOccupancy?: Array<{ quantity: number }> | null }> }> | null };

export type SubAddressAddressFragment = { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipality?: { name: string, postalCode: string } | null, country?: { name: LocalizedString } | null };

export type BookingEngineConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type BookingEngineConfigurationQuery = { properties?: Array<{ type: PropertyType, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipality?: { name: string, postalCode: string } | null, country?: { name: LocalizedString } | null } | null, subAddresses?: Array<{ name: string, resourceTypeIds: Array<string>, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipality?: { name: string, postalCode: string } | null, country?: { name: LocalizedString } | null } | null }> | null, bookingEngineConfiguration?: { googleGA4?: string | null, fiscalAdvances: boolean } | null }> | null };

export type BookingPolicyListFragment = { id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } };

export type BookingPoliciesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type BookingPoliciesQuery = { bookingPolicies?: Array<{ id: string, tenantId: string, propertyId: string, name: string, noShowRule: { type: NoShowType }, paymentRule: { type: GuaranteeType }, cancellationPolicy: { type: CancellationPolicyType } }> | null };

export type BookingPolicyDetailFragment = { additionalNote?: LocalizedString | null, id: string, tenantId: string, propertyId: string, name: string, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null }, noShowRule: { type: NoShowType, percentage?: number | null } };

export type BookingPolicyQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  bookingPolicyId: Scalars['ID'];
}>;


export type BookingPolicyQuery = { bookingPolicies?: Array<{ additionalNote?: LocalizedString | null, id: string, tenantId: string, propertyId: string, name: string, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null }, noShowRule: { type: NoShowType, percentage?: number | null } }> | null };

export type BookingPolicyNewMutationVariables = Exact<{
  input: BookingPolicyInput;
}>;


export type BookingPolicyNewMutation = { createBookingPolicy: { additionalNote?: LocalizedString | null, id: string, tenantId: string, propertyId: string, name: string, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null }, noShowRule: { type: NoShowType, percentage?: number | null } } };

export type BookingPolicyUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  input: BookingPolicyInput;
}>;


export type BookingPolicyUpdateMutation = { updateBookingPolicy: { additionalNote?: LocalizedString | null, id: string, tenantId: string, propertyId: string, name: string, paymentRule: { type: GuaranteeType, percentage?: number | null, guaranteedCreditCard: boolean, paymentsAcceptedId?: Array<string> | null }, cancellationPolicy: { type: CancellationPolicyType, daysWithoutPenalties?: number | null, hourWithoutPenalties?: Date | null, penaltyType?: CancellationPenaltyType | null, percentage?: number | null }, noShowRule: { type: NoShowType, percentage?: number | null } } };

export type BookingPolicyDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type BookingPolicyDeleteMutation = { deleteBookingPolicy?: any | null };

export type CashDeskTypeListFragment = { code: CashDeskTypeCode, name: string, id: string, propertyId: string, tenantId: string, documentsActive: Array<{ id: string, fiscalType: FiscalType }> };

export type CashDeskTypeListQueryVariables = Exact<{
  filter: TenantPropertyIdFilter;
}>;


export type CashDeskTypeListQuery = { cashDeskTypes?: Array<{ code: CashDeskTypeCode, name: string, id: string, propertyId: string, tenantId: string, documentsActive: Array<{ id: string, fiscalType: FiscalType }> }> | null };

export type DocumentActiveFragment = { id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null };

export type DocumentActivesQueryVariables = Exact<{
  filter: TenantPropertyIdFilter;
}>;


export type DocumentActivesQuery = { documentActives?: Array<{ id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null }> | null };

export type CreateDocumentActiveMutationVariables = Exact<{
  value: DocumentActiveInput;
}>;


export type CreateDocumentActiveMutation = { createDocumentActive: { id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null } };

export type UpdateDocumentActiveMutationVariables = Exact<{
  input: DocumentActiveInput;
  id: Scalars['String'];
}>;


export type UpdateDocumentActiveMutation = { updateDocumentActive: { id: string, fiscalType: FiscalType, documentSetCode?: string | null, counters?: Array<{ id: string, format: string, value: number, year: number }> | null } };

export type DeleteDocumentActiveMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteDocumentActiveId: Scalars['String'];
}>;


export type DeleteDocumentActiveMutation = { deleteDocumentActive?: any | null };

export type CreateCashDeskTypeMutationVariables = Exact<{
  value: CashDeskTypeInput;
}>;


export type CreateCashDeskTypeMutation = { createCashDeskType: { code: CashDeskTypeCode, name: string, id: string, propertyId: string, tenantId: string, documentsActive: Array<{ id: string, fiscalType: FiscalType }> } };

export type UpdateCashDeskTypeMutationVariables = Exact<{
  input: CashDeskTypeInput;
  id: Scalars['String'];
}>;


export type UpdateCashDeskTypeMutation = { updateCashDeskType: { code: CashDeskTypeCode, name: string, id: string, propertyId: string, tenantId: string, documentsActive: Array<{ id: string, fiscalType: FiscalType }> } };

export type CassaInCloudSalesModeFragment = { id: string, description: string };

export type PointOfSaleMealShiftFragment = { id: string, description: string, fromTime: string, toTime: string };

export type CassaInCloudDepartmentFragment = { id: string, description: string };

export type SpChargeCategoryFragment = { chargeCategoryId: string, externalCode: string };

export type PointOfSaleFragment = { id: string, name: string, description: string, externalId?: string | null, isDefault: boolean, property: { name: string }, configuration: { roomsOutChargeable?: boolean | null }, mappings: { chargeCategories: Array<{ chargeCategoryId: string, externalCode: string }> }, auditable: { state: State } };

export type CicConfigurationApiKeyFragment = { apiKey: string, description: string, pointOfSales?: Array<{ id: string, name: string, description: string, externalId?: string | null, isDefault: boolean, property: { name: string }, configuration: { roomsOutChargeable?: boolean | null }, mappings: { chargeCategories: Array<{ chargeCategoryId: string, externalCode: string }> }, auditable: { state: State } }> | null };

export type CicConfigurationFragment = { tenantSecret: string, apiKeys?: Array<{ apiKey: string, description: string, pointOfSales?: Array<{ id: string, name: string, description: string, externalId?: string | null, isDefault: boolean, property: { name: string }, configuration: { roomsOutChargeable?: boolean | null }, mappings: { chargeCategories: Array<{ chargeCategoryId: string, externalCode: string }> }, auditable: { state: State } }> | null }> | null };

export type CassaInCloudSalesPointFragment = { id: number, description: string, name: string };

export type AddCassaInCloudApiKeyMutationVariables = Exact<{
  value: CassaInCloudApiKeyInput;
}>;


export type AddCassaInCloudApiKeyMutation = { addCassaInCloudApiKey?: { apiKey: string, description: string, pointOfSales?: Array<{ id: string, name: string, description: string, externalId?: string | null, isDefault: boolean, property: { name: string }, configuration: { roomsOutChargeable?: boolean | null }, mappings: { chargeCategories: Array<{ chargeCategoryId: string, externalCode: string }> }, auditable: { state: State } }> | null } | null };

export type UpdateCassaInCloudApiKeyMutationVariables = Exact<{
  value: CassaInCloudApiKeyInput;
}>;


export type UpdateCassaInCloudApiKeyMutation = { updateCassaInCloudApiKey?: any | null };

export type RemoveCassaInCloudApiKeyMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  apiKey: Scalars['String'];
}>;


export type RemoveCassaInCloudApiKeyMutation = { removeCassaInCloudApiKey?: any | null };

export type CassaInCloudConfigurationQueryVariables = Exact<{
  filter?: InputMaybe<TenantQueryFilter>;
}>;


export type CassaInCloudConfigurationQuery = { tenants?: Array<{ cassaInCloudConfiguration?: { tenantSecret: string, apiKeys?: Array<{ apiKey: string, description: string, pointOfSales?: Array<{ id: string, name: string, description: string, externalId?: string | null, isDefault: boolean, property: { name: string }, configuration: { roomsOutChargeable?: boolean | null }, mappings: { chargeCategories: Array<{ chargeCategoryId: string, externalCode: string }> }, auditable: { state: State } }> | null }> | null } | null }> | null };

export type CheckCassaInCloudApiKeyQueryVariables = Exact<{
  apiKey: Scalars['String'];
}>;


export type CheckCassaInCloudApiKeyQuery = { checkCassaInCloudApiKey: boolean };

export type GetCassaInCloudSalesPointsQueryVariables = Exact<{
  apiKey: Scalars['String'];
}>;


export type GetCassaInCloudSalesPointsQuery = { getCassaInCloudSalesPoints: Array<{ id: number, description: string, name: string }> };

export type ActivatePointOfSalesMutationVariables = Exact<{
  input: ActivatePointOfSalesInput;
}>;


export type ActivatePointOfSalesMutation = { activatePointOfSales?: any | null };

export type PointOfSaleMealShiftsQueryVariables = Exact<{
  filter: PointOfSaleMealShiftQueryFilter;
}>;


export type PointOfSaleMealShiftsQuery = { pointOfSaleMealShifts: Array<{ id: string, description: string, fromTime: string, toTime: string }> };

export type GetCassaInCloudDepartmentsQueryVariables = Exact<{
  filter: CassaInCloudDepartmentsQueryFilter;
}>;


export type GetCassaInCloudDepartmentsQuery = { getCassaInCloudDepartments: Array<{ id: string, description: string }> };

export type GetCassaInCloudSalesModesQueryVariables = Exact<{
  filter: CassaInCloudSalesModesQueryFilter;
}>;


export type GetCassaInCloudSalesModesQuery = { getCassaInCloudSalesModes: Array<{ id: string, description: string }> };

export type UpdatePointOfSaleMutationVariables = Exact<{
  updatePointOfSaleId: Scalars['String'];
  value: PointOfSaleInput;
}>;


export type UpdatePointOfSaleMutation = { updatePointOfSale?: any | null };

export type GenerateCiCTenantSecretMutationVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GenerateCiCTenantSecretMutation = { generateTenantSecret: string };

export type ChannelFragment = { id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null };

export type ChannelsQueryVariables = Exact<{
  filter: ChannelQueryFilter;
}>;


export type ChannelsQuery = { channels?: Array<{ id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null }> | null };

export type CreateChannelMutationVariables = Exact<{
  value: ChannelInput;
}>;


export type CreateChannelMutation = { createChannel: { id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null } };

export type UpdateChannelMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChannelInput;
}>;


export type UpdateChannelMutation = { updateChannel: { id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null } };

export type ExpediaParametersFragment = { pricingModel: ExpediaPricingModel, distributionModels?: Array<string> | null, rateAcquisitionType?: string | null };

export type ChannelDetailsFragment = { id: string, onboardingUrl?: string | null, portalDataRetrieved: boolean, message?: string | null, portalResourcesTypeWarn?: Array<string> | null, portalRatesWarn?: Array<string> | null, channel?: { id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, expediaParameters?: { pricingModel: ExpediaPricingModel, distributionModels?: Array<string> | null, rateAcquisitionType?: string | null } | null, channelResourceTypeMappings?: Array<{ resourceTypeId: string, portalResourceType: { resourceTypeCodePortal: string, resourceTypeNamePortal?: string | null, info?: string | null, adults: number, child?: number | null } }> | null, channelRateMappings?: Array<{ rateId: string, chargeCategoryId?: string | null, portalrate: { rateCodePortal: string, rateNamePortal?: string | null, derived: boolean, info?: string | null, resourceTypeCodes?: Array<string> | null, person?: number | null, portalPricingType?: string | null } }> | null, channelChargeMappings?: Array<{ chargeCategoryCodePortal: string, chargeCategoryId: string, chargeCategory: { name: string } }> | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null } | null, portalRatesNotMapped?: Array<{ rateCodePortal: string, rateNamePortal?: string | null, derived: boolean, info?: string | null, resourceTypeCodes?: Array<string> | null, portalPricingType?: string | null }> | null, portalResourcesTypeNotMapped?: Array<{ resourceTypeCodePortal: string, resourceTypeNamePortal?: string | null, info?: string | null, adults: number, child?: number | null }> | null, portalOpportunities?: Array<{ code?: string | null, name?: string | null, info?: string | null }> | null, portalResourcesTypeNoLongerExist?: Array<{ resourceTypeId: string, portalResourceType: { resourceTypeCodePortal: string } }> | null, portalRatesNoLongerExist?: Array<{ rateId: string, chargeCategoryId?: string | null, portalrate: { rateCodePortal: string } }> | null };

export type ChannelDetailsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  channelDetailsId: IDFilter;
}>;


export type ChannelDetailsQuery = { channelDetails: { id: string, onboardingUrl?: string | null, portalDataRetrieved: boolean, message?: string | null, portalResourcesTypeWarn?: Array<string> | null, portalRatesWarn?: Array<string> | null, channel?: { id: string, name: string, percentage: number, info?: string | null, tenantId: string, propertyId: string, subPropertyId?: string | null, portalId: string, propertyPortalCode?: string | null, initialImportDate?: Date | null, lastDownload?: Date | null, throughFigaro?: number | null, lastUpdateChannel?: Date | null, expediaParameters?: { pricingModel: ExpediaPricingModel, distributionModels?: Array<string> | null, rateAcquisitionType?: string | null } | null, channelResourceTypeMappings?: Array<{ resourceTypeId: string, portalResourceType: { resourceTypeCodePortal: string, resourceTypeNamePortal?: string | null, info?: string | null, adults: number, child?: number | null } }> | null, channelRateMappings?: Array<{ rateId: string, chargeCategoryId?: string | null, portalrate: { rateCodePortal: string, rateNamePortal?: string | null, derived: boolean, info?: string | null, resourceTypeCodes?: Array<string> | null, person?: number | null, portalPricingType?: string | null } }> | null, channelChargeMappings?: Array<{ chargeCategoryCodePortal: string, chargeCategoryId: string, chargeCategory: { name: string } }> | null, airbnbParameters?: { hostUserId?: string | null, hostAuthorizationCode?: string | null, hostAuthorizationTimestamp?: Date | null, authentication?: { accessToken: string, expiresAt: number, refreshToken: string } | null } | null, auditable: { state: State }, portal: { id: string, name: PortalName }, credentials?: { userId: string, password: string } | null } | null, portalRatesNotMapped?: Array<{ rateCodePortal: string, rateNamePortal?: string | null, derived: boolean, info?: string | null, resourceTypeCodes?: Array<string> | null, portalPricingType?: string | null }> | null, portalResourcesTypeNotMapped?: Array<{ resourceTypeCodePortal: string, resourceTypeNamePortal?: string | null, info?: string | null, adults: number, child?: number | null }> | null, portalOpportunities?: Array<{ code?: string | null, name?: string | null, info?: string | null }> | null, portalResourcesTypeNoLongerExist?: Array<{ resourceTypeId: string, portalResourceType: { resourceTypeCodePortal: string } }> | null, portalRatesNoLongerExist?: Array<{ rateId: string, chargeCategoryId?: string | null, portalrate: { rateCodePortal: string } }> | null } };

export type DeleteChannelMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteChannelId: Scalars['String'];
}>;


export type DeleteChannelMutation = { deleteChannel?: any | null };

export type RetrieveFutureReservationsMutationVariables = Exact<{
  portalName: PortalName;
  tenantId: Scalars['ID'];
  channelId: Scalars['ID'];
}>;


export type RetrieveFutureReservationsMutation = { retrieveFutureReservations: Date };

export type ChannelCommunicationResultFragment = { id: string, state: ChannelCommunicationState, message?: string | null, createdOn: Date, dataSendJson: any, operations?: Array<ChannelCommunicationOperation> | null };

export type ChannelCommunicationResultsQueryVariables = Exact<{
  filter: ChannelCommunicationFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ChannelCommunicationResultsQuery = { channelCommunicationResults?: Array<{ id: string, state: ChannelCommunicationState, message?: string | null, createdOn: Date, dataSendJson: any, operations?: Array<ChannelCommunicationOperation> | null }> | null };

export type SendAvailabilitiesAndPricesMutationVariables = Exact<{
  input: SendAvailabilitiesAndPricesInput;
}>;


export type SendAvailabilitiesAndPricesMutation = { sendAvailabilitiesAndPrices?: any | null };

export type RetrieveReservationsMutationVariables = Exact<{
  portalName: PortalName;
  tenantId: Scalars['ID'];
  channelId: Scalars['ID'];
  voucher?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
}>;


export type RetrieveReservationsMutation = { retrieveReservation?: any | null };

export type PortalQueryResultFragment = { id: string, name: PortalName, commercialName: string, throughFigaro?: Array<number> | null };

export type PortalQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalQuery = { portals?: Array<{ id: string, name: PortalName, commercialName: string, throughFigaro?: Array<number> | null }> | null };

export type ChargeCategoryFragment = { id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } };

export type ChargeCategoriesQueryVariables = Exact<{
  filter: ChargeCategoryQueryFilter;
}>;


export type ChargeCategoriesQuery = { chargeCategories?: Array<{ id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } }> | null };

export type CreateChargeCategoryMutationVariables = Exact<{
  value: ChargeCategoryInput;
}>;


export type CreateChargeCategoryMutation = { createChargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } } };

export type DeleteChargeCategoryMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteChargeCategoryId: Scalars['String'];
}>;


export type DeleteChargeCategoryMutation = { deleteChargeCategory?: any | null };

export type EditChargeCategoryMutationVariables = Exact<{
  value: ChargeCategoryInput;
  updateChargeCategoryId: Scalars['String'];
}>;


export type EditChargeCategoryMutation = { updateChargeCategory: { id: string, name: string, code?: ChargeCategoryBoard | null, cityTax: boolean, stayIncluded: boolean, breakfastIncluded: boolean, lunchIncluded: boolean, dinnerIncluded: boolean, defaultVatId: string, defaultVat: { value: number, id: string, description: string, code: string } } };

export type ChildFragment = { id: string, taxonomyId: string, minAge: number, maxAge: number, noOccupancy: boolean, percentageDiscount: number, taxonomy: { description: LocalizedString } };

export type ChildrenQueryVariables = Exact<{
  filter: ChildQueryFilter;
}>;


export type ChildrenQuery = { children?: Array<{ id: string, taxonomyId: string, minAge: number, maxAge: number, noOccupancy: boolean, percentageDiscount: number, taxonomy: { description: LocalizedString } }> | null };

export type SetPropertyCityTaxConfigurationMutationVariables = Exact<{
  setPropertyCityTaxConfigurationId: Scalars['ID'];
  config: Array<CityTaxConfigurationInput> | CityTaxConfigurationInput;
  tenantId: Scalars['ID'];
}>;


export type SetPropertyCityTaxConfigurationMutation = { setPropertyCityTaxConfiguration?: any | null };

export type CityTaxConfigurationFragment = { amount: number, rule: CityTaxRule, name: string, currency: Currency, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, fileGenerator?: CityTaxFileGenerator | null, amountByPeriod?: Array<{ amount: number, period: { start?: Date | null, end?: Date | null } }> | null, genericConfiguration?: { amountType: ValueType, maxNights: number, minAge: number, validity?: { start: string, end: string } | null, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null };

export type CityTaxConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type CityTaxConfigurationQuery = { properties?: Array<{ cityTaxConfiguration?: { configurations: Array<{ amount: number, rule: CityTaxRule, name: string, currency: Currency, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, fileGenerator?: CityTaxFileGenerator | null, amountByPeriod?: Array<{ amount: number, period: { start?: Date | null, end?: Date | null } }> | null, genericConfiguration?: { amountType: ValueType, maxNights: number, minAge: number, validity?: { start: string, end: string } | null, exonerations: Array<{ code: CityTaxExonerationCode, description: LocalizedString, extCode?: string | null, discount?: number | null }> } | null }> } | null }> | null };

export type GetCityTaxRulesQueryVariables = Exact<{
  input: GetCityTaxRulesInput;
}>;


export type GetCityTaxRulesQuery = { getCityTaxRules: { rules: Array<CityTaxRule>, match: boolean } };

export type GetPropertyCodeItalianPsIstatCodeQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type GetPropertyCodeItalianPsIstatCodeQuery = { properties?: Array<{ address?: { municipality?: { codeItalianPs: string } | null } | null, istatConfigurations?: Array<{ procedureCode: IstatProcedureCode }> | null }> | null };

export type GetCityTaxRegulationRicestatQueryVariables = Exact<{
  input: GetCityTaxRegulationRicestatInput;
}>;


export type GetCityTaxRegulationRicestatQuery = { getCityTaxRegulationRicestat: { municipalityCode: string, rules: Array<{ value: string, name: string, description: string, cityTaxCode: string }> } };

export type DepositDocumentsQueryVariables = Exact<{
  filter: DepositDocumentQueryFilter;
}>;


export type DepositDocumentsQuery = { depositDocuments?: Array<{ id: string, depositAssigneds?: Array<{ id: string }> | null }> | null };

export type ProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvincesQuery = { provinces: Array<string> };

export type FelConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type FelConfigurationQuery = { properties?: Array<{ fiscalConfigurations?: Array<{ felConfiguration?: { taxSystem: RegimeFiscale, authorizedCapital?: number | null, inLiquidation: boolean, reaCode?: string | null, reaOffice?: string | null, soleShareholder: boolean } | null }> | null }> | null };

export type SetPropertyFelConfigurationMutationVariables = Exact<{
  setPropertyFelConfigurationId: Scalars['ID'];
  config: Array<FiscalConfigurationInput> | FiscalConfigurationInput;
  tenantId: Scalars['ID'];
}>;


export type SetPropertyFelConfigurationMutation = { setPropertyFiscalConfiguration?: any | null };

export type HoauFragment = { baseUrl: string, userId: string, token?: string | null };

export type PropertyHoauConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyHoauConfigurationQuery = { properties?: Array<{ type: PropertyType, name: string, tenantId: string, hoauConfiguration?: { baseUrl: string, userId: string, token?: string | null } | null }> | null };

export type HotelDateUpdateMutationVariables = Exact<{
  input: HotelDateInput;
}>;


export type HotelDateUpdateMutation = { setHotelDate?: any | null };

export type HousekeepingSettingsQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type HousekeepingSettingsQuery = { properties?: Array<{ type: PropertyType, housekeepingConfiguration?: { daysForResourceDirty?: number | null, reportAdditionalColumns?: Array<string> | null } | null }> | null };

export type UpdateHousekeepingSettingsMutationVariables = Exact<{
  updatePropertyId: Scalars['ID'];
  value: PropertyInput;
}>;


export type UpdateHousekeepingSettingsMutation = { updateProperty: { housekeepingConfiguration?: { daysForResourceDirty?: number | null } | null } };

export type FileUploadResponseFragment = { preSignedURL: string, file: { id: string } };

export type FileUploadPresignedURLMutationVariables = Exact<{
  file: FileInput;
}>;


export type FileUploadPresignedURLMutation = { fileUploadPresignedURL: { preSignedURL: string, file: { id: string } } };

export type SetEntityImagesMutationVariables = Exact<{
  input: EntityImageInput;
}>;


export type SetEntityImagesMutation = { setEntityImages?: any | null };

export type ImageFragment = { URL: string, id: string };

export type GetImagesQueryVariables = Exact<{
  propertyFilter: PropertyQueryFilter;
  resourceTypesFilter: ResourceTypeQueryFilter;
  additionalServicesFilter: AdditionalServiceQueryFilter;
}>;


export type GetImagesQuery = { properties?: Array<{ images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null }> | null }> | null, resourceTypes?: Array<{ customName?: LocalizedString | null, id: string, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null, name: { description: LocalizedString } }> | null, additionalServices?: Array<{ imageIds?: Array<string> | null, name: LocalizedString, id: string, images?: Array<{ URL: string, id: string }> | null }> | null };

export type GetPropertyImagesQueryVariables = Exact<{
  propertyFilter: PropertyQueryFilter;
}>;


export type GetPropertyImagesQuery = { properties?: Array<{ images?: Array<{ type: PropertyImageType, imageIds?: Array<string> | null, images?: Array<{ URL: string, id: string }> | null }> | null }> | null };

export type InsightFragment = { id: string, insightCode: Insight, endPause?: Date | null, insightInfo?: { code: Insight, priority: InsightPriority, type: InsightType, actionUrl?: string | null, title: LocalizedString, description: LocalizedString } | null };

export type InsightsQueryVariables = Exact<{
  filter: InsightQueryFilter;
}>;


export type InsightsQuery = { insights?: Array<{ id: string, insightCode: Insight, endPause?: Date | null, insightInfo?: { code: Insight, priority: InsightPriority, type: InsightType, actionUrl?: string | null, title: LocalizedString, description: LocalizedString } | null }> | null };

export type InsightMutationVariables = Exact<{
  input: InsightInput;
}>;


export type InsightMutation = { setInsightPause?: any | null };

export type IstatConfigurationFragment = { password?: string | null, propertyCode?: string | null, username?: string | null, name: string, procedureCode: IstatProcedureCode, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, overrideResourcesNumber?: number | null, overrideBedsNumber?: number | null };

export type ISTATConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type ISTATConfigurationQuery = { properties?: Array<{ istatConfigurations?: Array<{ password?: string | null, propertyCode?: string | null, username?: string | null, name: string, procedureCode: IstatProcedureCode, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, overrideResourcesNumber?: number | null, overrideBedsNumber?: number | null }> | null }> | null };

export type SetPropertyIstatConfigurationMutationVariables = Exact<{
  setPropertyIstatConfigurationId: Scalars['ID'];
  config?: InputMaybe<Array<IstatConfigurationInput> | IstatConfigurationInput>;
  tenantId: Scalars['ID'];
}>;


export type SetPropertyIstatConfigurationMutation = { setPropertyIstatConfiguration?: any | null };

export type GetIstatProcedureByPropertyQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type GetIstatProcedureByPropertyQuery = { getIstatProcedureByProperty: IstatProcedureCode };

export type IstatSystemCapabilitiesFragment = { supportsAutomaticSend?: boolean | null, supportsFileGeneration?: boolean | null, handlesCancellation?: boolean | null };

export type GetIstatSystemCapabilitiesQueryVariables = Exact<{
  procedureCode: IstatProcedureCode;
}>;


export type GetIstatSystemCapabilitiesQuery = { getIstatSystemCapabilities: { supportsAutomaticSend?: boolean | null, supportsFileGeneration?: boolean | null, handlesCancellation?: boolean | null } };

export type IstatResourcesQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type IstatResourcesQuery = { resources?: Array<{ code: string, id: string, codeIstat?: string | null }> | null };

export type MessageTemplateFragment = { id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, description?: string | null, chat?: LocalizedString | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } };

export type MessageTemplateListFragment = { id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, chat?: LocalizedString | null, description?: string | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } };

export type MailTemplateFragment = { language: Language, value: { subject: string, design?: string | null, html?: string | null } };

export type TenantPropertiesQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type TenantPropertiesQuery = { properties?: Array<{ id: string, name: string }> | null };

export type MessageTemplatesListQueryVariables = Exact<{
  filter: MessageTemplateQueryFilter;
}>;


export type MessageTemplatesListQuery = { messageTemplates?: Array<{ id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, chat?: LocalizedString | null, description?: string | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } }> | null };

export type MessageTemplatesQueryVariables = Exact<{
  filter: MessageTemplateQueryFilter;
}>;


export type MessageTemplatesQuery = { messageTemplates?: Array<{ id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, description?: string | null, chat?: LocalizedString | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } }> | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  value: MessageTemplateInput;
}>;


export type CreateMessageTemplateMutation = { createMessageTemplate: { id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, description?: string | null, chat?: LocalizedString | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } } };

export type UpdateMessageTemplateMutationVariables = Exact<{
  updateMailTemplateId: Scalars['String'];
  value: MessageTemplateInput;
}>;


export type UpdateMessageTemplateMutation = { updateMessageTemplate: { id: string, code: MessageTemplateCode, name: string, type: MessageTemplateType, tenantId?: string | null, propertyId?: string | null, description?: string | null, chat?: LocalizedString | null, mail?: Array<{ language: Language, value: { subject: string, design?: string | null, html?: string | null } }> | null, auditable: { createdBy?: string | null, modifiedOn?: Date | null, createdOn?: Date | null, state: State } } };

export type DeleteMessageTemplateMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteMailTemplateId: Scalars['String'];
}>;


export type DeleteMessageTemplateMutation = { deleteMessageTemplate?: any | null };

export type FileFragment = { URL: string, filename?: string | null, id: string, key: string, mimeType?: string | null, propertyId?: string | null, public: boolean, tenantId: string };

export type FilesQueryVariables = Exact<{
  filter: FilesQueryFilter;
}>;


export type FilesQuery = { files?: Array<{ URL: string, filename?: string | null, id: string, key: string, mimeType?: string | null, propertyId?: string | null, public: boolean, tenantId: string }> | null };

export type SendDataHubSpotMutationVariables = Exact<{
  data: Array<HubSpotDataInput> | HubSpotDataInput;
}>;


export type SendDataHubSpotMutation = { sendDataHubSpot?: string | null };

export type MultiManagementSubAddressFragment = { name: string, resourceTypeIds: Array<string> };

export type MultiManagementFiscalConfigurationFragment = { name: string, resourceTypeIds?: Array<string> | null };

export type MultiManagementCityTaxConfigurationFragment = { name: string, resourceIds?: Array<string> | null, resourceTypeIds?: Array<string> | null };

export type MultiManagementIstatConfigurationFragment = { name: string, resourceIds?: Array<string> | null, resourceTypeIds?: Array<string> | null };

export type MultiManagementQueryVariables = Exact<{
  resourceTypeFilter: ResourceTypeQueryFilter;
  propertyFilter: PropertyQueryFilter;
}>;


export type MultiManagementQuery = { resourceTypes?: Array<{ code?: string | null, customName?: LocalizedString | null, id: string, name: { description: LocalizedString }, resources?: Array<{ id: string, code: string, codeItalianPs?: string | null }> | null, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement } | null }> | null, properties?: Array<{ subAddresses?: Array<{ name: string, resourceTypeIds: Array<string> }> | null, fiscalConfigurations?: Array<{ name: string, resourceTypeIds?: Array<string> | null }> | null, cityTaxConfiguration?: { configurations: Array<{ name: string, resourceIds?: Array<string> | null, resourceTypeIds?: Array<string> | null }> } | null, istatConfigurations?: Array<{ name: string, resourceIds?: Array<string> | null, resourceTypeIds?: Array<string> | null }> | null, psConfigurations?: Array<{ password: string, username: string, wskey: string, auto: boolean, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, name: string }> | null }> | null };

export type SetPropertyConfigurationsMutationVariables = Exact<{
  value: SetPropertyConfigurationsInput;
}>;


export type SetPropertyConfigurationsMutation = { setPropertyConfigurations?: any | null };

export type PaymentGatewayFragment = { id: string, type: PaymentGatewayType, managedMethodTypes?: Array<PaymentMethodType> | null };

export type PaymentGatewaysQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type PaymentGatewaysQuery = { paymentGateways?: Array<{ id: string, type: PaymentGatewayType, managedMethodTypes?: Array<PaymentMethodType> | null }> | null };

export type PaymentMethodFragment = { id: string, tenantId: string, propertyId: string, type: PaymentMethodType, additionalNote?: LocalizedString | null, gateway?: { id: string, managedMethodTypes?: Array<PaymentMethodType> | null } | null };

export type PaymentMethodsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type PaymentMethodsQuery = { paymentMethods?: Array<{ id: string, tenantId: string, propertyId: string, type: PaymentMethodType, additionalNote?: LocalizedString | null, gateway?: { id: string, managedMethodTypes?: Array<PaymentMethodType> | null } | null }> | null };

export type PaymentMethodQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
}>;


export type PaymentMethodQuery = { paymentMethods?: Array<{ id: string, tenantId: string, propertyId: string, type: PaymentMethodType, additionalNote?: LocalizedString | null, gateway?: { id: string, managedMethodTypes?: Array<PaymentMethodType> | null } | null }> | null };

export type PaymentMethodNewMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;


export type PaymentMethodNewMutation = { createPaymentMethod: { id: string, tenantId: string, propertyId: string, type: PaymentMethodType, additionalNote?: LocalizedString | null, gateway?: { id: string, managedMethodTypes?: Array<PaymentMethodType> | null } | null } };

export type PaymentMethodUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  input: PaymentMethodInput;
}>;


export type PaymentMethodUpdateMutation = { updatePaymentMethod: { id: string, tenantId: string, propertyId: string, type: PaymentMethodType, additionalNote?: LocalizedString | null, gateway?: { id: string, managedMethodTypes?: Array<PaymentMethodType> | null } | null } };

export type PaymentMethodDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type PaymentMethodDeleteMutation = { deletePaymentMethod?: any | null };

export type PaymentActiveListFragment = { id: string, name: LocalizedString, managementCode?: string | null, paymentType: { id: string, name: LocalizedString }, auditable: { state: State } };

export type PaymentActiveListQueryVariables = Exact<{
  filter: PaymentActiveQueryFilter;
}>;


export type PaymentActiveListQuery = { paymentActives: Array<{ id: string, name: LocalizedString, managementCode?: string | null, paymentType: { id: string, name: LocalizedString }, auditable: { state: State } }> };

export type UpdatePaymentActiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: PaymentActiveInput;
}>;


export type UpdatePaymentActiveMutation = { updatePaymentActive: { id: string, name: LocalizedString, managementCode?: string | null, paymentType: { id: string, name: LocalizedString }, auditable: { state: State } } };

export type PaymentTypesQueryVariables = Exact<{
  filter: PaymentTypeQueryFilter;
}>;


export type PaymentTypesQuery = { paymentTypes: Array<{ id: string, name: LocalizedString }> };

export type CreatePaymentActiveMutationVariables = Exact<{
  value: PaymentActiveInput;
}>;


export type CreatePaymentActiveMutation = { createPaymentActive: { id: string, name: LocalizedString, managementCode?: string | null, paymentType: { id: string, name: LocalizedString }, auditable: { state: State } } };

export type PositionFragment = { id: string, name: string, order: number };

export type PositionsQueryVariables = Exact<{
  filter: PositionQueryFilter;
}>;


export type PositionsQuery = { positions?: Array<{ id: string, name: string, order: number }> | null };

export type CreatePositionMutationVariables = Exact<{
  value: PositionInput;
}>;


export type CreatePositionMutation = { createPosition: { id: string, name: string, order: number } };

export type UpdatePositionMutationVariables = Exact<{
  value: PositionInput;
  updatePositionId: Scalars['String'];
}>;


export type UpdatePositionMutation = { updatePosition: { id: string, name: string, order: number } };

export type DeletePositionMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deletePositionId: Scalars['String'];
}>;


export type DeletePositionMutation = { deletePosition?: any | null };

export type UpdatePrivacySettingsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  value: PrivacySettingsInput;
}>;


export type UpdatePrivacySettingsMutation = { updatePrivacySettings?: any | null };

export type GetCompanyInfoForPrivacyQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<TenantQueryFilter>;
}>;


export type GetCompanyInfoForPrivacyQuery = { getCompanyInfoForPrivacy: { name?: string | null, vat?: string | null, fiscalCode?: string | null }, tenants?: Array<{ id: string, privacySettings?: { companyAddress?: string | null, companyEmail?: string | null, companyName?: string | null, companyVat?: string | null, companyFiscalCode?: string | null, dataRetentionMonths: number, isCustomText: boolean, text: LocalizedString, useDirectMarketing: boolean, useHealthData: boolean, useThirdPartyMarketing: boolean, useProfiledMarketing: boolean } | null }> | null };

export type ProductFragment = { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, description: string, amount: number, chargeCategory: { name: string, defaultVatId: string, defaultVat: { code: string, value: number } }, auditable: { state: State } };

export type ProductsQueryVariables = Exact<{
  filter: ProductQueryFilter;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ProductsQuery = { products?: Array<{ id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, description: string, amount: number, chargeCategory: { name: string, defaultVatId: string, defaultVat: { code: string, value: number } }, auditable: { state: State } }> | null };

export type CreateProductMutationVariables = Exact<{
  value: ProductInput;
}>;


export type CreateProductMutation = { createProduct: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, description: string, amount: number, chargeCategory: { name: string, defaultVatId: string, defaultVat: { code: string, value: number } }, auditable: { state: State } } };

export type UpdateProductMutationVariables = Exact<{
  updateProductId: Scalars['ID'];
  value: ProductInput;
}>;


export type UpdateProductMutation = { updateProduct: { id: string, tenantId: string, propertyId?: string | null, chargeCategoryId: string, description: string, amount: number, chargeCategory: { name: string, defaultVatId: string, defaultVat: { code: string, value: number } }, auditable: { state: State } } };

export type DeleteProductMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteProductId: Scalars['ID'];
}>;


export type DeleteProductMutation = { deleteProduct?: any | null };

export type PSConfigurationFragment = { password: string, username: string, wskey: string, auto: boolean, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, name: string };

export type PSConfigurationQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PSConfigurationQuery = { properties?: Array<{ psConfigurations?: Array<{ password: string, username: string, wskey: string, auto: boolean, resourceTypeIds?: Array<string> | null, resourceIds?: Array<string> | null, name: string }> | null }> | null };

export type SetPropertyPsConfigurationMutationVariables = Exact<{
  setPropertyPsConfigurationId: Scalars['ID'];
  config?: InputMaybe<Array<PsConfigurationInput> | PsConfigurationInput>;
  tenantId: Scalars['ID'];
}>;


export type SetPropertyPsConfigurationMutation = { setPropertyPsConfiguration?: any | null };

export type PSResourcesQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type PSResourcesQuery = { resources?: Array<{ code: string, codeItalianPs?: string | null, id: string }> | null };

export type TestPropertyPsConfigurationQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type TestPropertyPsConfigurationQuery = { testPropertyPsConfiguration?: boolean | null };

export type ResourceTypeOptionFragment = { type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> };

export type TimeConfigurationFragment = { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null };

export type ResourceTypeFragment = { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null };

export type ResourceTypeEssentialFragment = { id: string, code?: string | null, description: LocalizedString, customName?: LocalizedString | null, logicalType: boolean, name: { description: LocalizedString } };

export type TaxonomyFragment = { id: string, type: TaxonomyType, description: LocalizedString, parentId?: string | null, order: number };

export type AmenityFragment = { id: string, name: LocalizedString, image?: string | null };

export type ResourceLayoutFragment = { id: string, occupation: number, description: LocalizedString };

export type TaxonomiesQueryVariables = Exact<{
  filter: TaxonomyQueryFilter;
}>;


export type TaxonomiesQuery = { taxonomies?: Array<{ id: string, type: TaxonomyType, description: LocalizedString, parentId?: string | null, order: number }> | null };

export type AmenitiesQueryVariables = Exact<{
  filter: AmenityQueryFilter;
}>;


export type AmenitiesQuery = { amenities?: Array<{ id: string, name: LocalizedString, image?: string | null }> | null };

export type ResourceLayoutsQueryVariables = Exact<{
  filter: ResourceLayoutQueryFilter;
}>;


export type ResourceLayoutsQuery = { resourceLayouts?: Array<{ id: string, occupation: number, description: LocalizedString }> | null };

export type CreateResourceTypeMutationVariables = Exact<{
  value: ResourceTypeInput;
}>;


export type CreateResourceTypeMutation = { createResourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } };

export type ResourceTypesQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypesQuery = { resourceTypes?: Array<{ id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null }> | null };

export type ResourceTypesEssentialQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypesEssentialQuery = { resourceTypes?: Array<{ id: string, code?: string | null, description: LocalizedString, customName?: LocalizedString | null, logicalType: boolean, name: { description: LocalizedString } }> | null };

export type ResourceTypeIdsQueryVariables = Exact<{
  filter: ResourceTypeQueryFilter;
}>;


export type ResourceTypeIdsQuery = { resourceTypes?: Array<{ id: string }> | null };

export type DeleteResourceTypeMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteResourceTypeId: Scalars['String'];
}>;


export type DeleteResourceTypeMutation = { deleteResourceType?: any | null };

export type UpdateResourceTypeMutationVariables = Exact<{
  updateResourceTypeId: Scalars['String'];
  value: ResourceTypeInput;
}>;


export type UpdateResourceTypeMutation = { updateResourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } };

export type OnboardingResourceTypeMutationVariables = Exact<{
  value: OnBoardingResourceTypeInput;
}>;


export type OnboardingResourceTypeMutation = { onboardingResourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } };

export type ResourceFragment = { id: string, description: string, positionId?: string | null, code: string, resourceTypeId: string, position?: { id: string, name: string, order: number } | null, layout?: { occupation: number, description: LocalizedString } | null, resourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } };

export type ResourcesQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type ResourcesQuery = { resources?: Array<{ id: string, description: string, positionId?: string | null, code: string, resourceTypeId: string, position?: { id: string, name: string, order: number } | null, layout?: { occupation: number, description: LocalizedString } | null, resourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } }> | null };

export type ResourceLookupTypeFragment = { id: string, code: string, resourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString } };

export type ResourcesLookupQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type ResourcesLookupQuery = { resources?: Array<{ id: string, code: string, resourceType: { id: string, code?: string | null, customName?: LocalizedString | null, description: LocalizedString } }> | null };

export type CreateResourceMutationVariables = Exact<{
  value: ResourceInput;
}>;


export type CreateResourceMutation = { createResource: { id: string, description: string, positionId?: string | null, code: string, resourceTypeId: string, position?: { id: string, name: string, order: number } | null, layout?: { occupation: number, description: LocalizedString } | null, resourceType: { id: string, code?: string | null, description: LocalizedString, persons: number, additionalPersons: number, maxAdults?: number | null, nameId: string, resourceCategoryId: string, configurationsLayoutId?: Array<string> | null, defaultLayoutId?: string | null, inventory: number, rackRate: number, minRate: number, amenitiesId?: Array<string> | null, order: number, customName?: LocalizedString | null, currency: Currency, logicalType: boolean, autoEquivalent: boolean, visibilityOnIbe: boolean, name: { description: LocalizedString }, resources?: Array<{ id: string, description: string, code: string, roomTetrisOrder: number, position?: { name: string } | null }> | null, equivalences: Array<{ type: OptionType, logicResourceId?: string | null, order: number, group: Array<{ resourceTypeId: string, resourceId?: string | null }> }>, timeConfiguration?: { unitOfMeasurement: ResourceTypeTimeUnitOfMeasurement, chargeCategoryId: string, activity?: { from: Date, to: Date } | null } | null } } };

export type UpdateResourceMutationVariables = Exact<{
  updateResourceId: Scalars['String'];
  value: ResourceInput;
}>;


export type UpdateResourceMutation = { updateResource: { id: string } };

export type DeleteResourceMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  deleteResourceId: Scalars['String'];
}>;


export type DeleteResourceMutation = { deleteResource?: any | null };

export type UpdateResourcesRoomTetrisOrderMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  input: Array<UpdateResourceRoomTetrisOrderInput> | UpdateResourceRoomTetrisOrderInput;
}>;


export type UpdateResourcesRoomTetrisOrderMutation = { updateResourcesRoomTetrisOrder?: any | null };

export type TagFragment = { id: string, label: string, color: string };

export type TagsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type TagsQuery = { tags?: Array<{ id: string, label: string, color: string }> | null };

export type TagNewMutationVariables = Exact<{
  value: TagInput;
}>;


export type TagNewMutation = { createTag: { id: string, label: string, color: string } };

export type TagUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  value: TagInput;
}>;


export type TagUpdateMutation = { updateTag: { id: string, label: string, color: string } };

export type TagDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type TagDeleteMutation = { deleteTag?: any | null };

export type StartTsPayOnboardingMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  vatNumber: Scalars['String'];
}>;


export type StartTsPayOnboardingMutation = { startTsPayOnboarding: string };

export type TsPayOnboardingStateQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type TsPayOnboardingStateQuery = { properties?: Array<{ fiscalConfigurations?: Array<{ default: boolean, tspay?: { state: TsPayOnboardingState } | null }> | null }> | null };

export type FiscalConfigurationsTsPayQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type FiscalConfigurationsTsPayQuery = { properties?: Array<{ fiscalConfigurations?: Array<{ default: boolean, vatNumber?: string | null, tspay?: { merchantRef?: string | null, state: TsPayOnboardingState } | null }> | null }> | null };

export type CreateLinkFroReservationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  reservationId: Scalars['ID'];
  payment?: InputMaybe<PaymentInput>;
}>;


export type CreateLinkFroReservationMutation = { createLinkForReservation?: { url: string, orderKey: string, type: TsPayLinkType } | null };

export type CreateLink2PayPosOnlineMutationVariables = Exact<{
  input: Link2PayInput;
}>;


export type CreateLink2PayPosOnlineMutation = { createLink2PayPosOnLine: { url: string, orderKey: string, type: TsPayLinkType } };

export type TsPayLinkStatusQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  orderKey: Scalars['String'];
}>;


export type TsPayLinkStatusQuery = { tsPayLinks?: { charges: Array<{ state: TsPayChargeState, error?: { message?: string | null } | null }> } | null };

export type UserWithRoleFragment = { id: string, email?: string | null, fullname?: string | null, authorizations?: Array<{ propertyId?: string | null, tenantId?: string | null, role?: { code: string, name: LocalizedString } | null }> | null };

export type PropertyRoleFragment = { code: string, name: LocalizedString };

export type RolesQueryVariables = Exact<{
  filter?: InputMaybe<RoleQueryFilter>;
}>;


export type RolesQuery = { roles?: Array<{ code: string, name: LocalizedString }> | null };

export type UsersWithRolesQueryVariables = Exact<{
  filter: UserQueryInput;
}>;


export type UsersWithRolesQuery = { users?: Array<{ id: string, email?: string | null, fullname?: string | null, authorizations?: Array<{ propertyId?: string | null, tenantId?: string | null, role?: { code: string, name: LocalizedString } | null }> | null }> | null };

export type UpdateUserRoleMutationVariables = Exact<{
  updateUserRoleId: Scalars['ID'];
  value: Array<UserRoleInput> | UserRoleInput;
}>;


export type UpdateUserRoleMutation = { updateUserRole?: any | null };

export type CreateUserAndRoleMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserAndRoleMutation = { createUserAndRole?: any | null };

export type VatFragment = { id: string, code: string, codePa?: string | null, value: number, order: number, description: string, tenantId: string, propertyId?: string | null };

export type VatsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type VatsQuery = { vats?: Array<{ id: string, code: string, codePa?: string | null, value: number, order: number, description: string, tenantId: string, propertyId?: string | null }> | null };

export type VatQueryVariables = Exact<{
  vatId: Scalars['ID'];
  tenantId: Scalars['ID'];
}>;


export type VatQuery = { vats?: Array<{ id: string, code: string, codePa?: string | null, value: number, order: number, description: string, tenantId: string, propertyId?: string | null }> | null };

export type VatNewMutationVariables = Exact<{
  input: VatInput;
}>;


export type VatNewMutation = { createVat: { id: string, code: string, codePa?: string | null, value: number, order: number, description: string, tenantId: string, propertyId?: string | null } };

export type VatUpdateMutationVariables = Exact<{
  id: Scalars['String'];
  input: VatInput;
}>;


export type VatUpdateMutation = { updateVat: { id: string, code: string, codePa?: string | null, value: number, order: number, description: string, tenantId: string, propertyId?: string | null } };

export type VatDeleteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  id: Scalars['String'];
}>;


export type VatDeleteMutation = { deleteVat?: any | null };

export type SinapsiRateFragment = { type: RateType, id: string, chargeCategory: { id: string }, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType }> | null };

export type PriceCalendarSinapsiFragment = { day: Date, id: string, availabilities: Array<{ availability: number, resourceTypeId: string }>, rates: Array<{ stopSellResourcesTypeId?: Array<string> | null, chargesRate?: Array<{ price?: number | null, resourceTypeId: string }> | null, rate: { type: RateType, resourcesRate?: Array<{ price: number, resourceTypeId: string }> | null } }> };

export type GetBasePriceResourceTypeAndRateForSinapsiQueryVariables = Exact<{
  priceCalendarFilter: PriceCalendarFilter;
  ratesFilter: RateQueryFilter;
}>;


export type GetBasePriceResourceTypeAndRateForSinapsiQuery = { getPriceCalendar: Array<{ day: Date, id: string, availabilities: Array<{ availability: number, resourceTypeId: string }>, rates: Array<{ stopSellResourcesTypeId?: Array<string> | null, chargesRate?: Array<{ price?: number | null, resourceTypeId: string }> | null, rate: { type: RateType, resourcesRate?: Array<{ price: number, resourceTypeId: string }> | null } }> }>, rates?: Array<{ type: RateType, id: string, chargeCategory: { id: string }, resourcesRate?: Array<{ resourceTypeId: string, priceType: PriceType }> | null }> | null };

export type SinapsiBudgetForecastFragment = { month: string, otb: number, to_come: number };

export type SinapsiPriceRecommendationFragment = { resourceTypeId: string, recommendations: Array<{ date: Date, price: number, warnings?: { min?: boolean | null, max?: boolean | null } | null } | null> };

export type SinapsiPriceFragment = { prices?: Array<{ resourceTypeId: string, recommendations: Array<{ date: Date, price: number, warnings?: { min?: boolean | null, max?: boolean | null } | null } | null> }> | null, budget_forecast?: Array<{ month: string, otb: number, to_come: number }> | null, last_period_stats?: { n_changes: number } | null };

export type GetSinapsiPricesQueryVariables = Exact<{
  filter: SinapsiFilter;
  options: SinapsiQueryOptions;
}>;


export type GetSinapsiPricesQuery = { getSinapsiPrices: { prices?: Array<{ resourceTypeId: string, recommendations: Array<{ date: Date, price: number, warnings?: { min?: boolean | null, max?: boolean | null } | null } | null> }> | null, budget_forecast?: Array<{ month: string, otb: number, to_come: number }> | null, last_period_stats?: { n_changes: number } | null } };

export type UpdateSinapsiPriceCalendarMutationVariables = Exact<{
  value: PriceCalendarInput;
}>;


export type UpdateSinapsiPriceCalendarMutation = { updatePriceCalendar?: any | null };

export type AuditLastTimeSavedQueryVariables = Exact<{
  filter: AuditQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<AuditSortInput> | AuditSortInput>;
}>;


export type AuditLastTimeSavedQuery = { audits?: Array<{ timestamp: Date }> | null };

export type ResourceTypeForSinapsiFragment = { id: string, code?: string | null, customName?: LocalizedString | null, minRate: number, currency: Currency, additionalPersons: number, persons: number, rackRate: number, inventory: number, name: { description: LocalizedString } };

export type SinapsiConfigurationFragment = { ignore_resources?: Array<string> | null, pricing?: { limits?: Array<{ resourceTypeId: string, min: number, max: number }> | null, overrides?: Array<{ from: Date, to: Date, limits: Array<{ resourceTypeId: string, min: number, max: number }> }> | null, order?: { active?: boolean | null, exclude_from_ordering?: Array<string> | null } | null } | null, risk_profile?: { risk_appetite: string } | null, autopilot?: { active: boolean, max_n_days?: number | null } | null };

export type ResourceTypesForSinapsiQueryVariables = Exact<{
  resourceTypesFilter: ResourceTypeQueryFilter;
}>;


export type ResourceTypesForSinapsiQuery = { resourceTypes?: Array<{ id: string, code?: string | null, customName?: LocalizedString | null, minRate: number, currency: Currency, additionalPersons: number, persons: number, rackRate: number, inventory: number, name: { description: LocalizedString } }> | null };

export type SinapsiConfigurationQueryVariables = Exact<{
  propertiesFilter: PropertyQueryFilter;
}>;


export type SinapsiConfigurationQuery = { properties?: Array<{ sinapsiConfiguration?: { ignore_resources?: Array<string> | null, pricing?: { limits?: Array<{ resourceTypeId: string, min: number, max: number }> | null, overrides?: Array<{ from: Date, to: Date, limits: Array<{ resourceTypeId: string, min: number, max: number }> }> | null, order?: { active?: boolean | null, exclude_from_ordering?: Array<string> | null } | null } | null, risk_profile?: { risk_appetite: string } | null, autopilot?: { active: boolean, max_n_days?: number | null } | null } | null }> | null };

export type SetPropertySinapsiConfigurationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  config: SinapsiConfigurationInput;
}>;


export type SetPropertySinapsiConfigurationMutation = { setPropertySinapsiConfiguration?: any | null };

export type SinapsiStatisticFragment = { date: Date, occupancy: number, inventory: number, totalProduction: number };

export type MainSinapsiStatisticsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  mainStart: Scalars['Date'];
  mainEnd: Scalars['Date'];
  vatIncluded: Scalars['Boolean'];
}>;


export type MainSinapsiStatisticsQuery = { getStatistics?: Array<{ date: Date, occupancy: number, inventory: number, totalProduction: number }> | null };

export type ComparisonSinapsiStatisticsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  comparisonStart: Scalars['Date'];
  comparisonEnd: Scalars['Date'];
  vatIncluded: Scalars['Boolean'];
}>;


export type ComparisonSinapsiStatisticsQuery = { getStatistics?: Array<{ date: Date, occupancy: number, inventory: number, totalProduction: number }> | null };

export type ComparisonWithOnTheBookSinapsiStatisticsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  comparisonStart: Scalars['Date'];
  comparisonEnd: Scalars['Date'];
  vatIncluded: Scalars['Boolean'];
  dateFrom?: InputMaybe<Scalars['Date']>;
}>;


export type ComparisonWithOnTheBookSinapsiStatisticsQuery = { getStatistics?: Array<{ date: Date, occupancy: number, inventory: number, totalProduction: number }> | null };

export type GetSinapsiDailyPriceAuditQueryVariables = Exact<{
  filter: SinapsiDailyPriceAuditFilterInput;
}>;


export type GetSinapsiDailyPriceAuditQuery = { getSinapsiDailyPriceAudit: Array<{ price: number, timestamp: Date }> };

export type TenantCompanyInfoQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type TenantCompanyInfoQuery = { tenants?: Array<{ description?: string | null, vatNumber?: string | null }> | null };

export type ThreadFragment = { archived: boolean, externalId: string, id: string, origin: ThreadOrigin, read: boolean, reservationId: string, lastMessage?: { message: string, createdOn: Date } | null, reservation: { reservationCode: string, reference: { mainGuest: { name: any } }, reservedResources?: Array<{ start: Date, end: Date, adults: number, children: number }> | null } };

export type ThreadsQueryVariables = Exact<{
  filter: ThreadQueryFilter;
}>;


export type ThreadsQuery = { threads?: Array<{ archived: boolean, externalId: string, id: string, origin: ThreadOrigin, read: boolean, reservationId: string, lastMessage?: { message: string, createdOn: Date } | null, reservation: { reservationCode: string, reference: { mainGuest: { name: any } }, reservedResources?: Array<{ start: Date, end: Date, adults: number, children: number }> | null } }> | null };

export type MessageFragment = { externalUserId?: string | null, id: string, internalNote: boolean, message: string, auditable: { createdOn?: Date | null } };

export type ThreadMessagesQueryVariables = Exact<{
  filter: ThreadMessageQueryFilter;
}>;


export type ThreadMessagesQuery = { threadMessages?: Array<{ externalUserId?: string | null, id: string, internalNote: boolean, message: string, auditable: { createdOn?: Date | null } }> | null };

export type UpdateThreadMutationVariables = Exact<{
  input: UpdateThreadInput;
}>;


export type UpdateThreadMutation = { updateThread?: any | null };

export type DeleteInternalThreadMessageMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  threadMessageId: Scalars['ID'];
}>;


export type DeleteInternalThreadMessageMutation = { deleteInternalThreadMessage?: any | null };

export type SendThreadMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendThreadMessageMutation = { sendThreadMessage?: any | null };

export type ReservationThreadFragment = { id: string, archived: boolean, lastMessage?: { message: string, createdOn: Date } | null };

export type ReservationThreadsQueryVariables = Exact<{
  filter: ThreadQueryFilter;
}>;


export type ReservationThreadsQuery = { threads?: Array<{ id: string, archived: boolean, lastMessage?: { message: string, createdOn: Date } | null }> | null };

export type NewThreadMessageEventSubscriptionVariables = Exact<{
  filter: NewThreadMessageEventFilter;
}>;


export type NewThreadMessageEventSubscription = { newThreadMessageEvent?: { threadId: string } | null };

export type GetBuyNowUrlFromStoreQueryVariables = Exact<{
  request: StoreUpgradeInput;
}>;


export type GetBuyNowUrlFromStoreQuery = { getUrlFromStore: { url: string } };

export type PropertyClassTypeQueryVariables = Exact<{
  filter: PropertyQueryFilter;
}>;


export type PropertyClassTypeQuery = { properties?: Array<{ classType?: { id: string, description: LocalizedString } | null }> | null };

export type HowManyResourcesQueryVariables = Exact<{
  filter: ResourceQueryFilter;
}>;


export type HowManyResourcesQuery = { resources?: Array<{ id: string }> | null };

export type PlanFragment = { currency?: string | null, billingFrequency?: string | null, footerFooterFeatures?: string | null, price?: number | null, title: string, footerFeatures?: Array<{ text: string }> | null };

export type StoreCatalogFragment = { pricesPages?: Array<{ url: string, descriptionRows?: Array<{ description?: string | null }> | null, cards?: Array<{ plans?: Array<{ currency?: string | null, billingFrequency?: string | null, footerFooterFeatures?: string | null, price?: number | null, title: string, footerFeatures?: Array<{ text: string }> | null }> | null }> | null }> | null };

export type GetCatalogFromStoreQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GetCatalogFromStoreQuery = { getCatalogFromStore: { pricesPages?: Array<{ url: string, descriptionRows?: Array<{ description?: string | null }> | null, cards?: Array<{ plans?: Array<{ currency?: string | null, billingFrequency?: string | null, footerFooterFeatures?: string | null, price?: number | null, title: string, footerFeatures?: Array<{ text: string }> | null }> | null }> | null }> | null } };

export type GetSubscriptionStoreQueryVariables = Exact<{
  input: SubscriptionInfoInput;
}>;


export type GetSubscriptionStoreQuery = { getSubscriptionStore: string };

export type CountryFragment = { id: string, isoCode: string, name: LocalizedString };

export type CountriesQueryVariables = Exact<{
  filter?: InputMaybe<CountryQueryFilter>;
}>;


export type CountriesQuery = { countries?: Array<{ id: string, isoCode: string, name: LocalizedString }> | null };

export type MunicipalityFragment = { id: string, name: string, province: string, postalCode: string, istat: string, cadastralCode: string };

export type MunicipalitiesQueryVariables = Exact<{
  filter?: InputMaybe<MunicipalityQueryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MunicipalitiesQuery = { municipalities?: Array<{ id: string, name: string, province: string, postalCode: string, istat: string, cadastralCode: string }> | null };

export type AddressFragment = { countryId?: string | null, city?: any | null, province?: string | null, postalCode?: string | null, address?: any | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null };

export type CountriesMunicipalitiesQueryVariables = Exact<{
  countryFilter: CountryQueryFilter;
  municipalityFilter: MunicipalityQueryFilter;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CountriesMunicipalitiesQuery = { countries?: Array<{ id: string, isoCode: string, name: LocalizedString }> | null, municipalities?: Array<{ id: string, name: string, province: string, postalCode: string, istat: string, cadastralCode: string }> | null, italy?: Array<{ id: string, isoCode: string, name: LocalizedString }> | null };

export type FiscalGatewayWorkstationFragment = { name: string, workstationID: string, apikey: string };

export type CashDeskTypeFragment = { id: string, code: CashDeskTypeCode, fiscalGatewayWorkstations: Array<{ name: string, workstationID: string, apikey: string }>, auditable: { state: State } };

export type CashDeskTypesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type CashDeskTypesQuery = { cashDeskTypes?: Array<{ id: string, code: CashDeskTypeCode, fiscalGatewayWorkstations: Array<{ name: string, workstationID: string, apikey: string }>, auditable: { state: State } }> | null };

export type CreateFiscalGatewayWorkstationMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  name: Scalars['String'];
  cashDeskTypeId: Scalars['ID'];
}>;


export type CreateFiscalGatewayWorkstationMutation = { createFiscalGatewayWorkstation: { name: string, workstationID: string, apikey: string } };

export type CashDeskFragment = { id: string, hotelDate: Date, cashDeskType: { id: string, code: CashDeskTypeCode, name: string, documentsActive: Array<{ fiscalType: FiscalType }> } };

export type PropertyFiscalConfigurationFragment = { cashDeskTypeIds: Array<string>, resourceTypeIds?: Array<string> | null, name: string };

export type PropertyFiscalConfigurationsFragment = { id: string, fiscalConfigurations?: Array<{ cashDeskTypeIds: Array<string>, resourceTypeIds?: Array<string> | null, name: string }> | null };

export type CashDesksQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  cashDeskId?: InputMaybe<IDFilter>;
  open?: InputMaybe<Scalars['Boolean']>;
}>;


export type CashDesksQuery = { cashDesks?: Array<{ id: string, hotelDate: Date, cashDeskType: { id: string, code: CashDeskTypeCode, name: string, documentsActive: Array<{ fiscalType: FiscalType }> } }> | null, properties?: Array<{ id: string, fiscalConfigurations?: Array<{ cashDeskTypeIds: Array<string>, resourceTypeIds?: Array<string> | null, name: string }> | null }> | null };

export type CervedSubjectFragment = { subject_id?: string | null, subject_type?: string | null, tax_code?: string | null, company_info?: { business_name?: string | null, vat_number?: string | null } | null, person_info?: { first_name?: string | null, last_name?: string | null, name?: string | null } | null, address?: { postal_code?: string | null, street?: { description?: string | null } | null, city?: { istat_code?: string | null, description?: string | null } | null, country?: { isoCode?: string | null } | null, province?: { code?: string | null } | null } | null };

export type CervedAdvancedSearchQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
}>;


export type CervedAdvancedSearchQuery = { cervedAdvancedSearch: { subjects?: Array<{ subject_id?: string | null, subject_type?: string | null, tax_code?: string | null, company_info?: { business_name?: string | null, vat_number?: string | null } | null, person_info?: { first_name?: string | null, last_name?: string | null, name?: string | null } | null, address?: { postal_code?: string | null, street?: { description?: string | null } | null, city?: { istat_code?: string | null, description?: string | null } | null, country?: { isoCode?: string | null } | null, province?: { code?: string | null } | null } | null } | null> | null } };

export type CoProductionAssignedFragment = { id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } };

export type CoReservationFragment = { id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } };

export type CoBillFragment = { id: string, open: boolean, reservedResourceId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null, owner: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } };

export type CoDepositAssignedFragment = { id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number };

export type CoDepositFragment = { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> };

export type CoBillsAndDepositsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  billIds: Array<Scalars['ID']> | Scalars['ID'];
  depositIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CoBillsAndDepositsQuery = { bills?: Array<{ id: string, open: boolean, reservedResourceId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null, owner: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null, documents?: Array<{ id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> }> | null };

export type CoReservationQueryVariables = Exact<{
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type CoReservationQuery = { reservations?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null };

export type CoDocumentDetailFragment = { referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null };

export type CoInfoDocumentDepositAssignedFragment = { id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null };

export type CoDocumentFragment = { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType, currency: Currency, totalAmount: number, unpaidAmount: number, documentType: DocumentType, note?: string | null, customerId: string, cashDeskId: string, auditable: { state: State }, customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }, consolidatedData?: { customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } | null, cashDesk: { id: string, open: boolean, cashDeskTypeId: string }, documentDetails: Array<{ referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null }>, depositAssigneds?: Array<{ id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null }> | null, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActiveId: string, expireDate?: Date | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, paymentActive: { id: string, name: LocalizedString, paymentType: { id: string, code: PaymentTypeCode, sign: AlgebraicSign } } }>, bills?: Array<{ id: string, reservationId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null }> | null, felAdditionalInfo?: { sent: boolean, state?: FelState | null, closed: boolean } | null, scelAdditionalInfo?: { sent: number, note?: string | null } | null, creditNote?: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType } | null, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null };

export type CoDocumentQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
  documentId: Scalars['ID'];
}>;


export type CoDocumentQuery = { documents?: Array<{ id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType, currency: Currency, totalAmount: number, unpaidAmount: number, documentType: DocumentType, note?: string | null, customerId: string, cashDeskId: string, auditable: { state: State }, customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }, consolidatedData?: { customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } | null, cashDesk: { id: string, open: boolean, cashDeskTypeId: string }, documentDetails: Array<{ referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null }>, depositAssigneds?: Array<{ id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null }> | null, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActiveId: string, expireDate?: Date | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, paymentActive: { id: string, name: LocalizedString, paymentType: { id: string, code: PaymentTypeCode, sign: AlgebraicSign } } }>, bills?: Array<{ id: string, reservationId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null }> | null, felAdditionalInfo?: { sent: boolean, state?: FelState | null, closed: boolean } | null, scelAdditionalInfo?: { sent: number, note?: string | null } | null, creditNote?: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType } | null, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null }> | null };

export type CreateCoDocumentMutationVariables = Exact<{
  input: CheckoutDocumentInput;
}>;


export type CreateCoDocumentMutation = { createCheckoutDocument: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType, currency: Currency, totalAmount: number, unpaidAmount: number, documentType: DocumentType, note?: string | null, customerId: string, cashDeskId: string, auditable: { state: State }, customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }, consolidatedData?: { customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } | null, cashDesk: { id: string, open: boolean, cashDeskTypeId: string }, documentDetails: Array<{ referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null }>, depositAssigneds?: Array<{ id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null }> | null, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActiveId: string, expireDate?: Date | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, paymentActive: { id: string, name: LocalizedString, paymentType: { id: string, code: PaymentTypeCode, sign: AlgebraicSign } } }>, bills?: Array<{ id: string, reservationId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null }> | null, felAdditionalInfo?: { sent: boolean, state?: FelState | null, closed: boolean } | null, scelAdditionalInfo?: { sent: number, note?: string | null } | null, creditNote?: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType } | null, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null } };

export type UpdateCoDocumentMutationVariables = Exact<{
  documentId: Scalars['String'];
  input: DocumentInput;
}>;


export type UpdateCoDocumentMutation = { updateDocument: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType, currency: Currency, totalAmount: number, unpaidAmount: number, documentType: DocumentType, note?: string | null, customerId: string, cashDeskId: string, auditable: { state: State }, customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }, consolidatedData?: { customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } | null, cashDesk: { id: string, open: boolean, cashDeskTypeId: string }, documentDetails: Array<{ referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null }>, depositAssigneds?: Array<{ id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null }> | null, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActiveId: string, expireDate?: Date | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, paymentActive: { id: string, name: LocalizedString, paymentType: { id: string, code: PaymentTypeCode, sign: AlgebraicSign } } }>, bills?: Array<{ id: string, reservationId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null }> | null, felAdditionalInfo?: { sent: boolean, state?: FelState | null, closed: boolean } | null, scelAdditionalInfo?: { sent: number, note?: string | null } | null, creditNote?: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType } | null, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null } };

export type UpdateFinalizedDocumentMutationVariables = Exact<{
  documentId: Scalars['String'];
  input: DocumentInput;
}>;


export type UpdateFinalizedDocumentMutation = { updateFinalizedDocument: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType, currency: Currency, totalAmount: number, unpaidAmount: number, documentType: DocumentType, note?: string | null, customerId: string, cashDeskId: string, auditable: { state: State }, customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null }, consolidatedData?: { customer: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } | null, cashDesk: { id: string, open: boolean, cashDeskTypeId: string }, documentDetails: Array<{ referenceDocumentId?: string | null, description: string, amount: number, totalAmount: number, quantity: number, date: Date, billId?: string | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, reference: { accountantCategoryId?: string | null, chargeCategoryId?: string | null }, vat?: { id: string, value: number, code: string } | null }>, depositAssigneds?: Array<{ id: string, documentId?: string | null, amount: number, currency: Currency, document?: { numberExtended: string } | null, reservation?: { id: string, reservationCode: string } | null, reservedResource?: { id: string, resourceOccupancies: Array<{ assignedResourceType: { code?: string | null, customName?: LocalizedString | null, name: { description: LocalizedString } }, resource?: { code: string } | null }> } | null, bill?: { id: string, description: string } | null }> | null, documentPaymentDetails: Array<{ amount: number, referenceDocumentId?: string | null, paymentActiveId: string, expireDate?: Date | null, referenceDocument?: { id: string, numberExtended: string, fiscalType: FiscalType, documentType: DocumentType, depositAssigneds?: Array<{ id: string, documentId?: string | null, billId?: string | null, reservationId?: string | null, reservedResourceId?: string | null, amount: number }> | null, documentDetails: Array<{ reference: { accountantCategory?: { defaultVat: { value: number, description: string } } | null }, vat?: { id: string, value: number, description: string } | null }> } | null, paymentActive: { id: string, name: LocalizedString, paymentType: { id: string, code: PaymentTypeCode, sign: AlgebraicSign } } }>, bills?: Array<{ id: string, reservationId?: Array<string> | null, productions?: Array<{ id: string, billId: string, quota: number, bill: { id: string, reservationId?: Array<string> | null }, production: { id: string, currency: Currency, date: Date, description?: string | null, reservedResourceId?: string | null, total: number, quantity: number, amount: number, chargeCategoryId: string, vatId: string, chargeCategory: { id: string, name: string, stayIncluded: boolean }, reservedResource?: { resourceOccupancies: Array<{ resourceId?: string | null, reservedResourceTypeId: string }> } | null, vat: { id: string, value: number, code: string } } }> | null, reservation?: Array<{ id: string, reservationCode: string, voucher?: string | null, credit: CreditType, reservedResources?: Array<{ id: string, start: Date, end: Date, resourceOccupancies: Array<{ start: Date, end: Date, phase: ReservedResourcePhase, reservedResourceType: { id: string, code?: string | null, customName?: LocalizedString | null, name: { id: string, description: LocalizedString } }, resource?: { id: string, code: string } | null }>, guestOccupancies?: Array<{ phase: ReservedResourcePhase, type: GuestType, start: Date, end: Date, cityTaxExoneration?: CityTaxExonerationCode | null, wciState?: WciState | null, guest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } }> | null }> | null, reference: { agency?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerCompany?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, customerPerson?: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } | null, mainGuest: { id: string, name: any, language: Language, type: CustomerType, fiscalCode?: any | null, vatNumber?: any | null, managementCode?: string | null, dummyCustomer?: boolean | null, company?: { defaultCredit?: CreditType | null, splitPayment: boolean, sdiCode?: string | null } | null, person?: { birthDate?: Date | null, birthAddress?: { address?: any | null, city?: any | null, country?: { id: string, isoCode: string } | null, municipality?: { id: string, name: string } | null } | null } | null, address?: { address?: any | null, city?: any | null, province?: string | null, postalCode?: string | null, municipalityId?: string | null, country?: { id: string, isoCode: string, name: LocalizedString } | null, municipality?: { id: string, name: string } | null } | null, mailContacts?: Array<{ isDefault: boolean, value: string, type: MailContactType, order: number }> | null, phoneContacts?: Array<{ isDefault: boolean, value: string, type: PhoneContactType, order: number }> | null, auditable: { state: State }, tags?: Array<{ id: string, label: string, color: string }> | null } } }> | null }> | null, felAdditionalInfo?: { sent: boolean, state?: FelState | null, closed: boolean } | null, scelAdditionalInfo?: { sent: number, note?: string | null } | null, creditNote?: { id: string, numberExtended: string, documentDate: Date, fiscalType: FiscalType } | null, referenceDocument?: { id: string, numberExtended: string, documentDate: Date } | null } };

export type FinalizeCoDocumentMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  documentId: Scalars['String'];
}>;


export type FinalizeCoDocumentMutation = { finalizeDocument?: any | null };

export type DeleteCoDocumentMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  documentId: Scalars['String'];
}>;


export type DeleteCoDocumentMutation = { deleteDocument?: any | null };

export type UndoCoDocumentMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  documentId: Scalars['String'];
}>;


export type UndoCoDocumentMutation = { undoDocument?: any | null };

export type CreateCreditNoteMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  documentId: Scalars['ID'];
  reverseProduction: Scalars['Boolean'];
}>;


export type CreateCreditNoteMutation = { createCreditNoteDocument: string };

export type CreateCreditNoteForAdvanceMutationVariables = Exact<{
  input: CreditNoteForAdvanceInput;
}>;


export type CreateCreditNoteForAdvanceMutation = { createCreditNoteForAdvance: string };

export type CreateManualDocumentMutationVariables = Exact<{
  input: ManualDocumentInput;
}>;


export type CreateManualDocumentMutation = { createManualDocument: { id: string } };

export type UpdateDepositAssignedsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  depositDocumentId: Scalars['ID'];
  depositAssigneds: Array<UpdateDepositAssigneds> | UpdateDepositAssigneds;
}>;


export type UpdateDepositAssignedsMutation = { updateDepositAssigneds?: any | null };

export type MailContactFragment = { type: MailContactType, value: string, order: number, isDefault: boolean };

export type PhoneContactFragment = { type: PhoneContactType, value: string, order: number, isDefault: boolean };

export type WebContactFragment = { type: WebContactType, value: string, order: number, isDefault: boolean };

export type GooglePlaceFragment = { place_id: string, name: string, geometry: { location: { lat: number, lng: number } } };

export type GooglePlacesFindQueryVariables = Exact<{
  input: GooglePlacesFindInput;
}>;


export type GooglePlacesFindQuery = { googlePlacesFind: { candidates?: Array<{ place_id: string, name: string, geometry: { location: { lat: number, lng: number } } }> | null } };

export type IdentificationDocumentFragment = { id: string, tenantId?: string | null, name: LocalizedString };

export type IdentificationDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentificationDocumentsQuery = { identificationDocuments?: Array<{ id: string, tenantId?: string | null, name: LocalizedString }> | null };

export type PersonIdentificationDocumentFragment = { documentId: string, releaseBy?: string | null, expirationDate: Date, number: any, countryId: string, city?: any | null };

export type PaymentActiveFragment = { id: string, name: LocalizedString, paymentType: { code: PaymentTypeCode, sign: AlgebraicSign }, paymentMethods?: Array<{ gateway?: { type: PaymentGatewayType } | null }> | null };

export type PaymentActivesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  propertyId: Scalars['ID'];
}>;


export type PaymentActivesQuery = { paymentActives: Array<{ id: string, name: LocalizedString, paymentType: { code: PaymentTypeCode, sign: AlgebraicSign }, paymentMethods?: Array<{ gateway?: { type: PaymentGatewayType } | null }> | null }> };

export const CityTaxReportDetailFragmentDoc = gql`
    fragment CityTaxReportDetail on CityTaxReportDetail {
  amount
  currency
  documents {
    to
    from
  }
  payingGuests
  payingNights
  exonerations {
    guests
    nights
    type {
      code
      description
    }
  }
}
    `;
export const FelAdditionalInfoFragmentDoc = gql`
    fragment FelAdditionalInfo on FelAdditionalInfo {
  state
  sent
  closed
  lastError
}
    `;
export const ScelAdditionalInfoFragmentDoc = gql`
    fragment ScelAdditionalInfo on ScelAdditionalInfo {
  sent
  lastError
  state
  canceled
}
    `;
export const UnpaidDocumentReservationFragmentDoc = gql`
    fragment UnpaidDocumentReservation on Reservation {
  id
  voucher
  reservationCode
  reference {
    mainGuest {
      name
    }
  }
}
    `;
export const UnpaidDocumentsFragmentDoc = gql`
    fragment UnpaidDocuments on Document {
  id
  numberExtended
  documentDate
  totalAmount
  unpaidAmount
  residualAmount
  documentPaymentDetails {
    expireDate
    amount
    paymentActiveId
  }
  bills {
    reservation {
      ...UnpaidDocumentReservation
    }
  }
}
    ${UnpaidDocumentReservationFragmentDoc}`;
export const PaidInFullDocumentFragmentDoc = gql`
    fragment PaidInFullDocument on Document {
  id
  numberExtended
  documentDate
  totalAmount
  documentPaymentDetails {
    paymentActiveId
    amount
    referenceDocument {
      id
      numberExtended
      documentDate
    }
  }
  customer {
    id
    name
    type
    fiscalCode
  }
  auditable {
    state
  }
}
    `;
export const DocumentEmailFragmentDoc = gql`
    fragment DocumentEmail on Email {
  id
  messageId
  from
  to
  subject
  emailState
  stateTransaction {
    state
    result
    timestamp
  }
  body
  documents {
    id
    documentType
  }
}
    `;
export const DepositDetailDocumentFragmentDoc = gql`
    fragment DepositDetailDocument on Document {
  id
  numberExtended
  fiscalType
  documentDate
  totalAmount
  residualAmount
  currency
}
    `;
export const PropertyCityTaxConfigurationFragmentDoc = gql`
    fragment PropertyCityTaxConfiguration on CityTaxConfiguration {
  configurations {
    genericConfiguration {
      exonerations {
        code
        description
        extCode
        discount
      }
      maxNights
      minAge
      amountType
    }
  }
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  countryId
  city
  province
  postalCode
  address
  municipalityId
  country {
    id
    isoCode
    name
  }
  municipality {
    id
    name
  }
}
    `;
export const PhoneContactFragmentDoc = gql`
    fragment PhoneContact on PhoneContact {
  type
  value
  order
  isDefault
}
    `;
export const MailContactFragmentDoc = gql`
    fragment MailContact on MailContact {
  type
  value
  order
  isDefault
}
    `;
export const WebContactFragmentDoc = gql`
    fragment WebContact on WebContact {
  type
  value
  order
  isDefault
}
    `;
export const InnerPropertyFragmentDoc = gql`
    fragment InnerProperty on Property {
  id
  tenantId
  type
  parentPropertyId
  fiscalConfigurations {
    felConfiguration {
      taxSystem
    }
    resourceTypeIds
  }
  cityTaxConfiguration {
    ...PropertyCityTaxConfiguration
  }
  name
  description
  classTypeId
  categoryId
  vatNumber
  fiscalCode
  placeId
  address {
    ...Address
    coordinates
    country {
      isoCode
    }
    municipality {
      name
    }
  }
  phoneContacts {
    ...PhoneContact
  }
  mailContacts {
    ...MailContact
  }
  webContacts {
    ...WebContact
  }
  ibeCode
  checkout {
    from
    to
  }
  checkin {
    to
    from
  }
  subAddresses {
    name
    description
    classTypeId
    categoryId
    placeId
    resourceTypeIds
    ibeCode
    address {
      ...Address
      coordinates
      country {
        isoCode
      }
      municipality {
        name
      }
    }
    phoneContacts {
      ...PhoneContact
    }
    mailContacts {
      ...MailContact
    }
    webContacts {
      ...WebContact
    }
    checkout {
      from
      to
    }
    checkin {
      to
      from
    }
  }
}
    ${PropertyCityTaxConfigurationFragmentDoc}
${AddressFragmentDoc}
${PhoneContactFragmentDoc}
${MailContactFragmentDoc}
${WebContactFragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment Property on Property {
  ...InnerProperty
  subProperties {
    ...InnerProperty
  }
}
    ${InnerPropertyFragmentDoc}`;
export const PropertyClassTypeFragmentDoc = gql`
    fragment PropertyClassType on Taxonomy {
  id
  description
  order
}
    `;
export const PropertyCategoryFragmentDoc = gql`
    fragment PropertyCategory on Taxonomy {
  id
  description
  parentId
  order
}
    `;
export const AuditFragmentDoc = gql`
    fragment Audit on Audit {
  id
  operationName
  timestamp
  modifiedBy
  operation
  changes
  entityId
  entityName
  correlationId
}
    `;
export const ChargeCategoryAuditFragmentDoc = gql`
    fragment ChargeCategoryAudit on ChargeCategory {
  id
  name
}
    `;
export const VatAuditFragmentDoc = gql`
    fragment VatAudit on Vat {
  id
  description
  value
}
    `;
export const ReservedResourceAuditFragmentDoc = gql`
    fragment ReservedResourceAudit on ReservedResource {
  resourceOccupancies {
    reservedResourceType {
      code
      name {
        description
      }
      customName
    }
    resource {
      code
    }
    end
    start
  }
  reservation {
    reservationCode
    id
  }
}
    `;
export const ResourceTypeAuditFragmentDoc = gql`
    fragment ResourceTypeAudit on ResourceType {
  id
  code
  customName
  name {
    description
  }
  resources {
    id
    code
  }
}
    `;
export const ResourceOccupancyBillPageFragmentDoc = gql`
    fragment ResourceOccupancyBillPage on ResourceOccupancy {
  start
  end
  phase
  reservedResourceTypeId
  resourceId
}
    `;
export const ReservedResourceBillPageFragmentDoc = gql`
    fragment ReservedResourceBillPage on ReservedResource {
  id
  start
  end
  resourceOccupancies {
    ...ResourceOccupancyBillPage
  }
  reservationId
}
    ${ResourceOccupancyBillPageFragmentDoc}`;
export const ProductionBillPageFragmentDoc = gql`
    fragment ProductionBillPage on Production {
  id
  currency
  amount
  quantity
  total
  date
  chargeCategoryId
  vatId
  description
  cityTax {
    guestId
    exoneration
  }
  reservedResource {
    ...ReservedResourceBillPage
  }
}
    ${ReservedResourceBillPageFragmentDoc}`;
export const ProductionAssignedBillPageFragmentDoc = gql`
    fragment ProductionAssignedBillPage on ProductionAssigned {
  id
  quota
  billId
  production {
    ...ProductionBillPage
  }
}
    ${ProductionBillPageFragmentDoc}`;
export const BillPageFragmentDoc = gql`
    fragment BillPage on Bill {
  id
  open
  auditable {
    createdOn
  }
  reservationId
  open
  reservation {
    id
    reservationCode
    isGroup
    group
    reservedResources {
      start
      end
    }
  }
  reservedResourceId
  productions {
    ...ProductionAssignedBillPage
  }
  description
  documentId
  category
  ownerId
  searchInfo {
    ownerName
    resources
    guestNames
  }
}
    ${ProductionAssignedBillPageFragmentDoc}`;
export const ChargeCategoryBillPageFragmentDoc = gql`
    fragment ChargeCategoryBillPage on ChargeCategory {
  id
  name
  cityTax
  stayIncluded
}
    `;
export const VatBillPageFragmentDoc = gql`
    fragment VatBillPage on Vat {
  id
  code
  value
}
    `;
export const ResourceTypeBillPageFragmentDoc = gql`
    fragment ResourceTypeBillPage on ResourceType {
  id
  name {
    description
  }
  code
  customName
}
    `;
export const ResourceBillPageFragmentDoc = gql`
    fragment ResourceBillPage on Resource {
  id
  code
}
    `;
export const DatiDocumentiCorrelatiFragmentDoc = gql`
    fragment DatiDocumentiCorrelati on DatiDocumentiCorrelati {
  idDocumento
  data
  commessa
  codiceCIG
  codiceCUP
}
    `;
export const CustomFieldsFragmentDoc = gql`
    fragment CustomFields on FelCustomFields {
  bolloVirtuale
  datiOrdineAcquisto {
    ...DatiDocumentiCorrelati
  }
  datiContratto {
    ...DatiDocumentiCorrelati
  }
  datiConvenzione {
    ...DatiDocumentiCorrelati
  }
  datiFattureCollegate {
    ...DatiDocumentiCorrelati
  }
  datiRicezione {
    ...DatiDocumentiCorrelati
  }
}
    ${DatiDocumentiCorrelatiFragmentDoc}`;
export const DocumentsListFragmentDoc = gql`
    fragment DocumentsList on Document {
  id
  fiscalType
  currency
  numberExtended
  number
  consolidatedData {
    customer {
      id
      name
      type
      fiscalCode
      vatNumber
    }
  }
  customer {
    id
    name
    type
    fiscalCode
    vatNumber
  }
  documentDate
  totalAmount
  netAmount
  vatAmount
  unpaidAmount
  felAdditionalInfo {
    state
    sent
    closed
    lastError
    customFields {
      ...CustomFields
    }
  }
  scelAdditionalInfo {
    sent
    lastError
    state
    canceled
  }
  cashDesk {
    cashDeskTypeId
  }
  auditable {
    state
  }
  documentPaymentDetails {
    amount
    referenceDocumentId
    paymentActive {
      paymentType {
        sign
      }
      name
    }
  }
}
    ${CustomFieldsFragmentDoc}`;
export const BillListProductionItemFragmentDoc = gql`
    fragment BillListProductionItem on Production {
  id
  date
  hotelDate
  chargeCategoryId
  chargeCategory {
    name
  }
  currency
  description
  quantity
  amount
  total
  vatId
  vat {
    code
    value
  }
  manual
  reservedResourceId
  reservedResource {
    guestOccupancies {
      start
      end
      guest {
        name
      }
    }
    resourceOccupancies {
      resource {
        code
        resourceType {
          code
          customName
          name {
            description
          }
        }
      }
    }
    reservation {
      reservationCode
    }
  }
  cityTax {
    guestId
    exoneration
  }
}
    `;
export const BillListItemFragmentDoc = gql`
    fragment BillListItem on Bill {
  id
  tenantId
  propertyId
  ownerId
  documentId
  document {
    ...DocumentsList
    numberExtended
  }
  searchInfo {
    ownerName
    resources
    guestNames
  }
  owner {
    id
    name
    type
  }
  open
  description
  category
  auditable {
    createdOn
  }
  reservation {
    reservationCode
    reservedResources {
      id
    }
  }
  reservationId
  reservedResourceId
  reservedResource {
    end
    start
  }
  productions {
    id
    quota
    production {
      ...BillListProductionItem
    }
  }
}
    ${DocumentsListFragmentDoc}
${BillListProductionItemFragmentDoc}`;
export const BillItemReservedResourceFragmentDoc = gql`
    fragment BillItemReservedResource on ReservedResource {
  start
  end
}
    `;
export const BillItemFragmentDoc = gql`
    fragment BillItem on Bill {
  id
  tenantId
  propertyId
  description
  category
  searchInfo {
    ownerName
    resources
    guestNames
  }
  ownerId
  owner {
    name
  }
  reservationId
  reservation {
    reservationCode
    reservationState {
      noshow
    }
  }
  reservedResourceId
  reservedResource {
    ...BillItemReservedResource
  }
  auditable {
    createdOn
  }
}
    ${BillItemReservedResourceFragmentDoc}`;
export const ProductionFragmentDoc = gql`
    fragment Production on Production {
  id
  currency
  amount
  quantity
  total
  date
  chargeCategory {
    id
    name
    cityTax
    stayIncluded
  }
  vat {
    id
    value
    code
  }
  reservedResource {
    id
    reservationId
    resourceOccupancies {
      start
      end
      phase
      reservedResourceType {
        name {
          description
        }
        code
        customName
      }
      resource {
        id
        code
      }
    }
  }
  description
  cityTax {
    guestId
    exoneration
  }
}
    `;
export const ProductionAssignedFragmentDoc = gql`
    fragment ProductionAssigned on ProductionAssigned {
  id
  quota
  billId
  production {
    ...Production
  }
}
    ${ProductionFragmentDoc}`;
export const DepositAssignedFragmentDoc = gql`
    fragment DepositAssigned on DepositAssigned {
  id
  reservationId
  reservedResourceId
  billId
  documentId
  amount
}
    `;
export const ReservationBillDocumentFragmentDoc = gql`
    fragment ReservationBillDocument on Document {
  id
  numberExtended
  fiscalType
  totalAmount
  documentDate
  depositAssigneds {
    ...DepositAssigned
  }
  customer {
    id
    name
    type
    fiscalCode
  }
  creditNote {
    id
    numberExtended
    fiscalType
    totalAmount
    documentDate
    depositAssigneds {
      ...DepositAssigned
    }
    customer {
      name
      type
      fiscalCode
    }
  }
}
    ${DepositAssignedFragmentDoc}`;
export const ReservationBillFragmentDoc = gql`
    fragment ReservationBill on Bill {
  id
  reservationId
  open
  auditable {
    createdOn
  }
  owner {
    id
    name
    type
  }
  reservedResourceId
  reservedResource {
    id
    end
    start
    resourceOccupancies {
      start
      end
      phase
      reservedResourceType {
        id
        code
        customName
        name {
          id
          description
        }
      }
      resource {
        id
        code
      }
    }
  }
  productions {
    ...ProductionAssigned
  }
  description
  document {
    ...ReservationBillDocument
  }
  category
  searchInfo {
    ownerName
    resources
    guestNames
  }
}
    ${ProductionAssignedFragmentDoc}
${ReservationBillDocumentFragmentDoc}`;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  label
  color
}
    `;
export const PlaningGuestOccupancyFragmentDoc = gql`
    fragment PlaningGuestOccupancy on GuestOccupancy {
  type
  guest {
    id
    name
    tags {
      ...Tag
    }
  }
  phase
}
    ${TagFragmentDoc}`;
export const PlanningReservationFragmentDoc = gql`
    fragment PlanningReservation on Reservation {
  id
  reservationState {
    confirmed
    canceled
    noshow
    optioned
  }
  reference {
    mainGuest {
      name
      tags {
        id
        color
        label
      }
    }
    customerCompany {
      name
      tags {
        id
        color
        label
      }
    }
  }
  portalInfo {
    portal {
      name
    }
  }
  voucher
  reservationCode
  notes {
    description
  }
  credit
  isGroup
  group
  origin {
    id
    name
  }
  tags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const PlanningReservedResourceFragmentDoc = gql`
    fragment PlanningReservedResource on ReservedResource {
  id
  start
  end
  time {
    from
    to
  }
  phase
  adults
  children
  policy {
    name
  }
  chargeCategory {
    name
  }
  reservation {
    ...PlanningReservation
  }
  resourceOccupancies {
    start
    end
    reservedResourceType {
      id
      code
    }
    assignedResourceType {
      id
      code
    }
    resource {
      id
      code
    }
    commitments {
      resourceTypeId
      resourcesId
      quantity
    }
  }
  guestOccupancies {
    guest {
      name
    }
    phase
  }
}
    ${PlanningReservationFragmentDoc}`;
export const PlanningReservedResourceDetailsFragmentDoc = gql`
    fragment PlanningReservedResourceDetails on ReservedResource {
  additionalServices {
    additionalService {
      id
    }
    quantity
  }
  adults
  chargeCategoryId
  childOccupancies {
    childId
    quantity
  }
  children
  guestOccupancies {
    wciState
    type
    start
    phase
    guestId
    end
    cityTaxExoneration
  }
  manualPrice
  manualDailyPrices {
    day
    price
  }
  dailyPricesStored {
    dailyPrices {
      day
      price
    }
  }
  rateId
  reservationId
  resourceOccupancies {
    end
    resourceId
    reservedResourceTypeId
    assignedResourceTypeId
    start
    commitments {
      resourceTypeId
      resourcesId
    }
  }
  productions {
    currency
    total
    date
    chargeCategory {
      stayIncluded
    }
  }
  start
  end
  phase
}
    `;
export const ResourceLayoutFragmentDoc = gql`
    fragment ResourceLayout on ResourceLayout {
  id
  occupation
  description
}
    `;
export const ResourceUnavailabilityFragmentDoc = gql`
    fragment ResourceUnavailability on ResourceUnavailability {
  id
  name
  start
  end
  note
}
    `;
export const ResourceForPlanningFragmentDoc = gql`
    fragment ResourceForPlanning on Resource {
  id
  code
  position {
    name
  }
  layout {
    ...ResourceLayout
  }
  cleaningState
  unavailabilities {
    ...ResourceUnavailability
  }
  roomTetrisOrder
}
    ${ResourceLayoutFragmentDoc}
${ResourceUnavailabilityFragmentDoc}`;
export const ResourceTimeConfigurationFragmentDoc = gql`
    fragment ResourceTimeConfiguration on TimeConfiguration {
  activity {
    from
    to
  }
  unitOfMeasurement
}
    `;
export const ResourceTypeForPlanningFragmentDoc = gql`
    fragment ResourceTypeForPlanning on ResourceType {
  id
  code
  name {
    type
    description
  }
  customName
  tenantId
  propertyId
  inventory
  configurationsLayout {
    ...ResourceLayout
  }
  resources {
    ...ResourceForPlanning
  }
  logicalType
  timeConfiguration {
    ...ResourceTimeConfiguration
  }
}
    ${ResourceLayoutFragmentDoc}
${ResourceForPlanningFragmentDoc}
${ResourceTimeConfigurationFragmentDoc}`;
export const PlanningReservationInfoDataFragmentDoc = gql`
    fragment PlanningReservationInfoData on Reservation {
  id
  reservedResources {
    id
    phase
    guestOccupancies {
      wciState
    }
    productions {
      total
      bills {
        bill {
          reservationId
          id
          open
        }
      }
    }
  }
}
    `;
export const PlanningReservationDepositInfoDataFragmentDoc = gql`
    fragment PlanningReservationDepositInfoData on Document {
  id
  residualAmount
}
    `;
export const PriceCalendarDayAvailabilityFragmentDoc = gql`
    fragment PriceCalendarDayAvailability on PriceCalendarDayAvailability {
  availability
  resourceTypeId
  stopSellOTA
  onlineLimit
}
    `;
export const PriceCalendarDayRateFragmentDoc = gql`
    fragment PriceCalendarDayRate on PriceCalendarDayRate {
  rateId
  bookingPolicyId
  stopSellResourcesTypeId
  closeChargesCategoryId
  currency
  chargesRate {
    priceType
    chargeCategoryId
    resourceTypeId
    price
    minStay
    closedToArrival
    closedToDeparture
    rulesForDifferentOccupation {
      occupancy
      variation
      type
      value
    }
    priceForDifferentOccupation {
      occupation
      price
    }
  }
}
    `;
export const PriceCalendarDayFragmentDoc = gql`
    fragment PriceCalendarDay on PriceCalendarDay {
  id
  day
  availabilities {
    ...PriceCalendarDayAvailability
  }
  rates {
    ...PriceCalendarDayRate
  }
}
    ${PriceCalendarDayAvailabilityFragmentDoc}
${PriceCalendarDayRateFragmentDoc}`;
export const IstatDataFragmentDoc = gql`
    fragment IstatData on IstatDailyData {
  date
  property {
    availableRooms
    availableBeds
    occupiedRooms
  }
  guests {
    phases {
      checkin
      checkout
      stay
    }
    municipality {
      name
      isoCode
    }
    country {
      name
      isoCode
    }
  }
}
    `;
export const GuestAddressFragmentDoc = gql`
    fragment GuestAddress on Address {
  address
  country {
    id
    isoCode
    name
  }
  city
  province
  postalCode
  municipalityId
  municipality {
    id
    name
  }
}
    `;
export const GuestFragmentDoc = gql`
    fragment Guest on Customer {
  id
  type
  name
  firstName
  lastName
  language
  address {
    ...GuestAddress
  }
  person {
    gender
    birthDate
    birthAddress {
      ...GuestAddress
    }
    identificationDocument {
      documentId
      number
      city
      expirationDate
      countryId
    }
    nationalityId
  }
  auditable {
    state
  }
  phoneContacts {
    isDefault
    order
    value
    type
  }
  mailContacts {
    isDefault
    order
    value
    type
  }
  cityTax {
    exoneration
  }
}
    ${GuestAddressFragmentDoc}`;
export const PsErrorFragmentDoc = gql`
    fragment PsError on PsError {
  message
  details
  code
}
    `;
export const PsRegistrationDataFragmentDoc = gql`
    fragment PsRegistrationData on ReservedResource {
  id
  reservationId
  reservation {
    reservationState {
      noshow
      canceled
    }
  }
  guestOccupancies {
    phase
    type
    checkout
    checkin
    start
    end
    cityTaxExoneration
    guest {
      ...Guest
    }
    psSent {
      success
      timestamp
      lastError {
        ...PsError
      }
    }
  }
  resourceOccupancies {
    assignedResourceType {
      customName
      description
    }
  }
}
    ${GuestFragmentDoc}
${PsErrorFragmentDoc}`;
export const IstatErrorFragmentDoc = gql`
    fragment IstatError on IstatError {
  configurationName
  date
  message
  messageFromSystem
}
    `;
export const RegistrationFileFragmentDoc = gql`
    fragment RegistrationFile on File {
  key
  URL
  filename
  mimeType
}
    `;
export const BookingPolicyReservationFragmentDoc = gql`
    fragment BookingPolicyReservation on BookingPolicy {
  additionalNote
  cancellationPolicy {
    daysWithoutPenalties
    hourWithoutPenalties
    penaltyType
    percentage
    type
  }
  name
  noShowRule {
    percentage
    type
  }
  paymentRule {
    guaranteedCreditCard
    installments {
      dayFromCheckin
      order
      value
    }
    paymentsAcceptedId
    percentage
    type
  }
}
    `;
export const AdditionalServiceFragmentDoc = gql`
    fragment AdditionalService on AdditionalService {
  id
  tenantId
  propertyId
  chargeCategoryId
  chargeCategory {
    name
  }
  name
  description
  validity {
    start
    end
  }
  minStay
  pricingType
  currency
  price
  excludeCheckout
  excludeCheckin
  automaticForChildren
  automaticForAdults
  childServicePrices {
    childId
    price
  }
  availabilityConfig {
    resourceTypeId
    resourceType {
      name {
        description
      }
      customName
      code
    }
    time {
      from
      to
    }
    entireStay
  }
  auditable {
    state
  }
}
    `;
export const ReservationRatesFragmentDoc = gql`
    fragment ReservationRates on RqOutput {
  id
  resources {
    availability
    inventory
    dailyAvailability {
      availability
      day
    }
    resourceType {
      id
      description
      code
      persons
      additionalPersons
      inventory
      rackRate
      currency
      customName
      maxAdults
      name {
        description
      }
      timeConfiguration {
        activity {
          from
          to
        }
        unitOfMeasurement
      }
    }
  }
  rates {
    bookingPolicyOverrideId
    bookingPolicyOverride {
      ...BookingPolicyReservation
    }
    rate {
      mandatoryAdditionalServices {
        priceZero
        additionalService {
          ...AdditionalService
        }
      }
      id
      name
      chargeCategoryId
      minStay
      maxStay
      minAdvance
      maxAdvance
      affiliatedCompaniesId
      bookingPolicy {
        ...BookingPolicyReservation
      }
      closeToArrival
      closeToDeparture
      childRule {
        rule
        childDiscount {
          percentage
          child {
            id
            noOccupancy
            taxonomy {
              description
            }
            auditable {
              state
            }
          }
        }
      }
    }
    restrictionsNotMet
    resourceRates {
      dailyPrice {
        price
        day
        restriction
      }
      bookable
      restrictionsNotMet
      resourceTypeId
      resourceType {
        maxAdults
        persons
      }
      chargeCategoryId
      chargeCategory {
        name
        stayIncluded
        breakfastIncluded
        lunchIncluded
        dinnerIncluded
        defaultVatId
      }
    }
  }
}
    ${BookingPolicyReservationFragmentDoc}
${AdditionalServiceFragmentDoc}`;
export const OriginFragmentDoc = gql`
    fragment Origin on Origin {
  id
  name
  pms
}
    `;
export const ReservationInputFragmentDoc = gql`
    fragment ReservationInput on Reservation {
  id
  reference {
    customerPersonId
    customerCompanyId
    mainGuestId
  }
  reservedResources {
    end
    start
    rateId
    chargeCategoryId
  }
  notes {
    description
  }
  group
  disableAutomation
}
    `;
export const DepositDocumentFragmentDoc = gql`
    fragment DepositDocument on Document {
  id
  numberExtended
  fiscalType
  totalAmount
  residualAmount
  documentDate
  documentPaymentDetails {
    paymentActive {
      name
    }
  }
  depositAssigneds {
    ...DepositAssigned
  }
  customer {
    name
    type
    fiscalCode
  }
}
    ${DepositAssignedFragmentDoc}`;
export const ProductionDetailItemFragmentDoc = gql`
    fragment ProductionDetailItem on Production {
  id
  date
  description
  quantity
  amount
  total
  currency
  chargeCategory {
    name
  }
  bills {
    quota
    bill {
      id
      description
      reservation {
        id
        reservationCode
      }
    }
  }
}
    `;
export const ReservedResourceProductionDetailItemFragmentDoc = gql`
    fragment ReservedResourceProductionDetailItem on ReservedResource {
  productions {
    ...ProductionDetailItem
  }
}
    ${ProductionDetailItemFragmentDoc}`;
export const ReservationListFragmentDoc = gql`
    fragment ReservationList on Reservation {
  id
  reservationCode
  reservationState {
    name
    icon
    color
  }
  reference {
    mainGuest {
      name
    }
  }
  origin {
    name
  }
  reservedResources {
    adults
    children
    start
    end
    chargeCategory {
      name
    }
  }
  notes {
    type
    description
  }
}
    `;
export const reservationSearchFragmentDoc = gql`
    fragment reservationSearch on ReservationQueryOutput {
  id
  reservationCode
  mainGuest
  company
  start
  end
  reservationState
  resources
  canceledOn
  createdOn
  group
  isGroup
  originId
  portalId
  optionExpiration
}
    `;
export const UsedPortalFragmentDoc = gql`
    fragment UsedPortal on Portal {
  id
  name
  commercialName
}
    `;
export const TsPayChargeFragmentDoc = gql`
    fragment TsPayCharge on TsPayCharge {
  id
  chargeKey
  state
  refundReason
  amount
  amountPreauth
  netAmount
  currency
  error {
    message
    errorType
  }
  auditable {
    modifiedOn
    state
  }
  link {
    auditable {
      modifiedOn
    }
  }
}
    `;
export const PortalInfoFragmentDoc = gql`
    fragment PortalInfo on PortalInfo {
  portal {
    name
  }
  payment {
    amount
    currency
    commissionModel
    paymentMethod
    paymentCard {
      cardActivationDate
    }
  }
  commission
  portalCityTaxExoneration
}
    `;
export const ResourceTypeFragmentFragmentDoc = gql`
    fragment ResourceTypeFragment on ResourceType {
  id
  name {
    description
  }
  code
  customName
  description
  persons
  additionalPersons
  maxAdults
  configurationsLayout {
    ...ResourceLayout
  }
  timeConfiguration {
    activity {
      from
      to
    }
    unitOfMeasurement
  }
}
    ${ResourceLayoutFragmentDoc}`;
export const ResourceOccupancyFragmentDoc = gql`
    fragment ResourceOccupancy on ResourceOccupancy {
  start
  end
  phase
  reservedResourceType {
    ...ResourceTypeFragment
  }
  reservedResourceLayoutId
  assignedResourceType {
    ...ResourceTypeFragment
  }
  resource {
    id
    code
  }
}
    ${ResourceTypeFragmentFragmentDoc}`;
export const GuestOccupancyFragmentDoc = gql`
    fragment GuestOccupancy on GuestOccupancy {
  phase
  type
  start
  end
  cityTaxExoneration
  wciState
  checkin
  checkout
  guest {
    ...Guest
  }
}
    ${GuestFragmentDoc}`;
export const ReservedResourceFragmentDoc = gql`
    fragment ReservedResource on ReservedResource {
  id
  propertyId
  reservationId
  additionalServices {
    additionalService {
      id
    }
    quantity
  }
  chargeCategory {
    id
    code
    name
  }
  chargeCategories {
    chargeCategoryId
    day
  }
  start
  end
  resourceOccupancies {
    ...ResourceOccupancy
  }
  phase
  adults
  children
  rate {
    id
    name
    chargesRate {
      chargeCategoryId
    }
    childRule {
      childDiscount {
        child {
          id
          taxonomy {
            description
          }
          noOccupancy
          auditable {
            state
          }
        }
      }
    }
  }
  productions {
    currency
    amount
    chargeCategory {
      stayIncluded
    }
    hotelDate
    chargeCategoryId
    currency
    date
    description
    id
    quantity
    total
    vatId
    bills {
      billId
    }
  }
  guestOccupancies {
    ...GuestOccupancy
  }
  childOccupancies {
    child {
      id
      noOccupancy
      minAge
      maxAge
    }
    quantity
  }
  dailyPricesStored {
    dailyPrices {
      day
      price
    }
  }
  manualDailyPrices {
    day
    price
  }
  manualPrice
  policy {
    additionalNote
    cancellationPolicy {
      daysWithoutPenalties
      hourWithoutPenalties
      penaltyType
      percentage
      type
    }
    name
    noShowRule {
      type
      percentage
    }
    paymentRule {
      guaranteedCreditCard
      installments {
        dayFromCheckin
        order
        value
      }
      paymentsAcceptedId
      percentage
      type
    }
  }
  time {
    from
    to
  }
}
    ${ResourceOccupancyFragmentDoc}
${GuestOccupancyFragmentDoc}`;
export const ReferenceCustomerFragmentDoc = gql`
    fragment ReferenceCustomer on Customer {
  id
  name
  language
  company {
    defaultCredit
    splitPayment
    sdiCode
  }
  person {
    birthDate
    birthAddress {
      address
      country {
        id
        isoCode
      }
      city
      municipality {
        id
        name
      }
    }
  }
  address {
    address
    country {
      id
      isoCode
      name
    }
    city
    province
    postalCode
    municipalityId
    municipality {
      id
      name
    }
  }
  type
  fiscalCode
  vatNumber
  mailContacts {
    isDefault
    value
    type
    order
  }
  phoneContacts {
    isDefault
    value
    type
    order
  }
  auditable {
    state
  }
  tags {
    ...Tag
  }
  managementCode
  dummyCustomer
}
    ${TagFragmentDoc}`;
export const NoteFragmentDoc = gql`
    fragment Note on Note {
  type
  description
}
    `;
export const ReservationStateFragmentDoc = gql`
    fragment ReservationState on ReservationState {
  id
  name
  icon
  color
  order
  confirmed
  optioned
  canceled
  noshow
}
    `;
export const ReservationBookingPolicyFragmentDoc = gql`
    fragment ReservationBookingPolicy on ReservationBookingPolicy {
  paymentRule {
    guaranteedCreditCard
    type
  }
  noShowRule {
    percentage
    type
  }
  cancellationPolicy {
    daysWithoutPenalties
    hourWithoutPenalties
    penaltyType
    percentage
    type
  }
  name
  additionalNote
}
    `;
export const TsPayLinkFragmentDoc = gql`
    fragment TsPayLink on TsPayLink {
  id
  generateDocument
  documentId
  cardInfo
  type
  currency
  amount
  auditable {
    createdOn
    modifiedOn
    state
  }
  charges {
    state
    error {
      message
      errorType
    }
    auditable {
      modifiedOn
    }
    amount
  }
}
    `;
export const ReservationFileFragmentDoc = gql`
    fragment ReservationFile on File {
  id
  URL
  filename
  mimeType
  auditable {
    createdOn
  }
}
    `;
export const ReservationDetailFragmentDoc = gql`
    fragment ReservationDetail on Reservation {
  id
  credit
  tenantId
  propertyId
  portalInfo {
    ...PortalInfo
  }
  reservationCode
  reservedResources {
    ...ReservedResource
  }
  isGroup
  group
  paOrder
  paCIG
  disableAutomation
  reference {
    agency {
      ...ReferenceCustomer
    }
    customerCompany {
      ...ReferenceCustomer
    }
    customerPerson {
      ...ReferenceCustomer
    }
    mainGuest {
      ...ReferenceCustomer
    }
  }
  origin {
    id
    name
  }
  voucher
  auditable {
    createdOn
  }
  notes {
    ...Note
  }
  reservationState {
    ...ReservationState
  }
  optionExpiration
  policy {
    ...ReservationBookingPolicy
  }
  tsPayLinks {
    ...TsPayLink
  }
  files {
    ...ReservationFile
  }
}
    ${PortalInfoFragmentDoc}
${ReservedResourceFragmentDoc}
${ReferenceCustomerFragmentDoc}
${NoteFragmentDoc}
${ReservationStateFragmentDoc}
${ReservationBookingPolicyFragmentDoc}
${TsPayLinkFragmentDoc}
${ReservationFileFragmentDoc}`;
export const CityTaxExonerationFragmentDoc = gql`
    fragment CityTaxExoneration on CityTaxExoneration {
  code
  description
  discount
}
    `;
export const EmailFragmentDoc = gql`
    fragment Email on Email {
  id
  to
  subject
  stateTransaction {
    state
    timestamp
    result
  }
  emailState
  body
}
    `;
export const ReservationSearchWithRRFragmentDoc = gql`
    fragment ReservationSearchWithRR on ReservationQueryOutput {
  id
  reservationCode
  mainGuest
  company
  start
  end
  reservationState
  resources
  canceledOn
  createdOn
  group
  isGroup
  originId
  portalId
  optionExpiration
  reservedResources {
    id
    guestOccupancies {
      guest {
        id
        name
      }
    }
    resourceOccupancies {
      assignedResourceType {
        id
        code
        customName
        name {
          description
        }
      }
      resource {
        id
        code
      }
    }
  }
}
    `;
export const CustomerListFragmentDoc = gql`
    fragment CustomerList on Customer {
  id
  type
  name
  mailContacts {
    ...MailContact
  }
  phoneContacts {
    ...PhoneContact
  }
  address {
    ...Address
    country {
      isoCode
    }
    municipality {
      name
    }
  }
  fiscalCode
  vatNumber
  privacy {
    marketingConsent
    marketingConsentDate
    managementConsent
    managementConsentDate
    dataThirdPartyConsent
    dataThirdPartyConsentDate
  }
  person {
    birthDate
  }
  company {
    splitPayment
  }
}
    ${MailContactFragmentDoc}
${PhoneContactFragmentDoc}
${AddressFragmentDoc}`;
export const PersonIdentificationDocumentFragmentDoc = gql`
    fragment PersonIdentificationDocument on PersonIdentificationDocument {
  documentId
  releaseBy
  expirationDate
  number
  countryId
  city
}
    `;
export const CustomerDetailFragmentDoc = gql`
    fragment CustomerDetail on Customer {
  id
  type
  name
  mailContacts {
    ...MailContact
  }
  phoneContacts {
    ...PhoneContact
  }
  address {
    ...Address
    country {
      isoCode
    }
    municipality {
      name
    }
  }
  fiscalCode
  vatNumber
  stayVatId
  privacy {
    marketingConsent
    marketingConsentDate
    managementConsent
    managementConsentDate
    dataThirdPartyConsent
    dataThirdPartyConsentDate
    profiledMarketingConsent
    profiledMarketingConsentDate
    log {
      ip
      platform
      timestamp
      userAgent
    }
  }
  firstName
  lastName
  mailContacts {
    ...MailContact
  }
  phoneContacts {
    ...PhoneContact
  }
  webContacts {
    ...WebContact
  }
  language
  tenantId
  company {
    physicalPerson
    sdiCode
  }
  person {
    gender
    birthDate
    birthAddress {
      ...Address
    }
    identificationDocument {
      ...PersonIdentificationDocument
    }
    nationalityId
  }
  fiscalCode
  vatNumber
  tagsId
  auditable {
    state
  }
  company {
    defaultCredit
    splitPayment
    felOptions {
      riferimentoAmministrazione
    }
  }
  cityTax {
    contracts {
      start
      end
    }
    exoneration
  }
  relatedCompanyId
}
    ${MailContactFragmentDoc}
${PhoneContactFragmentDoc}
${AddressFragmentDoc}
${WebContactFragmentDoc}
${PersonIdentificationDocumentFragmentDoc}`;
export const SimpleCustomerLookupFragmentDoc = gql`
    fragment SimpleCustomerLookup on Customer {
  id
  name
  firstName
  lastName
  type
  language
  phoneContacts {
    isDefault
    value
  }
  mailContacts {
    isDefault
    value
  }
  address {
    country {
      isoCode
    }
    municipality {
      name
    }
    city
    address
  }
  mailContacts {
    isDefault
    value
    type
    order
  }
  phoneContacts {
    isDefault
    value
    type
    order
  }
  person {
    birthDate
    birthAddress {
      country {
        isoCode
      }
      municipality {
        name
      }
      city
    }
  }
  company {
    defaultCredit
  }
  tags {
    id
    label
    color
  }
  relatedCompanyId
  relatedCompany {
    name
  }
}
    `;
export const DailyClosureAuditFragmentDoc = gql`
    fragment DailyClosureAudit on DailyClosureAudit {
  id
  tenantId
  propertyId
  procedureName
  executionDate
  executedBy
  duration
  manualExecution
  result
  message
  fileIds
  configurationName
  referenceDate
}
    `;
export const DashboardKpiRowFragmentDoc = gql`
    fragment DashboardKpiRow on DashboardKpiRow {
  current
  total
  moreData
}
    `;
export const DashboardReceptionFragmentDoc = gql`
    fragment DashboardReception on DashboardReceptionQueryOutput {
  departures {
    ...DashboardKpiRow
  }
  arrivals {
    ...DashboardKpiRow
  }
  occupancy {
    ...DashboardKpiRow
  }
  availability {
    ...DashboardKpiRow
  }
}
    ${DashboardKpiRowFragmentDoc}`;
export const DashboardMealsFragmentDoc = gql`
    fragment DashboardMeals on DashboardMealsQueryOutput {
  breakfasts {
    ...DashboardKpiRow
  }
  lunches {
    ...DashboardKpiRow
  }
  dinners {
    ...DashboardKpiRow
  }
}
    ${DashboardKpiRowFragmentDoc}`;
export const DashboardRevenueFragmentDoc = gql`
    fragment DashboardRevenue on DashboardRevenueQueryOutput {
  revpar {
    ...DashboardKpiRow
  }
  adr {
    ...DashboardKpiRow
  }
  roomProduction {
    ...DashboardKpiRow
  }
  totalProduction {
    ...DashboardKpiRow
  }
}
    ${DashboardKpiRowFragmentDoc}`;
export const DashboardEventRowFragmentDoc = gql`
    fragment DashboardEventRow on DashboardEventRow {
  data
  occurred
}
    `;
export const DashboardSalesFragmentDoc = gql`
    fragment DashboardSales on DashboardSellsQueryOutput {
  reservations {
    ...DashboardKpiRow
  }
  lastReservation {
    ...DashboardEventRow
  }
  cancellations {
    ...DashboardKpiRow
  }
  lastCancellation {
    ...DashboardEventRow
  }
}
    ${DashboardKpiRowFragmentDoc}
${DashboardEventRowFragmentDoc}`;
export const DashboardRRFragmentDoc = gql`
    fragment DashboardRR on ReservedResource {
  id
  phase
  start
  end
  childOccupancies {
    childId
    quantity
    child {
      minAge
      maxAge
      taxonomy {
        description
      }
    }
  }
  productions {
    total
    bills {
      bill {
        open
      }
      quota
    }
  }
  chargeCategory {
    name
    code
    breakfastIncluded
    lunchIncluded
    dinnerIncluded
  }
  resourceOccupancies {
    start
    resource {
      id
      code
    }
    reservedResourceType {
      name {
        description
      }
      customName
    }
  }
  reservation {
    id
    reservedResources {
      id
    }
    depositAssigneds {
      amount
      documentId
    }
    origin {
      name
      ota
    }
    portalInfo {
      portal {
        name
      }
    }
    reference {
      mainGuest {
        name
        language
        type
      }
      agency {
        name
        language
        type
      }
      customerPerson {
        name
        language
        type
      }
      customerCompany {
        name
        language
        type
      }
    }
    isGroup
    group
    notes {
      type
      description
    }
    reservationStateId
    reservationState {
      noshow
    }
  }
  adults
  children
  guestOccupancies {
    type
    guest {
      name
    }
    start
    end
  }
}
    `;
export const IstatDailyClosureAuditFragmentDoc = gql`
    fragment IstatDailyClosureAudit on DailyClosureAudit {
  executionDate
  referenceDate
  procedureName
  result
  manualExecution
  message
  configurationName
}
    `;
export const DashboardCleaningFragmentDoc = gql`
    fragment DashboardCleaning on ResourceHousekeeping {
  id
  cleaningState
  code
  layout {
    ...ResourceLayout
  }
  unavailabilities {
    id
    start
    end
    name
    note
  }
  reservedResource {
    id
    start
    end
    resourceOccupancies {
      resourceId
      start
      end
      phase
      reservedResourceLayout {
        ...ResourceLayout
      }
    }
    reservation {
      notes {
        description
        type
      }
      reservationState {
        canceled
      }
    }
    children
    adults
  }
  positionId
  resourceType {
    code
    customName
    name {
      description
    }
    timeConfiguration {
      unitOfMeasurement
    }
  }
}
    ${ResourceLayoutFragmentDoc}`;
export const HistoricalCustomerResearchCustomerFragmentDoc = gql`
    fragment HistoricalCustomerResearchCustomer on Customer {
  id
  name
  tags {
    id
    color
    label
  }
}
    `;
export const HistoricalCustomerResearchFragmentDoc = gql`
    fragment HistoricalCustomerResearch on Reservation {
  id
  reservationCode
  reservedResources {
    id
    adults
    children
    start
    end
    productions {
      chargeCategory {
        stayIncluded
      }
      amount
      currency
    }
    guestOccupancies {
      guest {
        id
        name
      }
      start
      end
    }
  }
  notes {
    type
    description
  }
  reference {
    mainGuest {
      ...HistoricalCustomerResearchCustomer
    }
    customerCompany {
      ...HistoricalCustomerResearchCustomer
    }
    agency {
      ...HistoricalCustomerResearchCustomer
    }
  }
  isGroup
  group
}
    ${HistoricalCustomerResearchCustomerFragmentDoc}`;
export const HistoricalCustomerReservedResourceResearchFragmentDoc = gql`
    fragment HistoricalCustomerReservedResourceResearch on ReservedResource {
  reservation {
    ...HistoricalCustomerResearch
  }
}
    ${HistoricalCustomerResearchFragmentDoc}`;
export const NcsNotificationFragmentDoc = gql`
    fragment NcsNotification on NcsNotification {
  id
  notification {
    message
    title
  }
  createdDate
  read
}
    `;
export const RateFragmentDoc = gql`
    fragment Rate on Rate {
  currency
  type
  name
  description
  visibilityOnIbe
  agreementRate
  parentRateId
  derivedRules {
    operation
    value
  }
  minStay
  maxStay
  minAdvance
  maxAdvance
  closeToArrival
  closeToDeparture
  chargeCategoryId
  resourcesRate {
    resourceTypeId
    priceType
    price
    rulesForDifferentOccupation {
      occupancy
      variation
      type
      value
    }
    priceForDifferentOccupation {
      occupation
      price
    }
  }
  parentRate {
    resourcesRate {
      resourceTypeId
      priceType
      price
      rulesForDifferentOccupation {
        occupancy
        variation
        type
        value
      }
      priceForDifferentOccupation {
        occupation
        price
      }
    }
  }
  chargesRate {
    chargeCategoryId
    priceModel
    operation
    price
    priceForDifferentOccupation {
      occupation
      price
    }
    resourceTypeId
    chargeCategory {
      id
      name
      code
    }
  }
  resourcesTypeEnabledId
  resourcesTypeEnabled {
    id
    persons
  }
  childRule {
    rule
    childDiscount {
      childId
      percentage
      child {
        id
        percentageDiscount
        noOccupancy
        maxAge
        minAge
        taxonomyId
        taxonomy {
          description
        }
      }
    }
  }
  bookingPolicyId
  ibeCode
  order
  tenantId
  propertyId
  id
  restrictionFromParent
  crossSell
  affiliatedCompaniesId
  chargeCategory {
    name
    code
  }
  bookingPolicy {
    id
    tenantId
    propertyId
    name
    noShowRule {
      type
    }
    paymentRule {
      type
    }
    cancellationPolicy {
      type
    }
  }
  mandatoryAdditionalServices {
    additionalService {
      id
      name
    }
    priceZero
  }
  priceRanges {
    name
    resourceType {
      resourceTypeId
      price
      resourceType {
        rackRate
        customName
        name {
          description
        }
        code
        persons
        additionalPersons
      }
    }
  }
  intPrices
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on Customer {
  id
  name
}
    `;
export const BaseRateConfiguredResourceTypesFragmentDoc = gql`
    fragment BaseRateConfiguredResourceTypes on Rate {
  resourcesRate {
    resourceTypeId
  }
}
    `;
export const StatisticFragmentDoc = gql`
    fragment Statistic on StatisticOutput {
  date
  inventory
  unavailability
  occupancy
  adr
  revpar
  trevpar
  totalProduction
  roomProduction
  originDistributions {
    amount
    label
  }
}
    `;
export const PickupFragmentDoc = gql`
    fragment Pickup on PickupOutputByResourceType {
  daysBefore
  resourceTypeId
}
    `;
export const ContextIstatConfigurationFragmentDoc = gql`
    fragment ContextIstatConfiguration on IstatConfiguration {
  name
  procedureCode
}
    `;
export const ContextPsConfigurationFragmentDoc = gql`
    fragment ContextPsConfiguration on PsConfiguration {
  name
  auto
}
    `;
export const ContextFiscalConfigurationFragmentDoc = gql`
    fragment ContextFiscalConfiguration on FiscalConfiguration {
  name
  default
  vatNumber
  fiscalCode
  iban
  tspay {
    merchantRef
  }
  cashDeskTypeIds
}
    `;
export const ContextDailyClosureConfigurationFragmentDoc = gql`
    fragment ContextDailyClosureConfiguration on DailyClosureConfiguration {
  automatic
  time
}
    `;
export const ContextSubAddressFragmentDoc = gql`
    fragment ContextSubAddress on PropertySubAddress {
  name
  resourceTypeIds
}
    `;
export const userRoleFragmentDoc = gql`
    fragment userRole on UserRoleOutput {
  code
  permissions
}
    `;
export const HousekeepingResourceFragmentDoc = gql`
    fragment HousekeepingResource on ResourceHousekeeping {
  id
  code
  cleaningState
  unavailabilities {
    id
    start
    end
    name
    note
  }
  layout {
    ...ResourceLayout
  }
  resourceType {
    code
    customName
    name {
      description
    }
    timeConfiguration {
      unitOfMeasurement
    }
  }
  position {
    name
  }
  reservedResource {
    id
    resourceOccupancies {
      start
      end
      phase
      resourceId
      reservedResourceLayout {
        ...ResourceLayout
      }
    }
    guestOccupancies {
      start
      end
      phase
    }
    reservation {
      notes {
        type
        description
      }
      reservationState {
        canceled
      }
    }
  }
}
    ${ResourceLayoutFragmentDoc}`;
export const ChargeCategoryImportReservationsFragmentDoc = gql`
    fragment ChargeCategoryImportReservations on ChargeCategory {
  id
  code
  name
}
    `;
export const ResourceTypeImportReservationsFragmentDoc = gql`
    fragment ResourceTypeImportReservations on ResourceType {
  id
  name {
    description
  }
  code
  customName
}
    `;
export const ResourceImportReservationsFragmentDoc = gql`
    fragment ResourceImportReservations on Resource {
  id
  code
  resourceTypeId
}
    `;
export const GridBulkReservationFragmentDoc = gql`
    fragment GridBulkReservation on BulkReservation {
  id
  error
  row {
    originalId
    portalName
    customerName
    start
    end
    resourceId
    resourceTypeId
    totalAmount
  }
}
    `;
export const PreviousImportBulkReservationFragmentDoc = gql`
    fragment PreviousImportBulkReservation on BulkReservation {
  id
  error
  timestamp
}
    `;
export const ImportedTaskListFragmentDoc = gql`
    fragment ImportedTaskList on ImportedTask {
  id
  tenantId
  type
  timestamp
  start
  end
  database
  extPropertyId
  lastMessage
  lastError
}
    `;
export const ImportablePropertyDataFragmentDoc = gql`
    fragment ImportablePropertyData on ImportedPropertyData {
  id
  name
  address {
    countryIsoCode
    address
    municipalityIstatCode
    postalCode
    province
    city
  }
}
    `;
export const ImportablePropertyFragmentDoc = gql`
    fragment ImportableProperty on ImportedProperty {
  id
  tenantId
  data {
    ...ImportablePropertyData
  }
}
    ${ImportablePropertyDataFragmentDoc}`;
export const PasserByBillDocumentItemFragmentDoc = gql`
    fragment PasserByBillDocumentItem on PassersByBillDocument {
  _id
  numberExtended
  fiscalType
}
    `;
export const PasserByBillItemFragmentDoc = gql`
    fragment PasserByBillItem on PassersByBill {
  _id
  total
  productionLength
  owner {
    _id
    name
  }
  description
  creationDate
  document {
    ...PasserByBillDocumentItem
  }
}
    ${PasserByBillDocumentItemFragmentDoc}`;
export const PosDepositDocumentFragmentDoc = gql`
    fragment PosDepositDocument on Document {
  id
  depositAssigneds {
    id
    amount
  }
}
    `;
export const QuoteMainGuestFragmentDoc = gql`
    fragment QuoteMainGuest on Customer {
  name
  mailContacts {
    isDefault
    order
    value
  }
}
    `;
export const QuoteDetailsFragmentDoc = gql`
    fragment QuoteDetails on Quotation {
  expiration
  id
  propertyId
  quotationCode
  quotationState
  quotationStateHistory {
    state
    timestamp
  }
  reference {
    customerPersonId
    customerCompanyId
    mainGuest {
      ...QuoteMainGuest
    }
    customerCompany {
      company {
        defaultCredit
      }
    }
  }
  tenantId
  auditable {
    createdBy
    createdOn
  }
  quotationDetails {
    reservationId
    quotedResources {
      resourceOccupancies {
        resourceTypeId
        resourceType {
          description
          customName
          code
        }
      }
      additionalServices {
        additionalService {
          ...AdditionalService
        }
        priceZero
        quantity
      }
      adults
      chargeCategoryId
      children
      childOccupancies {
        quantity
        childId
      }
      end
      manualDailyPrices {
        day
        price
      }
      manualPrice
      rateId
      rate {
        name
        mandatoryAdditionalServices {
          priceZero
          additionalService {
            ...AdditionalService
          }
        }
      }
      chargeCategory {
        id
        name
      }
      start
    }
  }
}
    ${QuoteMainGuestFragmentDoc}
${AdditionalServiceFragmentDoc}`;
export const PayAndConfirmQuotationFragmentDoc = gql`
    fragment PayAndConfirmQuotation on PayAndConfirmQuotation {
  reservationId
}
    `;
export const QuoteInputUniqueInfoFragmentDoc = gql`
    fragment QuoteInputUniqueInfo on Quotation {
  id
  auditable {
    modifiedOn
    createdOn
  }
}
    `;
export const QuoteItemFragmentDoc = gql`
    fragment QuoteItem on Quotation {
  ...QuoteInputUniqueInfo
  expiration
  propertyId
  quotationCode
  quotationState
  tenantId
  reference {
    agencyId
    customerCompanyId
    customerPersonId
    mainGuestId
  }
  quotationDetails {
    reservationId
    quotedResources {
      adults
      children
      end
      manualPrice
      rateId
      start
      resourceOccupancies {
        end
        resourceId
        resourceTypeId
        start
      }
      manualDailyPrices {
        day
        price
      }
      guestOccupancies {
        cityTaxExoneration
        end
        guestId
        start
        type
      }
      childOccupancies {
        childId
        quantity
      }
      additionalServices {
        additionalService {
          ...AdditionalService
        }
        quantity
        priceZero
      }
      chargeCategoryId
    }
  }
}
    ${QuoteInputUniqueInfoFragmentDoc}
${AdditionalServiceFragmentDoc}`;
export const QuotationDetailsFragmentDoc = gql`
    fragment QuotationDetails on QuotationDetail {
  reservationId
  quotedResources {
    adults
    children
    end
    manualPrice
    rateId
    rate {
      name
      mandatoryAdditionalServices {
        priceZero
        additionalService {
          ...AdditionalService
        }
      }
    }
    chargeCategory {
      id
      name
    }
    start
    resourceOccupancies {
      end
      resourceId
      resourceTypeId
      start
      resourceType {
        description
        customName
        code
      }
    }
    manualDailyPrices {
      day
      price
    }
    guestOccupancies {
      cityTaxExoneration
      end
      guestId
      start
      type
    }
    childOccupancies {
      childId
      quantity
    }
    additionalServices {
      quantity
      priceZero
      additionalService {
        ...AdditionalService
      }
    }
    chargeCategoryId
  }
}
    ${AdditionalServiceFragmentDoc}`;
export const QuotationFragmentDoc = gql`
    fragment Quotation on Quotation {
  id
  expiration
  propertyId
  tenantId
  quotationCode
  auditable {
    createdOn
    createdBy
  }
  reference {
    mainGuest {
      name
    }
  }
  quotationDetails {
    ...QuotationDetails
  }
  quotationState
}
    ${QuotationDetailsFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  fullname
  id
  tsId
}
    `;
export const AccountingDataExportConfigurationFragmentDoc = gql`
    fragment AccountingDataExportConfiguration on ExportProcedure {
  id
  tenantId
  propertyId
  type
  managementConfiguration {
    batchPayments
    batchSales
    cityTaxDebts
    customersAccount
    customersDeposit
    customersFiscalDeposit
    customersVATPayments
    debtsforVAT
    defaultCompanyCode
    exportSuspendedPayments
    groupPayments
    groupRevenues
    revenueAccount
    vatSales
    vatrfSuspended
  }
  auditable {
    state
  }
}
    `;
export const AccountingDataExportFragmentDoc = gql`
    fragment AccountingDataExport on ExportData {
  id
  tenantId
  propertyId
  property {
    name
  }
  requestInfo {
    start
    end
    user
    forceExport
  }
  status
  fileIds
  exportProcedure {
    id
    propertyId
  }
  auditable {
    createdOn
  }
  message
}
    `;
export const AccountingDataExportVatFragmentDoc = gql`
    fragment AccountingDataExportVat on Vat {
  id
  code
  description
  order
  propertyId
  managementCode
  value
}
    `;
export const AccountingDataExportPaymentActiveFragmentDoc = gql`
    fragment AccountingDataExportPaymentActive on PaymentActive {
  id
  propertyId
  tenantId
  name
  paymentTypeId
  paymentType {
    sign
  }
  managementCode
  auditable {
    state
  }
}
    `;
export const AccountingDataExportChargeCategoryFragmentDoc = gql`
    fragment AccountingDataExportChargeCategory on ChargeCategory {
  id
  tenantId
  propertyId
  name
  stayIncluded
  breakfastIncluded
  lunchIncluded
  dinnerIncluded
  defaultVatId
  defaultVat {
    description
  }
  cityTax
  managementCode
  code
}
    `;
export const AccountingDataExportCashDeskTypeFragmentDoc = gql`
    fragment AccountingDataExportCashDeskType on CashDeskType {
  id
  tenantId
  propertyId
  name
  code
  managementCode
  documentsActiveId
}
    `;
export const MessageAutomationFragmentDoc = gql`
    fragment MessageAutomation on MessageAutomation {
  name
  id
  messageTemplateId
  auditable {
    state
  }
  phase
  cancellationMessageTemplateId
  linkToPayMessageTemplateId
  originIds
  resourceTypeIds
  scheduledConfiguration {
    beforeOrAfter
    days
    outOfBounds
    scheduleAt
  }
  scheduledType
  wciState
}
    `;
export const MessageTemplateAutomationFragmentDoc = gql`
    fragment MessageTemplateAutomation on MessageTemplate {
  id
  code
  name
  type
  tenantId
}
    `;
export const ResourceTypeAutomationFragmentDoc = gql`
    fragment ResourceTypeAutomation on ResourceType {
  id
  name {
    description
  }
  customName
  code
}
    `;
export const CashDeskTypeBillingFragmentDoc = gql`
    fragment CashDeskTypeBilling on CashDeskType {
  code
  name
  id
  documentsActive {
    id
    fiscalType
    documentSetCode
    counters {
      id
      format
      value
      year
    }
  }
}
    `;
export const FiscalConfigurationBillingFragmentDoc = gql`
    fragment FiscalConfigurationBilling on FiscalConfiguration {
  felConfiguration {
    reaOffice
    reaCode
    inLiquidation
    authorizedCapital
    soleShareholder
    taxSystem
    flowType
  }
  iban
  cashDeskTypeIds
  default
  fiscalCode
  name
  registryItemId
  resourceTypeIds
  vatNumber
  propertyName
  address {
    countryId
    country {
      isoCode
    }
    city
    province
    postalCode
    address
    municipalityId
    municipality {
      name
    }
  }
  tspay {
    state
  }
}
    `;
export const SubscriptionDigitalFragmentDoc = gql`
    fragment SubscriptionDigital on SubscriptionDigital {
  appId
  id
}
    `;
export const AvailabilityRequestFragmentDoc = gql`
    fragment AvailabilityRequest on AvailabilityRequest {
  id
  auditable {
    createdOn
    modifiedOn
  }
  start
  end
  customer {
    firstName
    lastName
    email
  }
  resources {
    adults
    childOccupancy {
      quantity
    }
  }
  state
}
    `;
export const SubAddressAddressFragmentDoc = gql`
    fragment SubAddressAddress on Address {
  address
  city
  province
  postalCode
  municipality {
    name
    postalCode
  }
  country {
    name
  }
}
    `;
export const BookingPolicyListFragmentDoc = gql`
    fragment BookingPolicyList on BookingPolicy {
  id
  tenantId
  propertyId
  name
  noShowRule {
    type
  }
  paymentRule {
    type
  }
  cancellationPolicy {
    type
  }
}
    `;
export const BookingPolicyDetailFragmentDoc = gql`
    fragment BookingPolicyDetail on BookingPolicy {
  ...BookingPolicyList
  paymentRule {
    type
    percentage
    guaranteedCreditCard
    paymentsAcceptedId
  }
  cancellationPolicy {
    type
    daysWithoutPenalties
    hourWithoutPenalties
    penaltyType
    percentage
  }
  noShowRule {
    type
    percentage
  }
  additionalNote
}
    ${BookingPolicyListFragmentDoc}`;
export const CashDeskTypeListFragmentDoc = gql`
    fragment CashDeskTypeList on CashDeskType {
  code
  name
  id
  documentsActive {
    id
    fiscalType
  }
  propertyId
  tenantId
}
    `;
export const DocumentActiveFragmentDoc = gql`
    fragment DocumentActive on DocumentActive {
  id
  fiscalType
  documentSetCode
  counters {
    id
    format
    value
    year
  }
}
    `;
export const CassaInCloudSalesModeFragmentDoc = gql`
    fragment CassaInCloudSalesMode on CassaInCloudSalesMode {
  id
  description
}
    `;
export const PointOfSaleMealShiftFragmentDoc = gql`
    fragment PointOfSaleMealShift on PointOfSaleMealShift {
  id
  description
  fromTime
  toTime
}
    `;
export const CassaInCloudDepartmentFragmentDoc = gql`
    fragment CassaInCloudDepartment on CassaInCloudDepartment {
  id
  description
}
    `;
export const SpChargeCategoryFragmentDoc = gql`
    fragment SpChargeCategory on PointOfSaleMappingsChargeCategoryEntry {
  chargeCategoryId
  externalCode
}
    `;
export const PointOfSaleFragmentDoc = gql`
    fragment PointOfSale on PointOfSale {
  id
  property {
    name
  }
  name
  description
  externalId
  isDefault
  configuration {
    roomsOutChargeable
  }
  mappings {
    chargeCategories {
      ...SpChargeCategory
    }
  }
  auditable {
    state
  }
}
    ${SpChargeCategoryFragmentDoc}`;
export const CicConfigurationApiKeyFragmentDoc = gql`
    fragment CicConfigurationApiKey on CassaInCloudConfigurationApiKeyEntry {
  apiKey
  description
  pointOfSales {
    ...PointOfSale
  }
}
    ${PointOfSaleFragmentDoc}`;
export const CicConfigurationFragmentDoc = gql`
    fragment CicConfiguration on CassaInCloudConfiguration {
  tenantSecret
  apiKeys {
    ...CicConfigurationApiKey
  }
}
    ${CicConfigurationApiKeyFragmentDoc}`;
export const CassaInCloudSalesPointFragmentDoc = gql`
    fragment CassaInCloudSalesPoint on CassaInCloudSalesPoint {
  id
  description
  name
}
    `;
export const ExpediaParametersFragmentDoc = gql`
    fragment ExpediaParameters on ExpediaParameters {
  pricingModel
  distributionModels
  rateAcquisitionType
}
    `;
export const ChannelFragmentDoc = gql`
    fragment Channel on Channel {
  id
  name
  percentage
  airbnbParameters {
    hostUserId
    hostAuthorizationCode
    hostAuthorizationTimestamp
    authentication {
      accessToken
      expiresAt
      refreshToken
    }
  }
  info
  auditable {
    state
  }
  tenantId
  propertyId
  subPropertyId
  portalId
  portal {
    id
    name
  }
  propertyPortalCode
  initialImportDate
  lastDownload
  throughFigaro
  lastUpdateChannel
  credentials {
    userId
    password
  }
}
    `;
export const ChannelDetailsFragmentDoc = gql`
    fragment ChannelDetails on ChannelOutput {
  id
  onboardingUrl
  portalDataRetrieved
  channel {
    expediaParameters {
      ...ExpediaParameters
    }
    channelResourceTypeMappings {
      resourceTypeId
      portalResourceType {
        resourceTypeCodePortal
        resourceTypeNamePortal
        info
        adults
        child
      }
    }
    channelRateMappings {
      rateId
      chargeCategoryId
      portalrate {
        rateCodePortal
        rateNamePortal
        derived
        info
        resourceTypeCodes
        person
        portalPricingType
      }
    }
    channelChargeMappings {
      chargeCategoryCodePortal
      chargeCategoryId
      chargeCategory {
        name
      }
    }
    ...Channel
  }
  message
  portalRatesNotMapped {
    rateCodePortal
    rateNamePortal
    derived
    info
    resourceTypeCodes
    portalPricingType
  }
  portalResourcesTypeNotMapped {
    resourceTypeCodePortal
    resourceTypeNamePortal
    info
    adults
    child
  }
  portalResourcesTypeWarn
  portalRatesWarn
  portalOpportunities {
    code
    name
    info
  }
  portalResourcesTypeNoLongerExist {
    resourceTypeId
    portalResourceType {
      resourceTypeCodePortal
    }
  }
  portalRatesNoLongerExist {
    rateId
    chargeCategoryId
    portalrate {
      rateCodePortal
    }
  }
}
    ${ExpediaParametersFragmentDoc}
${ChannelFragmentDoc}`;
export const ChannelCommunicationResultFragmentDoc = gql`
    fragment ChannelCommunicationResult on ChannelCommunicationResult {
  id
  state
  message
  createdOn
  dataSendJson
  operations
}
    `;
export const PortalQueryResultFragmentDoc = gql`
    fragment PortalQueryResult on Portal {
  id
  name
  commercialName
  throughFigaro
}
    `;
export const ChargeCategoryFragmentDoc = gql`
    fragment ChargeCategory on ChargeCategory {
  id
  name
  code
  cityTax
  stayIncluded
  breakfastIncluded
  lunchIncluded
  dinnerIncluded
  defaultVatId
  cityTax
  defaultVat {
    value
    id
    description
    code
  }
}
    `;
export const ChildFragmentDoc = gql`
    fragment Child on Child {
  id
  taxonomyId
  taxonomy {
    description
  }
  minAge
  maxAge
  noOccupancy
  percentageDiscount
}
    `;
export const CityTaxConfigurationFragmentDoc = gql`
    fragment CityTaxConfiguration on CityTaxRuleConfiguration {
  amount
  rule
  name
  currency
  amountByPeriod {
    period {
      start
      end
    }
    amount
  }
  rule
  genericConfiguration {
    amountType
    maxNights
    minAge
    validity {
      start
      end
    }
    exonerations {
      code
      description
      extCode
      discount
    }
  }
  resourceTypeIds
  resourceIds
  fileGenerator
}
    `;
export const HoauFragmentDoc = gql`
    fragment Hoau on HoauConfiguration {
  baseUrl
  userId
  token
}
    `;
export const FileUploadResponseFragmentDoc = gql`
    fragment FileUploadResponse on FileUploadResponse {
  preSignedURL
  file {
    id
  }
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on File {
  URL
  id
}
    `;
export const InsightFragmentDoc = gql`
    fragment Insight on InsightStatus {
  id
  insightCode
  insightInfo {
    code
    priority
    type
    actionUrl
    title
    description
  }
  endPause
}
    `;
export const IstatConfigurationFragmentDoc = gql`
    fragment IstatConfiguration on IstatConfiguration {
  password
  propertyCode
  username
  name
  procedureCode
  resourceTypeIds
  resourceIds
  overrideResourcesNumber
  overrideBedsNumber
}
    `;
export const IstatSystemCapabilitiesFragmentDoc = gql`
    fragment IstatSystemCapabilities on IstatCapabilities {
  supportsAutomaticSend
  supportsFileGeneration
  handlesCancellation
}
    `;
export const MailTemplateFragmentDoc = gql`
    fragment MailTemplate on LocalizedMailMessageTemplate {
  language
  value {
    subject
    design
    html
  }
}
    `;
export const MessageTemplateFragmentDoc = gql`
    fragment MessageTemplate on MessageTemplate {
  id
  code
  name
  type
  tenantId
  propertyId
  mail {
    ...MailTemplate
  }
  description
  chat
  auditable {
    createdBy
    modifiedOn
    createdOn
    state
  }
}
    ${MailTemplateFragmentDoc}`;
export const MessageTemplateListFragmentDoc = gql`
    fragment MessageTemplateList on MessageTemplate {
  id
  code
  name
  type
  tenantId
  propertyId
  mail {
    language
    value {
      subject
      design
      html
    }
  }
  chat
  description
  auditable {
    createdBy
    modifiedOn
    createdOn
    state
  }
}
    `;
export const FileFragmentDoc = gql`
    fragment File on File {
  URL
  filename
  id
  key
  mimeType
  propertyId
  public
  tenantId
}
    `;
export const MultiManagementSubAddressFragmentDoc = gql`
    fragment MultiManagementSubAddress on PropertySubAddress {
  name
  resourceTypeIds
}
    `;
export const MultiManagementFiscalConfigurationFragmentDoc = gql`
    fragment MultiManagementFiscalConfiguration on FiscalConfiguration {
  name
  resourceTypeIds
}
    `;
export const MultiManagementCityTaxConfigurationFragmentDoc = gql`
    fragment MultiManagementCityTaxConfiguration on CityTaxRuleConfiguration {
  name
  resourceIds
  resourceTypeIds
}
    `;
export const MultiManagementIstatConfigurationFragmentDoc = gql`
    fragment MultiManagementIstatConfiguration on IstatConfiguration {
  name
  resourceIds
  resourceTypeIds
}
    `;
export const PaymentGatewayFragmentDoc = gql`
    fragment PaymentGateway on PaymentGateway {
  id
  type
  managedMethodTypes
}
    `;
export const PaymentMethodFragmentDoc = gql`
    fragment PaymentMethod on PaymentMethod {
  id
  tenantId
  propertyId
  type
  gateway {
    id
    managedMethodTypes
  }
  additionalNote
}
    `;
export const PaymentActiveListFragmentDoc = gql`
    fragment PaymentActiveList on PaymentActive {
  id
  name
  paymentType {
    id
    name
  }
  auditable {
    state
  }
  managementCode
}
    `;
export const PositionFragmentDoc = gql`
    fragment Position on Position {
  id
  name
  order
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  tenantId
  propertyId
  chargeCategoryId
  chargeCategory {
    name
    defaultVatId
    defaultVat {
      code
      value
    }
  }
  description
  amount
  auditable {
    state
  }
}
    `;
export const PSConfigurationFragmentDoc = gql`
    fragment PSConfiguration on PsConfiguration {
  password
  username
  wskey
  auto
  resourceTypeIds
  resourceIds
  name
}
    `;
export const ResourceTypeEssentialFragmentDoc = gql`
    fragment ResourceTypeEssential on ResourceType {
  id
  code
  description
  name {
    description
  }
  customName
  logicalType
}
    `;
export const TaxonomyFragmentDoc = gql`
    fragment Taxonomy on Taxonomy {
  id
  type
  description
  parentId
  order
}
    `;
export const AmenityFragmentDoc = gql`
    fragment Amenity on Amenity {
  id
  name
  image
}
    `;
export const ResourceTypeOptionFragmentDoc = gql`
    fragment ResourceTypeOption on ResourceTypeOption {
  type
  logicResourceId
  group {
    resourceTypeId
    resourceId
  }
  order
}
    `;
export const TimeConfigurationFragmentDoc = gql`
    fragment TimeConfiguration on TimeConfiguration {
  activity {
    from
    to
  }
  unitOfMeasurement
  chargeCategoryId
}
    `;
export const ResourceTypeFragmentDoc = gql`
    fragment ResourceType on ResourceType {
  id
  code
  description
  persons
  additionalPersons
  maxAdults
  nameId
  resourceCategoryId
  configurationsLayoutId
  defaultLayoutId
  inventory
  rackRate
  minRate
  amenitiesId
  order
  customName
  name {
    description
  }
  currency
  resources {
    id
    description
    code
    position {
      name
    }
    roomTetrisOrder
  }
  order
  minRate
  logicalType
  autoEquivalent
  equivalences {
    ...ResourceTypeOption
  }
  visibilityOnIbe
  timeConfiguration {
    ...TimeConfiguration
  }
}
    ${ResourceTypeOptionFragmentDoc}
${TimeConfigurationFragmentDoc}`;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  id
  description
  positionId
  position {
    id
    name
    order
  }
  code
  layout {
    occupation
    description
  }
  resourceTypeId
  resourceType {
    ...ResourceType
  }
}
    ${ResourceTypeFragmentDoc}`;
export const ResourceLookupTypeFragmentDoc = gql`
    fragment ResourceLookupType on Resource {
  id
  code
  resourceType {
    id
    code
    customName
    description
  }
}
    `;
export const UserWithRoleFragmentDoc = gql`
    fragment UserWithRole on User {
  id
  authorizations {
    role {
      code
      name
    }
    propertyId
    tenantId
  }
  email
  fullname
}
    `;
export const PropertyRoleFragmentDoc = gql`
    fragment PropertyRole on Role {
  code
  name
}
    `;
export const VatFragmentDoc = gql`
    fragment Vat on Vat {
  id
  code
  codePa
  value
  order
  description
  tenantId
  propertyId
}
    `;
export const SinapsiRateFragmentDoc = gql`
    fragment SinapsiRate on Rate {
  type
  id
  chargeCategory {
    id
  }
  resourcesRate {
    resourceTypeId
    priceType
  }
}
    `;
export const PriceCalendarSinapsiFragmentDoc = gql`
    fragment PriceCalendarSinapsi on PriceCalendarDay {
  availabilities {
    availability
    resourceTypeId
  }
  day
  id
  rates {
    chargesRate {
      price
      resourceTypeId
    }
    rate {
      type
      resourcesRate {
        price
        resourceTypeId
      }
    }
    stopSellResourcesTypeId
  }
}
    `;
export const SinapsiPriceRecommendationFragmentDoc = gql`
    fragment SinapsiPriceRecommendation on SinapsiResourceRecommendedPrices {
  resourceTypeId
  recommendations {
    date
    price
    warnings {
      min
      max
    }
  }
}
    `;
export const SinapsiBudgetForecastFragmentDoc = gql`
    fragment SinapsiBudgetForecast on SinapsiBudgetForecast {
  month
  otb
  to_come
}
    `;
export const SinapsiPriceFragmentDoc = gql`
    fragment SinapsiPrice on SinapsiOutput {
  prices {
    resourceTypeId
    recommendations {
      date
      price
      warnings {
        min
        max
      }
    }
  }
  budget_forecast {
    ...SinapsiBudgetForecast
  }
  last_period_stats {
    n_changes
  }
}
    ${SinapsiBudgetForecastFragmentDoc}`;
export const ResourceTypeForSinapsiFragmentDoc = gql`
    fragment ResourceTypeForSinapsi on ResourceType {
  id
  code
  customName
  name {
    description
  }
  minRate
  currency
  additionalPersons
  persons
  additionalPersons
  rackRate
  inventory
}
    `;
export const SinapsiConfigurationFragmentDoc = gql`
    fragment SinapsiConfiguration on SinapsiConfiguration {
  pricing {
    limits {
      resourceTypeId
      min
      max
    }
    overrides {
      from
      to
      limits {
        resourceTypeId
        min
        max
      }
    }
    order {
      active
      exclude_from_ordering
    }
  }
  risk_profile {
    risk_appetite
  }
  autopilot {
    active
    max_n_days
  }
  ignore_resources
}
    `;
export const SinapsiStatisticFragmentDoc = gql`
    fragment SinapsiStatistic on StatisticOutput {
  date
  occupancy
  inventory
  totalProduction
}
    `;
export const ThreadFragmentDoc = gql`
    fragment Thread on Thread {
  archived
  externalId
  id
  lastMessage {
    message
    createdOn
  }
  origin
  read
  reservationId
  reservation {
    reservationCode
    reference {
      mainGuest {
        name
      }
    }
    reservedResources {
      start
      end
      adults
      children
    }
  }
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on ThreadMessage {
  externalUserId
  id
  internalNote
  message
  auditable {
    createdOn
  }
}
    `;
export const ReservationThreadFragmentDoc = gql`
    fragment ReservationThread on Thread {
  id
  archived
  lastMessage {
    message
    createdOn
  }
}
    `;
export const PlanFragmentDoc = gql`
    fragment Plan on Plan {
  currency
  billingFrequency
  footerFeatures {
    text
  }
  footerFooterFeatures
  price
  title
}
    `;
export const StoreCatalogFragmentDoc = gql`
    fragment StoreCatalog on StoreResponse {
  pricesPages {
    url
    descriptionRows {
      description
    }
    cards {
      plans {
        ...Plan
      }
    }
  }
}
    ${PlanFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  isoCode
  name
}
    `;
export const MunicipalityFragmentDoc = gql`
    fragment Municipality on Municipality {
  id
  name
  province
  postalCode
  istat
  cadastralCode
}
    `;
export const FiscalGatewayWorkstationFragmentDoc = gql`
    fragment FiscalGatewayWorkstation on FiscalGatewayWorkstation {
  name
  workstationID
  apikey
}
    `;
export const CashDeskTypeFragmentDoc = gql`
    fragment CashDeskType on CashDeskType {
  id
  code
  fiscalGatewayWorkstations {
    ...FiscalGatewayWorkstation
  }
  auditable {
    state
  }
}
    ${FiscalGatewayWorkstationFragmentDoc}`;
export const CashDeskFragmentDoc = gql`
    fragment CashDesk on CashDesk {
  id
  hotelDate
  cashDeskType {
    id
    code
    name
    documentsActive {
      fiscalType
    }
  }
}
    `;
export const PropertyFiscalConfigurationFragmentDoc = gql`
    fragment PropertyFiscalConfiguration on FiscalConfiguration {
  cashDeskTypeIds
  resourceTypeIds
  name
}
    `;
export const PropertyFiscalConfigurationsFragmentDoc = gql`
    fragment PropertyFiscalConfigurations on Property {
  id
  fiscalConfigurations {
    ...PropertyFiscalConfiguration
  }
}
    ${PropertyFiscalConfigurationFragmentDoc}`;
export const CervedSubjectFragmentDoc = gql`
    fragment CervedSubject on CervedSubject {
  subject_id
  subject_type
  tax_code
  company_info {
    business_name
    vat_number
  }
  person_info {
    first_name
    last_name
    name
  }
  address {
    street {
      description
    }
    city {
      istat_code
      description
    }
    country {
      isoCode
    }
    postal_code
    province {
      code
    }
  }
}
    `;
export const CoProductionAssignedFragmentDoc = gql`
    fragment CoProductionAssigned on ProductionAssigned {
  id
  billId
  bill {
    id
    reservationId
  }
  quota
  production {
    id
    currency
    date
    description
    reservedResourceId
    total
    quantity
    amount
    chargeCategoryId
    chargeCategory {
      id
      name
      stayIncluded
    }
    reservedResource {
      resourceOccupancies {
        resourceId
        reservedResourceTypeId
      }
    }
    vatId
    vat {
      id
      value
      code
    }
  }
}
    `;
export const CoReservationFragmentDoc = gql`
    fragment CoReservation on Reservation {
  id
  reservationCode
  voucher
  credit
  reservedResources {
    id
    start
    end
    resourceOccupancies {
      start
      end
      phase
      reservedResourceType {
        id
        code
        customName
        name {
          id
          description
        }
      }
      resource {
        id
        code
      }
    }
    guestOccupancies {
      phase
      type
      start
      end
      cityTaxExoneration
      wciState
      guest {
        ...ReferenceCustomer
      }
    }
  }
  reference {
    agency {
      ...ReferenceCustomer
    }
    customerCompany {
      ...ReferenceCustomer
    }
    customerPerson {
      ...ReferenceCustomer
    }
    mainGuest {
      ...ReferenceCustomer
    }
  }
}
    ${ReferenceCustomerFragmentDoc}`;
export const CoBillFragmentDoc = gql`
    fragment CoBill on Bill {
  id
  open
  productions {
    ...CoProductionAssigned
  }
  reservation {
    ...CoReservation
  }
  owner {
    ...ReferenceCustomer
  }
  reservedResourceId
}
    ${CoProductionAssignedFragmentDoc}
${CoReservationFragmentDoc}
${ReferenceCustomerFragmentDoc}`;
export const CoDepositAssignedFragmentDoc = gql`
    fragment CoDepositAssigned on DepositAssigned {
  id
  documentId
  billId
  reservationId
  reservedResourceId
  amount
}
    `;
export const CoDepositFragmentDoc = gql`
    fragment CoDeposit on Document {
  id
  numberExtended
  fiscalType
  documentType
  depositAssigneds {
    ...CoDepositAssigned
  }
  documentDetails {
    reference {
      accountantCategory {
        defaultVat {
          value
          description
        }
      }
    }
    vat {
      id
      value
      description
    }
  }
}
    ${CoDepositAssignedFragmentDoc}`;
export const CoDocumentDetailFragmentDoc = gql`
    fragment CoDocumentDetail on DocumentDetail {
  referenceDocumentId
  referenceDocument {
    ...CoDeposit
  }
  reference {
    accountantCategoryId
    chargeCategoryId
  }
  description
  amount
  totalAmount
  quantity
  vat {
    id
    value
    code
  }
  date
  billId
}
    ${CoDepositFragmentDoc}`;
export const CoInfoDocumentDepositAssignedFragmentDoc = gql`
    fragment CoInfoDocumentDepositAssigned on DepositAssigned {
  id
  documentId
  document {
    numberExtended
  }
  reservation {
    id
    reservationCode
  }
  reservedResource {
    id
    resourceOccupancies {
      assignedResourceType {
        code
        customName
        name {
          description
        }
      }
      resource {
        code
      }
    }
  }
  bill {
    id
    description
  }
  amount
  currency
}
    `;
export const CoDocumentFragmentDoc = gql`
    fragment CoDocument on Document {
  id
  numberExtended
  documentDate
  fiscalType
  currency
  totalAmount
  unpaidAmount
  documentType
  note
  auditable {
    state
  }
  customerId
  customer {
    ...ReferenceCustomer
  }
  consolidatedData {
    customer {
      ...ReferenceCustomer
    }
  }
  cashDeskId
  cashDesk {
    id
    open
    cashDeskTypeId
  }
  documentDetails {
    ...CoDocumentDetail
  }
  depositAssigneds {
    ...CoInfoDocumentDepositAssigned
  }
  documentPaymentDetails {
    amount
    referenceDocumentId
    referenceDocument {
      ...CoDeposit
    }
    paymentActiveId
    paymentActive {
      id
      paymentType {
        id
        code
        sign
      }
      name
    }
    expireDate
  }
  bills {
    id
    productions {
      ...CoProductionAssigned
    }
    reservationId
    reservation {
      ...CoReservation
    }
  }
  felAdditionalInfo {
    sent
    state
    closed
  }
  scelAdditionalInfo {
    sent
    note
  }
  creditNote {
    id
    numberExtended
    documentDate
    fiscalType
  }
  referenceDocument {
    id
    numberExtended
    documentDate
  }
}
    ${ReferenceCustomerFragmentDoc}
${CoDocumentDetailFragmentDoc}
${CoInfoDocumentDepositAssignedFragmentDoc}
${CoDepositFragmentDoc}
${CoProductionAssignedFragmentDoc}
${CoReservationFragmentDoc}`;
export const GooglePlaceFragmentDoc = gql`
    fragment GooglePlace on GooglePlace {
  place_id
  geometry {
    location {
      lat
      lng
    }
  }
  name
}
    `;
export const IdentificationDocumentFragmentDoc = gql`
    fragment IdentificationDocument on IdentificationDocument {
  id
  tenantId
  name
}
    `;
export const PaymentActiveFragmentDoc = gql`
    fragment PaymentActive on PaymentActive {
  id
  name
  paymentType {
    code
    sign
  }
  paymentMethods {
    gateway {
      type
    }
  }
}
    `;
export const GetCityTaxReportDocument = gql`
    query GetCityTaxReport($filter: CityTaxReportInput!) {
  getCityTaxReport(filter: $filter) {
    invoice {
      ...CityTaxReportDetail
    }
    receipt {
      ...CityTaxReportDetail
    }
  }
}
    ${CityTaxReportDetailFragmentDoc}`;

/**
 * __useGetCityTaxReportQuery__
 *
 * To run a query within a React component, call `useGetCityTaxReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityTaxReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityTaxReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCityTaxReportQuery(baseOptions: Apollo.QueryHookOptions<GetCityTaxReportQuery, GetCityTaxReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityTaxReportQuery, GetCityTaxReportQueryVariables>(GetCityTaxReportDocument, options);
      }
export function useGetCityTaxReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityTaxReportQuery, GetCityTaxReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityTaxReportQuery, GetCityTaxReportQueryVariables>(GetCityTaxReportDocument, options);
        }
export type GetCityTaxReportQueryHookResult = ReturnType<typeof useGetCityTaxReportQuery>;
export type GetCityTaxReportLazyQueryHookResult = ReturnType<typeof useGetCityTaxReportLazyQuery>;
export type GetCityTaxReportQueryResult = Apollo.QueryResult<GetCityTaxReportQuery, GetCityTaxReportQueryVariables>;
export const GetCityTaxConfigurationsDocument = gql`
    query GetCityTaxConfigurations($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    cityTaxConfiguration {
      configurations {
        name
        resourceTypeIds
        resourceIds
      }
    }
  }
}
    `;

/**
 * __useGetCityTaxConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetCityTaxConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityTaxConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityTaxConfigurationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCityTaxConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<GetCityTaxConfigurationsQuery, GetCityTaxConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityTaxConfigurationsQuery, GetCityTaxConfigurationsQueryVariables>(GetCityTaxConfigurationsDocument, options);
      }
export function useGetCityTaxConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityTaxConfigurationsQuery, GetCityTaxConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityTaxConfigurationsQuery, GetCityTaxConfigurationsQueryVariables>(GetCityTaxConfigurationsDocument, options);
        }
export type GetCityTaxConfigurationsQueryHookResult = ReturnType<typeof useGetCityTaxConfigurationsQuery>;
export type GetCityTaxConfigurationsLazyQueryHookResult = ReturnType<typeof useGetCityTaxConfigurationsLazyQuery>;
export type GetCityTaxConfigurationsQueryResult = Apollo.QueryResult<GetCityTaxConfigurationsQuery, GetCityTaxConfigurationsQueryVariables>;
export const GenerateCityTaxFileDocument = gql`
    mutation GenerateCityTaxFile($filter: GenerateCityTaxFileInput!) {
  generateCityTaxFile(input: $filter) {
    success
    fileUrl
    errors {
      ruleConfigurationName
      date
      message
    }
  }
}
    `;
export type GenerateCityTaxFileMutationFn = Apollo.MutationFunction<GenerateCityTaxFileMutation, GenerateCityTaxFileMutationVariables>;

/**
 * __useGenerateCityTaxFileMutation__
 *
 * To run a mutation, you first call `useGenerateCityTaxFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCityTaxFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCityTaxFileMutation, { data, loading, error }] = useGenerateCityTaxFileMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGenerateCityTaxFileMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCityTaxFileMutation, GenerateCityTaxFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCityTaxFileMutation, GenerateCityTaxFileMutationVariables>(GenerateCityTaxFileDocument, options);
      }
export type GenerateCityTaxFileMutationHookResult = ReturnType<typeof useGenerateCityTaxFileMutation>;
export type GenerateCityTaxFileMutationResult = Apollo.MutationResult<GenerateCityTaxFileMutation>;
export type GenerateCityTaxFileMutationOptions = Apollo.BaseMutationOptions<GenerateCityTaxFileMutation, GenerateCityTaxFileMutationVariables>;
export const FiscalConfigurationDocumentsDocument = gql`
    query FiscalConfigurationDocuments($propertyFilter: PropertyQueryFilter!, $cashDeskTypeFilter: TenantPropertyIdFilter!) {
  properties(filter: $propertyFilter) {
    fiscalConfigurations {
      name
      cashDeskTypeIds
    }
  }
  cashDeskTypes(filter: $cashDeskTypeFilter) {
    id
    name
  }
}
    `;

/**
 * __useFiscalConfigurationDocumentsQuery__
 *
 * To run a query within a React component, call `useFiscalConfigurationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalConfigurationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalConfigurationDocumentsQuery({
 *   variables: {
 *      propertyFilter: // value for 'propertyFilter'
 *      cashDeskTypeFilter: // value for 'cashDeskTypeFilter'
 *   },
 * });
 */
export function useFiscalConfigurationDocumentsQuery(baseOptions: Apollo.QueryHookOptions<FiscalConfigurationDocumentsQuery, FiscalConfigurationDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalConfigurationDocumentsQuery, FiscalConfigurationDocumentsQueryVariables>(FiscalConfigurationDocumentsDocument, options);
      }
export function useFiscalConfigurationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalConfigurationDocumentsQuery, FiscalConfigurationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalConfigurationDocumentsQuery, FiscalConfigurationDocumentsQueryVariables>(FiscalConfigurationDocumentsDocument, options);
        }
export type FiscalConfigurationDocumentsQueryHookResult = ReturnType<typeof useFiscalConfigurationDocumentsQuery>;
export type FiscalConfigurationDocumentsLazyQueryHookResult = ReturnType<typeof useFiscalConfigurationDocumentsLazyQuery>;
export type FiscalConfigurationDocumentsQueryResult = Apollo.QueryResult<FiscalConfigurationDocumentsQuery, FiscalConfigurationDocumentsQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($filter: DocumentQueryFilter!, $skip: Int, $limit: Int) {
  documents(filter: $filter, skip: $skip, limit: $limit) {
    ...DocumentsList
  }
}
    ${DocumentsListFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const SendInvoideToTSDigitalDocument = gql`
    mutation SendInvoideToTSDigital($tenantId: ID!, $id: ID!) {
  sendInvoiceToTSDigital(tenantId: $tenantId, id: $id) {
    ...FelAdditionalInfo
  }
}
    ${FelAdditionalInfoFragmentDoc}`;
export type SendInvoideToTSDigitalMutationFn = Apollo.MutationFunction<SendInvoideToTSDigitalMutation, SendInvoideToTSDigitalMutationVariables>;

/**
 * __useSendInvoideToTSDigitalMutation__
 *
 * To run a mutation, you first call `useSendInvoideToTSDigitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoideToTSDigitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoideToTsDigitalMutation, { data, loading, error }] = useSendInvoideToTSDigitalMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendInvoideToTSDigitalMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoideToTSDigitalMutation, SendInvoideToTSDigitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoideToTSDigitalMutation, SendInvoideToTSDigitalMutationVariables>(SendInvoideToTSDigitalDocument, options);
      }
export type SendInvoideToTSDigitalMutationHookResult = ReturnType<typeof useSendInvoideToTSDigitalMutation>;
export type SendInvoideToTSDigitalMutationResult = Apollo.MutationResult<SendInvoideToTSDigitalMutation>;
export type SendInvoideToTSDigitalMutationOptions = Apollo.BaseMutationOptions<SendInvoideToTSDigitalMutation, SendInvoideToTSDigitalMutationVariables>;
export const PaymentActivesDocumentsDocument = gql`
    query PaymentActivesDocuments($filter: PaymentActiveQueryFilter!) {
  paymentActives(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __usePaymentActivesDocumentsQuery__
 *
 * To run a query within a React component, call `usePaymentActivesDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentActivesDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentActivesDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentActivesDocumentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentActivesDocumentsQuery, PaymentActivesDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentActivesDocumentsQuery, PaymentActivesDocumentsQueryVariables>(PaymentActivesDocumentsDocument, options);
      }
export function usePaymentActivesDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentActivesDocumentsQuery, PaymentActivesDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentActivesDocumentsQuery, PaymentActivesDocumentsQueryVariables>(PaymentActivesDocumentsDocument, options);
        }
export type PaymentActivesDocumentsQueryHookResult = ReturnType<typeof usePaymentActivesDocumentsQuery>;
export type PaymentActivesDocumentsLazyQueryHookResult = ReturnType<typeof usePaymentActivesDocumentsLazyQuery>;
export type PaymentActivesDocumentsQueryResult = Apollo.QueryResult<PaymentActivesDocumentsQuery, PaymentActivesDocumentsQueryVariables>;
export const UpdateInvoiceStateDocument = gql`
    mutation UpdateInvoiceState($tenantId: ID!, $id: ID!) {
  updateInvoiceState(tenantId: $tenantId, id: $id) {
    ...FelAdditionalInfo
  }
}
    ${FelAdditionalInfoFragmentDoc}`;
export type UpdateInvoiceStateMutationFn = Apollo.MutationFunction<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables>;

/**
 * __useUpdateInvoiceStateMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceStateMutation, { data, loading, error }] = useUpdateInvoiceStateMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInvoiceStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables>(UpdateInvoiceStateDocument, options);
      }
export type UpdateInvoiceStateMutationHookResult = ReturnType<typeof useUpdateInvoiceStateMutation>;
export type UpdateInvoiceStateMutationResult = Apollo.MutationResult<UpdateInvoiceStateMutation>;
export type UpdateInvoiceStateMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables>;
export const SendReceiptToFiscalGatewayDocument = gql`
    mutation SendReceiptToFiscalGateway($tenantId: ID!, $id: ID!, $resend: Boolean) {
  sendReceiptToFiscalGateway(tenantId: $tenantId, id: $id, resend: $resend)
}
    `;
export type SendReceiptToFiscalGatewayMutationFn = Apollo.MutationFunction<SendReceiptToFiscalGatewayMutation, SendReceiptToFiscalGatewayMutationVariables>;

/**
 * __useSendReceiptToFiscalGatewayMutation__
 *
 * To run a mutation, you first call `useSendReceiptToFiscalGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReceiptToFiscalGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReceiptToFiscalGatewayMutation, { data, loading, error }] = useSendReceiptToFiscalGatewayMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *      resend: // value for 'resend'
 *   },
 * });
 */
export function useSendReceiptToFiscalGatewayMutation(baseOptions?: Apollo.MutationHookOptions<SendReceiptToFiscalGatewayMutation, SendReceiptToFiscalGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReceiptToFiscalGatewayMutation, SendReceiptToFiscalGatewayMutationVariables>(SendReceiptToFiscalGatewayDocument, options);
      }
export type SendReceiptToFiscalGatewayMutationHookResult = ReturnType<typeof useSendReceiptToFiscalGatewayMutation>;
export type SendReceiptToFiscalGatewayMutationResult = Apollo.MutationResult<SendReceiptToFiscalGatewayMutation>;
export type SendReceiptToFiscalGatewayMutationOptions = Apollo.BaseMutationOptions<SendReceiptToFiscalGatewayMutation, SendReceiptToFiscalGatewayMutationVariables>;
export const DocumentTotalsDocument = gql`
    query DocumentTotals($filter: DocumentQueryFilter!) {
  documentTotals(filter: $filter) {
    currency
    totals {
      totalAmount
      vatAmount
      stay
      citytax
      deposit
      advance
      other
      payments {
        paymentActiveId
        paymentActiveName
        total
      }
    }
  }
}
    `;

/**
 * __useDocumentTotalsQuery__
 *
 * To run a query within a React component, call `useDocumentTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTotalsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDocumentTotalsQuery(baseOptions: Apollo.QueryHookOptions<DocumentTotalsQuery, DocumentTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTotalsQuery, DocumentTotalsQueryVariables>(DocumentTotalsDocument, options);
      }
export function useDocumentTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTotalsQuery, DocumentTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTotalsQuery, DocumentTotalsQueryVariables>(DocumentTotalsDocument, options);
        }
export type DocumentTotalsQueryHookResult = ReturnType<typeof useDocumentTotalsQuery>;
export type DocumentTotalsLazyQueryHookResult = ReturnType<typeof useDocumentTotalsLazyQuery>;
export type DocumentTotalsQueryResult = Apollo.QueryResult<DocumentTotalsQuery, DocumentTotalsQueryVariables>;
export const UnpaidDocumentsDocument = gql`
    query UnpaidDocuments($filter: DocumentQueryFilter!, $skip: Int, $limit: Int) {
  documents(filter: $filter, skip: $skip, limit: $limit) {
    ...UnpaidDocuments
  }
}
    ${UnpaidDocumentsFragmentDoc}`;

/**
 * __useUnpaidDocumentsQuery__
 *
 * To run a query within a React component, call `useUnpaidDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnpaidDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnpaidDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUnpaidDocumentsQuery(baseOptions: Apollo.QueryHookOptions<UnpaidDocumentsQuery, UnpaidDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnpaidDocumentsQuery, UnpaidDocumentsQueryVariables>(UnpaidDocumentsDocument, options);
      }
export function useUnpaidDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnpaidDocumentsQuery, UnpaidDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnpaidDocumentsQuery, UnpaidDocumentsQueryVariables>(UnpaidDocumentsDocument, options);
        }
export type UnpaidDocumentsQueryHookResult = ReturnType<typeof useUnpaidDocumentsQuery>;
export type UnpaidDocumentsLazyQueryHookResult = ReturnType<typeof useUnpaidDocumentsLazyQuery>;
export type UnpaidDocumentsQueryResult = Apollo.QueryResult<UnpaidDocumentsQuery, UnpaidDocumentsQueryVariables>;
export const PaidInFullDocumentsDocument = gql`
    query PaidInFullDocuments($filter: DocumentQueryFilter!, $skip: Int, $limit: Int) {
  documents(filter: $filter, skip: $skip, limit: $limit) {
    ...PaidInFullDocument
  }
}
    ${PaidInFullDocumentFragmentDoc}`;

/**
 * __usePaidInFullDocumentsQuery__
 *
 * To run a query within a React component, call `usePaidInFullDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidInFullDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidInFullDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaidInFullDocumentsQuery(baseOptions: Apollo.QueryHookOptions<PaidInFullDocumentsQuery, PaidInFullDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaidInFullDocumentsQuery, PaidInFullDocumentsQueryVariables>(PaidInFullDocumentsDocument, options);
      }
export function usePaidInFullDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaidInFullDocumentsQuery, PaidInFullDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaidInFullDocumentsQuery, PaidInFullDocumentsQueryVariables>(PaidInFullDocumentsDocument, options);
        }
export type PaidInFullDocumentsQueryHookResult = ReturnType<typeof usePaidInFullDocumentsQuery>;
export type PaidInFullDocumentsLazyQueryHookResult = ReturnType<typeof usePaidInFullDocumentsLazyQuery>;
export type PaidInFullDocumentsQueryResult = Apollo.QueryResult<PaidInFullDocumentsQuery, PaidInFullDocumentsQueryVariables>;
export const CreatePaidInFullDocumentDocument = gql`
    mutation CreatePaidInFullDocument($input: PaidInFullDocumentInput!) {
  createPaidInFullDocument(input: $input)
}
    `;
export type CreatePaidInFullDocumentMutationFn = Apollo.MutationFunction<CreatePaidInFullDocumentMutation, CreatePaidInFullDocumentMutationVariables>;

/**
 * __useCreatePaidInFullDocumentMutation__
 *
 * To run a mutation, you first call `useCreatePaidInFullDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaidInFullDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaidInFullDocumentMutation, { data, loading, error }] = useCreatePaidInFullDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaidInFullDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaidInFullDocumentMutation, CreatePaidInFullDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaidInFullDocumentMutation, CreatePaidInFullDocumentMutationVariables>(CreatePaidInFullDocumentDocument, options);
      }
export type CreatePaidInFullDocumentMutationHookResult = ReturnType<typeof useCreatePaidInFullDocumentMutation>;
export type CreatePaidInFullDocumentMutationResult = Apollo.MutationResult<CreatePaidInFullDocumentMutation>;
export type CreatePaidInFullDocumentMutationOptions = Apollo.BaseMutationOptions<CreatePaidInFullDocumentMutation, CreatePaidInFullDocumentMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($tenantId: ID!, $id: String!) {
  deleteDocument(tenantId: $tenantId, id: $id)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const SendPaymentLinkEMailForUnpaidDocumentsDocument = gql`
    mutation SendPaymentLinkEMailForUnpaidDocuments($input: PaymentLinkForUnpaidDocumentsInput!) {
  sendPaymentLinkEmailForUnpaidDocuments(input: $input) {
    emailState
  }
}
    `;
export type SendPaymentLinkEMailForUnpaidDocumentsMutationFn = Apollo.MutationFunction<SendPaymentLinkEMailForUnpaidDocumentsMutation, SendPaymentLinkEMailForUnpaidDocumentsMutationVariables>;

/**
 * __useSendPaymentLinkEMailForUnpaidDocumentsMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkEMailForUnpaidDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkEMailForUnpaidDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentLinkEMailForUnpaidDocumentsMutation, { data, loading, error }] = useSendPaymentLinkEMailForUnpaidDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentLinkEMailForUnpaidDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentLinkEMailForUnpaidDocumentsMutation, SendPaymentLinkEMailForUnpaidDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentLinkEMailForUnpaidDocumentsMutation, SendPaymentLinkEMailForUnpaidDocumentsMutationVariables>(SendPaymentLinkEMailForUnpaidDocumentsDocument, options);
      }
export type SendPaymentLinkEMailForUnpaidDocumentsMutationHookResult = ReturnType<typeof useSendPaymentLinkEMailForUnpaidDocumentsMutation>;
export type SendPaymentLinkEMailForUnpaidDocumentsMutationResult = Apollo.MutationResult<SendPaymentLinkEMailForUnpaidDocumentsMutation>;
export type SendPaymentLinkEMailForUnpaidDocumentsMutationOptions = Apollo.BaseMutationOptions<SendPaymentLinkEMailForUnpaidDocumentsMutation, SendPaymentLinkEMailForUnpaidDocumentsMutationVariables>;
export const CreateLinkForUnpaidDocumentDocument = gql`
    mutation CreateLinkForUnpaidDocument($input: Link2PayUnpaidDocumentInput!) {
  createLinkForUnpaidDocument(input: $input) {
    url
  }
}
    `;
export type CreateLinkForUnpaidDocumentMutationFn = Apollo.MutationFunction<CreateLinkForUnpaidDocumentMutation, CreateLinkForUnpaidDocumentMutationVariables>;

/**
 * __useCreateLinkForUnpaidDocumentMutation__
 *
 * To run a mutation, you first call `useCreateLinkForUnpaidDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkForUnpaidDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkForUnpaidDocumentMutation, { data, loading, error }] = useCreateLinkForUnpaidDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLinkForUnpaidDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkForUnpaidDocumentMutation, CreateLinkForUnpaidDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkForUnpaidDocumentMutation, CreateLinkForUnpaidDocumentMutationVariables>(CreateLinkForUnpaidDocumentDocument, options);
      }
export type CreateLinkForUnpaidDocumentMutationHookResult = ReturnType<typeof useCreateLinkForUnpaidDocumentMutation>;
export type CreateLinkForUnpaidDocumentMutationResult = Apollo.MutationResult<CreateLinkForUnpaidDocumentMutation>;
export type CreateLinkForUnpaidDocumentMutationOptions = Apollo.BaseMutationOptions<CreateLinkForUnpaidDocumentMutation, CreateLinkForUnpaidDocumentMutationVariables>;
export const SendReminderEmailForUnpaidDocumentsDocument = gql`
    mutation SendReminderEmailForUnpaidDocuments($input: ReminderForUnpaidDocumentsInput!) {
  sendReminderEmailForUnpaidDocuments(input: $input) {
    emailState
  }
}
    `;
export type SendReminderEmailForUnpaidDocumentsMutationFn = Apollo.MutationFunction<SendReminderEmailForUnpaidDocumentsMutation, SendReminderEmailForUnpaidDocumentsMutationVariables>;

/**
 * __useSendReminderEmailForUnpaidDocumentsMutation__
 *
 * To run a mutation, you first call `useSendReminderEmailForUnpaidDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReminderEmailForUnpaidDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReminderEmailForUnpaidDocumentsMutation, { data, loading, error }] = useSendReminderEmailForUnpaidDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReminderEmailForUnpaidDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<SendReminderEmailForUnpaidDocumentsMutation, SendReminderEmailForUnpaidDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReminderEmailForUnpaidDocumentsMutation, SendReminderEmailForUnpaidDocumentsMutationVariables>(SendReminderEmailForUnpaidDocumentsDocument, options);
      }
export type SendReminderEmailForUnpaidDocumentsMutationHookResult = ReturnType<typeof useSendReminderEmailForUnpaidDocumentsMutation>;
export type SendReminderEmailForUnpaidDocumentsMutationResult = Apollo.MutationResult<SendReminderEmailForUnpaidDocumentsMutation>;
export type SendReminderEmailForUnpaidDocumentsMutationOptions = Apollo.BaseMutationOptions<SendReminderEmailForUnpaidDocumentsMutation, SendReminderEmailForUnpaidDocumentsMutationVariables>;
export const GetDocumentEmailsDocument = gql`
    query GetDocumentEmails($tenantId: ID!, $customerId: ID!, $documentId: ID) {
  getDocumentEmails(
    tenantId: $tenantId
    customerId: $customerId
    documentId: $documentId
  ) {
    ...DocumentEmail
  }
}
    ${DocumentEmailFragmentDoc}`;

/**
 * __useGetDocumentEmailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentEmailsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      customerId: // value for 'customerId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentEmailsQuery, GetDocumentEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentEmailsQuery, GetDocumentEmailsQueryVariables>(GetDocumentEmailsDocument, options);
      }
export function useGetDocumentEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentEmailsQuery, GetDocumentEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentEmailsQuery, GetDocumentEmailsQueryVariables>(GetDocumentEmailsDocument, options);
        }
export type GetDocumentEmailsQueryHookResult = ReturnType<typeof useGetDocumentEmailsQuery>;
export type GetDocumentEmailsLazyQueryHookResult = ReturnType<typeof useGetDocumentEmailsLazyQuery>;
export type GetDocumentEmailsQueryResult = Apollo.QueryResult<GetDocumentEmailsQuery, GetDocumentEmailsQueryVariables>;
export const UpdateInvoiceCustomFieldsDocument = gql`
    mutation UpdateInvoiceCustomFields($tenantId: ID!, $customFields: FelCustomFieldsInput!, $updateInvoiceCustomFieldsId: ID!) {
  updateInvoiceCustomFields(
    tenantId: $tenantId
    customFields: $customFields
    id: $updateInvoiceCustomFieldsId
  )
}
    `;
export type UpdateInvoiceCustomFieldsMutationFn = Apollo.MutationFunction<UpdateInvoiceCustomFieldsMutation, UpdateInvoiceCustomFieldsMutationVariables>;

/**
 * __useUpdateInvoiceCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceCustomFieldsMutation, { data, loading, error }] = useUpdateInvoiceCustomFieldsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      customFields: // value for 'customFields'
 *      updateInvoiceCustomFieldsId: // value for 'updateInvoiceCustomFieldsId'
 *   },
 * });
 */
export function useUpdateInvoiceCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceCustomFieldsMutation, UpdateInvoiceCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceCustomFieldsMutation, UpdateInvoiceCustomFieldsMutationVariables>(UpdateInvoiceCustomFieldsDocument, options);
      }
export type UpdateInvoiceCustomFieldsMutationHookResult = ReturnType<typeof useUpdateInvoiceCustomFieldsMutation>;
export type UpdateInvoiceCustomFieldsMutationResult = Apollo.MutationResult<UpdateInvoiceCustomFieldsMutation>;
export type UpdateInvoiceCustomFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceCustomFieldsMutation, UpdateInvoiceCustomFieldsMutationVariables>;
export const UpdateDocumentPaymentDetailsDocument = gql`
    mutation UpdateDocumentPaymentDetails($tenantId: ID!, $updateDocumentPaymentDetailsId: ID!, $paymentActiveIds: [ID!]!) {
  updateDocumentPaymentDetails(
    tenantId: $tenantId
    id: $updateDocumentPaymentDetailsId
    paymentActiveIds: $paymentActiveIds
  )
}
    `;
export type UpdateDocumentPaymentDetailsMutationFn = Apollo.MutationFunction<UpdateDocumentPaymentDetailsMutation, UpdateDocumentPaymentDetailsMutationVariables>;

/**
 * __useUpdateDocumentPaymentDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPaymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPaymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentPaymentDetailsMutation, { data, loading, error }] = useUpdateDocumentPaymentDetailsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      updateDocumentPaymentDetailsId: // value for 'updateDocumentPaymentDetailsId'
 *      paymentActiveIds: // value for 'paymentActiveIds'
 *   },
 * });
 */
export function useUpdateDocumentPaymentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentPaymentDetailsMutation, UpdateDocumentPaymentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentPaymentDetailsMutation, UpdateDocumentPaymentDetailsMutationVariables>(UpdateDocumentPaymentDetailsDocument, options);
      }
export type UpdateDocumentPaymentDetailsMutationHookResult = ReturnType<typeof useUpdateDocumentPaymentDetailsMutation>;
export type UpdateDocumentPaymentDetailsMutationResult = Apollo.MutationResult<UpdateDocumentPaymentDetailsMutation>;
export type UpdateDocumentPaymentDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentPaymentDetailsMutation, UpdateDocumentPaymentDetailsMutationVariables>;
export const accountantCategoriesDocument = gql`
    query accountantCategories($filter: AccountantCategoryQueryFilter!) {
  accountantCategories(filter: $filter) {
    id
    default {
      advance
      deposit
    }
    defaultVatId
  }
}
    `;

/**
 * __useaccountantCategoriesQuery__
 *
 * To run a query within a React component, call `useaccountantCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useaccountantCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaccountantCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useaccountantCategoriesQuery(baseOptions: Apollo.QueryHookOptions<accountantCategoriesQuery, accountantCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<accountantCategoriesQuery, accountantCategoriesQueryVariables>(accountantCategoriesDocument, options);
      }
export function useaccountantCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<accountantCategoriesQuery, accountantCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<accountantCategoriesQuery, accountantCategoriesQueryVariables>(accountantCategoriesDocument, options);
        }
export type accountantCategoriesQueryHookResult = ReturnType<typeof useaccountantCategoriesQuery>;
export type accountantCategoriesLazyQueryHookResult = ReturnType<typeof useaccountantCategoriesLazyQuery>;
export type accountantCategoriesQueryResult = Apollo.QueryResult<accountantCategoriesQuery, accountantCategoriesQueryVariables>;
export const DepositDetailDocumentsDocument = gql`
    query DepositDetailDocuments($filter: DocumentQueryFilter!) {
  documents(filter: $filter) {
    ...DepositDetailDocument
  }
}
    ${DepositDetailDocumentFragmentDoc}`;

/**
 * __useDepositDetailDocumentsQuery__
 *
 * To run a query within a React component, call `useDepositDetailDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositDetailDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositDetailDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDepositDetailDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DepositDetailDocumentsQuery, DepositDetailDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepositDetailDocumentsQuery, DepositDetailDocumentsQueryVariables>(DepositDetailDocumentsDocument, options);
      }
export function useDepositDetailDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositDetailDocumentsQuery, DepositDetailDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepositDetailDocumentsQuery, DepositDetailDocumentsQueryVariables>(DepositDetailDocumentsDocument, options);
        }
export type DepositDetailDocumentsQueryHookResult = ReturnType<typeof useDepositDetailDocumentsQuery>;
export type DepositDetailDocumentsLazyQueryHookResult = ReturnType<typeof useDepositDetailDocumentsLazyQuery>;
export type DepositDetailDocumentsQueryResult = Apollo.QueryResult<DepositDetailDocumentsQuery, DepositDetailDocumentsQueryVariables>;
export const PropertyDocument = gql`
    query Property($tenantId: ID!, $propertyId: ID!) {
  properties(
    filter: {tenantId: {eq: $tenantId}, id: {eq: $propertyId}}
    skip: 0
    limit: 1
  ) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const PropertyNewDocument = gql`
    mutation PropertyNew($input: PropertyInput!) {
  createProperty(value: $input) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export type PropertyNewMutationFn = Apollo.MutationFunction<PropertyNewMutation, PropertyNewMutationVariables>;

/**
 * __usePropertyNewMutation__
 *
 * To run a mutation, you first call `usePropertyNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePropertyNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [propertyNewMutation, { data, loading, error }] = usePropertyNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropertyNewMutation(baseOptions?: Apollo.MutationHookOptions<PropertyNewMutation, PropertyNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PropertyNewMutation, PropertyNewMutationVariables>(PropertyNewDocument, options);
      }
export type PropertyNewMutationHookResult = ReturnType<typeof usePropertyNewMutation>;
export type PropertyNewMutationResult = Apollo.MutationResult<PropertyNewMutation>;
export type PropertyNewMutationOptions = Apollo.BaseMutationOptions<PropertyNewMutation, PropertyNewMutationVariables>;
export const PropertyUpdateDocument = gql`
    mutation PropertyUpdate($id: ID!, $input: PropertyInput!) {
  updateProperty(id: $id, value: $input) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export type PropertyUpdateMutationFn = Apollo.MutationFunction<PropertyUpdateMutation, PropertyUpdateMutationVariables>;

/**
 * __usePropertyUpdateMutation__
 *
 * To run a mutation, you first call `usePropertyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePropertyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [propertyUpdateMutation, { data, loading, error }] = usePropertyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropertyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PropertyUpdateMutation, PropertyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PropertyUpdateMutation, PropertyUpdateMutationVariables>(PropertyUpdateDocument, options);
      }
export type PropertyUpdateMutationHookResult = ReturnType<typeof usePropertyUpdateMutation>;
export type PropertyUpdateMutationResult = Apollo.MutationResult<PropertyUpdateMutation>;
export type PropertyUpdateMutationOptions = Apollo.BaseMutationOptions<PropertyUpdateMutation, PropertyUpdateMutationVariables>;
export const PropertyDeleteDocument = gql`
    mutation PropertyDelete($id: ID!, $tenantId: ID!) {
  deleteProperty(id: $id, tenantId: $tenantId)
}
    `;
export type PropertyDeleteMutationFn = Apollo.MutationFunction<PropertyDeleteMutation, PropertyDeleteMutationVariables>;

/**
 * __usePropertyDeleteMutation__
 *
 * To run a mutation, you first call `usePropertyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePropertyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [propertyDeleteMutation, { data, loading, error }] = usePropertyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function usePropertyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PropertyDeleteMutation, PropertyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PropertyDeleteMutation, PropertyDeleteMutationVariables>(PropertyDeleteDocument, options);
      }
export type PropertyDeleteMutationHookResult = ReturnType<typeof usePropertyDeleteMutation>;
export type PropertyDeleteMutationResult = Apollo.MutationResult<PropertyDeleteMutation>;
export type PropertyDeleteMutationOptions = Apollo.BaseMutationOptions<PropertyDeleteMutation, PropertyDeleteMutationVariables>;
export const PropertyClassTypesDocument = gql`
    query PropertyClassTypes {
  taxonomies(filter: {type: {eq: PROPERTY_CLASSTYPE}}) {
    ...PropertyClassType
  }
}
    ${PropertyClassTypeFragmentDoc}`;

/**
 * __usePropertyClassTypesQuery__
 *
 * To run a query within a React component, call `usePropertyClassTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyClassTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyClassTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyClassTypesQuery(baseOptions?: Apollo.QueryHookOptions<PropertyClassTypesQuery, PropertyClassTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyClassTypesQuery, PropertyClassTypesQueryVariables>(PropertyClassTypesDocument, options);
      }
export function usePropertyClassTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyClassTypesQuery, PropertyClassTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyClassTypesQuery, PropertyClassTypesQueryVariables>(PropertyClassTypesDocument, options);
        }
export type PropertyClassTypesQueryHookResult = ReturnType<typeof usePropertyClassTypesQuery>;
export type PropertyClassTypesLazyQueryHookResult = ReturnType<typeof usePropertyClassTypesLazyQuery>;
export type PropertyClassTypesQueryResult = Apollo.QueryResult<PropertyClassTypesQuery, PropertyClassTypesQueryVariables>;
export const PropertyCategoriesDocument = gql`
    query PropertyCategories {
  taxonomies(filter: {type: {eq: PROPERTY_CATEGORY}}) {
    ...PropertyCategory
  }
}
    ${PropertyCategoryFragmentDoc}`;

/**
 * __usePropertyCategoriesQuery__
 *
 * To run a query within a React component, call `usePropertyCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>(PropertyCategoriesDocument, options);
      }
export function usePropertyCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>(PropertyCategoriesDocument, options);
        }
export type PropertyCategoriesQueryHookResult = ReturnType<typeof usePropertyCategoriesQuery>;
export type PropertyCategoriesLazyQueryHookResult = ReturnType<typeof usePropertyCategoriesLazyQuery>;
export type PropertyCategoriesQueryResult = Apollo.QueryResult<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>;
export const SetPropertySubAddressesDocument = gql`
    mutation SetPropertySubAddresses($tenantId: ID!, $propertyId: ID!, $config: [PropertySubAddressInput!]) {
  setPropertySubAddresses(tenantId: $tenantId, id: $propertyId, config: $config)
}
    `;
export type SetPropertySubAddressesMutationFn = Apollo.MutationFunction<SetPropertySubAddressesMutation, SetPropertySubAddressesMutationVariables>;

/**
 * __useSetPropertySubAddressesMutation__
 *
 * To run a mutation, you first call `useSetPropertySubAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertySubAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertySubAddressesMutation, { data, loading, error }] = useSetPropertySubAddressesMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSetPropertySubAddressesMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertySubAddressesMutation, SetPropertySubAddressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertySubAddressesMutation, SetPropertySubAddressesMutationVariables>(SetPropertySubAddressesDocument, options);
      }
export type SetPropertySubAddressesMutationHookResult = ReturnType<typeof useSetPropertySubAddressesMutation>;
export type SetPropertySubAddressesMutationResult = Apollo.MutationResult<SetPropertySubAddressesMutation>;
export type SetPropertySubAddressesMutationOptions = Apollo.BaseMutationOptions<SetPropertySubAddressesMutation, SetPropertySubAddressesMutationVariables>;
export const AuditsListDocument = gql`
    query AuditsList($filter: AuditQueryFilter!, $sorts: [AuditSortInput!], $limit: Int, $skip: Int) {
  audits(filter: $filter, limit: $limit, skip: $skip, sorts: $sorts) {
    ...Audit
  }
}
    ${AuditFragmentDoc}`;

/**
 * __useAuditsListQuery__
 *
 * To run a query within a React component, call `useAuditsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorts: // value for 'sorts'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAuditsListQuery(baseOptions: Apollo.QueryHookOptions<AuditsListQuery, AuditsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditsListQuery, AuditsListQueryVariables>(AuditsListDocument, options);
      }
export function useAuditsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditsListQuery, AuditsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditsListQuery, AuditsListQueryVariables>(AuditsListDocument, options);
        }
export type AuditsListQueryHookResult = ReturnType<typeof useAuditsListQuery>;
export type AuditsListLazyQueryHookResult = ReturnType<typeof useAuditsListLazyQuery>;
export type AuditsListQueryResult = Apollo.QueryResult<AuditsListQuery, AuditsListQueryVariables>;
export const ChargeCategoriesAuditDocument = gql`
    query ChargeCategoriesAudit($filter: ChargeCategoryQueryFilter!) {
  chargeCategories(filter: $filter) {
    ...ChargeCategory
  }
}
    ${ChargeCategoryFragmentDoc}`;

/**
 * __useChargeCategoriesAuditQuery__
 *
 * To run a query within a React component, call `useChargeCategoriesAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeCategoriesAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeCategoriesAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChargeCategoriesAuditQuery(baseOptions: Apollo.QueryHookOptions<ChargeCategoriesAuditQuery, ChargeCategoriesAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeCategoriesAuditQuery, ChargeCategoriesAuditQueryVariables>(ChargeCategoriesAuditDocument, options);
      }
export function useChargeCategoriesAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeCategoriesAuditQuery, ChargeCategoriesAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeCategoriesAuditQuery, ChargeCategoriesAuditQueryVariables>(ChargeCategoriesAuditDocument, options);
        }
export type ChargeCategoriesAuditQueryHookResult = ReturnType<typeof useChargeCategoriesAuditQuery>;
export type ChargeCategoriesAuditLazyQueryHookResult = ReturnType<typeof useChargeCategoriesAuditLazyQuery>;
export type ChargeCategoriesAuditQueryResult = Apollo.QueryResult<ChargeCategoriesAuditQuery, ChargeCategoriesAuditQueryVariables>;
export const VatsAuditDocument = gql`
    query VatsAudit($filter: VatQueryFilter!) {
  vats(filter: $filter) {
    ...VatAudit
  }
}
    ${VatAuditFragmentDoc}`;

/**
 * __useVatsAuditQuery__
 *
 * To run a query within a React component, call `useVatsAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatsAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatsAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVatsAuditQuery(baseOptions: Apollo.QueryHookOptions<VatsAuditQuery, VatsAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatsAuditQuery, VatsAuditQueryVariables>(VatsAuditDocument, options);
      }
export function useVatsAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatsAuditQuery, VatsAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatsAuditQuery, VatsAuditQueryVariables>(VatsAuditDocument, options);
        }
export type VatsAuditQueryHookResult = ReturnType<typeof useVatsAuditQuery>;
export type VatsAuditLazyQueryHookResult = ReturnType<typeof useVatsAuditLazyQuery>;
export type VatsAuditQueryResult = Apollo.QueryResult<VatsAuditQuery, VatsAuditQueryVariables>;
export const ReservedResourceAuditDocument = gql`
    query ReservedResourceAudit($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    ...ReservedResourceAudit
  }
}
    ${ReservedResourceAuditFragmentDoc}`;

/**
 * __useReservedResourceAuditQuery__
 *
 * To run a query within a React component, call `useReservedResourceAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservedResourceAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservedResourceAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReservedResourceAuditQuery(baseOptions: Apollo.QueryHookOptions<ReservedResourceAuditQuery, ReservedResourceAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservedResourceAuditQuery, ReservedResourceAuditQueryVariables>(ReservedResourceAuditDocument, options);
      }
export function useReservedResourceAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservedResourceAuditQuery, ReservedResourceAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservedResourceAuditQuery, ReservedResourceAuditQueryVariables>(ReservedResourceAuditDocument, options);
        }
export type ReservedResourceAuditQueryHookResult = ReturnType<typeof useReservedResourceAuditQuery>;
export type ReservedResourceAuditLazyQueryHookResult = ReturnType<typeof useReservedResourceAuditLazyQuery>;
export type ReservedResourceAuditQueryResult = Apollo.QueryResult<ReservedResourceAuditQuery, ReservedResourceAuditQueryVariables>;
export const ResourceTypeAuditDocument = gql`
    query ResourceTypeAudit($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    ...ResourceTypeAudit
  }
}
    ${ResourceTypeAuditFragmentDoc}`;

/**
 * __useResourceTypeAuditQuery__
 *
 * To run a query within a React component, call `useResourceTypeAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypeAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypeAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypeAuditQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypeAuditQuery, ResourceTypeAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypeAuditQuery, ResourceTypeAuditQueryVariables>(ResourceTypeAuditDocument, options);
      }
export function useResourceTypeAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypeAuditQuery, ResourceTypeAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypeAuditQuery, ResourceTypeAuditQueryVariables>(ResourceTypeAuditDocument, options);
        }
export type ResourceTypeAuditQueryHookResult = ReturnType<typeof useResourceTypeAuditQuery>;
export type ResourceTypeAuditLazyQueryHookResult = ReturnType<typeof useResourceTypeAuditLazyQuery>;
export type ResourceTypeAuditQueryResult = Apollo.QueryResult<ResourceTypeAuditQuery, ResourceTypeAuditQueryVariables>;
export const DeleteReservedResourceIdsDocument = gql`
    query DeleteReservedResourceIds($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter, showDeleted: true) {
    id
  }
}
    `;

/**
 * __useDeleteReservedResourceIdsQuery__
 *
 * To run a query within a React component, call `useDeleteReservedResourceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservedResourceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteReservedResourceIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteReservedResourceIdsQuery(baseOptions: Apollo.QueryHookOptions<DeleteReservedResourceIdsQuery, DeleteReservedResourceIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteReservedResourceIdsQuery, DeleteReservedResourceIdsQueryVariables>(DeleteReservedResourceIdsDocument, options);
      }
export function useDeleteReservedResourceIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteReservedResourceIdsQuery, DeleteReservedResourceIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteReservedResourceIdsQuery, DeleteReservedResourceIdsQueryVariables>(DeleteReservedResourceIdsDocument, options);
        }
export type DeleteReservedResourceIdsQueryHookResult = ReturnType<typeof useDeleteReservedResourceIdsQuery>;
export type DeleteReservedResourceIdsLazyQueryHookResult = ReturnType<typeof useDeleteReservedResourceIdsLazyQuery>;
export type DeleteReservedResourceIdsQueryResult = Apollo.QueryResult<DeleteReservedResourceIdsQuery, DeleteReservedResourceIdsQueryVariables>;
export const DeleteDocumentIdsDocument = gql`
    query DeleteDocumentIds($filter: DocumentQueryFilter!) {
  documents(filter: $filter, showDeleted: true) {
    id
  }
}
    `;

/**
 * __useDeleteDocumentIdsQuery__
 *
 * To run a query within a React component, call `useDeleteDocumentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteDocumentIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteDocumentIdsQuery(baseOptions: Apollo.QueryHookOptions<DeleteDocumentIdsQuery, DeleteDocumentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteDocumentIdsQuery, DeleteDocumentIdsQueryVariables>(DeleteDocumentIdsDocument, options);
      }
export function useDeleteDocumentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteDocumentIdsQuery, DeleteDocumentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteDocumentIdsQuery, DeleteDocumentIdsQueryVariables>(DeleteDocumentIdsDocument, options);
        }
export type DeleteDocumentIdsQueryHookResult = ReturnType<typeof useDeleteDocumentIdsQuery>;
export type DeleteDocumentIdsLazyQueryHookResult = ReturnType<typeof useDeleteDocumentIdsLazyQuery>;
export type DeleteDocumentIdsQueryResult = Apollo.QueryResult<DeleteDocumentIdsQuery, DeleteDocumentIdsQueryVariables>;
export const DeleteBillIdsDocument = gql`
    query DeleteBillIds($filter: BillQueryFilter!) {
  bills(filter: $filter, showDeleted: true) {
    id
  }
}
    `;

/**
 * __useDeleteBillIdsQuery__
 *
 * To run a query within a React component, call `useDeleteBillIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteBillIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteBillIdsQuery(baseOptions: Apollo.QueryHookOptions<DeleteBillIdsQuery, DeleteBillIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteBillIdsQuery, DeleteBillIdsQueryVariables>(DeleteBillIdsDocument, options);
      }
export function useDeleteBillIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteBillIdsQuery, DeleteBillIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteBillIdsQuery, DeleteBillIdsQueryVariables>(DeleteBillIdsDocument, options);
        }
export type DeleteBillIdsQueryHookResult = ReturnType<typeof useDeleteBillIdsQuery>;
export type DeleteBillIdsLazyQueryHookResult = ReturnType<typeof useDeleteBillIdsLazyQuery>;
export type DeleteBillIdsQueryResult = Apollo.QueryResult<DeleteBillIdsQuery, DeleteBillIdsQueryVariables>;
export const DeleteProductionIdsDocument = gql`
    query DeleteProductionIds($filter: ProductionQueryFilter!) {
  productions(filter: $filter, showDeleted: true) {
    id
  }
}
    `;

/**
 * __useDeleteProductionIdsQuery__
 *
 * To run a query within a React component, call `useDeleteProductionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteProductionIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteProductionIdsQuery(baseOptions: Apollo.QueryHookOptions<DeleteProductionIdsQuery, DeleteProductionIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteProductionIdsQuery, DeleteProductionIdsQueryVariables>(DeleteProductionIdsDocument, options);
      }
export function useDeleteProductionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteProductionIdsQuery, DeleteProductionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteProductionIdsQuery, DeleteProductionIdsQueryVariables>(DeleteProductionIdsDocument, options);
        }
export type DeleteProductionIdsQueryHookResult = ReturnType<typeof useDeleteProductionIdsQuery>;
export type DeleteProductionIdsLazyQueryHookResult = ReturnType<typeof useDeleteProductionIdsLazyQuery>;
export type DeleteProductionIdsQueryResult = Apollo.QueryResult<DeleteProductionIdsQuery, DeleteProductionIdsQueryVariables>;
export const DeleteDepositDocumentIdsDocument = gql`
    query DeleteDepositDocumentIds($filter: DepositDocumentQueryFilter!) {
  depositDocuments(filter: $filter, showDeleted: true) {
    id
  }
}
    `;

/**
 * __useDeleteDepositDocumentIdsQuery__
 *
 * To run a query within a React component, call `useDeleteDepositDocumentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepositDocumentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteDepositDocumentIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteDepositDocumentIdsQuery(baseOptions: Apollo.QueryHookOptions<DeleteDepositDocumentIdsQuery, DeleteDepositDocumentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteDepositDocumentIdsQuery, DeleteDepositDocumentIdsQueryVariables>(DeleteDepositDocumentIdsDocument, options);
      }
export function useDeleteDepositDocumentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteDepositDocumentIdsQuery, DeleteDepositDocumentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteDepositDocumentIdsQuery, DeleteDepositDocumentIdsQueryVariables>(DeleteDepositDocumentIdsDocument, options);
        }
export type DeleteDepositDocumentIdsQueryHookResult = ReturnType<typeof useDeleteDepositDocumentIdsQuery>;
export type DeleteDepositDocumentIdsLazyQueryHookResult = ReturnType<typeof useDeleteDepositDocumentIdsLazyQuery>;
export type DeleteDepositDocumentIdsQueryResult = Apollo.QueryResult<DeleteDepositDocumentIdsQuery, DeleteDepositDocumentIdsQueryVariables>;
export const BillsDocument = gql`
    query Bills($filter: OpenBillsQueryFilter!, $limit: Int) {
  openBills(filter: $filter, limit: $limit) {
    ...BillPage
  }
}
    ${BillPageFragmentDoc}`;

/**
 * __useBillsQuery__
 *
 * To run a query within a React component, call `useBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBillsQuery(baseOptions: Apollo.QueryHookOptions<BillsQuery, BillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
      }
export function useBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillsQuery, BillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
        }
export type BillsQueryHookResult = ReturnType<typeof useBillsQuery>;
export type BillsLazyQueryHookResult = ReturnType<typeof useBillsLazyQuery>;
export type BillsQueryResult = Apollo.QueryResult<BillsQuery, BillsQueryVariables>;
export const DepositAssignedBillPageDocument = gql`
    query DepositAssignedBillPage($filter: ReservationQueryFilter!) {
  reservations(filter: $filter) {
    depositAssigneds {
      depositDocumentId
    }
  }
}
    `;

/**
 * __useDepositAssignedBillPageQuery__
 *
 * To run a query within a React component, call `useDepositAssignedBillPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositAssignedBillPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositAssignedBillPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDepositAssignedBillPageQuery(baseOptions: Apollo.QueryHookOptions<DepositAssignedBillPageQuery, DepositAssignedBillPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepositAssignedBillPageQuery, DepositAssignedBillPageQueryVariables>(DepositAssignedBillPageDocument, options);
      }
export function useDepositAssignedBillPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositAssignedBillPageQuery, DepositAssignedBillPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepositAssignedBillPageQuery, DepositAssignedBillPageQueryVariables>(DepositAssignedBillPageDocument, options);
        }
export type DepositAssignedBillPageQueryHookResult = ReturnType<typeof useDepositAssignedBillPageQuery>;
export type DepositAssignedBillPageLazyQueryHookResult = ReturnType<typeof useDepositAssignedBillPageLazyQuery>;
export type DepositAssignedBillPageQueryResult = Apollo.QueryResult<DepositAssignedBillPageQuery, DepositAssignedBillPageQueryVariables>;
export const AdditionalInfoBillPageDocument = gql`
    query AdditionalInfoBillPage($chargeCategoryFilter: ChargeCategoryQueryFilter!, $vatFilter: VatQueryFilter!, $resourceTypeFilter: ResourceTypeQueryFilter!, $resourceFilter: ResourceQueryFilter!) {
  chargeCategories(filter: $chargeCategoryFilter) {
    ...ChargeCategoryBillPage
  }
  vats(filter: $vatFilter) {
    ...VatBillPage
  }
  resourceTypes(filter: $resourceTypeFilter) {
    ...ResourceTypeBillPage
  }
  resources(filter: $resourceFilter) {
    ...ResourceBillPage
  }
}
    ${ChargeCategoryBillPageFragmentDoc}
${VatBillPageFragmentDoc}
${ResourceTypeBillPageFragmentDoc}
${ResourceBillPageFragmentDoc}`;

/**
 * __useAdditionalInfoBillPageQuery__
 *
 * To run a query within a React component, call `useAdditionalInfoBillPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalInfoBillPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalInfoBillPageQuery({
 *   variables: {
 *      chargeCategoryFilter: // value for 'chargeCategoryFilter'
 *      vatFilter: // value for 'vatFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      resourceFilter: // value for 'resourceFilter'
 *   },
 * });
 */
export function useAdditionalInfoBillPageQuery(baseOptions: Apollo.QueryHookOptions<AdditionalInfoBillPageQuery, AdditionalInfoBillPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalInfoBillPageQuery, AdditionalInfoBillPageQueryVariables>(AdditionalInfoBillPageDocument, options);
      }
export function useAdditionalInfoBillPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalInfoBillPageQuery, AdditionalInfoBillPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalInfoBillPageQuery, AdditionalInfoBillPageQueryVariables>(AdditionalInfoBillPageDocument, options);
        }
export type AdditionalInfoBillPageQueryHookResult = ReturnType<typeof useAdditionalInfoBillPageQuery>;
export type AdditionalInfoBillPageLazyQueryHookResult = ReturnType<typeof useAdditionalInfoBillPageLazyQuery>;
export type AdditionalInfoBillPageQueryResult = Apollo.QueryResult<AdditionalInfoBillPageQuery, AdditionalInfoBillPageQueryVariables>;
export const BillSearchDocument = gql`
    query BillSearch($skip: Int, $filter: BillQueryFilter!, $limit: Int) {
  bills(skip: $skip, filter: $filter, limit: $limit) {
    ...BillItem
  }
}
    ${BillItemFragmentDoc}`;

/**
 * __useBillSearchQuery__
 *
 * To run a query within a React component, call `useBillSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillSearchQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBillSearchQuery(baseOptions: Apollo.QueryHookOptions<BillSearchQuery, BillSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillSearchQuery, BillSearchQueryVariables>(BillSearchDocument, options);
      }
export function useBillSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillSearchQuery, BillSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillSearchQuery, BillSearchQueryVariables>(BillSearchDocument, options);
        }
export type BillSearchQueryHookResult = ReturnType<typeof useBillSearchQuery>;
export type BillSearchLazyQueryHookResult = ReturnType<typeof useBillSearchLazyQuery>;
export type BillSearchQueryResult = Apollo.QueryResult<BillSearchQuery, BillSearchQueryVariables>;
export const BillsListDocument = gql`
    query BillsList($skip: Int, $filter: BillQueryFilter!, $limit: Int) {
  bills(skip: $skip, filter: $filter, limit: $limit) {
    ...BillListItem
  }
}
    ${BillListItemFragmentDoc}`;

/**
 * __useBillsListQuery__
 *
 * To run a query within a React component, call `useBillsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBillsListQuery(baseOptions: Apollo.QueryHookOptions<BillsListQuery, BillsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillsListQuery, BillsListQueryVariables>(BillsListDocument, options);
      }
export function useBillsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillsListQuery, BillsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillsListQuery, BillsListQueryVariables>(BillsListDocument, options);
        }
export type BillsListQueryHookResult = ReturnType<typeof useBillsListQuery>;
export type BillsListLazyQueryHookResult = ReturnType<typeof useBillsListLazyQuery>;
export type BillsListQueryResult = Apollo.QueryResult<BillsListQuery, BillsListQueryVariables>;
export const CreateBillDocument = gql`
    mutation CreateBill($value: BillInput!) {
  createBill(value: $value) {
    ...BillItem
  }
}
    ${BillItemFragmentDoc}`;
export type CreateBillMutationFn = Apollo.MutationFunction<CreateBillMutation, CreateBillMutationVariables>;

/**
 * __useCreateBillMutation__
 *
 * To run a mutation, you first call `useCreateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillMutation, { data, loading, error }] = useCreateBillMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateBillMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillMutation, CreateBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillMutation, CreateBillMutationVariables>(CreateBillDocument, options);
      }
export type CreateBillMutationHookResult = ReturnType<typeof useCreateBillMutation>;
export type CreateBillMutationResult = Apollo.MutationResult<CreateBillMutation>;
export type CreateBillMutationOptions = Apollo.BaseMutationOptions<CreateBillMutation, CreateBillMutationVariables>;
export const UpdateBillDocument = gql`
    mutation UpdateBill($updateBillId: ID!, $value: BillInput!) {
  updateBill(id: $updateBillId, value: $value) {
    ...BillListItem
  }
}
    ${BillListItemFragmentDoc}`;
export type UpdateBillMutationFn = Apollo.MutationFunction<UpdateBillMutation, UpdateBillMutationVariables>;

/**
 * __useUpdateBillMutation__
 *
 * To run a mutation, you first call `useUpdateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillMutation, { data, loading, error }] = useUpdateBillMutation({
 *   variables: {
 *      updateBillId: // value for 'updateBillId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateBillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillMutation, UpdateBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillMutation, UpdateBillMutationVariables>(UpdateBillDocument, options);
      }
export type UpdateBillMutationHookResult = ReturnType<typeof useUpdateBillMutation>;
export type UpdateBillMutationResult = Apollo.MutationResult<UpdateBillMutation>;
export type UpdateBillMutationOptions = Apollo.BaseMutationOptions<UpdateBillMutation, UpdateBillMutationVariables>;
export const DeleteBillDocument = gql`
    mutation DeleteBill($deleteBillTenantId: ID!, $deleteBillId: ID!) {
  deleteBill(tenantId: $deleteBillTenantId, id: $deleteBillId)
}
    `;
export type DeleteBillMutationFn = Apollo.MutationFunction<DeleteBillMutation, DeleteBillMutationVariables>;

/**
 * __useDeleteBillMutation__
 *
 * To run a mutation, you first call `useDeleteBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillMutation, { data, loading, error }] = useDeleteBillMutation({
 *   variables: {
 *      deleteBillTenantId: // value for 'deleteBillTenantId'
 *      deleteBillId: // value for 'deleteBillId'
 *   },
 * });
 */
export function useDeleteBillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillMutation, DeleteBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillMutation, DeleteBillMutationVariables>(DeleteBillDocument, options);
      }
export type DeleteBillMutationHookResult = ReturnType<typeof useDeleteBillMutation>;
export type DeleteBillMutationResult = Apollo.MutationResult<DeleteBillMutation>;
export type DeleteBillMutationOptions = Apollo.BaseMutationOptions<DeleteBillMutation, DeleteBillMutationVariables>;
export const CreateProductionDocument = gql`
    mutation CreateProduction($value: ProductionInput!, $billAllocation: [BillAllocationInput!]!) {
  createProduction(value: $value, billAllocation: $billAllocation) {
    id
  }
}
    `;
export type CreateProductionMutationFn = Apollo.MutationFunction<CreateProductionMutation, CreateProductionMutationVariables>;

/**
 * __useCreateProductionMutation__
 *
 * To run a mutation, you first call `useCreateProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductionMutation, { data, loading, error }] = useCreateProductionMutation({
 *   variables: {
 *      value: // value for 'value'
 *      billAllocation: // value for 'billAllocation'
 *   },
 * });
 */
export function useCreateProductionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductionMutation, CreateProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductionMutation, CreateProductionMutationVariables>(CreateProductionDocument, options);
      }
export type CreateProductionMutationHookResult = ReturnType<typeof useCreateProductionMutation>;
export type CreateProductionMutationResult = Apollo.MutationResult<CreateProductionMutation>;
export type CreateProductionMutationOptions = Apollo.BaseMutationOptions<CreateProductionMutation, CreateProductionMutationVariables>;
export const GetAllAvailableResourcesDocument = gql`
    query GetAllAvailableResources($tenantId: ID!, $propertyId: ID!, $excludeReservedResourceId: ID!, $start: Date!, $end: Date!, $time: TimeRangeInput, $resourceTypeId: ID) {
  getAllAvailableResources(
    filter: {startDate: $start, endDate: $end, tenantId: $tenantId, propertyId: $propertyId, excludeReservedResourceId: $excludeReservedResourceId, time: $time, resourceTypeId: $resourceTypeId}
  ) {
    id
    code
    resourceTypeId
  }
}
    `;

/**
 * __useGetAllAvailableResourcesQuery__
 *
 * To run a query within a React component, call `useGetAllAvailableResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAvailableResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAvailableResourcesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      excludeReservedResourceId: // value for 'excludeReservedResourceId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      time: // value for 'time'
 *      resourceTypeId: // value for 'resourceTypeId'
 *   },
 * });
 */
export function useGetAllAvailableResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetAllAvailableResourcesQuery, GetAllAvailableResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAvailableResourcesQuery, GetAllAvailableResourcesQueryVariables>(GetAllAvailableResourcesDocument, options);
      }
export function useGetAllAvailableResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAvailableResourcesQuery, GetAllAvailableResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAvailableResourcesQuery, GetAllAvailableResourcesQueryVariables>(GetAllAvailableResourcesDocument, options);
        }
export type GetAllAvailableResourcesQueryHookResult = ReturnType<typeof useGetAllAvailableResourcesQuery>;
export type GetAllAvailableResourcesLazyQueryHookResult = ReturnType<typeof useGetAllAvailableResourcesLazyQuery>;
export type GetAllAvailableResourcesQueryResult = Apollo.QueryResult<GetAllAvailableResourcesQuery, GetAllAvailableResourcesQueryVariables>;
export const DailyAvailabilitiesDocument = gql`
    query DailyAvailabilities($tenantId: ID!, $propertyId: ID!, $start: Date!, $end: Date!, $resourceTypeIds: [ID!]!) {
  dailyAvailabilities(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, dateRange: {start: $start, end: $end}, resourceTypeId: {in: $resourceTypeIds}}
  ) {
    availability
    day
    resourceTypeId
  }
}
    `;

/**
 * __useDailyAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useDailyAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyAvailabilitiesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      resourceTypeIds: // value for 'resourceTypeIds'
 *   },
 * });
 */
export function useDailyAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<DailyAvailabilitiesQuery, DailyAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyAvailabilitiesQuery, DailyAvailabilitiesQueryVariables>(DailyAvailabilitiesDocument, options);
      }
export function useDailyAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyAvailabilitiesQuery, DailyAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyAvailabilitiesQuery, DailyAvailabilitiesQueryVariables>(DailyAvailabilitiesDocument, options);
        }
export type DailyAvailabilitiesQueryHookResult = ReturnType<typeof useDailyAvailabilitiesQuery>;
export type DailyAvailabilitiesLazyQueryHookResult = ReturnType<typeof useDailyAvailabilitiesLazyQuery>;
export type DailyAvailabilitiesQueryResult = Apollo.QueryResult<DailyAvailabilitiesQuery, DailyAvailabilitiesQueryVariables>;
export const PlanningReservedResourcesDocument = gql`
    query PlanningReservedResources($tenantId: ID!, $propertyId: ID!, $start: Date!, $end: Date!) {
  reservedResources(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, dateRange: {start: $start, end: $end}, excludeCanceled: true}
  ) {
    ...PlanningReservedResource
  }
}
    ${PlanningReservedResourceFragmentDoc}`;

/**
 * __usePlanningReservedResourcesQuery__
 *
 * To run a query within a React component, call `usePlanningReservedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningReservedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningReservedResourcesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function usePlanningReservedResourcesQuery(baseOptions: Apollo.QueryHookOptions<PlanningReservedResourcesQuery, PlanningReservedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningReservedResourcesQuery, PlanningReservedResourcesQueryVariables>(PlanningReservedResourcesDocument, options);
      }
export function usePlanningReservedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningReservedResourcesQuery, PlanningReservedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningReservedResourcesQuery, PlanningReservedResourcesQueryVariables>(PlanningReservedResourcesDocument, options);
        }
export type PlanningReservedResourcesQueryHookResult = ReturnType<typeof usePlanningReservedResourcesQuery>;
export type PlanningReservedResourcesLazyQueryHookResult = ReturnType<typeof usePlanningReservedResourcesLazyQuery>;
export type PlanningReservedResourcesQueryResult = Apollo.QueryResult<PlanningReservedResourcesQuery, PlanningReservedResourcesQueryVariables>;
export const PlanningReservedResourceDetailsDocument = gql`
    query PlanningReservedResourceDetails($tenantId: ID!, $propertyId: ID!, $reservedResourceId: ID!) {
  reservedResources(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {eq: $reservedResourceId}}
  ) {
    ...PlanningReservedResourceDetails
  }
}
    ${PlanningReservedResourceDetailsFragmentDoc}`;

/**
 * __usePlanningReservedResourceDetailsQuery__
 *
 * To run a query within a React component, call `usePlanningReservedResourceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningReservedResourceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningReservedResourceDetailsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      reservedResourceId: // value for 'reservedResourceId'
 *   },
 * });
 */
export function usePlanningReservedResourceDetailsQuery(baseOptions: Apollo.QueryHookOptions<PlanningReservedResourceDetailsQuery, PlanningReservedResourceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningReservedResourceDetailsQuery, PlanningReservedResourceDetailsQueryVariables>(PlanningReservedResourceDetailsDocument, options);
      }
export function usePlanningReservedResourceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningReservedResourceDetailsQuery, PlanningReservedResourceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningReservedResourceDetailsQuery, PlanningReservedResourceDetailsQueryVariables>(PlanningReservedResourceDetailsDocument, options);
        }
export type PlanningReservedResourceDetailsQueryHookResult = ReturnType<typeof usePlanningReservedResourceDetailsQuery>;
export type PlanningReservedResourceDetailsLazyQueryHookResult = ReturnType<typeof usePlanningReservedResourceDetailsLazyQuery>;
export type PlanningReservedResourceDetailsQueryResult = Apollo.QueryResult<PlanningReservedResourceDetailsQuery, PlanningReservedResourceDetailsQueryVariables>;
export const ReservedResourcesDocument = gql`
    subscription ReservedResources($filter: ReservedResourceEventFilter!) {
  reservedResourceEvent(filter: $filter) {
    id
    operation
  }
}
    `;

/**
 * __useReservedResourcesSubscription__
 *
 * To run a query within a React component, call `useReservedResourcesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReservedResourcesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservedResourcesSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReservedResourcesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReservedResourcesSubscription, ReservedResourcesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReservedResourcesSubscription, ReservedResourcesSubscriptionVariables>(ReservedResourcesDocument, options);
      }
export type ReservedResourcesSubscriptionHookResult = ReturnType<typeof useReservedResourcesSubscription>;
export type ReservedResourcesSubscriptionResult = Apollo.SubscriptionResult<ReservedResourcesSubscription>;
export const PlanningResourceTypesDocument = gql`
    query PlanningResourceTypes($tenantId: ID!, $propertyId: ID!, $timeResource: Boolean, $resourceTypeId: IDFilter) {
  resourceTypes(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, timeResources: $timeResource, id: $resourceTypeId}
    limit: 100
  ) {
    ...ResourceTypeForPlanning
  }
}
    ${ResourceTypeForPlanningFragmentDoc}`;

/**
 * __usePlanningResourceTypesQuery__
 *
 * To run a query within a React component, call `usePlanningResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningResourceTypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      timeResource: // value for 'timeResource'
 *      resourceTypeId: // value for 'resourceTypeId'
 *   },
 * });
 */
export function usePlanningResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<PlanningResourceTypesQuery, PlanningResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningResourceTypesQuery, PlanningResourceTypesQueryVariables>(PlanningResourceTypesDocument, options);
      }
export function usePlanningResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningResourceTypesQuery, PlanningResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningResourceTypesQuery, PlanningResourceTypesQueryVariables>(PlanningResourceTypesDocument, options);
        }
export type PlanningResourceTypesQueryHookResult = ReturnType<typeof usePlanningResourceTypesQuery>;
export type PlanningResourceTypesLazyQueryHookResult = ReturnType<typeof usePlanningResourceTypesLazyQuery>;
export type PlanningResourceTypesQueryResult = Apollo.QueryResult<PlanningResourceTypesQuery, PlanningResourceTypesQueryVariables>;
export const PlanningDailyAvailabilitiesDocument = gql`
    query PlanningDailyAvailabilities($tenantId: ID!, $propertyId: ID!, $start: Date!, $end: Date!) {
  dailyAvailabilities(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, dateRange: {start: $start, end: $end}}
    limit: 1000
  ) {
    day
    resourceTypeId
    availability
    resources {
      type
      resourceId
    }
  }
}
    `;

/**
 * __usePlanningDailyAvailabilitiesQuery__
 *
 * To run a query within a React component, call `usePlanningDailyAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningDailyAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningDailyAvailabilitiesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function usePlanningDailyAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<PlanningDailyAvailabilitiesQuery, PlanningDailyAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningDailyAvailabilitiesQuery, PlanningDailyAvailabilitiesQueryVariables>(PlanningDailyAvailabilitiesDocument, options);
      }
export function usePlanningDailyAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningDailyAvailabilitiesQuery, PlanningDailyAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningDailyAvailabilitiesQuery, PlanningDailyAvailabilitiesQueryVariables>(PlanningDailyAvailabilitiesDocument, options);
        }
export type PlanningDailyAvailabilitiesQueryHookResult = ReturnType<typeof usePlanningDailyAvailabilitiesQuery>;
export type PlanningDailyAvailabilitiesLazyQueryHookResult = ReturnType<typeof usePlanningDailyAvailabilitiesLazyQuery>;
export type PlanningDailyAvailabilitiesQueryResult = Apollo.QueryResult<PlanningDailyAvailabilitiesQuery, PlanningDailyAvailabilitiesQueryVariables>;
export const PlanningReservationInfoDocument = gql`
    query PlanningReservationInfo($tenantId: ID!, $propertyId: ID!, $reservationId: ID!) {
  reservations(
    filter: {tenantId: {eq: $tenantId}, propertyId: $propertyId, id: {eq: $reservationId}}
  ) {
    ...PlanningReservationInfoData
  }
  depositDocuments(
    filter: {tenantId: {eq: $tenantId}, reservationId: $reservationId}
  ) {
    ...PlanningReservationDepositInfoData
  }
}
    ${PlanningReservationInfoDataFragmentDoc}
${PlanningReservationDepositInfoDataFragmentDoc}`;

/**
 * __usePlanningReservationInfoQuery__
 *
 * To run a query within a React component, call `usePlanningReservationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningReservationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningReservationInfoQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function usePlanningReservationInfoQuery(baseOptions: Apollo.QueryHookOptions<PlanningReservationInfoQuery, PlanningReservationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningReservationInfoQuery, PlanningReservationInfoQueryVariables>(PlanningReservationInfoDocument, options);
      }
export function usePlanningReservationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningReservationInfoQuery, PlanningReservationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningReservationInfoQuery, PlanningReservationInfoQueryVariables>(PlanningReservationInfoDocument, options);
        }
export type PlanningReservationInfoQueryHookResult = ReturnType<typeof usePlanningReservationInfoQuery>;
export type PlanningReservationInfoLazyQueryHookResult = ReturnType<typeof usePlanningReservationInfoLazyQuery>;
export type PlanningReservationInfoQueryResult = Apollo.QueryResult<PlanningReservationInfoQuery, PlanningReservationInfoQueryVariables>;
export const GetPriceCalendarDocument = gql`
    query GetPriceCalendar($filter: PriceCalendarFilter!) {
  getPriceCalendar(filter: $filter) {
    ...PriceCalendarDay
  }
}
    ${PriceCalendarDayFragmentDoc}`;

/**
 * __useGetPriceCalendarQuery__
 *
 * To run a query within a React component, call `useGetPriceCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceCalendarQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPriceCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetPriceCalendarQuery, GetPriceCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceCalendarQuery, GetPriceCalendarQueryVariables>(GetPriceCalendarDocument, options);
      }
export function useGetPriceCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceCalendarQuery, GetPriceCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceCalendarQuery, GetPriceCalendarQueryVariables>(GetPriceCalendarDocument, options);
        }
export type GetPriceCalendarQueryHookResult = ReturnType<typeof useGetPriceCalendarQuery>;
export type GetPriceCalendarLazyQueryHookResult = ReturnType<typeof useGetPriceCalendarLazyQuery>;
export type GetPriceCalendarQueryResult = Apollo.QueryResult<GetPriceCalendarQuery, GetPriceCalendarQueryVariables>;
export const ResourceTypeAndRateAndChargeCategoryDocument = gql`
    query ResourceTypeAndRateAndChargeCategory($filterResourceType: ResourceTypeQueryFilter!, $filterRate: RateQueryFilter!, $filterChargeCategory: ChargeCategoryQueryFilter!) {
  resourceTypes(filter: $filterResourceType) {
    ...ResourceType
  }
  rates(filter: $filterRate) {
    ...Rate
  }
  chargeCategories(filter: $filterChargeCategory) {
    ...ChargeCategory
  }
}
    ${ResourceTypeFragmentDoc}
${RateFragmentDoc}
${ChargeCategoryFragmentDoc}`;

/**
 * __useResourceTypeAndRateAndChargeCategoryQuery__
 *
 * To run a query within a React component, call `useResourceTypeAndRateAndChargeCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypeAndRateAndChargeCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypeAndRateAndChargeCategoryQuery({
 *   variables: {
 *      filterResourceType: // value for 'filterResourceType'
 *      filterRate: // value for 'filterRate'
 *      filterChargeCategory: // value for 'filterChargeCategory'
 *   },
 * });
 */
export function useResourceTypeAndRateAndChargeCategoryQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypeAndRateAndChargeCategoryQuery, ResourceTypeAndRateAndChargeCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypeAndRateAndChargeCategoryQuery, ResourceTypeAndRateAndChargeCategoryQueryVariables>(ResourceTypeAndRateAndChargeCategoryDocument, options);
      }
export function useResourceTypeAndRateAndChargeCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypeAndRateAndChargeCategoryQuery, ResourceTypeAndRateAndChargeCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypeAndRateAndChargeCategoryQuery, ResourceTypeAndRateAndChargeCategoryQueryVariables>(ResourceTypeAndRateAndChargeCategoryDocument, options);
        }
export type ResourceTypeAndRateAndChargeCategoryQueryHookResult = ReturnType<typeof useResourceTypeAndRateAndChargeCategoryQuery>;
export type ResourceTypeAndRateAndChargeCategoryLazyQueryHookResult = ReturnType<typeof useResourceTypeAndRateAndChargeCategoryLazyQuery>;
export type ResourceTypeAndRateAndChargeCategoryQueryResult = Apollo.QueryResult<ResourceTypeAndRateAndChargeCategoryQuery, ResourceTypeAndRateAndChargeCategoryQueryVariables>;
export const UpdatePriceCalendarDocument = gql`
    mutation UpdatePriceCalendar($value: PriceCalendarInput!) {
  updatePriceCalendar(value: $value)
}
    `;
export type UpdatePriceCalendarMutationFn = Apollo.MutationFunction<UpdatePriceCalendarMutation, UpdatePriceCalendarMutationVariables>;

/**
 * __useUpdatePriceCalendarMutation__
 *
 * To run a mutation, you first call `useUpdatePriceCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceCalendarMutation, { data, loading, error }] = useUpdatePriceCalendarMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePriceCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceCalendarMutation, UpdatePriceCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceCalendarMutation, UpdatePriceCalendarMutationVariables>(UpdatePriceCalendarDocument, options);
      }
export type UpdatePriceCalendarMutationHookResult = ReturnType<typeof useUpdatePriceCalendarMutation>;
export type UpdatePriceCalendarMutationResult = Apollo.MutationResult<UpdatePriceCalendarMutation>;
export type UpdatePriceCalendarMutationOptions = Apollo.BaseMutationOptions<UpdatePriceCalendarMutation, UpdatePriceCalendarMutationVariables>;
export const UpdatePriceCalendarRangeDocument = gql`
    mutation UpdatePriceCalendarRange($value: PriceCalendarRangeInput!) {
  updatePriceCalendarRange(value: $value)
}
    `;
export type UpdatePriceCalendarRangeMutationFn = Apollo.MutationFunction<UpdatePriceCalendarRangeMutation, UpdatePriceCalendarRangeMutationVariables>;

/**
 * __useUpdatePriceCalendarRangeMutation__
 *
 * To run a mutation, you first call `useUpdatePriceCalendarRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceCalendarRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceCalendarRangeMutation, { data, loading, error }] = useUpdatePriceCalendarRangeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePriceCalendarRangeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceCalendarRangeMutation, UpdatePriceCalendarRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceCalendarRangeMutation, UpdatePriceCalendarRangeMutationVariables>(UpdatePriceCalendarRangeDocument, options);
      }
export type UpdatePriceCalendarRangeMutationHookResult = ReturnType<typeof useUpdatePriceCalendarRangeMutation>;
export type UpdatePriceCalendarRangeMutationResult = Apollo.MutationResult<UpdatePriceCalendarRangeMutation>;
export type UpdatePriceCalendarRangeMutationOptions = Apollo.BaseMutationOptions<UpdatePriceCalendarRangeMutation, UpdatePriceCalendarRangeMutationVariables>;
export const MoveProductionAssignedDocument = gql`
    mutation MoveProductionAssigned($input: MoveProductionAssignedInput!) {
  moveProductionAssigned(input: $input)
}
    `;
export type MoveProductionAssignedMutationFn = Apollo.MutationFunction<MoveProductionAssignedMutation, MoveProductionAssignedMutationVariables>;

/**
 * __useMoveProductionAssignedMutation__
 *
 * To run a mutation, you first call `useMoveProductionAssignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProductionAssignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProductionAssignedMutation, { data, loading, error }] = useMoveProductionAssignedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveProductionAssignedMutation(baseOptions?: Apollo.MutationHookOptions<MoveProductionAssignedMutation, MoveProductionAssignedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveProductionAssignedMutation, MoveProductionAssignedMutationVariables>(MoveProductionAssignedDocument, options);
      }
export type MoveProductionAssignedMutationHookResult = ReturnType<typeof useMoveProductionAssignedMutation>;
export type MoveProductionAssignedMutationResult = Apollo.MutationResult<MoveProductionAssignedMutation>;
export type MoveProductionAssignedMutationOptions = Apollo.BaseMutationOptions<MoveProductionAssignedMutation, MoveProductionAssignedMutationVariables>;
export const SplitProductionAssignedDocument = gql`
    mutation SplitProductionAssigned($input: SplitProductionAssignedInput!) {
  splitProductionAssigned(input: $input)
}
    `;
export type SplitProductionAssignedMutationFn = Apollo.MutationFunction<SplitProductionAssignedMutation, SplitProductionAssignedMutationVariables>;

/**
 * __useSplitProductionAssignedMutation__
 *
 * To run a mutation, you first call `useSplitProductionAssignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitProductionAssignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitProductionAssignedMutation, { data, loading, error }] = useSplitProductionAssignedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitProductionAssignedMutation(baseOptions?: Apollo.MutationHookOptions<SplitProductionAssignedMutation, SplitProductionAssignedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitProductionAssignedMutation, SplitProductionAssignedMutationVariables>(SplitProductionAssignedDocument, options);
      }
export type SplitProductionAssignedMutationHookResult = ReturnType<typeof useSplitProductionAssignedMutation>;
export type SplitProductionAssignedMutationResult = Apollo.MutationResult<SplitProductionAssignedMutation>;
export type SplitProductionAssignedMutationOptions = Apollo.BaseMutationOptions<SplitProductionAssignedMutation, SplitProductionAssignedMutationVariables>;
export const deleteProductionDocument = gql`
    mutation deleteProduction($tenantId: ID!, $id: ID!) {
  deleteProduction(tenantId: $tenantId, id: $id)
}
    `;
export type deleteProductionMutationFn = Apollo.MutationFunction<deleteProductionMutation, deleteProductionMutationVariables>;

/**
 * __usedeleteProductionMutation__
 *
 * To run a mutation, you first call `usedeleteProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usedeleteProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductionMutation, { data, loading, error }] = usedeleteProductionMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usedeleteProductionMutation(baseOptions?: Apollo.MutationHookOptions<deleteProductionMutation, deleteProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<deleteProductionMutation, deleteProductionMutationVariables>(deleteProductionDocument, options);
      }
export type deleteProductionMutationHookResult = ReturnType<typeof usedeleteProductionMutation>;
export type deleteProductionMutationResult = Apollo.MutationResult<deleteProductionMutation>;
export type deleteProductionMutationOptions = Apollo.BaseMutationOptions<deleteProductionMutation, deleteProductionMutationVariables>;
export const UpdateProductionDocument = gql`
    mutation UpdateProduction($id: ID!, $value: ProductionInput!) {
  updateProduction(id: $id, value: $value) {
    id
    amount
    quantity
    total
    description
  }
}
    `;
export type UpdateProductionMutationFn = Apollo.MutationFunction<UpdateProductionMutation, UpdateProductionMutationVariables>;

/**
 * __useUpdateProductionMutation__
 *
 * To run a mutation, you first call `useUpdateProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductionMutation, { data, loading, error }] = useUpdateProductionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateProductionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductionMutation, UpdateProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductionMutation, UpdateProductionMutationVariables>(UpdateProductionDocument, options);
      }
export type UpdateProductionMutationHookResult = ReturnType<typeof useUpdateProductionMutation>;
export type UpdateProductionMutationResult = Apollo.MutationResult<UpdateProductionMutation>;
export type UpdateProductionMutationOptions = Apollo.BaseMutationOptions<UpdateProductionMutation, UpdateProductionMutationVariables>;
export const GetIstatDataDocument = gql`
    query GetIstatData($input: GetIstatDataInput!) {
  getIstatData(input: $input) {
    ...IstatData
  }
}
    ${IstatDataFragmentDoc}`;

/**
 * __useGetIstatDataQuery__
 *
 * To run a query within a React component, call `useGetIstatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIstatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIstatDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIstatDataQuery(baseOptions: Apollo.QueryHookOptions<GetIstatDataQuery, GetIstatDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIstatDataQuery, GetIstatDataQueryVariables>(GetIstatDataDocument, options);
      }
export function useGetIstatDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIstatDataQuery, GetIstatDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIstatDataQuery, GetIstatDataQueryVariables>(GetIstatDataDocument, options);
        }
export type GetIstatDataQueryHookResult = ReturnType<typeof useGetIstatDataQuery>;
export type GetIstatDataLazyQueryHookResult = ReturnType<typeof useGetIstatDataLazyQuery>;
export type GetIstatDataQueryResult = Apollo.QueryResult<GetIstatDataQuery, GetIstatDataQueryVariables>;
export const PsRegistrationsDataDocument = gql`
    query PsRegistrationsData($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    ...PsRegistrationData
  }
}
    ${PsRegistrationDataFragmentDoc}`;

/**
 * __usePsRegistrationsDataQuery__
 *
 * To run a query within a React component, call `usePsRegistrationsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePsRegistrationsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePsRegistrationsDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePsRegistrationsDataQuery(baseOptions: Apollo.QueryHookOptions<PsRegistrationsDataQuery, PsRegistrationsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PsRegistrationsDataQuery, PsRegistrationsDataQueryVariables>(PsRegistrationsDataDocument, options);
      }
export function usePsRegistrationsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PsRegistrationsDataQuery, PsRegistrationsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PsRegistrationsDataQuery, PsRegistrationsDataQueryVariables>(PsRegistrationsDataDocument, options);
        }
export type PsRegistrationsDataQueryHookResult = ReturnType<typeof usePsRegistrationsDataQuery>;
export type PsRegistrationsDataLazyQueryHookResult = ReturnType<typeof usePsRegistrationsDataLazyQuery>;
export type PsRegistrationsDataQueryResult = Apollo.QueryResult<PsRegistrationsDataQuery, PsRegistrationsDataQueryVariables>;
export const GetPsConfigurationDocument = gql`
    query GetPsConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    psConfigurations {
      auto
    }
  }
}
    `;

/**
 * __useGetPsConfigurationQuery__
 *
 * To run a query within a React component, call `useGetPsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPsConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPsConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetPsConfigurationQuery, GetPsConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPsConfigurationQuery, GetPsConfigurationQueryVariables>(GetPsConfigurationDocument, options);
      }
export function useGetPsConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPsConfigurationQuery, GetPsConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPsConfigurationQuery, GetPsConfigurationQueryVariables>(GetPsConfigurationDocument, options);
        }
export type GetPsConfigurationQueryHookResult = ReturnType<typeof useGetPsConfigurationQuery>;
export type GetPsConfigurationLazyQueryHookResult = ReturnType<typeof useGetPsConfigurationLazyQuery>;
export type GetPsConfigurationQueryResult = Apollo.QueryResult<GetPsConfigurationQuery, GetPsConfigurationQueryVariables>;
export const SendPsDocument = gql`
    mutation SendPs($input: SendPSInput!) {
  sendPs(input: $input)
}
    `;
export type SendPsMutationFn = Apollo.MutationFunction<SendPsMutation, SendPsMutationVariables>;

/**
 * __useSendPsMutation__
 *
 * To run a mutation, you first call `useSendPsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPsMutation, { data, loading, error }] = useSendPsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPsMutation(baseOptions?: Apollo.MutationHookOptions<SendPsMutation, SendPsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPsMutation, SendPsMutationVariables>(SendPsDocument, options);
      }
export type SendPsMutationHookResult = ReturnType<typeof useSendPsMutation>;
export type SendPsMutationResult = Apollo.MutationResult<SendPsMutation>;
export type SendPsMutationOptions = Apollo.BaseMutationOptions<SendPsMutation, SendPsMutationVariables>;
export const SendIstatDocument = gql`
    mutation SendIstat($input: SendIstatInput!) {
  sendIstat(input: $input) {
    ...IstatError
  }
}
    ${IstatErrorFragmentDoc}`;
export type SendIstatMutationFn = Apollo.MutationFunction<SendIstatMutation, SendIstatMutationVariables>;

/**
 * __useSendIstatMutation__
 *
 * To run a mutation, you first call `useSendIstatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendIstatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendIstatMutation, { data, loading, error }] = useSendIstatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendIstatMutation(baseOptions?: Apollo.MutationHookOptions<SendIstatMutation, SendIstatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendIstatMutation, SendIstatMutationVariables>(SendIstatDocument, options);
      }
export type SendIstatMutationHookResult = ReturnType<typeof useSendIstatMutation>;
export type SendIstatMutationResult = Apollo.MutationResult<SendIstatMutation>;
export type SendIstatMutationOptions = Apollo.BaseMutationOptions<SendIstatMutation, SendIstatMutationVariables>;
export const SendIstatPeriodDocument = gql`
    mutation SendIstatPeriod($input: SendIstatPeriodInput!) {
  sendIstatPeriod(input: $input)
}
    `;
export type SendIstatPeriodMutationFn = Apollo.MutationFunction<SendIstatPeriodMutation, SendIstatPeriodMutationVariables>;

/**
 * __useSendIstatPeriodMutation__
 *
 * To run a mutation, you first call `useSendIstatPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendIstatPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendIstatPeriodMutation, { data, loading, error }] = useSendIstatPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendIstatPeriodMutation(baseOptions?: Apollo.MutationHookOptions<SendIstatPeriodMutation, SendIstatPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendIstatPeriodMutation, SendIstatPeriodMutationVariables>(SendIstatPeriodDocument, options);
      }
export type SendIstatPeriodMutationHookResult = ReturnType<typeof useSendIstatPeriodMutation>;
export type SendIstatPeriodMutationResult = Apollo.MutationResult<SendIstatPeriodMutation>;
export type SendIstatPeriodMutationOptions = Apollo.BaseMutationOptions<SendIstatPeriodMutation, SendIstatPeriodMutationVariables>;
export const GetRegistrationFilesDocument = gql`
    query GetRegistrationFiles($tenantId: ID!, $propertyId: ID, $id: ID!) {
  files(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {eq: $id}}
  ) {
    ...RegistrationFile
  }
}
    ${RegistrationFileFragmentDoc}`;

/**
 * __useGetRegistrationFilesQuery__
 *
 * To run a query within a React component, call `useGetRegistrationFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationFilesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegistrationFilesQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationFilesQuery, GetRegistrationFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationFilesQuery, GetRegistrationFilesQueryVariables>(GetRegistrationFilesDocument, options);
      }
export function useGetRegistrationFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationFilesQuery, GetRegistrationFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationFilesQuery, GetRegistrationFilesQueryVariables>(GetRegistrationFilesDocument, options);
        }
export type GetRegistrationFilesQueryHookResult = ReturnType<typeof useGetRegistrationFilesQuery>;
export type GetRegistrationFilesLazyQueryHookResult = ReturnType<typeof useGetRegistrationFilesLazyQuery>;
export type GetRegistrationFilesQueryResult = Apollo.QueryResult<GetRegistrationFilesQuery, GetRegistrationFilesQueryVariables>;
export const GenerateIstatFileDocument = gql`
    mutation GenerateIstatFile($input: GenerateIstatFileInput!) {
  generateIstatFile(input: $input) {
    success
    fileUrl
    errors {
      configurationName
      date
      message
    }
  }
}
    `;
export type GenerateIstatFileMutationFn = Apollo.MutationFunction<GenerateIstatFileMutation, GenerateIstatFileMutationVariables>;

/**
 * __useGenerateIstatFileMutation__
 *
 * To run a mutation, you first call `useGenerateIstatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIstatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIstatFileMutation, { data, loading, error }] = useGenerateIstatFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateIstatFileMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIstatFileMutation, GenerateIstatFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIstatFileMutation, GenerateIstatFileMutationVariables>(GenerateIstatFileDocument, options);
      }
export type GenerateIstatFileMutationHookResult = ReturnType<typeof useGenerateIstatFileMutation>;
export type GenerateIstatFileMutationResult = Apollo.MutationResult<GenerateIstatFileMutation>;
export type GenerateIstatFileMutationOptions = Apollo.BaseMutationOptions<GenerateIstatFileMutation, GenerateIstatFileMutationVariables>;
export const ReservationRatesDocument = gql`
    query ReservationRates($filter: RqQueryFilter!) {
  rateQuery(filter: $filter) {
    ...ReservationRates
  }
}
    ${ReservationRatesFragmentDoc}`;

/**
 * __useReservationRatesQuery__
 *
 * To run a query within a React component, call `useReservationRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationRatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReservationRatesQuery(baseOptions: Apollo.QueryHookOptions<ReservationRatesQuery, ReservationRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationRatesQuery, ReservationRatesQueryVariables>(ReservationRatesDocument, options);
      }
export function useReservationRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationRatesQuery, ReservationRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationRatesQuery, ReservationRatesQueryVariables>(ReservationRatesDocument, options);
        }
export type ReservationRatesQueryHookResult = ReturnType<typeof useReservationRatesQuery>;
export type ReservationRatesLazyQueryHookResult = ReturnType<typeof useReservationRatesLazyQuery>;
export type ReservationRatesQueryResult = Apollo.QueryResult<ReservationRatesQuery, ReservationRatesQueryVariables>;
export const OriginsDocument = gql`
    query Origins($tenantId: ID!, $pms: Boolean) {
  origins(filter: {tenantId: {eq: $tenantId}, pms: $pms}) {
    ...Origin
  }
}
    ${OriginFragmentDoc}`;

/**
 * __useOriginsQuery__
 *
 * To run a query within a React component, call `useOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      pms: // value for 'pms'
 *   },
 * });
 */
export function useOriginsQuery(baseOptions: Apollo.QueryHookOptions<OriginsQuery, OriginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginsQuery, OriginsQueryVariables>(OriginsDocument, options);
      }
export function useOriginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginsQuery, OriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginsQuery, OriginsQueryVariables>(OriginsDocument, options);
        }
export type OriginsQueryHookResult = ReturnType<typeof useOriginsQuery>;
export type OriginsLazyQueryHookResult = ReturnType<typeof useOriginsLazyQuery>;
export type OriginsQueryResult = Apollo.QueryResult<OriginsQuery, OriginsQueryVariables>;
export const ReservationCreateDocument = gql`
    mutation ReservationCreate($value: ReservationInput!, $options: ReservationOptions!) {
  createReservation(value: $value, options: $options) {
    ...ReservationDetail
  }
}
    ${ReservationDetailFragmentDoc}`;
export type ReservationCreateMutationFn = Apollo.MutationFunction<ReservationCreateMutation, ReservationCreateMutationVariables>;

/**
 * __useReservationCreateMutation__
 *
 * To run a mutation, you first call `useReservationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservationCreateMutation, { data, loading, error }] = useReservationCreateMutation({
 *   variables: {
 *      value: // value for 'value'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useReservationCreateMutation(baseOptions?: Apollo.MutationHookOptions<ReservationCreateMutation, ReservationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservationCreateMutation, ReservationCreateMutationVariables>(ReservationCreateDocument, options);
      }
export type ReservationCreateMutationHookResult = ReturnType<typeof useReservationCreateMutation>;
export type ReservationCreateMutationResult = Apollo.MutationResult<ReservationCreateMutation>;
export type ReservationCreateMutationOptions = Apollo.BaseMutationOptions<ReservationCreateMutation, ReservationCreateMutationVariables>;
export const ReservedResourceCreateDocument = gql`
    mutation ReservedResourceCreate($value: ReservedResourceInput!, $options: ReservationOptions!) {
  createReservedResource(value: $value, options: $options) {
    id
  }
}
    `;
export type ReservedResourceCreateMutationFn = Apollo.MutationFunction<ReservedResourceCreateMutation, ReservedResourceCreateMutationVariables>;

/**
 * __useReservedResourceCreateMutation__
 *
 * To run a mutation, you first call `useReservedResourceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservedResourceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservedResourceCreateMutation, { data, loading, error }] = useReservedResourceCreateMutation({
 *   variables: {
 *      value: // value for 'value'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useReservedResourceCreateMutation(baseOptions?: Apollo.MutationHookOptions<ReservedResourceCreateMutation, ReservedResourceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservedResourceCreateMutation, ReservedResourceCreateMutationVariables>(ReservedResourceCreateDocument, options);
      }
export type ReservedResourceCreateMutationHookResult = ReturnType<typeof useReservedResourceCreateMutation>;
export type ReservedResourceCreateMutationResult = Apollo.MutationResult<ReservedResourceCreateMutation>;
export type ReservedResourceCreateMutationOptions = Apollo.BaseMutationOptions<ReservedResourceCreateMutation, ReservedResourceCreateMutationVariables>;
export const ReservationsCreationDocument = gql`
    query ReservationsCreation($filter: ReservationQueryFilter!) {
  reservations(filter: $filter) {
    ...ReservationInput
  }
}
    ${ReservationInputFragmentDoc}`;

/**
 * __useReservationsCreationQuery__
 *
 * To run a query within a React component, call `useReservationsCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationsCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationsCreationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReservationsCreationQuery(baseOptions: Apollo.QueryHookOptions<ReservationsCreationQuery, ReservationsCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationsCreationQuery, ReservationsCreationQueryVariables>(ReservationsCreationDocument, options);
      }
export function useReservationsCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationsCreationQuery, ReservationsCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationsCreationQuery, ReservationsCreationQueryVariables>(ReservationsCreationDocument, options);
        }
export type ReservationsCreationQueryHookResult = ReturnType<typeof useReservationsCreationQuery>;
export type ReservationsCreationLazyQueryHookResult = ReturnType<typeof useReservationsCreationLazyQuery>;
export type ReservationsCreationQueryResult = Apollo.QueryResult<ReservationsCreationQuery, ReservationsCreationQueryVariables>;
export const CreateDepositDocument = gql`
    mutation CreateDeposit($input: DepositDocumentInput!) {
  createDepositDocument(value: $input) {
    id
  }
}
    `;
export type CreateDepositMutationFn = Apollo.MutationFunction<CreateDepositMutation, CreateDepositMutationVariables>;

/**
 * __useCreateDepositMutation__
 *
 * To run a mutation, you first call `useCreateDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepositMutation, { data, loading, error }] = useCreateDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepositMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepositMutation, CreateDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepositMutation, CreateDepositMutationVariables>(CreateDepositDocument, options);
      }
export type CreateDepositMutationHookResult = ReturnType<typeof useCreateDepositMutation>;
export type CreateDepositMutationResult = Apollo.MutationResult<CreateDepositMutation>;
export type CreateDepositMutationOptions = Apollo.BaseMutationOptions<CreateDepositMutation, CreateDepositMutationVariables>;
export const DeleteDepositDocument = gql`
    mutation DeleteDeposit($tenantId: ID!, $depositId: String!) {
  deleteDocument(tenantId: $tenantId, id: $depositId)
}
    `;
export type DeleteDepositMutationFn = Apollo.MutationFunction<DeleteDepositMutation, DeleteDepositMutationVariables>;

/**
 * __useDeleteDepositMutation__
 *
 * To run a mutation, you first call `useDeleteDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepositMutation, { data, loading, error }] = useDeleteDepositMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      depositId: // value for 'depositId'
 *   },
 * });
 */
export function useDeleteDepositMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepositMutation, DeleteDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepositMutation, DeleteDepositMutationVariables>(DeleteDepositDocument, options);
      }
export type DeleteDepositMutationHookResult = ReturnType<typeof useDeleteDepositMutation>;
export type DeleteDepositMutationResult = Apollo.MutationResult<DeleteDepositMutation>;
export type DeleteDepositMutationOptions = Apollo.BaseMutationOptions<DeleteDepositMutation, DeleteDepositMutationVariables>;
export const CreateCheckoutDocumentDocument = gql`
    mutation CreateCheckoutDocument($input: CheckoutDocumentInput!) {
  createCheckoutDocument(value: $input) {
    id
  }
}
    `;
export type CreateCheckoutDocumentMutationFn = Apollo.MutationFunction<CreateCheckoutDocumentMutation, CreateCheckoutDocumentMutationVariables>;

/**
 * __useCreateCheckoutDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutDocumentMutation, { data, loading, error }] = useCreateCheckoutDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutDocumentMutation, CreateCheckoutDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutDocumentMutation, CreateCheckoutDocumentMutationVariables>(CreateCheckoutDocumentDocument, options);
      }
export type CreateCheckoutDocumentMutationHookResult = ReturnType<typeof useCreateCheckoutDocumentMutation>;
export type CreateCheckoutDocumentMutationResult = Apollo.MutationResult<CreateCheckoutDocumentMutation>;
export type CreateCheckoutDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutDocumentMutation, CreateCheckoutDocumentMutationVariables>;
export const GetProductionsDocument = gql`
    query GetProductions($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    productions {
      id
    }
  }
}
    `;

/**
 * __useGetProductionsQuery__
 *
 * To run a query within a React component, call `useGetProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductionsQuery(baseOptions: Apollo.QueryHookOptions<GetProductionsQuery, GetProductionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionsQuery, GetProductionsQueryVariables>(GetProductionsDocument, options);
      }
export function useGetProductionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionsQuery, GetProductionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionsQuery, GetProductionsQueryVariables>(GetProductionsDocument, options);
        }
export type GetProductionsQueryHookResult = ReturnType<typeof useGetProductionsQuery>;
export type GetProductionsLazyQueryHookResult = ReturnType<typeof useGetProductionsLazyQuery>;
export type GetProductionsQueryResult = Apollo.QueryResult<GetProductionsQuery, GetProductionsQueryVariables>;
export const GetProductionsDetailsDocument = gql`
    query GetProductionsDetails($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    ...ReservedResourceProductionDetailItem
  }
}
    ${ReservedResourceProductionDetailItemFragmentDoc}`;

/**
 * __useGetProductionsDetailsQuery__
 *
 * To run a query within a React component, call `useGetProductionsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionsDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProductionsDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetProductionsDetailsQuery, GetProductionsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionsDetailsQuery, GetProductionsDetailsQueryVariables>(GetProductionsDetailsDocument, options);
      }
export function useGetProductionsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionsDetailsQuery, GetProductionsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionsDetailsQuery, GetProductionsDetailsQueryVariables>(GetProductionsDetailsDocument, options);
        }
export type GetProductionsDetailsQueryHookResult = ReturnType<typeof useGetProductionsDetailsQuery>;
export type GetProductionsDetailsLazyQueryHookResult = ReturnType<typeof useGetProductionsDetailsLazyQuery>;
export type GetProductionsDetailsQueryResult = Apollo.QueryResult<GetProductionsDetailsQuery, GetProductionsDetailsQueryVariables>;
export const ReservationListDocument = gql`
    query ReservationList($tenantId: ID!, $propertyId: ID!, $skip: Int, $limit: Int) {
  reservations(
    filter: {tenantId: {eq: $tenantId}, propertyId: $propertyId}
    skip: $skip
    limit: $limit
  ) {
    ...ReservationList
  }
}
    ${ReservationListFragmentDoc}`;

/**
 * __useReservationListQuery__
 *
 * To run a query within a React component, call `useReservationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationListQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReservationListQuery(baseOptions: Apollo.QueryHookOptions<ReservationListQuery, ReservationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationListQuery, ReservationListQueryVariables>(ReservationListDocument, options);
      }
export function useReservationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationListQuery, ReservationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationListQuery, ReservationListQueryVariables>(ReservationListDocument, options);
        }
export type ReservationListQueryHookResult = ReturnType<typeof useReservationListQuery>;
export type ReservationListLazyQueryHookResult = ReturnType<typeof useReservationListLazyQuery>;
export type ReservationListQueryResult = Apollo.QueryResult<ReservationListQuery, ReservationListQueryVariables>;
export const ReservationSearchDocument = gql`
    query ReservationSearch($filter: ReservationFullTextQueryFilter!, $skip: Int, $limit: Int, $sort: ReservationFullTextQuerySortInput) {
  reservationSearch(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    ...reservationSearch
  }
}
    ${reservationSearchFragmentDoc}`;

/**
 * __useReservationSearchQuery__
 *
 * To run a query within a React component, call `useReservationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReservationSearchQuery(baseOptions: Apollo.QueryHookOptions<ReservationSearchQuery, ReservationSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationSearchQuery, ReservationSearchQueryVariables>(ReservationSearchDocument, options);
      }
export function useReservationSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationSearchQuery, ReservationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationSearchQuery, ReservationSearchQueryVariables>(ReservationSearchDocument, options);
        }
export type ReservationSearchQueryHookResult = ReturnType<typeof useReservationSearchQuery>;
export type ReservationSearchLazyQueryHookResult = ReturnType<typeof useReservationSearchLazyQuery>;
export type ReservationSearchQueryResult = Apollo.QueryResult<ReservationSearchQuery, ReservationSearchQueryVariables>;
export const UsedPortalDocument = gql`
    query UsedPortal($filter: ChannelQueryFilter!) {
  channels(filter: $filter) {
    portal {
      ...UsedPortal
    }
  }
}
    ${UsedPortalFragmentDoc}`;

/**
 * __useUsedPortalQuery__
 *
 * To run a query within a React component, call `useUsedPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsedPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsedPortalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsedPortalQuery(baseOptions: Apollo.QueryHookOptions<UsedPortalQuery, UsedPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsedPortalQuery, UsedPortalQueryVariables>(UsedPortalDocument, options);
      }
export function useUsedPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsedPortalQuery, UsedPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsedPortalQuery, UsedPortalQueryVariables>(UsedPortalDocument, options);
        }
export type UsedPortalQueryHookResult = ReturnType<typeof useUsedPortalQuery>;
export type UsedPortalLazyQueryHookResult = ReturnType<typeof useUsedPortalLazyQuery>;
export type UsedPortalQueryResult = Apollo.QueryResult<UsedPortalQuery, UsedPortalQueryVariables>;
export const ReservationDeleteDocument = gql`
    mutation ReservationDelete($tenantId: ID!, $id: ID!) {
  deleteReservation(tenantId: $tenantId, id: $id)
}
    `;
export type ReservationDeleteMutationFn = Apollo.MutationFunction<ReservationDeleteMutation, ReservationDeleteMutationVariables>;

/**
 * __useReservationDeleteMutation__
 *
 * To run a mutation, you first call `useReservationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservationDeleteMutation, { data, loading, error }] = useReservationDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReservationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ReservationDeleteMutation, ReservationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservationDeleteMutation, ReservationDeleteMutationVariables>(ReservationDeleteDocument, options);
      }
export type ReservationDeleteMutationHookResult = ReturnType<typeof useReservationDeleteMutation>;
export type ReservationDeleteMutationResult = Apollo.MutationResult<ReservationDeleteMutation>;
export type ReservationDeleteMutationOptions = Apollo.BaseMutationOptions<ReservationDeleteMutation, ReservationDeleteMutationVariables>;
export const ReservationStatesDocument = gql`
    query ReservationStates($tenantId: ID!) {
  reservationStates(filter: {tenantId: {eq: $tenantId}}) {
    ...ReservationState
  }
}
    ${ReservationStateFragmentDoc}`;

/**
 * __useReservationStatesQuery__
 *
 * To run a query within a React component, call `useReservationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationStatesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useReservationStatesQuery(baseOptions: Apollo.QueryHookOptions<ReservationStatesQuery, ReservationStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationStatesQuery, ReservationStatesQueryVariables>(ReservationStatesDocument, options);
      }
export function useReservationStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationStatesQuery, ReservationStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationStatesQuery, ReservationStatesQueryVariables>(ReservationStatesDocument, options);
        }
export type ReservationStatesQueryHookResult = ReturnType<typeof useReservationStatesQuery>;
export type ReservationStatesLazyQueryHookResult = ReturnType<typeof useReservationStatesLazyQuery>;
export type ReservationStatesQueryResult = Apollo.QueryResult<ReservationStatesQuery, ReservationStatesQueryVariables>;
export const GuestsLookupDocument = gql`
    query GuestsLookup($tenantId: ID!, $search: StringFilter, $idFilter: IDFilter, $type: CustomerType, $skip: Int, $limit: Int) {
  customers(
    filter: {tenantId: {eq: $tenantId}, search: $search, id: $idFilter, type: $type}
    skip: $skip
    limit: $limit
  ) {
    ...Guest
  }
}
    ${GuestFragmentDoc}`;

/**
 * __useGuestsLookupQuery__
 *
 * To run a query within a React component, call `useGuestsLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestsLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestsLookupQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *      idFilter: // value for 'idFilter'
 *      type: // value for 'type'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGuestsLookupQuery(baseOptions: Apollo.QueryHookOptions<GuestsLookupQuery, GuestsLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestsLookupQuery, GuestsLookupQueryVariables>(GuestsLookupDocument, options);
      }
export function useGuestsLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestsLookupQuery, GuestsLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestsLookupQuery, GuestsLookupQueryVariables>(GuestsLookupDocument, options);
        }
export type GuestsLookupQueryHookResult = ReturnType<typeof useGuestsLookupQuery>;
export type GuestsLookupLazyQueryHookResult = ReturnType<typeof useGuestsLookupLazyQuery>;
export type GuestsLookupQueryResult = Apollo.QueryResult<GuestsLookupQuery, GuestsLookupQueryVariables>;
export const ReferenceCustomersLookupDocument = gql`
    query ReferenceCustomersLookup($tenantId: ID!, $search: StringFilter, $idFilter: IDFilter, $type: CustomerType, $skip: Int, $limit: Int) {
  customers(
    filter: {tenantId: {eq: $tenantId}, search: $search, id: $idFilter, type: $type}
    skip: $skip
    limit: $limit
  ) {
    ...ReferenceCustomer
  }
}
    ${ReferenceCustomerFragmentDoc}`;

/**
 * __useReferenceCustomersLookupQuery__
 *
 * To run a query within a React component, call `useReferenceCustomersLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferenceCustomersLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferenceCustomersLookupQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *      idFilter: // value for 'idFilter'
 *      type: // value for 'type'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReferenceCustomersLookupQuery(baseOptions: Apollo.QueryHookOptions<ReferenceCustomersLookupQuery, ReferenceCustomersLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferenceCustomersLookupQuery, ReferenceCustomersLookupQueryVariables>(ReferenceCustomersLookupDocument, options);
      }
export function useReferenceCustomersLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferenceCustomersLookupQuery, ReferenceCustomersLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferenceCustomersLookupQuery, ReferenceCustomersLookupQueryVariables>(ReferenceCustomersLookupDocument, options);
        }
export type ReferenceCustomersLookupQueryHookResult = ReturnType<typeof useReferenceCustomersLookupQuery>;
export type ReferenceCustomersLookupLazyQueryHookResult = ReturnType<typeof useReferenceCustomersLookupLazyQuery>;
export type ReferenceCustomersLookupQueryResult = Apollo.QueryResult<ReferenceCustomersLookupQuery, ReferenceCustomersLookupQueryVariables>;
export const ReservationDetailDocument = gql`
    query ReservationDetail($tenantId: ID!, $propertyId: ID!, $reservationId: ID!) {
  reservations(
    filter: {tenantId: {eq: $tenantId}, propertyId: $propertyId, id: {eq: $reservationId}}
    skip: 0
    limit: 1
  ) {
    ...ReservationDetail
  }
  bills(filter: {tenantId: {eq: $tenantId}, reservationId: {eq: $reservationId}}) {
    ...ReservationBill
  }
  depositDocuments(
    filter: {tenantId: {eq: $tenantId}, reservationId: $reservationId}
  ) {
    ...DepositDocument
  }
  getReservationLink(tenantId: $tenantId, reservationId: $reservationId)
}
    ${ReservationDetailFragmentDoc}
${ReservationBillFragmentDoc}
${DepositDocumentFragmentDoc}`;

/**
 * __useReservationDetailQuery__
 *
 * To run a query within a React component, call `useReservationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationDetailQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useReservationDetailQuery(baseOptions: Apollo.QueryHookOptions<ReservationDetailQuery, ReservationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationDetailQuery, ReservationDetailQueryVariables>(ReservationDetailDocument, options);
      }
export function useReservationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationDetailQuery, ReservationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationDetailQuery, ReservationDetailQueryVariables>(ReservationDetailDocument, options);
        }
export type ReservationDetailQueryHookResult = ReturnType<typeof useReservationDetailQuery>;
export type ReservationDetailLazyQueryHookResult = ReturnType<typeof useReservationDetailLazyQuery>;
export type ReservationDetailQueryResult = Apollo.QueryResult<ReservationDetailQuery, ReservationDetailQueryVariables>;
export const ReservationUpdateDocument = gql`
    mutation ReservationUpdate($id: ID!, $input: ReservationUpdateInput!) {
  updateReservation(id: $id, value: $input) {
    ...ReservationDetail
  }
}
    ${ReservationDetailFragmentDoc}`;
export type ReservationUpdateMutationFn = Apollo.MutationFunction<ReservationUpdateMutation, ReservationUpdateMutationVariables>;

/**
 * __useReservationUpdateMutation__
 *
 * To run a mutation, you first call `useReservationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservationUpdateMutation, { data, loading, error }] = useReservationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReservationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReservationUpdateMutation, ReservationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservationUpdateMutation, ReservationUpdateMutationVariables>(ReservationUpdateDocument, options);
      }
export type ReservationUpdateMutationHookResult = ReturnType<typeof useReservationUpdateMutation>;
export type ReservationUpdateMutationResult = Apollo.MutationResult<ReservationUpdateMutation>;
export type ReservationUpdateMutationOptions = Apollo.BaseMutationOptions<ReservationUpdateMutation, ReservationUpdateMutationVariables>;
export const ReservedResourceUpdateDocument = gql`
    mutation ReservedResourceUpdate($reservedResourceId: ID!, $input: ReservedResourceInput!, $options: ReservedResourceOptions!) {
  updateReservedResource(
    id: $reservedResourceId
    value: $input
    options: $options
  ) {
    ...ReservedResource
  }
}
    ${ReservedResourceFragmentDoc}`;
export type ReservedResourceUpdateMutationFn = Apollo.MutationFunction<ReservedResourceUpdateMutation, ReservedResourceUpdateMutationVariables>;

/**
 * __useReservedResourceUpdateMutation__
 *
 * To run a mutation, you first call `useReservedResourceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservedResourceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservedResourceUpdateMutation, { data, loading, error }] = useReservedResourceUpdateMutation({
 *   variables: {
 *      reservedResourceId: // value for 'reservedResourceId'
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useReservedResourceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReservedResourceUpdateMutation, ReservedResourceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservedResourceUpdateMutation, ReservedResourceUpdateMutationVariables>(ReservedResourceUpdateDocument, options);
      }
export type ReservedResourceUpdateMutationHookResult = ReturnType<typeof useReservedResourceUpdateMutation>;
export type ReservedResourceUpdateMutationResult = Apollo.MutationResult<ReservedResourceUpdateMutation>;
export type ReservedResourceUpdateMutationOptions = Apollo.BaseMutationOptions<ReservedResourceUpdateMutation, ReservedResourceUpdateMutationVariables>;
export const DeleteReservedResourceDocument = gql`
    mutation DeleteReservedResource($tenantId: ID!, $deleteReservedResourceId: ID!) {
  deleteReservedResource(tenantId: $tenantId, id: $deleteReservedResourceId)
}
    `;
export type DeleteReservedResourceMutationFn = Apollo.MutationFunction<DeleteReservedResourceMutation, DeleteReservedResourceMutationVariables>;

/**
 * __useDeleteReservedResourceMutation__
 *
 * To run a mutation, you first call `useDeleteReservedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservedResourceMutation, { data, loading, error }] = useDeleteReservedResourceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteReservedResourceId: // value for 'deleteReservedResourceId'
 *   },
 * });
 */
export function useDeleteReservedResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservedResourceMutation, DeleteReservedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservedResourceMutation, DeleteReservedResourceMutationVariables>(DeleteReservedResourceDocument, options);
      }
export type DeleteReservedResourceMutationHookResult = ReturnType<typeof useDeleteReservedResourceMutation>;
export type DeleteReservedResourceMutationResult = Apollo.MutationResult<DeleteReservedResourceMutation>;
export type DeleteReservedResourceMutationOptions = Apollo.BaseMutationOptions<DeleteReservedResourceMutation, DeleteReservedResourceMutationVariables>;
export const AvailableResourcesDocument = gql`
    query AvailableResources($tenantId: ID!, $propertyId: ID!, $resourceTypeId: ID, $start: Date!, $end: Date!, $time: TimeRangeInput) {
  getAllAvailableResources(
    filter: {tenantId: $tenantId, propertyId: $propertyId, resourceTypeId: $resourceTypeId, startDate: $start, endDate: $end, time: $time}
  ) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;

/**
 * __useAvailableResourcesQuery__
 *
 * To run a query within a React component, call `useAvailableResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableResourcesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      resourceTypeId: // value for 'resourceTypeId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useAvailableResourcesQuery(baseOptions: Apollo.QueryHookOptions<AvailableResourcesQuery, AvailableResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableResourcesQuery, AvailableResourcesQueryVariables>(AvailableResourcesDocument, options);
      }
export function useAvailableResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableResourcesQuery, AvailableResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableResourcesQuery, AvailableResourcesQueryVariables>(AvailableResourcesDocument, options);
        }
export type AvailableResourcesQueryHookResult = ReturnType<typeof useAvailableResourcesQuery>;
export type AvailableResourcesLazyQueryHookResult = ReturnType<typeof useAvailableResourcesLazyQuery>;
export type AvailableResourcesQueryResult = Apollo.QueryResult<AvailableResourcesQuery, AvailableResourcesQueryVariables>;
export const ReservedResourcesCheckInDocument = gql`
    mutation ReservedResourcesCheckIn($input: CheckinCheckoutReservedResourcesInput!) {
  checkinReservedResources(input: $input)
}
    `;
export type ReservedResourcesCheckInMutationFn = Apollo.MutationFunction<ReservedResourcesCheckInMutation, ReservedResourcesCheckInMutationVariables>;

/**
 * __useReservedResourcesCheckInMutation__
 *
 * To run a mutation, you first call `useReservedResourcesCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservedResourcesCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservedResourcesCheckInMutation, { data, loading, error }] = useReservedResourcesCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReservedResourcesCheckInMutation(baseOptions?: Apollo.MutationHookOptions<ReservedResourcesCheckInMutation, ReservedResourcesCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservedResourcesCheckInMutation, ReservedResourcesCheckInMutationVariables>(ReservedResourcesCheckInDocument, options);
      }
export type ReservedResourcesCheckInMutationHookResult = ReturnType<typeof useReservedResourcesCheckInMutation>;
export type ReservedResourcesCheckInMutationResult = Apollo.MutationResult<ReservedResourcesCheckInMutation>;
export type ReservedResourcesCheckInMutationOptions = Apollo.BaseMutationOptions<ReservedResourcesCheckInMutation, ReservedResourcesCheckInMutationVariables>;
export const ReservedResourcesCheckOutDocument = gql`
    mutation ReservedResourcesCheckOut($input: CheckinCheckoutReservedResourcesInput!) {
  checkoutReservedResources(input: $input)
}
    `;
export type ReservedResourcesCheckOutMutationFn = Apollo.MutationFunction<ReservedResourcesCheckOutMutation, ReservedResourcesCheckOutMutationVariables>;

/**
 * __useReservedResourcesCheckOutMutation__
 *
 * To run a mutation, you first call `useReservedResourcesCheckOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservedResourcesCheckOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservedResourcesCheckOutMutation, { data, loading, error }] = useReservedResourcesCheckOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReservedResourcesCheckOutMutation(baseOptions?: Apollo.MutationHookOptions<ReservedResourcesCheckOutMutation, ReservedResourcesCheckOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservedResourcesCheckOutMutation, ReservedResourcesCheckOutMutationVariables>(ReservedResourcesCheckOutDocument, options);
      }
export type ReservedResourcesCheckOutMutationHookResult = ReturnType<typeof useReservedResourcesCheckOutMutation>;
export type ReservedResourcesCheckOutMutationResult = Apollo.MutationResult<ReservedResourcesCheckOutMutation>;
export type ReservedResourcesCheckOutMutationOptions = Apollo.BaseMutationOptions<ReservedResourcesCheckOutMutation, ReservedResourcesCheckOutMutationVariables>;
export const CityTaxExonerationsDocument = gql`
    query CityTaxExonerations($tenantId: ID!, $propertyId: ID!, $usage: ExonerationUsage!) {
  cityTaxExonerations(tenantId: $tenantId, propertyId: $propertyId, usage: $usage) {
    ...CityTaxExoneration
  }
}
    ${CityTaxExonerationFragmentDoc}`;

/**
 * __useCityTaxExonerationsQuery__
 *
 * To run a query within a React component, call `useCityTaxExonerationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityTaxExonerationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityTaxExonerationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      usage: // value for 'usage'
 *   },
 * });
 */
export function useCityTaxExonerationsQuery(baseOptions: Apollo.QueryHookOptions<CityTaxExonerationsQuery, CityTaxExonerationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityTaxExonerationsQuery, CityTaxExonerationsQueryVariables>(CityTaxExonerationsDocument, options);
      }
export function useCityTaxExonerationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityTaxExonerationsQuery, CityTaxExonerationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityTaxExonerationsQuery, CityTaxExonerationsQueryVariables>(CityTaxExonerationsDocument, options);
        }
export type CityTaxExonerationsQueryHookResult = ReturnType<typeof useCityTaxExonerationsQuery>;
export type CityTaxExonerationsLazyQueryHookResult = ReturnType<typeof useCityTaxExonerationsLazyQuery>;
export type CityTaxExonerationsQueryResult = Apollo.QueryResult<CityTaxExonerationsQuery, CityTaxExonerationsQueryVariables>;
export const EditRRResourceTypesDocument = gql`
    query EditRRResourceTypes($tenantId: ID!, $propertyId: ID!, $timeResources: Boolean) {
  resourceTypes(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, timeResources: $timeResources}
  ) {
    id
    code
    customName
    name {
      description
    }
    maxAdults
    persons
    additionalPersons
  }
}
    `;

/**
 * __useEditRRResourceTypesQuery__
 *
 * To run a query within a React component, call `useEditRRResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditRRResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditRRResourceTypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      timeResources: // value for 'timeResources'
 *   },
 * });
 */
export function useEditRRResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<EditRRResourceTypesQuery, EditRRResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditRRResourceTypesQuery, EditRRResourceTypesQueryVariables>(EditRRResourceTypesDocument, options);
      }
export function useEditRRResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditRRResourceTypesQuery, EditRRResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditRRResourceTypesQuery, EditRRResourceTypesQueryVariables>(EditRRResourceTypesDocument, options);
        }
export type EditRRResourceTypesQueryHookResult = ReturnType<typeof useEditRRResourceTypesQuery>;
export type EditRRResourceTypesLazyQueryHookResult = ReturnType<typeof useEditRRResourceTypesLazyQuery>;
export type EditRRResourceTypesQueryResult = Apollo.QueryResult<EditRRResourceTypesQuery, EditRRResourceTypesQueryVariables>;
export const GetReservationPortalPaymentCardDocument = gql`
    query GetReservationPortalPaymentCard($tenantId: ID!, $reservationId: ID!) {
  getReservationPortalPaymentCard(
    tenantId: $tenantId
    reservationId: $reservationId
  ) {
    network
    number
    fullName
    expiration
    cvv
  }
}
    `;

/**
 * __useGetReservationPortalPaymentCardQuery__
 *
 * To run a query within a React component, call `useGetReservationPortalPaymentCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationPortalPaymentCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationPortalPaymentCardQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useGetReservationPortalPaymentCardQuery(baseOptions: Apollo.QueryHookOptions<GetReservationPortalPaymentCardQuery, GetReservationPortalPaymentCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationPortalPaymentCardQuery, GetReservationPortalPaymentCardQueryVariables>(GetReservationPortalPaymentCardDocument, options);
      }
export function useGetReservationPortalPaymentCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationPortalPaymentCardQuery, GetReservationPortalPaymentCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationPortalPaymentCardQuery, GetReservationPortalPaymentCardQueryVariables>(GetReservationPortalPaymentCardDocument, options);
        }
export type GetReservationPortalPaymentCardQueryHookResult = ReturnType<typeof useGetReservationPortalPaymentCardQuery>;
export type GetReservationPortalPaymentCardLazyQueryHookResult = ReturnType<typeof useGetReservationPortalPaymentCardLazyQuery>;
export type GetReservationPortalPaymentCardQueryResult = Apollo.QueryResult<GetReservationPortalPaymentCardQuery, GetReservationPortalPaymentCardQueryVariables>;
export const GetReservationEmailsDocument = gql`
    query GetReservationEmails($tenantId: ID!, $reservationId: ID!) {
  getReservationEmails(tenantId: $tenantId, reservationId: $reservationId) {
    ...Email
  }
}
    ${EmailFragmentDoc}`;

/**
 * __useGetReservationEmailsQuery__
 *
 * To run a query within a React component, call `useGetReservationEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationEmailsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useGetReservationEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetReservationEmailsQuery, GetReservationEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationEmailsQuery, GetReservationEmailsQueryVariables>(GetReservationEmailsDocument, options);
      }
export function useGetReservationEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationEmailsQuery, GetReservationEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationEmailsQuery, GetReservationEmailsQueryVariables>(GetReservationEmailsDocument, options);
        }
export type GetReservationEmailsQueryHookResult = ReturnType<typeof useGetReservationEmailsQuery>;
export type GetReservationEmailsLazyQueryHookResult = ReturnType<typeof useGetReservationEmailsLazyQuery>;
export type GetReservationEmailsQueryResult = Apollo.QueryResult<GetReservationEmailsQuery, GetReservationEmailsQueryVariables>;
export const CustomerDocumentImagesDocument = gql`
    query CustomerDocumentImages($filter: CustomerDocumentImageQueryFilter!) {
  customerDocumentImages(filter: $filter) {
    type
    fileId
    file {
      URL
    }
  }
}
    `;

/**
 * __useCustomerDocumentImagesQuery__
 *
 * To run a query within a React component, call `useCustomerDocumentImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerDocumentImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerDocumentImagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerDocumentImagesQuery(baseOptions: Apollo.QueryHookOptions<CustomerDocumentImagesQuery, CustomerDocumentImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerDocumentImagesQuery, CustomerDocumentImagesQueryVariables>(CustomerDocumentImagesDocument, options);
      }
export function useCustomerDocumentImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerDocumentImagesQuery, CustomerDocumentImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerDocumentImagesQuery, CustomerDocumentImagesQueryVariables>(CustomerDocumentImagesDocument, options);
        }
export type CustomerDocumentImagesQueryHookResult = ReturnType<typeof useCustomerDocumentImagesQuery>;
export type CustomerDocumentImagesLazyQueryHookResult = ReturnType<typeof useCustomerDocumentImagesLazyQuery>;
export type CustomerDocumentImagesQueryResult = Apollo.QueryResult<CustomerDocumentImagesQuery, CustomerDocumentImagesQueryVariables>;
export const UpdateReservedResourcesDocument = gql`
    mutation UpdateReservedResources($value: [ReservedResourceMultiInput!]!, $options: ReservationOptions!) {
  updateReservedResources(value: $value, options: $options) {
    ...ReservedResource
  }
}
    ${ReservedResourceFragmentDoc}`;
export type UpdateReservedResourcesMutationFn = Apollo.MutationFunction<UpdateReservedResourcesMutation, UpdateReservedResourcesMutationVariables>;

/**
 * __useUpdateReservedResourcesMutation__
 *
 * To run a mutation, you first call `useUpdateReservedResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservedResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservedResourcesMutation, { data, loading, error }] = useUpdateReservedResourcesMutation({
 *   variables: {
 *      value: // value for 'value'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateReservedResourcesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservedResourcesMutation, UpdateReservedResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservedResourcesMutation, UpdateReservedResourcesMutationVariables>(UpdateReservedResourcesDocument, options);
      }
export type UpdateReservedResourcesMutationHookResult = ReturnType<typeof useUpdateReservedResourcesMutation>;
export type UpdateReservedResourcesMutationResult = Apollo.MutationResult<UpdateReservedResourcesMutation>;
export type UpdateReservedResourcesMutationOptions = Apollo.BaseMutationOptions<UpdateReservedResourcesMutation, UpdateReservedResourcesMutationVariables>;
export const UndoCheckinReservedResourcesDocument = gql`
    mutation UndoCheckinReservedResources($input: CheckinCheckoutReservedResourcesInput!) {
  undoCheckinReservedResources(input: $input)
}
    `;
export type UndoCheckinReservedResourcesMutationFn = Apollo.MutationFunction<UndoCheckinReservedResourcesMutation, UndoCheckinReservedResourcesMutationVariables>;

/**
 * __useUndoCheckinReservedResourcesMutation__
 *
 * To run a mutation, you first call `useUndoCheckinReservedResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCheckinReservedResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCheckinReservedResourcesMutation, { data, loading, error }] = useUndoCheckinReservedResourcesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndoCheckinReservedResourcesMutation(baseOptions?: Apollo.MutationHookOptions<UndoCheckinReservedResourcesMutation, UndoCheckinReservedResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoCheckinReservedResourcesMutation, UndoCheckinReservedResourcesMutationVariables>(UndoCheckinReservedResourcesDocument, options);
      }
export type UndoCheckinReservedResourcesMutationHookResult = ReturnType<typeof useUndoCheckinReservedResourcesMutation>;
export type UndoCheckinReservedResourcesMutationResult = Apollo.MutationResult<UndoCheckinReservedResourcesMutation>;
export type UndoCheckinReservedResourcesMutationOptions = Apollo.BaseMutationOptions<UndoCheckinReservedResourcesMutation, UndoCheckinReservedResourcesMutationVariables>;
export const UndoCheckoutReservedResourcesDocument = gql`
    mutation UndoCheckoutReservedResources($input: CheckinCheckoutReservedResourcesInput!) {
  undoCheckoutReservedResources(input: $input)
}
    `;
export type UndoCheckoutReservedResourcesMutationFn = Apollo.MutationFunction<UndoCheckoutReservedResourcesMutation, UndoCheckoutReservedResourcesMutationVariables>;

/**
 * __useUndoCheckoutReservedResourcesMutation__
 *
 * To run a mutation, you first call `useUndoCheckoutReservedResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCheckoutReservedResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCheckoutReservedResourcesMutation, { data, loading, error }] = useUndoCheckoutReservedResourcesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndoCheckoutReservedResourcesMutation(baseOptions?: Apollo.MutationHookOptions<UndoCheckoutReservedResourcesMutation, UndoCheckoutReservedResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoCheckoutReservedResourcesMutation, UndoCheckoutReservedResourcesMutationVariables>(UndoCheckoutReservedResourcesDocument, options);
      }
export type UndoCheckoutReservedResourcesMutationHookResult = ReturnType<typeof useUndoCheckoutReservedResourcesMutation>;
export type UndoCheckoutReservedResourcesMutationResult = Apollo.MutationResult<UndoCheckoutReservedResourcesMutation>;
export type UndoCheckoutReservedResourcesMutationOptions = Apollo.BaseMutationOptions<UndoCheckoutReservedResourcesMutation, UndoCheckoutReservedResourcesMutationVariables>;
export const CreateChargeForReservationDocument = gql`
    mutation CreateChargeForReservation($input: ChargeForReservationInput!) {
  createChargeForReservation(input: $input) {
    amount
  }
}
    `;
export type CreateChargeForReservationMutationFn = Apollo.MutationFunction<CreateChargeForReservationMutation, CreateChargeForReservationMutationVariables>;

/**
 * __useCreateChargeForReservationMutation__
 *
 * To run a mutation, you first call `useCreateChargeForReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargeForReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargeForReservationMutation, { data, loading, error }] = useCreateChargeForReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChargeForReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateChargeForReservationMutation, CreateChargeForReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChargeForReservationMutation, CreateChargeForReservationMutationVariables>(CreateChargeForReservationDocument, options);
      }
export type CreateChargeForReservationMutationHookResult = ReturnType<typeof useCreateChargeForReservationMutation>;
export type CreateChargeForReservationMutationResult = Apollo.MutationResult<CreateChargeForReservationMutation>;
export type CreateChargeForReservationMutationOptions = Apollo.BaseMutationOptions<CreateChargeForReservationMutation, CreateChargeForReservationMutationVariables>;
export const HoauReservedResourcesDocument = gql`
    query HoauReservedResources($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    id
    guestOccupancies {
      guest {
        name
      }
    }
    resourceOccupancies {
      start
      end
      resource {
        code
      }
      assignedResourceType {
        name {
          description
        }
        customName
        code
      }
      reservedResourceType {
        name {
          description
        }
        customName
        code
      }
    }
    automationId
  }
}
    `;

/**
 * __useHoauReservedResourcesQuery__
 *
 * To run a query within a React component, call `useHoauReservedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoauReservedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoauReservedResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHoauReservedResourcesQuery(baseOptions: Apollo.QueryHookOptions<HoauReservedResourcesQuery, HoauReservedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HoauReservedResourcesQuery, HoauReservedResourcesQueryVariables>(HoauReservedResourcesDocument, options);
      }
export function useHoauReservedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HoauReservedResourcesQuery, HoauReservedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HoauReservedResourcesQuery, HoauReservedResourcesQueryVariables>(HoauReservedResourcesDocument, options);
        }
export type HoauReservedResourcesQueryHookResult = ReturnType<typeof useHoauReservedResourcesQuery>;
export type HoauReservedResourcesLazyQueryHookResult = ReturnType<typeof useHoauReservedResourcesLazyQuery>;
export type HoauReservedResourcesQueryResult = Apollo.QueryResult<HoauReservedResourcesQuery, HoauReservedResourcesQueryVariables>;
export const SendMessageForAutomationDocument = gql`
    mutation SendMessageForAutomation($input: MessageForAutomationInput!) {
  sendMessageForAutomation(input: $input)
}
    `;
export type SendMessageForAutomationMutationFn = Apollo.MutationFunction<SendMessageForAutomationMutation, SendMessageForAutomationMutationVariables>;

/**
 * __useSendMessageForAutomationMutation__
 *
 * To run a mutation, you first call `useSendMessageForAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageForAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageForAutomationMutation, { data, loading, error }] = useSendMessageForAutomationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageForAutomationMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageForAutomationMutation, SendMessageForAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageForAutomationMutation, SendMessageForAutomationMutationVariables>(SendMessageForAutomationDocument, options);
      }
export type SendMessageForAutomationMutationHookResult = ReturnType<typeof useSendMessageForAutomationMutation>;
export type SendMessageForAutomationMutationResult = Apollo.MutationResult<SendMessageForAutomationMutation>;
export type SendMessageForAutomationMutationOptions = Apollo.BaseMutationOptions<SendMessageForAutomationMutation, SendMessageForAutomationMutationVariables>;
export const ReservationSearchWithDetailsDocument = gql`
    query ReservationSearchWithDetails($filter: ReservationFullTextQueryFilter!, $skip: Int, $limit: Int, $sort: ReservationFullTextQuerySortInput) {
  reservationSearch(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    ...ReservationSearchWithRR
  }
}
    ${ReservationSearchWithRRFragmentDoc}`;

/**
 * __useReservationSearchWithDetailsQuery__
 *
 * To run a query within a React component, call `useReservationSearchWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationSearchWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationSearchWithDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReservationSearchWithDetailsQuery(baseOptions: Apollo.QueryHookOptions<ReservationSearchWithDetailsQuery, ReservationSearchWithDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationSearchWithDetailsQuery, ReservationSearchWithDetailsQueryVariables>(ReservationSearchWithDetailsDocument, options);
      }
export function useReservationSearchWithDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationSearchWithDetailsQuery, ReservationSearchWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationSearchWithDetailsQuery, ReservationSearchWithDetailsQueryVariables>(ReservationSearchWithDetailsDocument, options);
        }
export type ReservationSearchWithDetailsQueryHookResult = ReturnType<typeof useReservationSearchWithDetailsQuery>;
export type ReservationSearchWithDetailsLazyQueryHookResult = ReturnType<typeof useReservationSearchWithDetailsLazyQuery>;
export type ReservationSearchWithDetailsQueryResult = Apollo.QueryResult<ReservationSearchWithDetailsQuery, ReservationSearchWithDetailsQueryVariables>;
export const RateQueryForResourceDocument = gql`
    query RateQueryForResource($filter: RqQueryForResourceFilter!) {
  rateQueryForResource(filter: $filter) {
    rate {
      resourceRates {
        dailyPrice {
          day
          price
        }
        chargeCategoryId
        resourceTypeId
      }
      bookingPolicyOverrideId
      rate {
        affiliatedCompaniesId
      }
      rateId
    }
  }
}
    `;

/**
 * __useRateQueryForResourceQuery__
 *
 * To run a query within a React component, call `useRateQueryForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRateQueryForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRateQueryForResourceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRateQueryForResourceQuery(baseOptions: Apollo.QueryHookOptions<RateQueryForResourceQuery, RateQueryForResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RateQueryForResourceQuery, RateQueryForResourceQueryVariables>(RateQueryForResourceDocument, options);
      }
export function useRateQueryForResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RateQueryForResourceQuery, RateQueryForResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RateQueryForResourceQuery, RateQueryForResourceQueryVariables>(RateQueryForResourceDocument, options);
        }
export type RateQueryForResourceQueryHookResult = ReturnType<typeof useRateQueryForResourceQuery>;
export type RateQueryForResourceLazyQueryHookResult = ReturnType<typeof useRateQueryForResourceLazyQuery>;
export type RateQueryForResourceQueryResult = Apollo.QueryResult<RateQueryForResourceQuery, RateQueryForResourceQueryVariables>;
export const ResourceTypesGroupDocument = gql`
    query ResourceTypesGroup($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    id
    maxAdults
    persons
  }
}
    `;

/**
 * __useResourceTypesGroupQuery__
 *
 * To run a query within a React component, call `useResourceTypesGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesGroupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypesGroupQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypesGroupQuery, ResourceTypesGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesGroupQuery, ResourceTypesGroupQueryVariables>(ResourceTypesGroupDocument, options);
      }
export function useResourceTypesGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesGroupQuery, ResourceTypesGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesGroupQuery, ResourceTypesGroupQueryVariables>(ResourceTypesGroupDocument, options);
        }
export type ResourceTypesGroupQueryHookResult = ReturnType<typeof useResourceTypesGroupQuery>;
export type ResourceTypesGroupLazyQueryHookResult = ReturnType<typeof useResourceTypesGroupLazyQuery>;
export type ResourceTypesGroupQueryResult = Apollo.QueryResult<ResourceTypesGroupQuery, ResourceTypesGroupQueryVariables>;
export const CreateResourceUnavailabilityDocument = gql`
    mutation CreateResourceUnavailability($value: CreateResourceUnavailabilityInput!, $allowOverbooking: Boolean!) {
  createResourceUnavailability(value: $value, allowOverbooking: $allowOverbooking) {
    id
  }
}
    `;
export type CreateResourceUnavailabilityMutationFn = Apollo.MutationFunction<CreateResourceUnavailabilityMutation, CreateResourceUnavailabilityMutationVariables>;

/**
 * __useCreateResourceUnavailabilityMutation__
 *
 * To run a mutation, you first call `useCreateResourceUnavailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceUnavailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceUnavailabilityMutation, { data, loading, error }] = useCreateResourceUnavailabilityMutation({
 *   variables: {
 *      value: // value for 'value'
 *      allowOverbooking: // value for 'allowOverbooking'
 *   },
 * });
 */
export function useCreateResourceUnavailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceUnavailabilityMutation, CreateResourceUnavailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceUnavailabilityMutation, CreateResourceUnavailabilityMutationVariables>(CreateResourceUnavailabilityDocument, options);
      }
export type CreateResourceUnavailabilityMutationHookResult = ReturnType<typeof useCreateResourceUnavailabilityMutation>;
export type CreateResourceUnavailabilityMutationResult = Apollo.MutationResult<CreateResourceUnavailabilityMutation>;
export type CreateResourceUnavailabilityMutationOptions = Apollo.BaseMutationOptions<CreateResourceUnavailabilityMutation, CreateResourceUnavailabilityMutationVariables>;
export const UpdateResourceUnavailabilityDocument = gql`
    mutation UpdateResourceUnavailability($value: UpdateResourceUnavailabilityInput!, $allowOverbooking: Boolean!) {
  updateResourceUnavailability(value: $value, allowOverbooking: $allowOverbooking) {
    id
  }
}
    `;
export type UpdateResourceUnavailabilityMutationFn = Apollo.MutationFunction<UpdateResourceUnavailabilityMutation, UpdateResourceUnavailabilityMutationVariables>;

/**
 * __useUpdateResourceUnavailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateResourceUnavailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceUnavailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceUnavailabilityMutation, { data, loading, error }] = useUpdateResourceUnavailabilityMutation({
 *   variables: {
 *      value: // value for 'value'
 *      allowOverbooking: // value for 'allowOverbooking'
 *   },
 * });
 */
export function useUpdateResourceUnavailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceUnavailabilityMutation, UpdateResourceUnavailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceUnavailabilityMutation, UpdateResourceUnavailabilityMutationVariables>(UpdateResourceUnavailabilityDocument, options);
      }
export type UpdateResourceUnavailabilityMutationHookResult = ReturnType<typeof useUpdateResourceUnavailabilityMutation>;
export type UpdateResourceUnavailabilityMutationResult = Apollo.MutationResult<UpdateResourceUnavailabilityMutation>;
export type UpdateResourceUnavailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateResourceUnavailabilityMutation, UpdateResourceUnavailabilityMutationVariables>;
export const DeleteResourceUnavailabilityDocument = gql`
    mutation DeleteResourceUnavailability($value: DeleteResourceUnavailabilityInput!) {
  deleteResourceUnavailability(value: $value) {
    id
  }
}
    `;
export type DeleteResourceUnavailabilityMutationFn = Apollo.MutationFunction<DeleteResourceUnavailabilityMutation, DeleteResourceUnavailabilityMutationVariables>;

/**
 * __useDeleteResourceUnavailabilityMutation__
 *
 * To run a mutation, you first call `useDeleteResourceUnavailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceUnavailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceUnavailabilityMutation, { data, loading, error }] = useDeleteResourceUnavailabilityMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useDeleteResourceUnavailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceUnavailabilityMutation, DeleteResourceUnavailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceUnavailabilityMutation, DeleteResourceUnavailabilityMutationVariables>(DeleteResourceUnavailabilityDocument, options);
      }
export type DeleteResourceUnavailabilityMutationHookResult = ReturnType<typeof useDeleteResourceUnavailabilityMutation>;
export type DeleteResourceUnavailabilityMutationResult = Apollo.MutationResult<DeleteResourceUnavailabilityMutation>;
export type DeleteResourceUnavailabilityMutationOptions = Apollo.BaseMutationOptions<DeleteResourceUnavailabilityMutation, DeleteResourceUnavailabilityMutationVariables>;
export const GetWorstBookingPolicyDocument = gql`
    query GetWorstBookingPolicy($input: WorstBookingPolicyInput!) {
  getWorstBookingPolicy(input: $input) {
    additionalNote
    cancellationPolicy {
      daysWithoutPenalties
      hourWithoutPenalties
      penaltyType
      percentage
      type
    }
    name
    noShowRule {
      percentage
      type
    }
    paymentRule {
      guaranteedCreditCard
      installments {
        dayFromCheckin
        order
        value
      }
      paymentsAcceptedId
      percentage
      type
    }
  }
}
    `;

/**
 * __useGetWorstBookingPolicyQuery__
 *
 * To run a query within a React component, call `useGetWorstBookingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorstBookingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorstBookingPolicyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorstBookingPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>(GetWorstBookingPolicyDocument, options);
      }
export function useGetWorstBookingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>(GetWorstBookingPolicyDocument, options);
        }
export type GetWorstBookingPolicyQueryHookResult = ReturnType<typeof useGetWorstBookingPolicyQuery>;
export type GetWorstBookingPolicyLazyQueryHookResult = ReturnType<typeof useGetWorstBookingPolicyLazyQuery>;
export type GetWorstBookingPolicyQueryResult = Apollo.QueryResult<GetWorstBookingPolicyQuery, GetWorstBookingPolicyQueryVariables>;
export const CustomersDocument = gql`
    query Customers($filter: CustomerQueryFilter!, $sorts: [CustomerSortInput!], $skip: Int, $limit: Int) {
  customers(filter: $filter, sorts: $sorts, skip: $skip, limit: $limit) {
    ...CustomerList
  }
}
    ${CustomerListFragmentDoc}`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorts: // value for 'sorts'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const CustomerDocument = gql`
    query Customer($tenantId: ID!, $customerId: ID, $dummy: Boolean) {
  customers(
    filter: {tenantId: {eq: $tenantId}, id: {eq: $customerId}, dummy: $dummy}
    skip: 0
    limit: 1
  ) {
    ...CustomerDetail
  }
}
    ${CustomerDetailFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      customerId: // value for 'customerId'
 *      dummy: // value for 'dummy'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CustomerNewDocument = gql`
    mutation CustomerNew($input: CustomerInput!) {
  createCustomer(value: $input) {
    ...CustomerDetail
  }
}
    ${CustomerDetailFragmentDoc}`;
export type CustomerNewMutationFn = Apollo.MutationFunction<CustomerNewMutation, CustomerNewMutationVariables>;

/**
 * __useCustomerNewMutation__
 *
 * To run a mutation, you first call `useCustomerNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerNewMutation, { data, loading, error }] = useCustomerNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerNewMutation(baseOptions?: Apollo.MutationHookOptions<CustomerNewMutation, CustomerNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerNewMutation, CustomerNewMutationVariables>(CustomerNewDocument, options);
      }
export type CustomerNewMutationHookResult = ReturnType<typeof useCustomerNewMutation>;
export type CustomerNewMutationResult = Apollo.MutationResult<CustomerNewMutation>;
export type CustomerNewMutationOptions = Apollo.BaseMutationOptions<CustomerNewMutation, CustomerNewMutationVariables>;
export const CustomerUpdateDocument = gql`
    mutation CustomerUpdate($id: String!, $input: CustomerInput!, $guestOfReservedResourceId: ID) {
  updateCustomer(
    id: $id
    value: $input
    guestOfReservedResourceId: $guestOfReservedResourceId
  ) {
    ...CustomerDetail
  }
}
    ${CustomerDetailFragmentDoc}`;
export type CustomerUpdateMutationFn = Apollo.MutationFunction<CustomerUpdateMutation, CustomerUpdateMutationVariables>;

/**
 * __useCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMutation, { data, loading, error }] = useCustomerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      guestOfReservedResourceId: // value for 'guestOfReservedResourceId'
 *   },
 * });
 */
export function useCustomerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateMutation, CustomerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateMutation, CustomerUpdateMutationVariables>(CustomerUpdateDocument, options);
      }
export type CustomerUpdateMutationHookResult = ReturnType<typeof useCustomerUpdateMutation>;
export type CustomerUpdateMutationResult = Apollo.MutationResult<CustomerUpdateMutation>;
export type CustomerUpdateMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateMutation, CustomerUpdateMutationVariables>;
export const CustomerDeleteDocument = gql`
    mutation CustomerDelete($tenantId: ID!, $id: String!) {
  deleteCustomer(tenantId: $tenantId, id: $id)
}
    `;
export type CustomerDeleteMutationFn = Apollo.MutationFunction<CustomerDeleteMutation, CustomerDeleteMutationVariables>;

/**
 * __useCustomerDeleteMutation__
 *
 * To run a mutation, you first call `useCustomerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerDeleteMutation, { data, loading, error }] = useCustomerDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CustomerDeleteMutation, CustomerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerDeleteMutation, CustomerDeleteMutationVariables>(CustomerDeleteDocument, options);
      }
export type CustomerDeleteMutationHookResult = ReturnType<typeof useCustomerDeleteMutation>;
export type CustomerDeleteMutationResult = Apollo.MutationResult<CustomerDeleteMutation>;
export type CustomerDeleteMutationOptions = Apollo.BaseMutationOptions<CustomerDeleteMutation, CustomerDeleteMutationVariables>;
export const SimpleCustomersLookupDocument = gql`
    query SimpleCustomersLookup($tenantId: ID!, $search: StringFilter, $idFilter: IDFilter, $type: CustomerType, $skip: Int, $limit: Int) {
  customers(
    filter: {tenantId: {eq: $tenantId}, search: $search, id: $idFilter, type: $type}
    skip: $skip
    limit: $limit
  ) {
    ...SimpleCustomerLookup
  }
}
    ${SimpleCustomerLookupFragmentDoc}`;

/**
 * __useSimpleCustomersLookupQuery__
 *
 * To run a query within a React component, call `useSimpleCustomersLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleCustomersLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleCustomersLookupQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *      idFilter: // value for 'idFilter'
 *      type: // value for 'type'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSimpleCustomersLookupQuery(baseOptions: Apollo.QueryHookOptions<SimpleCustomersLookupQuery, SimpleCustomersLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleCustomersLookupQuery, SimpleCustomersLookupQueryVariables>(SimpleCustomersLookupDocument, options);
      }
export function useSimpleCustomersLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimpleCustomersLookupQuery, SimpleCustomersLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleCustomersLookupQuery, SimpleCustomersLookupQueryVariables>(SimpleCustomersLookupDocument, options);
        }
export type SimpleCustomersLookupQueryHookResult = ReturnType<typeof useSimpleCustomersLookupQuery>;
export type SimpleCustomersLookupLazyQueryHookResult = ReturnType<typeof useSimpleCustomersLookupLazyQuery>;
export type SimpleCustomersLookupQueryResult = Apollo.QueryResult<SimpleCustomersLookupQuery, SimpleCustomersLookupQueryVariables>;
export const ValidateItalianFiscalCodeDocument = gql`
    query ValidateItalianFiscalCode($fiscalCode: String!) {
  validateItalianFiscalCode(fiscalCode: $fiscalCode)
}
    `;

/**
 * __useValidateItalianFiscalCodeQuery__
 *
 * To run a query within a React component, call `useValidateItalianFiscalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateItalianFiscalCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateItalianFiscalCodeQuery({
 *   variables: {
 *      fiscalCode: // value for 'fiscalCode'
 *   },
 * });
 */
export function useValidateItalianFiscalCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateItalianFiscalCodeQuery, ValidateItalianFiscalCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateItalianFiscalCodeQuery, ValidateItalianFiscalCodeQueryVariables>(ValidateItalianFiscalCodeDocument, options);
      }
export function useValidateItalianFiscalCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateItalianFiscalCodeQuery, ValidateItalianFiscalCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateItalianFiscalCodeQuery, ValidateItalianFiscalCodeQueryVariables>(ValidateItalianFiscalCodeDocument, options);
        }
export type ValidateItalianFiscalCodeQueryHookResult = ReturnType<typeof useValidateItalianFiscalCodeQuery>;
export type ValidateItalianFiscalCodeLazyQueryHookResult = ReturnType<typeof useValidateItalianFiscalCodeLazyQuery>;
export type ValidateItalianFiscalCodeQueryResult = Apollo.QueryResult<ValidateItalianFiscalCodeQuery, ValidateItalianFiscalCodeQueryVariables>;
export const ValidateItalianVatCodeDocument = gql`
    query ValidateItalianVatCode($vatCode: String!) {
  validateItalianVatCode(vatCode: $vatCode)
}
    `;

/**
 * __useValidateItalianVatCodeQuery__
 *
 * To run a query within a React component, call `useValidateItalianVatCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateItalianVatCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateItalianVatCodeQuery({
 *   variables: {
 *      vatCode: // value for 'vatCode'
 *   },
 * });
 */
export function useValidateItalianVatCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateItalianVatCodeQuery, ValidateItalianVatCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateItalianVatCodeQuery, ValidateItalianVatCodeQueryVariables>(ValidateItalianVatCodeDocument, options);
      }
export function useValidateItalianVatCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateItalianVatCodeQuery, ValidateItalianVatCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateItalianVatCodeQuery, ValidateItalianVatCodeQueryVariables>(ValidateItalianVatCodeDocument, options);
        }
export type ValidateItalianVatCodeQueryHookResult = ReturnType<typeof useValidateItalianVatCodeQuery>;
export type ValidateItalianVatCodeLazyQueryHookResult = ReturnType<typeof useValidateItalianVatCodeLazyQuery>;
export type ValidateItalianVatCodeQueryResult = Apollo.QueryResult<ValidateItalianVatCodeQuery, ValidateItalianVatCodeQueryVariables>;
export const CityTaxForPersonFormDocument = gql`
    query CityTaxForPersonForm($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    cityTaxConfiguration {
      configurations {
        rule
      }
    }
  }
}
    `;

/**
 * __useCityTaxForPersonFormQuery__
 *
 * To run a query within a React component, call `useCityTaxForPersonFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityTaxForPersonFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityTaxForPersonFormQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCityTaxForPersonFormQuery(baseOptions: Apollo.QueryHookOptions<CityTaxForPersonFormQuery, CityTaxForPersonFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityTaxForPersonFormQuery, CityTaxForPersonFormQueryVariables>(CityTaxForPersonFormDocument, options);
      }
export function useCityTaxForPersonFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityTaxForPersonFormQuery, CityTaxForPersonFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityTaxForPersonFormQuery, CityTaxForPersonFormQueryVariables>(CityTaxForPersonFormDocument, options);
        }
export type CityTaxForPersonFormQueryHookResult = ReturnType<typeof useCityTaxForPersonFormQuery>;
export type CityTaxForPersonFormLazyQueryHookResult = ReturnType<typeof useCityTaxForPersonFormLazyQuery>;
export type CityTaxForPersonFormQueryResult = Apollo.QueryResult<CityTaxForPersonFormQuery, CityTaxForPersonFormQueryVariables>;
export const GuestNameDocument = gql`
    query GuestName($tenantId: ID!, $guestId: ID!) {
  customers(filter: {tenantId: {eq: $tenantId}, id: {eq: $guestId}}, limit: 1) {
    id
    name
  }
}
    `;

/**
 * __useGuestNameQuery__
 *
 * To run a query within a React component, call `useGuestNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestNameQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      guestId: // value for 'guestId'
 *   },
 * });
 */
export function useGuestNameQuery(baseOptions: Apollo.QueryHookOptions<GuestNameQuery, GuestNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestNameQuery, GuestNameQueryVariables>(GuestNameDocument, options);
      }
export function useGuestNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestNameQuery, GuestNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestNameQuery, GuestNameQueryVariables>(GuestNameDocument, options);
        }
export type GuestNameQueryHookResult = ReturnType<typeof useGuestNameQuery>;
export type GuestNameLazyQueryHookResult = ReturnType<typeof useGuestNameLazyQuery>;
export type GuestNameQueryResult = Apollo.QueryResult<GuestNameQuery, GuestNameQueryVariables>;
export const DailyClosureAuditsDocument = gql`
    query DailyClosureAudits($filter: DailyClosureAuditQueryFilter!, $sorts: [DailyClosureAuditSortInput!], $limit: Int) {
  dailyClosureAudits(filter: $filter, sorts: $sorts, limit: $limit) {
    ...DailyClosureAudit
  }
}
    ${DailyClosureAuditFragmentDoc}`;

/**
 * __useDailyClosureAuditsQuery__
 *
 * To run a query within a React component, call `useDailyClosureAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyClosureAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyClosureAuditsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorts: // value for 'sorts'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDailyClosureAuditsQuery(baseOptions: Apollo.QueryHookOptions<DailyClosureAuditsQuery, DailyClosureAuditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyClosureAuditsQuery, DailyClosureAuditsQueryVariables>(DailyClosureAuditsDocument, options);
      }
export function useDailyClosureAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyClosureAuditsQuery, DailyClosureAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyClosureAuditsQuery, DailyClosureAuditsQueryVariables>(DailyClosureAuditsDocument, options);
        }
export type DailyClosureAuditsQueryHookResult = ReturnType<typeof useDailyClosureAuditsQuery>;
export type DailyClosureAuditsLazyQueryHookResult = ReturnType<typeof useDailyClosureAuditsLazyQuery>;
export type DailyClosureAuditsQueryResult = Apollo.QueryResult<DailyClosureAuditsQuery, DailyClosureAuditsQueryVariables>;
export const DashboardKpiDocument = gql`
    query DashboardKpi($tenantId: ID!, $propertyId: ID!, $date: Date!) {
  dashboardReception(
    filter: {tenantId: $tenantId, propertyId: $propertyId, date: $date}
  ) {
    ...DashboardReception
  }
  dashboardMeals(
    filter: {tenantId: $tenantId, propertyId: $propertyId, date: $date}
  ) {
    ...DashboardMeals
  }
  dashboardRevenue(
    filter: {tenantId: $tenantId, propertyId: $propertyId, date: $date}
  ) {
    ...DashboardRevenue
  }
  dashboardSells(
    filter: {tenantId: $tenantId, propertyId: $propertyId, date: $date}
  ) {
    ...DashboardSales
  }
}
    ${DashboardReceptionFragmentDoc}
${DashboardMealsFragmentDoc}
${DashboardRevenueFragmentDoc}
${DashboardSalesFragmentDoc}`;

/**
 * __useDashboardKpiQuery__
 *
 * To run a query within a React component, call `useDashboardKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardKpiQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDashboardKpiQuery(baseOptions: Apollo.QueryHookOptions<DashboardKpiQuery, DashboardKpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardKpiQuery, DashboardKpiQueryVariables>(DashboardKpiDocument, options);
      }
export function useDashboardKpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardKpiQuery, DashboardKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardKpiQuery, DashboardKpiQueryVariables>(DashboardKpiDocument, options);
        }
export type DashboardKpiQueryHookResult = ReturnType<typeof useDashboardKpiQuery>;
export type DashboardKpiLazyQueryHookResult = ReturnType<typeof useDashboardKpiLazyQuery>;
export type DashboardKpiQueryResult = Apollo.QueryResult<DashboardKpiQuery, DashboardKpiQueryVariables>;
export const DashboardRRsDocument = gql`
    query DashboardRRs($filter: DashboardQueryFilter!) {
  dashboardRRs(filter: $filter) {
    ...DashboardRR
  }
}
    ${DashboardRRFragmentDoc}`;

/**
 * __useDashboardRRsQuery__
 *
 * To run a query within a React component, call `useDashboardRRsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardRRsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardRRsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardRRsQuery(baseOptions: Apollo.QueryHookOptions<DashboardRRsQuery, DashboardRRsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardRRsQuery, DashboardRRsQueryVariables>(DashboardRRsDocument, options);
      }
export function useDashboardRRsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardRRsQuery, DashboardRRsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardRRsQuery, DashboardRRsQueryVariables>(DashboardRRsDocument, options);
        }
export type DashboardRRsQueryHookResult = ReturnType<typeof useDashboardRRsQuery>;
export type DashboardRRsLazyQueryHookResult = ReturnType<typeof useDashboardRRsLazyQuery>;
export type DashboardRRsQueryResult = Apollo.QueryResult<DashboardRRsQuery, DashboardRRsQueryVariables>;
export const IstatDailyClosureAuditsDocument = gql`
    query IstatDailyClosureAudits($filter: DailyClosureAuditQueryFilter!, $sorts: [DailyClosureAuditSortInput!], $limit: Int) {
  dailyClosureAudits(filter: $filter, sorts: $sorts, limit: $limit) {
    ...IstatDailyClosureAudit
  }
}
    ${IstatDailyClosureAuditFragmentDoc}`;

/**
 * __useIstatDailyClosureAuditsQuery__
 *
 * To run a query within a React component, call `useIstatDailyClosureAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIstatDailyClosureAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIstatDailyClosureAuditsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorts: // value for 'sorts'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIstatDailyClosureAuditsQuery(baseOptions: Apollo.QueryHookOptions<IstatDailyClosureAuditsQuery, IstatDailyClosureAuditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IstatDailyClosureAuditsQuery, IstatDailyClosureAuditsQueryVariables>(IstatDailyClosureAuditsDocument, options);
      }
export function useIstatDailyClosureAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IstatDailyClosureAuditsQuery, IstatDailyClosureAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IstatDailyClosureAuditsQuery, IstatDailyClosureAuditsQueryVariables>(IstatDailyClosureAuditsDocument, options);
        }
export type IstatDailyClosureAuditsQueryHookResult = ReturnType<typeof useIstatDailyClosureAuditsQuery>;
export type IstatDailyClosureAuditsLazyQueryHookResult = ReturnType<typeof useIstatDailyClosureAuditsLazyQuery>;
export type IstatDailyClosureAuditsQueryResult = Apollo.QueryResult<IstatDailyClosureAuditsQuery, IstatDailyClosureAuditsQueryVariables>;
export const DashboardCleaningDocument = gql`
    query DashboardCleaning($filter: ResourceQueryFilter!) {
  resourcesHousekeeping(filter: $filter) {
    ...DashboardCleaning
  }
}
    ${DashboardCleaningFragmentDoc}`;

/**
 * __useDashboardCleaningQuery__
 *
 * To run a query within a React component, call `useDashboardCleaningQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCleaningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCleaningQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardCleaningQuery(baseOptions: Apollo.QueryHookOptions<DashboardCleaningQuery, DashboardCleaningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCleaningQuery, DashboardCleaningQueryVariables>(DashboardCleaningDocument, options);
      }
export function useDashboardCleaningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCleaningQuery, DashboardCleaningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCleaningQuery, DashboardCleaningQueryVariables>(DashboardCleaningDocument, options);
        }
export type DashboardCleaningQueryHookResult = ReturnType<typeof useDashboardCleaningQuery>;
export type DashboardCleaningLazyQueryHookResult = ReturnType<typeof useDashboardCleaningLazyQuery>;
export type DashboardCleaningQueryResult = Apollo.QueryResult<DashboardCleaningQuery, DashboardCleaningQueryVariables>;
export const DashboardKpiEventDocument = gql`
    subscription DashboardKpiEvent($filter: DashboardQueryFilter!) {
  dashboardKpiEvent(filter: $filter) {
    tenantId
    propertyId
    date
  }
}
    `;

/**
 * __useDashboardKpiEventSubscription__
 *
 * To run a query within a React component, call `useDashboardKpiEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDashboardKpiEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardKpiEventSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDashboardKpiEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<DashboardKpiEventSubscription, DashboardKpiEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DashboardKpiEventSubscription, DashboardKpiEventSubscriptionVariables>(DashboardKpiEventDocument, options);
      }
export type DashboardKpiEventSubscriptionHookResult = ReturnType<typeof useDashboardKpiEventSubscription>;
export type DashboardKpiEventSubscriptionResult = Apollo.SubscriptionResult<DashboardKpiEventSubscription>;
export const SendReservationEmailDocument = gql`
    mutation SendReservationEmail($input: SendReservationMessageInput!) {
  sendReservationMessage(input: $input)
}
    `;
export type SendReservationEmailMutationFn = Apollo.MutationFunction<SendReservationEmailMutation, SendReservationEmailMutationVariables>;

/**
 * __useSendReservationEmailMutation__
 *
 * To run a mutation, you first call `useSendReservationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReservationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReservationEmailMutation, { data, loading, error }] = useSendReservationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReservationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendReservationEmailMutation, SendReservationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReservationEmailMutation, SendReservationEmailMutationVariables>(SendReservationEmailDocument, options);
      }
export type SendReservationEmailMutationHookResult = ReturnType<typeof useSendReservationEmailMutation>;
export type SendReservationEmailMutationResult = Apollo.MutationResult<SendReservationEmailMutation>;
export type SendReservationEmailMutationOptions = Apollo.BaseMutationOptions<SendReservationEmailMutation, SendReservationEmailMutationVariables>;
export const SendPosLink2PayEmailDocument = gql`
    mutation SendPosLink2PayEmail($input: SendPosLink2PayEmailInput!) {
  sendPosLink2PayEmail(input: $input) {
    emailState
    stateTransaction {
      result
      state
    }
  }
}
    `;
export type SendPosLink2PayEmailMutationFn = Apollo.MutationFunction<SendPosLink2PayEmailMutation, SendPosLink2PayEmailMutationVariables>;

/**
 * __useSendPosLink2PayEmailMutation__
 *
 * To run a mutation, you first call `useSendPosLink2PayEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPosLink2PayEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPosLink2PayEmailMutation, { data, loading, error }] = useSendPosLink2PayEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPosLink2PayEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPosLink2PayEmailMutation, SendPosLink2PayEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPosLink2PayEmailMutation, SendPosLink2PayEmailMutationVariables>(SendPosLink2PayEmailDocument, options);
      }
export type SendPosLink2PayEmailMutationHookResult = ReturnType<typeof useSendPosLink2PayEmailMutation>;
export type SendPosLink2PayEmailMutationResult = Apollo.MutationResult<SendPosLink2PayEmailMutation>;
export type SendPosLink2PayEmailMutationOptions = Apollo.BaseMutationOptions<SendPosLink2PayEmailMutation, SendPosLink2PayEmailMutationVariables>;
export const PropertyEmailDocument = gql`
    query PropertyEmail($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    mailContacts {
      value
      type
    }
  }
}
    `;

/**
 * __usePropertyEmailQuery__
 *
 * To run a query within a React component, call `usePropertyEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyEmailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyEmailQuery(baseOptions: Apollo.QueryHookOptions<PropertyEmailQuery, PropertyEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyEmailQuery, PropertyEmailQueryVariables>(PropertyEmailDocument, options);
      }
export function usePropertyEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyEmailQuery, PropertyEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyEmailQuery, PropertyEmailQueryVariables>(PropertyEmailDocument, options);
        }
export type PropertyEmailQueryHookResult = ReturnType<typeof usePropertyEmailQuery>;
export type PropertyEmailLazyQueryHookResult = ReturnType<typeof usePropertyEmailLazyQuery>;
export type PropertyEmailQueryResult = Apollo.QueryResult<PropertyEmailQuery, PropertyEmailQueryVariables>;
export const SendAttachmentEmailForDocumentDocument = gql`
    mutation SendAttachmentEmailForDocument($input: AttachmentForDocumentInput!) {
  sendAttachmentEmailForDocument(input: $input) {
    id
  }
}
    `;
export type SendAttachmentEmailForDocumentMutationFn = Apollo.MutationFunction<SendAttachmentEmailForDocumentMutation, SendAttachmentEmailForDocumentMutationVariables>;

/**
 * __useSendAttachmentEmailForDocumentMutation__
 *
 * To run a mutation, you first call `useSendAttachmentEmailForDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAttachmentEmailForDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAttachmentEmailForDocumentMutation, { data, loading, error }] = useSendAttachmentEmailForDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAttachmentEmailForDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SendAttachmentEmailForDocumentMutation, SendAttachmentEmailForDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAttachmentEmailForDocumentMutation, SendAttachmentEmailForDocumentMutationVariables>(SendAttachmentEmailForDocumentDocument, options);
      }
export type SendAttachmentEmailForDocumentMutationHookResult = ReturnType<typeof useSendAttachmentEmailForDocumentMutation>;
export type SendAttachmentEmailForDocumentMutationResult = Apollo.MutationResult<SendAttachmentEmailForDocumentMutation>;
export type SendAttachmentEmailForDocumentMutationOptions = Apollo.BaseMutationOptions<SendAttachmentEmailForDocumentMutation, SendAttachmentEmailForDocumentMutationVariables>;
export const HistoricalCustomerResearchDocument = gql`
    query HistoricalCustomerResearch($filter: ReservationQueryFilter!) {
  reservations(filter: $filter) {
    ...HistoricalCustomerResearch
  }
}
    ${HistoricalCustomerResearchFragmentDoc}`;

/**
 * __useHistoricalCustomerResearchQuery__
 *
 * To run a query within a React component, call `useHistoricalCustomerResearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalCustomerResearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalCustomerResearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHistoricalCustomerResearchQuery(baseOptions: Apollo.QueryHookOptions<HistoricalCustomerResearchQuery, HistoricalCustomerResearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalCustomerResearchQuery, HistoricalCustomerResearchQueryVariables>(HistoricalCustomerResearchDocument, options);
      }
export function useHistoricalCustomerResearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalCustomerResearchQuery, HistoricalCustomerResearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalCustomerResearchQuery, HistoricalCustomerResearchQueryVariables>(HistoricalCustomerResearchDocument, options);
        }
export type HistoricalCustomerResearchQueryHookResult = ReturnType<typeof useHistoricalCustomerResearchQuery>;
export type HistoricalCustomerResearchLazyQueryHookResult = ReturnType<typeof useHistoricalCustomerResearchLazyQuery>;
export type HistoricalCustomerResearchQueryResult = Apollo.QueryResult<HistoricalCustomerResearchQuery, HistoricalCustomerResearchQueryVariables>;
export const HistoricalCustomerReservedResourceResearchDocument = gql`
    query HistoricalCustomerReservedResourceResearch($filter: ReservedResourceQueryFilter!) {
  reservedResources(filter: $filter) {
    ...HistoricalCustomerReservedResourceResearch
  }
}
    ${HistoricalCustomerReservedResourceResearchFragmentDoc}`;

/**
 * __useHistoricalCustomerReservedResourceResearchQuery__
 *
 * To run a query within a React component, call `useHistoricalCustomerReservedResourceResearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalCustomerReservedResourceResearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalCustomerReservedResourceResearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHistoricalCustomerReservedResourceResearchQuery(baseOptions: Apollo.QueryHookOptions<HistoricalCustomerReservedResourceResearchQuery, HistoricalCustomerReservedResourceResearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalCustomerReservedResourceResearchQuery, HistoricalCustomerReservedResourceResearchQueryVariables>(HistoricalCustomerReservedResourceResearchDocument, options);
      }
export function useHistoricalCustomerReservedResourceResearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalCustomerReservedResourceResearchQuery, HistoricalCustomerReservedResourceResearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalCustomerReservedResourceResearchQuery, HistoricalCustomerReservedResourceResearchQueryVariables>(HistoricalCustomerReservedResourceResearchDocument, options);
        }
export type HistoricalCustomerReservedResourceResearchQueryHookResult = ReturnType<typeof useHistoricalCustomerReservedResourceResearchQuery>;
export type HistoricalCustomerReservedResourceResearchLazyQueryHookResult = ReturnType<typeof useHistoricalCustomerReservedResourceResearchLazyQuery>;
export type HistoricalCustomerReservedResourceResearchQueryResult = Apollo.QueryResult<HistoricalCustomerReservedResourceResearchQuery, HistoricalCustomerReservedResourceResearchQueryVariables>;
export const NotificationBellNscSummaryDocument = gql`
    query NotificationBellNscSummary($tenantId: ID!, $propertyId: ID!, $userId: ID!) {
  getNcsNotificationsSummary(
    tenantId: $tenantId
    propertyId: $propertyId
    userId: $userId
  ) {
    unread
    appCode
  }
}
    `;

/**
 * __useNotificationBellNscSummaryQuery__
 *
 * To run a query within a React component, call `useNotificationBellNscSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationBellNscSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationBellNscSummaryQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationBellNscSummaryQuery(baseOptions: Apollo.QueryHookOptions<NotificationBellNscSummaryQuery, NotificationBellNscSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationBellNscSummaryQuery, NotificationBellNscSummaryQueryVariables>(NotificationBellNscSummaryDocument, options);
      }
export function useNotificationBellNscSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationBellNscSummaryQuery, NotificationBellNscSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationBellNscSummaryQuery, NotificationBellNscSummaryQueryVariables>(NotificationBellNscSummaryDocument, options);
        }
export type NotificationBellNscSummaryQueryHookResult = ReturnType<typeof useNotificationBellNscSummaryQuery>;
export type NotificationBellNscSummaryLazyQueryHookResult = ReturnType<typeof useNotificationBellNscSummaryLazyQuery>;
export type NotificationBellNscSummaryQueryResult = Apollo.QueryResult<NotificationBellNscSummaryQuery, NotificationBellNscSummaryQueryVariables>;
export const GetNcsNotificationsDocument = gql`
    query GetNcsNotifications($tenantId: ID!, $propertyId: ID!, $userId: ID!) {
  getNcsNotifications(
    tenantId: $tenantId
    propertyId: $propertyId
    userId: $userId
  ) {
    ...NcsNotification
  }
}
    ${NcsNotificationFragmentDoc}`;

/**
 * __useGetNcsNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNcsNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNcsNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNcsNotificationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNcsNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNcsNotificationsQuery, GetNcsNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNcsNotificationsQuery, GetNcsNotificationsQueryVariables>(GetNcsNotificationsDocument, options);
      }
export function useGetNcsNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNcsNotificationsQuery, GetNcsNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNcsNotificationsQuery, GetNcsNotificationsQueryVariables>(GetNcsNotificationsDocument, options);
        }
export type GetNcsNotificationsQueryHookResult = ReturnType<typeof useGetNcsNotificationsQuery>;
export type GetNcsNotificationsLazyQueryHookResult = ReturnType<typeof useGetNcsNotificationsLazyQuery>;
export type GetNcsNotificationsQueryResult = Apollo.QueryResult<GetNcsNotificationsQuery, GetNcsNotificationsQueryVariables>;
export const NcsUserPreferencesDocument = gql`
    query NcsUserPreferences($tenantId: ID!, $propertyId: ID!, $userId: ID!) {
  ncsUserPreferences(
    tenantId: $tenantId
    propertyId: $propertyId
    userId: $userId
  ) {
    templates {
      channels
      template
    }
  }
}
    `;

/**
 * __useNcsUserPreferencesQuery__
 *
 * To run a query within a React component, call `useNcsUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNcsUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNcsUserPreferencesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNcsUserPreferencesQuery(baseOptions: Apollo.QueryHookOptions<NcsUserPreferencesQuery, NcsUserPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NcsUserPreferencesQuery, NcsUserPreferencesQueryVariables>(NcsUserPreferencesDocument, options);
      }
export function useNcsUserPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NcsUserPreferencesQuery, NcsUserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NcsUserPreferencesQuery, NcsUserPreferencesQueryVariables>(NcsUserPreferencesDocument, options);
        }
export type NcsUserPreferencesQueryHookResult = ReturnType<typeof useNcsUserPreferencesQuery>;
export type NcsUserPreferencesLazyQueryHookResult = ReturnType<typeof useNcsUserPreferencesLazyQuery>;
export type NcsUserPreferencesQueryResult = Apollo.QueryResult<NcsUserPreferencesQuery, NcsUserPreferencesQueryVariables>;
export const SetNcsUserPreferenceDocument = gql`
    mutation SetNcsUserPreference($tenantId: ID!, $propertyId: ID!, $userId: ID!, $preferences: [NcsTemplatePreferenceInput!]!) {
  setNcsUserPreference(
    tenantId: $tenantId
    propertyId: $propertyId
    userId: $userId
    preferences: $preferences
  )
}
    `;
export type SetNcsUserPreferenceMutationFn = Apollo.MutationFunction<SetNcsUserPreferenceMutation, SetNcsUserPreferenceMutationVariables>;

/**
 * __useSetNcsUserPreferenceMutation__
 *
 * To run a mutation, you first call `useSetNcsUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNcsUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNcsUserPreferenceMutation, { data, loading, error }] = useSetNcsUserPreferenceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSetNcsUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetNcsUserPreferenceMutation, SetNcsUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNcsUserPreferenceMutation, SetNcsUserPreferenceMutationVariables>(SetNcsUserPreferenceDocument, options);
      }
export type SetNcsUserPreferenceMutationHookResult = ReturnType<typeof useSetNcsUserPreferenceMutation>;
export type SetNcsUserPreferenceMutationResult = Apollo.MutationResult<SetNcsUserPreferenceMutation>;
export type SetNcsUserPreferenceMutationOptions = Apollo.BaseMutationOptions<SetNcsUserPreferenceMutation, SetNcsUserPreferenceMutationVariables>;
export const SetNcsNotificationReadDocument = gql`
    mutation SetNcsNotificationRead($notificationId: String!, $read: Boolean!) {
  setNcsNotificationRead(id: $notificationId, read: $read)
}
    `;
export type SetNcsNotificationReadMutationFn = Apollo.MutationFunction<SetNcsNotificationReadMutation, SetNcsNotificationReadMutationVariables>;

/**
 * __useSetNcsNotificationReadMutation__
 *
 * To run a mutation, you first call `useSetNcsNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNcsNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNcsNotificationReadMutation, { data, loading, error }] = useSetNcsNotificationReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useSetNcsNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<SetNcsNotificationReadMutation, SetNcsNotificationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNcsNotificationReadMutation, SetNcsNotificationReadMutationVariables>(SetNcsNotificationReadDocument, options);
      }
export type SetNcsNotificationReadMutationHookResult = ReturnType<typeof useSetNcsNotificationReadMutation>;
export type SetNcsNotificationReadMutationResult = Apollo.MutationResult<SetNcsNotificationReadMutation>;
export type SetNcsNotificationReadMutationOptions = Apollo.BaseMutationOptions<SetNcsNotificationReadMutation, SetNcsNotificationReadMutationVariables>;
export const SetNcsNotificationsReadDocument = gql`
    mutation SetNcsNotificationsRead($tenantId: ID!, $read: Boolean!, $userId: ID, $propertyId: ID!) {
  setNcsNotificationsRead(
    tenantId: $tenantId
    read: $read
    userId: $userId
    propertyId: $propertyId
  )
}
    `;
export type SetNcsNotificationsReadMutationFn = Apollo.MutationFunction<SetNcsNotificationsReadMutation, SetNcsNotificationsReadMutationVariables>;

/**
 * __useSetNcsNotificationsReadMutation__
 *
 * To run a mutation, you first call `useSetNcsNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNcsNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNcsNotificationsReadMutation, { data, loading, error }] = useSetNcsNotificationsReadMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      read: // value for 'read'
 *      userId: // value for 'userId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useSetNcsNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<SetNcsNotificationsReadMutation, SetNcsNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNcsNotificationsReadMutation, SetNcsNotificationsReadMutationVariables>(SetNcsNotificationsReadDocument, options);
      }
export type SetNcsNotificationsReadMutationHookResult = ReturnType<typeof useSetNcsNotificationsReadMutation>;
export type SetNcsNotificationsReadMutationResult = Apollo.MutationResult<SetNcsNotificationsReadMutation>;
export type SetNcsNotificationsReadMutationOptions = Apollo.BaseMutationOptions<SetNcsNotificationsReadMutation, SetNcsNotificationsReadMutationVariables>;
export const AllBookingPoliciesDocument = gql`
    query AllBookingPolicies($tenantId: ID!, $propertyId: ID!) {
  bookingPolicies(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}}
  ) {
    ...BookingPolicyList
  }
}
    ${BookingPolicyListFragmentDoc}`;

/**
 * __useAllBookingPoliciesQuery__
 *
 * To run a query within a React component, call `useAllBookingPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBookingPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBookingPoliciesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAllBookingPoliciesQuery(baseOptions: Apollo.QueryHookOptions<AllBookingPoliciesQuery, AllBookingPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBookingPoliciesQuery, AllBookingPoliciesQueryVariables>(AllBookingPoliciesDocument, options);
      }
export function useAllBookingPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBookingPoliciesQuery, AllBookingPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBookingPoliciesQuery, AllBookingPoliciesQueryVariables>(AllBookingPoliciesDocument, options);
        }
export type AllBookingPoliciesQueryHookResult = ReturnType<typeof useAllBookingPoliciesQuery>;
export type AllBookingPoliciesLazyQueryHookResult = ReturnType<typeof useAllBookingPoliciesLazyQuery>;
export type AllBookingPoliciesQueryResult = Apollo.QueryResult<AllBookingPoliciesQuery, AllBookingPoliciesQueryVariables>;
export const BaseRateConfiguredResourceTypesDocument = gql`
    query BaseRateConfiguredResourceTypes($filter: RateQueryFilter!) {
  rates(filter: $filter) {
    ...BaseRateConfiguredResourceTypes
  }
}
    ${BaseRateConfiguredResourceTypesFragmentDoc}`;

/**
 * __useBaseRateConfiguredResourceTypesQuery__
 *
 * To run a query within a React component, call `useBaseRateConfiguredResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseRateConfiguredResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseRateConfiguredResourceTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBaseRateConfiguredResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<BaseRateConfiguredResourceTypesQuery, BaseRateConfiguredResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BaseRateConfiguredResourceTypesQuery, BaseRateConfiguredResourceTypesQueryVariables>(BaseRateConfiguredResourceTypesDocument, options);
      }
export function useBaseRateConfiguredResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BaseRateConfiguredResourceTypesQuery, BaseRateConfiguredResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BaseRateConfiguredResourceTypesQuery, BaseRateConfiguredResourceTypesQueryVariables>(BaseRateConfiguredResourceTypesDocument, options);
        }
export type BaseRateConfiguredResourceTypesQueryHookResult = ReturnType<typeof useBaseRateConfiguredResourceTypesQuery>;
export type BaseRateConfiguredResourceTypesLazyQueryHookResult = ReturnType<typeof useBaseRateConfiguredResourceTypesLazyQuery>;
export type BaseRateConfiguredResourceTypesQueryResult = Apollo.QueryResult<BaseRateConfiguredResourceTypesQuery, BaseRateConfiguredResourceTypesQueryVariables>;
export const CompaniesDocument = gql`
    query Companies($filter: CustomerQueryFilter!) {
  customers(filter: $filter) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const RatesDocument = gql`
    query Rates($filter: RateQueryFilter!) {
  rates(filter: $filter) {
    ...Rate
  }
}
    ${RateFragmentDoc}`;

/**
 * __useRatesQuery__
 *
 * To run a query within a React component, call `useRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRatesQuery(baseOptions: Apollo.QueryHookOptions<RatesQuery, RatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatesQuery, RatesQueryVariables>(RatesDocument, options);
      }
export function useRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatesQuery, RatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatesQuery, RatesQueryVariables>(RatesDocument, options);
        }
export type RatesQueryHookResult = ReturnType<typeof useRatesQuery>;
export type RatesLazyQueryHookResult = ReturnType<typeof useRatesLazyQuery>;
export type RatesQueryResult = Apollo.QueryResult<RatesQuery, RatesQueryVariables>;
export const CreateRateDocument = gql`
    mutation CreateRate($value: RateInput!) {
  createRate(value: $value) {
    ...Rate
  }
}
    ${RateFragmentDoc}`;
export type CreateRateMutationFn = Apollo.MutationFunction<CreateRateMutation, CreateRateMutationVariables>;

/**
 * __useCreateRateMutation__
 *
 * To run a mutation, you first call `useCreateRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRateMutation, { data, loading, error }] = useCreateRateMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateRateMutation, CreateRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRateMutation, CreateRateMutationVariables>(CreateRateDocument, options);
      }
export type CreateRateMutationHookResult = ReturnType<typeof useCreateRateMutation>;
export type CreateRateMutationResult = Apollo.MutationResult<CreateRateMutation>;
export type CreateRateMutationOptions = Apollo.BaseMutationOptions<CreateRateMutation, CreateRateMutationVariables>;
export const UpdateRateDocument = gql`
    mutation UpdateRate($value: RateInput!, $updateRateId: String!) {
  updateRate(value: $value, id: $updateRateId) {
    ...Rate
  }
}
    ${RateFragmentDoc}`;
export type UpdateRateMutationFn = Apollo.MutationFunction<UpdateRateMutation, UpdateRateMutationVariables>;

/**
 * __useUpdateRateMutation__
 *
 * To run a mutation, you first call `useUpdateRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateMutation, { data, loading, error }] = useUpdateRateMutation({
 *   variables: {
 *      value: // value for 'value'
 *      updateRateId: // value for 'updateRateId'
 *   },
 * });
 */
export function useUpdateRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRateMutation, UpdateRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRateMutation, UpdateRateMutationVariables>(UpdateRateDocument, options);
      }
export type UpdateRateMutationHookResult = ReturnType<typeof useUpdateRateMutation>;
export type UpdateRateMutationResult = Apollo.MutationResult<UpdateRateMutation>;
export type UpdateRateMutationOptions = Apollo.BaseMutationOptions<UpdateRateMutation, UpdateRateMutationVariables>;
export const DeleteRateDocument = gql`
    mutation DeleteRate($tenantId: ID!, $deleteRateId: String!) {
  deleteRate(tenantId: $tenantId, id: $deleteRateId)
}
    `;
export type DeleteRateMutationFn = Apollo.MutationFunction<DeleteRateMutation, DeleteRateMutationVariables>;

/**
 * __useDeleteRateMutation__
 *
 * To run a mutation, you first call `useDeleteRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRateMutation, { data, loading, error }] = useDeleteRateMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteRateId: // value for 'deleteRateId'
 *   },
 * });
 */
export function useDeleteRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRateMutation, DeleteRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRateMutation, DeleteRateMutationVariables>(DeleteRateDocument, options);
      }
export type DeleteRateMutationHookResult = ReturnType<typeof useDeleteRateMutation>;
export type DeleteRateMutationResult = Apollo.MutationResult<DeleteRateMutation>;
export type DeleteRateMutationOptions = Apollo.BaseMutationOptions<DeleteRateMutation, DeleteRateMutationVariables>;
export const StatisticsDocument = gql`
    query Statistics($tenantId: ID!, $propertyId: ID!, $mainStart: Date!, $mainEnd: Date!, $comparisonStart: Date!, $comparisonEnd: Date!, $vatIncluded: Boolean!) {
  main: getStatistics(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $mainStart, end: $mainEnd, vatIncluded: $vatIncluded}
  ) {
    ...Statistic
  }
  comparison: getStatistics(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $comparisonStart, end: $comparisonEnd, vatIncluded: $vatIncluded}
  ) {
    ...Statistic
  }
  pickupMain: getPickupByResourceType(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $mainStart, end: $mainEnd, daysBefore: 90}
  ) {
    ...Pickup
  }
  pickupComparison: getPickupByResourceType(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $comparisonStart, end: $comparisonEnd, daysBefore: 90}
  ) {
    ...Pickup
  }
}
    ${StatisticFragmentDoc}
${PickupFragmentDoc}`;

/**
 * __useStatisticsQuery__
 *
 * To run a query within a React component, call `useStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      mainStart: // value for 'mainStart'
 *      mainEnd: // value for 'mainEnd'
 *      comparisonStart: // value for 'comparisonStart'
 *      comparisonEnd: // value for 'comparisonEnd'
 *      vatIncluded: // value for 'vatIncluded'
 *   },
 * });
 */
export function useStatisticsQuery(baseOptions: Apollo.QueryHookOptions<StatisticsQuery, StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatisticsQuery, StatisticsQueryVariables>(StatisticsDocument, options);
      }
export function useStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatisticsQuery, StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatisticsQuery, StatisticsQueryVariables>(StatisticsDocument, options);
        }
export type StatisticsQueryHookResult = ReturnType<typeof useStatisticsQuery>;
export type StatisticsLazyQueryHookResult = ReturnType<typeof useStatisticsLazyQuery>;
export type StatisticsQueryResult = Apollo.QueryResult<StatisticsQuery, StatisticsQueryVariables>;
export const ContextTenantsDocument = gql`
    query ContextTenants {
  tenants {
    id
    description
    currency
    language
    backoffice
    privacySettings {
      isCustomText
    }
    scelTemplate
    registryItemId
    sellerName
  }
}
    `;

/**
 * __useContextTenantsQuery__
 *
 * To run a query within a React component, call `useContextTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContextTenantsQuery(baseOptions?: Apollo.QueryHookOptions<ContextTenantsQuery, ContextTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextTenantsQuery, ContextTenantsQueryVariables>(ContextTenantsDocument, options);
      }
export function useContextTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextTenantsQuery, ContextTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextTenantsQuery, ContextTenantsQueryVariables>(ContextTenantsDocument, options);
        }
export type ContextTenantsQueryHookResult = ReturnType<typeof useContextTenantsQuery>;
export type ContextTenantsLazyQueryHookResult = ReturnType<typeof useContextTenantsLazyQuery>;
export type ContextTenantsQueryResult = Apollo.QueryResult<ContextTenantsQuery, ContextTenantsQueryVariables>;
export const ContextPropertiesDocument = gql`
    query ContextProperties($tenantId: [ID!]!) {
  properties(filter: {tenantId: {in: $tenantId}}) {
    id
    name
    tenantId
    hotelDate
    timeZone
    countryIsoCode: address {
      country {
        isoCode
      }
    }
    cityTaxConfiguration {
      chargeCategoryId
      configurations {
        name
        amount
        rule
        fileGenerator
      }
    }
    classType {
      description
    }
    istatConfigurations {
      ...ContextIstatConfiguration
    }
    psConfigurations {
      ...ContextPsConfiguration
    }
    fiscalConfigurations {
      ...ContextFiscalConfiguration
    }
    dailyClosureConfiguration {
      ...ContextDailyClosureConfiguration
    }
    subAddresses {
      ...ContextSubAddress
    }
  }
}
    ${ContextIstatConfigurationFragmentDoc}
${ContextPsConfigurationFragmentDoc}
${ContextFiscalConfigurationFragmentDoc}
${ContextDailyClosureConfigurationFragmentDoc}
${ContextSubAddressFragmentDoc}`;

/**
 * __useContextPropertiesQuery__
 *
 * To run a query within a React component, call `useContextPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextPropertiesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useContextPropertiesQuery(baseOptions: Apollo.QueryHookOptions<ContextPropertiesQuery, ContextPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextPropertiesQuery, ContextPropertiesQueryVariables>(ContextPropertiesDocument, options);
      }
export function useContextPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextPropertiesQuery, ContextPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextPropertiesQuery, ContextPropertiesQueryVariables>(ContextPropertiesDocument, options);
        }
export type ContextPropertiesQueryHookResult = ReturnType<typeof useContextPropertiesQuery>;
export type ContextPropertiesLazyQueryHookResult = ReturnType<typeof useContextPropertiesLazyQuery>;
export type ContextPropertiesQueryResult = Apollo.QueryResult<ContextPropertiesQuery, ContextPropertiesQueryVariables>;
export const ContextUserPermissionsDocument = gql`
    query ContextUserPermissions($input: UserPermissionQueryInput!) {
  getUserPermissions(input: $input) {
    userRole {
      ...userRole
    }
    userModules
    modules
    features
    trialModules {
      module
      trialExpiration
    }
    tenantSellerName
  }
}
    ${userRoleFragmentDoc}`;

/**
 * __useContextUserPermissionsQuery__
 *
 * To run a query within a React component, call `useContextUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextUserPermissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContextUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<ContextUserPermissionsQuery, ContextUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextUserPermissionsQuery, ContextUserPermissionsQueryVariables>(ContextUserPermissionsDocument, options);
      }
export function useContextUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextUserPermissionsQuery, ContextUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextUserPermissionsQuery, ContextUserPermissionsQueryVariables>(ContextUserPermissionsDocument, options);
        }
export type ContextUserPermissionsQueryHookResult = ReturnType<typeof useContextUserPermissionsQuery>;
export type ContextUserPermissionsLazyQueryHookResult = ReturnType<typeof useContextUserPermissionsLazyQuery>;
export type ContextUserPermissionsQueryResult = Apollo.QueryResult<ContextUserPermissionsQuery, ContextUserPermissionsQueryVariables>;
export const UnusedPlantsDocument = gql`
    query UnusedPlants($tenantId: ID!) {
  unusedPlants(tenantId: $tenantId) {
    id
    description
  }
}
    `;

/**
 * __useUnusedPlantsQuery__
 *
 * To run a query within a React component, call `useUnusedPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnusedPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnusedPlantsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useUnusedPlantsQuery(baseOptions: Apollo.QueryHookOptions<UnusedPlantsQuery, UnusedPlantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnusedPlantsQuery, UnusedPlantsQueryVariables>(UnusedPlantsDocument, options);
      }
export function useUnusedPlantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnusedPlantsQuery, UnusedPlantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnusedPlantsQuery, UnusedPlantsQueryVariables>(UnusedPlantsDocument, options);
        }
export type UnusedPlantsQueryHookResult = ReturnType<typeof useUnusedPlantsQuery>;
export type UnusedPlantsLazyQueryHookResult = ReturnType<typeof useUnusedPlantsLazyQuery>;
export type UnusedPlantsQueryResult = Apollo.QueryResult<UnusedPlantsQuery, UnusedPlantsQueryVariables>;
export const ContextCashDocumentActivesDocument = gql`
    query ContextCashDocumentActives($filter: TenantPropertyIdFilter!) {
  cashDeskTypes(filter: $filter) {
    id
    documentsActive {
      fiscalType
    }
  }
}
    `;

/**
 * __useContextCashDocumentActivesQuery__
 *
 * To run a query within a React component, call `useContextCashDocumentActivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextCashDocumentActivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextCashDocumentActivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContextCashDocumentActivesQuery(baseOptions: Apollo.QueryHookOptions<ContextCashDocumentActivesQuery, ContextCashDocumentActivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextCashDocumentActivesQuery, ContextCashDocumentActivesQueryVariables>(ContextCashDocumentActivesDocument, options);
      }
export function useContextCashDocumentActivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextCashDocumentActivesQuery, ContextCashDocumentActivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextCashDocumentActivesQuery, ContextCashDocumentActivesQueryVariables>(ContextCashDocumentActivesDocument, options);
        }
export type ContextCashDocumentActivesQueryHookResult = ReturnType<typeof useContextCashDocumentActivesQuery>;
export type ContextCashDocumentActivesLazyQueryHookResult = ReturnType<typeof useContextCashDocumentActivesLazyQuery>;
export type ContextCashDocumentActivesQueryResult = Apollo.QueryResult<ContextCashDocumentActivesQuery, ContextCashDocumentActivesQueryVariables>;
export const HorecahubIntegrationsDocument = gql`
    query HorecahubIntegrations($horecahubIntegrationsTenantId2: ID) {
  horecahubIntegrations(tenantId: $horecahubIntegrationsTenantId2) {
    id
  }
}
    `;

/**
 * __useHorecahubIntegrationsQuery__
 *
 * To run a query within a React component, call `useHorecahubIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorecahubIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorecahubIntegrationsQuery({
 *   variables: {
 *      horecahubIntegrationsTenantId2: // value for 'horecahubIntegrationsTenantId2'
 *   },
 * });
 */
export function useHorecahubIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<HorecahubIntegrationsQuery, HorecahubIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorecahubIntegrationsQuery, HorecahubIntegrationsQueryVariables>(HorecahubIntegrationsDocument, options);
      }
export function useHorecahubIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorecahubIntegrationsQuery, HorecahubIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorecahubIntegrationsQuery, HorecahubIntegrationsQueryVariables>(HorecahubIntegrationsDocument, options);
        }
export type HorecahubIntegrationsQueryHookResult = ReturnType<typeof useHorecahubIntegrationsQuery>;
export type HorecahubIntegrationsLazyQueryHookResult = ReturnType<typeof useHorecahubIntegrationsLazyQuery>;
export type HorecahubIntegrationsQueryResult = Apollo.QueryResult<HorecahubIntegrationsQuery, HorecahubIntegrationsQueryVariables>;
export const HorecahubFlowsDocument = gql`
    query HorecahubFlows($tenantId: ID!, $productCode: String!) {
  horecahubFlows(tenantId: $tenantId, productCode: $productCode) {
    state
  }
}
    `;

/**
 * __useHorecahubFlowsQuery__
 *
 * To run a query within a React component, call `useHorecahubFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHorecahubFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHorecahubFlowsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useHorecahubFlowsQuery(baseOptions: Apollo.QueryHookOptions<HorecahubFlowsQuery, HorecahubFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HorecahubFlowsQuery, HorecahubFlowsQueryVariables>(HorecahubFlowsDocument, options);
      }
export function useHorecahubFlowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HorecahubFlowsQuery, HorecahubFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HorecahubFlowsQuery, HorecahubFlowsQueryVariables>(HorecahubFlowsDocument, options);
        }
export type HorecahubFlowsQueryHookResult = ReturnType<typeof useHorecahubFlowsQuery>;
export type HorecahubFlowsLazyQueryHookResult = ReturnType<typeof useHorecahubFlowsLazyQuery>;
export type HorecahubFlowsQueryResult = Apollo.QueryResult<HorecahubFlowsQuery, HorecahubFlowsQueryVariables>;
export const HorecahubRegisterIntegrationDocument = gql`
    mutation HorecahubRegisterIntegration($tenantId: ID!) {
  horecahubRegisterIntegration(tenantId: $tenantId) {
    id
  }
}
    `;
export type HorecahubRegisterIntegrationMutationFn = Apollo.MutationFunction<HorecahubRegisterIntegrationMutation, HorecahubRegisterIntegrationMutationVariables>;

/**
 * __useHorecahubRegisterIntegrationMutation__
 *
 * To run a mutation, you first call `useHorecahubRegisterIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHorecahubRegisterIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [horecahubRegisterIntegrationMutation, { data, loading, error }] = useHorecahubRegisterIntegrationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useHorecahubRegisterIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<HorecahubRegisterIntegrationMutation, HorecahubRegisterIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HorecahubRegisterIntegrationMutation, HorecahubRegisterIntegrationMutationVariables>(HorecahubRegisterIntegrationDocument, options);
      }
export type HorecahubRegisterIntegrationMutationHookResult = ReturnType<typeof useHorecahubRegisterIntegrationMutation>;
export type HorecahubRegisterIntegrationMutationResult = Apollo.MutationResult<HorecahubRegisterIntegrationMutation>;
export type HorecahubRegisterIntegrationMutationOptions = Apollo.BaseMutationOptions<HorecahubRegisterIntegrationMutation, HorecahubRegisterIntegrationMutationVariables>;
export const HousekeepingResourcesDocument = gql`
    query HousekeepingResources($tenantId: ID!, $propertyId: ID!, $cleaningState: CleaningState, $resourceIdFilter: IDFilter) {
  resourcesHousekeeping(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, cleaningState: $cleaningState, id: $resourceIdFilter}
  ) {
    ...HousekeepingResource
  }
}
    ${HousekeepingResourceFragmentDoc}`;

/**
 * __useHousekeepingResourcesQuery__
 *
 * To run a query within a React component, call `useHousekeepingResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHousekeepingResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHousekeepingResourcesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      cleaningState: // value for 'cleaningState'
 *      resourceIdFilter: // value for 'resourceIdFilter'
 *   },
 * });
 */
export function useHousekeepingResourcesQuery(baseOptions: Apollo.QueryHookOptions<HousekeepingResourcesQuery, HousekeepingResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HousekeepingResourcesQuery, HousekeepingResourcesQueryVariables>(HousekeepingResourcesDocument, options);
      }
export function useHousekeepingResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HousekeepingResourcesQuery, HousekeepingResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HousekeepingResourcesQuery, HousekeepingResourcesQueryVariables>(HousekeepingResourcesDocument, options);
        }
export type HousekeepingResourcesQueryHookResult = ReturnType<typeof useHousekeepingResourcesQuery>;
export type HousekeepingResourcesLazyQueryHookResult = ReturnType<typeof useHousekeepingResourcesLazyQuery>;
export type HousekeepingResourcesQueryResult = Apollo.QueryResult<HousekeepingResourcesQuery, HousekeepingResourcesQueryVariables>;
export const SetResourceCleaningStateDocument = gql`
    mutation SetResourceCleaningState($input: ResourceCleaningStateInput!) {
  setResourceCleaningState(input: $input)
}
    `;
export type SetResourceCleaningStateMutationFn = Apollo.MutationFunction<SetResourceCleaningStateMutation, SetResourceCleaningStateMutationVariables>;

/**
 * __useSetResourceCleaningStateMutation__
 *
 * To run a mutation, you first call `useSetResourceCleaningStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResourceCleaningStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResourceCleaningStateMutation, { data, loading, error }] = useSetResourceCleaningStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetResourceCleaningStateMutation(baseOptions?: Apollo.MutationHookOptions<SetResourceCleaningStateMutation, SetResourceCleaningStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResourceCleaningStateMutation, SetResourceCleaningStateMutationVariables>(SetResourceCleaningStateDocument, options);
      }
export type SetResourceCleaningStateMutationHookResult = ReturnType<typeof useSetResourceCleaningStateMutation>;
export type SetResourceCleaningStateMutationResult = Apollo.MutationResult<SetResourceCleaningStateMutation>;
export type SetResourceCleaningStateMutationOptions = Apollo.BaseMutationOptions<SetResourceCleaningStateMutation, SetResourceCleaningStateMutationVariables>;
export const ChargeCategoriesImportReservationsDocument = gql`
    query ChargeCategoriesImportReservations($filter: ChargeCategoryQueryFilter!) {
  chargeCategories(filter: $filter) {
    ...ChargeCategoryImportReservations
  }
}
    ${ChargeCategoryImportReservationsFragmentDoc}`;

/**
 * __useChargeCategoriesImportReservationsQuery__
 *
 * To run a query within a React component, call `useChargeCategoriesImportReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeCategoriesImportReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeCategoriesImportReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChargeCategoriesImportReservationsQuery(baseOptions: Apollo.QueryHookOptions<ChargeCategoriesImportReservationsQuery, ChargeCategoriesImportReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeCategoriesImportReservationsQuery, ChargeCategoriesImportReservationsQueryVariables>(ChargeCategoriesImportReservationsDocument, options);
      }
export function useChargeCategoriesImportReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeCategoriesImportReservationsQuery, ChargeCategoriesImportReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeCategoriesImportReservationsQuery, ChargeCategoriesImportReservationsQueryVariables>(ChargeCategoriesImportReservationsDocument, options);
        }
export type ChargeCategoriesImportReservationsQueryHookResult = ReturnType<typeof useChargeCategoriesImportReservationsQuery>;
export type ChargeCategoriesImportReservationsLazyQueryHookResult = ReturnType<typeof useChargeCategoriesImportReservationsLazyQuery>;
export type ChargeCategoriesImportReservationsQueryResult = Apollo.QueryResult<ChargeCategoriesImportReservationsQuery, ChargeCategoriesImportReservationsQueryVariables>;
export const ResourceTypeImportReservationsDocument = gql`
    query ResourceTypeImportReservations($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    ...ResourceTypeImportReservations
  }
}
    ${ResourceTypeImportReservationsFragmentDoc}`;

/**
 * __useResourceTypeImportReservationsQuery__
 *
 * To run a query within a React component, call `useResourceTypeImportReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypeImportReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypeImportReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypeImportReservationsQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypeImportReservationsQuery, ResourceTypeImportReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypeImportReservationsQuery, ResourceTypeImportReservationsQueryVariables>(ResourceTypeImportReservationsDocument, options);
      }
export function useResourceTypeImportReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypeImportReservationsQuery, ResourceTypeImportReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypeImportReservationsQuery, ResourceTypeImportReservationsQueryVariables>(ResourceTypeImportReservationsDocument, options);
        }
export type ResourceTypeImportReservationsQueryHookResult = ReturnType<typeof useResourceTypeImportReservationsQuery>;
export type ResourceTypeImportReservationsLazyQueryHookResult = ReturnType<typeof useResourceTypeImportReservationsLazyQuery>;
export type ResourceTypeImportReservationsQueryResult = Apollo.QueryResult<ResourceTypeImportReservationsQuery, ResourceTypeImportReservationsQueryVariables>;
export const ResourceImportReservationsDocument = gql`
    query ResourceImportReservations($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    ...ResourceImportReservations
  }
}
    ${ResourceImportReservationsFragmentDoc}`;

/**
 * __useResourceImportReservationsQuery__
 *
 * To run a query within a React component, call `useResourceImportReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceImportReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceImportReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceImportReservationsQuery(baseOptions: Apollo.QueryHookOptions<ResourceImportReservationsQuery, ResourceImportReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceImportReservationsQuery, ResourceImportReservationsQueryVariables>(ResourceImportReservationsDocument, options);
      }
export function useResourceImportReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceImportReservationsQuery, ResourceImportReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceImportReservationsQuery, ResourceImportReservationsQueryVariables>(ResourceImportReservationsDocument, options);
        }
export type ResourceImportReservationsQueryHookResult = ReturnType<typeof useResourceImportReservationsQuery>;
export type ResourceImportReservationsLazyQueryHookResult = ReturnType<typeof useResourceImportReservationsLazyQuery>;
export type ResourceImportReservationsQueryResult = Apollo.QueryResult<ResourceImportReservationsQuery, ResourceImportReservationsQueryVariables>;
export const InsertBulkReservationsDocument = gql`
    mutation InsertBulkReservations($tenantId: ID!, $propertyId: ID!, $rows: [BulkReservationInput!]!) {
  insertBulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    rows: $rows
  )
}
    `;
export type InsertBulkReservationsMutationFn = Apollo.MutationFunction<InsertBulkReservationsMutation, InsertBulkReservationsMutationVariables>;

/**
 * __useInsertBulkReservationsMutation__
 *
 * To run a mutation, you first call `useInsertBulkReservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBulkReservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBulkReservationsMutation, { data, loading, error }] = useInsertBulkReservationsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useInsertBulkReservationsMutation(baseOptions?: Apollo.MutationHookOptions<InsertBulkReservationsMutation, InsertBulkReservationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBulkReservationsMutation, InsertBulkReservationsMutationVariables>(InsertBulkReservationsDocument, options);
      }
export type InsertBulkReservationsMutationHookResult = ReturnType<typeof useInsertBulkReservationsMutation>;
export type InsertBulkReservationsMutationResult = Apollo.MutationResult<InsertBulkReservationsMutation>;
export type InsertBulkReservationsMutationOptions = Apollo.BaseMutationOptions<InsertBulkReservationsMutation, InsertBulkReservationsMutationVariables>;
export const BulkReservationsDocument = gql`
    query BulkReservations($tenantId: ID!, $propertyId: ID!, $correlationId: String!, $processed: Boolean, $error: Boolean) {
  bulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    correlationId: $correlationId
    processed: $processed
    error: $error
  ) {
    error
  }
}
    `;

/**
 * __useBulkReservationsQuery__
 *
 * To run a query within a React component, call `useBulkReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkReservationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      correlationId: // value for 'correlationId'
 *      processed: // value for 'processed'
 *      error: // value for 'error'
 *   },
 * });
 */
export function useBulkReservationsQuery(baseOptions: Apollo.QueryHookOptions<BulkReservationsQuery, BulkReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkReservationsQuery, BulkReservationsQueryVariables>(BulkReservationsDocument, options);
      }
export function useBulkReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkReservationsQuery, BulkReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkReservationsQuery, BulkReservationsQueryVariables>(BulkReservationsDocument, options);
        }
export type BulkReservationsQueryHookResult = ReturnType<typeof useBulkReservationsQuery>;
export type BulkReservationsLazyQueryHookResult = ReturnType<typeof useBulkReservationsLazyQuery>;
export type BulkReservationsQueryResult = Apollo.QueryResult<BulkReservationsQuery, BulkReservationsQueryVariables>;
export const TimestampBulkReservationDocument = gql`
    query TimestampBulkReservation($tenantId: ID!, $propertyId: ID!, $correlationId: String!, $error: Boolean) {
  bulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    correlationId: $correlationId
    error: $error
  ) {
    timestamp
  }
}
    `;

/**
 * __useTimestampBulkReservationQuery__
 *
 * To run a query within a React component, call `useTimestampBulkReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimestampBulkReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimestampBulkReservationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      correlationId: // value for 'correlationId'
 *      error: // value for 'error'
 *   },
 * });
 */
export function useTimestampBulkReservationQuery(baseOptions: Apollo.QueryHookOptions<TimestampBulkReservationQuery, TimestampBulkReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimestampBulkReservationQuery, TimestampBulkReservationQueryVariables>(TimestampBulkReservationDocument, options);
      }
export function useTimestampBulkReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimestampBulkReservationQuery, TimestampBulkReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimestampBulkReservationQuery, TimestampBulkReservationQueryVariables>(TimestampBulkReservationDocument, options);
        }
export type TimestampBulkReservationQueryHookResult = ReturnType<typeof useTimestampBulkReservationQuery>;
export type TimestampBulkReservationLazyQueryHookResult = ReturnType<typeof useTimestampBulkReservationLazyQuery>;
export type TimestampBulkReservationQueryResult = Apollo.QueryResult<TimestampBulkReservationQuery, TimestampBulkReservationQueryVariables>;
export const GridBulkReservationsDocument = gql`
    query GridBulkReservations($tenantId: ID!, $propertyId: ID!, $correlationId: String!, $error: Boolean) {
  bulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    correlationId: $correlationId
    error: $error
  ) {
    ...GridBulkReservation
  }
}
    ${GridBulkReservationFragmentDoc}`;

/**
 * __useGridBulkReservationsQuery__
 *
 * To run a query within a React component, call `useGridBulkReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridBulkReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridBulkReservationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      correlationId: // value for 'correlationId'
 *      error: // value for 'error'
 *   },
 * });
 */
export function useGridBulkReservationsQuery(baseOptions: Apollo.QueryHookOptions<GridBulkReservationsQuery, GridBulkReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GridBulkReservationsQuery, GridBulkReservationsQueryVariables>(GridBulkReservationsDocument, options);
      }
export function useGridBulkReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GridBulkReservationsQuery, GridBulkReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GridBulkReservationsQuery, GridBulkReservationsQueryVariables>(GridBulkReservationsDocument, options);
        }
export type GridBulkReservationsQueryHookResult = ReturnType<typeof useGridBulkReservationsQuery>;
export type GridBulkReservationsLazyQueryHookResult = ReturnType<typeof useGridBulkReservationsLazyQuery>;
export type GridBulkReservationsQueryResult = Apollo.QueryResult<GridBulkReservationsQuery, GridBulkReservationsQueryVariables>;
export const PreviousImportBulkReservationsDocument = gql`
    query PreviousImportBulkReservations($tenantId: ID!, $propertyId: ID!, $correlationId: String!) {
  bulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    correlationId: $correlationId
  ) {
    ...PreviousImportBulkReservation
  }
}
    ${PreviousImportBulkReservationFragmentDoc}`;

/**
 * __usePreviousImportBulkReservationsQuery__
 *
 * To run a query within a React component, call `usePreviousImportBulkReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousImportBulkReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousImportBulkReservationsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function usePreviousImportBulkReservationsQuery(baseOptions: Apollo.QueryHookOptions<PreviousImportBulkReservationsQuery, PreviousImportBulkReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviousImportBulkReservationsQuery, PreviousImportBulkReservationsQueryVariables>(PreviousImportBulkReservationsDocument, options);
      }
export function usePreviousImportBulkReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviousImportBulkReservationsQuery, PreviousImportBulkReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviousImportBulkReservationsQuery, PreviousImportBulkReservationsQueryVariables>(PreviousImportBulkReservationsDocument, options);
        }
export type PreviousImportBulkReservationsQueryHookResult = ReturnType<typeof usePreviousImportBulkReservationsQuery>;
export type PreviousImportBulkReservationsLazyQueryHookResult = ReturnType<typeof usePreviousImportBulkReservationsLazyQuery>;
export type PreviousImportBulkReservationsQueryResult = Apollo.QueryResult<PreviousImportBulkReservationsQuery, PreviousImportBulkReservationsQueryVariables>;
export const DeleteBulkReservationsDocument = gql`
    mutation DeleteBulkReservations($tenantId: ID!, $propertyId: ID!, $correlationId: String!) {
  deleteBulkReservations(
    tenantId: $tenantId
    propertyId: $propertyId
    correlationId: $correlationId
  )
}
    `;
export type DeleteBulkReservationsMutationFn = Apollo.MutationFunction<DeleteBulkReservationsMutation, DeleteBulkReservationsMutationVariables>;

/**
 * __useDeleteBulkReservationsMutation__
 *
 * To run a mutation, you first call `useDeleteBulkReservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulkReservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulkReservationsMutation, { data, loading, error }] = useDeleteBulkReservationsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useDeleteBulkReservationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBulkReservationsMutation, DeleteBulkReservationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBulkReservationsMutation, DeleteBulkReservationsMutationVariables>(DeleteBulkReservationsDocument, options);
      }
export type DeleteBulkReservationsMutationHookResult = ReturnType<typeof useDeleteBulkReservationsMutation>;
export type DeleteBulkReservationsMutationResult = Apollo.MutationResult<DeleteBulkReservationsMutation>;
export type DeleteBulkReservationsMutationOptions = Apollo.BaseMutationOptions<DeleteBulkReservationsMutation, DeleteBulkReservationsMutationVariables>;
export const ImportedTasksDocument = gql`
    query ImportedTasks($filters: ImportedTaskQueryFilter!) {
  importedTasks(filters: $filters) {
    ...ImportedTaskList
  }
}
    ${ImportedTaskListFragmentDoc}`;

/**
 * __useImportedTasksQuery__
 *
 * To run a query within a React component, call `useImportedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportedTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useImportedTasksQuery(baseOptions: Apollo.QueryHookOptions<ImportedTasksQuery, ImportedTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportedTasksQuery, ImportedTasksQueryVariables>(ImportedTasksDocument, options);
      }
export function useImportedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportedTasksQuery, ImportedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportedTasksQuery, ImportedTasksQueryVariables>(ImportedTasksDocument, options);
        }
export type ImportedTasksQueryHookResult = ReturnType<typeof useImportedTasksQuery>;
export type ImportedTasksLazyQueryHookResult = ReturnType<typeof useImportedTasksLazyQuery>;
export type ImportedTasksQueryResult = Apollo.QueryResult<ImportedTasksQuery, ImportedTasksQueryVariables>;
export const ImportablePropertiesDocument = gql`
    query ImportableProperties($tenantId: ID!) {
  importableProperties(tenantId: $tenantId) {
    ...ImportableProperty
  }
}
    ${ImportablePropertyFragmentDoc}`;

/**
 * __useImportablePropertiesQuery__
 *
 * To run a query within a React component, call `useImportablePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportablePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportablePropertiesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useImportablePropertiesQuery(baseOptions: Apollo.QueryHookOptions<ImportablePropertiesQuery, ImportablePropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportablePropertiesQuery, ImportablePropertiesQueryVariables>(ImportablePropertiesDocument, options);
      }
export function useImportablePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportablePropertiesQuery, ImportablePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportablePropertiesQuery, ImportablePropertiesQueryVariables>(ImportablePropertiesDocument, options);
        }
export type ImportablePropertiesQueryHookResult = ReturnType<typeof useImportablePropertiesQuery>;
export type ImportablePropertiesLazyQueryHookResult = ReturnType<typeof useImportablePropertiesLazyQuery>;
export type ImportablePropertiesQueryResult = Apollo.QueryResult<ImportablePropertiesQuery, ImportablePropertiesQueryVariables>;
export const ExportDatabaseDocument = gql`
    mutation ExportDatabase($input: ExportDatabaseInput!) {
  exportDatabase(input: $input) {
    taskId
  }
}
    `;
export type ExportDatabaseMutationFn = Apollo.MutationFunction<ExportDatabaseMutation, ExportDatabaseMutationVariables>;

/**
 * __useExportDatabaseMutation__
 *
 * To run a mutation, you first call `useExportDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDatabaseMutation, { data, loading, error }] = useExportDatabaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<ExportDatabaseMutation, ExportDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportDatabaseMutation, ExportDatabaseMutationVariables>(ExportDatabaseDocument, options);
      }
export type ExportDatabaseMutationHookResult = ReturnType<typeof useExportDatabaseMutation>;
export type ExportDatabaseMutationResult = Apollo.MutationResult<ExportDatabaseMutation>;
export type ExportDatabaseMutationOptions = Apollo.BaseMutationOptions<ExportDatabaseMutation, ExportDatabaseMutationVariables>;
export const ImportPropertyDocument = gql`
    mutation ImportProperty($value: ImportPropertyInput!) {
  importProperty(value: $value) {
    taskId
    propertyId
  }
}
    `;
export type ImportPropertyMutationFn = Apollo.MutationFunction<ImportPropertyMutation, ImportPropertyMutationVariables>;

/**
 * __useImportPropertyMutation__
 *
 * To run a mutation, you first call `useImportPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPropertyMutation, { data, loading, error }] = useImportPropertyMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useImportPropertyMutation(baseOptions?: Apollo.MutationHookOptions<ImportPropertyMutation, ImportPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPropertyMutation, ImportPropertyMutationVariables>(ImportPropertyDocument, options);
      }
export type ImportPropertyMutationHookResult = ReturnType<typeof useImportPropertyMutation>;
export type ImportPropertyMutationResult = Apollo.MutationResult<ImportPropertyMutation>;
export type ImportPropertyMutationOptions = Apollo.BaseMutationOptions<ImportPropertyMutation, ImportPropertyMutationVariables>;
export const ImportPropertyRetryDocument = gql`
    mutation ImportPropertyRetry($input: RetryImportPropertyInput!) {
  importPropertyRetry(input: $input) {
    propertyId
    taskId
  }
}
    `;
export type ImportPropertyRetryMutationFn = Apollo.MutationFunction<ImportPropertyRetryMutation, ImportPropertyRetryMutationVariables>;

/**
 * __useImportPropertyRetryMutation__
 *
 * To run a mutation, you first call `useImportPropertyRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPropertyRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPropertyRetryMutation, { data, loading, error }] = useImportPropertyRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPropertyRetryMutation(baseOptions?: Apollo.MutationHookOptions<ImportPropertyRetryMutation, ImportPropertyRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPropertyRetryMutation, ImportPropertyRetryMutationVariables>(ImportPropertyRetryDocument, options);
      }
export type ImportPropertyRetryMutationHookResult = ReturnType<typeof useImportPropertyRetryMutation>;
export type ImportPropertyRetryMutationResult = Apollo.MutationResult<ImportPropertyRetryMutation>;
export type ImportPropertyRetryMutationOptions = Apollo.BaseMutationOptions<ImportPropertyRetryMutation, ImportPropertyRetryMutationVariables>;
export const AttachDatabaseForExportDocument = gql`
    mutation AttachDatabaseForExport($backupName: String!, $dbName: String!) {
  attachDatabaseForExport(backupName: $backupName, dbName: $dbName)
}
    `;
export type AttachDatabaseForExportMutationFn = Apollo.MutationFunction<AttachDatabaseForExportMutation, AttachDatabaseForExportMutationVariables>;

/**
 * __useAttachDatabaseForExportMutation__
 *
 * To run a mutation, you first call `useAttachDatabaseForExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachDatabaseForExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachDatabaseForExportMutation, { data, loading, error }] = useAttachDatabaseForExportMutation({
 *   variables: {
 *      backupName: // value for 'backupName'
 *      dbName: // value for 'dbName'
 *   },
 * });
 */
export function useAttachDatabaseForExportMutation(baseOptions?: Apollo.MutationHookOptions<AttachDatabaseForExportMutation, AttachDatabaseForExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachDatabaseForExportMutation, AttachDatabaseForExportMutationVariables>(AttachDatabaseForExportDocument, options);
      }
export type AttachDatabaseForExportMutationHookResult = ReturnType<typeof useAttachDatabaseForExportMutation>;
export type AttachDatabaseForExportMutationResult = Apollo.MutationResult<AttachDatabaseForExportMutation>;
export type AttachDatabaseForExportMutationOptions = Apollo.BaseMutationOptions<AttachDatabaseForExportMutation, AttachDatabaseForExportMutationVariables>;
export const GetDatabaseAttachStateDocument = gql`
    query GetDatabaseAttachState($dbName: String!, $taskId: Int!) {
  getDatabaseAttachState(dbName: $dbName, taskId: $taskId) {
    state
    percentage
    info
  }
}
    `;

/**
 * __useGetDatabaseAttachStateQuery__
 *
 * To run a query within a React component, call `useGetDatabaseAttachStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatabaseAttachStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatabaseAttachStateQuery({
 *   variables: {
 *      dbName: // value for 'dbName'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetDatabaseAttachStateQuery(baseOptions: Apollo.QueryHookOptions<GetDatabaseAttachStateQuery, GetDatabaseAttachStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatabaseAttachStateQuery, GetDatabaseAttachStateQueryVariables>(GetDatabaseAttachStateDocument, options);
      }
export function useGetDatabaseAttachStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatabaseAttachStateQuery, GetDatabaseAttachStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatabaseAttachStateQuery, GetDatabaseAttachStateQueryVariables>(GetDatabaseAttachStateDocument, options);
        }
export type GetDatabaseAttachStateQueryHookResult = ReturnType<typeof useGetDatabaseAttachStateQuery>;
export type GetDatabaseAttachStateLazyQueryHookResult = ReturnType<typeof useGetDatabaseAttachStateLazyQuery>;
export type GetDatabaseAttachStateQueryResult = Apollo.QueryResult<GetDatabaseAttachStateQuery, GetDatabaseAttachStateQueryVariables>;
export const ExportableDatabasesDocument = gql`
    query ExportableDatabases {
  exportableDatabases {
    name
    ready
  }
}
    `;

/**
 * __useExportableDatabasesQuery__
 *
 * To run a query within a React component, call `useExportableDatabasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportableDatabasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportableDatabasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportableDatabasesQuery(baseOptions?: Apollo.QueryHookOptions<ExportableDatabasesQuery, ExportableDatabasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportableDatabasesQuery, ExportableDatabasesQueryVariables>(ExportableDatabasesDocument, options);
      }
export function useExportableDatabasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportableDatabasesQuery, ExportableDatabasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportableDatabasesQuery, ExportableDatabasesQueryVariables>(ExportableDatabasesDocument, options);
        }
export type ExportableDatabasesQueryHookResult = ReturnType<typeof useExportableDatabasesQuery>;
export type ExportableDatabasesLazyQueryHookResult = ReturnType<typeof useExportableDatabasesLazyQuery>;
export type ExportableDatabasesQueryResult = Apollo.QueryResult<ExportableDatabasesQuery, ExportableDatabasesQueryVariables>;
export const CreateExportScriptsDocument = gql`
    mutation CreateExportScripts($backupName: String!, $type: PmsType!) {
  createExportScripts(backupName: $backupName, type: $type)
}
    `;
export type CreateExportScriptsMutationFn = Apollo.MutationFunction<CreateExportScriptsMutation, CreateExportScriptsMutationVariables>;

/**
 * __useCreateExportScriptsMutation__
 *
 * To run a mutation, you first call `useCreateExportScriptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportScriptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportScriptsMutation, { data, loading, error }] = useCreateExportScriptsMutation({
 *   variables: {
 *      backupName: // value for 'backupName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateExportScriptsMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportScriptsMutation, CreateExportScriptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportScriptsMutation, CreateExportScriptsMutationVariables>(CreateExportScriptsDocument, options);
      }
export type CreateExportScriptsMutationHookResult = ReturnType<typeof useCreateExportScriptsMutation>;
export type CreateExportScriptsMutationResult = Apollo.MutationResult<CreateExportScriptsMutation>;
export type CreateExportScriptsMutationOptions = Apollo.BaseMutationOptions<CreateExportScriptsMutation, CreateExportScriptsMutationVariables>;
export const UpdateSupportUserRoleDocument = gql`
    mutation UpdateSupportUserRole($itemId: String!) {
  updateSupportUserRole(itemId: $itemId)
}
    `;
export type UpdateSupportUserRoleMutationFn = Apollo.MutationFunction<UpdateSupportUserRoleMutation, UpdateSupportUserRoleMutationVariables>;

/**
 * __useUpdateSupportUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateSupportUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupportUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupportUserRoleMutation, { data, loading, error }] = useUpdateSupportUserRoleMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useUpdateSupportUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupportUserRoleMutation, UpdateSupportUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupportUserRoleMutation, UpdateSupportUserRoleMutationVariables>(UpdateSupportUserRoleDocument, options);
      }
export type UpdateSupportUserRoleMutationHookResult = ReturnType<typeof useUpdateSupportUserRoleMutation>;
export type UpdateSupportUserRoleMutationResult = Apollo.MutationResult<UpdateSupportUserRoleMutation>;
export type UpdateSupportUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateSupportUserRoleMutation, UpdateSupportUserRoleMutationVariables>;
export const UpdateSellerNameDocument = gql`
    mutation UpdateSellerName($tenantId: ID!, $value: String) {
  updateSellerName(tenantId: $tenantId, value: $value)
}
    `;
export type UpdateSellerNameMutationFn = Apollo.MutationFunction<UpdateSellerNameMutation, UpdateSellerNameMutationVariables>;

/**
 * __useUpdateSellerNameMutation__
 *
 * To run a mutation, you first call `useUpdateSellerNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellerNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellerNameMutation, { data, loading, error }] = useUpdateSellerNameMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateSellerNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellerNameMutation, UpdateSellerNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellerNameMutation, UpdateSellerNameMutationVariables>(UpdateSellerNameDocument, options);
      }
export type UpdateSellerNameMutationHookResult = ReturnType<typeof useUpdateSellerNameMutation>;
export type UpdateSellerNameMutationResult = Apollo.MutationResult<UpdateSellerNameMutation>;
export type UpdateSellerNameMutationOptions = Apollo.BaseMutationOptions<UpdateSellerNameMutation, UpdateSellerNameMutationVariables>;
export const RebuildPropertyAvailabilityDocument = gql`
    mutation RebuildPropertyAvailability($tenantId: ID!, $propertyId: ID!, $fireAndForget: Boolean!) {
  rebuildPropertyAvailability(
    tenantId: $tenantId
    propertyId: $propertyId
    fireAndForget: $fireAndForget
  )
}
    `;
export type RebuildPropertyAvailabilityMutationFn = Apollo.MutationFunction<RebuildPropertyAvailabilityMutation, RebuildPropertyAvailabilityMutationVariables>;

/**
 * __useRebuildPropertyAvailabilityMutation__
 *
 * To run a mutation, you first call `useRebuildPropertyAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRebuildPropertyAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rebuildPropertyAvailabilityMutation, { data, loading, error }] = useRebuildPropertyAvailabilityMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      fireAndForget: // value for 'fireAndForget'
 *   },
 * });
 */
export function useRebuildPropertyAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<RebuildPropertyAvailabilityMutation, RebuildPropertyAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RebuildPropertyAvailabilityMutation, RebuildPropertyAvailabilityMutationVariables>(RebuildPropertyAvailabilityDocument, options);
      }
export type RebuildPropertyAvailabilityMutationHookResult = ReturnType<typeof useRebuildPropertyAvailabilityMutation>;
export type RebuildPropertyAvailabilityMutationResult = Apollo.MutationResult<RebuildPropertyAvailabilityMutation>;
export type RebuildPropertyAvailabilityMutationOptions = Apollo.BaseMutationOptions<RebuildPropertyAvailabilityMutation, RebuildPropertyAvailabilityMutationVariables>;
export const RebuildPropertyAvailabilityEventDocument = gql`
    subscription RebuildPropertyAvailabilityEvent($filter: RebuildPropertyAvailabilityEventFilter!) {
  rebuildPropertyAvailabilityEvent(filter: $filter) {
    tenantId
    propertyId
    errors {
      error
      resourceTypeId
    }
  }
}
    `;

/**
 * __useRebuildPropertyAvailabilityEventSubscription__
 *
 * To run a query within a React component, call `useRebuildPropertyAvailabilityEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRebuildPropertyAvailabilityEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRebuildPropertyAvailabilityEventSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRebuildPropertyAvailabilityEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<RebuildPropertyAvailabilityEventSubscription, RebuildPropertyAvailabilityEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RebuildPropertyAvailabilityEventSubscription, RebuildPropertyAvailabilityEventSubscriptionVariables>(RebuildPropertyAvailabilityEventDocument, options);
      }
export type RebuildPropertyAvailabilityEventSubscriptionHookResult = ReturnType<typeof useRebuildPropertyAvailabilityEventSubscription>;
export type RebuildPropertyAvailabilityEventSubscriptionResult = Apollo.SubscriptionResult<RebuildPropertyAvailabilityEventSubscription>;
export const OnboardingPropertyDocument = gql`
    mutation OnboardingProperty($value: OnBoardingInput!) {
  onboardingProperty(value: $value) {
    id
  }
}
    `;
export type OnboardingPropertyMutationFn = Apollo.MutationFunction<OnboardingPropertyMutation, OnboardingPropertyMutationVariables>;

/**
 * __useOnboardingPropertyMutation__
 *
 * To run a mutation, you first call `useOnboardingPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingPropertyMutation, { data, loading, error }] = useOnboardingPropertyMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useOnboardingPropertyMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingPropertyMutation, OnboardingPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingPropertyMutation, OnboardingPropertyMutationVariables>(OnboardingPropertyDocument, options);
      }
export type OnboardingPropertyMutationHookResult = ReturnType<typeof useOnboardingPropertyMutation>;
export type OnboardingPropertyMutationResult = Apollo.MutationResult<OnboardingPropertyMutation>;
export type OnboardingPropertyMutationOptions = Apollo.BaseMutationOptions<OnboardingPropertyMutation, OnboardingPropertyMutationVariables>;
export const PasserByBillsDocument = gql`
    query PasserByBills($tenantId: ID!, $propertyId: ID!, $open: Boolean, $search: String, $skip: Int, $limit: Int) {
  passersByBills(
    tenantId: $tenantId
    propertyId: $propertyId
    open: $open
    search: $search
    skip: $skip
    limit: $limit
  ) {
    ...PasserByBillItem
  }
}
    ${PasserByBillItemFragmentDoc}`;

/**
 * __usePasserByBillsQuery__
 *
 * To run a query within a React component, call `usePasserByBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasserByBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasserByBillsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      open: // value for 'open'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePasserByBillsQuery(baseOptions: Apollo.QueryHookOptions<PasserByBillsQuery, PasserByBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PasserByBillsQuery, PasserByBillsQueryVariables>(PasserByBillsDocument, options);
      }
export function usePasserByBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PasserByBillsQuery, PasserByBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PasserByBillsQuery, PasserByBillsQueryVariables>(PasserByBillsDocument, options);
        }
export type PasserByBillsQueryHookResult = ReturnType<typeof usePasserByBillsQuery>;
export type PasserByBillsLazyQueryHookResult = ReturnType<typeof usePasserByBillsLazyQuery>;
export type PasserByBillsQueryResult = Apollo.QueryResult<PasserByBillsQuery, PasserByBillsQueryVariables>;
export const PosDepositDocumentsDocument = gql`
    query PosDepositDocuments($filter: DepositDocumentQueryFilter!) {
  depositDocuments(filter: $filter) {
    ...PosDepositDocument
  }
}
    ${PosDepositDocumentFragmentDoc}`;

/**
 * __usePosDepositDocumentsQuery__
 *
 * To run a query within a React component, call `usePosDepositDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosDepositDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosDepositDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePosDepositDocumentsQuery(baseOptions: Apollo.QueryHookOptions<PosDepositDocumentsQuery, PosDepositDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosDepositDocumentsQuery, PosDepositDocumentsQueryVariables>(PosDepositDocumentsDocument, options);
      }
export function usePosDepositDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosDepositDocumentsQuery, PosDepositDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosDepositDocumentsQuery, PosDepositDocumentsQueryVariables>(PosDepositDocumentsDocument, options);
        }
export type PosDepositDocumentsQueryHookResult = ReturnType<typeof usePosDepositDocumentsQuery>;
export type PosDepositDocumentsLazyQueryHookResult = ReturnType<typeof usePosDepositDocumentsLazyQuery>;
export type PosDepositDocumentsQueryResult = Apollo.QueryResult<PosDepositDocumentsQuery, PosDepositDocumentsQueryVariables>;
export const AppDailyClosureEventDocument = gql`
    subscription AppDailyClosureEvent($filter: DailyClosureEventFilter!) {
  dailyClosureEvent(filter: $filter) {
    result
    propertyId
    procedureNames
  }
}
    `;

/**
 * __useAppDailyClosureEventSubscription__
 *
 * To run a query within a React component, call `useAppDailyClosureEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppDailyClosureEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppDailyClosureEventSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAppDailyClosureEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppDailyClosureEventSubscription, AppDailyClosureEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppDailyClosureEventSubscription, AppDailyClosureEventSubscriptionVariables>(AppDailyClosureEventDocument, options);
      }
export type AppDailyClosureEventSubscriptionHookResult = ReturnType<typeof useAppDailyClosureEventSubscription>;
export type AppDailyClosureEventSubscriptionResult = Apollo.SubscriptionResult<AppDailyClosureEventSubscription>;
export const QuotationDetailDocument = gql`
    query QuotationDetail($filter: QuotationQueryFilter!) {
  quotations(filter: $filter) {
    ...QuoteDetails
  }
}
    ${QuoteDetailsFragmentDoc}`;

/**
 * __useQuotationDetailQuery__
 *
 * To run a query within a React component, call `useQuotationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationDetailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQuotationDetailQuery(baseOptions: Apollo.QueryHookOptions<QuotationDetailQuery, QuotationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationDetailQuery, QuotationDetailQueryVariables>(QuotationDetailDocument, options);
      }
export function useQuotationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationDetailQuery, QuotationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationDetailQuery, QuotationDetailQueryVariables>(QuotationDetailDocument, options);
        }
export type QuotationDetailQueryHookResult = ReturnType<typeof useQuotationDetailQuery>;
export type QuotationDetailLazyQueryHookResult = ReturnType<typeof useQuotationDetailLazyQuery>;
export type QuotationDetailQueryResult = Apollo.QueryResult<QuotationDetailQuery, QuotationDetailQueryVariables>;
export const OperatorNameDocument = gql`
    query OperatorName($tsId: String!, $tenantId: ID!, $propertyId: ID!) {
  users(filter: {tsId: $tsId, tenantId: $tenantId, propertyId: $propertyId}) {
    fullname
  }
}
    `;

/**
 * __useOperatorNameQuery__
 *
 * To run a query within a React component, call `useOperatorNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorNameQuery({
 *   variables: {
 *      tsId: // value for 'tsId'
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useOperatorNameQuery(baseOptions: Apollo.QueryHookOptions<OperatorNameQuery, OperatorNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorNameQuery, OperatorNameQueryVariables>(OperatorNameDocument, options);
      }
export function useOperatorNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorNameQuery, OperatorNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorNameQuery, OperatorNameQueryVariables>(OperatorNameDocument, options);
        }
export type OperatorNameQueryHookResult = ReturnType<typeof useOperatorNameQuery>;
export type OperatorNameLazyQueryHookResult = ReturnType<typeof useOperatorNameLazyQuery>;
export type OperatorNameQueryResult = Apollo.QueryResult<OperatorNameQuery, OperatorNameQueryVariables>;
export const ConfirmQuotationDocument = gql`
    mutation ConfirmQuotation($input: ConfirmQuotationInput!) {
  confirmQuotation(input: $input) {
    ...PayAndConfirmQuotation
  }
}
    ${PayAndConfirmQuotationFragmentDoc}`;
export type ConfirmQuotationMutationFn = Apollo.MutationFunction<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;

/**
 * __useConfirmQuotationMutation__
 *
 * To run a mutation, you first call `useConfirmQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmQuotationMutation, { data, loading, error }] = useConfirmQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmQuotationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>(ConfirmQuotationDocument, options);
      }
export type ConfirmQuotationMutationHookResult = ReturnType<typeof useConfirmQuotationMutation>;
export type ConfirmQuotationMutationResult = Apollo.MutationResult<ConfirmQuotationMutation>;
export type ConfirmQuotationMutationOptions = Apollo.BaseMutationOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;
export const DeleteQuotationDocument = gql`
    mutation DeleteQuotation($deleteQuotationId: ID!, $tenantId: ID!) {
  deleteQuotation(id: $deleteQuotationId, tenantId: $tenantId)
}
    `;
export type DeleteQuotationMutationFn = Apollo.MutationFunction<DeleteQuotationMutation, DeleteQuotationMutationVariables>;

/**
 * __useDeleteQuotationMutation__
 *
 * To run a mutation, you first call `useDeleteQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuotationMutation, { data, loading, error }] = useDeleteQuotationMutation({
 *   variables: {
 *      deleteQuotationId: // value for 'deleteQuotationId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useDeleteQuotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuotationMutation, DeleteQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuotationMutation, DeleteQuotationMutationVariables>(DeleteQuotationDocument, options);
      }
export type DeleteQuotationMutationHookResult = ReturnType<typeof useDeleteQuotationMutation>;
export type DeleteQuotationMutationResult = Apollo.MutationResult<DeleteQuotationMutation>;
export type DeleteQuotationMutationOptions = Apollo.BaseMutationOptions<DeleteQuotationMutation, DeleteQuotationMutationVariables>;
export const GetQuotationLinkDocument = gql`
    query GetQuotationLink($tenantId: ID!, $quotationId: ID!) {
  getQuotationLink(tenantId: $tenantId, quotationId: $quotationId)
}
    `;

/**
 * __useGetQuotationLinkQuery__
 *
 * To run a query within a React component, call `useGetQuotationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotationLinkQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      quotationId: // value for 'quotationId'
 *   },
 * });
 */
export function useGetQuotationLinkQuery(baseOptions: Apollo.QueryHookOptions<GetQuotationLinkQuery, GetQuotationLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotationLinkQuery, GetQuotationLinkQueryVariables>(GetQuotationLinkDocument, options);
      }
export function useGetQuotationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotationLinkQuery, GetQuotationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotationLinkQuery, GetQuotationLinkQueryVariables>(GetQuotationLinkDocument, options);
        }
export type GetQuotationLinkQueryHookResult = ReturnType<typeof useGetQuotationLinkQuery>;
export type GetQuotationLinkLazyQueryHookResult = ReturnType<typeof useGetQuotationLinkLazyQuery>;
export type GetQuotationLinkQueryResult = Apollo.QueryResult<GetQuotationLinkQuery, GetQuotationLinkQueryVariables>;
export const SetQuotationStateDocument = gql`
    mutation SetQuotationState($tenantId: ID!, $setQuotationStateId: ID!, $state: SetQuotationState!) {
  setQuotationState(tenantId: $tenantId, id: $setQuotationStateId, state: $state)
}
    `;
export type SetQuotationStateMutationFn = Apollo.MutationFunction<SetQuotationStateMutation, SetQuotationStateMutationVariables>;

/**
 * __useSetQuotationStateMutation__
 *
 * To run a mutation, you first call `useSetQuotationStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuotationStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuotationStateMutation, { data, loading, error }] = useSetQuotationStateMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      setQuotationStateId: // value for 'setQuotationStateId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetQuotationStateMutation(baseOptions?: Apollo.MutationHookOptions<SetQuotationStateMutation, SetQuotationStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuotationStateMutation, SetQuotationStateMutationVariables>(SetQuotationStateDocument, options);
      }
export type SetQuotationStateMutationHookResult = ReturnType<typeof useSetQuotationStateMutation>;
export type SetQuotationStateMutationResult = Apollo.MutationResult<SetQuotationStateMutation>;
export type SetQuotationStateMutationOptions = Apollo.BaseMutationOptions<SetQuotationStateMutation, SetQuotationStateMutationVariables>;
export const SendQuotationEmailDocument = gql`
    mutation SendQuotationEmail($input: SendQuotationEmailInput!) {
  sendQuotationEmail(input: $input) {
    id
  }
}
    `;
export type SendQuotationEmailMutationFn = Apollo.MutationFunction<SendQuotationEmailMutation, SendQuotationEmailMutationVariables>;

/**
 * __useSendQuotationEmailMutation__
 *
 * To run a mutation, you first call `useSendQuotationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuotationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuotationEmailMutation, { data, loading, error }] = useSendQuotationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendQuotationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendQuotationEmailMutation, SendQuotationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQuotationEmailMutation, SendQuotationEmailMutationVariables>(SendQuotationEmailDocument, options);
      }
export type SendQuotationEmailMutationHookResult = ReturnType<typeof useSendQuotationEmailMutation>;
export type SendQuotationEmailMutationResult = Apollo.MutationResult<SendQuotationEmailMutation>;
export type SendQuotationEmailMutationOptions = Apollo.BaseMutationOptions<SendQuotationEmailMutation, SendQuotationEmailMutationVariables>;
export const CreateQuotationDocument = gql`
    mutation CreateQuotation($value: QuotationInput!) {
  createQuotation(value: $value) {
    ...QuoteItem
  }
}
    ${QuoteItemFragmentDoc}`;
export type CreateQuotationMutationFn = Apollo.MutationFunction<CreateQuotationMutation, CreateQuotationMutationVariables>;

/**
 * __useCreateQuotationMutation__
 *
 * To run a mutation, you first call `useCreateQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationMutation, { data, loading, error }] = useCreateQuotationMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateQuotationMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotationMutation, CreateQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotationMutation, CreateQuotationMutationVariables>(CreateQuotationDocument, options);
      }
export type CreateQuotationMutationHookResult = ReturnType<typeof useCreateQuotationMutation>;
export type CreateQuotationMutationResult = Apollo.MutationResult<CreateQuotationMutation>;
export type CreateQuotationMutationOptions = Apollo.BaseMutationOptions<CreateQuotationMutation, CreateQuotationMutationVariables>;
export const UpdateQuotationDocument = gql`
    mutation UpdateQuotation($updateQuotationId: ID!, $value: QuotationInput!) {
  updateQuotation(id: $updateQuotationId, value: $value) {
    ...QuoteItem
  }
}
    ${QuoteItemFragmentDoc}`;
export type UpdateQuotationMutationFn = Apollo.MutationFunction<UpdateQuotationMutation, UpdateQuotationMutationVariables>;

/**
 * __useUpdateQuotationMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationMutation, { data, loading, error }] = useUpdateQuotationMutation({
 *   variables: {
 *      updateQuotationId: // value for 'updateQuotationId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateQuotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotationMutation, UpdateQuotationMutationVariables>(UpdateQuotationDocument, options);
      }
export type UpdateQuotationMutationHookResult = ReturnType<typeof useUpdateQuotationMutation>;
export type UpdateQuotationMutationResult = Apollo.MutationResult<UpdateQuotationMutation>;
export type UpdateQuotationMutationOptions = Apollo.BaseMutationOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>;
export const QuotationsDocument = gql`
    query Quotations($filter: QuotationQueryFilter!, $limit: Int) {
  quotations(filter: $filter, limit: $limit) {
    ...Quotation
  }
}
    ${QuotationFragmentDoc}`;

/**
 * __useQuotationsQuery__
 *
 * To run a query within a React component, call `useQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useQuotationsQuery(baseOptions: Apollo.QueryHookOptions<QuotationsQuery, QuotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotationsQuery, QuotationsQueryVariables>(QuotationsDocument, options);
      }
export function useQuotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotationsQuery, QuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotationsQuery, QuotationsQueryVariables>(QuotationsDocument, options);
        }
export type QuotationsQueryHookResult = ReturnType<typeof useQuotationsQuery>;
export type QuotationsLazyQueryHookResult = ReturnType<typeof useQuotationsLazyQuery>;
export type QuotationsQueryResult = Apollo.QueryResult<QuotationsQuery, QuotationsQueryVariables>;
export const ResourceTypeAvailabilityDocument = gql`
    query ResourceTypeAvailability($filter: ResourceTypeAvailabilityInput!) {
  getResourceTypeAvailability(filter: $filter)
}
    `;

/**
 * __useResourceTypeAvailabilityQuery__
 *
 * To run a query within a React component, call `useResourceTypeAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypeAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypeAvailabilityQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypeAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypeAvailabilityQuery, ResourceTypeAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypeAvailabilityQuery, ResourceTypeAvailabilityQueryVariables>(ResourceTypeAvailabilityDocument, options);
      }
export function useResourceTypeAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypeAvailabilityQuery, ResourceTypeAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypeAvailabilityQuery, ResourceTypeAvailabilityQueryVariables>(ResourceTypeAvailabilityDocument, options);
        }
export type ResourceTypeAvailabilityQueryHookResult = ReturnType<typeof useResourceTypeAvailabilityQuery>;
export type ResourceTypeAvailabilityLazyQueryHookResult = ReturnType<typeof useResourceTypeAvailabilityLazyQuery>;
export type ResourceTypeAvailabilityQueryResult = Apollo.QueryResult<ResourceTypeAvailabilityQuery, ResourceTypeAvailabilityQueryVariables>;
export const UsersDocument = gql`
    query Users($filter: UserQueryInput!) {
  users(filter: $filter) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const AccountingDataExportSettingsDocument = gql`
    query AccountingDataExportSettings($tenantId: ID!) {
  exportProcedures(filter: {tenantId: {eq: $tenantId}}) {
    ...AccountingDataExportConfiguration
  }
}
    ${AccountingDataExportConfigurationFragmentDoc}`;

/**
 * __useAccountingDataExportSettingsQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportSettingsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAccountingDataExportSettingsQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportSettingsQuery, AccountingDataExportSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportSettingsQuery, AccountingDataExportSettingsQueryVariables>(AccountingDataExportSettingsDocument, options);
      }
export function useAccountingDataExportSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportSettingsQuery, AccountingDataExportSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportSettingsQuery, AccountingDataExportSettingsQueryVariables>(AccountingDataExportSettingsDocument, options);
        }
export type AccountingDataExportSettingsQueryHookResult = ReturnType<typeof useAccountingDataExportSettingsQuery>;
export type AccountingDataExportSettingsLazyQueryHookResult = ReturnType<typeof useAccountingDataExportSettingsLazyQuery>;
export type AccountingDataExportSettingsQueryResult = Apollo.QueryResult<AccountingDataExportSettingsQuery, AccountingDataExportSettingsQueryVariables>;
export const AccountingDataExportsDocument = gql`
    query AccountingDataExports($tenantId: ID!, $exportProcedureId: String!) {
  exportData(
    filter: {tenantId: {eq: $tenantId}, exportProcedureId: $exportProcedureId}
  ) {
    ...AccountingDataExport
  }
}
    ${AccountingDataExportFragmentDoc}`;

/**
 * __useAccountingDataExportsQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      exportProcedureId: // value for 'exportProcedureId'
 *   },
 * });
 */
export function useAccountingDataExportsQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportsQuery, AccountingDataExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportsQuery, AccountingDataExportsQueryVariables>(AccountingDataExportsDocument, options);
      }
export function useAccountingDataExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportsQuery, AccountingDataExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportsQuery, AccountingDataExportsQueryVariables>(AccountingDataExportsDocument, options);
        }
export type AccountingDataExportsQueryHookResult = ReturnType<typeof useAccountingDataExportsQuery>;
export type AccountingDataExportsLazyQueryHookResult = ReturnType<typeof useAccountingDataExportsLazyQuery>;
export type AccountingDataExportsQueryResult = Apollo.QueryResult<AccountingDataExportsQuery, AccountingDataExportsQueryVariables>;
export const AccountingDataExportStartDocument = gql`
    mutation AccountingDataExportStart($input: ExportInput!) {
  startExportManagement(input: $input) {
    id
    status
    auditable {
      createdOn
    }
  }
}
    `;
export type AccountingDataExportStartMutationFn = Apollo.MutationFunction<AccountingDataExportStartMutation, AccountingDataExportStartMutationVariables>;

/**
 * __useAccountingDataExportStartMutation__
 *
 * To run a mutation, you first call `useAccountingDataExportStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountingDataExportStartMutation, { data, loading, error }] = useAccountingDataExportStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountingDataExportStartMutation(baseOptions?: Apollo.MutationHookOptions<AccountingDataExportStartMutation, AccountingDataExportStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountingDataExportStartMutation, AccountingDataExportStartMutationVariables>(AccountingDataExportStartDocument, options);
      }
export type AccountingDataExportStartMutationHookResult = ReturnType<typeof useAccountingDataExportStartMutation>;
export type AccountingDataExportStartMutationResult = Apollo.MutationResult<AccountingDataExportStartMutation>;
export type AccountingDataExportStartMutationOptions = Apollo.BaseMutationOptions<AccountingDataExportStartMutation, AccountingDataExportStartMutationVariables>;
export const AccountingDataExportVatsDocument = gql`
    query AccountingDataExportVats($tenantId: ID!) {
  vats(filter: {tenantId: {eq: $tenantId}}) {
    ...AccountingDataExportVat
  }
}
    ${AccountingDataExportVatFragmentDoc}`;

/**
 * __useAccountingDataExportVatsQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportVatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportVatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportVatsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAccountingDataExportVatsQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportVatsQuery, AccountingDataExportVatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportVatsQuery, AccountingDataExportVatsQueryVariables>(AccountingDataExportVatsDocument, options);
      }
export function useAccountingDataExportVatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportVatsQuery, AccountingDataExportVatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportVatsQuery, AccountingDataExportVatsQueryVariables>(AccountingDataExportVatsDocument, options);
        }
export type AccountingDataExportVatsQueryHookResult = ReturnType<typeof useAccountingDataExportVatsQuery>;
export type AccountingDataExportVatsLazyQueryHookResult = ReturnType<typeof useAccountingDataExportVatsLazyQuery>;
export type AccountingDataExportVatsQueryResult = Apollo.QueryResult<AccountingDataExportVatsQuery, AccountingDataExportVatsQueryVariables>;
export const AccountingDataExportPaymentActivesDocument = gql`
    query AccountingDataExportPaymentActives($tenantId: ID!) {
  paymentActives(filter: {tenantId: {eq: $tenantId}}) {
    ...AccountingDataExportPaymentActive
  }
}
    ${AccountingDataExportPaymentActiveFragmentDoc}`;

/**
 * __useAccountingDataExportPaymentActivesQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportPaymentActivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportPaymentActivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportPaymentActivesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAccountingDataExportPaymentActivesQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportPaymentActivesQuery, AccountingDataExportPaymentActivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportPaymentActivesQuery, AccountingDataExportPaymentActivesQueryVariables>(AccountingDataExportPaymentActivesDocument, options);
      }
export function useAccountingDataExportPaymentActivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportPaymentActivesQuery, AccountingDataExportPaymentActivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportPaymentActivesQuery, AccountingDataExportPaymentActivesQueryVariables>(AccountingDataExportPaymentActivesDocument, options);
        }
export type AccountingDataExportPaymentActivesQueryHookResult = ReturnType<typeof useAccountingDataExportPaymentActivesQuery>;
export type AccountingDataExportPaymentActivesLazyQueryHookResult = ReturnType<typeof useAccountingDataExportPaymentActivesLazyQuery>;
export type AccountingDataExportPaymentActivesQueryResult = Apollo.QueryResult<AccountingDataExportPaymentActivesQuery, AccountingDataExportPaymentActivesQueryVariables>;
export const AccountingDataExportChargeCategoriesDocument = gql`
    query AccountingDataExportChargeCategories($tenantId: ID!) {
  chargeCategories(filter: {tenantId: {eq: $tenantId}}) {
    ...AccountingDataExportChargeCategory
  }
}
    ${AccountingDataExportChargeCategoryFragmentDoc}`;

/**
 * __useAccountingDataExportChargeCategoriesQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportChargeCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportChargeCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportChargeCategoriesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAccountingDataExportChargeCategoriesQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportChargeCategoriesQuery, AccountingDataExportChargeCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportChargeCategoriesQuery, AccountingDataExportChargeCategoriesQueryVariables>(AccountingDataExportChargeCategoriesDocument, options);
      }
export function useAccountingDataExportChargeCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportChargeCategoriesQuery, AccountingDataExportChargeCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportChargeCategoriesQuery, AccountingDataExportChargeCategoriesQueryVariables>(AccountingDataExportChargeCategoriesDocument, options);
        }
export type AccountingDataExportChargeCategoriesQueryHookResult = ReturnType<typeof useAccountingDataExportChargeCategoriesQuery>;
export type AccountingDataExportChargeCategoriesLazyQueryHookResult = ReturnType<typeof useAccountingDataExportChargeCategoriesLazyQuery>;
export type AccountingDataExportChargeCategoriesQueryResult = Apollo.QueryResult<AccountingDataExportChargeCategoriesQuery, AccountingDataExportChargeCategoriesQueryVariables>;
export const AccountingDataExportCashDeskTypesDocument = gql`
    query AccountingDataExportCashDeskTypes($tenantId: ID!) {
  cashDeskTypes(filter: {tenantId: {eq: $tenantId}}) {
    ...AccountingDataExportCashDeskType
  }
}
    ${AccountingDataExportCashDeskTypeFragmentDoc}`;

/**
 * __useAccountingDataExportCashDeskTypesQuery__
 *
 * To run a query within a React component, call `useAccountingDataExportCashDeskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportCashDeskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingDataExportCashDeskTypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAccountingDataExportCashDeskTypesQuery(baseOptions: Apollo.QueryHookOptions<AccountingDataExportCashDeskTypesQuery, AccountingDataExportCashDeskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingDataExportCashDeskTypesQuery, AccountingDataExportCashDeskTypesQueryVariables>(AccountingDataExportCashDeskTypesDocument, options);
      }
export function useAccountingDataExportCashDeskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingDataExportCashDeskTypesQuery, AccountingDataExportCashDeskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingDataExportCashDeskTypesQuery, AccountingDataExportCashDeskTypesQueryVariables>(AccountingDataExportCashDeskTypesDocument, options);
        }
export type AccountingDataExportCashDeskTypesQueryHookResult = ReturnType<typeof useAccountingDataExportCashDeskTypesQuery>;
export type AccountingDataExportCashDeskTypesLazyQueryHookResult = ReturnType<typeof useAccountingDataExportCashDeskTypesLazyQuery>;
export type AccountingDataExportCashDeskTypesQueryResult = Apollo.QueryResult<AccountingDataExportCashDeskTypesQuery, AccountingDataExportCashDeskTypesQueryVariables>;
export const AccountingDataExportCreateConfigurationDocument = gql`
    mutation AccountingDataExportCreateConfiguration($value: ExportProcedureInput!) {
  createExportProcedure(value: $value) {
    id
  }
}
    `;
export type AccountingDataExportCreateConfigurationMutationFn = Apollo.MutationFunction<AccountingDataExportCreateConfigurationMutation, AccountingDataExportCreateConfigurationMutationVariables>;

/**
 * __useAccountingDataExportCreateConfigurationMutation__
 *
 * To run a mutation, you first call `useAccountingDataExportCreateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportCreateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountingDataExportCreateConfigurationMutation, { data, loading, error }] = useAccountingDataExportCreateConfigurationMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAccountingDataExportCreateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AccountingDataExportCreateConfigurationMutation, AccountingDataExportCreateConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountingDataExportCreateConfigurationMutation, AccountingDataExportCreateConfigurationMutationVariables>(AccountingDataExportCreateConfigurationDocument, options);
      }
export type AccountingDataExportCreateConfigurationMutationHookResult = ReturnType<typeof useAccountingDataExportCreateConfigurationMutation>;
export type AccountingDataExportCreateConfigurationMutationResult = Apollo.MutationResult<AccountingDataExportCreateConfigurationMutation>;
export type AccountingDataExportCreateConfigurationMutationOptions = Apollo.BaseMutationOptions<AccountingDataExportCreateConfigurationMutation, AccountingDataExportCreateConfigurationMutationVariables>;
export const AccountingDataExportUpdateConfigurationDocument = gql`
    mutation AccountingDataExportUpdateConfiguration($id: String!, $value: ExportProcedureInput!) {
  updateExportProcedure(id: $id, value: $value) {
    id
  }
}
    `;
export type AccountingDataExportUpdateConfigurationMutationFn = Apollo.MutationFunction<AccountingDataExportUpdateConfigurationMutation, AccountingDataExportUpdateConfigurationMutationVariables>;

/**
 * __useAccountingDataExportUpdateConfigurationMutation__
 *
 * To run a mutation, you first call `useAccountingDataExportUpdateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportUpdateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountingDataExportUpdateConfigurationMutation, { data, loading, error }] = useAccountingDataExportUpdateConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAccountingDataExportUpdateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AccountingDataExportUpdateConfigurationMutation, AccountingDataExportUpdateConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountingDataExportUpdateConfigurationMutation, AccountingDataExportUpdateConfigurationMutationVariables>(AccountingDataExportUpdateConfigurationDocument, options);
      }
export type AccountingDataExportUpdateConfigurationMutationHookResult = ReturnType<typeof useAccountingDataExportUpdateConfigurationMutation>;
export type AccountingDataExportUpdateConfigurationMutationResult = Apollo.MutationResult<AccountingDataExportUpdateConfigurationMutation>;
export type AccountingDataExportUpdateConfigurationMutationOptions = Apollo.BaseMutationOptions<AccountingDataExportUpdateConfigurationMutation, AccountingDataExportUpdateConfigurationMutationVariables>;
export const AccountingDataExportUpdatePaymentActiveDocument = gql`
    mutation AccountingDataExportUpdatePaymentActive($id: String!, $input: PaymentActiveInput!) {
  updatePaymentActive(id: $id, input: $input) {
    id
  }
}
    `;
export type AccountingDataExportUpdatePaymentActiveMutationFn = Apollo.MutationFunction<AccountingDataExportUpdatePaymentActiveMutation, AccountingDataExportUpdatePaymentActiveMutationVariables>;

/**
 * __useAccountingDataExportUpdatePaymentActiveMutation__
 *
 * To run a mutation, you first call `useAccountingDataExportUpdatePaymentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportUpdatePaymentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountingDataExportUpdatePaymentActiveMutation, { data, loading, error }] = useAccountingDataExportUpdatePaymentActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountingDataExportUpdatePaymentActiveMutation(baseOptions?: Apollo.MutationHookOptions<AccountingDataExportUpdatePaymentActiveMutation, AccountingDataExportUpdatePaymentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountingDataExportUpdatePaymentActiveMutation, AccountingDataExportUpdatePaymentActiveMutationVariables>(AccountingDataExportUpdatePaymentActiveDocument, options);
      }
export type AccountingDataExportUpdatePaymentActiveMutationHookResult = ReturnType<typeof useAccountingDataExportUpdatePaymentActiveMutation>;
export type AccountingDataExportUpdatePaymentActiveMutationResult = Apollo.MutationResult<AccountingDataExportUpdatePaymentActiveMutation>;
export type AccountingDataExportUpdatePaymentActiveMutationOptions = Apollo.BaseMutationOptions<AccountingDataExportUpdatePaymentActiveMutation, AccountingDataExportUpdatePaymentActiveMutationVariables>;
export const AccountingDataExportUpdateCashDeskTypeDocument = gql`
    mutation AccountingDataExportUpdateCashDeskType($id: String!, $input: CashDeskTypeInput!) {
  updateCashDeskType(id: $id, input: $input) {
    id
  }
}
    `;
export type AccountingDataExportUpdateCashDeskTypeMutationFn = Apollo.MutationFunction<AccountingDataExportUpdateCashDeskTypeMutation, AccountingDataExportUpdateCashDeskTypeMutationVariables>;

/**
 * __useAccountingDataExportUpdateCashDeskTypeMutation__
 *
 * To run a mutation, you first call `useAccountingDataExportUpdateCashDeskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountingDataExportUpdateCashDeskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountingDataExportUpdateCashDeskTypeMutation, { data, loading, error }] = useAccountingDataExportUpdateCashDeskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountingDataExportUpdateCashDeskTypeMutation(baseOptions?: Apollo.MutationHookOptions<AccountingDataExportUpdateCashDeskTypeMutation, AccountingDataExportUpdateCashDeskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountingDataExportUpdateCashDeskTypeMutation, AccountingDataExportUpdateCashDeskTypeMutationVariables>(AccountingDataExportUpdateCashDeskTypeDocument, options);
      }
export type AccountingDataExportUpdateCashDeskTypeMutationHookResult = ReturnType<typeof useAccountingDataExportUpdateCashDeskTypeMutation>;
export type AccountingDataExportUpdateCashDeskTypeMutationResult = Apollo.MutationResult<AccountingDataExportUpdateCashDeskTypeMutation>;
export type AccountingDataExportUpdateCashDeskTypeMutationOptions = Apollo.BaseMutationOptions<AccountingDataExportUpdateCashDeskTypeMutation, AccountingDataExportUpdateCashDeskTypeMutationVariables>;
export const SingleAdditionalServiceDocument = gql`
    query SingleAdditionalService($filter: AdditionalServiceQueryFilter!) {
  additionalServices(filter: $filter) {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;

/**
 * __useSingleAdditionalServiceQuery__
 *
 * To run a query within a React component, call `useSingleAdditionalServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAdditionalServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAdditionalServiceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSingleAdditionalServiceQuery(baseOptions: Apollo.QueryHookOptions<SingleAdditionalServiceQuery, SingleAdditionalServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAdditionalServiceQuery, SingleAdditionalServiceQueryVariables>(SingleAdditionalServiceDocument, options);
      }
export function useSingleAdditionalServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAdditionalServiceQuery, SingleAdditionalServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAdditionalServiceQuery, SingleAdditionalServiceQueryVariables>(SingleAdditionalServiceDocument, options);
        }
export type SingleAdditionalServiceQueryHookResult = ReturnType<typeof useSingleAdditionalServiceQuery>;
export type SingleAdditionalServiceLazyQueryHookResult = ReturnType<typeof useSingleAdditionalServiceLazyQuery>;
export type SingleAdditionalServiceQueryResult = Apollo.QueryResult<SingleAdditionalServiceQuery, SingleAdditionalServiceQueryVariables>;
export const AdditionalServicesDocument = gql`
    query AdditionalServices($filter: AdditionalServiceQueryFilter!, $limit: Int, $skip: Int) {
  additionalServices(filter: $filter, limit: $limit, skip: $skip) {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;

/**
 * __useAdditionalServicesQuery__
 *
 * To run a query within a React component, call `useAdditionalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalServicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAdditionalServicesQuery(baseOptions: Apollo.QueryHookOptions<AdditionalServicesQuery, AdditionalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalServicesQuery, AdditionalServicesQueryVariables>(AdditionalServicesDocument, options);
      }
export function useAdditionalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalServicesQuery, AdditionalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalServicesQuery, AdditionalServicesQueryVariables>(AdditionalServicesDocument, options);
        }
export type AdditionalServicesQueryHookResult = ReturnType<typeof useAdditionalServicesQuery>;
export type AdditionalServicesLazyQueryHookResult = ReturnType<typeof useAdditionalServicesLazyQuery>;
export type AdditionalServicesQueryResult = Apollo.QueryResult<AdditionalServicesQuery, AdditionalServicesQueryVariables>;
export const CreateAdditionalServiceDocument = gql`
    mutation CreateAdditionalService($value: AdditionalServiceInput!) {
  createAdditionalService(value: $value) {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;
export type CreateAdditionalServiceMutationFn = Apollo.MutationFunction<CreateAdditionalServiceMutation, CreateAdditionalServiceMutationVariables>;

/**
 * __useCreateAdditionalServiceMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalServiceMutation, { data, loading, error }] = useCreateAdditionalServiceMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateAdditionalServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalServiceMutation, CreateAdditionalServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalServiceMutation, CreateAdditionalServiceMutationVariables>(CreateAdditionalServiceDocument, options);
      }
export type CreateAdditionalServiceMutationHookResult = ReturnType<typeof useCreateAdditionalServiceMutation>;
export type CreateAdditionalServiceMutationResult = Apollo.MutationResult<CreateAdditionalServiceMutation>;
export type CreateAdditionalServiceMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalServiceMutation, CreateAdditionalServiceMutationVariables>;
export const DeleteAdditionalServiceDocument = gql`
    mutation DeleteAdditionalService($tenantId: ID!, $deleteAdditionalServiceId: String!) {
  deleteAdditionalService(tenantId: $tenantId, id: $deleteAdditionalServiceId)
}
    `;
export type DeleteAdditionalServiceMutationFn = Apollo.MutationFunction<DeleteAdditionalServiceMutation, DeleteAdditionalServiceMutationVariables>;

/**
 * __useDeleteAdditionalServiceMutation__
 *
 * To run a mutation, you first call `useDeleteAdditionalServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdditionalServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdditionalServiceMutation, { data, loading, error }] = useDeleteAdditionalServiceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteAdditionalServiceId: // value for 'deleteAdditionalServiceId'
 *   },
 * });
 */
export function useDeleteAdditionalServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdditionalServiceMutation, DeleteAdditionalServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdditionalServiceMutation, DeleteAdditionalServiceMutationVariables>(DeleteAdditionalServiceDocument, options);
      }
export type DeleteAdditionalServiceMutationHookResult = ReturnType<typeof useDeleteAdditionalServiceMutation>;
export type DeleteAdditionalServiceMutationResult = Apollo.MutationResult<DeleteAdditionalServiceMutation>;
export type DeleteAdditionalServiceMutationOptions = Apollo.BaseMutationOptions<DeleteAdditionalServiceMutation, DeleteAdditionalServiceMutationVariables>;
export const UpdateAdditionalServiceDocument = gql`
    mutation UpdateAdditionalService($updateAdditionalServiceId: String!, $value: AdditionalServiceInput!) {
  updateAdditionalService(id: $updateAdditionalServiceId, value: $value) {
    ...AdditionalService
  }
}
    ${AdditionalServiceFragmentDoc}`;
export type UpdateAdditionalServiceMutationFn = Apollo.MutationFunction<UpdateAdditionalServiceMutation, UpdateAdditionalServiceMutationVariables>;

/**
 * __useUpdateAdditionalServiceMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalServiceMutation, { data, loading, error }] = useUpdateAdditionalServiceMutation({
 *   variables: {
 *      updateAdditionalServiceId: // value for 'updateAdditionalServiceId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateAdditionalServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalServiceMutation, UpdateAdditionalServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalServiceMutation, UpdateAdditionalServiceMutationVariables>(UpdateAdditionalServiceDocument, options);
      }
export type UpdateAdditionalServiceMutationHookResult = ReturnType<typeof useUpdateAdditionalServiceMutation>;
export type UpdateAdditionalServiceMutationResult = Apollo.MutationResult<UpdateAdditionalServiceMutation>;
export type UpdateAdditionalServiceMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalServiceMutation, UpdateAdditionalServiceMutationVariables>;
export const MessageTemplatesAutomationDocument = gql`
    query MessageTemplatesAutomation($filter: MessageTemplateQueryFilter!) {
  messageTemplates(filter: $filter) {
    ...MessageTemplateAutomation
  }
}
    ${MessageTemplateAutomationFragmentDoc}`;

/**
 * __useMessageTemplatesAutomationQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesAutomationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessageTemplatesAutomationQuery(baseOptions: Apollo.QueryHookOptions<MessageTemplatesAutomationQuery, MessageTemplatesAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplatesAutomationQuery, MessageTemplatesAutomationQueryVariables>(MessageTemplatesAutomationDocument, options);
      }
export function useMessageTemplatesAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesAutomationQuery, MessageTemplatesAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplatesAutomationQuery, MessageTemplatesAutomationQueryVariables>(MessageTemplatesAutomationDocument, options);
        }
export type MessageTemplatesAutomationQueryHookResult = ReturnType<typeof useMessageTemplatesAutomationQuery>;
export type MessageTemplatesAutomationLazyQueryHookResult = ReturnType<typeof useMessageTemplatesAutomationLazyQuery>;
export type MessageTemplatesAutomationQueryResult = Apollo.QueryResult<MessageTemplatesAutomationQuery, MessageTemplatesAutomationQueryVariables>;
export const MessageAutomationListDocument = gql`
    query MessageAutomationList($filter: MessageAutomationQueryFilter!) {
  messageAutomations(filter: $filter) {
    ...MessageAutomation
  }
}
    ${MessageAutomationFragmentDoc}`;

/**
 * __useMessageAutomationListQuery__
 *
 * To run a query within a React component, call `useMessageAutomationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAutomationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAutomationListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessageAutomationListQuery(baseOptions: Apollo.QueryHookOptions<MessageAutomationListQuery, MessageAutomationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageAutomationListQuery, MessageAutomationListQueryVariables>(MessageAutomationListDocument, options);
      }
export function useMessageAutomationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageAutomationListQuery, MessageAutomationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageAutomationListQuery, MessageAutomationListQueryVariables>(MessageAutomationListDocument, options);
        }
export type MessageAutomationListQueryHookResult = ReturnType<typeof useMessageAutomationListQuery>;
export type MessageAutomationListLazyQueryHookResult = ReturnType<typeof useMessageAutomationListLazyQuery>;
export type MessageAutomationListQueryResult = Apollo.QueryResult<MessageAutomationListQuery, MessageAutomationListQueryVariables>;
export const UpdateMessageAutomationDocument = gql`
    mutation UpdateMessageAutomation($id: ID!, $value: MessageAutomationInput!) {
  updateMessageAutomation(id: $id, value: $value) {
    ...MessageAutomation
  }
}
    ${MessageAutomationFragmentDoc}`;
export type UpdateMessageAutomationMutationFn = Apollo.MutationFunction<UpdateMessageAutomationMutation, UpdateMessageAutomationMutationVariables>;

/**
 * __useUpdateMessageAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateMessageAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageAutomationMutation, { data, loading, error }] = useUpdateMessageAutomationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateMessageAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageAutomationMutation, UpdateMessageAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageAutomationMutation, UpdateMessageAutomationMutationVariables>(UpdateMessageAutomationDocument, options);
      }
export type UpdateMessageAutomationMutationHookResult = ReturnType<typeof useUpdateMessageAutomationMutation>;
export type UpdateMessageAutomationMutationResult = Apollo.MutationResult<UpdateMessageAutomationMutation>;
export type UpdateMessageAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateMessageAutomationMutation, UpdateMessageAutomationMutationVariables>;
export const DeleteMessageAutomationDocument = gql`
    mutation DeleteMessageAutomation($tenantId: ID!, $id: ID!) {
  deleteMessageAutomation(tenantId: $tenantId, id: $id)
}
    `;
export type DeleteMessageAutomationMutationFn = Apollo.MutationFunction<DeleteMessageAutomationMutation, DeleteMessageAutomationMutationVariables>;

/**
 * __useDeleteMessageAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteMessageAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageAutomationMutation, { data, loading, error }] = useDeleteMessageAutomationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageAutomationMutation, DeleteMessageAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageAutomationMutation, DeleteMessageAutomationMutationVariables>(DeleteMessageAutomationDocument, options);
      }
export type DeleteMessageAutomationMutationHookResult = ReturnType<typeof useDeleteMessageAutomationMutation>;
export type DeleteMessageAutomationMutationResult = Apollo.MutationResult<DeleteMessageAutomationMutation>;
export type DeleteMessageAutomationMutationOptions = Apollo.BaseMutationOptions<DeleteMessageAutomationMutation, DeleteMessageAutomationMutationVariables>;
export const ResourceTypesAndPropertyAutomationDocument = gql`
    query ResourceTypesAndPropertyAutomation($propertyFilter: PropertyQueryFilter!, $resourceTypeFilter: ResourceTypeQueryFilter!) {
  properties(filter: $propertyFilter) {
    id
    name
    subAddresses {
      name
      resourceTypeIds
    }
  }
  resourceTypes(filter: $resourceTypeFilter) {
    ...ResourceTypeAutomation
  }
}
    ${ResourceTypeAutomationFragmentDoc}`;

/**
 * __useResourceTypesAndPropertyAutomationQuery__
 *
 * To run a query within a React component, call `useResourceTypesAndPropertyAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesAndPropertyAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesAndPropertyAutomationQuery({
 *   variables: {
 *      propertyFilter: // value for 'propertyFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *   },
 * });
 */
export function useResourceTypesAndPropertyAutomationQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypesAndPropertyAutomationQuery, ResourceTypesAndPropertyAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesAndPropertyAutomationQuery, ResourceTypesAndPropertyAutomationQueryVariables>(ResourceTypesAndPropertyAutomationDocument, options);
      }
export function useResourceTypesAndPropertyAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesAndPropertyAutomationQuery, ResourceTypesAndPropertyAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesAndPropertyAutomationQuery, ResourceTypesAndPropertyAutomationQueryVariables>(ResourceTypesAndPropertyAutomationDocument, options);
        }
export type ResourceTypesAndPropertyAutomationQueryHookResult = ReturnType<typeof useResourceTypesAndPropertyAutomationQuery>;
export type ResourceTypesAndPropertyAutomationLazyQueryHookResult = ReturnType<typeof useResourceTypesAndPropertyAutomationLazyQuery>;
export type ResourceTypesAndPropertyAutomationQueryResult = Apollo.QueryResult<ResourceTypesAndPropertyAutomationQuery, ResourceTypesAndPropertyAutomationQueryVariables>;
export const CreateMessageAutomationDocument = gql`
    mutation CreateMessageAutomation($value: MessageAutomationInput!) {
  createMessageAutomation(value: $value) {
    ...MessageAutomation
  }
}
    ${MessageAutomationFragmentDoc}`;
export type CreateMessageAutomationMutationFn = Apollo.MutationFunction<CreateMessageAutomationMutation, CreateMessageAutomationMutationVariables>;

/**
 * __useCreateMessageAutomationMutation__
 *
 * To run a mutation, you first call `useCreateMessageAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageAutomationMutation, { data, loading, error }] = useCreateMessageAutomationMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateMessageAutomationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageAutomationMutation, CreateMessageAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageAutomationMutation, CreateMessageAutomationMutationVariables>(CreateMessageAutomationDocument, options);
      }
export type CreateMessageAutomationMutationHookResult = ReturnType<typeof useCreateMessageAutomationMutation>;
export type CreateMessageAutomationMutationResult = Apollo.MutationResult<CreateMessageAutomationMutation>;
export type CreateMessageAutomationMutationOptions = Apollo.BaseMutationOptions<CreateMessageAutomationMutation, CreateMessageAutomationMutationVariables>;
export const CashDeskTypeBillingDocument = gql`
    query CashDeskTypeBilling($filter: TenantPropertyIdFilter!) {
  cashDeskTypes(filter: $filter) {
    ...CashDeskTypeBilling
  }
}
    ${CashDeskTypeBillingFragmentDoc}`;

/**
 * __useCashDeskTypeBillingQuery__
 *
 * To run a query within a React component, call `useCashDeskTypeBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDeskTypeBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDeskTypeBillingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCashDeskTypeBillingQuery(baseOptions: Apollo.QueryHookOptions<CashDeskTypeBillingQuery, CashDeskTypeBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDeskTypeBillingQuery, CashDeskTypeBillingQueryVariables>(CashDeskTypeBillingDocument, options);
      }
export function useCashDeskTypeBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDeskTypeBillingQuery, CashDeskTypeBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDeskTypeBillingQuery, CashDeskTypeBillingQueryVariables>(CashDeskTypeBillingDocument, options);
        }
export type CashDeskTypeBillingQueryHookResult = ReturnType<typeof useCashDeskTypeBillingQuery>;
export type CashDeskTypeBillingLazyQueryHookResult = ReturnType<typeof useCashDeskTypeBillingLazyQuery>;
export type CashDeskTypeBillingQueryResult = Apollo.QueryResult<CashDeskTypeBillingQuery, CashDeskTypeBillingQueryVariables>;
export const FiscalConfigurationsDocument = gql`
    query FiscalConfigurations($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    id
    vatNumber
    address {
      country {
        isoCode
      }
    }
    tenant {
      id
      vatNumber
    }
    fiscalConfigurations {
      ...FiscalConfigurationBilling
    }
  }
}
    ${FiscalConfigurationBillingFragmentDoc}`;

/**
 * __useFiscalConfigurationsQuery__
 *
 * To run a query within a React component, call `useFiscalConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalConfigurationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFiscalConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<FiscalConfigurationsQuery, FiscalConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalConfigurationsQuery, FiscalConfigurationsQueryVariables>(FiscalConfigurationsDocument, options);
      }
export function useFiscalConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalConfigurationsQuery, FiscalConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalConfigurationsQuery, FiscalConfigurationsQueryVariables>(FiscalConfigurationsDocument, options);
        }
export type FiscalConfigurationsQueryHookResult = ReturnType<typeof useFiscalConfigurationsQuery>;
export type FiscalConfigurationsLazyQueryHookResult = ReturnType<typeof useFiscalConfigurationsLazyQuery>;
export type FiscalConfigurationsQueryResult = Apollo.QueryResult<FiscalConfigurationsQuery, FiscalConfigurationsQueryVariables>;
export const GetRegistryItemsDocument = gql`
    query GetRegistryItems($input: GetRegistryItemsInput!) {
  getRegistryItems(input: $input) {
    base {
      id
      details {
        description
        addresses {
          streetName
          streetNumber
          city
          province
          zipCode
          country
          fullAddress
          types
          id
        }
        economics {
          rea
          cciaa
          capitalStock
          liquidationState
          registrationDate
          taxRegime
          soleShareholder
          balanceSheetDate
          economicActivities {
            mainActivity {
              code
              rootCode
            }
          }
        }
      }
      ncsId
      identifier {
        vatNumber
        taxId
      }
    }
  }
}
    `;

/**
 * __useGetRegistryItemsQuery__
 *
 * To run a query within a React component, call `useGetRegistryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRegistryItemsQuery(baseOptions: Apollo.QueryHookOptions<GetRegistryItemsQuery, GetRegistryItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistryItemsQuery, GetRegistryItemsQueryVariables>(GetRegistryItemsDocument, options);
      }
export function useGetRegistryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistryItemsQuery, GetRegistryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistryItemsQuery, GetRegistryItemsQueryVariables>(GetRegistryItemsDocument, options);
        }
export type GetRegistryItemsQueryHookResult = ReturnType<typeof useGetRegistryItemsQuery>;
export type GetRegistryItemsLazyQueryHookResult = ReturnType<typeof useGetRegistryItemsLazyQuery>;
export type GetRegistryItemsQueryResult = Apollo.QueryResult<GetRegistryItemsQuery, GetRegistryItemsQueryVariables>;
export const GetSubscriptionInfoDocument = gql`
    query GetSubscriptionInfo($registryCompanyId: String!) {
  getSubscriptionInfo(registryCompanyId: $registryCompanyId) {
    ...SubscriptionDigital
  }
}
    ${SubscriptionDigitalFragmentDoc}`;

/**
 * __useGetSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionInfoQuery({
 *   variables: {
 *      registryCompanyId: // value for 'registryCompanyId'
 *   },
 * });
 */
export function useGetSubscriptionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>(GetSubscriptionInfoDocument, options);
      }
export function useGetSubscriptionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>(GetSubscriptionInfoDocument, options);
        }
export type GetSubscriptionInfoQueryHookResult = ReturnType<typeof useGetSubscriptionInfoQuery>;
export type GetSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useGetSubscriptionInfoLazyQuery>;
export type GetSubscriptionInfoQueryResult = Apollo.QueryResult<GetSubscriptionInfoQuery, GetSubscriptionInfoQueryVariables>;
export const SetPropertyFiscalConfigurationDocument = gql`
    mutation SetPropertyFiscalConfiguration($tenantId: ID!, $setPropertyFiscalConfigurationId: ID!, $config: [FiscalConfigurationInput!]!) {
  setPropertyFiscalConfiguration(
    tenantId: $tenantId
    id: $setPropertyFiscalConfigurationId
    config: $config
  )
}
    `;
export type SetPropertyFiscalConfigurationMutationFn = Apollo.MutationFunction<SetPropertyFiscalConfigurationMutation, SetPropertyFiscalConfigurationMutationVariables>;

/**
 * __useSetPropertyFiscalConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertyFiscalConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyFiscalConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyFiscalConfigurationMutation, { data, loading, error }] = useSetPropertyFiscalConfigurationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      setPropertyFiscalConfigurationId: // value for 'setPropertyFiscalConfigurationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSetPropertyFiscalConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyFiscalConfigurationMutation, SetPropertyFiscalConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyFiscalConfigurationMutation, SetPropertyFiscalConfigurationMutationVariables>(SetPropertyFiscalConfigurationDocument, options);
      }
export type SetPropertyFiscalConfigurationMutationHookResult = ReturnType<typeof useSetPropertyFiscalConfigurationMutation>;
export type SetPropertyFiscalConfigurationMutationResult = Apollo.MutationResult<SetPropertyFiscalConfigurationMutation>;
export type SetPropertyFiscalConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertyFiscalConfigurationMutation, SetPropertyFiscalConfigurationMutationVariables>;
export const DeleteCashDeskTypeDocument = gql`
    mutation DeleteCashDeskType($tenantId: ID!, $id: String!) {
  deleteCashDeskType(tenantId: $tenantId, id: $id)
}
    `;
export type DeleteCashDeskTypeMutationFn = Apollo.MutationFunction<DeleteCashDeskTypeMutation, DeleteCashDeskTypeMutationVariables>;

/**
 * __useDeleteCashDeskTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCashDeskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashDeskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashDeskTypeMutation, { data, loading, error }] = useDeleteCashDeskTypeMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCashDeskTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashDeskTypeMutation, DeleteCashDeskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCashDeskTypeMutation, DeleteCashDeskTypeMutationVariables>(DeleteCashDeskTypeDocument, options);
      }
export type DeleteCashDeskTypeMutationHookResult = ReturnType<typeof useDeleteCashDeskTypeMutation>;
export type DeleteCashDeskTypeMutationResult = Apollo.MutationResult<DeleteCashDeskTypeMutation>;
export type DeleteCashDeskTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCashDeskTypeMutation, DeleteCashDeskTypeMutationVariables>;
export const IsCashDeskTypeUsedDocument = gql`
    query IsCashDeskTypeUsed($tenantId: ID!, $propertyId: ID!, $cashDeskTypeIds: [ID!]!) {
  documents(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, cashDeskTypeId: {in: $cashDeskTypeIds}}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useIsCashDeskTypeUsedQuery__
 *
 * To run a query within a React component, call `useIsCashDeskTypeUsedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCashDeskTypeUsedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCashDeskTypeUsedQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      cashDeskTypeIds: // value for 'cashDeskTypeIds'
 *   },
 * });
 */
export function useIsCashDeskTypeUsedQuery(baseOptions: Apollo.QueryHookOptions<IsCashDeskTypeUsedQuery, IsCashDeskTypeUsedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCashDeskTypeUsedQuery, IsCashDeskTypeUsedQueryVariables>(IsCashDeskTypeUsedDocument, options);
      }
export function useIsCashDeskTypeUsedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCashDeskTypeUsedQuery, IsCashDeskTypeUsedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCashDeskTypeUsedQuery, IsCashDeskTypeUsedQueryVariables>(IsCashDeskTypeUsedDocument, options);
        }
export type IsCashDeskTypeUsedQueryHookResult = ReturnType<typeof useIsCashDeskTypeUsedQuery>;
export type IsCashDeskTypeUsedLazyQueryHookResult = ReturnType<typeof useIsCashDeskTypeUsedLazyQuery>;
export type IsCashDeskTypeUsedQueryResult = Apollo.QueryResult<IsCashDeskTypeUsedQuery, IsCashDeskTypeUsedQueryVariables>;
export const BookingEngineURLSDocument = gql`
    query BookingEngineURLS($tenantId: ID!, $propertyId: [ID!]!) {
  bookingEngineUrls(tenantId: $tenantId, propertyId: $propertyId) {
    propertyId
    url
  }
}
    `;

/**
 * __useBookingEngineURLSQuery__
 *
 * To run a query within a React component, call `useBookingEngineURLSQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEngineURLSQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEngineURLSQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useBookingEngineURLSQuery(baseOptions: Apollo.QueryHookOptions<BookingEngineURLSQuery, BookingEngineURLSQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingEngineURLSQuery, BookingEngineURLSQueryVariables>(BookingEngineURLSDocument, options);
      }
export function useBookingEngineURLSLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingEngineURLSQuery, BookingEngineURLSQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingEngineURLSQuery, BookingEngineURLSQueryVariables>(BookingEngineURLSDocument, options);
        }
export type BookingEngineURLSQueryHookResult = ReturnType<typeof useBookingEngineURLSQuery>;
export type BookingEngineURLSLazyQueryHookResult = ReturnType<typeof useBookingEngineURLSLazyQuery>;
export type BookingEngineURLSQueryResult = Apollo.QueryResult<BookingEngineURLSQuery, BookingEngineURLSQueryVariables>;
export const AvailabilityRequestDocument = gql`
    query AvailabilityRequest($filter: AvailabilityRequestQueryFilter!, $skip: Int, $limit: Int) {
  availabilityRequests(filter: $filter, skip: $skip, limit: $limit) {
    ...AvailabilityRequest
  }
}
    ${AvailabilityRequestFragmentDoc}`;

/**
 * __useAvailabilityRequestQuery__
 *
 * To run a query within a React component, call `useAvailabilityRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityRequestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAvailabilityRequestQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityRequestQuery, AvailabilityRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityRequestQuery, AvailabilityRequestQueryVariables>(AvailabilityRequestDocument, options);
      }
export function useAvailabilityRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityRequestQuery, AvailabilityRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityRequestQuery, AvailabilityRequestQueryVariables>(AvailabilityRequestDocument, options);
        }
export type AvailabilityRequestQueryHookResult = ReturnType<typeof useAvailabilityRequestQuery>;
export type AvailabilityRequestLazyQueryHookResult = ReturnType<typeof useAvailabilityRequestLazyQuery>;
export type AvailabilityRequestQueryResult = Apollo.QueryResult<AvailabilityRequestQuery, AvailabilityRequestQueryVariables>;
export const BookingEngineConfigurationDocument = gql`
    query BookingEngineConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    type
    address {
      ...SubAddressAddress
    }
    subAddresses {
      name
      resourceTypeIds
      address {
        ...SubAddressAddress
      }
    }
    bookingEngineConfiguration {
      googleGA4
      fiscalAdvances
    }
  }
}
    ${SubAddressAddressFragmentDoc}`;

/**
 * __useBookingEngineConfigurationQuery__
 *
 * To run a query within a React component, call `useBookingEngineConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingEngineConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingEngineConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingEngineConfigurationQuery(baseOptions: Apollo.QueryHookOptions<BookingEngineConfigurationQuery, BookingEngineConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingEngineConfigurationQuery, BookingEngineConfigurationQueryVariables>(BookingEngineConfigurationDocument, options);
      }
export function useBookingEngineConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingEngineConfigurationQuery, BookingEngineConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingEngineConfigurationQuery, BookingEngineConfigurationQueryVariables>(BookingEngineConfigurationDocument, options);
        }
export type BookingEngineConfigurationQueryHookResult = ReturnType<typeof useBookingEngineConfigurationQuery>;
export type BookingEngineConfigurationLazyQueryHookResult = ReturnType<typeof useBookingEngineConfigurationLazyQuery>;
export type BookingEngineConfigurationQueryResult = Apollo.QueryResult<BookingEngineConfigurationQuery, BookingEngineConfigurationQueryVariables>;
export const BookingPoliciesDocument = gql`
    query BookingPolicies($tenantId: ID!, $propertyId: ID!, $skip: Int!, $limit: Int!) {
  bookingPolicies(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}}
    skip: $skip
    limit: $limit
  ) {
    ...BookingPolicyList
  }
}
    ${BookingPolicyListFragmentDoc}`;

/**
 * __useBookingPoliciesQuery__
 *
 * To run a query within a React component, call `useBookingPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingPoliciesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookingPoliciesQuery(baseOptions: Apollo.QueryHookOptions<BookingPoliciesQuery, BookingPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingPoliciesQuery, BookingPoliciesQueryVariables>(BookingPoliciesDocument, options);
      }
export function useBookingPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingPoliciesQuery, BookingPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingPoliciesQuery, BookingPoliciesQueryVariables>(BookingPoliciesDocument, options);
        }
export type BookingPoliciesQueryHookResult = ReturnType<typeof useBookingPoliciesQuery>;
export type BookingPoliciesLazyQueryHookResult = ReturnType<typeof useBookingPoliciesLazyQuery>;
export type BookingPoliciesQueryResult = Apollo.QueryResult<BookingPoliciesQuery, BookingPoliciesQueryVariables>;
export const BookingPolicyDocument = gql`
    query BookingPolicy($tenantId: ID!, $propertyId: ID!, $bookingPolicyId: ID!) {
  bookingPolicies(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {eq: $bookingPolicyId}}
    skip: 0
    limit: 1
  ) {
    ...BookingPolicyDetail
  }
}
    ${BookingPolicyDetailFragmentDoc}`;

/**
 * __useBookingPolicyQuery__
 *
 * To run a query within a React component, call `useBookingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingPolicyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      bookingPolicyId: // value for 'bookingPolicyId'
 *   },
 * });
 */
export function useBookingPolicyQuery(baseOptions: Apollo.QueryHookOptions<BookingPolicyQuery, BookingPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingPolicyQuery, BookingPolicyQueryVariables>(BookingPolicyDocument, options);
      }
export function useBookingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingPolicyQuery, BookingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingPolicyQuery, BookingPolicyQueryVariables>(BookingPolicyDocument, options);
        }
export type BookingPolicyQueryHookResult = ReturnType<typeof useBookingPolicyQuery>;
export type BookingPolicyLazyQueryHookResult = ReturnType<typeof useBookingPolicyLazyQuery>;
export type BookingPolicyQueryResult = Apollo.QueryResult<BookingPolicyQuery, BookingPolicyQueryVariables>;
export const BookingPolicyNewDocument = gql`
    mutation BookingPolicyNew($input: BookingPolicyInput!) {
  createBookingPolicy(value: $input) {
    ...BookingPolicyDetail
  }
}
    ${BookingPolicyDetailFragmentDoc}`;
export type BookingPolicyNewMutationFn = Apollo.MutationFunction<BookingPolicyNewMutation, BookingPolicyNewMutationVariables>;

/**
 * __useBookingPolicyNewMutation__
 *
 * To run a mutation, you first call `useBookingPolicyNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingPolicyNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingPolicyNewMutation, { data, loading, error }] = useBookingPolicyNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingPolicyNewMutation(baseOptions?: Apollo.MutationHookOptions<BookingPolicyNewMutation, BookingPolicyNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingPolicyNewMutation, BookingPolicyNewMutationVariables>(BookingPolicyNewDocument, options);
      }
export type BookingPolicyNewMutationHookResult = ReturnType<typeof useBookingPolicyNewMutation>;
export type BookingPolicyNewMutationResult = Apollo.MutationResult<BookingPolicyNewMutation>;
export type BookingPolicyNewMutationOptions = Apollo.BaseMutationOptions<BookingPolicyNewMutation, BookingPolicyNewMutationVariables>;
export const BookingPolicyUpdateDocument = gql`
    mutation BookingPolicyUpdate($id: String!, $input: BookingPolicyInput!) {
  updateBookingPolicy(id: $id, value: $input) {
    ...BookingPolicyDetail
  }
}
    ${BookingPolicyDetailFragmentDoc}`;
export type BookingPolicyUpdateMutationFn = Apollo.MutationFunction<BookingPolicyUpdateMutation, BookingPolicyUpdateMutationVariables>;

/**
 * __useBookingPolicyUpdateMutation__
 *
 * To run a mutation, you first call `useBookingPolicyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingPolicyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingPolicyUpdateMutation, { data, loading, error }] = useBookingPolicyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingPolicyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BookingPolicyUpdateMutation, BookingPolicyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingPolicyUpdateMutation, BookingPolicyUpdateMutationVariables>(BookingPolicyUpdateDocument, options);
      }
export type BookingPolicyUpdateMutationHookResult = ReturnType<typeof useBookingPolicyUpdateMutation>;
export type BookingPolicyUpdateMutationResult = Apollo.MutationResult<BookingPolicyUpdateMutation>;
export type BookingPolicyUpdateMutationOptions = Apollo.BaseMutationOptions<BookingPolicyUpdateMutation, BookingPolicyUpdateMutationVariables>;
export const BookingPolicyDeleteDocument = gql`
    mutation BookingPolicyDelete($tenantId: ID!, $id: String!) {
  deleteBookingPolicy(tenantId: $tenantId, id: $id)
}
    `;
export type BookingPolicyDeleteMutationFn = Apollo.MutationFunction<BookingPolicyDeleteMutation, BookingPolicyDeleteMutationVariables>;

/**
 * __useBookingPolicyDeleteMutation__
 *
 * To run a mutation, you first call `useBookingPolicyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingPolicyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingPolicyDeleteMutation, { data, loading, error }] = useBookingPolicyDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingPolicyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BookingPolicyDeleteMutation, BookingPolicyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingPolicyDeleteMutation, BookingPolicyDeleteMutationVariables>(BookingPolicyDeleteDocument, options);
      }
export type BookingPolicyDeleteMutationHookResult = ReturnType<typeof useBookingPolicyDeleteMutation>;
export type BookingPolicyDeleteMutationResult = Apollo.MutationResult<BookingPolicyDeleteMutation>;
export type BookingPolicyDeleteMutationOptions = Apollo.BaseMutationOptions<BookingPolicyDeleteMutation, BookingPolicyDeleteMutationVariables>;
export const CashDeskTypeListDocument = gql`
    query CashDeskTypeList($filter: TenantPropertyIdFilter!) {
  cashDeskTypes(filter: $filter) {
    ...CashDeskTypeList
  }
}
    ${CashDeskTypeListFragmentDoc}`;

/**
 * __useCashDeskTypeListQuery__
 *
 * To run a query within a React component, call `useCashDeskTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDeskTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDeskTypeListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCashDeskTypeListQuery(baseOptions: Apollo.QueryHookOptions<CashDeskTypeListQuery, CashDeskTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDeskTypeListQuery, CashDeskTypeListQueryVariables>(CashDeskTypeListDocument, options);
      }
export function useCashDeskTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDeskTypeListQuery, CashDeskTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDeskTypeListQuery, CashDeskTypeListQueryVariables>(CashDeskTypeListDocument, options);
        }
export type CashDeskTypeListQueryHookResult = ReturnType<typeof useCashDeskTypeListQuery>;
export type CashDeskTypeListLazyQueryHookResult = ReturnType<typeof useCashDeskTypeListLazyQuery>;
export type CashDeskTypeListQueryResult = Apollo.QueryResult<CashDeskTypeListQuery, CashDeskTypeListQueryVariables>;
export const DocumentActivesDocument = gql`
    query DocumentActives($filter: TenantPropertyIdFilter!) {
  documentActives(filter: $filter) {
    ...DocumentActive
  }
}
    ${DocumentActiveFragmentDoc}`;

/**
 * __useDocumentActivesQuery__
 *
 * To run a query within a React component, call `useDocumentActivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentActivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentActivesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDocumentActivesQuery(baseOptions: Apollo.QueryHookOptions<DocumentActivesQuery, DocumentActivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentActivesQuery, DocumentActivesQueryVariables>(DocumentActivesDocument, options);
      }
export function useDocumentActivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentActivesQuery, DocumentActivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentActivesQuery, DocumentActivesQueryVariables>(DocumentActivesDocument, options);
        }
export type DocumentActivesQueryHookResult = ReturnType<typeof useDocumentActivesQuery>;
export type DocumentActivesLazyQueryHookResult = ReturnType<typeof useDocumentActivesLazyQuery>;
export type DocumentActivesQueryResult = Apollo.QueryResult<DocumentActivesQuery, DocumentActivesQueryVariables>;
export const CreateDocumentActiveDocument = gql`
    mutation CreateDocumentActive($value: DocumentActiveInput!) {
  createDocumentActive(value: $value) {
    ...DocumentActive
  }
}
    ${DocumentActiveFragmentDoc}`;
export type CreateDocumentActiveMutationFn = Apollo.MutationFunction<CreateDocumentActiveMutation, CreateDocumentActiveMutationVariables>;

/**
 * __useCreateDocumentActiveMutation__
 *
 * To run a mutation, you first call `useCreateDocumentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentActiveMutation, { data, loading, error }] = useCreateDocumentActiveMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateDocumentActiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentActiveMutation, CreateDocumentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentActiveMutation, CreateDocumentActiveMutationVariables>(CreateDocumentActiveDocument, options);
      }
export type CreateDocumentActiveMutationHookResult = ReturnType<typeof useCreateDocumentActiveMutation>;
export type CreateDocumentActiveMutationResult = Apollo.MutationResult<CreateDocumentActiveMutation>;
export type CreateDocumentActiveMutationOptions = Apollo.BaseMutationOptions<CreateDocumentActiveMutation, CreateDocumentActiveMutationVariables>;
export const UpdateDocumentActiveDocument = gql`
    mutation UpdateDocumentActive($input: DocumentActiveInput!, $id: String!) {
  updateDocumentActive(input: $input, id: $id) {
    ...DocumentActive
  }
}
    ${DocumentActiveFragmentDoc}`;
export type UpdateDocumentActiveMutationFn = Apollo.MutationFunction<UpdateDocumentActiveMutation, UpdateDocumentActiveMutationVariables>;

/**
 * __useUpdateDocumentActiveMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentActiveMutation, { data, loading, error }] = useUpdateDocumentActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDocumentActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentActiveMutation, UpdateDocumentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentActiveMutation, UpdateDocumentActiveMutationVariables>(UpdateDocumentActiveDocument, options);
      }
export type UpdateDocumentActiveMutationHookResult = ReturnType<typeof useUpdateDocumentActiveMutation>;
export type UpdateDocumentActiveMutationResult = Apollo.MutationResult<UpdateDocumentActiveMutation>;
export type UpdateDocumentActiveMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentActiveMutation, UpdateDocumentActiveMutationVariables>;
export const DeleteDocumentActiveDocument = gql`
    mutation DeleteDocumentActive($tenantId: ID!, $deleteDocumentActiveId: String!) {
  deleteDocumentActive(tenantId: $tenantId, id: $deleteDocumentActiveId)
}
    `;
export type DeleteDocumentActiveMutationFn = Apollo.MutationFunction<DeleteDocumentActiveMutation, DeleteDocumentActiveMutationVariables>;

/**
 * __useDeleteDocumentActiveMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentActiveMutation, { data, loading, error }] = useDeleteDocumentActiveMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteDocumentActiveId: // value for 'deleteDocumentActiveId'
 *   },
 * });
 */
export function useDeleteDocumentActiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentActiveMutation, DeleteDocumentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentActiveMutation, DeleteDocumentActiveMutationVariables>(DeleteDocumentActiveDocument, options);
      }
export type DeleteDocumentActiveMutationHookResult = ReturnType<typeof useDeleteDocumentActiveMutation>;
export type DeleteDocumentActiveMutationResult = Apollo.MutationResult<DeleteDocumentActiveMutation>;
export type DeleteDocumentActiveMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentActiveMutation, DeleteDocumentActiveMutationVariables>;
export const CreateCashDeskTypeDocument = gql`
    mutation CreateCashDeskType($value: CashDeskTypeInput!) {
  createCashDeskType(value: $value) {
    ...CashDeskTypeList
  }
}
    ${CashDeskTypeListFragmentDoc}`;
export type CreateCashDeskTypeMutationFn = Apollo.MutationFunction<CreateCashDeskTypeMutation, CreateCashDeskTypeMutationVariables>;

/**
 * __useCreateCashDeskTypeMutation__
 *
 * To run a mutation, you first call `useCreateCashDeskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashDeskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashDeskTypeMutation, { data, loading, error }] = useCreateCashDeskTypeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateCashDeskTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashDeskTypeMutation, CreateCashDeskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashDeskTypeMutation, CreateCashDeskTypeMutationVariables>(CreateCashDeskTypeDocument, options);
      }
export type CreateCashDeskTypeMutationHookResult = ReturnType<typeof useCreateCashDeskTypeMutation>;
export type CreateCashDeskTypeMutationResult = Apollo.MutationResult<CreateCashDeskTypeMutation>;
export type CreateCashDeskTypeMutationOptions = Apollo.BaseMutationOptions<CreateCashDeskTypeMutation, CreateCashDeskTypeMutationVariables>;
export const UpdateCashDeskTypeDocument = gql`
    mutation UpdateCashDeskType($input: CashDeskTypeInput!, $id: String!) {
  updateCashDeskType(input: $input, id: $id) {
    ...CashDeskTypeList
  }
}
    ${CashDeskTypeListFragmentDoc}`;
export type UpdateCashDeskTypeMutationFn = Apollo.MutationFunction<UpdateCashDeskTypeMutation, UpdateCashDeskTypeMutationVariables>;

/**
 * __useUpdateCashDeskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCashDeskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashDeskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashDeskTypeMutation, { data, loading, error }] = useUpdateCashDeskTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCashDeskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashDeskTypeMutation, UpdateCashDeskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCashDeskTypeMutation, UpdateCashDeskTypeMutationVariables>(UpdateCashDeskTypeDocument, options);
      }
export type UpdateCashDeskTypeMutationHookResult = ReturnType<typeof useUpdateCashDeskTypeMutation>;
export type UpdateCashDeskTypeMutationResult = Apollo.MutationResult<UpdateCashDeskTypeMutation>;
export type UpdateCashDeskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCashDeskTypeMutation, UpdateCashDeskTypeMutationVariables>;
export const AddCassaInCloudApiKeyDocument = gql`
    mutation AddCassaInCloudApiKey($value: CassaInCloudApiKeyInput!) {
  addCassaInCloudApiKey(value: $value) {
    ...CicConfigurationApiKey
  }
}
    ${CicConfigurationApiKeyFragmentDoc}`;
export type AddCassaInCloudApiKeyMutationFn = Apollo.MutationFunction<AddCassaInCloudApiKeyMutation, AddCassaInCloudApiKeyMutationVariables>;

/**
 * __useAddCassaInCloudApiKeyMutation__
 *
 * To run a mutation, you first call `useAddCassaInCloudApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCassaInCloudApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCassaInCloudApiKeyMutation, { data, loading, error }] = useAddCassaInCloudApiKeyMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAddCassaInCloudApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddCassaInCloudApiKeyMutation, AddCassaInCloudApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCassaInCloudApiKeyMutation, AddCassaInCloudApiKeyMutationVariables>(AddCassaInCloudApiKeyDocument, options);
      }
export type AddCassaInCloudApiKeyMutationHookResult = ReturnType<typeof useAddCassaInCloudApiKeyMutation>;
export type AddCassaInCloudApiKeyMutationResult = Apollo.MutationResult<AddCassaInCloudApiKeyMutation>;
export type AddCassaInCloudApiKeyMutationOptions = Apollo.BaseMutationOptions<AddCassaInCloudApiKeyMutation, AddCassaInCloudApiKeyMutationVariables>;
export const UpdateCassaInCloudApiKeyDocument = gql`
    mutation UpdateCassaInCloudApiKey($value: CassaInCloudApiKeyInput!) {
  updateCassaInCloudApiKey(value: $value)
}
    `;
export type UpdateCassaInCloudApiKeyMutationFn = Apollo.MutationFunction<UpdateCassaInCloudApiKeyMutation, UpdateCassaInCloudApiKeyMutationVariables>;

/**
 * __useUpdateCassaInCloudApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateCassaInCloudApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCassaInCloudApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCassaInCloudApiKeyMutation, { data, loading, error }] = useUpdateCassaInCloudApiKeyMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateCassaInCloudApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCassaInCloudApiKeyMutation, UpdateCassaInCloudApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCassaInCloudApiKeyMutation, UpdateCassaInCloudApiKeyMutationVariables>(UpdateCassaInCloudApiKeyDocument, options);
      }
export type UpdateCassaInCloudApiKeyMutationHookResult = ReturnType<typeof useUpdateCassaInCloudApiKeyMutation>;
export type UpdateCassaInCloudApiKeyMutationResult = Apollo.MutationResult<UpdateCassaInCloudApiKeyMutation>;
export type UpdateCassaInCloudApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateCassaInCloudApiKeyMutation, UpdateCassaInCloudApiKeyMutationVariables>;
export const RemoveCassaInCloudApiKeyDocument = gql`
    mutation RemoveCassaInCloudApiKey($tenantId: ID!, $apiKey: String!) {
  removeCassaInCloudApiKey(tenantId: $tenantId, apiKey: $apiKey)
}
    `;
export type RemoveCassaInCloudApiKeyMutationFn = Apollo.MutationFunction<RemoveCassaInCloudApiKeyMutation, RemoveCassaInCloudApiKeyMutationVariables>;

/**
 * __useRemoveCassaInCloudApiKeyMutation__
 *
 * To run a mutation, you first call `useRemoveCassaInCloudApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCassaInCloudApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCassaInCloudApiKeyMutation, { data, loading, error }] = useRemoveCassaInCloudApiKeyMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useRemoveCassaInCloudApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCassaInCloudApiKeyMutation, RemoveCassaInCloudApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCassaInCloudApiKeyMutation, RemoveCassaInCloudApiKeyMutationVariables>(RemoveCassaInCloudApiKeyDocument, options);
      }
export type RemoveCassaInCloudApiKeyMutationHookResult = ReturnType<typeof useRemoveCassaInCloudApiKeyMutation>;
export type RemoveCassaInCloudApiKeyMutationResult = Apollo.MutationResult<RemoveCassaInCloudApiKeyMutation>;
export type RemoveCassaInCloudApiKeyMutationOptions = Apollo.BaseMutationOptions<RemoveCassaInCloudApiKeyMutation, RemoveCassaInCloudApiKeyMutationVariables>;
export const CassaInCloudConfigurationDocument = gql`
    query CassaInCloudConfiguration($filter: TenantQueryFilter) {
  tenants(filter: $filter) {
    cassaInCloudConfiguration {
      ...CicConfiguration
    }
  }
}
    ${CicConfigurationFragmentDoc}`;

/**
 * __useCassaInCloudConfigurationQuery__
 *
 * To run a query within a React component, call `useCassaInCloudConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCassaInCloudConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCassaInCloudConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCassaInCloudConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<CassaInCloudConfigurationQuery, CassaInCloudConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CassaInCloudConfigurationQuery, CassaInCloudConfigurationQueryVariables>(CassaInCloudConfigurationDocument, options);
      }
export function useCassaInCloudConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CassaInCloudConfigurationQuery, CassaInCloudConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CassaInCloudConfigurationQuery, CassaInCloudConfigurationQueryVariables>(CassaInCloudConfigurationDocument, options);
        }
export type CassaInCloudConfigurationQueryHookResult = ReturnType<typeof useCassaInCloudConfigurationQuery>;
export type CassaInCloudConfigurationLazyQueryHookResult = ReturnType<typeof useCassaInCloudConfigurationLazyQuery>;
export type CassaInCloudConfigurationQueryResult = Apollo.QueryResult<CassaInCloudConfigurationQuery, CassaInCloudConfigurationQueryVariables>;
export const CheckCassaInCloudApiKeyDocument = gql`
    query CheckCassaInCloudApiKey($apiKey: String!) {
  checkCassaInCloudApiKey(apiKey: $apiKey)
}
    `;

/**
 * __useCheckCassaInCloudApiKeyQuery__
 *
 * To run a query within a React component, call `useCheckCassaInCloudApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCassaInCloudApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCassaInCloudApiKeyQuery({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useCheckCassaInCloudApiKeyQuery(baseOptions: Apollo.QueryHookOptions<CheckCassaInCloudApiKeyQuery, CheckCassaInCloudApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCassaInCloudApiKeyQuery, CheckCassaInCloudApiKeyQueryVariables>(CheckCassaInCloudApiKeyDocument, options);
      }
export function useCheckCassaInCloudApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCassaInCloudApiKeyQuery, CheckCassaInCloudApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCassaInCloudApiKeyQuery, CheckCassaInCloudApiKeyQueryVariables>(CheckCassaInCloudApiKeyDocument, options);
        }
export type CheckCassaInCloudApiKeyQueryHookResult = ReturnType<typeof useCheckCassaInCloudApiKeyQuery>;
export type CheckCassaInCloudApiKeyLazyQueryHookResult = ReturnType<typeof useCheckCassaInCloudApiKeyLazyQuery>;
export type CheckCassaInCloudApiKeyQueryResult = Apollo.QueryResult<CheckCassaInCloudApiKeyQuery, CheckCassaInCloudApiKeyQueryVariables>;
export const GetCassaInCloudSalesPointsDocument = gql`
    query GetCassaInCloudSalesPoints($apiKey: String!) {
  getCassaInCloudSalesPoints(apiKey: $apiKey) {
    ...CassaInCloudSalesPoint
  }
}
    ${CassaInCloudSalesPointFragmentDoc}`;

/**
 * __useGetCassaInCloudSalesPointsQuery__
 *
 * To run a query within a React component, call `useGetCassaInCloudSalesPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCassaInCloudSalesPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCassaInCloudSalesPointsQuery({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useGetCassaInCloudSalesPointsQuery(baseOptions: Apollo.QueryHookOptions<GetCassaInCloudSalesPointsQuery, GetCassaInCloudSalesPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCassaInCloudSalesPointsQuery, GetCassaInCloudSalesPointsQueryVariables>(GetCassaInCloudSalesPointsDocument, options);
      }
export function useGetCassaInCloudSalesPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCassaInCloudSalesPointsQuery, GetCassaInCloudSalesPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCassaInCloudSalesPointsQuery, GetCassaInCloudSalesPointsQueryVariables>(GetCassaInCloudSalesPointsDocument, options);
        }
export type GetCassaInCloudSalesPointsQueryHookResult = ReturnType<typeof useGetCassaInCloudSalesPointsQuery>;
export type GetCassaInCloudSalesPointsLazyQueryHookResult = ReturnType<typeof useGetCassaInCloudSalesPointsLazyQuery>;
export type GetCassaInCloudSalesPointsQueryResult = Apollo.QueryResult<GetCassaInCloudSalesPointsQuery, GetCassaInCloudSalesPointsQueryVariables>;
export const ActivatePointOfSalesDocument = gql`
    mutation ActivatePointOfSales($input: ActivatePointOfSalesInput!) {
  activatePointOfSales(input: $input)
}
    `;
export type ActivatePointOfSalesMutationFn = Apollo.MutationFunction<ActivatePointOfSalesMutation, ActivatePointOfSalesMutationVariables>;

/**
 * __useActivatePointOfSalesMutation__
 *
 * To run a mutation, you first call `useActivatePointOfSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePointOfSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePointOfSalesMutation, { data, loading, error }] = useActivatePointOfSalesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivatePointOfSalesMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePointOfSalesMutation, ActivatePointOfSalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePointOfSalesMutation, ActivatePointOfSalesMutationVariables>(ActivatePointOfSalesDocument, options);
      }
export type ActivatePointOfSalesMutationHookResult = ReturnType<typeof useActivatePointOfSalesMutation>;
export type ActivatePointOfSalesMutationResult = Apollo.MutationResult<ActivatePointOfSalesMutation>;
export type ActivatePointOfSalesMutationOptions = Apollo.BaseMutationOptions<ActivatePointOfSalesMutation, ActivatePointOfSalesMutationVariables>;
export const PointOfSaleMealShiftsDocument = gql`
    query PointOfSaleMealShifts($filter: PointOfSaleMealShiftQueryFilter!) {
  pointOfSaleMealShifts(filter: $filter) {
    ...PointOfSaleMealShift
  }
}
    ${PointOfSaleMealShiftFragmentDoc}`;

/**
 * __usePointOfSaleMealShiftsQuery__
 *
 * To run a query within a React component, call `usePointOfSaleMealShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleMealShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfSaleMealShiftsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePointOfSaleMealShiftsQuery(baseOptions: Apollo.QueryHookOptions<PointOfSaleMealShiftsQuery, PointOfSaleMealShiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfSaleMealShiftsQuery, PointOfSaleMealShiftsQueryVariables>(PointOfSaleMealShiftsDocument, options);
      }
export function usePointOfSaleMealShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfSaleMealShiftsQuery, PointOfSaleMealShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfSaleMealShiftsQuery, PointOfSaleMealShiftsQueryVariables>(PointOfSaleMealShiftsDocument, options);
        }
export type PointOfSaleMealShiftsQueryHookResult = ReturnType<typeof usePointOfSaleMealShiftsQuery>;
export type PointOfSaleMealShiftsLazyQueryHookResult = ReturnType<typeof usePointOfSaleMealShiftsLazyQuery>;
export type PointOfSaleMealShiftsQueryResult = Apollo.QueryResult<PointOfSaleMealShiftsQuery, PointOfSaleMealShiftsQueryVariables>;
export const GetCassaInCloudDepartmentsDocument = gql`
    query GetCassaInCloudDepartments($filter: CassaInCloudDepartmentsQueryFilter!) {
  getCassaInCloudDepartments(filter: $filter) {
    ...CassaInCloudDepartment
  }
}
    ${CassaInCloudDepartmentFragmentDoc}`;

/**
 * __useGetCassaInCloudDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCassaInCloudDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCassaInCloudDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCassaInCloudDepartmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCassaInCloudDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCassaInCloudDepartmentsQuery, GetCassaInCloudDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCassaInCloudDepartmentsQuery, GetCassaInCloudDepartmentsQueryVariables>(GetCassaInCloudDepartmentsDocument, options);
      }
export function useGetCassaInCloudDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCassaInCloudDepartmentsQuery, GetCassaInCloudDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCassaInCloudDepartmentsQuery, GetCassaInCloudDepartmentsQueryVariables>(GetCassaInCloudDepartmentsDocument, options);
        }
export type GetCassaInCloudDepartmentsQueryHookResult = ReturnType<typeof useGetCassaInCloudDepartmentsQuery>;
export type GetCassaInCloudDepartmentsLazyQueryHookResult = ReturnType<typeof useGetCassaInCloudDepartmentsLazyQuery>;
export type GetCassaInCloudDepartmentsQueryResult = Apollo.QueryResult<GetCassaInCloudDepartmentsQuery, GetCassaInCloudDepartmentsQueryVariables>;
export const GetCassaInCloudSalesModesDocument = gql`
    query GetCassaInCloudSalesModes($filter: CassaInCloudSalesModesQueryFilter!) {
  getCassaInCloudSalesModes(filter: $filter) {
    ...CassaInCloudSalesMode
  }
}
    ${CassaInCloudSalesModeFragmentDoc}`;

/**
 * __useGetCassaInCloudSalesModesQuery__
 *
 * To run a query within a React component, call `useGetCassaInCloudSalesModesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCassaInCloudSalesModesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCassaInCloudSalesModesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCassaInCloudSalesModesQuery(baseOptions: Apollo.QueryHookOptions<GetCassaInCloudSalesModesQuery, GetCassaInCloudSalesModesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCassaInCloudSalesModesQuery, GetCassaInCloudSalesModesQueryVariables>(GetCassaInCloudSalesModesDocument, options);
      }
export function useGetCassaInCloudSalesModesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCassaInCloudSalesModesQuery, GetCassaInCloudSalesModesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCassaInCloudSalesModesQuery, GetCassaInCloudSalesModesQueryVariables>(GetCassaInCloudSalesModesDocument, options);
        }
export type GetCassaInCloudSalesModesQueryHookResult = ReturnType<typeof useGetCassaInCloudSalesModesQuery>;
export type GetCassaInCloudSalesModesLazyQueryHookResult = ReturnType<typeof useGetCassaInCloudSalesModesLazyQuery>;
export type GetCassaInCloudSalesModesQueryResult = Apollo.QueryResult<GetCassaInCloudSalesModesQuery, GetCassaInCloudSalesModesQueryVariables>;
export const UpdatePointOfSaleDocument = gql`
    mutation UpdatePointOfSale($updatePointOfSaleId: String!, $value: PointOfSaleInput!) {
  updatePointOfSale(id: $updatePointOfSaleId, value: $value)
}
    `;
export type UpdatePointOfSaleMutationFn = Apollo.MutationFunction<UpdatePointOfSaleMutation, UpdatePointOfSaleMutationVariables>;

/**
 * __useUpdatePointOfSaleMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfSaleMutation, { data, loading, error }] = useUpdatePointOfSaleMutation({
 *   variables: {
 *      updatePointOfSaleId: // value for 'updatePointOfSaleId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePointOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfSaleMutation, UpdatePointOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfSaleMutation, UpdatePointOfSaleMutationVariables>(UpdatePointOfSaleDocument, options);
      }
export type UpdatePointOfSaleMutationHookResult = ReturnType<typeof useUpdatePointOfSaleMutation>;
export type UpdatePointOfSaleMutationResult = Apollo.MutationResult<UpdatePointOfSaleMutation>;
export type UpdatePointOfSaleMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfSaleMutation, UpdatePointOfSaleMutationVariables>;
export const GenerateCiCTenantSecretDocument = gql`
    mutation GenerateCiCTenantSecret($tenantId: ID!) {
  generateTenantSecret(tenantId: $tenantId)
}
    `;
export type GenerateCiCTenantSecretMutationFn = Apollo.MutationFunction<GenerateCiCTenantSecretMutation, GenerateCiCTenantSecretMutationVariables>;

/**
 * __useGenerateCiCTenantSecretMutation__
 *
 * To run a mutation, you first call `useGenerateCiCTenantSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCiCTenantSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCiCTenantSecretMutation, { data, loading, error }] = useGenerateCiCTenantSecretMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGenerateCiCTenantSecretMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCiCTenantSecretMutation, GenerateCiCTenantSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCiCTenantSecretMutation, GenerateCiCTenantSecretMutationVariables>(GenerateCiCTenantSecretDocument, options);
      }
export type GenerateCiCTenantSecretMutationHookResult = ReturnType<typeof useGenerateCiCTenantSecretMutation>;
export type GenerateCiCTenantSecretMutationResult = Apollo.MutationResult<GenerateCiCTenantSecretMutation>;
export type GenerateCiCTenantSecretMutationOptions = Apollo.BaseMutationOptions<GenerateCiCTenantSecretMutation, GenerateCiCTenantSecretMutationVariables>;
export const ChannelsDocument = gql`
    query Channels($filter: ChannelQueryFilter!) {
  channels(filter: $filter) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;

/**
 * __useChannelsQuery__
 *
 * To run a query within a React component, call `useChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChannelsQuery(baseOptions: Apollo.QueryHookOptions<ChannelsQuery, ChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelsQuery, ChannelsQueryVariables>(ChannelsDocument, options);
      }
export function useChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelsQuery, ChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelsQuery, ChannelsQueryVariables>(ChannelsDocument, options);
        }
export type ChannelsQueryHookResult = ReturnType<typeof useChannelsQuery>;
export type ChannelsLazyQueryHookResult = ReturnType<typeof useChannelsLazyQuery>;
export type ChannelsQueryResult = Apollo.QueryResult<ChannelsQuery, ChannelsQueryVariables>;
export const CreateChannelDocument = gql`
    mutation CreateChannel($value: ChannelInput!) {
  createChannel(value: $value) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const UpdateChannelDocument = gql`
    mutation UpdateChannel($id: String!, $input: ChannelInput!) {
  updateChannel(id: $id, value: $input) {
    ...Channel
  }
}
    ${ChannelFragmentDoc}`;
export type UpdateChannelMutationFn = Apollo.MutationFunction<UpdateChannelMutation, UpdateChannelMutationVariables>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelMutation, UpdateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument, options);
      }
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<UpdateChannelMutation, UpdateChannelMutationVariables>;
export const ChannelDetailsDocument = gql`
    query ChannelDetails($tenantId: ID!, $channelDetailsId: IDFilter!) {
  channelDetails(tenantId: $tenantId, id: $channelDetailsId) {
    ...ChannelDetails
  }
}
    ${ChannelDetailsFragmentDoc}`;

/**
 * __useChannelDetailsQuery__
 *
 * To run a query within a React component, call `useChannelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      channelDetailsId: // value for 'channelDetailsId'
 *   },
 * });
 */
export function useChannelDetailsQuery(baseOptions: Apollo.QueryHookOptions<ChannelDetailsQuery, ChannelDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelDetailsQuery, ChannelDetailsQueryVariables>(ChannelDetailsDocument, options);
      }
export function useChannelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelDetailsQuery, ChannelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelDetailsQuery, ChannelDetailsQueryVariables>(ChannelDetailsDocument, options);
        }
export type ChannelDetailsQueryHookResult = ReturnType<typeof useChannelDetailsQuery>;
export type ChannelDetailsLazyQueryHookResult = ReturnType<typeof useChannelDetailsLazyQuery>;
export type ChannelDetailsQueryResult = Apollo.QueryResult<ChannelDetailsQuery, ChannelDetailsQueryVariables>;
export const DeleteChannelDocument = gql`
    mutation DeleteChannel($tenantId: ID!, $deleteChannelId: String!) {
  deleteChannel(tenantId: $tenantId, id: $deleteChannelId)
}
    `;
export type DeleteChannelMutationFn = Apollo.MutationFunction<DeleteChannelMutation, DeleteChannelMutationVariables>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteChannelId: // value for 'deleteChannelId'
 *   },
 * });
 */
export function useDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelMutation, DeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument, options);
      }
export type DeleteChannelMutationHookResult = ReturnType<typeof useDeleteChannelMutation>;
export type DeleteChannelMutationResult = Apollo.MutationResult<DeleteChannelMutation>;
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const RetrieveFutureReservationsDocument = gql`
    mutation RetrieveFutureReservations($portalName: PortalName!, $tenantId: ID!, $channelId: ID!) {
  retrieveFutureReservations(
    portalName: $portalName
    tenantId: $tenantId
    channelId: $channelId
  )
}
    `;
export type RetrieveFutureReservationsMutationFn = Apollo.MutationFunction<RetrieveFutureReservationsMutation, RetrieveFutureReservationsMutationVariables>;

/**
 * __useRetrieveFutureReservationsMutation__
 *
 * To run a mutation, you first call `useRetrieveFutureReservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveFutureReservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveFutureReservationsMutation, { data, loading, error }] = useRetrieveFutureReservationsMutation({
 *   variables: {
 *      portalName: // value for 'portalName'
 *      tenantId: // value for 'tenantId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useRetrieveFutureReservationsMutation(baseOptions?: Apollo.MutationHookOptions<RetrieveFutureReservationsMutation, RetrieveFutureReservationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrieveFutureReservationsMutation, RetrieveFutureReservationsMutationVariables>(RetrieveFutureReservationsDocument, options);
      }
export type RetrieveFutureReservationsMutationHookResult = ReturnType<typeof useRetrieveFutureReservationsMutation>;
export type RetrieveFutureReservationsMutationResult = Apollo.MutationResult<RetrieveFutureReservationsMutation>;
export type RetrieveFutureReservationsMutationOptions = Apollo.BaseMutationOptions<RetrieveFutureReservationsMutation, RetrieveFutureReservationsMutationVariables>;
export const ChannelCommunicationResultsDocument = gql`
    query ChannelCommunicationResults($filter: ChannelCommunicationFilter!, $skip: Int, $limit: Int) {
  channelCommunicationResults(filter: $filter, skip: $skip, limit: $limit) {
    ...ChannelCommunicationResult
  }
}
    ${ChannelCommunicationResultFragmentDoc}`;

/**
 * __useChannelCommunicationResultsQuery__
 *
 * To run a query within a React component, call `useChannelCommunicationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelCommunicationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelCommunicationResultsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelCommunicationResultsQuery(baseOptions: Apollo.QueryHookOptions<ChannelCommunicationResultsQuery, ChannelCommunicationResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelCommunicationResultsQuery, ChannelCommunicationResultsQueryVariables>(ChannelCommunicationResultsDocument, options);
      }
export function useChannelCommunicationResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelCommunicationResultsQuery, ChannelCommunicationResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelCommunicationResultsQuery, ChannelCommunicationResultsQueryVariables>(ChannelCommunicationResultsDocument, options);
        }
export type ChannelCommunicationResultsQueryHookResult = ReturnType<typeof useChannelCommunicationResultsQuery>;
export type ChannelCommunicationResultsLazyQueryHookResult = ReturnType<typeof useChannelCommunicationResultsLazyQuery>;
export type ChannelCommunicationResultsQueryResult = Apollo.QueryResult<ChannelCommunicationResultsQuery, ChannelCommunicationResultsQueryVariables>;
export const SendAvailabilitiesAndPricesDocument = gql`
    mutation SendAvailabilitiesAndPrices($input: SendAvailabilitiesAndPricesInput!) {
  sendAvailabilitiesAndPrices(input: $input)
}
    `;
export type SendAvailabilitiesAndPricesMutationFn = Apollo.MutationFunction<SendAvailabilitiesAndPricesMutation, SendAvailabilitiesAndPricesMutationVariables>;

/**
 * __useSendAvailabilitiesAndPricesMutation__
 *
 * To run a mutation, you first call `useSendAvailabilitiesAndPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAvailabilitiesAndPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAvailabilitiesAndPricesMutation, { data, loading, error }] = useSendAvailabilitiesAndPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAvailabilitiesAndPricesMutation(baseOptions?: Apollo.MutationHookOptions<SendAvailabilitiesAndPricesMutation, SendAvailabilitiesAndPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAvailabilitiesAndPricesMutation, SendAvailabilitiesAndPricesMutationVariables>(SendAvailabilitiesAndPricesDocument, options);
      }
export type SendAvailabilitiesAndPricesMutationHookResult = ReturnType<typeof useSendAvailabilitiesAndPricesMutation>;
export type SendAvailabilitiesAndPricesMutationResult = Apollo.MutationResult<SendAvailabilitiesAndPricesMutation>;
export type SendAvailabilitiesAndPricesMutationOptions = Apollo.BaseMutationOptions<SendAvailabilitiesAndPricesMutation, SendAvailabilitiesAndPricesMutationVariables>;
export const RetrieveReservationsDocument = gql`
    mutation RetrieveReservations($portalName: PortalName!, $tenantId: ID!, $channelId: ID!, $voucher: String, $lastUpdate: DateTime) {
  retrieveReservation(
    portalName: $portalName
    tenantId: $tenantId
    channelId: $channelId
    voucher: $voucher
    lastUpdate: $lastUpdate
  )
}
    `;
export type RetrieveReservationsMutationFn = Apollo.MutationFunction<RetrieveReservationsMutation, RetrieveReservationsMutationVariables>;

/**
 * __useRetrieveReservationsMutation__
 *
 * To run a mutation, you first call `useRetrieveReservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveReservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveReservationsMutation, { data, loading, error }] = useRetrieveReservationsMutation({
 *   variables: {
 *      portalName: // value for 'portalName'
 *      tenantId: // value for 'tenantId'
 *      channelId: // value for 'channelId'
 *      voucher: // value for 'voucher'
 *      lastUpdate: // value for 'lastUpdate'
 *   },
 * });
 */
export function useRetrieveReservationsMutation(baseOptions?: Apollo.MutationHookOptions<RetrieveReservationsMutation, RetrieveReservationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrieveReservationsMutation, RetrieveReservationsMutationVariables>(RetrieveReservationsDocument, options);
      }
export type RetrieveReservationsMutationHookResult = ReturnType<typeof useRetrieveReservationsMutation>;
export type RetrieveReservationsMutationResult = Apollo.MutationResult<RetrieveReservationsMutation>;
export type RetrieveReservationsMutationOptions = Apollo.BaseMutationOptions<RetrieveReservationsMutation, RetrieveReservationsMutationVariables>;
export const PortalDocument = gql`
    query Portal {
  portals {
    ...PortalQueryResult
  }
}
    ${PortalQueryResultFragmentDoc}`;

/**
 * __usePortalQuery__
 *
 * To run a query within a React component, call `usePortalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalQuery(baseOptions?: Apollo.QueryHookOptions<PortalQuery, PortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalQuery, PortalQueryVariables>(PortalDocument, options);
      }
export function usePortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalQuery, PortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalQuery, PortalQueryVariables>(PortalDocument, options);
        }
export type PortalQueryHookResult = ReturnType<typeof usePortalQuery>;
export type PortalLazyQueryHookResult = ReturnType<typeof usePortalLazyQuery>;
export type PortalQueryResult = Apollo.QueryResult<PortalQuery, PortalQueryVariables>;
export const ChargeCategoriesDocument = gql`
    query ChargeCategories($filter: ChargeCategoryQueryFilter!) {
  chargeCategories(filter: $filter) {
    ...ChargeCategory
  }
}
    ${ChargeCategoryFragmentDoc}`;

/**
 * __useChargeCategoriesQuery__
 *
 * To run a query within a React component, call `useChargeCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChargeCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ChargeCategoriesQuery, ChargeCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeCategoriesQuery, ChargeCategoriesQueryVariables>(ChargeCategoriesDocument, options);
      }
export function useChargeCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeCategoriesQuery, ChargeCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeCategoriesQuery, ChargeCategoriesQueryVariables>(ChargeCategoriesDocument, options);
        }
export type ChargeCategoriesQueryHookResult = ReturnType<typeof useChargeCategoriesQuery>;
export type ChargeCategoriesLazyQueryHookResult = ReturnType<typeof useChargeCategoriesLazyQuery>;
export type ChargeCategoriesQueryResult = Apollo.QueryResult<ChargeCategoriesQuery, ChargeCategoriesQueryVariables>;
export const CreateChargeCategoryDocument = gql`
    mutation CreateChargeCategory($value: ChargeCategoryInput!) {
  createChargeCategory(value: $value) {
    ...ChargeCategory
  }
}
    ${ChargeCategoryFragmentDoc}`;
export type CreateChargeCategoryMutationFn = Apollo.MutationFunction<CreateChargeCategoryMutation, CreateChargeCategoryMutationVariables>;

/**
 * __useCreateChargeCategoryMutation__
 *
 * To run a mutation, you first call `useCreateChargeCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargeCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargeCategoryMutation, { data, loading, error }] = useCreateChargeCategoryMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateChargeCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateChargeCategoryMutation, CreateChargeCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChargeCategoryMutation, CreateChargeCategoryMutationVariables>(CreateChargeCategoryDocument, options);
      }
export type CreateChargeCategoryMutationHookResult = ReturnType<typeof useCreateChargeCategoryMutation>;
export type CreateChargeCategoryMutationResult = Apollo.MutationResult<CreateChargeCategoryMutation>;
export type CreateChargeCategoryMutationOptions = Apollo.BaseMutationOptions<CreateChargeCategoryMutation, CreateChargeCategoryMutationVariables>;
export const DeleteChargeCategoryDocument = gql`
    mutation DeleteChargeCategory($tenantId: ID!, $deleteChargeCategoryId: String!) {
  deleteChargeCategory(tenantId: $tenantId, id: $deleteChargeCategoryId)
}
    `;
export type DeleteChargeCategoryMutationFn = Apollo.MutationFunction<DeleteChargeCategoryMutation, DeleteChargeCategoryMutationVariables>;

/**
 * __useDeleteChargeCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteChargeCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChargeCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChargeCategoryMutation, { data, loading, error }] = useDeleteChargeCategoryMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteChargeCategoryId: // value for 'deleteChargeCategoryId'
 *   },
 * });
 */
export function useDeleteChargeCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChargeCategoryMutation, DeleteChargeCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChargeCategoryMutation, DeleteChargeCategoryMutationVariables>(DeleteChargeCategoryDocument, options);
      }
export type DeleteChargeCategoryMutationHookResult = ReturnType<typeof useDeleteChargeCategoryMutation>;
export type DeleteChargeCategoryMutationResult = Apollo.MutationResult<DeleteChargeCategoryMutation>;
export type DeleteChargeCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteChargeCategoryMutation, DeleteChargeCategoryMutationVariables>;
export const EditChargeCategoryDocument = gql`
    mutation EditChargeCategory($value: ChargeCategoryInput!, $updateChargeCategoryId: String!) {
  updateChargeCategory(value: $value, id: $updateChargeCategoryId) {
    ...ChargeCategory
  }
}
    ${ChargeCategoryFragmentDoc}`;
export type EditChargeCategoryMutationFn = Apollo.MutationFunction<EditChargeCategoryMutation, EditChargeCategoryMutationVariables>;

/**
 * __useEditChargeCategoryMutation__
 *
 * To run a mutation, you first call `useEditChargeCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChargeCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChargeCategoryMutation, { data, loading, error }] = useEditChargeCategoryMutation({
 *   variables: {
 *      value: // value for 'value'
 *      updateChargeCategoryId: // value for 'updateChargeCategoryId'
 *   },
 * });
 */
export function useEditChargeCategoryMutation(baseOptions?: Apollo.MutationHookOptions<EditChargeCategoryMutation, EditChargeCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChargeCategoryMutation, EditChargeCategoryMutationVariables>(EditChargeCategoryDocument, options);
      }
export type EditChargeCategoryMutationHookResult = ReturnType<typeof useEditChargeCategoryMutation>;
export type EditChargeCategoryMutationResult = Apollo.MutationResult<EditChargeCategoryMutation>;
export type EditChargeCategoryMutationOptions = Apollo.BaseMutationOptions<EditChargeCategoryMutation, EditChargeCategoryMutationVariables>;
export const ChildrenDocument = gql`
    query Children($filter: ChildQueryFilter!) {
  children(filter: $filter) {
    ...Child
  }
}
    ${ChildFragmentDoc}`;

/**
 * __useChildrenQuery__
 *
 * To run a query within a React component, call `useChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildrenQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChildrenQuery(baseOptions: Apollo.QueryHookOptions<ChildrenQuery, ChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildrenQuery, ChildrenQueryVariables>(ChildrenDocument, options);
      }
export function useChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildrenQuery, ChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildrenQuery, ChildrenQueryVariables>(ChildrenDocument, options);
        }
export type ChildrenQueryHookResult = ReturnType<typeof useChildrenQuery>;
export type ChildrenLazyQueryHookResult = ReturnType<typeof useChildrenLazyQuery>;
export type ChildrenQueryResult = Apollo.QueryResult<ChildrenQuery, ChildrenQueryVariables>;
export const SetPropertyCityTaxConfigurationDocument = gql`
    mutation SetPropertyCityTaxConfiguration($setPropertyCityTaxConfigurationId: ID!, $config: [CityTaxConfigurationInput!]!, $tenantId: ID!) {
  setPropertyCityTaxConfiguration(
    id: $setPropertyCityTaxConfigurationId
    config: $config
    tenantId: $tenantId
  )
}
    `;
export type SetPropertyCityTaxConfigurationMutationFn = Apollo.MutationFunction<SetPropertyCityTaxConfigurationMutation, SetPropertyCityTaxConfigurationMutationVariables>;

/**
 * __useSetPropertyCityTaxConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertyCityTaxConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyCityTaxConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyCityTaxConfigurationMutation, { data, loading, error }] = useSetPropertyCityTaxConfigurationMutation({
 *   variables: {
 *      setPropertyCityTaxConfigurationId: // value for 'setPropertyCityTaxConfigurationId'
 *      config: // value for 'config'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetPropertyCityTaxConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyCityTaxConfigurationMutation, SetPropertyCityTaxConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyCityTaxConfigurationMutation, SetPropertyCityTaxConfigurationMutationVariables>(SetPropertyCityTaxConfigurationDocument, options);
      }
export type SetPropertyCityTaxConfigurationMutationHookResult = ReturnType<typeof useSetPropertyCityTaxConfigurationMutation>;
export type SetPropertyCityTaxConfigurationMutationResult = Apollo.MutationResult<SetPropertyCityTaxConfigurationMutation>;
export type SetPropertyCityTaxConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertyCityTaxConfigurationMutation, SetPropertyCityTaxConfigurationMutationVariables>;
export const CityTaxConfigurationDocument = gql`
    query CityTaxConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    cityTaxConfiguration {
      configurations {
        ...CityTaxConfiguration
      }
    }
  }
}
    ${CityTaxConfigurationFragmentDoc}`;

/**
 * __useCityTaxConfigurationQuery__
 *
 * To run a query within a React component, call `useCityTaxConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityTaxConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityTaxConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCityTaxConfigurationQuery(baseOptions: Apollo.QueryHookOptions<CityTaxConfigurationQuery, CityTaxConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityTaxConfigurationQuery, CityTaxConfigurationQueryVariables>(CityTaxConfigurationDocument, options);
      }
export function useCityTaxConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityTaxConfigurationQuery, CityTaxConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityTaxConfigurationQuery, CityTaxConfigurationQueryVariables>(CityTaxConfigurationDocument, options);
        }
export type CityTaxConfigurationQueryHookResult = ReturnType<typeof useCityTaxConfigurationQuery>;
export type CityTaxConfigurationLazyQueryHookResult = ReturnType<typeof useCityTaxConfigurationLazyQuery>;
export type CityTaxConfigurationQueryResult = Apollo.QueryResult<CityTaxConfigurationQuery, CityTaxConfigurationQueryVariables>;
export const GetCityTaxRulesDocument = gql`
    query GetCityTaxRules($input: GetCityTaxRulesInput!) {
  getCityTaxRules(input: $input) {
    rules
    match
  }
}
    `;

/**
 * __useGetCityTaxRulesQuery__
 *
 * To run a query within a React component, call `useGetCityTaxRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityTaxRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityTaxRulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCityTaxRulesQuery(baseOptions: Apollo.QueryHookOptions<GetCityTaxRulesQuery, GetCityTaxRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityTaxRulesQuery, GetCityTaxRulesQueryVariables>(GetCityTaxRulesDocument, options);
      }
export function useGetCityTaxRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityTaxRulesQuery, GetCityTaxRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityTaxRulesQuery, GetCityTaxRulesQueryVariables>(GetCityTaxRulesDocument, options);
        }
export type GetCityTaxRulesQueryHookResult = ReturnType<typeof useGetCityTaxRulesQuery>;
export type GetCityTaxRulesLazyQueryHookResult = ReturnType<typeof useGetCityTaxRulesLazyQuery>;
export type GetCityTaxRulesQueryResult = Apollo.QueryResult<GetCityTaxRulesQuery, GetCityTaxRulesQueryVariables>;
export const GetPropertyCodeItalianPsIstatCodeDocument = gql`
    query GetPropertyCodeItalianPsIstatCode($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    address {
      municipality {
        codeItalianPs
      }
    }
    istatConfigurations {
      procedureCode
    }
  }
}
    `;

/**
 * __useGetPropertyCodeItalianPsIstatCodeQuery__
 *
 * To run a query within a React component, call `useGetPropertyCodeItalianPsIstatCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyCodeItalianPsIstatCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyCodeItalianPsIstatCodeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPropertyCodeItalianPsIstatCodeQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyCodeItalianPsIstatCodeQuery, GetPropertyCodeItalianPsIstatCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyCodeItalianPsIstatCodeQuery, GetPropertyCodeItalianPsIstatCodeQueryVariables>(GetPropertyCodeItalianPsIstatCodeDocument, options);
      }
export function useGetPropertyCodeItalianPsIstatCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyCodeItalianPsIstatCodeQuery, GetPropertyCodeItalianPsIstatCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyCodeItalianPsIstatCodeQuery, GetPropertyCodeItalianPsIstatCodeQueryVariables>(GetPropertyCodeItalianPsIstatCodeDocument, options);
        }
export type GetPropertyCodeItalianPsIstatCodeQueryHookResult = ReturnType<typeof useGetPropertyCodeItalianPsIstatCodeQuery>;
export type GetPropertyCodeItalianPsIstatCodeLazyQueryHookResult = ReturnType<typeof useGetPropertyCodeItalianPsIstatCodeLazyQuery>;
export type GetPropertyCodeItalianPsIstatCodeQueryResult = Apollo.QueryResult<GetPropertyCodeItalianPsIstatCodeQuery, GetPropertyCodeItalianPsIstatCodeQueryVariables>;
export const GetCityTaxRegulationRicestatDocument = gql`
    query GetCityTaxRegulationRicestat($input: GetCityTaxRegulationRicestatInput!) {
  getCityTaxRegulationRicestat(input: $input) {
    rules {
      value
      name
      description
      cityTaxCode
    }
    municipalityCode
  }
}
    `;

/**
 * __useGetCityTaxRegulationRicestatQuery__
 *
 * To run a query within a React component, call `useGetCityTaxRegulationRicestatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityTaxRegulationRicestatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityTaxRegulationRicestatQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCityTaxRegulationRicestatQuery(baseOptions: Apollo.QueryHookOptions<GetCityTaxRegulationRicestatQuery, GetCityTaxRegulationRicestatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityTaxRegulationRicestatQuery, GetCityTaxRegulationRicestatQueryVariables>(GetCityTaxRegulationRicestatDocument, options);
      }
export function useGetCityTaxRegulationRicestatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityTaxRegulationRicestatQuery, GetCityTaxRegulationRicestatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityTaxRegulationRicestatQuery, GetCityTaxRegulationRicestatQueryVariables>(GetCityTaxRegulationRicestatDocument, options);
        }
export type GetCityTaxRegulationRicestatQueryHookResult = ReturnType<typeof useGetCityTaxRegulationRicestatQuery>;
export type GetCityTaxRegulationRicestatLazyQueryHookResult = ReturnType<typeof useGetCityTaxRegulationRicestatLazyQuery>;
export type GetCityTaxRegulationRicestatQueryResult = Apollo.QueryResult<GetCityTaxRegulationRicestatQuery, GetCityTaxRegulationRicestatQueryVariables>;
export const DepositDocumentsDocument = gql`
    query DepositDocuments($filter: DepositDocumentQueryFilter!) {
  depositDocuments(filter: $filter) {
    id
    depositAssigneds {
      id
    }
  }
}
    `;

/**
 * __useDepositDocumentsQuery__
 *
 * To run a query within a React component, call `useDepositDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDepositDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DepositDocumentsQuery, DepositDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepositDocumentsQuery, DepositDocumentsQueryVariables>(DepositDocumentsDocument, options);
      }
export function useDepositDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepositDocumentsQuery, DepositDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepositDocumentsQuery, DepositDocumentsQueryVariables>(DepositDocumentsDocument, options);
        }
export type DepositDocumentsQueryHookResult = ReturnType<typeof useDepositDocumentsQuery>;
export type DepositDocumentsLazyQueryHookResult = ReturnType<typeof useDepositDocumentsLazyQuery>;
export type DepositDocumentsQueryResult = Apollo.QueryResult<DepositDocumentsQuery, DepositDocumentsQueryVariables>;
export const ProvincesDocument = gql`
    query Provinces {
  provinces
}
    `;

/**
 * __useProvincesQuery__
 *
 * To run a query within a React component, call `useProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvincesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProvincesQuery(baseOptions?: Apollo.QueryHookOptions<ProvincesQuery, ProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options);
      }
export function useProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvincesQuery, ProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options);
        }
export type ProvincesQueryHookResult = ReturnType<typeof useProvincesQuery>;
export type ProvincesLazyQueryHookResult = ReturnType<typeof useProvincesLazyQuery>;
export type ProvincesQueryResult = Apollo.QueryResult<ProvincesQuery, ProvincesQueryVariables>;
export const FelConfigurationDocument = gql`
    query FelConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    fiscalConfigurations {
      felConfiguration {
        taxSystem
        authorizedCapital
        inLiquidation
        reaCode
        reaOffice
        soleShareholder
      }
    }
  }
}
    `;

/**
 * __useFelConfigurationQuery__
 *
 * To run a query within a React component, call `useFelConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFelConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFelConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFelConfigurationQuery(baseOptions: Apollo.QueryHookOptions<FelConfigurationQuery, FelConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FelConfigurationQuery, FelConfigurationQueryVariables>(FelConfigurationDocument, options);
      }
export function useFelConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FelConfigurationQuery, FelConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FelConfigurationQuery, FelConfigurationQueryVariables>(FelConfigurationDocument, options);
        }
export type FelConfigurationQueryHookResult = ReturnType<typeof useFelConfigurationQuery>;
export type FelConfigurationLazyQueryHookResult = ReturnType<typeof useFelConfigurationLazyQuery>;
export type FelConfigurationQueryResult = Apollo.QueryResult<FelConfigurationQuery, FelConfigurationQueryVariables>;
export const SetPropertyFelConfigurationDocument = gql`
    mutation SetPropertyFelConfiguration($setPropertyFelConfigurationId: ID!, $config: [FiscalConfigurationInput!]!, $tenantId: ID!) {
  setPropertyFiscalConfiguration(
    id: $setPropertyFelConfigurationId
    config: $config
    tenantId: $tenantId
  )
}
    `;
export type SetPropertyFelConfigurationMutationFn = Apollo.MutationFunction<SetPropertyFelConfigurationMutation, SetPropertyFelConfigurationMutationVariables>;

/**
 * __useSetPropertyFelConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertyFelConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyFelConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyFelConfigurationMutation, { data, loading, error }] = useSetPropertyFelConfigurationMutation({
 *   variables: {
 *      setPropertyFelConfigurationId: // value for 'setPropertyFelConfigurationId'
 *      config: // value for 'config'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetPropertyFelConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyFelConfigurationMutation, SetPropertyFelConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyFelConfigurationMutation, SetPropertyFelConfigurationMutationVariables>(SetPropertyFelConfigurationDocument, options);
      }
export type SetPropertyFelConfigurationMutationHookResult = ReturnType<typeof useSetPropertyFelConfigurationMutation>;
export type SetPropertyFelConfigurationMutationResult = Apollo.MutationResult<SetPropertyFelConfigurationMutation>;
export type SetPropertyFelConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertyFelConfigurationMutation, SetPropertyFelConfigurationMutationVariables>;
export const PropertyHoauConfigurationDocument = gql`
    query PropertyHoauConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    hoauConfiguration {
      ...Hoau
    }
    type
    name
    tenantId
  }
}
    ${HoauFragmentDoc}`;

/**
 * __usePropertyHoauConfigurationQuery__
 *
 * To run a query within a React component, call `usePropertyHoauConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyHoauConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyHoauConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyHoauConfigurationQuery(baseOptions: Apollo.QueryHookOptions<PropertyHoauConfigurationQuery, PropertyHoauConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyHoauConfigurationQuery, PropertyHoauConfigurationQueryVariables>(PropertyHoauConfigurationDocument, options);
      }
export function usePropertyHoauConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyHoauConfigurationQuery, PropertyHoauConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyHoauConfigurationQuery, PropertyHoauConfigurationQueryVariables>(PropertyHoauConfigurationDocument, options);
        }
export type PropertyHoauConfigurationQueryHookResult = ReturnType<typeof usePropertyHoauConfigurationQuery>;
export type PropertyHoauConfigurationLazyQueryHookResult = ReturnType<typeof usePropertyHoauConfigurationLazyQuery>;
export type PropertyHoauConfigurationQueryResult = Apollo.QueryResult<PropertyHoauConfigurationQuery, PropertyHoauConfigurationQueryVariables>;
export const HotelDateUpdateDocument = gql`
    mutation HotelDateUpdate($input: HotelDateInput!) {
  setHotelDate(input: $input)
}
    `;
export type HotelDateUpdateMutationFn = Apollo.MutationFunction<HotelDateUpdateMutation, HotelDateUpdateMutationVariables>;

/**
 * __useHotelDateUpdateMutation__
 *
 * To run a mutation, you first call `useHotelDateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHotelDateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hotelDateUpdateMutation, { data, loading, error }] = useHotelDateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHotelDateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<HotelDateUpdateMutation, HotelDateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HotelDateUpdateMutation, HotelDateUpdateMutationVariables>(HotelDateUpdateDocument, options);
      }
export type HotelDateUpdateMutationHookResult = ReturnType<typeof useHotelDateUpdateMutation>;
export type HotelDateUpdateMutationResult = Apollo.MutationResult<HotelDateUpdateMutation>;
export type HotelDateUpdateMutationOptions = Apollo.BaseMutationOptions<HotelDateUpdateMutation, HotelDateUpdateMutationVariables>;
export const HousekeepingSettingsDocument = gql`
    query HousekeepingSettings($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    housekeepingConfiguration {
      daysForResourceDirty
      reportAdditionalColumns
    }
    type
  }
}
    `;

/**
 * __useHousekeepingSettingsQuery__
 *
 * To run a query within a React component, call `useHousekeepingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHousekeepingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHousekeepingSettingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHousekeepingSettingsQuery(baseOptions: Apollo.QueryHookOptions<HousekeepingSettingsQuery, HousekeepingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HousekeepingSettingsQuery, HousekeepingSettingsQueryVariables>(HousekeepingSettingsDocument, options);
      }
export function useHousekeepingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HousekeepingSettingsQuery, HousekeepingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HousekeepingSettingsQuery, HousekeepingSettingsQueryVariables>(HousekeepingSettingsDocument, options);
        }
export type HousekeepingSettingsQueryHookResult = ReturnType<typeof useHousekeepingSettingsQuery>;
export type HousekeepingSettingsLazyQueryHookResult = ReturnType<typeof useHousekeepingSettingsLazyQuery>;
export type HousekeepingSettingsQueryResult = Apollo.QueryResult<HousekeepingSettingsQuery, HousekeepingSettingsQueryVariables>;
export const UpdateHousekeepingSettingsDocument = gql`
    mutation UpdateHousekeepingSettings($updatePropertyId: ID!, $value: PropertyInput!) {
  updateProperty(id: $updatePropertyId, value: $value) {
    housekeepingConfiguration {
      daysForResourceDirty
    }
  }
}
    `;
export type UpdateHousekeepingSettingsMutationFn = Apollo.MutationFunction<UpdateHousekeepingSettingsMutation, UpdateHousekeepingSettingsMutationVariables>;

/**
 * __useUpdateHousekeepingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateHousekeepingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHousekeepingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHousekeepingSettingsMutation, { data, loading, error }] = useUpdateHousekeepingSettingsMutation({
 *   variables: {
 *      updatePropertyId: // value for 'updatePropertyId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateHousekeepingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHousekeepingSettingsMutation, UpdateHousekeepingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHousekeepingSettingsMutation, UpdateHousekeepingSettingsMutationVariables>(UpdateHousekeepingSettingsDocument, options);
      }
export type UpdateHousekeepingSettingsMutationHookResult = ReturnType<typeof useUpdateHousekeepingSettingsMutation>;
export type UpdateHousekeepingSettingsMutationResult = Apollo.MutationResult<UpdateHousekeepingSettingsMutation>;
export type UpdateHousekeepingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateHousekeepingSettingsMutation, UpdateHousekeepingSettingsMutationVariables>;
export const FileUploadPresignedURLDocument = gql`
    mutation FileUploadPresignedURL($file: FileInput!) {
  fileUploadPresignedURL(file: $file) {
    ...FileUploadResponse
  }
}
    ${FileUploadResponseFragmentDoc}`;
export type FileUploadPresignedURLMutationFn = Apollo.MutationFunction<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>;

/**
 * __useFileUploadPresignedURLMutation__
 *
 * To run a mutation, you first call `useFileUploadPresignedURLMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadPresignedURLMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadPresignedUrlMutation, { data, loading, error }] = useFileUploadPresignedURLMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useFileUploadPresignedURLMutation(baseOptions?: Apollo.MutationHookOptions<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>(FileUploadPresignedURLDocument, options);
      }
export type FileUploadPresignedURLMutationHookResult = ReturnType<typeof useFileUploadPresignedURLMutation>;
export type FileUploadPresignedURLMutationResult = Apollo.MutationResult<FileUploadPresignedURLMutation>;
export type FileUploadPresignedURLMutationOptions = Apollo.BaseMutationOptions<FileUploadPresignedURLMutation, FileUploadPresignedURLMutationVariables>;
export const SetEntityImagesDocument = gql`
    mutation SetEntityImages($input: EntityImageInput!) {
  setEntityImages(input: $input)
}
    `;
export type SetEntityImagesMutationFn = Apollo.MutationFunction<SetEntityImagesMutation, SetEntityImagesMutationVariables>;

/**
 * __useSetEntityImagesMutation__
 *
 * To run a mutation, you first call `useSetEntityImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityImagesMutation, { data, loading, error }] = useSetEntityImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEntityImagesMutation(baseOptions?: Apollo.MutationHookOptions<SetEntityImagesMutation, SetEntityImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEntityImagesMutation, SetEntityImagesMutationVariables>(SetEntityImagesDocument, options);
      }
export type SetEntityImagesMutationHookResult = ReturnType<typeof useSetEntityImagesMutation>;
export type SetEntityImagesMutationResult = Apollo.MutationResult<SetEntityImagesMutation>;
export type SetEntityImagesMutationOptions = Apollo.BaseMutationOptions<SetEntityImagesMutation, SetEntityImagesMutationVariables>;
export const GetImagesDocument = gql`
    query GetImages($propertyFilter: PropertyQueryFilter!, $resourceTypesFilter: ResourceTypeQueryFilter!, $additionalServicesFilter: AdditionalServiceQueryFilter!) {
  properties(filter: $propertyFilter) {
    images {
      type
      imageIds
      images {
        ...Image
      }
    }
  }
  resourceTypes(filter: $resourceTypesFilter) {
    customName
    id
    imageIds
    images {
      ...Image
    }
    name {
      description
    }
  }
  additionalServices(filter: $additionalServicesFilter) {
    imageIds
    images {
      ...Image
    }
    name
    id
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetImagesQuery__
 *
 * To run a query within a React component, call `useGetImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImagesQuery({
 *   variables: {
 *      propertyFilter: // value for 'propertyFilter'
 *      resourceTypesFilter: // value for 'resourceTypesFilter'
 *      additionalServicesFilter: // value for 'additionalServicesFilter'
 *   },
 * });
 */
export function useGetImagesQuery(baseOptions: Apollo.QueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
      }
export function useGetImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
        }
export type GetImagesQueryHookResult = ReturnType<typeof useGetImagesQuery>;
export type GetImagesLazyQueryHookResult = ReturnType<typeof useGetImagesLazyQuery>;
export type GetImagesQueryResult = Apollo.QueryResult<GetImagesQuery, GetImagesQueryVariables>;
export const GetPropertyImagesDocument = gql`
    query GetPropertyImages($propertyFilter: PropertyQueryFilter!) {
  properties(filter: $propertyFilter) {
    images {
      type
      imageIds
      images {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetPropertyImagesQuery__
 *
 * To run a query within a React component, call `useGetPropertyImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyImagesQuery({
 *   variables: {
 *      propertyFilter: // value for 'propertyFilter'
 *   },
 * });
 */
export function useGetPropertyImagesQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>(GetPropertyImagesDocument, options);
      }
export function useGetPropertyImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>(GetPropertyImagesDocument, options);
        }
export type GetPropertyImagesQueryHookResult = ReturnType<typeof useGetPropertyImagesQuery>;
export type GetPropertyImagesLazyQueryHookResult = ReturnType<typeof useGetPropertyImagesLazyQuery>;
export type GetPropertyImagesQueryResult = Apollo.QueryResult<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>;
export const InsightsDocument = gql`
    query Insights($filter: InsightQueryFilter!) {
  insights(filter: $filter) {
    ...Insight
  }
}
    ${InsightFragmentDoc}`;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;
export const InsightDocument = gql`
    mutation Insight($input: InsightInput!) {
  setInsightPause(input: $input)
}
    `;
export type InsightMutationFn = Apollo.MutationFunction<InsightMutation, InsightMutationVariables>;

/**
 * __useInsightMutation__
 *
 * To run a mutation, you first call `useInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insightMutation, { data, loading, error }] = useInsightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsightMutation(baseOptions?: Apollo.MutationHookOptions<InsightMutation, InsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsightMutation, InsightMutationVariables>(InsightDocument, options);
      }
export type InsightMutationHookResult = ReturnType<typeof useInsightMutation>;
export type InsightMutationResult = Apollo.MutationResult<InsightMutation>;
export type InsightMutationOptions = Apollo.BaseMutationOptions<InsightMutation, InsightMutationVariables>;
export const ISTATConfigurationDocument = gql`
    query ISTATConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    istatConfigurations {
      ...IstatConfiguration
    }
  }
}
    ${IstatConfigurationFragmentDoc}`;

/**
 * __useISTATConfigurationQuery__
 *
 * To run a query within a React component, call `useISTATConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useISTATConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useISTATConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useISTATConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ISTATConfigurationQuery, ISTATConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISTATConfigurationQuery, ISTATConfigurationQueryVariables>(ISTATConfigurationDocument, options);
      }
export function useISTATConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISTATConfigurationQuery, ISTATConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISTATConfigurationQuery, ISTATConfigurationQueryVariables>(ISTATConfigurationDocument, options);
        }
export type ISTATConfigurationQueryHookResult = ReturnType<typeof useISTATConfigurationQuery>;
export type ISTATConfigurationLazyQueryHookResult = ReturnType<typeof useISTATConfigurationLazyQuery>;
export type ISTATConfigurationQueryResult = Apollo.QueryResult<ISTATConfigurationQuery, ISTATConfigurationQueryVariables>;
export const SetPropertyIstatConfigurationDocument = gql`
    mutation SetPropertyIstatConfiguration($setPropertyIstatConfigurationId: ID!, $config: [IstatConfigurationInput!], $tenantId: ID!) {
  setPropertyIstatConfiguration(
    id: $setPropertyIstatConfigurationId
    config: $config
    tenantId: $tenantId
  )
}
    `;
export type SetPropertyIstatConfigurationMutationFn = Apollo.MutationFunction<SetPropertyIstatConfigurationMutation, SetPropertyIstatConfigurationMutationVariables>;

/**
 * __useSetPropertyIstatConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertyIstatConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyIstatConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyIstatConfigurationMutation, { data, loading, error }] = useSetPropertyIstatConfigurationMutation({
 *   variables: {
 *      setPropertyIstatConfigurationId: // value for 'setPropertyIstatConfigurationId'
 *      config: // value for 'config'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetPropertyIstatConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyIstatConfigurationMutation, SetPropertyIstatConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyIstatConfigurationMutation, SetPropertyIstatConfigurationMutationVariables>(SetPropertyIstatConfigurationDocument, options);
      }
export type SetPropertyIstatConfigurationMutationHookResult = ReturnType<typeof useSetPropertyIstatConfigurationMutation>;
export type SetPropertyIstatConfigurationMutationResult = Apollo.MutationResult<SetPropertyIstatConfigurationMutation>;
export type SetPropertyIstatConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertyIstatConfigurationMutation, SetPropertyIstatConfigurationMutationVariables>;
export const GetIstatProcedureByPropertyDocument = gql`
    query GetIstatProcedureByProperty($tenantId: ID!, $propertyId: ID!) {
  getIstatProcedureByProperty(tenantId: $tenantId, propertyId: $propertyId)
}
    `;

/**
 * __useGetIstatProcedureByPropertyQuery__
 *
 * To run a query within a React component, call `useGetIstatProcedureByPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIstatProcedureByPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIstatProcedureByPropertyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetIstatProcedureByPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetIstatProcedureByPropertyQuery, GetIstatProcedureByPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIstatProcedureByPropertyQuery, GetIstatProcedureByPropertyQueryVariables>(GetIstatProcedureByPropertyDocument, options);
      }
export function useGetIstatProcedureByPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIstatProcedureByPropertyQuery, GetIstatProcedureByPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIstatProcedureByPropertyQuery, GetIstatProcedureByPropertyQueryVariables>(GetIstatProcedureByPropertyDocument, options);
        }
export type GetIstatProcedureByPropertyQueryHookResult = ReturnType<typeof useGetIstatProcedureByPropertyQuery>;
export type GetIstatProcedureByPropertyLazyQueryHookResult = ReturnType<typeof useGetIstatProcedureByPropertyLazyQuery>;
export type GetIstatProcedureByPropertyQueryResult = Apollo.QueryResult<GetIstatProcedureByPropertyQuery, GetIstatProcedureByPropertyQueryVariables>;
export const GetIstatSystemCapabilitiesDocument = gql`
    query GetIstatSystemCapabilities($procedureCode: IstatProcedureCode!) {
  getIstatSystemCapabilities(procedureCode: $procedureCode) {
    ...IstatSystemCapabilities
  }
}
    ${IstatSystemCapabilitiesFragmentDoc}`;

/**
 * __useGetIstatSystemCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetIstatSystemCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIstatSystemCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIstatSystemCapabilitiesQuery({
 *   variables: {
 *      procedureCode: // value for 'procedureCode'
 *   },
 * });
 */
export function useGetIstatSystemCapabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetIstatSystemCapabilitiesQuery, GetIstatSystemCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIstatSystemCapabilitiesQuery, GetIstatSystemCapabilitiesQueryVariables>(GetIstatSystemCapabilitiesDocument, options);
      }
export function useGetIstatSystemCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIstatSystemCapabilitiesQuery, GetIstatSystemCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIstatSystemCapabilitiesQuery, GetIstatSystemCapabilitiesQueryVariables>(GetIstatSystemCapabilitiesDocument, options);
        }
export type GetIstatSystemCapabilitiesQueryHookResult = ReturnType<typeof useGetIstatSystemCapabilitiesQuery>;
export type GetIstatSystemCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetIstatSystemCapabilitiesLazyQuery>;
export type GetIstatSystemCapabilitiesQueryResult = Apollo.QueryResult<GetIstatSystemCapabilitiesQuery, GetIstatSystemCapabilitiesQueryVariables>;
export const IstatResourcesDocument = gql`
    query IstatResources($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    code
    id
    codeIstat
  }
}
    `;

/**
 * __useIstatResourcesQuery__
 *
 * To run a query within a React component, call `useIstatResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIstatResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIstatResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIstatResourcesQuery(baseOptions: Apollo.QueryHookOptions<IstatResourcesQuery, IstatResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IstatResourcesQuery, IstatResourcesQueryVariables>(IstatResourcesDocument, options);
      }
export function useIstatResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IstatResourcesQuery, IstatResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IstatResourcesQuery, IstatResourcesQueryVariables>(IstatResourcesDocument, options);
        }
export type IstatResourcesQueryHookResult = ReturnType<typeof useIstatResourcesQuery>;
export type IstatResourcesLazyQueryHookResult = ReturnType<typeof useIstatResourcesLazyQuery>;
export type IstatResourcesQueryResult = Apollo.QueryResult<IstatResourcesQuery, IstatResourcesQueryVariables>;
export const TenantPropertiesDocument = gql`
    query TenantProperties($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useTenantPropertiesQuery__
 *
 * To run a query within a React component, call `useTenantPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTenantPropertiesQuery(baseOptions: Apollo.QueryHookOptions<TenantPropertiesQuery, TenantPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantPropertiesQuery, TenantPropertiesQueryVariables>(TenantPropertiesDocument, options);
      }
export function useTenantPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantPropertiesQuery, TenantPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantPropertiesQuery, TenantPropertiesQueryVariables>(TenantPropertiesDocument, options);
        }
export type TenantPropertiesQueryHookResult = ReturnType<typeof useTenantPropertiesQuery>;
export type TenantPropertiesLazyQueryHookResult = ReturnType<typeof useTenantPropertiesLazyQuery>;
export type TenantPropertiesQueryResult = Apollo.QueryResult<TenantPropertiesQuery, TenantPropertiesQueryVariables>;
export const MessageTemplatesListDocument = gql`
    query MessageTemplatesList($filter: MessageTemplateQueryFilter!) {
  messageTemplates(filter: $filter) {
    ...MessageTemplateList
  }
}
    ${MessageTemplateListFragmentDoc}`;

/**
 * __useMessageTemplatesListQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessageTemplatesListQuery(baseOptions: Apollo.QueryHookOptions<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>(MessageTemplatesListDocument, options);
      }
export function useMessageTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>(MessageTemplatesListDocument, options);
        }
export type MessageTemplatesListQueryHookResult = ReturnType<typeof useMessageTemplatesListQuery>;
export type MessageTemplatesListLazyQueryHookResult = ReturnType<typeof useMessageTemplatesListLazyQuery>;
export type MessageTemplatesListQueryResult = Apollo.QueryResult<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>;
export const MessageTemplatesDocument = gql`
    query MessageTemplates($filter: MessageTemplateQueryFilter!) {
  messageTemplates(filter: $filter) {
    ...MessageTemplate
  }
}
    ${MessageTemplateFragmentDoc}`;

/**
 * __useMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument, options);
      }
export function useMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageTemplatesQuery, MessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument, options);
        }
export type MessageTemplatesQueryHookResult = ReturnType<typeof useMessageTemplatesQuery>;
export type MessageTemplatesLazyQueryHookResult = ReturnType<typeof useMessageTemplatesLazyQuery>;
export type MessageTemplatesQueryResult = Apollo.QueryResult<MessageTemplatesQuery, MessageTemplatesQueryVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation CreateMessageTemplate($value: MessageTemplateInput!) {
  createMessageTemplate(value: $value) {
    ...MessageTemplate
  }
}
    ${MessageTemplateFragmentDoc}`;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation UpdateMessageTemplate($updateMailTemplateId: String!, $value: MessageTemplateInput!) {
  updateMessageTemplate(id: $updateMailTemplateId, value: $value) {
    ...MessageTemplate
  }
}
    ${MessageTemplateFragmentDoc}`;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      updateMailTemplateId: // value for 'updateMailTemplateId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const DeleteMessageTemplateDocument = gql`
    mutation DeleteMessageTemplate($tenantId: ID!, $deleteMailTemplateId: String!) {
  deleteMessageTemplate(tenantId: $tenantId, id: $deleteMailTemplateId)
}
    `;
export type DeleteMessageTemplateMutationFn = Apollo.MutationFunction<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;

/**
 * __useDeleteMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplateMutation, { data, loading, error }] = useDeleteMessageTemplateMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteMailTemplateId: // value for 'deleteMailTemplateId'
 *   },
 * });
 */
export function useDeleteMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>(DeleteMessageTemplateDocument, options);
      }
export type DeleteMessageTemplateMutationHookResult = ReturnType<typeof useDeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationResult = Apollo.MutationResult<DeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;
export const FilesDocument = gql`
    query Files($filter: FilesQueryFilter!) {
  files(filter: $filter) {
    ...File
  }
}
    ${FileFragmentDoc}`;

/**
 * __useFilesQuery__
 *
 * To run a query within a React component, call `useFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilesQuery(baseOptions: Apollo.QueryHookOptions<FilesQuery, FilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
      }
export function useFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesQuery, FilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
        }
export type FilesQueryHookResult = ReturnType<typeof useFilesQuery>;
export type FilesLazyQueryHookResult = ReturnType<typeof useFilesLazyQuery>;
export type FilesQueryResult = Apollo.QueryResult<FilesQuery, FilesQueryVariables>;
export const SendDataHubSpotDocument = gql`
    mutation SendDataHubSpot($data: [HubSpotDataInput!]!) {
  sendDataHubSpot(data: $data)
}
    `;
export type SendDataHubSpotMutationFn = Apollo.MutationFunction<SendDataHubSpotMutation, SendDataHubSpotMutationVariables>;

/**
 * __useSendDataHubSpotMutation__
 *
 * To run a mutation, you first call `useSendDataHubSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDataHubSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDataHubSpotMutation, { data, loading, error }] = useSendDataHubSpotMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendDataHubSpotMutation(baseOptions?: Apollo.MutationHookOptions<SendDataHubSpotMutation, SendDataHubSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDataHubSpotMutation, SendDataHubSpotMutationVariables>(SendDataHubSpotDocument, options);
      }
export type SendDataHubSpotMutationHookResult = ReturnType<typeof useSendDataHubSpotMutation>;
export type SendDataHubSpotMutationResult = Apollo.MutationResult<SendDataHubSpotMutation>;
export type SendDataHubSpotMutationOptions = Apollo.BaseMutationOptions<SendDataHubSpotMutation, SendDataHubSpotMutationVariables>;
export const MultiManagementDocument = gql`
    query MultiManagement($resourceTypeFilter: ResourceTypeQueryFilter!, $propertyFilter: PropertyQueryFilter!) {
  resourceTypes(filter: $resourceTypeFilter) {
    code
    customName
    name {
      description
    }
    id
    resources {
      id
      code
      codeItalianPs
    }
    timeConfiguration {
      unitOfMeasurement
    }
  }
  properties(filter: $propertyFilter) {
    subAddresses {
      ...MultiManagementSubAddress
    }
    fiscalConfigurations {
      ...MultiManagementFiscalConfiguration
    }
    cityTaxConfiguration {
      configurations {
        ...MultiManagementCityTaxConfiguration
      }
    }
    istatConfigurations {
      ...MultiManagementIstatConfiguration
    }
    psConfigurations {
      ...PSConfiguration
    }
  }
}
    ${MultiManagementSubAddressFragmentDoc}
${MultiManagementFiscalConfigurationFragmentDoc}
${MultiManagementCityTaxConfigurationFragmentDoc}
${MultiManagementIstatConfigurationFragmentDoc}
${PSConfigurationFragmentDoc}`;

/**
 * __useMultiManagementQuery__
 *
 * To run a query within a React component, call `useMultiManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiManagementQuery({
 *   variables: {
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      propertyFilter: // value for 'propertyFilter'
 *   },
 * });
 */
export function useMultiManagementQuery(baseOptions: Apollo.QueryHookOptions<MultiManagementQuery, MultiManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiManagementQuery, MultiManagementQueryVariables>(MultiManagementDocument, options);
      }
export function useMultiManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiManagementQuery, MultiManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiManagementQuery, MultiManagementQueryVariables>(MultiManagementDocument, options);
        }
export type MultiManagementQueryHookResult = ReturnType<typeof useMultiManagementQuery>;
export type MultiManagementLazyQueryHookResult = ReturnType<typeof useMultiManagementLazyQuery>;
export type MultiManagementQueryResult = Apollo.QueryResult<MultiManagementQuery, MultiManagementQueryVariables>;
export const SetPropertyConfigurationsDocument = gql`
    mutation SetPropertyConfigurations($value: SetPropertyConfigurationsInput!) {
  setPropertyConfigurations(value: $value)
}
    `;
export type SetPropertyConfigurationsMutationFn = Apollo.MutationFunction<SetPropertyConfigurationsMutation, SetPropertyConfigurationsMutationVariables>;

/**
 * __useSetPropertyConfigurationsMutation__
 *
 * To run a mutation, you first call `useSetPropertyConfigurationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyConfigurationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyConfigurationsMutation, { data, loading, error }] = useSetPropertyConfigurationsMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetPropertyConfigurationsMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyConfigurationsMutation, SetPropertyConfigurationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyConfigurationsMutation, SetPropertyConfigurationsMutationVariables>(SetPropertyConfigurationsDocument, options);
      }
export type SetPropertyConfigurationsMutationHookResult = ReturnType<typeof useSetPropertyConfigurationsMutation>;
export type SetPropertyConfigurationsMutationResult = Apollo.MutationResult<SetPropertyConfigurationsMutation>;
export type SetPropertyConfigurationsMutationOptions = Apollo.BaseMutationOptions<SetPropertyConfigurationsMutation, SetPropertyConfigurationsMutationVariables>;
export const PaymentGatewaysDocument = gql`
    query PaymentGateways($tenantId: ID!, $propertyId: ID!) {
  paymentGateways(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}}
  ) {
    ...PaymentGateway
  }
}
    ${PaymentGatewayFragmentDoc}`;

/**
 * __usePaymentGatewaysQuery__
 *
 * To run a query within a React component, call `usePaymentGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentGatewaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentGatewaysQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePaymentGatewaysQuery(baseOptions: Apollo.QueryHookOptions<PaymentGatewaysQuery, PaymentGatewaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentGatewaysQuery, PaymentGatewaysQueryVariables>(PaymentGatewaysDocument, options);
      }
export function usePaymentGatewaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentGatewaysQuery, PaymentGatewaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentGatewaysQuery, PaymentGatewaysQueryVariables>(PaymentGatewaysDocument, options);
        }
export type PaymentGatewaysQueryHookResult = ReturnType<typeof usePaymentGatewaysQuery>;
export type PaymentGatewaysLazyQueryHookResult = ReturnType<typeof usePaymentGatewaysLazyQuery>;
export type PaymentGatewaysQueryResult = Apollo.QueryResult<PaymentGatewaysQuery, PaymentGatewaysQueryVariables>;
export const PaymentMethodsDocument = gql`
    query PaymentMethods($tenantId: ID!, $propertyId: ID!) {
  paymentMethods(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}}
  ) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const PaymentMethodDocument = gql`
    query PaymentMethod($tenantId: ID!, $propertyId: ID!, $paymentMethodId: ID!) {
  paymentMethods(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {eq: $paymentMethodId}}
  ) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __usePaymentMethodQuery__
 *
 * To run a query within a React component, call `usePaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodQuery, PaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodQuery, PaymentMethodQueryVariables>(PaymentMethodDocument, options);
      }
export function usePaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodQuery, PaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodQuery, PaymentMethodQueryVariables>(PaymentMethodDocument, options);
        }
export type PaymentMethodQueryHookResult = ReturnType<typeof usePaymentMethodQuery>;
export type PaymentMethodLazyQueryHookResult = ReturnType<typeof usePaymentMethodLazyQuery>;
export type PaymentMethodQueryResult = Apollo.QueryResult<PaymentMethodQuery, PaymentMethodQueryVariables>;
export const PaymentMethodNewDocument = gql`
    mutation PaymentMethodNew($input: PaymentMethodInput!) {
  createPaymentMethod(value: $input) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;
export type PaymentMethodNewMutationFn = Apollo.MutationFunction<PaymentMethodNewMutation, PaymentMethodNewMutationVariables>;

/**
 * __usePaymentMethodNewMutation__
 *
 * To run a mutation, you first call `usePaymentMethodNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodNewMutation, { data, loading, error }] = usePaymentMethodNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodNewMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodNewMutation, PaymentMethodNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodNewMutation, PaymentMethodNewMutationVariables>(PaymentMethodNewDocument, options);
      }
export type PaymentMethodNewMutationHookResult = ReturnType<typeof usePaymentMethodNewMutation>;
export type PaymentMethodNewMutationResult = Apollo.MutationResult<PaymentMethodNewMutation>;
export type PaymentMethodNewMutationOptions = Apollo.BaseMutationOptions<PaymentMethodNewMutation, PaymentMethodNewMutationVariables>;
export const PaymentMethodUpdateDocument = gql`
    mutation PaymentMethodUpdate($id: String!, $input: PaymentMethodInput!) {
  updatePaymentMethod(id: $id, value: $input) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;
export type PaymentMethodUpdateMutationFn = Apollo.MutationFunction<PaymentMethodUpdateMutation, PaymentMethodUpdateMutationVariables>;

/**
 * __usePaymentMethodUpdateMutation__
 *
 * To run a mutation, you first call `usePaymentMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodUpdateMutation, { data, loading, error }] = usePaymentMethodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodUpdateMutation, PaymentMethodUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodUpdateMutation, PaymentMethodUpdateMutationVariables>(PaymentMethodUpdateDocument, options);
      }
export type PaymentMethodUpdateMutationHookResult = ReturnType<typeof usePaymentMethodUpdateMutation>;
export type PaymentMethodUpdateMutationResult = Apollo.MutationResult<PaymentMethodUpdateMutation>;
export type PaymentMethodUpdateMutationOptions = Apollo.BaseMutationOptions<PaymentMethodUpdateMutation, PaymentMethodUpdateMutationVariables>;
export const PaymentMethodDeleteDocument = gql`
    mutation PaymentMethodDelete($tenantId: ID!, $id: String!) {
  deletePaymentMethod(tenantId: $tenantId, id: $id)
}
    `;
export type PaymentMethodDeleteMutationFn = Apollo.MutationFunction<PaymentMethodDeleteMutation, PaymentMethodDeleteMutationVariables>;

/**
 * __usePaymentMethodDeleteMutation__
 *
 * To run a mutation, you first call `usePaymentMethodDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodDeleteMutation, { data, loading, error }] = usePaymentMethodDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentMethodDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodDeleteMutation, PaymentMethodDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodDeleteMutation, PaymentMethodDeleteMutationVariables>(PaymentMethodDeleteDocument, options);
      }
export type PaymentMethodDeleteMutationHookResult = ReturnType<typeof usePaymentMethodDeleteMutation>;
export type PaymentMethodDeleteMutationResult = Apollo.MutationResult<PaymentMethodDeleteMutation>;
export type PaymentMethodDeleteMutationOptions = Apollo.BaseMutationOptions<PaymentMethodDeleteMutation, PaymentMethodDeleteMutationVariables>;
export const PaymentActiveListDocument = gql`
    query PaymentActiveList($filter: PaymentActiveQueryFilter!) {
  paymentActives(filter: $filter) {
    ...PaymentActiveList
  }
}
    ${PaymentActiveListFragmentDoc}`;

/**
 * __usePaymentActiveListQuery__
 *
 * To run a query within a React component, call `usePaymentActiveListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentActiveListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentActiveListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentActiveListQuery(baseOptions: Apollo.QueryHookOptions<PaymentActiveListQuery, PaymentActiveListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentActiveListQuery, PaymentActiveListQueryVariables>(PaymentActiveListDocument, options);
      }
export function usePaymentActiveListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentActiveListQuery, PaymentActiveListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentActiveListQuery, PaymentActiveListQueryVariables>(PaymentActiveListDocument, options);
        }
export type PaymentActiveListQueryHookResult = ReturnType<typeof usePaymentActiveListQuery>;
export type PaymentActiveListLazyQueryHookResult = ReturnType<typeof usePaymentActiveListLazyQuery>;
export type PaymentActiveListQueryResult = Apollo.QueryResult<PaymentActiveListQuery, PaymentActiveListQueryVariables>;
export const UpdatePaymentActiveDocument = gql`
    mutation UpdatePaymentActive($id: String!, $input: PaymentActiveInput!) {
  updatePaymentActive(id: $id, input: $input) {
    ...PaymentActiveList
  }
}
    ${PaymentActiveListFragmentDoc}`;
export type UpdatePaymentActiveMutationFn = Apollo.MutationFunction<UpdatePaymentActiveMutation, UpdatePaymentActiveMutationVariables>;

/**
 * __useUpdatePaymentActiveMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentActiveMutation, { data, loading, error }] = useUpdatePaymentActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentActiveMutation, UpdatePaymentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentActiveMutation, UpdatePaymentActiveMutationVariables>(UpdatePaymentActiveDocument, options);
      }
export type UpdatePaymentActiveMutationHookResult = ReturnType<typeof useUpdatePaymentActiveMutation>;
export type UpdatePaymentActiveMutationResult = Apollo.MutationResult<UpdatePaymentActiveMutation>;
export type UpdatePaymentActiveMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentActiveMutation, UpdatePaymentActiveMutationVariables>;
export const PaymentTypesDocument = gql`
    query PaymentTypes($filter: PaymentTypeQueryFilter!) {
  paymentTypes(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __usePaymentTypesQuery__
 *
 * To run a query within a React component, call `usePaymentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentTypesQuery(baseOptions: Apollo.QueryHookOptions<PaymentTypesQuery, PaymentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTypesQuery, PaymentTypesQueryVariables>(PaymentTypesDocument, options);
      }
export function usePaymentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTypesQuery, PaymentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTypesQuery, PaymentTypesQueryVariables>(PaymentTypesDocument, options);
        }
export type PaymentTypesQueryHookResult = ReturnType<typeof usePaymentTypesQuery>;
export type PaymentTypesLazyQueryHookResult = ReturnType<typeof usePaymentTypesLazyQuery>;
export type PaymentTypesQueryResult = Apollo.QueryResult<PaymentTypesQuery, PaymentTypesQueryVariables>;
export const CreatePaymentActiveDocument = gql`
    mutation CreatePaymentActive($value: PaymentActiveInput!) {
  createPaymentActive(value: $value) {
    ...PaymentActiveList
  }
}
    ${PaymentActiveListFragmentDoc}`;
export type CreatePaymentActiveMutationFn = Apollo.MutationFunction<CreatePaymentActiveMutation, CreatePaymentActiveMutationVariables>;

/**
 * __useCreatePaymentActiveMutation__
 *
 * To run a mutation, you first call `useCreatePaymentActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentActiveMutation, { data, loading, error }] = useCreatePaymentActiveMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreatePaymentActiveMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentActiveMutation, CreatePaymentActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentActiveMutation, CreatePaymentActiveMutationVariables>(CreatePaymentActiveDocument, options);
      }
export type CreatePaymentActiveMutationHookResult = ReturnType<typeof useCreatePaymentActiveMutation>;
export type CreatePaymentActiveMutationResult = Apollo.MutationResult<CreatePaymentActiveMutation>;
export type CreatePaymentActiveMutationOptions = Apollo.BaseMutationOptions<CreatePaymentActiveMutation, CreatePaymentActiveMutationVariables>;
export const PositionsDocument = gql`
    query Positions($filter: PositionQueryFilter!) {
  positions(filter: $filter) {
    ...Position
  }
}
    ${PositionFragmentDoc}`;

/**
 * __usePositionsQuery__
 *
 * To run a query within a React component, call `usePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePositionsQuery(baseOptions: Apollo.QueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
      }
export function usePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionsQuery, PositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionsQuery, PositionsQueryVariables>(PositionsDocument, options);
        }
export type PositionsQueryHookResult = ReturnType<typeof usePositionsQuery>;
export type PositionsLazyQueryHookResult = ReturnType<typeof usePositionsLazyQuery>;
export type PositionsQueryResult = Apollo.QueryResult<PositionsQuery, PositionsQueryVariables>;
export const CreatePositionDocument = gql`
    mutation CreatePosition($value: PositionInput!) {
  createPosition(value: $value) {
    ...Position
  }
}
    ${PositionFragmentDoc}`;
export type CreatePositionMutationFn = Apollo.MutationFunction<CreatePositionMutation, CreatePositionMutationVariables>;

/**
 * __useCreatePositionMutation__
 *
 * To run a mutation, you first call `useCreatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPositionMutation, { data, loading, error }] = useCreatePositionMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreatePositionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePositionMutation, CreatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePositionMutation, CreatePositionMutationVariables>(CreatePositionDocument, options);
      }
export type CreatePositionMutationHookResult = ReturnType<typeof useCreatePositionMutation>;
export type CreatePositionMutationResult = Apollo.MutationResult<CreatePositionMutation>;
export type CreatePositionMutationOptions = Apollo.BaseMutationOptions<CreatePositionMutation, CreatePositionMutationVariables>;
export const UpdatePositionDocument = gql`
    mutation UpdatePosition($value: PositionInput!, $updatePositionId: String!) {
  updatePosition(value: $value, id: $updatePositionId) {
    ...Position
  }
}
    ${PositionFragmentDoc}`;
export type UpdatePositionMutationFn = Apollo.MutationFunction<UpdatePositionMutation, UpdatePositionMutationVariables>;

/**
 * __useUpdatePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionMutation, { data, loading, error }] = useUpdatePositionMutation({
 *   variables: {
 *      value: // value for 'value'
 *      updatePositionId: // value for 'updatePositionId'
 *   },
 * });
 */
export function useUpdatePositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionMutation, UpdatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionMutation, UpdatePositionMutationVariables>(UpdatePositionDocument, options);
      }
export type UpdatePositionMutationHookResult = ReturnType<typeof useUpdatePositionMutation>;
export type UpdatePositionMutationResult = Apollo.MutationResult<UpdatePositionMutation>;
export type UpdatePositionMutationOptions = Apollo.BaseMutationOptions<UpdatePositionMutation, UpdatePositionMutationVariables>;
export const DeletePositionDocument = gql`
    mutation DeletePosition($tenantId: ID!, $deletePositionId: String!) {
  deletePosition(tenantId: $tenantId, id: $deletePositionId)
}
    `;
export type DeletePositionMutationFn = Apollo.MutationFunction<DeletePositionMutation, DeletePositionMutationVariables>;

/**
 * __useDeletePositionMutation__
 *
 * To run a mutation, you first call `useDeletePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositionMutation, { data, loading, error }] = useDeletePositionMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deletePositionId: // value for 'deletePositionId'
 *   },
 * });
 */
export function useDeletePositionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePositionMutation, DeletePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePositionMutation, DeletePositionMutationVariables>(DeletePositionDocument, options);
      }
export type DeletePositionMutationHookResult = ReturnType<typeof useDeletePositionMutation>;
export type DeletePositionMutationResult = Apollo.MutationResult<DeletePositionMutation>;
export type DeletePositionMutationOptions = Apollo.BaseMutationOptions<DeletePositionMutation, DeletePositionMutationVariables>;
export const UpdatePrivacySettingsDocument = gql`
    mutation UpdatePrivacySettings($tenantId: ID!, $value: PrivacySettingsInput!) {
  updatePrivacySettings(tenantId: $tenantId, value: $value)
}
    `;
export type UpdatePrivacySettingsMutationFn = Apollo.MutationFunction<UpdatePrivacySettingsMutation, UpdatePrivacySettingsMutationVariables>;

/**
 * __useUpdatePrivacySettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivacySettingsMutation, { data, loading, error }] = useUpdatePrivacySettingsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdatePrivacySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivacySettingsMutation, UpdatePrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivacySettingsMutation, UpdatePrivacySettingsMutationVariables>(UpdatePrivacySettingsDocument, options);
      }
export type UpdatePrivacySettingsMutationHookResult = ReturnType<typeof useUpdatePrivacySettingsMutation>;
export type UpdatePrivacySettingsMutationResult = Apollo.MutationResult<UpdatePrivacySettingsMutation>;
export type UpdatePrivacySettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePrivacySettingsMutation, UpdatePrivacySettingsMutationVariables>;
export const GetCompanyInfoForPrivacyDocument = gql`
    query GetCompanyInfoForPrivacy($tenantId: ID!, $filter: TenantQueryFilter) {
  getCompanyInfoForPrivacy(tenantId: $tenantId) {
    name
    vat
    fiscalCode
  }
  tenants(filter: $filter) {
    id
    privacySettings {
      companyAddress
      companyEmail
      companyName
      companyVat
      companyFiscalCode
      dataRetentionMonths
      isCustomText
      text
      useDirectMarketing
      useHealthData
      useThirdPartyMarketing
      useProfiledMarketing
    }
  }
}
    `;

/**
 * __useGetCompanyInfoForPrivacyQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoForPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoForPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoForPrivacyQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCompanyInfoForPrivacyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInfoForPrivacyQuery, GetCompanyInfoForPrivacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoForPrivacyQuery, GetCompanyInfoForPrivacyQueryVariables>(GetCompanyInfoForPrivacyDocument, options);
      }
export function useGetCompanyInfoForPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoForPrivacyQuery, GetCompanyInfoForPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoForPrivacyQuery, GetCompanyInfoForPrivacyQueryVariables>(GetCompanyInfoForPrivacyDocument, options);
        }
export type GetCompanyInfoForPrivacyQueryHookResult = ReturnType<typeof useGetCompanyInfoForPrivacyQuery>;
export type GetCompanyInfoForPrivacyLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoForPrivacyLazyQuery>;
export type GetCompanyInfoForPrivacyQueryResult = Apollo.QueryResult<GetCompanyInfoForPrivacyQuery, GetCompanyInfoForPrivacyQueryVariables>;
export const ProductsDocument = gql`
    query Products($filter: ProductQueryFilter!, $skip: Int, $limit: Int) {
  products(filter: $filter, skip: $skip, limit: $limit) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($value: ProductInput!) {
  createProduct(value: $value) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($updateProductId: ID!, $value: ProductInput!) {
  updateProduct(id: $updateProductId, value: $value) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      updateProductId: // value for 'updateProductId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($tenantId: ID!, $deleteProductId: ID!) {
  deleteProduct(tenantId: $tenantId, id: $deleteProductId)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteProductId: // value for 'deleteProductId'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const PSConfigurationDocument = gql`
    query PSConfiguration($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    psConfigurations {
      ...PSConfiguration
    }
  }
}
    ${PSConfigurationFragmentDoc}`;

/**
 * __usePSConfigurationQuery__
 *
 * To run a query within a React component, call `usePSConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePSConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePSConfigurationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePSConfigurationQuery(baseOptions: Apollo.QueryHookOptions<PSConfigurationQuery, PSConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PSConfigurationQuery, PSConfigurationQueryVariables>(PSConfigurationDocument, options);
      }
export function usePSConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PSConfigurationQuery, PSConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PSConfigurationQuery, PSConfigurationQueryVariables>(PSConfigurationDocument, options);
        }
export type PSConfigurationQueryHookResult = ReturnType<typeof usePSConfigurationQuery>;
export type PSConfigurationLazyQueryHookResult = ReturnType<typeof usePSConfigurationLazyQuery>;
export type PSConfigurationQueryResult = Apollo.QueryResult<PSConfigurationQuery, PSConfigurationQueryVariables>;
export const SetPropertyPsConfigurationDocument = gql`
    mutation SetPropertyPsConfiguration($setPropertyPsConfigurationId: ID!, $config: [PsConfigurationInput!], $tenantId: ID!) {
  setPropertyPsConfiguration(
    id: $setPropertyPsConfigurationId
    config: $config
    tenantId: $tenantId
  )
}
    `;
export type SetPropertyPsConfigurationMutationFn = Apollo.MutationFunction<SetPropertyPsConfigurationMutation, SetPropertyPsConfigurationMutationVariables>;

/**
 * __useSetPropertyPsConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertyPsConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertyPsConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertyPsConfigurationMutation, { data, loading, error }] = useSetPropertyPsConfigurationMutation({
 *   variables: {
 *      setPropertyPsConfigurationId: // value for 'setPropertyPsConfigurationId'
 *      config: // value for 'config'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetPropertyPsConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertyPsConfigurationMutation, SetPropertyPsConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertyPsConfigurationMutation, SetPropertyPsConfigurationMutationVariables>(SetPropertyPsConfigurationDocument, options);
      }
export type SetPropertyPsConfigurationMutationHookResult = ReturnType<typeof useSetPropertyPsConfigurationMutation>;
export type SetPropertyPsConfigurationMutationResult = Apollo.MutationResult<SetPropertyPsConfigurationMutation>;
export type SetPropertyPsConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertyPsConfigurationMutation, SetPropertyPsConfigurationMutationVariables>;
export const PSResourcesDocument = gql`
    query PSResources($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    code
    codeItalianPs
    id
  }
}
    `;

/**
 * __usePSResourcesQuery__
 *
 * To run a query within a React component, call `usePSResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePSResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePSResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePSResourcesQuery(baseOptions: Apollo.QueryHookOptions<PSResourcesQuery, PSResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PSResourcesQuery, PSResourcesQueryVariables>(PSResourcesDocument, options);
      }
export function usePSResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PSResourcesQuery, PSResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PSResourcesQuery, PSResourcesQueryVariables>(PSResourcesDocument, options);
        }
export type PSResourcesQueryHookResult = ReturnType<typeof usePSResourcesQuery>;
export type PSResourcesLazyQueryHookResult = ReturnType<typeof usePSResourcesLazyQuery>;
export type PSResourcesQueryResult = Apollo.QueryResult<PSResourcesQuery, PSResourcesQueryVariables>;
export const TestPropertyPsConfigurationDocument = gql`
    query TestPropertyPsConfiguration($tenantId: ID!, $propertyId: ID!) {
  testPropertyPsConfiguration(tenantId: $tenantId, propertyId: $propertyId)
}
    `;

/**
 * __useTestPropertyPsConfigurationQuery__
 *
 * To run a query within a React component, call `useTestPropertyPsConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestPropertyPsConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestPropertyPsConfigurationQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useTestPropertyPsConfigurationQuery(baseOptions: Apollo.QueryHookOptions<TestPropertyPsConfigurationQuery, TestPropertyPsConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestPropertyPsConfigurationQuery, TestPropertyPsConfigurationQueryVariables>(TestPropertyPsConfigurationDocument, options);
      }
export function useTestPropertyPsConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestPropertyPsConfigurationQuery, TestPropertyPsConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestPropertyPsConfigurationQuery, TestPropertyPsConfigurationQueryVariables>(TestPropertyPsConfigurationDocument, options);
        }
export type TestPropertyPsConfigurationQueryHookResult = ReturnType<typeof useTestPropertyPsConfigurationQuery>;
export type TestPropertyPsConfigurationLazyQueryHookResult = ReturnType<typeof useTestPropertyPsConfigurationLazyQuery>;
export type TestPropertyPsConfigurationQueryResult = Apollo.QueryResult<TestPropertyPsConfigurationQuery, TestPropertyPsConfigurationQueryVariables>;
export const TaxonomiesDocument = gql`
    query Taxonomies($filter: TaxonomyQueryFilter!) {
  taxonomies(filter: $filter) {
    ...Taxonomy
  }
}
    ${TaxonomyFragmentDoc}`;

/**
 * __useTaxonomiesQuery__
 *
 * To run a query within a React component, call `useTaxonomiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTaxonomiesQuery(baseOptions: Apollo.QueryHookOptions<TaxonomiesQuery, TaxonomiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomiesQuery, TaxonomiesQueryVariables>(TaxonomiesDocument, options);
      }
export function useTaxonomiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomiesQuery, TaxonomiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomiesQuery, TaxonomiesQueryVariables>(TaxonomiesDocument, options);
        }
export type TaxonomiesQueryHookResult = ReturnType<typeof useTaxonomiesQuery>;
export type TaxonomiesLazyQueryHookResult = ReturnType<typeof useTaxonomiesLazyQuery>;
export type TaxonomiesQueryResult = Apollo.QueryResult<TaxonomiesQuery, TaxonomiesQueryVariables>;
export const AmenitiesDocument = gql`
    query Amenities($filter: AmenityQueryFilter!) {
  amenities(filter: $filter) {
    ...Amenity
  }
}
    ${AmenityFragmentDoc}`;

/**
 * __useAmenitiesQuery__
 *
 * To run a query within a React component, call `useAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAmenitiesQuery(baseOptions: Apollo.QueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
      }
export function useAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
        }
export type AmenitiesQueryHookResult = ReturnType<typeof useAmenitiesQuery>;
export type AmenitiesLazyQueryHookResult = ReturnType<typeof useAmenitiesLazyQuery>;
export type AmenitiesQueryResult = Apollo.QueryResult<AmenitiesQuery, AmenitiesQueryVariables>;
export const ResourceLayoutsDocument = gql`
    query ResourceLayouts($filter: ResourceLayoutQueryFilter!) {
  resourceLayouts(filter: $filter) {
    ...ResourceLayout
  }
}
    ${ResourceLayoutFragmentDoc}`;

/**
 * __useResourceLayoutsQuery__
 *
 * To run a query within a React component, call `useResourceLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceLayoutsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceLayoutsQuery(baseOptions: Apollo.QueryHookOptions<ResourceLayoutsQuery, ResourceLayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceLayoutsQuery, ResourceLayoutsQueryVariables>(ResourceLayoutsDocument, options);
      }
export function useResourceLayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceLayoutsQuery, ResourceLayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceLayoutsQuery, ResourceLayoutsQueryVariables>(ResourceLayoutsDocument, options);
        }
export type ResourceLayoutsQueryHookResult = ReturnType<typeof useResourceLayoutsQuery>;
export type ResourceLayoutsLazyQueryHookResult = ReturnType<typeof useResourceLayoutsLazyQuery>;
export type ResourceLayoutsQueryResult = Apollo.QueryResult<ResourceLayoutsQuery, ResourceLayoutsQueryVariables>;
export const CreateResourceTypeDocument = gql`
    mutation CreateResourceType($value: ResourceTypeInput!) {
  createResourceType(value: $value) {
    ...ResourceType
  }
}
    ${ResourceTypeFragmentDoc}`;
export type CreateResourceTypeMutationFn = Apollo.MutationFunction<CreateResourceTypeMutation, CreateResourceTypeMutationVariables>;

/**
 * __useCreateResourceTypeMutation__
 *
 * To run a mutation, you first call `useCreateResourceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceTypeMutation, { data, loading, error }] = useCreateResourceTypeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateResourceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceTypeMutation, CreateResourceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceTypeMutation, CreateResourceTypeMutationVariables>(CreateResourceTypeDocument, options);
      }
export type CreateResourceTypeMutationHookResult = ReturnType<typeof useCreateResourceTypeMutation>;
export type CreateResourceTypeMutationResult = Apollo.MutationResult<CreateResourceTypeMutation>;
export type CreateResourceTypeMutationOptions = Apollo.BaseMutationOptions<CreateResourceTypeMutation, CreateResourceTypeMutationVariables>;
export const ResourceTypesDocument = gql`
    query ResourceTypes($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    ...ResourceType
  }
}
    ${ResourceTypeFragmentDoc}`;

/**
 * __useResourceTypesQuery__
 *
 * To run a query within a React component, call `useResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypesQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, options);
      }
export function useResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesQuery, ResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesQuery, ResourceTypesQueryVariables>(ResourceTypesDocument, options);
        }
export type ResourceTypesQueryHookResult = ReturnType<typeof useResourceTypesQuery>;
export type ResourceTypesLazyQueryHookResult = ReturnType<typeof useResourceTypesLazyQuery>;
export type ResourceTypesQueryResult = Apollo.QueryResult<ResourceTypesQuery, ResourceTypesQueryVariables>;
export const ResourceTypesEssentialDocument = gql`
    query ResourceTypesEssential($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    ...ResourceTypeEssential
  }
}
    ${ResourceTypeEssentialFragmentDoc}`;

/**
 * __useResourceTypesEssentialQuery__
 *
 * To run a query within a React component, call `useResourceTypesEssentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesEssentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesEssentialQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypesEssentialQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypesEssentialQuery, ResourceTypesEssentialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesEssentialQuery, ResourceTypesEssentialQueryVariables>(ResourceTypesEssentialDocument, options);
      }
export function useResourceTypesEssentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesEssentialQuery, ResourceTypesEssentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesEssentialQuery, ResourceTypesEssentialQueryVariables>(ResourceTypesEssentialDocument, options);
        }
export type ResourceTypesEssentialQueryHookResult = ReturnType<typeof useResourceTypesEssentialQuery>;
export type ResourceTypesEssentialLazyQueryHookResult = ReturnType<typeof useResourceTypesEssentialLazyQuery>;
export type ResourceTypesEssentialQueryResult = Apollo.QueryResult<ResourceTypesEssentialQuery, ResourceTypesEssentialQueryVariables>;
export const ResourceTypeIdsDocument = gql`
    query ResourceTypeIds($filter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $filter) {
    id
  }
}
    `;

/**
 * __useResourceTypeIdsQuery__
 *
 * To run a query within a React component, call `useResourceTypeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypeIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourceTypeIdsQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypeIdsQuery, ResourceTypeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypeIdsQuery, ResourceTypeIdsQueryVariables>(ResourceTypeIdsDocument, options);
      }
export function useResourceTypeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypeIdsQuery, ResourceTypeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypeIdsQuery, ResourceTypeIdsQueryVariables>(ResourceTypeIdsDocument, options);
        }
export type ResourceTypeIdsQueryHookResult = ReturnType<typeof useResourceTypeIdsQuery>;
export type ResourceTypeIdsLazyQueryHookResult = ReturnType<typeof useResourceTypeIdsLazyQuery>;
export type ResourceTypeIdsQueryResult = Apollo.QueryResult<ResourceTypeIdsQuery, ResourceTypeIdsQueryVariables>;
export const DeleteResourceTypeDocument = gql`
    mutation DeleteResourceType($tenantId: ID!, $deleteResourceTypeId: String!) {
  deleteResourceType(tenantId: $tenantId, id: $deleteResourceTypeId)
}
    `;
export type DeleteResourceTypeMutationFn = Apollo.MutationFunction<DeleteResourceTypeMutation, DeleteResourceTypeMutationVariables>;

/**
 * __useDeleteResourceTypeMutation__
 *
 * To run a mutation, you first call `useDeleteResourceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceTypeMutation, { data, loading, error }] = useDeleteResourceTypeMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteResourceTypeId: // value for 'deleteResourceTypeId'
 *   },
 * });
 */
export function useDeleteResourceTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceTypeMutation, DeleteResourceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceTypeMutation, DeleteResourceTypeMutationVariables>(DeleteResourceTypeDocument, options);
      }
export type DeleteResourceTypeMutationHookResult = ReturnType<typeof useDeleteResourceTypeMutation>;
export type DeleteResourceTypeMutationResult = Apollo.MutationResult<DeleteResourceTypeMutation>;
export type DeleteResourceTypeMutationOptions = Apollo.BaseMutationOptions<DeleteResourceTypeMutation, DeleteResourceTypeMutationVariables>;
export const UpdateResourceTypeDocument = gql`
    mutation UpdateResourceType($updateResourceTypeId: String!, $value: ResourceTypeInput!) {
  updateResourceType(id: $updateResourceTypeId, value: $value) {
    ...ResourceType
  }
}
    ${ResourceTypeFragmentDoc}`;
export type UpdateResourceTypeMutationFn = Apollo.MutationFunction<UpdateResourceTypeMutation, UpdateResourceTypeMutationVariables>;

/**
 * __useUpdateResourceTypeMutation__
 *
 * To run a mutation, you first call `useUpdateResourceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceTypeMutation, { data, loading, error }] = useUpdateResourceTypeMutation({
 *   variables: {
 *      updateResourceTypeId: // value for 'updateResourceTypeId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateResourceTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceTypeMutation, UpdateResourceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceTypeMutation, UpdateResourceTypeMutationVariables>(UpdateResourceTypeDocument, options);
      }
export type UpdateResourceTypeMutationHookResult = ReturnType<typeof useUpdateResourceTypeMutation>;
export type UpdateResourceTypeMutationResult = Apollo.MutationResult<UpdateResourceTypeMutation>;
export type UpdateResourceTypeMutationOptions = Apollo.BaseMutationOptions<UpdateResourceTypeMutation, UpdateResourceTypeMutationVariables>;
export const OnboardingResourceTypeDocument = gql`
    mutation OnboardingResourceType($value: OnBoardingResourceTypeInput!) {
  onboardingResourceType(value: $value) {
    ...ResourceType
  }
}
    ${ResourceTypeFragmentDoc}`;
export type OnboardingResourceTypeMutationFn = Apollo.MutationFunction<OnboardingResourceTypeMutation, OnboardingResourceTypeMutationVariables>;

/**
 * __useOnboardingResourceTypeMutation__
 *
 * To run a mutation, you first call `useOnboardingResourceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingResourceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingResourceTypeMutation, { data, loading, error }] = useOnboardingResourceTypeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useOnboardingResourceTypeMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingResourceTypeMutation, OnboardingResourceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingResourceTypeMutation, OnboardingResourceTypeMutationVariables>(OnboardingResourceTypeDocument, options);
      }
export type OnboardingResourceTypeMutationHookResult = ReturnType<typeof useOnboardingResourceTypeMutation>;
export type OnboardingResourceTypeMutationResult = Apollo.MutationResult<OnboardingResourceTypeMutation>;
export type OnboardingResourceTypeMutationOptions = Apollo.BaseMutationOptions<OnboardingResourceTypeMutation, OnboardingResourceTypeMutationVariables>;
export const ResourcesDocument = gql`
    query Resources($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourcesQuery(baseOptions: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
      }
export function useResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
        }
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesLazyQueryHookResult = ReturnType<typeof useResourcesLazyQuery>;
export type ResourcesQueryResult = Apollo.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export const ResourcesLookupDocument = gql`
    query ResourcesLookup($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    ...ResourceLookupType
  }
}
    ${ResourceLookupTypeFragmentDoc}`;

/**
 * __useResourcesLookupQuery__
 *
 * To run a query within a React component, call `useResourcesLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesLookupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useResourcesLookupQuery(baseOptions: Apollo.QueryHookOptions<ResourcesLookupQuery, ResourcesLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesLookupQuery, ResourcesLookupQueryVariables>(ResourcesLookupDocument, options);
      }
export function useResourcesLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesLookupQuery, ResourcesLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesLookupQuery, ResourcesLookupQueryVariables>(ResourcesLookupDocument, options);
        }
export type ResourcesLookupQueryHookResult = ReturnType<typeof useResourcesLookupQuery>;
export type ResourcesLookupLazyQueryHookResult = ReturnType<typeof useResourcesLookupLazyQuery>;
export type ResourcesLookupQueryResult = Apollo.QueryResult<ResourcesLookupQuery, ResourcesLookupQueryVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($value: ResourceInput!) {
  createResource(value: $value) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($updateResourceId: String!, $value: ResourceInput!) {
  updateResource(id: $updateResourceId, value: $value) {
    id
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      updateResourceId: // value for 'updateResourceId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($tenantId: ID!, $deleteResourceId: String!) {
  deleteResource(tenantId: $tenantId, id: $deleteResourceId)
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      deleteResourceId: // value for 'deleteResourceId'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const UpdateResourcesRoomTetrisOrderDocument = gql`
    mutation UpdateResourcesRoomTetrisOrder($tenantId: ID!, $input: [UpdateResourceRoomTetrisOrderInput!]!) {
  updateResourcesRoomTetrisOrder(tenantId: $tenantId, input: $input)
}
    `;
export type UpdateResourcesRoomTetrisOrderMutationFn = Apollo.MutationFunction<UpdateResourcesRoomTetrisOrderMutation, UpdateResourcesRoomTetrisOrderMutationVariables>;

/**
 * __useUpdateResourcesRoomTetrisOrderMutation__
 *
 * To run a mutation, you first call `useUpdateResourcesRoomTetrisOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourcesRoomTetrisOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourcesRoomTetrisOrderMutation, { data, loading, error }] = useUpdateResourcesRoomTetrisOrderMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourcesRoomTetrisOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourcesRoomTetrisOrderMutation, UpdateResourcesRoomTetrisOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourcesRoomTetrisOrderMutation, UpdateResourcesRoomTetrisOrderMutationVariables>(UpdateResourcesRoomTetrisOrderDocument, options);
      }
export type UpdateResourcesRoomTetrisOrderMutationHookResult = ReturnType<typeof useUpdateResourcesRoomTetrisOrderMutation>;
export type UpdateResourcesRoomTetrisOrderMutationResult = Apollo.MutationResult<UpdateResourcesRoomTetrisOrderMutation>;
export type UpdateResourcesRoomTetrisOrderMutationOptions = Apollo.BaseMutationOptions<UpdateResourcesRoomTetrisOrderMutation, UpdateResourcesRoomTetrisOrderMutationVariables>;
export const TagsDocument = gql`
    query Tags($tenantId: ID!) {
  tags(filter: {tenantId: {eq: $tenantId}}) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TagNewDocument = gql`
    mutation TagNew($value: TagInput!) {
  createTag(value: $value) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type TagNewMutationFn = Apollo.MutationFunction<TagNewMutation, TagNewMutationVariables>;

/**
 * __useTagNewMutation__
 *
 * To run a mutation, you first call `useTagNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagNewMutation, { data, loading, error }] = useTagNewMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTagNewMutation(baseOptions?: Apollo.MutationHookOptions<TagNewMutation, TagNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagNewMutation, TagNewMutationVariables>(TagNewDocument, options);
      }
export type TagNewMutationHookResult = ReturnType<typeof useTagNewMutation>;
export type TagNewMutationResult = Apollo.MutationResult<TagNewMutation>;
export type TagNewMutationOptions = Apollo.BaseMutationOptions<TagNewMutation, TagNewMutationVariables>;
export const TagUpdateDocument = gql`
    mutation TagUpdate($id: String!, $value: TagInput!) {
  updateTag(id: $id, value: $value) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export type TagUpdateMutationFn = Apollo.MutationFunction<TagUpdateMutation, TagUpdateMutationVariables>;

/**
 * __useTagUpdateMutation__
 *
 * To run a mutation, you first call `useTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagUpdateMutation, { data, loading, error }] = useTagUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TagUpdateMutation, TagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagUpdateMutation, TagUpdateMutationVariables>(TagUpdateDocument, options);
      }
export type TagUpdateMutationHookResult = ReturnType<typeof useTagUpdateMutation>;
export type TagUpdateMutationResult = Apollo.MutationResult<TagUpdateMutation>;
export type TagUpdateMutationOptions = Apollo.BaseMutationOptions<TagUpdateMutation, TagUpdateMutationVariables>;
export const TagDeleteDocument = gql`
    mutation TagDelete($tenantId: ID!, $id: String!) {
  deleteTag(tenantId: $tenantId, id: $id)
}
    `;
export type TagDeleteMutationFn = Apollo.MutationFunction<TagDeleteMutation, TagDeleteMutationVariables>;

/**
 * __useTagDeleteMutation__
 *
 * To run a mutation, you first call `useTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDeleteMutation, { data, loading, error }] = useTagDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TagDeleteMutation, TagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagDeleteMutation, TagDeleteMutationVariables>(TagDeleteDocument, options);
      }
export type TagDeleteMutationHookResult = ReturnType<typeof useTagDeleteMutation>;
export type TagDeleteMutationResult = Apollo.MutationResult<TagDeleteMutation>;
export type TagDeleteMutationOptions = Apollo.BaseMutationOptions<TagDeleteMutation, TagDeleteMutationVariables>;
export const StartTsPayOnboardingDocument = gql`
    mutation StartTsPayOnboarding($tenantId: ID!, $propertyId: ID!, $vatNumber: String!) {
  startTsPayOnboarding(
    tenantId: $tenantId
    propertyId: $propertyId
    vatNumber: $vatNumber
  )
}
    `;
export type StartTsPayOnboardingMutationFn = Apollo.MutationFunction<StartTsPayOnboardingMutation, StartTsPayOnboardingMutationVariables>;

/**
 * __useStartTsPayOnboardingMutation__
 *
 * To run a mutation, you first call `useStartTsPayOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTsPayOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTsPayOnboardingMutation, { data, loading, error }] = useStartTsPayOnboardingMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      vatNumber: // value for 'vatNumber'
 *   },
 * });
 */
export function useStartTsPayOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<StartTsPayOnboardingMutation, StartTsPayOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTsPayOnboardingMutation, StartTsPayOnboardingMutationVariables>(StartTsPayOnboardingDocument, options);
      }
export type StartTsPayOnboardingMutationHookResult = ReturnType<typeof useStartTsPayOnboardingMutation>;
export type StartTsPayOnboardingMutationResult = Apollo.MutationResult<StartTsPayOnboardingMutation>;
export type StartTsPayOnboardingMutationOptions = Apollo.BaseMutationOptions<StartTsPayOnboardingMutation, StartTsPayOnboardingMutationVariables>;
export const TsPayOnboardingStateDocument = gql`
    query TsPayOnboardingState($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    fiscalConfigurations {
      default
      tspay {
        state
      }
    }
  }
}
    `;

/**
 * __useTsPayOnboardingStateQuery__
 *
 * To run a query within a React component, call `useTsPayOnboardingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTsPayOnboardingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTsPayOnboardingStateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTsPayOnboardingStateQuery(baseOptions: Apollo.QueryHookOptions<TsPayOnboardingStateQuery, TsPayOnboardingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TsPayOnboardingStateQuery, TsPayOnboardingStateQueryVariables>(TsPayOnboardingStateDocument, options);
      }
export function useTsPayOnboardingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TsPayOnboardingStateQuery, TsPayOnboardingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TsPayOnboardingStateQuery, TsPayOnboardingStateQueryVariables>(TsPayOnboardingStateDocument, options);
        }
export type TsPayOnboardingStateQueryHookResult = ReturnType<typeof useTsPayOnboardingStateQuery>;
export type TsPayOnboardingStateLazyQueryHookResult = ReturnType<typeof useTsPayOnboardingStateLazyQuery>;
export type TsPayOnboardingStateQueryResult = Apollo.QueryResult<TsPayOnboardingStateQuery, TsPayOnboardingStateQueryVariables>;
export const FiscalConfigurationsTsPayDocument = gql`
    query FiscalConfigurationsTsPay($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    fiscalConfigurations {
      default
      vatNumber
      tspay {
        merchantRef
        state
      }
    }
  }
}
    `;

/**
 * __useFiscalConfigurationsTsPayQuery__
 *
 * To run a query within a React component, call `useFiscalConfigurationsTsPayQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiscalConfigurationsTsPayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiscalConfigurationsTsPayQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFiscalConfigurationsTsPayQuery(baseOptions: Apollo.QueryHookOptions<FiscalConfigurationsTsPayQuery, FiscalConfigurationsTsPayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiscalConfigurationsTsPayQuery, FiscalConfigurationsTsPayQueryVariables>(FiscalConfigurationsTsPayDocument, options);
      }
export function useFiscalConfigurationsTsPayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiscalConfigurationsTsPayQuery, FiscalConfigurationsTsPayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiscalConfigurationsTsPayQuery, FiscalConfigurationsTsPayQueryVariables>(FiscalConfigurationsTsPayDocument, options);
        }
export type FiscalConfigurationsTsPayQueryHookResult = ReturnType<typeof useFiscalConfigurationsTsPayQuery>;
export type FiscalConfigurationsTsPayLazyQueryHookResult = ReturnType<typeof useFiscalConfigurationsTsPayLazyQuery>;
export type FiscalConfigurationsTsPayQueryResult = Apollo.QueryResult<FiscalConfigurationsTsPayQuery, FiscalConfigurationsTsPayQueryVariables>;
export const CreateLinkFroReservationDocument = gql`
    mutation CreateLinkFroReservation($tenantId: ID!, $propertyId: ID!, $reservationId: ID!, $payment: PaymentInput) {
  createLinkForReservation(
    input: {tenantId: $tenantId, propertyId: $propertyId, reservationId: $reservationId, payment: $payment}
  ) {
    url
    orderKey
    type
  }
}
    `;
export type CreateLinkFroReservationMutationFn = Apollo.MutationFunction<CreateLinkFroReservationMutation, CreateLinkFroReservationMutationVariables>;

/**
 * __useCreateLinkFroReservationMutation__
 *
 * To run a mutation, you first call `useCreateLinkFroReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkFroReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkFroReservationMutation, { data, loading, error }] = useCreateLinkFroReservationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      reservationId: // value for 'reservationId'
 *      payment: // value for 'payment'
 *   },
 * });
 */
export function useCreateLinkFroReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkFroReservationMutation, CreateLinkFroReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkFroReservationMutation, CreateLinkFroReservationMutationVariables>(CreateLinkFroReservationDocument, options);
      }
export type CreateLinkFroReservationMutationHookResult = ReturnType<typeof useCreateLinkFroReservationMutation>;
export type CreateLinkFroReservationMutationResult = Apollo.MutationResult<CreateLinkFroReservationMutation>;
export type CreateLinkFroReservationMutationOptions = Apollo.BaseMutationOptions<CreateLinkFroReservationMutation, CreateLinkFroReservationMutationVariables>;
export const CreateLink2PayPosOnlineDocument = gql`
    mutation CreateLink2PayPosOnline($input: Link2PayInput!) {
  createLink2PayPosOnLine(input: $input) {
    url
    orderKey
    type
  }
}
    `;
export type CreateLink2PayPosOnlineMutationFn = Apollo.MutationFunction<CreateLink2PayPosOnlineMutation, CreateLink2PayPosOnlineMutationVariables>;

/**
 * __useCreateLink2PayPosOnlineMutation__
 *
 * To run a mutation, you first call `useCreateLink2PayPosOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLink2PayPosOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLink2PayPosOnlineMutation, { data, loading, error }] = useCreateLink2PayPosOnlineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLink2PayPosOnlineMutation(baseOptions?: Apollo.MutationHookOptions<CreateLink2PayPosOnlineMutation, CreateLink2PayPosOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLink2PayPosOnlineMutation, CreateLink2PayPosOnlineMutationVariables>(CreateLink2PayPosOnlineDocument, options);
      }
export type CreateLink2PayPosOnlineMutationHookResult = ReturnType<typeof useCreateLink2PayPosOnlineMutation>;
export type CreateLink2PayPosOnlineMutationResult = Apollo.MutationResult<CreateLink2PayPosOnlineMutation>;
export type CreateLink2PayPosOnlineMutationOptions = Apollo.BaseMutationOptions<CreateLink2PayPosOnlineMutation, CreateLink2PayPosOnlineMutationVariables>;
export const TsPayLinkStatusDocument = gql`
    query TsPayLinkStatus($tenantId: ID!, $orderKey: String!) {
  tsPayLinks(tenantId: $tenantId, orderKey: $orderKey) {
    charges {
      state
      error {
        message
      }
    }
  }
}
    `;

/**
 * __useTsPayLinkStatusQuery__
 *
 * To run a query within a React component, call `useTsPayLinkStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTsPayLinkStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTsPayLinkStatusQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      orderKey: // value for 'orderKey'
 *   },
 * });
 */
export function useTsPayLinkStatusQuery(baseOptions: Apollo.QueryHookOptions<TsPayLinkStatusQuery, TsPayLinkStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TsPayLinkStatusQuery, TsPayLinkStatusQueryVariables>(TsPayLinkStatusDocument, options);
      }
export function useTsPayLinkStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TsPayLinkStatusQuery, TsPayLinkStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TsPayLinkStatusQuery, TsPayLinkStatusQueryVariables>(TsPayLinkStatusDocument, options);
        }
export type TsPayLinkStatusQueryHookResult = ReturnType<typeof useTsPayLinkStatusQuery>;
export type TsPayLinkStatusLazyQueryHookResult = ReturnType<typeof useTsPayLinkStatusLazyQuery>;
export type TsPayLinkStatusQueryResult = Apollo.QueryResult<TsPayLinkStatusQuery, TsPayLinkStatusQueryVariables>;
export const RolesDocument = gql`
    query Roles($filter: RoleQueryFilter) {
  roles(filter: $filter) {
    ...PropertyRole
  }
}
    ${PropertyRoleFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const UsersWithRolesDocument = gql`
    query UsersWithRoles($filter: UserQueryInput!) {
  users(filter: $filter) {
    ...UserWithRole
  }
}
    ${UserWithRoleFragmentDoc}`;

/**
 * __useUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersWithRolesQuery(baseOptions: Apollo.QueryHookOptions<UsersWithRolesQuery, UsersWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersWithRolesQuery, UsersWithRolesQueryVariables>(UsersWithRolesDocument, options);
      }
export function useUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersWithRolesQuery, UsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersWithRolesQuery, UsersWithRolesQueryVariables>(UsersWithRolesDocument, options);
        }
export type UsersWithRolesQueryHookResult = ReturnType<typeof useUsersWithRolesQuery>;
export type UsersWithRolesLazyQueryHookResult = ReturnType<typeof useUsersWithRolesLazyQuery>;
export type UsersWithRolesQueryResult = Apollo.QueryResult<UsersWithRolesQuery, UsersWithRolesQueryVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($updateUserRoleId: ID!, $value: [UserRoleInput!]!) {
  updateUserRole(id: $updateUserRoleId, value: $value)
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      updateUserRoleId: // value for 'updateUserRoleId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const CreateUserAndRoleDocument = gql`
    mutation CreateUserAndRole($input: UserInput!) {
  createUserAndRole(input: $input)
}
    `;
export type CreateUserAndRoleMutationFn = Apollo.MutationFunction<CreateUserAndRoleMutation, CreateUserAndRoleMutationVariables>;

/**
 * __useCreateUserAndRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserAndRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAndRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAndRoleMutation, { data, loading, error }] = useCreateUserAndRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAndRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAndRoleMutation, CreateUserAndRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAndRoleMutation, CreateUserAndRoleMutationVariables>(CreateUserAndRoleDocument, options);
      }
export type CreateUserAndRoleMutationHookResult = ReturnType<typeof useCreateUserAndRoleMutation>;
export type CreateUserAndRoleMutationResult = Apollo.MutationResult<CreateUserAndRoleMutation>;
export type CreateUserAndRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserAndRoleMutation, CreateUserAndRoleMutationVariables>;
export const VatsDocument = gql`
    query Vats($tenantId: ID!, $skip: Int, $limit: Int) {
  vats(filter: {tenantId: {eq: $tenantId}}, skip: $skip, limit: $limit) {
    ...Vat
  }
}
    ${VatFragmentDoc}`;

/**
 * __useVatsQuery__
 *
 * To run a query within a React component, call `useVatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVatsQuery(baseOptions: Apollo.QueryHookOptions<VatsQuery, VatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatsQuery, VatsQueryVariables>(VatsDocument, options);
      }
export function useVatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatsQuery, VatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatsQuery, VatsQueryVariables>(VatsDocument, options);
        }
export type VatsQueryHookResult = ReturnType<typeof useVatsQuery>;
export type VatsLazyQueryHookResult = ReturnType<typeof useVatsLazyQuery>;
export type VatsQueryResult = Apollo.QueryResult<VatsQuery, VatsQueryVariables>;
export const VatDocument = gql`
    query Vat($vatId: ID!, $tenantId: ID!) {
  vats(filter: {tenantId: {eq: $tenantId}, id: {eq: $vatId}}) {
    ...Vat
  }
}
    ${VatFragmentDoc}`;

/**
 * __useVatQuery__
 *
 * To run a query within a React component, call `useVatQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatQuery({
 *   variables: {
 *      vatId: // value for 'vatId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useVatQuery(baseOptions: Apollo.QueryHookOptions<VatQuery, VatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VatQuery, VatQueryVariables>(VatDocument, options);
      }
export function useVatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VatQuery, VatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VatQuery, VatQueryVariables>(VatDocument, options);
        }
export type VatQueryHookResult = ReturnType<typeof useVatQuery>;
export type VatLazyQueryHookResult = ReturnType<typeof useVatLazyQuery>;
export type VatQueryResult = Apollo.QueryResult<VatQuery, VatQueryVariables>;
export const VatNewDocument = gql`
    mutation VatNew($input: VatInput!) {
  createVat(value: $input) {
    ...Vat
  }
}
    ${VatFragmentDoc}`;
export type VatNewMutationFn = Apollo.MutationFunction<VatNewMutation, VatNewMutationVariables>;

/**
 * __useVatNewMutation__
 *
 * To run a mutation, you first call `useVatNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVatNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vatNewMutation, { data, loading, error }] = useVatNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVatNewMutation(baseOptions?: Apollo.MutationHookOptions<VatNewMutation, VatNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VatNewMutation, VatNewMutationVariables>(VatNewDocument, options);
      }
export type VatNewMutationHookResult = ReturnType<typeof useVatNewMutation>;
export type VatNewMutationResult = Apollo.MutationResult<VatNewMutation>;
export type VatNewMutationOptions = Apollo.BaseMutationOptions<VatNewMutation, VatNewMutationVariables>;
export const VatUpdateDocument = gql`
    mutation VatUpdate($id: String!, $input: VatInput!) {
  updateVat(id: $id, value: $input) {
    ...Vat
  }
}
    ${VatFragmentDoc}`;
export type VatUpdateMutationFn = Apollo.MutationFunction<VatUpdateMutation, VatUpdateMutationVariables>;

/**
 * __useVatUpdateMutation__
 *
 * To run a mutation, you first call `useVatUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVatUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vatUpdateMutation, { data, loading, error }] = useVatUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVatUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VatUpdateMutation, VatUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VatUpdateMutation, VatUpdateMutationVariables>(VatUpdateDocument, options);
      }
export type VatUpdateMutationHookResult = ReturnType<typeof useVatUpdateMutation>;
export type VatUpdateMutationResult = Apollo.MutationResult<VatUpdateMutation>;
export type VatUpdateMutationOptions = Apollo.BaseMutationOptions<VatUpdateMutation, VatUpdateMutationVariables>;
export const VatDeleteDocument = gql`
    mutation VatDelete($tenantId: ID!, $id: String!) {
  deleteVat(tenantId: $tenantId, id: $id)
}
    `;
export type VatDeleteMutationFn = Apollo.MutationFunction<VatDeleteMutation, VatDeleteMutationVariables>;

/**
 * __useVatDeleteMutation__
 *
 * To run a mutation, you first call `useVatDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVatDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vatDeleteMutation, { data, loading, error }] = useVatDeleteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVatDeleteMutation(baseOptions?: Apollo.MutationHookOptions<VatDeleteMutation, VatDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VatDeleteMutation, VatDeleteMutationVariables>(VatDeleteDocument, options);
      }
export type VatDeleteMutationHookResult = ReturnType<typeof useVatDeleteMutation>;
export type VatDeleteMutationResult = Apollo.MutationResult<VatDeleteMutation>;
export type VatDeleteMutationOptions = Apollo.BaseMutationOptions<VatDeleteMutation, VatDeleteMutationVariables>;
export const GetBasePriceResourceTypeAndRateForSinapsiDocument = gql`
    query GetBasePriceResourceTypeAndRateForSinapsi($priceCalendarFilter: PriceCalendarFilter!, $ratesFilter: RateQueryFilter!) {
  getPriceCalendar(filter: $priceCalendarFilter) {
    ...PriceCalendarSinapsi
  }
  rates(filter: $ratesFilter) {
    ...SinapsiRate
  }
}
    ${PriceCalendarSinapsiFragmentDoc}
${SinapsiRateFragmentDoc}`;

/**
 * __useGetBasePriceResourceTypeAndRateForSinapsiQuery__
 *
 * To run a query within a React component, call `useGetBasePriceResourceTypeAndRateForSinapsiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasePriceResourceTypeAndRateForSinapsiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasePriceResourceTypeAndRateForSinapsiQuery({
 *   variables: {
 *      priceCalendarFilter: // value for 'priceCalendarFilter'
 *      ratesFilter: // value for 'ratesFilter'
 *   },
 * });
 */
export function useGetBasePriceResourceTypeAndRateForSinapsiQuery(baseOptions: Apollo.QueryHookOptions<GetBasePriceResourceTypeAndRateForSinapsiQuery, GetBasePriceResourceTypeAndRateForSinapsiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasePriceResourceTypeAndRateForSinapsiQuery, GetBasePriceResourceTypeAndRateForSinapsiQueryVariables>(GetBasePriceResourceTypeAndRateForSinapsiDocument, options);
      }
export function useGetBasePriceResourceTypeAndRateForSinapsiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasePriceResourceTypeAndRateForSinapsiQuery, GetBasePriceResourceTypeAndRateForSinapsiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasePriceResourceTypeAndRateForSinapsiQuery, GetBasePriceResourceTypeAndRateForSinapsiQueryVariables>(GetBasePriceResourceTypeAndRateForSinapsiDocument, options);
        }
export type GetBasePriceResourceTypeAndRateForSinapsiQueryHookResult = ReturnType<typeof useGetBasePriceResourceTypeAndRateForSinapsiQuery>;
export type GetBasePriceResourceTypeAndRateForSinapsiLazyQueryHookResult = ReturnType<typeof useGetBasePriceResourceTypeAndRateForSinapsiLazyQuery>;
export type GetBasePriceResourceTypeAndRateForSinapsiQueryResult = Apollo.QueryResult<GetBasePriceResourceTypeAndRateForSinapsiQuery, GetBasePriceResourceTypeAndRateForSinapsiQueryVariables>;
export const GetSinapsiPricesDocument = gql`
    query GetSinapsiPrices($filter: SinapsiFilter!, $options: SinapsiQueryOptions!) {
  getSinapsiPrices(filter: $filter, options: $options) {
    ...SinapsiPrice
  }
}
    ${SinapsiPriceFragmentDoc}`;

/**
 * __useGetSinapsiPricesQuery__
 *
 * To run a query within a React component, call `useGetSinapsiPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinapsiPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinapsiPricesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetSinapsiPricesQuery(baseOptions: Apollo.QueryHookOptions<GetSinapsiPricesQuery, GetSinapsiPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSinapsiPricesQuery, GetSinapsiPricesQueryVariables>(GetSinapsiPricesDocument, options);
      }
export function useGetSinapsiPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinapsiPricesQuery, GetSinapsiPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSinapsiPricesQuery, GetSinapsiPricesQueryVariables>(GetSinapsiPricesDocument, options);
        }
export type GetSinapsiPricesQueryHookResult = ReturnType<typeof useGetSinapsiPricesQuery>;
export type GetSinapsiPricesLazyQueryHookResult = ReturnType<typeof useGetSinapsiPricesLazyQuery>;
export type GetSinapsiPricesQueryResult = Apollo.QueryResult<GetSinapsiPricesQuery, GetSinapsiPricesQueryVariables>;
export const UpdateSinapsiPriceCalendarDocument = gql`
    mutation UpdateSinapsiPriceCalendar($value: PriceCalendarInput!) {
  updatePriceCalendar(value: $value)
}
    `;
export type UpdateSinapsiPriceCalendarMutationFn = Apollo.MutationFunction<UpdateSinapsiPriceCalendarMutation, UpdateSinapsiPriceCalendarMutationVariables>;

/**
 * __useUpdateSinapsiPriceCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateSinapsiPriceCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSinapsiPriceCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSinapsiPriceCalendarMutation, { data, loading, error }] = useUpdateSinapsiPriceCalendarMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateSinapsiPriceCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSinapsiPriceCalendarMutation, UpdateSinapsiPriceCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSinapsiPriceCalendarMutation, UpdateSinapsiPriceCalendarMutationVariables>(UpdateSinapsiPriceCalendarDocument, options);
      }
export type UpdateSinapsiPriceCalendarMutationHookResult = ReturnType<typeof useUpdateSinapsiPriceCalendarMutation>;
export type UpdateSinapsiPriceCalendarMutationResult = Apollo.MutationResult<UpdateSinapsiPriceCalendarMutation>;
export type UpdateSinapsiPriceCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateSinapsiPriceCalendarMutation, UpdateSinapsiPriceCalendarMutationVariables>;
export const AuditLastTimeSavedDocument = gql`
    query AuditLastTimeSaved($filter: AuditQueryFilter!, $limit: Int, $sorts: [AuditSortInput!]) {
  audits(filter: $filter, limit: $limit, sorts: $sorts) {
    timestamp
  }
}
    `;

/**
 * __useAuditLastTimeSavedQuery__
 *
 * To run a query within a React component, call `useAuditLastTimeSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLastTimeSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLastTimeSavedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAuditLastTimeSavedQuery(baseOptions: Apollo.QueryHookOptions<AuditLastTimeSavedQuery, AuditLastTimeSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLastTimeSavedQuery, AuditLastTimeSavedQueryVariables>(AuditLastTimeSavedDocument, options);
      }
export function useAuditLastTimeSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLastTimeSavedQuery, AuditLastTimeSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLastTimeSavedQuery, AuditLastTimeSavedQueryVariables>(AuditLastTimeSavedDocument, options);
        }
export type AuditLastTimeSavedQueryHookResult = ReturnType<typeof useAuditLastTimeSavedQuery>;
export type AuditLastTimeSavedLazyQueryHookResult = ReturnType<typeof useAuditLastTimeSavedLazyQuery>;
export type AuditLastTimeSavedQueryResult = Apollo.QueryResult<AuditLastTimeSavedQuery, AuditLastTimeSavedQueryVariables>;
export const ResourceTypesForSinapsiDocument = gql`
    query ResourceTypesForSinapsi($resourceTypesFilter: ResourceTypeQueryFilter!) {
  resourceTypes(filter: $resourceTypesFilter) {
    ...ResourceTypeForSinapsi
  }
}
    ${ResourceTypeForSinapsiFragmentDoc}`;

/**
 * __useResourceTypesForSinapsiQuery__
 *
 * To run a query within a React component, call `useResourceTypesForSinapsiQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceTypesForSinapsiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceTypesForSinapsiQuery({
 *   variables: {
 *      resourceTypesFilter: // value for 'resourceTypesFilter'
 *   },
 * });
 */
export function useResourceTypesForSinapsiQuery(baseOptions: Apollo.QueryHookOptions<ResourceTypesForSinapsiQuery, ResourceTypesForSinapsiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceTypesForSinapsiQuery, ResourceTypesForSinapsiQueryVariables>(ResourceTypesForSinapsiDocument, options);
      }
export function useResourceTypesForSinapsiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceTypesForSinapsiQuery, ResourceTypesForSinapsiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceTypesForSinapsiQuery, ResourceTypesForSinapsiQueryVariables>(ResourceTypesForSinapsiDocument, options);
        }
export type ResourceTypesForSinapsiQueryHookResult = ReturnType<typeof useResourceTypesForSinapsiQuery>;
export type ResourceTypesForSinapsiLazyQueryHookResult = ReturnType<typeof useResourceTypesForSinapsiLazyQuery>;
export type ResourceTypesForSinapsiQueryResult = Apollo.QueryResult<ResourceTypesForSinapsiQuery, ResourceTypesForSinapsiQueryVariables>;
export const SinapsiConfigurationDocument = gql`
    query SinapsiConfiguration($propertiesFilter: PropertyQueryFilter!) {
  properties(filter: $propertiesFilter) {
    sinapsiConfiguration {
      ...SinapsiConfiguration
    }
  }
}
    ${SinapsiConfigurationFragmentDoc}`;

/**
 * __useSinapsiConfigurationQuery__
 *
 * To run a query within a React component, call `useSinapsiConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinapsiConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinapsiConfigurationQuery({
 *   variables: {
 *      propertiesFilter: // value for 'propertiesFilter'
 *   },
 * });
 */
export function useSinapsiConfigurationQuery(baseOptions: Apollo.QueryHookOptions<SinapsiConfigurationQuery, SinapsiConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SinapsiConfigurationQuery, SinapsiConfigurationQueryVariables>(SinapsiConfigurationDocument, options);
      }
export function useSinapsiConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SinapsiConfigurationQuery, SinapsiConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SinapsiConfigurationQuery, SinapsiConfigurationQueryVariables>(SinapsiConfigurationDocument, options);
        }
export type SinapsiConfigurationQueryHookResult = ReturnType<typeof useSinapsiConfigurationQuery>;
export type SinapsiConfigurationLazyQueryHookResult = ReturnType<typeof useSinapsiConfigurationLazyQuery>;
export type SinapsiConfigurationQueryResult = Apollo.QueryResult<SinapsiConfigurationQuery, SinapsiConfigurationQueryVariables>;
export const SetPropertySinapsiConfigurationDocument = gql`
    mutation SetPropertySinapsiConfiguration($tenantId: ID!, $propertyId: ID!, $config: SinapsiConfigurationInput!) {
  setPropertySinapsiConfiguration(
    tenantId: $tenantId
    id: $propertyId
    config: $config
  )
}
    `;
export type SetPropertySinapsiConfigurationMutationFn = Apollo.MutationFunction<SetPropertySinapsiConfigurationMutation, SetPropertySinapsiConfigurationMutationVariables>;

/**
 * __useSetPropertySinapsiConfigurationMutation__
 *
 * To run a mutation, you first call `useSetPropertySinapsiConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPropertySinapsiConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPropertySinapsiConfigurationMutation, { data, loading, error }] = useSetPropertySinapsiConfigurationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSetPropertySinapsiConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SetPropertySinapsiConfigurationMutation, SetPropertySinapsiConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPropertySinapsiConfigurationMutation, SetPropertySinapsiConfigurationMutationVariables>(SetPropertySinapsiConfigurationDocument, options);
      }
export type SetPropertySinapsiConfigurationMutationHookResult = ReturnType<typeof useSetPropertySinapsiConfigurationMutation>;
export type SetPropertySinapsiConfigurationMutationResult = Apollo.MutationResult<SetPropertySinapsiConfigurationMutation>;
export type SetPropertySinapsiConfigurationMutationOptions = Apollo.BaseMutationOptions<SetPropertySinapsiConfigurationMutation, SetPropertySinapsiConfigurationMutationVariables>;
export const MainSinapsiStatisticsDocument = gql`
    query MainSinapsiStatistics($tenantId: ID!, $propertyId: ID!, $mainStart: Date!, $mainEnd: Date!, $vatIncluded: Boolean!) {
  getStatistics(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $mainStart, end: $mainEnd, vatIncluded: $vatIncluded}
  ) {
    ...SinapsiStatistic
  }
}
    ${SinapsiStatisticFragmentDoc}`;

/**
 * __useMainSinapsiStatisticsQuery__
 *
 * To run a query within a React component, call `useMainSinapsiStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainSinapsiStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainSinapsiStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      mainStart: // value for 'mainStart'
 *      mainEnd: // value for 'mainEnd'
 *      vatIncluded: // value for 'vatIncluded'
 *   },
 * });
 */
export function useMainSinapsiStatisticsQuery(baseOptions: Apollo.QueryHookOptions<MainSinapsiStatisticsQuery, MainSinapsiStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainSinapsiStatisticsQuery, MainSinapsiStatisticsQueryVariables>(MainSinapsiStatisticsDocument, options);
      }
export function useMainSinapsiStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainSinapsiStatisticsQuery, MainSinapsiStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainSinapsiStatisticsQuery, MainSinapsiStatisticsQueryVariables>(MainSinapsiStatisticsDocument, options);
        }
export type MainSinapsiStatisticsQueryHookResult = ReturnType<typeof useMainSinapsiStatisticsQuery>;
export type MainSinapsiStatisticsLazyQueryHookResult = ReturnType<typeof useMainSinapsiStatisticsLazyQuery>;
export type MainSinapsiStatisticsQueryResult = Apollo.QueryResult<MainSinapsiStatisticsQuery, MainSinapsiStatisticsQueryVariables>;
export const ComparisonSinapsiStatisticsDocument = gql`
    query ComparisonSinapsiStatistics($tenantId: ID!, $propertyId: ID!, $comparisonStart: Date!, $comparisonEnd: Date!, $vatIncluded: Boolean!) {
  getStatistics(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $comparisonStart, end: $comparisonEnd, vatIncluded: $vatIncluded}
  ) {
    ...SinapsiStatistic
  }
}
    ${SinapsiStatisticFragmentDoc}`;

/**
 * __useComparisonSinapsiStatisticsQuery__
 *
 * To run a query within a React component, call `useComparisonSinapsiStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparisonSinapsiStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparisonSinapsiStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      comparisonStart: // value for 'comparisonStart'
 *      comparisonEnd: // value for 'comparisonEnd'
 *      vatIncluded: // value for 'vatIncluded'
 *   },
 * });
 */
export function useComparisonSinapsiStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ComparisonSinapsiStatisticsQuery, ComparisonSinapsiStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparisonSinapsiStatisticsQuery, ComparisonSinapsiStatisticsQueryVariables>(ComparisonSinapsiStatisticsDocument, options);
      }
export function useComparisonSinapsiStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparisonSinapsiStatisticsQuery, ComparisonSinapsiStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparisonSinapsiStatisticsQuery, ComparisonSinapsiStatisticsQueryVariables>(ComparisonSinapsiStatisticsDocument, options);
        }
export type ComparisonSinapsiStatisticsQueryHookResult = ReturnType<typeof useComparisonSinapsiStatisticsQuery>;
export type ComparisonSinapsiStatisticsLazyQueryHookResult = ReturnType<typeof useComparisonSinapsiStatisticsLazyQuery>;
export type ComparisonSinapsiStatisticsQueryResult = Apollo.QueryResult<ComparisonSinapsiStatisticsQuery, ComparisonSinapsiStatisticsQueryVariables>;
export const ComparisonWithOnTheBookSinapsiStatisticsDocument = gql`
    query ComparisonWithOnTheBookSinapsiStatistics($tenantId: ID!, $propertyId: ID!, $comparisonStart: Date!, $comparisonEnd: Date!, $vatIncluded: Boolean!, $dateFrom: Date) {
  getStatistics(
    filter: {tenantId: $tenantId, propertyId: $propertyId, start: $comparisonStart, end: $comparisonEnd, vatIncluded: $vatIncluded, dateFrom: $dateFrom}
  ) {
    ...SinapsiStatistic
  }
}
    ${SinapsiStatisticFragmentDoc}`;

/**
 * __useComparisonWithOnTheBookSinapsiStatisticsQuery__
 *
 * To run a query within a React component, call `useComparisonWithOnTheBookSinapsiStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparisonWithOnTheBookSinapsiStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparisonWithOnTheBookSinapsiStatisticsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      comparisonStart: // value for 'comparisonStart'
 *      comparisonEnd: // value for 'comparisonEnd'
 *      vatIncluded: // value for 'vatIncluded'
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useComparisonWithOnTheBookSinapsiStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ComparisonWithOnTheBookSinapsiStatisticsQuery, ComparisonWithOnTheBookSinapsiStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparisonWithOnTheBookSinapsiStatisticsQuery, ComparisonWithOnTheBookSinapsiStatisticsQueryVariables>(ComparisonWithOnTheBookSinapsiStatisticsDocument, options);
      }
export function useComparisonWithOnTheBookSinapsiStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparisonWithOnTheBookSinapsiStatisticsQuery, ComparisonWithOnTheBookSinapsiStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparisonWithOnTheBookSinapsiStatisticsQuery, ComparisonWithOnTheBookSinapsiStatisticsQueryVariables>(ComparisonWithOnTheBookSinapsiStatisticsDocument, options);
        }
export type ComparisonWithOnTheBookSinapsiStatisticsQueryHookResult = ReturnType<typeof useComparisonWithOnTheBookSinapsiStatisticsQuery>;
export type ComparisonWithOnTheBookSinapsiStatisticsLazyQueryHookResult = ReturnType<typeof useComparisonWithOnTheBookSinapsiStatisticsLazyQuery>;
export type ComparisonWithOnTheBookSinapsiStatisticsQueryResult = Apollo.QueryResult<ComparisonWithOnTheBookSinapsiStatisticsQuery, ComparisonWithOnTheBookSinapsiStatisticsQueryVariables>;
export const GetSinapsiDailyPriceAuditDocument = gql`
    query GetSinapsiDailyPriceAudit($filter: SinapsiDailyPriceAuditFilterInput!) {
  getSinapsiDailyPriceAudit(filter: $filter) {
    price
    timestamp
  }
}
    `;

/**
 * __useGetSinapsiDailyPriceAuditQuery__
 *
 * To run a query within a React component, call `useGetSinapsiDailyPriceAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinapsiDailyPriceAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinapsiDailyPriceAuditQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSinapsiDailyPriceAuditQuery(baseOptions: Apollo.QueryHookOptions<GetSinapsiDailyPriceAuditQuery, GetSinapsiDailyPriceAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSinapsiDailyPriceAuditQuery, GetSinapsiDailyPriceAuditQueryVariables>(GetSinapsiDailyPriceAuditDocument, options);
      }
export function useGetSinapsiDailyPriceAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinapsiDailyPriceAuditQuery, GetSinapsiDailyPriceAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSinapsiDailyPriceAuditQuery, GetSinapsiDailyPriceAuditQueryVariables>(GetSinapsiDailyPriceAuditDocument, options);
        }
export type GetSinapsiDailyPriceAuditQueryHookResult = ReturnType<typeof useGetSinapsiDailyPriceAuditQuery>;
export type GetSinapsiDailyPriceAuditLazyQueryHookResult = ReturnType<typeof useGetSinapsiDailyPriceAuditLazyQuery>;
export type GetSinapsiDailyPriceAuditQueryResult = Apollo.QueryResult<GetSinapsiDailyPriceAuditQuery, GetSinapsiDailyPriceAuditQueryVariables>;
export const TenantCompanyInfoDocument = gql`
    query TenantCompanyInfo($tenantId: ID!) {
  tenants(filter: {id: {eq: $tenantId}}) {
    description
    vatNumber
  }
}
    `;

/**
 * __useTenantCompanyInfoQuery__
 *
 * To run a query within a React component, call `useTenantCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantCompanyInfoQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTenantCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<TenantCompanyInfoQuery, TenantCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantCompanyInfoQuery, TenantCompanyInfoQueryVariables>(TenantCompanyInfoDocument, options);
      }
export function useTenantCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantCompanyInfoQuery, TenantCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantCompanyInfoQuery, TenantCompanyInfoQueryVariables>(TenantCompanyInfoDocument, options);
        }
export type TenantCompanyInfoQueryHookResult = ReturnType<typeof useTenantCompanyInfoQuery>;
export type TenantCompanyInfoLazyQueryHookResult = ReturnType<typeof useTenantCompanyInfoLazyQuery>;
export type TenantCompanyInfoQueryResult = Apollo.QueryResult<TenantCompanyInfoQuery, TenantCompanyInfoQueryVariables>;
export const ThreadsDocument = gql`
    query Threads($filter: ThreadQueryFilter!) {
  threads(filter: $filter) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useThreadsQuery__
 *
 * To run a query within a React component, call `useThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useThreadsQuery(baseOptions: Apollo.QueryHookOptions<ThreadsQuery, ThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadsQuery, ThreadsQueryVariables>(ThreadsDocument, options);
      }
export function useThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadsQuery, ThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadsQuery, ThreadsQueryVariables>(ThreadsDocument, options);
        }
export type ThreadsQueryHookResult = ReturnType<typeof useThreadsQuery>;
export type ThreadsLazyQueryHookResult = ReturnType<typeof useThreadsLazyQuery>;
export type ThreadsQueryResult = Apollo.QueryResult<ThreadsQuery, ThreadsQueryVariables>;
export const ThreadMessagesDocument = gql`
    query ThreadMessages($filter: ThreadMessageQueryFilter!) {
  threadMessages(filter: $filter) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;

/**
 * __useThreadMessagesQuery__
 *
 * To run a query within a React component, call `useThreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useThreadMessagesQuery(baseOptions: Apollo.QueryHookOptions<ThreadMessagesQuery, ThreadMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadMessagesQuery, ThreadMessagesQueryVariables>(ThreadMessagesDocument, options);
      }
export function useThreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadMessagesQuery, ThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadMessagesQuery, ThreadMessagesQueryVariables>(ThreadMessagesDocument, options);
        }
export type ThreadMessagesQueryHookResult = ReturnType<typeof useThreadMessagesQuery>;
export type ThreadMessagesLazyQueryHookResult = ReturnType<typeof useThreadMessagesLazyQuery>;
export type ThreadMessagesQueryResult = Apollo.QueryResult<ThreadMessagesQuery, ThreadMessagesQueryVariables>;
export const UpdateThreadDocument = gql`
    mutation UpdateThread($input: UpdateThreadInput!) {
  updateThread(input: $input)
}
    `;
export type UpdateThreadMutationFn = Apollo.MutationFunction<UpdateThreadMutation, UpdateThreadMutationVariables>;

/**
 * __useUpdateThreadMutation__
 *
 * To run a mutation, you first call `useUpdateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreadMutation, { data, loading, error }] = useUpdateThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThreadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreadMutation, UpdateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreadMutation, UpdateThreadMutationVariables>(UpdateThreadDocument, options);
      }
export type UpdateThreadMutationHookResult = ReturnType<typeof useUpdateThreadMutation>;
export type UpdateThreadMutationResult = Apollo.MutationResult<UpdateThreadMutation>;
export type UpdateThreadMutationOptions = Apollo.BaseMutationOptions<UpdateThreadMutation, UpdateThreadMutationVariables>;
export const DeleteInternalThreadMessageDocument = gql`
    mutation DeleteInternalThreadMessage($tenantId: ID!, $threadMessageId: ID!) {
  deleteInternalThreadMessage(
    tenantId: $tenantId
    threadMessageId: $threadMessageId
  )
}
    `;
export type DeleteInternalThreadMessageMutationFn = Apollo.MutationFunction<DeleteInternalThreadMessageMutation, DeleteInternalThreadMessageMutationVariables>;

/**
 * __useDeleteInternalThreadMessageMutation__
 *
 * To run a mutation, you first call `useDeleteInternalThreadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalThreadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalThreadMessageMutation, { data, loading, error }] = useDeleteInternalThreadMessageMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      threadMessageId: // value for 'threadMessageId'
 *   },
 * });
 */
export function useDeleteInternalThreadMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternalThreadMessageMutation, DeleteInternalThreadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternalThreadMessageMutation, DeleteInternalThreadMessageMutationVariables>(DeleteInternalThreadMessageDocument, options);
      }
export type DeleteInternalThreadMessageMutationHookResult = ReturnType<typeof useDeleteInternalThreadMessageMutation>;
export type DeleteInternalThreadMessageMutationResult = Apollo.MutationResult<DeleteInternalThreadMessageMutation>;
export type DeleteInternalThreadMessageMutationOptions = Apollo.BaseMutationOptions<DeleteInternalThreadMessageMutation, DeleteInternalThreadMessageMutationVariables>;
export const SendThreadMessageDocument = gql`
    mutation SendThreadMessage($input: SendMessageInput!) {
  sendThreadMessage(input: $input)
}
    `;
export type SendThreadMessageMutationFn = Apollo.MutationFunction<SendThreadMessageMutation, SendThreadMessageMutationVariables>;

/**
 * __useSendThreadMessageMutation__
 *
 * To run a mutation, you first call `useSendThreadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendThreadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendThreadMessageMutation, { data, loading, error }] = useSendThreadMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendThreadMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendThreadMessageMutation, SendThreadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendThreadMessageMutation, SendThreadMessageMutationVariables>(SendThreadMessageDocument, options);
      }
export type SendThreadMessageMutationHookResult = ReturnType<typeof useSendThreadMessageMutation>;
export type SendThreadMessageMutationResult = Apollo.MutationResult<SendThreadMessageMutation>;
export type SendThreadMessageMutationOptions = Apollo.BaseMutationOptions<SendThreadMessageMutation, SendThreadMessageMutationVariables>;
export const ReservationThreadsDocument = gql`
    query ReservationThreads($filter: ThreadQueryFilter!) {
  threads(filter: $filter) {
    ...ReservationThread
  }
}
    ${ReservationThreadFragmentDoc}`;

/**
 * __useReservationThreadsQuery__
 *
 * To run a query within a React component, call `useReservationThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationThreadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReservationThreadsQuery(baseOptions: Apollo.QueryHookOptions<ReservationThreadsQuery, ReservationThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationThreadsQuery, ReservationThreadsQueryVariables>(ReservationThreadsDocument, options);
      }
export function useReservationThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationThreadsQuery, ReservationThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationThreadsQuery, ReservationThreadsQueryVariables>(ReservationThreadsDocument, options);
        }
export type ReservationThreadsQueryHookResult = ReturnType<typeof useReservationThreadsQuery>;
export type ReservationThreadsLazyQueryHookResult = ReturnType<typeof useReservationThreadsLazyQuery>;
export type ReservationThreadsQueryResult = Apollo.QueryResult<ReservationThreadsQuery, ReservationThreadsQueryVariables>;
export const NewThreadMessageEventDocument = gql`
    subscription NewThreadMessageEvent($filter: NewThreadMessageEventFilter!) {
  newThreadMessageEvent(filter: $filter) {
    threadId
  }
}
    `;

/**
 * __useNewThreadMessageEventSubscription__
 *
 * To run a query within a React component, call `useNewThreadMessageEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewThreadMessageEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewThreadMessageEventSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNewThreadMessageEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewThreadMessageEventSubscription, NewThreadMessageEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewThreadMessageEventSubscription, NewThreadMessageEventSubscriptionVariables>(NewThreadMessageEventDocument, options);
      }
export type NewThreadMessageEventSubscriptionHookResult = ReturnType<typeof useNewThreadMessageEventSubscription>;
export type NewThreadMessageEventSubscriptionResult = Apollo.SubscriptionResult<NewThreadMessageEventSubscription>;
export const GetBuyNowUrlFromStoreDocument = gql`
    query GetBuyNowUrlFromStore($request: StoreUpgradeInput!) {
  getUrlFromStore(request: $request) {
    url
  }
}
    `;

/**
 * __useGetBuyNowUrlFromStoreQuery__
 *
 * To run a query within a React component, call `useGetBuyNowUrlFromStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyNowUrlFromStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyNowUrlFromStoreQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetBuyNowUrlFromStoreQuery(baseOptions: Apollo.QueryHookOptions<GetBuyNowUrlFromStoreQuery, GetBuyNowUrlFromStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyNowUrlFromStoreQuery, GetBuyNowUrlFromStoreQueryVariables>(GetBuyNowUrlFromStoreDocument, options);
      }
export function useGetBuyNowUrlFromStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyNowUrlFromStoreQuery, GetBuyNowUrlFromStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyNowUrlFromStoreQuery, GetBuyNowUrlFromStoreQueryVariables>(GetBuyNowUrlFromStoreDocument, options);
        }
export type GetBuyNowUrlFromStoreQueryHookResult = ReturnType<typeof useGetBuyNowUrlFromStoreQuery>;
export type GetBuyNowUrlFromStoreLazyQueryHookResult = ReturnType<typeof useGetBuyNowUrlFromStoreLazyQuery>;
export type GetBuyNowUrlFromStoreQueryResult = Apollo.QueryResult<GetBuyNowUrlFromStoreQuery, GetBuyNowUrlFromStoreQueryVariables>;
export const PropertyClassTypeDocument = gql`
    query PropertyClassType($filter: PropertyQueryFilter!) {
  properties(filter: $filter) {
    classType {
      id
      description
    }
  }
}
    `;

/**
 * __usePropertyClassTypeQuery__
 *
 * To run a query within a React component, call `usePropertyClassTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyClassTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyClassTypeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyClassTypeQuery(baseOptions: Apollo.QueryHookOptions<PropertyClassTypeQuery, PropertyClassTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyClassTypeQuery, PropertyClassTypeQueryVariables>(PropertyClassTypeDocument, options);
      }
export function usePropertyClassTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyClassTypeQuery, PropertyClassTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyClassTypeQuery, PropertyClassTypeQueryVariables>(PropertyClassTypeDocument, options);
        }
export type PropertyClassTypeQueryHookResult = ReturnType<typeof usePropertyClassTypeQuery>;
export type PropertyClassTypeLazyQueryHookResult = ReturnType<typeof usePropertyClassTypeLazyQuery>;
export type PropertyClassTypeQueryResult = Apollo.QueryResult<PropertyClassTypeQuery, PropertyClassTypeQueryVariables>;
export const HowManyResourcesDocument = gql`
    query HowManyResources($filter: ResourceQueryFilter!) {
  resources(filter: $filter) {
    id
  }
}
    `;

/**
 * __useHowManyResourcesQuery__
 *
 * To run a query within a React component, call `useHowManyResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHowManyResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHowManyResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHowManyResourcesQuery(baseOptions: Apollo.QueryHookOptions<HowManyResourcesQuery, HowManyResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HowManyResourcesQuery, HowManyResourcesQueryVariables>(HowManyResourcesDocument, options);
      }
export function useHowManyResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HowManyResourcesQuery, HowManyResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HowManyResourcesQuery, HowManyResourcesQueryVariables>(HowManyResourcesDocument, options);
        }
export type HowManyResourcesQueryHookResult = ReturnType<typeof useHowManyResourcesQuery>;
export type HowManyResourcesLazyQueryHookResult = ReturnType<typeof useHowManyResourcesLazyQuery>;
export type HowManyResourcesQueryResult = Apollo.QueryResult<HowManyResourcesQuery, HowManyResourcesQueryVariables>;
export const GetCatalogFromStoreDocument = gql`
    query GetCatalogFromStore($tenantId: ID!) {
  getCatalogFromStore(tenantId: $tenantId) {
    ...StoreCatalog
  }
}
    ${StoreCatalogFragmentDoc}`;

/**
 * __useGetCatalogFromStoreQuery__
 *
 * To run a query within a React component, call `useGetCatalogFromStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogFromStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogFromStoreQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetCatalogFromStoreQuery(baseOptions: Apollo.QueryHookOptions<GetCatalogFromStoreQuery, GetCatalogFromStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogFromStoreQuery, GetCatalogFromStoreQueryVariables>(GetCatalogFromStoreDocument, options);
      }
export function useGetCatalogFromStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogFromStoreQuery, GetCatalogFromStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogFromStoreQuery, GetCatalogFromStoreQueryVariables>(GetCatalogFromStoreDocument, options);
        }
export type GetCatalogFromStoreQueryHookResult = ReturnType<typeof useGetCatalogFromStoreQuery>;
export type GetCatalogFromStoreLazyQueryHookResult = ReturnType<typeof useGetCatalogFromStoreLazyQuery>;
export type GetCatalogFromStoreQueryResult = Apollo.QueryResult<GetCatalogFromStoreQuery, GetCatalogFromStoreQueryVariables>;
export const GetSubscriptionStoreDocument = gql`
    query GetSubscriptionStore($input: SubscriptionInfoInput!) {
  getSubscriptionStore(input: $input)
}
    `;

/**
 * __useGetSubscriptionStoreQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionStoreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSubscriptionStoreQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionStoreQuery, GetSubscriptionStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionStoreQuery, GetSubscriptionStoreQueryVariables>(GetSubscriptionStoreDocument, options);
      }
export function useGetSubscriptionStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionStoreQuery, GetSubscriptionStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionStoreQuery, GetSubscriptionStoreQueryVariables>(GetSubscriptionStoreDocument, options);
        }
export type GetSubscriptionStoreQueryHookResult = ReturnType<typeof useGetSubscriptionStoreQuery>;
export type GetSubscriptionStoreLazyQueryHookResult = ReturnType<typeof useGetSubscriptionStoreLazyQuery>;
export type GetSubscriptionStoreQueryResult = Apollo.QueryResult<GetSubscriptionStoreQuery, GetSubscriptionStoreQueryVariables>;
export const CountriesDocument = gql`
    query Countries($filter: CountryQueryFilter) {
  countries(filter: $filter) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const MunicipalitiesDocument = gql`
    query Municipalities($filter: MunicipalityQueryFilter, $limit: Int) {
  municipalities(filter: $filter, limit: $limit) {
    ...Municipality
  }
}
    ${MunicipalityFragmentDoc}`;

/**
 * __useMunicipalitiesQuery__
 *
 * To run a query within a React component, call `useMunicipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMunicipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMunicipalitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMunicipalitiesQuery(baseOptions?: Apollo.QueryHookOptions<MunicipalitiesQuery, MunicipalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MunicipalitiesQuery, MunicipalitiesQueryVariables>(MunicipalitiesDocument, options);
      }
export function useMunicipalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MunicipalitiesQuery, MunicipalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MunicipalitiesQuery, MunicipalitiesQueryVariables>(MunicipalitiesDocument, options);
        }
export type MunicipalitiesQueryHookResult = ReturnType<typeof useMunicipalitiesQuery>;
export type MunicipalitiesLazyQueryHookResult = ReturnType<typeof useMunicipalitiesLazyQuery>;
export type MunicipalitiesQueryResult = Apollo.QueryResult<MunicipalitiesQuery, MunicipalitiesQueryVariables>;
export const CountriesMunicipalitiesDocument = gql`
    query CountriesMunicipalities($countryFilter: CountryQueryFilter!, $municipalityFilter: MunicipalityQueryFilter!, $limit: Int) {
  countries(filter: $countryFilter, limit: $limit) {
    ...Country
  }
  municipalities(filter: $municipalityFilter, limit: $limit) {
    ...Municipality
  }
  italy: countries(filter: {isoCode: {eq: "IT"}}, limit: 1) {
    ...Country
  }
}
    ${CountryFragmentDoc}
${MunicipalityFragmentDoc}`;

/**
 * __useCountriesMunicipalitiesQuery__
 *
 * To run a query within a React component, call `useCountriesMunicipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesMunicipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesMunicipalitiesQuery({
 *   variables: {
 *      countryFilter: // value for 'countryFilter'
 *      municipalityFilter: // value for 'municipalityFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCountriesMunicipalitiesQuery(baseOptions: Apollo.QueryHookOptions<CountriesMunicipalitiesQuery, CountriesMunicipalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesMunicipalitiesQuery, CountriesMunicipalitiesQueryVariables>(CountriesMunicipalitiesDocument, options);
      }
export function useCountriesMunicipalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesMunicipalitiesQuery, CountriesMunicipalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesMunicipalitiesQuery, CountriesMunicipalitiesQueryVariables>(CountriesMunicipalitiesDocument, options);
        }
export type CountriesMunicipalitiesQueryHookResult = ReturnType<typeof useCountriesMunicipalitiesQuery>;
export type CountriesMunicipalitiesLazyQueryHookResult = ReturnType<typeof useCountriesMunicipalitiesLazyQuery>;
export type CountriesMunicipalitiesQueryResult = Apollo.QueryResult<CountriesMunicipalitiesQuery, CountriesMunicipalitiesQueryVariables>;
export const CashDeskTypesDocument = gql`
    query CashDeskTypes($tenantId: ID!, $propertyId: ID!) {
  cashDeskTypes(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}}
  ) {
    ...CashDeskType
  }
}
    ${CashDeskTypeFragmentDoc}`;

/**
 * __useCashDeskTypesQuery__
 *
 * To run a query within a React component, call `useCashDeskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDeskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDeskTypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useCashDeskTypesQuery(baseOptions: Apollo.QueryHookOptions<CashDeskTypesQuery, CashDeskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDeskTypesQuery, CashDeskTypesQueryVariables>(CashDeskTypesDocument, options);
      }
export function useCashDeskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDeskTypesQuery, CashDeskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDeskTypesQuery, CashDeskTypesQueryVariables>(CashDeskTypesDocument, options);
        }
export type CashDeskTypesQueryHookResult = ReturnType<typeof useCashDeskTypesQuery>;
export type CashDeskTypesLazyQueryHookResult = ReturnType<typeof useCashDeskTypesLazyQuery>;
export type CashDeskTypesQueryResult = Apollo.QueryResult<CashDeskTypesQuery, CashDeskTypesQueryVariables>;
export const CreateFiscalGatewayWorkstationDocument = gql`
    mutation CreateFiscalGatewayWorkstation($tenantId: ID!, $name: String!, $cashDeskTypeId: ID!) {
  createFiscalGatewayWorkstation(
    tenantId: $tenantId
    name: $name
    cashDeskTypeId: $cashDeskTypeId
  ) {
    ...FiscalGatewayWorkstation
  }
}
    ${FiscalGatewayWorkstationFragmentDoc}`;
export type CreateFiscalGatewayWorkstationMutationFn = Apollo.MutationFunction<CreateFiscalGatewayWorkstationMutation, CreateFiscalGatewayWorkstationMutationVariables>;

/**
 * __useCreateFiscalGatewayWorkstationMutation__
 *
 * To run a mutation, you first call `useCreateFiscalGatewayWorkstationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFiscalGatewayWorkstationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFiscalGatewayWorkstationMutation, { data, loading, error }] = useCreateFiscalGatewayWorkstationMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      name: // value for 'name'
 *      cashDeskTypeId: // value for 'cashDeskTypeId'
 *   },
 * });
 */
export function useCreateFiscalGatewayWorkstationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFiscalGatewayWorkstationMutation, CreateFiscalGatewayWorkstationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFiscalGatewayWorkstationMutation, CreateFiscalGatewayWorkstationMutationVariables>(CreateFiscalGatewayWorkstationDocument, options);
      }
export type CreateFiscalGatewayWorkstationMutationHookResult = ReturnType<typeof useCreateFiscalGatewayWorkstationMutation>;
export type CreateFiscalGatewayWorkstationMutationResult = Apollo.MutationResult<CreateFiscalGatewayWorkstationMutation>;
export type CreateFiscalGatewayWorkstationMutationOptions = Apollo.BaseMutationOptions<CreateFiscalGatewayWorkstationMutation, CreateFiscalGatewayWorkstationMutationVariables>;
export const CashDesksDocument = gql`
    query CashDesks($tenantId: ID!, $propertyId: ID!, $cashDeskId: IDFilter, $open: Boolean) {
  cashDesks(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: $cashDeskId, open: $open}
  ) {
    ...CashDesk
  }
  properties(filter: {tenantId: {eq: $tenantId}, id: {eq: $propertyId}}) {
    ...PropertyFiscalConfigurations
  }
}
    ${CashDeskFragmentDoc}
${PropertyFiscalConfigurationsFragmentDoc}`;

/**
 * __useCashDesksQuery__
 *
 * To run a query within a React component, call `useCashDesksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashDesksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashDesksQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      cashDeskId: // value for 'cashDeskId'
 *      open: // value for 'open'
 *   },
 * });
 */
export function useCashDesksQuery(baseOptions: Apollo.QueryHookOptions<CashDesksQuery, CashDesksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashDesksQuery, CashDesksQueryVariables>(CashDesksDocument, options);
      }
export function useCashDesksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashDesksQuery, CashDesksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashDesksQuery, CashDesksQueryVariables>(CashDesksDocument, options);
        }
export type CashDesksQueryHookResult = ReturnType<typeof useCashDesksQuery>;
export type CashDesksLazyQueryHookResult = ReturnType<typeof useCashDesksLazyQuery>;
export type CashDesksQueryResult = Apollo.QueryResult<CashDesksQuery, CashDesksQueryVariables>;
export const CervedAdvancedSearchDocument = gql`
    query CervedAdvancedSearch($searchText: String, $vatNumber: String) {
  cervedAdvancedSearch(input: {searchText: $searchText, vatNumber: $vatNumber}) {
    subjects {
      ...CervedSubject
    }
  }
}
    ${CervedSubjectFragmentDoc}`;

/**
 * __useCervedAdvancedSearchQuery__
 *
 * To run a query within a React component, call `useCervedAdvancedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCervedAdvancedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCervedAdvancedSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      vatNumber: // value for 'vatNumber'
 *   },
 * });
 */
export function useCervedAdvancedSearchQuery(baseOptions?: Apollo.QueryHookOptions<CervedAdvancedSearchQuery, CervedAdvancedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CervedAdvancedSearchQuery, CervedAdvancedSearchQueryVariables>(CervedAdvancedSearchDocument, options);
      }
export function useCervedAdvancedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CervedAdvancedSearchQuery, CervedAdvancedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CervedAdvancedSearchQuery, CervedAdvancedSearchQueryVariables>(CervedAdvancedSearchDocument, options);
        }
export type CervedAdvancedSearchQueryHookResult = ReturnType<typeof useCervedAdvancedSearchQuery>;
export type CervedAdvancedSearchLazyQueryHookResult = ReturnType<typeof useCervedAdvancedSearchLazyQuery>;
export type CervedAdvancedSearchQueryResult = Apollo.QueryResult<CervedAdvancedSearchQuery, CervedAdvancedSearchQueryVariables>;
export const CoBillsAndDepositsDocument = gql`
    query CoBillsAndDeposits($tenantId: ID!, $propertyId: ID!, $billIds: [ID!]!, $depositIds: [ID!]!) {
  bills(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {in: $billIds}, open: true}
  ) {
    ...CoBill
  }
  documents(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {in: $depositIds}, documentType: ADVANCE}
  ) {
    ...CoDeposit
  }
}
    ${CoBillFragmentDoc}
${CoDepositFragmentDoc}`;

/**
 * __useCoBillsAndDepositsQuery__
 *
 * To run a query within a React component, call `useCoBillsAndDepositsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoBillsAndDepositsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoBillsAndDepositsQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      billIds: // value for 'billIds'
 *      depositIds: // value for 'depositIds'
 *   },
 * });
 */
export function useCoBillsAndDepositsQuery(baseOptions: Apollo.QueryHookOptions<CoBillsAndDepositsQuery, CoBillsAndDepositsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoBillsAndDepositsQuery, CoBillsAndDepositsQueryVariables>(CoBillsAndDepositsDocument, options);
      }
export function useCoBillsAndDepositsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoBillsAndDepositsQuery, CoBillsAndDepositsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoBillsAndDepositsQuery, CoBillsAndDepositsQueryVariables>(CoBillsAndDepositsDocument, options);
        }
export type CoBillsAndDepositsQueryHookResult = ReturnType<typeof useCoBillsAndDepositsQuery>;
export type CoBillsAndDepositsLazyQueryHookResult = ReturnType<typeof useCoBillsAndDepositsLazyQuery>;
export type CoBillsAndDepositsQueryResult = Apollo.QueryResult<CoBillsAndDepositsQuery, CoBillsAndDepositsQueryVariables>;
export const CoReservationDocument = gql`
    query CoReservation($id: ID!, $tenantId: ID!, $propertyId: ID!) {
  reservations(
    filter: {id: {eq: $id}, tenantId: {eq: $tenantId}, propertyId: $propertyId}
  ) {
    ...CoReservation
  }
}
    ${CoReservationFragmentDoc}`;

/**
 * __useCoReservationQuery__
 *
 * To run a query within a React component, call `useCoReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useCoReservationQuery(baseOptions: Apollo.QueryHookOptions<CoReservationQuery, CoReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoReservationQuery, CoReservationQueryVariables>(CoReservationDocument, options);
      }
export function useCoReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoReservationQuery, CoReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoReservationQuery, CoReservationQueryVariables>(CoReservationDocument, options);
        }
export type CoReservationQueryHookResult = ReturnType<typeof useCoReservationQuery>;
export type CoReservationLazyQueryHookResult = ReturnType<typeof useCoReservationLazyQuery>;
export type CoReservationQueryResult = Apollo.QueryResult<CoReservationQuery, CoReservationQueryVariables>;
export const CoDocumentDocument = gql`
    query CoDocument($tenantId: ID!, $propertyId: ID!, $documentId: ID!) {
  documents(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, id: {eq: $documentId}}
  ) {
    ...CoDocument
  }
}
    ${CoDocumentFragmentDoc}`;

/**
 * __useCoDocumentQuery__
 *
 * To run a query within a React component, call `useCoDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoDocumentQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCoDocumentQuery(baseOptions: Apollo.QueryHookOptions<CoDocumentQuery, CoDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoDocumentQuery, CoDocumentQueryVariables>(CoDocumentDocument, options);
      }
export function useCoDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoDocumentQuery, CoDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoDocumentQuery, CoDocumentQueryVariables>(CoDocumentDocument, options);
        }
export type CoDocumentQueryHookResult = ReturnType<typeof useCoDocumentQuery>;
export type CoDocumentLazyQueryHookResult = ReturnType<typeof useCoDocumentLazyQuery>;
export type CoDocumentQueryResult = Apollo.QueryResult<CoDocumentQuery, CoDocumentQueryVariables>;
export const CreateCoDocumentDocument = gql`
    mutation CreateCoDocument($input: CheckoutDocumentInput!) {
  createCheckoutDocument(value: $input) {
    ...CoDocument
  }
}
    ${CoDocumentFragmentDoc}`;
export type CreateCoDocumentMutationFn = Apollo.MutationFunction<CreateCoDocumentMutation, CreateCoDocumentMutationVariables>;

/**
 * __useCreateCoDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoDocumentMutation, { data, loading, error }] = useCreateCoDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoDocumentMutation, CreateCoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoDocumentMutation, CreateCoDocumentMutationVariables>(CreateCoDocumentDocument, options);
      }
export type CreateCoDocumentMutationHookResult = ReturnType<typeof useCreateCoDocumentMutation>;
export type CreateCoDocumentMutationResult = Apollo.MutationResult<CreateCoDocumentMutation>;
export type CreateCoDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCoDocumentMutation, CreateCoDocumentMutationVariables>;
export const UpdateCoDocumentDocument = gql`
    mutation UpdateCoDocument($documentId: String!, $input: DocumentInput!) {
  updateDocument(id: $documentId, value: $input) {
    ...CoDocument
  }
}
    ${CoDocumentFragmentDoc}`;
export type UpdateCoDocumentMutationFn = Apollo.MutationFunction<UpdateCoDocumentMutation, UpdateCoDocumentMutationVariables>;

/**
 * __useUpdateCoDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateCoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoDocumentMutation, { data, loading, error }] = useUpdateCoDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoDocumentMutation, UpdateCoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoDocumentMutation, UpdateCoDocumentMutationVariables>(UpdateCoDocumentDocument, options);
      }
export type UpdateCoDocumentMutationHookResult = ReturnType<typeof useUpdateCoDocumentMutation>;
export type UpdateCoDocumentMutationResult = Apollo.MutationResult<UpdateCoDocumentMutation>;
export type UpdateCoDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateCoDocumentMutation, UpdateCoDocumentMutationVariables>;
export const UpdateFinalizedDocumentDocument = gql`
    mutation UpdateFinalizedDocument($documentId: String!, $input: DocumentInput!) {
  updateFinalizedDocument(id: $documentId, value: $input) {
    ...CoDocument
  }
}
    ${CoDocumentFragmentDoc}`;
export type UpdateFinalizedDocumentMutationFn = Apollo.MutationFunction<UpdateFinalizedDocumentMutation, UpdateFinalizedDocumentMutationVariables>;

/**
 * __useUpdateFinalizedDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateFinalizedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinalizedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinalizedDocumentMutation, { data, loading, error }] = useUpdateFinalizedDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFinalizedDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinalizedDocumentMutation, UpdateFinalizedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinalizedDocumentMutation, UpdateFinalizedDocumentMutationVariables>(UpdateFinalizedDocumentDocument, options);
      }
export type UpdateFinalizedDocumentMutationHookResult = ReturnType<typeof useUpdateFinalizedDocumentMutation>;
export type UpdateFinalizedDocumentMutationResult = Apollo.MutationResult<UpdateFinalizedDocumentMutation>;
export type UpdateFinalizedDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateFinalizedDocumentMutation, UpdateFinalizedDocumentMutationVariables>;
export const FinalizeCoDocumentDocument = gql`
    mutation FinalizeCoDocument($tenantId: ID!, $documentId: String!) {
  finalizeDocument(tenantId: $tenantId, id: $documentId)
}
    `;
export type FinalizeCoDocumentMutationFn = Apollo.MutationFunction<FinalizeCoDocumentMutation, FinalizeCoDocumentMutationVariables>;

/**
 * __useFinalizeCoDocumentMutation__
 *
 * To run a mutation, you first call `useFinalizeCoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeCoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeCoDocumentMutation, { data, loading, error }] = useFinalizeCoDocumentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useFinalizeCoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeCoDocumentMutation, FinalizeCoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeCoDocumentMutation, FinalizeCoDocumentMutationVariables>(FinalizeCoDocumentDocument, options);
      }
export type FinalizeCoDocumentMutationHookResult = ReturnType<typeof useFinalizeCoDocumentMutation>;
export type FinalizeCoDocumentMutationResult = Apollo.MutationResult<FinalizeCoDocumentMutation>;
export type FinalizeCoDocumentMutationOptions = Apollo.BaseMutationOptions<FinalizeCoDocumentMutation, FinalizeCoDocumentMutationVariables>;
export const DeleteCoDocumentDocument = gql`
    mutation DeleteCoDocument($tenantId: ID!, $documentId: String!) {
  deleteDocument(tenantId: $tenantId, id: $documentId)
}
    `;
export type DeleteCoDocumentMutationFn = Apollo.MutationFunction<DeleteCoDocumentMutation, DeleteCoDocumentMutationVariables>;

/**
 * __useDeleteCoDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteCoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoDocumentMutation, { data, loading, error }] = useDeleteCoDocumentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteCoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCoDocumentMutation, DeleteCoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCoDocumentMutation, DeleteCoDocumentMutationVariables>(DeleteCoDocumentDocument, options);
      }
export type DeleteCoDocumentMutationHookResult = ReturnType<typeof useDeleteCoDocumentMutation>;
export type DeleteCoDocumentMutationResult = Apollo.MutationResult<DeleteCoDocumentMutation>;
export type DeleteCoDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteCoDocumentMutation, DeleteCoDocumentMutationVariables>;
export const UndoCoDocumentDocument = gql`
    mutation UndoCoDocument($tenantId: ID!, $documentId: String!) {
  undoDocument(tenantId: $tenantId, id: $documentId)
}
    `;
export type UndoCoDocumentMutationFn = Apollo.MutationFunction<UndoCoDocumentMutation, UndoCoDocumentMutationVariables>;

/**
 * __useUndoCoDocumentMutation__
 *
 * To run a mutation, you first call `useUndoCoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCoDocumentMutation, { data, loading, error }] = useUndoCoDocumentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useUndoCoDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UndoCoDocumentMutation, UndoCoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoCoDocumentMutation, UndoCoDocumentMutationVariables>(UndoCoDocumentDocument, options);
      }
export type UndoCoDocumentMutationHookResult = ReturnType<typeof useUndoCoDocumentMutation>;
export type UndoCoDocumentMutationResult = Apollo.MutationResult<UndoCoDocumentMutation>;
export type UndoCoDocumentMutationOptions = Apollo.BaseMutationOptions<UndoCoDocumentMutation, UndoCoDocumentMutationVariables>;
export const CreateCreditNoteDocument = gql`
    mutation CreateCreditNote($tenantId: ID!, $documentId: ID!, $reverseProduction: Boolean!) {
  createCreditNoteDocument(
    input: {tenantId: $tenantId, documentId: $documentId, reverseProduction: $reverseProduction}
  )
}
    `;
export type CreateCreditNoteMutationFn = Apollo.MutationFunction<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;

/**
 * __useCreateCreditNoteMutation__
 *
 * To run a mutation, you first call `useCreateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditNoteMutation, { data, loading, error }] = useCreateCreditNoteMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      documentId: // value for 'documentId'
 *      reverseProduction: // value for 'reverseProduction'
 *   },
 * });
 */
export function useCreateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>(CreateCreditNoteDocument, options);
      }
export type CreateCreditNoteMutationHookResult = ReturnType<typeof useCreateCreditNoteMutation>;
export type CreateCreditNoteMutationResult = Apollo.MutationResult<CreateCreditNoteMutation>;
export type CreateCreditNoteMutationOptions = Apollo.BaseMutationOptions<CreateCreditNoteMutation, CreateCreditNoteMutationVariables>;
export const CreateCreditNoteForAdvanceDocument = gql`
    mutation CreateCreditNoteForAdvance($input: CreditNoteForAdvanceInput!) {
  createCreditNoteForAdvance(input: $input)
}
    `;
export type CreateCreditNoteForAdvanceMutationFn = Apollo.MutationFunction<CreateCreditNoteForAdvanceMutation, CreateCreditNoteForAdvanceMutationVariables>;

/**
 * __useCreateCreditNoteForAdvanceMutation__
 *
 * To run a mutation, you first call `useCreateCreditNoteForAdvanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditNoteForAdvanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditNoteForAdvanceMutation, { data, loading, error }] = useCreateCreditNoteForAdvanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditNoteForAdvanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditNoteForAdvanceMutation, CreateCreditNoteForAdvanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditNoteForAdvanceMutation, CreateCreditNoteForAdvanceMutationVariables>(CreateCreditNoteForAdvanceDocument, options);
      }
export type CreateCreditNoteForAdvanceMutationHookResult = ReturnType<typeof useCreateCreditNoteForAdvanceMutation>;
export type CreateCreditNoteForAdvanceMutationResult = Apollo.MutationResult<CreateCreditNoteForAdvanceMutation>;
export type CreateCreditNoteForAdvanceMutationOptions = Apollo.BaseMutationOptions<CreateCreditNoteForAdvanceMutation, CreateCreditNoteForAdvanceMutationVariables>;
export const CreateManualDocumentDocument = gql`
    mutation CreateManualDocument($input: ManualDocumentInput!) {
  createManualDocument(value: $input) {
    id
  }
}
    `;
export type CreateManualDocumentMutationFn = Apollo.MutationFunction<CreateManualDocumentMutation, CreateManualDocumentMutationVariables>;

/**
 * __useCreateManualDocumentMutation__
 *
 * To run a mutation, you first call `useCreateManualDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualDocumentMutation, { data, loading, error }] = useCreateManualDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualDocumentMutation, CreateManualDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualDocumentMutation, CreateManualDocumentMutationVariables>(CreateManualDocumentDocument, options);
      }
export type CreateManualDocumentMutationHookResult = ReturnType<typeof useCreateManualDocumentMutation>;
export type CreateManualDocumentMutationResult = Apollo.MutationResult<CreateManualDocumentMutation>;
export type CreateManualDocumentMutationOptions = Apollo.BaseMutationOptions<CreateManualDocumentMutation, CreateManualDocumentMutationVariables>;
export const UpdateDepositAssignedsDocument = gql`
    mutation UpdateDepositAssigneds($tenantId: ID!, $depositDocumentId: ID!, $depositAssigneds: [UpdateDepositAssigneds!]!) {
  updateDepositAssigneds(
    tenantId: $tenantId
    depositDocumentId: $depositDocumentId
    depositAssigneds: $depositAssigneds
  )
}
    `;
export type UpdateDepositAssignedsMutationFn = Apollo.MutationFunction<UpdateDepositAssignedsMutation, UpdateDepositAssignedsMutationVariables>;

/**
 * __useUpdateDepositAssignedsMutation__
 *
 * To run a mutation, you first call `useUpdateDepositAssignedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepositAssignedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepositAssignedsMutation, { data, loading, error }] = useUpdateDepositAssignedsMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      depositDocumentId: // value for 'depositDocumentId'
 *      depositAssigneds: // value for 'depositAssigneds'
 *   },
 * });
 */
export function useUpdateDepositAssignedsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepositAssignedsMutation, UpdateDepositAssignedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepositAssignedsMutation, UpdateDepositAssignedsMutationVariables>(UpdateDepositAssignedsDocument, options);
      }
export type UpdateDepositAssignedsMutationHookResult = ReturnType<typeof useUpdateDepositAssignedsMutation>;
export type UpdateDepositAssignedsMutationResult = Apollo.MutationResult<UpdateDepositAssignedsMutation>;
export type UpdateDepositAssignedsMutationOptions = Apollo.BaseMutationOptions<UpdateDepositAssignedsMutation, UpdateDepositAssignedsMutationVariables>;
export const GooglePlacesFindDocument = gql`
    query GooglePlacesFind($input: GooglePlacesFindInput!) {
  googlePlacesFind(input: $input) {
    candidates {
      ...GooglePlace
    }
  }
}
    ${GooglePlaceFragmentDoc}`;

/**
 * __useGooglePlacesFindQuery__
 *
 * To run a query within a React component, call `useGooglePlacesFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useGooglePlacesFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGooglePlacesFindQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGooglePlacesFindQuery(baseOptions: Apollo.QueryHookOptions<GooglePlacesFindQuery, GooglePlacesFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GooglePlacesFindQuery, GooglePlacesFindQueryVariables>(GooglePlacesFindDocument, options);
      }
export function useGooglePlacesFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GooglePlacesFindQuery, GooglePlacesFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GooglePlacesFindQuery, GooglePlacesFindQueryVariables>(GooglePlacesFindDocument, options);
        }
export type GooglePlacesFindQueryHookResult = ReturnType<typeof useGooglePlacesFindQuery>;
export type GooglePlacesFindLazyQueryHookResult = ReturnType<typeof useGooglePlacesFindLazyQuery>;
export type GooglePlacesFindQueryResult = Apollo.QueryResult<GooglePlacesFindQuery, GooglePlacesFindQueryVariables>;
export const IdentificationDocumentsDocument = gql`
    query IdentificationDocuments {
  identificationDocuments {
    ...IdentificationDocument
  }
}
    ${IdentificationDocumentFragmentDoc}`;

/**
 * __useIdentificationDocumentsQuery__
 *
 * To run a query within a React component, call `useIdentificationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentificationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentificationDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentificationDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>(IdentificationDocumentsDocument, options);
      }
export function useIdentificationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>(IdentificationDocumentsDocument, options);
        }
export type IdentificationDocumentsQueryHookResult = ReturnType<typeof useIdentificationDocumentsQuery>;
export type IdentificationDocumentsLazyQueryHookResult = ReturnType<typeof useIdentificationDocumentsLazyQuery>;
export type IdentificationDocumentsQueryResult = Apollo.QueryResult<IdentificationDocumentsQuery, IdentificationDocumentsQueryVariables>;
export const PaymentActivesDocument = gql`
    query PaymentActives($tenantId: ID!, $propertyId: ID!) {
  paymentActives(
    filter: {tenantId: {eq: $tenantId}, propertyId: {eq: $propertyId}, isActive: true}
  ) {
    ...PaymentActive
  }
}
    ${PaymentActiveFragmentDoc}`;

/**
 * __usePaymentActivesQuery__
 *
 * To run a query within a React component, call `usePaymentActivesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentActivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentActivesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePaymentActivesQuery(baseOptions: Apollo.QueryHookOptions<PaymentActivesQuery, PaymentActivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentActivesQuery, PaymentActivesQueryVariables>(PaymentActivesDocument, options);
      }
export function usePaymentActivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentActivesQuery, PaymentActivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentActivesQuery, PaymentActivesQueryVariables>(PaymentActivesDocument, options);
        }
export type PaymentActivesQueryHookResult = ReturnType<typeof usePaymentActivesQuery>;
export type PaymentActivesLazyQueryHookResult = ReturnType<typeof usePaymentActivesLazyQuery>;
export type PaymentActivesQueryResult = Apollo.QueryResult<PaymentActivesQuery, PaymentActivesQueryVariables>;